export const QUESTIONS = [
  {
    "id": 1,
    "question": "In this type of organization, the project manager shares responsibility for team member assignments and performance evaluations with the functional manager.",
    "choice_a": "Functional",
    "choice_b": "Projectized",
    "choice_c": "Hierarchical",
    "choice_d": "Matrix",
    "correct_answer": "D",
    "explanation": "Project managers share authority with functional managers in a matrix organization.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      160,
      159,
      161,
      163,
      174
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 2,
    "question": "These are units of measures agreed upon by the agile team that are used to estimate the amount of work it takes to complete a user story.",
    "choice_a": "Story point",
    "choice_b": "Epic point",
    "choice_c": "Velocity",
    "choice_d": "Parametric estimate",
    "correct_answer": "A",
    "explanation": "Story points are used to measure the amount of work it takes to complete a user story. Velocity is the amount of time it takes to complete story points. Parametric estimates involve multiplying the rate times the amount of work. Epic points don\u2019t exist.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      267,
      154,
      145,
      322,
      310
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 3,
    "question": "The information you gather in the preliminary scope definition will serve as a basis for which of the following documents?",
    "choice_a": "Scope management plan",
    "choice_b": "Communication plan",
    "choice_c": "Project charter",
    "choice_d": "Stakeholder register",
    "correct_answer": "C",
    "explanation": "The information gathered in the preliminary scope definition, such as project goals, the reason for the project, description of the project, and high-level deliverables needed, will serve as a basis for the project charter.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      66,
      64,
      67,
      9,
      84
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 4,
    "question": "David is working on a project where oral health information will be exchanged during the testing of the system. Which of the following is true regarding this question? (Choose two.)",
    "choice_a": "Oral health information is PHII and should follow the standards and laws associated with protecting this data.",
    "choice_b": "PHII is a form of PII.",
    "choice_c": "Oral health information is not PHII and does not need to follow the standards and laws associated with protecting this data.",
    "choice_d": "PHII is a form of SPII.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Oral health information is PHII data, which is a form of PII.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      30,
      29,
      195,
      31,
      32
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 5,
    "question": "Who is responsible for assembling the project\u2019s team members?",
    "choice_a": "Project sponsor",
    "choice_b": "Project stakeholders",
    "choice_c": "Project customer",
    "choice_d": "Project manager",
    "correct_answer": "D",
    "explanation": "The project manager assembles the team members for the project. The project manager may get input from the sponsor, stakeholders, or customers, but it is the project manager who decides what the formation of the team should be.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      169,
      168,
      56,
      53,
      160
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 6,
    "question": "Which of these terms describes a critical path task?",
    "choice_a": "Hard logic",
    "choice_b": "Zero float",
    "choice_c": "Critical task",
    "choice_d": "Mandatory task",
    "correct_answer": "B",
    "explanation": "Tasks with zero float are critical path tasks, and if delayed, they will cause the delay of the project completion date.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      144,
      137,
      90,
      136,
      210
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 7,
    "question": "You\u2019re the project manager on a project where the scope has expanded. The change has been approved by the change control board (CCB). What steps must you take to acknowledge the new scope? (Choose two.)",
    "choice_a": "Update the project management plan.",
    "choice_b": "Update the SOW.",
    "choice_c": "Communicate the change to stakeholders and team members.",
    "choice_d": "Submit a change request.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Any time there\u2019s a significant change to the project, the project management plan must be updated, and the stakeholders notified of the change. Options D and E would have been done before the approval by the CCB. Options A and C occur after an approval.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      274,
      87,
      282,
      271,
      280
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Log the request on the change request log."
  },
  {
    "id": 8,
    "question": "Which of the following are project management life cycle phases according to CompTIA? (Choose three.)",
    "choice_a": "Scheduling",
    "choice_b": "Planning",
    "choice_c": "Executing",
    "choice_d": "Monitoring and Controlling",
    "correct_answer": [
      "B",
      "C",
      "G"
    ],
    "explanation": "Discovery/Concept, Initiating, Planning, Executing, and Closing are the five project management life cycle phases outlined by CompTIA.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      101,
      6,
      133,
      106,
      123
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Documenting",
    "choice_f": "Budgeting",
    "choice_g": "Closing"
  },
  {
    "id": 9,
    "question": "Risk analysis includes all of the following except for which one?",
    "choice_a": "Identifying risk",
    "choice_b": "Determining a risk response plan",
    "choice_c": "Determining an order-of-magnitude estimate for responses",
    "choice_d": "Determining probability and impact and assigning a risk score",
    "correct_answer": "C",
    "explanation": "Determining an order-of-magnitude estimate is used for cost or duration estimating, not risk analysis.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      216,
      219,
      220,
      221,
      222
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 10,
    "question": "Which of the following describes the responsibilities of the project sponsor?",
    "choice_a": "Provides or obtains financial resources",
    "choice_b": "Monitors the delivery of major milestones",
    "choice_c": "Runs interference and removes roadblocks",
    "choice_d": "Provides the project manager with authority to manage the project",
    "correct_answer": "E",
    "explanation": "A project sponsor is responsible for obtaining financial resources for the project, monitoring the progress of the project, and handling escalations from the project manager.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      53,
      56,
      263,
      57,
      6
    ],
    "source": "892458_Assessment Test",
    "choice_e": "All of the above"
  },
  {
    "id": 11,
    "question": "Which cost-estimating technique relies on estimating work packages and then rolling up these estimates to come up with a total cost estimate?",
    "choice_a": "Top-down",
    "choice_b": "Parametric",
    "choice_c": "Bottom-up",
    "choice_d": "Analogous",
    "correct_answer": "C",
    "explanation": "The bottom-up cost-estimating method is the most precise because you begin your estimating at the activities in the work package and roll them up for a total estimate.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      128,
      132,
      70,
      143,
      203
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 12,
    "question": "Fishbone diagrams, Pareto diagrams, decision tress, run charts, and control charts are examples of which of the following?",
    "choice_a": "Examples of various project management tools used to plan the work of the project",
    "choice_b": "Examples of various quality control tools used to examine the quality of work",
    "choice_c": "Examples of various scope management tools to control the quality of deliverables",
    "choice_d": "Examples of various scope management tools used to control scope creep",
    "correct_answer": "B",
    "explanation": "The tools described in this question are used during the Executing phase of the project to monitor quality and assure it meets expectations. It also helps in determining corrective actions needed to get the project back on track.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      310,
      311,
      314,
      266,
      322
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 13,
    "question": "Your project requires a resource with specialized knowledge of a specific business process. The resource will work with the project team during the development of this functionality. What type of resources are these?",
    "choice_a": "Internal resources",
    "choice_b": "Functional/extended resources",
    "choice_c": "Core resources",
    "choice_d": "Benched resources",
    "correct_answer": "B",
    "explanation": "Functional/extended resources are those needed for specific tasks or short periods of time on the project. They may also be stakeholders or subject matter experts who lend expertise to the project.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      55,
      162,
      163,
      169,
      26
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 14,
    "question": "Which of these statements describes an assumption?",
    "choice_a": "Our senior web developer will be available to work on this project.",
    "choice_b": "The electrical capacity at the site of the project event may not be adequate.",
    "choice_c": "The project\u2019s due date is June 27.",
    "choice_d": "There\u2019s a potential for server administrator to receive a promotion during the course of this project.",
    "correct_answer": "A",
    "explanation": "Assumptions are those things we believe to be true for planning purposes. Options B and D describe risks, while option C describes a constraint.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      216,
      315,
      281,
      88,
      275
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 15,
    "question": "All of the following are factors that influence communication methods except which one?",
    "choice_a": "Language barriers",
    "choice_b": "Technological barriers",
    "choice_c": "Task completion",
    "choice_d": "Cultural differences",
    "correct_answer": "C",
    "explanation": "Task completion is a communication trigger. The remaining options are examples of factors that influence communications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      246,
      247,
      271,
      244,
      242
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Intra-organizational differences",
    "choice_f": "A, B, D",
    "choice_g": "All of the above"
  },
  {
    "id": 16,
    "question": "Why is it important to comply with laws and regulations such as HIPPA, PIPEDA, GDPR, and CCPA when working as a project manager? (Choose all that apply.)",
    "choice_a": "Failure to comply may result in sanctions to the organization.",
    "choice_b": "Failure to comply may result in reputational damage to the organization.",
    "choice_c": "Failure to comply may result in financial penalties to the organization.",
    "choice_d": "Failure to comply may result in punitive damages to the organization.",
    "correct_answer": "E",
    "explanation": "All of the options are true.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      29,
      30,
      32,
      195,
      31
    ],
    "source": "892458_Assessment Test",
    "choice_e": "All of the above."
  },
  {
    "id": 17,
    "question": "This tool is often used in the vendor selection process to pick a winning bidder.",
    "choice_a": "Weighted scoring model",
    "choice_b": "Bidder conference",
    "choice_c": "RFQ",
    "choice_d": "SOW",
    "correct_answer": "A",
    "explanation": "A weighted scoring model is a tool that weights evaluation criteria and provides a way to score vendor responses. Bidder conferences, IFB, and SOW are all used during vendor solicitation.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      185,
      20,
      15,
      21,
      62
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 18,
    "question": "The network communication model is a visual depiction of what?",
    "choice_a": "Lines of communication",
    "choice_b": "Participant model",
    "choice_c": "Communication model",
    "choice_d": "Participant communication model",
    "correct_answer": "A",
    "explanation": "Lines of communication describe how many lines of communication exist between participants. The network communication model is a visual depiction of the lines of communication.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      228,
      227,
      244,
      269,
      246
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 19,
    "question": "Environmental, social, and governance factors that influence project management activities also include all of the following except which one?",
    "choice_a": "Project impact to local and global environment",
    "choice_b": "Awareness of compliance and privacy considerations",
    "choice_c": "Project impact to company brand value",
    "choice_d": "Awareness of company vision, mission statement, and values",
    "correct_answer": "B",
    "explanation": "Compliance and privacy considerations are not part of the ESG factors; however, they can influence and have an impact on the project.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      32,
      33,
      195,
      190,
      191
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Awareness of applicable regulations and standards"
  },
  {
    "id": 20,
    "question": "Which of the following project documents created in the Closing phase describes what went well and what didn\u2019t go well on the project?",
    "choice_a": "Project close report",
    "choice_b": "Stakeholder feedback report",
    "choice_c": "Lessons learned",
    "choice_d": "Post-project review",
    "correct_answer": "C",
    "explanation": "Lessons learned describe what went well and what didn\u2019t go well on the project. Lessons learned are included in the project close report, the postmortem report, and the post-project review.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      330,
      11,
      12,
      10,
      9
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 21,
    "question": "This chart shows the remaining time and work effort for an iteration or sprint.",
    "choice_a": "Run chart",
    "choice_b": "Gantt chart",
    "choice_c": "Scrum board",
    "choice_d": "Burndown chart",
    "correct_answer": "D",
    "explanation": "Burndown charts show the remaining time and work effort for an iteration or sprint.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      154,
      267,
      212,
      266,
      322
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 22,
    "question": "This is the approved, expected cost of the project.",
    "choice_a": "Expenditure budget",
    "choice_b": "Expenditure baseline",
    "choice_c": "Cost budget",
    "choice_d": "Cost baseline",
    "correct_answer": "D",
    "explanation": "The cost baseline is the approved, expected cost of the project.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      203,
      84,
      132,
      70,
      149
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 23,
    "question": "This document authorizes the project to begin.",
    "choice_a": "Business case",
    "choice_b": "Project concept document",
    "choice_c": "Project charter",
    "choice_d": "Preliminary scope statement",
    "correct_answer": "C",
    "explanation": "The project charter authorizes the project to begin.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      66,
      71,
      8,
      67,
      70
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 24,
    "question": "Your project has expected cash inflows of $1.2 million in year 1, $2.4 million in year 2, and $4.6 million in year 3. The project pays for itself in 23 months. Which cash flow technique was used to determine this?",
    "choice_a": "IRR",
    "choice_b": "NPV",
    "choice_c": "Discounted cash flow",
    "choice_d": "Payback period",
    "correct_answer": "D",
    "explanation": "Payback period is a technique that calculates the expected cash inflows over time to determine how many periods it will take to recover the original investment. IRR calculates the internal rate of return, NPV determines the net present value, and discounted cash flows determine the amount of the cash flows in today\u2019s dollars.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      14,
      70,
      203,
      96,
      126
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 25,
    "question": "A well-written change request should include which of the following components?",
    "choice_a": "A description of the type of change requested",
    "choice_b": "The amount of time the change will take to implement",
    "choice_c": "The cost of the change",
    "choice_d": "How to update the affected project planning documents",
    "correct_answer": "E",
    "explanation": "All of the options are elements of a change request.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      280,
      86,
      282,
      279,
      87
    ],
    "source": "892458_Assessment Test",
    "choice_e": "All of the above"
  },
  {
    "id": 26,
    "question": "\u201cInstall an Interactive Voice Response System that will increase customer response time by an average of 15 seconds and decrease the number of customer service interactions by 30 percent\u201d is an example of which of the following elements of scope statement?",
    "choice_a": "Requirements",
    "choice_b": "Objectives",
    "choice_c": "Project description",
    "choice_d": "Milestone",
    "correct_answer": "B",
    "explanation": "Objectives are specific and measurable. Project descriptions describe the key characteristics of the product, service, or result of the project. These are characteristics, but the clue in this question is the quantifiable results you\u2019re looking for at the conclusion of the project. The project description describes the project as a whole, and milestones describe major deliverables or accomplishments for the project.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      67,
      69,
      70,
      64,
      65
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 27,
    "question": "You are working for an organization and just learned that another organization with more power and influence is taking over your organization at the first of the year and they will set strategy and make all business decisions going forward. What does this describe?",
    "choice_a": "Business merger",
    "choice_b": "Business de-merger",
    "choice_c": "Business venture",
    "choice_d": "Business acquisition",
    "correct_answer": "D",
    "explanation": "This question describes a business acquisition. Companies that are acquiring others have the power and influence to make decisions. A business merger is a mutually agreeable arrangement where power is shared among the entities.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      289,
      53,
      28,
      5,
      51
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 28,
    "question": "All of the following are types of stakeholder analysis except for which one?",
    "choice_a": "Salience model",
    "choice_b": "Stakeholder register",
    "choice_c": "Power/interest grid",
    "choice_d": "Prioritization matrix",
    "correct_answer": "B",
    "explanation": "The stakeholder register is where the information about the stakeholders, including analysis details, are documented.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      59,
      16,
      8,
      19,
      93
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 29,
    "question": "Which of the following are stand-alone PII data elements, also known as SPII?",
    "choice_a": "Name, mother\u2019s maiden name, criminal history",
    "choice_b": "Date of birth and place of birth",
    "choice_c": "Employment information and educational information",
    "choice_d": "Vehicle registration number and cell phone number",
    "correct_answer": "E",
    "explanation": "Options A through D are examples of personally identifiable information that are considered linkable but not sensitive. Sensitive personally identifiable information consists of data elements that, on their own, can identify or trace an individual and could cause them harm, inconvenience, or embarrassment if used inappropriately. Option E consists of two pieces of SPII, fingerprints, and driver\u2019s license number. Street address is not SPII as a stand-alone element, but since it\u2019s linked to fingerprints and driver\u2019s license number, it is sensitive data.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      29,
      195,
      31,
      190,
      192
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Fingerprints, driver\u2019s license number, and street address"
  },
  {
    "id": 30,
    "question": "This estimating technique uses the most likely, optimistic, and pessimistic estimates to come up with an average cost or duration estimate.",
    "choice_a": "Analogous estimate",
    "choice_b": "Bottom-up estimate",
    "choice_c": "Parametric estimate",
    "choice_d": "Three-point estimate",
    "correct_answer": "D",
    "explanation": "The three-point estimating technique averages the most likely, optimistic, and pessimistic estimates to determine an overall cost or duration estimate.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      202,
      198,
      142,
      200,
      209
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 31,
    "question": "Which option describes an example of asynchronous communications?",
    "choice_a": "Face-to-face conversation",
    "choice_b": "Phone call",
    "choice_c": "Email",
    "choice_d": "Instant message",
    "correct_answer": "C",
    "explanation": "Asynchronous communication does not happen in real time and does not require an immediate response. All the other options describe synchronous communication, which is for scenarios requiring immediate responses.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      233,
      227,
      271,
      229,
      228
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 32,
    "question": "Which of these statements describes an assumption?",
    "choice_a": "Our senior web developer will be available to work on this project.",
    "choice_b": "The electrical capacity in the data center needs upgrading prior to the implementation of the servers.",
    "choice_c": "The project\u2019s due date is June 27.",
    "choice_d": "The budget for this project is $125,000.",
    "correct_answer": "A",
    "explanation": "Assumptions are those things we believe to be true for planning purposes. The other options describe a constraint.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      92,
      68,
      122,
      12,
      66
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 33,
    "question": "This is often added to the project schedule to provide extra time to account for risks or unforeseen issues that may cause tasks to take longer than the original estimate.",
    "choice_a": "Quality gate",
    "choice_b": "Buffer",
    "choice_c": "Milestone",
    "choice_d": "Governance gate",
    "correct_answer": "B",
    "explanation": "A buffer is added to the schedule to provide extra time to account for risks or unforeseen issues that may cause tasks to take longer than the original estimate.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      151,
      202,
      219,
      144,
      141
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 34,
    "question": "Which of the following is not true regarding cost estimating?",
    "choice_a": "Cost estimates are provided by team members.",
    "choice_b": "Cost estimate accuracy depends on the technique used to determine the estimate.",
    "choice_c": "Cost estimates have a quality factor built into them.",
    "choice_d": "Cost estimates are inputs to the project budget and used to determine the total project cost.",
    "correct_answer": "C",
    "explanation": "Cost estimates do not have a quality factor built into them. They are provided by team members, and the accuracy of the estimate depends on the estimating technique used. All the estimates are used as inputs to the budget to come up with the total project cost.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      203,
      70,
      132,
      84,
      206
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 35,
    "question": "Which of these is not an example of a project selection method?",
    "choice_a": "Cost\u2013benefit analysis",
    "choice_b": "Expert judgment",
    "choice_c": "Top-down estimating",
    "choice_d": "Scoring model",
    "correct_answer": "C",
    "explanation": "Cost\u2013benefit analysis, expert judgment, and scoring model are all project selection techniques. Top-down estimating is a type of cost estimating technique.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      20,
      15,
      142,
      198,
      21
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 36,
    "question": "This is how you will know the user story requirements were met satisfactorily at the end of the sprint.",
    "choice_a": "Acceptance criteria",
    "choice_b": "KPIs",
    "choice_c": "Metrics",
    "choice_d": "EVM",
    "correct_answer": "A",
    "explanation": "Acceptance criteria describe how to determine whether the deliverables are complete and meet the user story requirements.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      117,
      153,
      89,
      108,
      158
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 37,
    "question": "This chart or diagram is a type of histogram that rank-orders data by frequency over time.",
    "choice_a": "Run chart",
    "choice_b": "Scatter diagram",
    "choice_c": "Fishbone diagram",
    "choice_d": "Pareto chart",
    "correct_answer": "D",
    "explanation": "A Pareto diagram rank-orders data by frequency over time.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      310,
      311,
      314,
      307,
      266
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 38,
    "question": "One of your project activities requires following a specific procedure, inspecting the results, and signing off on an inspection before it can be included in the final deliverable. What type of dependency does this describe?",
    "choice_a": "External",
    "choice_b": "Discretionary",
    "choice_c": "Mandatory",
    "choice_d": "Logical",
    "correct_answer": "B",
    "explanation": "Discretionary dependencies are often process- or procedure- driven. This question describes a discretionary dependency.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      137,
      86,
      309,
      285,
      51
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 39,
    "question": "All of following are the most common elements in a three-tier, multitier architecture except for which one?",
    "choice_a": "Networking layer",
    "choice_b": "Application layer",
    "choice_c": "Processing layer",
    "choice_d": "Presentation layer",
    "correct_answer": "A",
    "explanation": "The Networking layer is not part of the three-tier architecture.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      37,
      36,
      38,
      39,
      40
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 40,
    "question": "This is the final, approved version of the project schedule. All of the following are true regarding this description except for which of the following?",
    "choice_a": "It will prevent future schedule risk.",
    "choice_b": "It\u2019s approved by the stakeholders, sponsor, and functional managers.",
    "choice_c": "It\u2019s used to monitor project progress throughout the remainder of the project.",
    "choice_d": "This describes a schedule baseline.",
    "correct_answer": "A",
    "explanation": "The schedule baseline is the final, approved version of the schedule and is signed by the stakeholders, sponsor, and functional managers. Having a schedule baseline will not prevent future schedule risk.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      274,
      53,
      151,
      56,
      315
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 41,
    "question": "According to CompTIA exam objectives, writing code and making changes to code involve all of the following environments except for which one?",
    "choice_a": "Beta stage",
    "choice_b": "Development",
    "choice_c": "Production",
    "choice_d": "Infrastructure",
    "correct_answer": "D",
    "explanation": "Development is where code is written, beta stage is where the code is tested, and production is where the finalized code resides. Infrastructure is what hosts these environments.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      298,
      297,
      36,
      37,
      40
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 42,
    "question": "All of the following represent a category of contract most commonly used in procurement except for which one?",
    "choice_a": "Time-and-materials",
    "choice_b": "Cost-reimbursable",
    "choice_c": "Fixed-price",
    "choice_d": "Requests for proposal",
    "correct_answer": "D",
    "explanation": "The three categories of contracts most often used to procure goods and services are time-and-materials, cost-reimbursable, and fixed-price. Requests for proposal are not contracts.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      182,
      277,
      276,
      278,
      6
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 43,
    "question": "These performance measurements are defined when you create the project management plan and are monitored and tracked during the Executing phase to determine whether the project is meeting its goals.",
    "choice_a": "ROI",
    "choice_b": "Balanced score card",
    "choice_c": "IRR",
    "choice_d": "KPI",
    "correct_answer": "D",
    "explanation": "Key performance indicators (KPIs) are measurable elements of project success defined when you create the project management plan and measure and monitor it throughout the Executing phase.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      320,
      89,
      274,
      209,
      211
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 44,
    "question": "In this organizational structure, you report to the director of project management, and your team members report to their areas of responsibility (accounting, human resources, and IT). You will have complete control of the project team members\u2019 time and assignments once the project is underway. Which type of organization does this describe?",
    "choice_a": "Projectized",
    "choice_b": "Functional",
    "choice_c": "Hierarchical",
    "choice_d": "Matrix",
    "correct_answer": "A",
    "explanation": "This describes a projectized organization because the project manager works in a division whose sole responsibility is project management, and once the team members are assigned to the project, the project manager has the authority to hold them accountable to their tasks and activities.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      161,
      160,
      159,
      56,
      53
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 45,
    "question": "Your project sponsor told you that the due date for the project is a key to its success and there is no chance of the date changing. What is this known as?",
    "choice_a": "A constraint",
    "choice_b": "An influence",
    "choice_c": "A deliverable",
    "choice_d": "A management directive",
    "correct_answer": "A",
    "explanation": "This describes a constraint. Constraints dictate or restrict the actions of the project team.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      90,
      53,
      95,
      88,
      215
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 46,
    "question": "All of the following are meeting types according to CompTIA exam objectives except for which one?",
    "choice_a": "Decisive",
    "choice_b": "Cooperative",
    "choice_c": "Informative",
    "choice_d": "Collaborative",
    "correct_answer": "B",
    "explanation": "The three meeting types are decisive, informative, and collaborative.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      253,
      255,
      256,
      261,
      25
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 47,
    "question": "This is a temporary way of resolving conflict and is considered a lose-lose technique. It emphasizes the areas of agreement over the areas of disagreement.",
    "choice_a": "Smoothing",
    "choice_b": "Forcing",
    "choice_c": "Avoiding",
    "choice_d": "Collaborating",
    "correct_answer": "A",
    "explanation": "Smoothing is a lose-lose conflict resolution technique. It is a temporary way to resolve conflict. Avoiding can also be a lose-lose conflict technique, but it isn\u2019t temporary in nature and doesn\u2019t emphasize anything because one of the parties leaves the discussions.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      273,
      294,
      321,
      236,
      259
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 48,
    "question": "Which of following describe secondary storage? (Choose two.)",
    "choice_a": "SAN.",
    "choice_b": "Flash drive.",
    "choice_c": "NAS.",
    "choice_d": "RAM.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Options A, C, and D are types of primary storage.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      39,
      36,
      37,
      38,
      40
    ],
    "source": "892458_Assessment Test",
    "choice_e": "It\u2019s also known as external memory."
  },
  {
    "id": 49,
    "question": "All of the following describe types of project endings except for which one?",
    "choice_a": "Integration",
    "choice_b": "Starvation",
    "choice_c": "Addition",
    "choice_d": "Extinction",
    "correct_answer": "E",
    "explanation": "Integration occurs when resources are distributed to other areas of the organization, and addition occurs when projects evolve into ongoing operations. Starvation is a project ending caused by resources being cut off from the project. Extinction occurs when the project work is completed and is accepted by the stakeholders.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      325,
      326,
      11,
      327,
      7
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Attrition"
  },
  {
    "id": 50,
    "question": "You need to perform a background check on a potential contract employee. Which of the following IT policies outlines the procedures for this check?",
    "choice_a": "Physical security policy",
    "choice_b": "Digital security policy",
    "choice_c": "Data security policy",
    "choice_d": "Operational security policy",
    "correct_answer": "D",
    "explanation": "Background check procedures are included in the operational security policy.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      193,
      190,
      191,
      192,
      194
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 51,
    "question": "Project managers may spend up to 90 percent of their time doing which of the following?",
    "choice_a": "Negotiating",
    "choice_b": "Managing scope",
    "choice_c": "Managing the project team",
    "choice_d": "Communicating",
    "correct_answer": "D",
    "explanation": "Project managers may spend up to 90 percent of their time communicating.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      232,
      23,
      227,
      228,
      241
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 52,
    "question": "In which cloud service model does the cloud service provider have the most control?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "C",
    "explanation": "The software-as-a-service (SaaS) model is where the service provider has the most control over the environment.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      40,
      41,
      49,
      37,
      36
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 53,
    "question": "This project management methodology divides up projects into stages that are logically organized. It has seven guiding principles and seven stages.",
    "choice_a": "Scrum",
    "choice_b": "Kanban",
    "choice_c": "PRINCE2",
    "choice_d": "Disciplined Agile",
    "correct_answer": "C",
    "explanation": "This question describes the PRINCE2 methodology.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      302,
      105,
      304,
      106,
      107
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 54,
    "question": "This person is responsible for time and duration estimates for tasks, cost estimates, status updates, and dependencies. Which of the following does this describe?",
    "choice_a": "Project manager",
    "choice_b": "Stakeholder",
    "choice_c": "Scheduler",
    "choice_d": "Project team member",
    "correct_answer": "D",
    "explanation": "The project team members are responsible for the tasks listed in the question.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      55,
      140,
      201,
      199,
      265
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 55,
    "question": "When taking over an incomplete project, what item should be of most interest to the new project manager?",
    "choice_a": "Project concept statement",
    "choice_b": "Project charter",
    "choice_c": "Project scope statement",
    "choice_d": "Project plan",
    "correct_answer": "C",
    "explanation": "The project\u2019s scope statement should be of most interest to the new project manager. The scope statement describes the product description, key deliverables, success and acceptance criteria, exclusions, assumptions, and constraints.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      122,
      12,
      84,
      92,
      99
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 56,
    "question": "All of the following are examples of records that are managed by a records management system except for which one?",
    "choice_a": "Board report",
    "choice_b": "Employee user access policy",
    "choice_c": "Draft of network diagrams",
    "choice_d": "Resignation letter",
    "correct_answer": "C",
    "explanation": "Drafts are not records until they are approved and distributed.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      284,
      11,
      66,
      93,
      236
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 57,
    "question": "In project management, the process of taking high-level project requirements and breaking them down into the tasks that will generate the deliverables is called what?",
    "choice_a": "Analyzing",
    "choice_b": "Decomposing",
    "choice_c": "Process flow diagram",
    "choice_d": "Break down",
    "correct_answer": "B",
    "explanation": "Decomposition is the process of analyzing the requirements of the project in such a way that you reduce the requirements down to the steps and tasks needed to produce them.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      128,
      85,
      64,
      99,
      132
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 58,
    "question": "Some team members on your team are driving each other crazy. They have different ways of organizing the tasks they are both assigned to, and the disparity in styles is causing them to bicker. Which of the following describes this situation?",
    "choice_a": "This is a constraint that\u2019s bringing about conflict on the team.",
    "choice_b": "This should be escalated to the project sponsor.",
    "choice_c": "This is a common cause of conflict.",
    "choice_d": "This is a team formation stage that will pass as they get to know each other better.",
    "correct_answer": "C",
    "explanation": "This situation describes varying work styles that are a common cause of conflict. Competing resource demands and constraints are also common causes of conflict. Conflicts are anything that restrict or dictate the actions of the project team. And issues like this should almost never have to be escalated to the project sponsor.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      177,
      242,
      232,
      173,
      90
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 59,
    "question": "Your organization is part of a network of researchers who need to share data and experimental results. Which cloud deployment model is the best solution for this scenario?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Community cloud",
    "correct_answer": "D",
    "explanation": "A community cloud is for a community of consumers who have similar needs. It\u2019s a form of private cloud with more than one tenant.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      41,
      40,
      49,
      38,
      36
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 60,
    "question": "This is a deliverables-oriented hierarchy that defines the work of the project.",
    "choice_a": "Scope document",
    "choice_b": "Scope management plan",
    "choice_c": "Work breakdown structure",
    "choice_d": "Project plan",
    "correct_answer": "C",
    "explanation": "The WBS is a deliverables-oriented hierarchy that defines all the project work and is completed after the scope management plan and scope statement are completed.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      128,
      9,
      93,
      84,
      132
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 61,
    "question": "Removable media is a security risk for all organizations. You are working with IT to create a policy that includes encryption procedures for removable media. Which policy are the procedures for removable media contained in?",
    "choice_a": "Physical security policy",
    "choice_b": "Digital security policy",
    "choice_c": "Data security policy",
    "choice_d": "Operational security policy",
    "correct_answer": "A",
    "explanation": "The physical security policy includes instructions for access to facilities, how to secure removable media, and how to secure mobile devices.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      192,
      190,
      191,
      195,
      297
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 62,
    "question": "Your organization has recently discovered that PII data has been exposed. What is this known as?",
    "choice_a": "Cybersecurity hack",
    "choice_b": "PII data disclosure",
    "choice_c": "Breach of confidentiality",
    "choice_d": "Data confidentiality exposure",
    "correct_answer": "C",
    "explanation": "This is known as a breach of confidentiality. It could have come about as a cybersecurity hacking incident, but the question doesn\u2019t state how the data was exposed.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      31,
      29,
      195,
      190,
      191
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 63,
    "question": "Your team has experienced issues in the past in having all IT team members engaged and involved on the project. The server team is notoriously left out of the loop until the last minute and then they have to scramble to get things ready for deployment. Which of the following team structures would help eliminate this issue?",
    "choice_a": "Project team",
    "choice_b": "Scrum team",
    "choice_c": "DevSecOps team",
    "choice_d": "Architect team",
    "correct_answer": "C",
    "explanation": "The DevSecOps team is one team consisting of team members with program development skills, cybersecurity skills, and operations skills. This framework ensures that all team members are aware of project tasks and increases collaboration and communication among team members, along with delivering products faster and with more fidelity.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      104,
      120,
      168,
      245,
      131
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 64,
    "question": "What is the best way to prevent scope creep?",
    "choice_a": "Make sure the requirements are thoroughly defined and documented.",
    "choice_b": "Put a statement in the charter that no additions to the project will be allowed once it\u2019s underway.",
    "choice_c": "Alert the sponsor that you will not be taking any change requests after the project starts.",
    "choice_d": "Inform stakeholders when they sign the project scope statement that no changes will be accepted after the scope statement is published.",
    "correct_answer": "A",
    "explanation": "The best way to avoid scope creep is to make sure the project\u2019s requirements have been thoroughly defined and documented.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      88,
      86,
      87,
      97,
      95
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 65,
    "question": "You\u2019re the project manager for a small project that is in the Closing phase. You prepare closure documents and take them to the project sponsor for sign-off. The project sponsor says that the documents are not needed because the project is so small. What should you tell the sponsor?",
    "choice_a": "You\u2019re sorry to have bothered them and will close the project without sign-off.",
    "choice_b": "You explain the sponsor is the one who needs to sign off on the documents, showing that the project is officially closed.",
    "choice_c": "You offer to have a stakeholder sign off in the sponsor\u2019s place.",
    "choice_d": "You offer to sign off on the documents yourself.",
    "correct_answer": "B",
    "explanation": "The sponsor is the one who must sign off on the completion of the project, whether successful or unsuccessful. Just as the sponsor is authorized to expend resources to bring forth the project\u2019s deliverables, the sponsor must also close the project and sign off.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      328,
      11,
      66,
      71,
      79
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 66,
    "question": "Which of following software manages documents, records, and data in electronic format for an organization?",
    "choice_a": "ERP",
    "choice_b": "CRM",
    "choice_c": "EDRMS",
    "choice_d": "CMS",
    "correct_answer": "C",
    "explanation": "EDRMS stands for electronic document and record management systems and is responsible for managing electronic documents, records, and more. ERP stands for enterprise resource planning. CRM is a customer relationship management system. CMS is a content management system.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      45,
      42,
      43,
      46,
      44
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 67,
    "question": "Your subject matter expert tells you that they estimate the time needed to complete their task is 40 hours. The task starts on Thursday, January 20 at 8 a.m. The team works eight-hour days, and they do not work weekends. Which day will the task end?",
    "choice_a": "January 24",
    "choice_b": "January 25",
    "choice_c": "January 27",
    "choice_d": "January 26",
    "correct_answer": "D",
    "explanation": "The task begins on January 20, which is day 1. The team does not work weekends, so the completion date, based on an eight-hour workday, is January 26.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      141,
      142,
      140,
      201,
      202
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 68,
    "question": "Your project sponsor has expressed their need to have real-time project information at their fingertips. Which of the following is the best way to meet this need?",
    "choice_a": "By creating a project dashboard with scope, cost, and time elements",
    "choice_b": "By updating the project status report on a daily basis",
    "choice_c": "By sending an email every morning to the sponsor describing the current project status",
    "choice_d": "By meeting face-to-face with the sponsor every day to update them on status",
    "correct_answer": "A",
    "explanation": "The best way to provide this information is to create a dashboard that provides real-time, updated information in a succinct and easy-to-read format.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      266,
      235,
      258,
      212,
      322
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 69,
    "question": "Luke is starting out in his project management career. He has project education but no hands-on experience. He is assigned to a project where he will be working with customer data, including full name, address, email address, phone number, and date of birth. What type of data is this known as?",
    "choice_a": "PHI",
    "choice_b": "Linkable data",
    "choice_c": "SPII",
    "choice_d": "Secure data",
    "correct_answer": "B",
    "explanation": "This question describes linkable data. On its own, this is not SPII but when linked with SPII, all the data becomes SPII.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      29,
      195,
      43,
      44,
      31
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 70,
    "question": "What key meeting is held after the project charter is signed and/or at the beginning of the Executing project management life cycle phase?",
    "choice_a": "Project kickoff",
    "choice_b": "Project review",
    "choice_c": "Project overview",
    "choice_d": "Project status meeting",
    "correct_answer": "A",
    "explanation": "The project kickoff meeting is held after the project charter is signed and/or during the Executing process. It serves to introduce team members, review the goals and objectives of the project, review stakeholder expectations, and review roles and responsibilities for team members.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      76,
      77,
      78,
      10,
      8
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 71,
    "question": "These important stakeholders are responsible for meeting the organizational goals and for providing team members from their departments to work on the project.",
    "choice_a": "Project champions",
    "choice_b": "SMEs",
    "choice_c": "PMO",
    "choice_d": "Senior management",
    "correct_answer": "D",
    "explanation": "The senior management team is responsible for meeting organizational goals and the project manager will work with them to assign resources from their departments to the project. The project champion encourages the organization to get behind the project, the subject matter experts lend expertise to the project and perform the work of the project, and the project management office provides guidance on project management processes as well as overseeing project work.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      53,
      57,
      61,
      62,
      51
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 72,
    "question": "When using an agile methodology, this serves as a placeholder for ideas that are not yet fully formed but that capture the essence of the idea. They are later broken down into user stories. What is this element called?",
    "choice_a": "Milestone",
    "choice_b": "Preview",
    "choice_c": "Backlog",
    "choice_d": "Epic",
    "correct_answer": "D",
    "explanation": "Epics are placeholders that contain big ideas that are not yet fully formed that are broken down into user stories as the project progresses.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      153,
      117,
      108,
      158,
      300
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 73,
    "question": "All of the following are types of testing used on information technology projects to determine if the system operates as expected except for which one?",
    "choice_a": "Progression",
    "choice_b": "Smoke",
    "choice_c": "End-to-end",
    "choice_d": "Stress",
    "correct_answer": "A",
    "explanation": "Testing is used to determine if the system operates as expected and to ensure all the functions, calculations, and features perform as planned. Progression is not a type of test.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      50,
      58,
      309,
      309,
      50
    ],
    "source": "892458_Assessment Test",
    "choice_e": "User acceptance"
  },
  {
    "id": 74,
    "question": "These important stakeholders are responsible for designing solutions for the technology enterprise.",
    "choice_a": "QA",
    "choice_b": "SMEs",
    "choice_c": "Architect",
    "choice_d": "Engineers",
    "correct_answer": "C",
    "explanation": "IT architects design solutions and services for the enterprise, business applications, infrastructure, and more. Quality assurance technicians ensure that the project works as designed, subject matter experts lend expertise to the project and perform the work of the project, and engineers write code and develop applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      58,
      121,
      55,
      53,
      57
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 75,
    "question": "What are the two types of charts that you might utilize to display the project schedule? (Choose two.)",
    "choice_a": "Run chart",
    "choice_b": "Gantt chart",
    "choice_c": "Milestone chart",
    "choice_d": "CPM",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Gantt charts and milestone charts are the most commonly used formats to display a project schedule.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      137,
      210,
      95,
      6,
      90
    ],
    "source": "892458_Assessment Test",
    "choice_e": "Histogram"
  },
  {
    "id": 76,
    "question": "Which of the following is the focus of HIPAA specifically?",
    "choice_a": "Protecting and safekeeping standards and regulations associated with personal data",
    "choice_b": "Protecting and safekeeping standards and regulations associated with linkable data",
    "choice_c": "Protecting and safekeeping SPII",
    "choice_d": "Protecting and safekeeping ePHI",
    "correct_answer": "D",
    "explanation": "The Health Insurance Portability and Accountability Act provides regulations regarding the safekeeping of electronic protected health information (ePHI).",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      30,
      195,
      29,
      31,
      190
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 77,
    "question": "This person is responsible for removing obstacles so that the team can perform their work, assisting the product owner in defining backlog items, and educating the team on agile processes.",
    "choice_a": "Project manager",
    "choice_b": "Scrum master",
    "choice_c": "Functional manager",
    "choice_d": "Subject matter expert",
    "correct_answer": "B",
    "explanation": "The Scrum master is responsible for removing obstacles that are getting in the way of the team performing the work. They work with the product owner to help define backlog items, and they educate team members on the agile process.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      119,
      108,
      120,
      117,
      153
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 78,
    "question": "Demonstrating competency, respect, honesty, integrity, openness, and doing what you say you\u2019ll do is an example of which of the following?",
    "choice_a": "Team building",
    "choice_b": "Managing team resources",
    "choice_c": "Demonstrating leadership skills",
    "choice_d": "Trust building",
    "correct_answer": "D",
    "explanation": "This is an example of trust building. As a project manager, you must do what you say you\u2019ll do and demonstrate the traits stated in the question.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      173,
      51,
      230,
      227,
      232
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 79,
    "question": "These gates are used as approval points in the project.",
    "choice_a": "Quality gates",
    "choice_b": "Approval gates",
    "choice_c": "Governance gates",
    "choice_d": "Milestone gates",
    "correct_answer": "C",
    "explanation": "Governance gates are used as approval points along the project. Quality gates are used to determine if the work meets quality standards. CompTIA does not recognize approval gates or milestone gates.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      150,
      250,
      132,
      71,
      66
    ],
    "source": "892458_Assessment Test"
  },
  {
    "id": 80,
    "question": "You are the project manager for Rivera Gourmet Adventure Vacations. Rivera combines the wonderful tastes of great gourmet food with outdoor adventure activities. Your project involves installing a new human resources software system. Your stakeholders understand this is a large undertaking and that you might experience some schedule slippage. Jason, the database analyst working on this project, is overallocated. He is critical to the success of the project, and you don\u2019t want to burn him out by overscheduling him. Which of the following actions should you take?",
    "choice_a": "You should use fast tracking to smooth out resource overallocation.",
    "choice_b": "You should use crashing to resource-level the critical path tasks.",
    "choice_c": "You should use resource leveling to balance out resource assignments.",
    "choice_d": "You should use resource smoothing to smooth out resource assignments.",
    "correct_answer": "C",
    "explanation": "Resource leveling is used for overallocated resources and allows for changes to the schedule completion dates. Crashing and fast tracking are schedule compression techniques that shorten the schedule. Resource smoothing techniques will not allow for changes to the critical path or project end date, and since you are concerned about not overusing this resource, lengthening the schedule is a better option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      148,
      144,
      164,
      141,
      135
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 81,
    "question": "You have identified risks on the project, performed risk analysis, and prepared response plans. You will document this information along with the risk owners and where the response plans can be located in which of the following?",
    "choice_a": "Risk matrix",
    "choice_b": "Risk response plan",
    "choice_c": "Risk register",
    "choice_d": "Risk statement",
    "correct_answer": "C",
    "explanation": "The risk register contains the information stated in the question.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      217,
      216,
      220,
      222,
      251
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 82,
    "question": "You are the project manager working on a new cloud deployment for your customer relationship management program. You have worked with the business analyst and business users to help define the characteristics for the final product. One of the requirements includes requiring customers to authenticate using a login with username and password, and having the system send them a code via text. Which of the following are true regarding this requirement? (Choose two.)",
    "choice_a": "This is a functional requirement.",
    "choice_b": "This is a nonfunctional requirement.",
    "choice_c": "This is a regulatory requirement.",
    "choice_d": "This is a business requirement.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "In software projects, nonfunctional requirements describe the characteristics related to the product such as security requirements or performance criteria. Functional requirements describe behavior such as calculations or processes. The question doesn\u2019t provide enough information to know if this is a regulatory requirement. All requirements should be tracked in the requirements traceability matrix.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      99,
      98,
      69,
      103,
      68
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "This should be tracked in the requirements traceability matrix."
  },
  {
    "id": 83,
    "question": "You are a project manager for Move It Now trucking company. Your company specializes in moving household goods across the city or across the country. Your project involves upgrading the nationwide computer network for the company. Your lead engineer has given you the following estimates for a critical path activity: 60 days most likely, 72 days pessimistic, 48 days optimistic. What is the weighted average estimate?",
    "choice_a": "54",
    "choice_b": "66",
    "choice_c": "60",
    "choice_d": "30",
    "correct_answer": "C",
    "explanation": "The calculation for PERT is the sum of optimistic time plus pessimistic time plus four times the most likely time divided by 6. The calculation for this example is as follows: (48 + 72 + (4  60)) / 6 = 60.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      199,
      141,
      144,
      201
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 84,
    "question": "This comes about by not controlling change and can cause irreparable damage to the project. Uncontrolled changes, changes that don\u2019t follow the change control process, and stakeholders asking for \u201cone little change\u201d can all lead to this.",
    "choice_a": "Uncontrolled change",
    "choice_b": "Schedule creep",
    "choice_c": "Budget change",
    "choice_d": "Scope creep",
    "correct_answer": "D",
    "explanation": "Scope creep comes about through uncontrolled change. The project manager should monitor this closely.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      86,
      279,
      281,
      91
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 85,
    "question": "You\u2019ve decided to put your project management skills to work at home. Your house needs painting, so you decide to plan it out as a project, identifying all the activities and sequencing them correctly. After an inspection of the house, you decide the rain gutters should be replaced too. Now that you see how much work you\u2019ve got ahead of you, you change your mind and decide to contract out both the painting and the gutter work, hopefully to the same contractor. You agree with the contract that you will reimburse them all the paint and supplies needed for both the house and the gutter work. You also agree to pay them $1,800 at the halfway point for his time and labor and another $1,800 when all the work is finished. What kind of contract does this describe?",
    "choice_a": "CPAF",
    "choice_b": "CPFF",
    "choice_c": "CPIF",
    "choice_d": "T&M",
    "correct_answer": "B",
    "explanation": "This is a cost plus fixed fee contract because you are reimbursing all allowable costs and agreed on a fixed fee for the work of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      199,
      201,
      278,
      274,
      86
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 86,
    "question": "Your PMO is responsible for managing groups of related projects in a coordinated fashion. Which of the following describes this concept?",
    "choice_a": "Life cycle phases",
    "choice_b": "Project management",
    "choice_c": "Process management",
    "choice_d": "Program",
    "correct_answer": "D",
    "explanation": "A program is a group of related projects that can benefit from coordinated management. The projects will bring about benefits that wouldn\u2019t be achieved if the projects were managed separately. The person who manages such a group of projects is called a program manager.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      57,
      28,
      164,
      4
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 87,
    "question": "Your project expenditures averaged $1,500 a month the first two months and are now projected to go up to $3,000 per month for the next four months, at the end of which your project will be completed. Your total project budget is $12,000. Which of the following statement is true?",
    "choice_a": "Your project cost estimates are incorrect.",
    "choice_b": "You used parametric estimating techniques to come up with the $12,000 total cost.",
    "choice_c": "Your burn rate is too high, and you will run out of money.",
    "choice_d": "The total project cost is too low.",
    "correct_answer": "C",
    "explanation": "The rate at which you are spending money over time (known as the burn rate) is too high, and you will run out of money if you don\u2019t take action to correct this. There is not enough information in the other options to know whether they are true. The question doesn\u2019t state the type of estimating methods used and just because you\u2019re spending money faster than anticipated doesn\u2019t mean the original cost estimate is too low.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      203,
      70,
      149,
      206,
      321
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 88,
    "question": "Your project involves implementing a new financial system for the organization. You work closely with the business analyst and business users to understand the pain points the current system presents to the users and to find the best business solution to solve the problem. You need to relay the requirements to the project manager as well as the development team and ensure the proposed solution fits within the IT enterprise. What role does this describe?",
    "choice_a": "Solutions architect",
    "choice_b": "Enterprise architect",
    "choice_c": "Product manager",
    "choice_d": "Product owner",
    "correct_answer": "A",
    "explanation": "This question describes a solutions architect. The solutions architect works with the enterprise architect and acts as a liaison between the business users, the development team, and the project manager.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      121,
      57,
      17,
      97,
      51
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 89,
    "question": "One of the primary roles of the project manager includes informing this person of changes, status, conflicts, and issues on the project.",
    "choice_a": "The project requestor",
    "choice_b": "The project sponsor",
    "choice_c": "The project champion",
    "choice_d": "The most influential project stakeholder",
    "correct_answer": "B",
    "explanation": "A key role of the project manager is informing the sponsor of changes, status, issues, and conflicts on the project. The project requestor and stakeholders should be informed as well, but the primary role of the project manager involves informing the sponsor and keeping them updated.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      53,
      56,
      232,
      272,
      23
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 90,
    "question": "Your project is winding down, and some of your team members are anxious about their status. What is the best way to deal with their concerns?",
    "choice_a": "Explain to the team members that they will be released when the project is done.",
    "choice_b": "Let the team members know that you can only discuss their release date with the functional managers.",
    "choice_c": "Establish the same release date for all the team members, even if their work is not completed.",
    "choice_d": "Review the team member release plans with the functional managers. Keep team members and functional managers informed based on the status of the project schedule.",
    "correct_answer": "D",
    "explanation": "Both team members and functional managers need to know in advance when you think a team member will be released. Team members may roll off the project at different times, so you need to discuss the release with each team member individually.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      174,
      23,
      172,
      335
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 91,
    "question": "You are developing a RACI chart and know which of the following is true?",
    "choice_a": "Only one resource can have the responsible designation.",
    "choice_b": "Only one resource can have the accountable designation.",
    "choice_c": "Only one resource can have the consult designation.",
    "choice_d": "Only one resource can have the inform designation.",
    "correct_answer": "B",
    "explanation": "Only one resource can have the accountable designation. Multiple people can have any of the other designations.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      8,
      12,
      71,
      236,
      259
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 92,
    "question": "Your project is underway, and a key stakeholder has submitted a change request. After further investigation, you discover some scope creep has also occurred on the project. These are examples of which of the following?",
    "choice_a": "Constraints",
    "choice_b": "Assumptions",
    "choice_c": "Influences",
    "choice_d": "Dependencies",
    "correct_answer": "C",
    "explanation": "Scope creep and change requests are examples of influences on the project. Influences can change, impact, or bring about new constraints.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      279,
      87,
      86,
      280
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 93,
    "question": "This document records items that usually arise during a status meeting. They concern the project but do not generally impact the project work directly. This document contains a description, an owner, and status, among other items.",
    "choice_a": "Status report",
    "choice_b": "Action items",
    "choice_c": "Issues",
    "choice_d": "Meeting minutes",
    "correct_answer": "B",
    "explanation": "Action items generally arise during the status meetings. They should be documented in an action item list. They are assigned an identification number, a description, and an owner, and their status is recorded and reviewed at status meetings. Issues generally impact the project work directly and may impede progress or bring about a risk. Action items are usually \u201cto dos\u201d or questions that must be answered regarding the project.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      256,
      253,
      315,
      254,
      72
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 94,
    "question": "You are working on allocating resources to the project. You know the resource type needed, such as programmer, tester, and tech writer, and are going to map the WBS identifier to the type and number of resources needed. What does this question describe?",
    "choice_a": "OBS",
    "choice_b": "RACI",
    "choice_c": "RBS",
    "choice_d": "RAM",
    "correct_answer": "D",
    "explanation": "This question describes a resource assignment matrix. The RACI chart is also a type of matrix-based chart, but it shows resource names and the type of responsibility they have on the project. Option A is an organization breakdown structure, and option C is a resource breakdown structure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      128,
      10,
      134,
      143
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 95,
    "question": "Your new project involves creating a prototype display for an Internet video ad. You are hiring a contractor for portions of the project. The contract stipulates that you\u2019ll pay all allowable costs and a 6 percent fee based on the allowable costs at the end of the contract. Which of the following describes this contract type?",
    "choice_a": "CPPF",
    "choice_b": "CPPC",
    "choice_c": "CPAF",
    "choice_d": "CPIF",
    "correct_answer": "B",
    "explanation": "This is a cost-reimbursable contract that includes a fee as a percentage of allowable costs. This type of contract is known as a cost plus percentage of cost (CPPC) contract.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      278,
      200,
      199,
      277,
      204
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 96,
    "question": "This is used to keep stakeholders and team members up to date. It typically contains information related to budgets, timelines, deliverables, and risks. The issue log and action items are usually distributed with this document.",
    "choice_a": "Status report",
    "choice_b": "Meeting minutes",
    "choice_c": "Action item log",
    "choice_d": "Dashboard information",
    "correct_answer": "A",
    "explanation": "Status reports update stakeholders on project progress. The issue log and action item list are usually distributed with the status report. Wiki pages are a way to distribute the reports. Meeting minutes document what occurred during the meeting and what decisions were made, whereas dashboards are up-to-date, real-time information on the status of key project elements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      324,
      287,
      259,
      236,
      208
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 97,
    "question": "This ESG factor includes reporting and monitoring project performance, communicating changes, accountability to the budget, and transparency.",
    "choice_a": "Governance",
    "choice_b": "Environmental",
    "choice_c": "Social",
    "choice_d": "Awareness of applicable regulations and standards",
    "correct_answer": "A",
    "explanation": "Governance factors refer to the way the project will be governed and how the governance will occur within the context of the overall organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      190,
      297,
      298,
      45,
      47
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 98,
    "question": "Your project concerns writing a new software app to track physical activity such as running, biking, and walking, including time spent on the activity, heart rate, and speeds. You\u2019ve performed some preliminary testing and discovered some changes need to be made to the code for the biking functionality. Once the changes are made, you\u2019ll test again to ensure the app is working as expected. What type of testing does this question describe?",
    "choice_a": "Stress",
    "choice_b": "End-to-end",
    "choice_c": "Unit",
    "choice_d": "User acceptance",
    "correct_answer": "C",
    "explanation": "Stress testing involves testing the system based on variable load conditions. End-to-end testing starts with the logon procedures and tests every feature of the app. Unit testing is the testing of one module or one unit of code, such as the biking feature, which this question describes. User acceptance testing is performed by the end users of the product.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      58,
      50,
      97,
      55,
      6
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 99,
    "question": "You are reporting on the project budget and are using a tool that shows the budget expenditures over time as shown here: <img src=\"/question_assets/Project+/BE1f001.png\"/> What is the name of this chart, and what is the actual burndown rate at the measurement date? (Choose two.)",
    "choice_a": "Actual burn rate is $100,000.",
    "choice_b": "Actual burn rate is $75,000.",
    "choice_c": "This is a budget burn-down chart.",
    "choice_d": "Actual burn rate is $80,000.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "This is a budget burn down chart. Burn rate is calculated as expenses to date/time periods at measurement date. First, we calculate how much has been spent to date. We started with a $400,000 budget and at the measurement date in November, we have $100,000 remaining. Therefore, expenses to date are $300,000. Expected burn rate is total budget $400,000 / 5 month time period = $80,000 expected burn rate per month. Actual burn rate is expenses to date/time periods at measurement date. The actual burn rate in this question is $300,000 / 4 months = $75,000 per month. You are spending less than the expected burn rate per month.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      213,
      322,
      266,
      154
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "This is a budget expenditure chart."
  },
  {
    "id": 100,
    "question": "Which of the following describes solutions design? (Choose two.)",
    "choice_a": "Determining how to configure the software program to meet the needs of the business.",
    "choice_b": "Determining the best technical solution to solve the business problem.",
    "choice_c": "Defining the functional and nonfunctional requirements of the software program.",
    "choice_d": "The person responsible for this role is known as the voice of the customer.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Option C is performed as part of the scope planning process or at the beginning of an iteration. Option D describes the product owner, and option E describes an agile methodology.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      103,
      132,
      84,
      9,
      128
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "This is a methodology that collocates team members to produce the work of the project faster."
  },
  {
    "id": 101,
    "question": "What does SWOT stand for? (Choose four.)",
    "choice_a": "Strengths",
    "choice_b": "Scope",
    "choice_c": "Operations",
    "choice_d": "Weakness",
    "correct_answer": [
      "A",
      "D",
      "E",
      "G"
    ],
    "explanation": "SWOT stands for strengths, weakness, opportunity, and threats and is useful in identifying risks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      218,
      217,
      215,
      226,
      261
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Threats",
    "choice_f": "Work effort",
    "choice_g": "Opportunities"
  },
  {
    "id": 102,
    "question": "You\u2019re a project manager for a project that\u2019s well into the executing phase. Which of the following activities will you be involved with during this process?",
    "choice_a": "Writing the project closure documents",
    "choice_b": "Preparing the project schedule",
    "choice_c": "Comparing budget estimates to actual costs",
    "choice_d": "Obtaining sign-off of the scope document",
    "correct_answer": "C",
    "explanation": "The executing phase involves performing the work of the project and tracking, monitoring, and controlling project results. Comparing budget estimates to actual costs is performed in the executing phase. Option A occurs in the Closing phase and options B and D occur in the Planning phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      10,
      324,
      203,
      84
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 103,
    "question": "You are ready to write the project charter and are not clear about the project description. What is the first step you should take?",
    "choice_a": "Meet with the requestor to identify and clarify the description.",
    "choice_b": "Meet with the requestor to write the project charter.",
    "choice_c": "Meet with the requestor to write the preliminary scope statement.",
    "choice_d": "Meet with the requestor to write the business case.",
    "correct_answer": "A",
    "explanation": "You must clarify the project request to determine exactly what the requestor needs. You can\u2019t write any of the documents named in the other options until you understand the project description.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      66,
      19,
      8,
      67
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 104,
    "question": "Why should you review the final project management plan with the sponsor and key stakeholders? (Choose two.)",
    "choice_a": "To catch any last-minute additions",
    "choice_b": "To make sure everyone agrees with the plan",
    "choice_c": "To obtain sign-off",
    "choice_d": "To give the sponsor the ability to back out",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A formal final review of the comprehensive project management plan is required so that you, the sponsor, and the key stakeholders understand the work of the project, the schedule, budget, and scope, and so that you can obtain sign-off.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      132,
      84,
      328,
      79,
      9
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "To prepare for the kick-off meeting"
  },
  {
    "id": 105,
    "question": "This term describes a characteristic of the scope planning (and other planning) phases:",
    "choice_a": "Looping",
    "choice_b": "Iterative",
    "choice_c": "Ongoing",
    "choice_d": "Repetitive",
    "correct_answer": "B",
    "explanation": "Project planning processes are iterative, meaning you\u2019ll define the scope statement and other planning documents, and as you create these documents, more information may come to light, or you may discover an element you missed. So, you\u2019ll go back through processes you\u2019ve already started and modify them with the new information.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      94,
      9,
      85,
      84,
      93
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 106,
    "question": "You are developing your project schedule and have decided to use the PERT method to determine project duration. The estimates you\u2019ve gathered so far include the following: most likely is 200 hours, optimistic is 180 hours, and pessimistic is 220 hours. Which of the following is the correct PERT estimate?",
    "choice_a": "190",
    "choice_b": "266",
    "choice_c": "200",
    "choice_d": "210",
    "correct_answer": "C",
    "explanation": "PERT\u2019s expected value calculation is as follows: (optimistic + pessimistic + (4  most likely)) / 6. The calculation for this question looks like this: (180 + 220 + (4  200)) / 6 = 200. Although PERT equals the most likely estimate in this example, that is not always the case.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      144,
      219,
      199,
      209
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 107,
    "question": "Your project is not going as expected. It is behind schedule, and one of the products being produced does not meet specifications. Working with the stakeholders, you write up two change requests. These are common project changes. Your next step is to submit which of the following to the CCB? (Choose two.)",
    "choice_a": "Funding change",
    "choice_b": "Timeline change",
    "choice_c": "Requirements change",
    "choice_d": "Quality change",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "This question describes a schedule or timeline change and a quality change. All of the options are types of common project changes, along with risk events and scope changes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      282,
      86,
      288,
      315
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Resource change"
  },
  {
    "id": 108,
    "question": "You are in the process of allocating resources to the project. When examining potential team members, you are looking at elements such as their skills, their years of experience, and their commitment to the project. You also discover that some needed skills are missing for critical work on the project and will need to hire those skills to fulfill these duties. You already know that you will allocate some resources who will also be working on other projects. What does this question describe?",
    "choice_a": "The resources working on other projects are shared resources. You have performed a gap analysis.",
    "choice_b": "The resources working on other projects are remote resources. You have performed a resource assessment.",
    "choice_c": "The resources working on other projects are internal resources. You have performed a resource allocation analysis.",
    "choice_d": "The resources working on other projects are dedicated resources. You have performed a resource skills assessment.",
    "correct_answer": "A",
    "explanation": "This question describes shared resources and the gap analysis process. Gap analysis looks at current state and compares it against the desired state.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      169,
      163,
      162,
      26,
      140
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 109,
    "question": "From this list, select those items that do not fall within the definition of infrastructure.",
    "choice_a": "The people on the IT team",
    "choice_b": "The servers",
    "choice_c": "The consultants advising on a project",
    "choice_d": "The network equipment",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Infrastructure includes the physical equipment needed to run systems and programs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      36,
      37,
      38,
      39,
      40
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "The cabling that connects computing equipment together"
  },
  {
    "id": 110,
    "question": "All of the following are communication triggers except for which one?",
    "choice_a": "Audits",
    "choice_b": "Incident response",
    "choice_c": "Task initiation",
    "choice_d": "Resource changes",
    "correct_answer": "E",
    "explanation": "Technological factors are factors that influence communication methods.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      272,
      247,
      251,
      246,
      271
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Technological factors",
    "choice_f": "Milestones"
  },
  {
    "id": 111,
    "question": "Which of the following are true regarding a Kanban board? (Choose three.)",
    "choice_a": "The Kanban board displays the work of the sprint in two- or four-week increments.",
    "choice_b": "Cards may change owners as they are pulled from one stage to another.",
    "choice_c": "Cards are pulled from one stage to another as the work is completed.",
    "choice_d": "The topmost card in any column of a Kanban board is most important.",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "A Kanban board is capacity based and sprints are timed based, so option A is incorrect. Cards are pulled from one stage to another as resources are available to work on the next task, not as the work is completed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      108,
      113,
      155,
      86
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Kanban allows for visualization of the work in each of the stages the work is progressing through."
  },
  {
    "id": 112,
    "question": "You work for a program manager in the PMO. You\u2019re working on a project to develop a cloud application. Your company\u2019s collections department will equip their field personnel with wireless tablets that will connect to the cloud. The servers, application, and data will reside on the cloud. You are starting the intake process for this project and have requested additional resources. One person from the PMO who will document requirements, and another from the IT department who will develop the programming code for the application. Which of the following are true regarding this question? (Choose three.",
    "choice_a": "This is a PaaS cloud model.",
    "choice_b": "You need a business analyst from the PMO for requirements.",
    "choice_c": "You need an engineer from the IT department to develop the program.",
    "choice_d": "This is a SaaS cloud model.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "This question describes the platform as a service cloud model whereby IT engineers (also known as developers) will write the program. SaaS allows consumers to use software developed by the provider. This question states the project manager works for the PMO, which establishes that a PMO exists. Business analysts also work for the PMO.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      58,
      53,
      88,
      6
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "You need an architect from the IT department to develop the program.",
    "choice_f": "You need a business analyst from the business unit who will act as an SME to write the requirements."
  },
  {
    "id": 113,
    "question": "You are working on a complex project and it\u2019s important that you show dependencies between tasks due to the resource shortages you are experiencing. Which of the following is true regarding this question?",
    "choice_a": "You should use a Gantt chart because it easily shows the dependencies between the tasks and the critical path.",
    "choice_b": "You should use a PERT chart because it shows the dependencies between the tasks along the entire project timeline.",
    "choice_c": "You should use a PERT chart because it easily shows the dependencies between the tasks and the critical path.",
    "choice_d": "You should use a milestone chart because it shows the dependencies between the tasks and the critical path.",
    "correct_answer": "C",
    "explanation": "A PERT chart shows the dependencies between tasks but does not display the entire project timeline. It\u2019s difficult (not easy, as the question states) to display dependencies and the critical path on a Gantt chart. A Gantt chart can display the entire project timeline, a PERT chart cannot (unless it\u2019s a very small project).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      146,
      138,
      152,
      139
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 114,
    "question": "You are managing a new software deployment for your organization and are using a development methodology that consists of phases such planning, defining, designing, building, testing, and deploying. You want to ensure that you deliver a high-quality program to the organization. Which of the following does this describe?",
    "choice_a": "Project life cycle",
    "choice_b": "SDLC",
    "choice_c": "PRINCE2",
    "choice_d": "Project management phases",
    "correct_answer": "B",
    "explanation": "This question describes the software development life cycle methodology. Project life cycles are not the same as development life cycles. Development life cycles are performed within the project life cycle. Waterfall and agile are types of SDLC. PRINCE2 is a project management methodology. Project management phases are used to manage the phases of the project life cycle.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      106,
      107,
      105,
      133,
      6
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 115,
    "question": "You are working on creating the budget for the project. Your organization has code of accounts for different categories of expenses. One of the purchases you\u2019ll be making for your project includes specialized IT equipment that has an expected useful life of five years. In addition, you will be using contract labor to help with the implementation of some of this equipment, and full-time employees to perform the configuration of this equipment. Which of the following is true regarding this question?",
    "choice_a": "The specialized IT equipment and contract labor is a CapEx and the full-time employees are OpEx.",
    "choice_b": "The specialized IT equipment is a CapEx and both the contact labor and the full-time employees are OpEx.",
    "choice_c": "The specialized IT equipment is an OpEx and both the contact labor and full-time employees are CapEx.",
    "choice_d": "The specialized IT equipment and full-time employees are a CapEx and the contact labor is an OpEx.",
    "correct_answer": "B",
    "explanation": "CapEx apply to assets that are expected to provide benefit to the organization into the future. OpEx are used for day-to-day activities of doing business such as paying contract labor and salaries.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      206,
      70,
      14,
      188
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 116,
    "question": "Your department is responsible for performing system maintenance on the customer support servers. This maintenance activity requires specialized skills, and you have one person on staff with these skills. During this maintenance cycle, you will cross-train two other team members so that they can also perform these tasks in the future. Which of the following are true regarding this question? (Choose three.)",
    "choice_a": "This project was brought about because of a technological need.",
    "choice_b": "This is an ongoing operation.",
    "choice_c": "This is not temporary in nature.",
    "choice_d": "This was brought about because of a business need.",
    "correct_answer": [
      "B",
      "C",
      "F"
    ],
    "explanation": "The work you are undertaking does not create a unique product or service. It is part of the ongoing operational maintenance. The reason it came about is irrelevant because it\u2019s part of ongoing operations. This activity may be temporary with a start and end date to perform the maintenance, but it does not create a unique product or service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      3,
      88,
      86,
      127
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "The project manager is responsible for assigning resources to this task.",
    "choice_f": "This does not create a unique product or service."
  },
  {
    "id": 117,
    "question": "You\u2019re developing a scope statement for a customer request. A couple of the elements that the customer wants could be difficult to accomplish, but after consulting with the project team, you think they can be done. These elements are not included in the product description. What should you do?",
    "choice_a": "Include these elements in the scope document, trusting your project team to deliver.",
    "choice_b": "Include these elements in the scope document, denoting them as a concern, and document how the issues were resolved.",
    "choice_c": "Discuss this situation with the project sponsor and the customer. Obtain sponsor sign-off on any changes.",
    "choice_d": "Note the elements in the exclusions section of the scope statement, and state that they\u2019ll be included in phase 2.",
    "correct_answer": "C",
    "explanation": "Whenever problems arise on a project that are outside the authority or control of the project manager to resolve or when problems have the ability to affect project outcomes, the sponsor should always be informed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      88,
      288,
      24,
      51
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 118,
    "question": "You are documenting issues in the issues log and need to work with the team to determine prioritization of the issues. All of the following are used to help determine priority except for which one?",
    "choice_a": "The current status of the issue",
    "choice_b": "The issue severity usually ranked as high-medium-low",
    "choice_c": "The scope of the impact of the issue to the organization",
    "choice_d": "The issue escalation criterion",
    "correct_answer": "A",
    "explanation": "According to CompTIA, the factors used to determine priority are issue severity, impact to the project, urgency of the issue, scope of the impact to the organization, and issue escalation.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      317,
      318,
      315,
      220,
      24
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 119,
    "question": "Your project requires that IT develop a new application in the cloud. What type of cloud service is best for this?",
    "choice_a": "IaaS",
    "choice_b": "XaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "C",
    "explanation": "Platform as a service (PaaS) is a software model that allows application developers to build applications in the cloud.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      49,
      36,
      37
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 120,
    "question": "Project schedules should be re-baselined after which of the following activities?",
    "choice_a": "When an approved change has impacted a noncritical path task",
    "choice_b": "When the product sponsor determines a schedule change needs to occur",
    "choice_c": "When risk events cause changes to the schedule activities",
    "choice_d": "When an approved change has impacted a critical path task",
    "correct_answer": "D",
    "explanation": "A project schedule should be re-baselined when an approved change has occurred that impacts a critical path task, which in turn impacts the project end date.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      274,
      279,
      86,
      135
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 121,
    "question": "Your organization underwent an internal reorganization recently, and two years ago they were acquired by another company. You know which of the following is true regarding this question? (Choose three.)",
    "choice_a": "Both of these situations describe a type of change that could impact your project.",
    "choice_b": "The reorganization and acquisition are types of organizational change.",
    "choice_c": "These situations describe an operational change that can bring about project change.",
    "choice_d": "The firm that acquired your organization has the authority and power to make decisions.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "A reorganization and an acquisition are types of organizational changes that could impact or bring about project changes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      289,
      226,
      281,
      315,
      282
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "The reorganization and acquisition are types of organizational influences on constraints."
  },
  {
    "id": 122,
    "question": "You are a project manager who works for a nationwide bank with branches in every major city in the country. You are creating a project schedule. Your primary constraint is a hard deadline of November 1. The resource availability for this project is questionable. Which of the following techniques will you use to help resolve this problem?",
    "choice_a": "Resource leveling",
    "choice_b": "Reverse resource allocation",
    "choice_c": "Critical chain method",
    "choice_d": "Resource smoothing",
    "correct_answer": "D",
    "explanation": "Resource smoothing adjusts the schedule activities within their floats and does not impact the project end date. This question states that your deadline for the project is November 1, implying you cannot change the end date. The critical chain method adds activity buffers, which can change the project end date.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      144,
      90,
      274,
      281,
      91
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 123,
    "question": "Which of the following is true regarding the minimum viable product?",
    "choice_a": "An MVP is a fully functioning end product that meets the requirements criteria.",
    "choice_b": "MVPs are produced when using a predictive development methodology.",
    "choice_c": "MVPs are the final outcome of the SDLC process.",
    "choice_d": "MVPs are used to validate the product and as justification for a change request.",
    "correct_answer": "E",
    "explanation": "All of the options are incorrect. An MVP is a representation of the end product that has enough features and functionality to determine value. They are produced quickly with little effort. MVPs are produced when using adaptive, or agile, methodologies. MVPs are part of the SDLC process, not the final outcome. MVPs are used to validate the product at the end of an iteration. Work that isn\u2019t acceptable or needs to be changed is incorporated into the next iteration. Agile does not use a change request process. The changes needed will be discussed at the end of this sprint, and the beginning of the next.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      158,
      108,
      117,
      280
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "None of the above."
  },
  {
    "id": 124,
    "question": "You are a project manager for Uncle Sam\u2019s Flag Company. Your company has designed a new line of products featuring the American flag. Because of some unique circumstances, the products are in hot demand. The project sponsor has asked you to do whatever it takes to get this project completed early and make the products available. You decide to use an agile approach to complete this project. Your team\u2019s velocity, based on past experience, is 21 story points per sprint. Your project has a total of 252 story points. Your sprints are two weeks in duration. Which of the following is true?",
    "choice_a": "Your project duration is 24 weeks.",
    "choice_b": "You are performing the Define Activities process.",
    "choice_c": "Your project duration is 12 weeks.",
    "choice_d": "You are using a Kanban methodology.",
    "correct_answer": "A",
    "explanation": "There are 252 story points, and the team can complete 21 story points per sprint. 252 \u00f7 21 = 12. It will take 12 sprints to complete the story points. The sprints are two weeks in duration. 12 \u00d72 = 24 weeks total. Velocity is used in Scrum. This activity would be associated with the Estimate Activity Durations process.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      155,
      157,
      108,
      211,
      210
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 125,
    "question": "You\u2019re a project manager for a project that\u2019s well underway. You have a disgruntled team member who is distracting the team\u2019s focus. The team member came to the team with some sort of chip on their shoulder but managed to keep it low-key until now. This team member has skills that are critical to the project\u2019s success and is required for the entire project lifecycle. What\u2019s the best plan to deal with this issue?",
    "choice_a": "Ask this extended team member to seek a new team to work with.",
    "choice_b": "Ask the core team member what the issues seem to be. After a listening session, tell them that things aren\u2019t working out and that you\u2019re seeking a new team for them to work with.",
    "choice_c": "Ask the core team member what the issues seem to be. Try to get to the heart of what\u2019s bothering them. Ask how you can help correct the issues, if possible. Stress the importance of the project and their role on the team.",
    "choice_d": "Tell the functional team member what you perceive the issues to be and then ask them what\u2019s bothering them. Stress the importance of the project and their role on the team and strive to find a resolution to the issues.",
    "correct_answer": "C",
    "explanation": "People are the most important element of your project. Clearly, this individual came to the team with some sort of issue. It\u2019s important to first get with this person and try to determine what the issues are and ask how you can help. Telling them that they can no longer be on the team without first trying to resolve the issue is not a good solution. Also, telling the team member what you believe the issue is before they\u2019ve had a chance to speak first may put them on the defensive, and you\u2019ll never get to the heart of the problem.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      179,
      173,
      230,
      23,
      245
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 126,
    "question": "Which of the following are reasons for bringing about a project? (Choose three.)",
    "choice_a": "Feasibility study",
    "choice_b": "Market demand",
    "choice_c": "Business case justification",
    "choice_d": "Organizational need",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "The needs or demands that bring about a project include the following: market demand, organizational need, customer request, technological advance, legal requirements, ecological impact, and social needs. A feasibility study is conducted to determine the viability of a project, and the business case documents the reasons for the project and the justification for the project. Stakeholder needs may bring about a project, but their needs will fall more specifically into one of the seven needs or demands that bring about a project.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      14,
      8,
      19,
      102,
      65
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Social needs",
    "choice_f": "Project charter sign-off"
  },
  {
    "id": 127,
    "question": "You have completed qualitative risk analysis and have decided that more analysis needs to be performed because of the significant impact the cost and schedule risks pose to the project. Which of the following is true? (Choose two.)",
    "choice_a": "You should use quantitative analysis to further analyze and determine which of these risks has the greatest impact on the project objectives.",
    "choice_b": "You should use the probability and impact matrix tool and technique to further analyze and determine which of these risks has the greatest impact on the project objectives.",
    "choice_c": "You should use Monte Carlo analysis to further analyze and simulate the schedule and cost risks many times to estimate potential outcomes.",
    "choice_d": "You should use the EVM technique to further analyze and determine cost and schedule risks.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Quantitative techniques are performed after qualitative techniques and can be used to further analyze project risks. Monte Carlo is a simulation technique, used most often for cost and schedule risk, that helps estimate outcomes for multiple scenarios. Monte Carlo is also a quantitative risk analysis technique. Probability and impact matrix is a qualitative risk analysis technique, and option D describes earned value management, which is not a risk analysis technique.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      221,
      220,
      222,
      216,
      219
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 128,
    "question": "Your project sponsor has just signed the project charter. You are ready to hold the kickoff meeting and using a waterfall life cycle methodology. Which of the following are true regarding this question?",
    "choice_a": "You may need to hold an additional kickoff meeting if all the team members are not yet assigned.",
    "choice_b": "You\u2019ll discuss the objectives of the project at this meeting.",
    "choice_c": "This is the best way to formally introduce team members and stakeholders.",
    "choice_d": "The project team can begin starting the work of the project once this meeting is concluded.",
    "correct_answer": "G",
    "explanation": "This concludes the initiating phase, and the planning phase can begin. Option D describes the executing phase, where the work of the project is performed. The planning phase comes before the executing phase when using a waterfall life cycle development approach so the work cannot begin until the planning is completed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      81,
      7,
      9,
      76,
      85
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "You have completed the initiating phase when the kickoff is completed.",
    "choice_f": "All of the options are true.",
    "choice_g": "Options A, B, C, and E are true."
  },
  {
    "id": 129,
    "question": "You are examining the network paths for your project. Path A\u2019s duration is 1-2-3-5-8; Path B\u2019s duration is 1-3-5-6-7; Path C\u2019s duration is 1-2-5-4-9; and Path D\u2019s duration is 2-3-4-4-8. Which of the following is the critical path for this project?",
    "choice_a": "Path D",
    "choice_b": "Path C",
    "choice_c": "Path B",
    "choice_d": "Path A",
    "correct_answer": "C",
    "explanation": "The duration of Path A is 19, the duration of Path B is 22, the duration of Path C is 21, and the duration of Path D is 21. Therefore, Path B (option C) is the critical path because it\u2019s the longest path on the project.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      144,
      141,
      142,
      140,
      210
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 130,
    "question": "Your project concerns developing a new software app that tracks employee\u2019s expense. There are several modules involved in this system that work together to produce the final expense report, one of which allows employees to take pictures of their receipts to include with the final expense report. You have just completed unit testing. Which test will you perform next?",
    "choice_a": "Regression",
    "choice_b": "End-to-end",
    "choice_c": "Integration",
    "choice_d": "User acceptance",
    "correct_answer": "C",
    "explanation": "Integration testing combines software modules and tests them as a group. This may also involve testing programs or modules that need to interact with one another. An integration test typically occurs after unit testing is completed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      50,
      110,
      309,
      6
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 131,
    "question": "You are evaluating proposals from three vendors. You are comparing the bids against each other to determine costs, experience, features and functionality of the products, and more. You are also determining the number of years of experience they have in the industry and in performing projects such as this one. Which of the following vendor evaluation techniques does this describe? (Choose two.)",
    "choice_a": "Physical capacity",
    "choice_b": "Cost\u2013benefit",
    "choice_c": "Qualifications",
    "choice_d": "Market research",
    "correct_answer": [
      "C",
      "F"
    ],
    "explanation": "This question describes competitive analysis and qualifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      185,
      169,
      62,
      15,
      53
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Technical approach",
    "choice_f": "Competitive analysis"
  },
  {
    "id": 132,
    "question": "How will you know that the deliverables are meeting expectations as documented in the project scope statement?",
    "choice_a": "By measuring earned value management",
    "choice_b": "By using KPIs",
    "choice_c": "Be requiring the team to report on progress",
    "choice_d": "By observing the work product",
    "correct_answer": "B",
    "explanation": "Key performance indicators help determine whether the project is on track and provide specific measures to determine if the deliverables have met expectations. KPIs may include earned value management results, but the calculations themselves are not a KPI unless documented in the scope statement. Observing the work product will help determine if the deliverables are being met, but KPIs are what\u2019s documented in the scope statement.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      89,
      88,
      306,
      320,
      209
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 133,
    "question": "This agile methodology focuses on frequent cycles and delivering software to the customer when the customer needs it. The core values for this methodology are communication, simplicity, feedback, courage, and respect. Which methodology does this describe?",
    "choice_a": "Feature-driven development",
    "choice_b": "Agile unified process",
    "choice_c": "Dynamic systems development method",
    "choice_d": "Extreme programming",
    "correct_answer": "D",
    "explanation": "Extreme programming (XP) focuses on frequent cycles and delivering software to the customer when the customer needs it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      107,
      112,
      300,
      158
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 134,
    "question": "Your project entails developing an app that will unlock your front door to allow deliveries from your favorite online services. The app will unlock the front door, detect and record how long the door was open, detect that a package or box was deposited on a delivery mat that is just inside the door, and then relock the door 30 seconds after the mat senses a package was placed there. You are using an agile approach to manage this project and will use iterative scheduling based on four-week periods of time. Which of the following describes this concept? (Choose two.)",
    "choice_a": "User stories are pulled from the product backlog and placed on the sprint backlog for the team to work on in the upcoming sprint.",
    "choice_b": "User stories that are in the sprint backlog will be decomposed into tasks and team members will choose the tasks they want to work on during the sprint.",
    "choice_c": "User stories are pulled from the product backlog as the team has capacity to work on them.",
    "choice_d": "User stories are decomposed into tasks and managed on a task board. Tasks cannot proceed from one work column to another on the board until the team has capacity to work on them.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Options A and B are known as iterative scheduling. Options C and D are known as on-demand scheduling or pull-based scheduling.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      107,
      118,
      123,
      109,
      144
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 135,
    "question": "Your project is not going as expected. The project is behind schedule, risks have occurred that no one thought would come about, and critical team members are leaving the project. Which of the following options is true regarding this scenario?",
    "choice_a": "You should send an email to the project stakeholders to inform them of the situation.",
    "choice_b": "You should hold an informational meeting to devise solutions to these issues.",
    "choice_c": "You should use an asynchronous form of communication.",
    "choice_d": "You should inform the project sponsor in person.",
    "correct_answer": "D",
    "explanation": "You need to use real-time communication (synchronous) and should inform the project sponsor in person of this situation. Asynchronous communication is not real time. You might hold a collaborative meeting to devise solutions to the issues, not an informational meeting.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      233,
      253,
      53,
      272,
      271
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 136,
    "question": "Which of the following is not a resource life cycle phase?",
    "choice_a": "End-of-life software",
    "choice_b": "Maintenance",
    "choice_c": "Successor planning",
    "choice_d": "Hardware decommissioning",
    "correct_answer": "E",
    "explanation": "Resource life cycles include acquisition, maintenance, hardware decommissioning, end-of-life software, and successor planning.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      148,
      164,
      163,
      161
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Subscription"
  },
  {
    "id": 137,
    "question": "You are working on an agile software development project. Your team has self-organized, and you\u2019re ready to begin the work of the project. What is the team\u2019s next step?",
    "choice_a": "Hold the backlog refinement meeting so the team can choose the backlog items to work on during the upcoming sprint.",
    "choice_b": "Hold the sprint planning meeting so the team can choose the backlog items to work on during the upcoming sprint.",
    "choice_c": "Hold the retrospective planning meeting so the team can choose the backlog items to work on during the upcoming sprint.",
    "choice_d": "Hold the daily standup planning meeting so the team can choose the backlog items to work on during the upcoming sprint.",
    "correct_answer": "B",
    "explanation": "The next step is to hold the sprint planning meeting. The daily standup meetings are held daily to discuss progress and what\u2019s up next; the retrospective is held at the end of the sprint. The backlog refinement meeting is held mid-way through the sprint to review the user stories coming up in the next sprint.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      108,
      119,
      120,
      253
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 138,
    "question": "Recognizing the warning signs of trouble will help mitigate expensive consequences. You will often see these warning signs come about during communications with stakeholders or team members, among others. Which soft skill does this describe that should be in the project manager\u2019s skill set?",
    "choice_a": "Communicating",
    "choice_b": "Problem solving",
    "choice_c": "Consensus building",
    "choice_d": "Listening",
    "correct_answer": "B",
    "explanation": "This question describes problem solving. Communicating and listening play a part as well but understanding and recognizing warning signs are the basis for problem solving.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      23,
      230,
      272,
      263
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 139,
    "question": "You are working with a vendor on your outdoor event for a small gathering of potential customers. The vendor will supply appetizers and drinks, including bottled water and wine. Unfortunately, the wine was not delivered the morning of the event and the vendor had to send two staff members to a local wine shop to buy the wine needed for the event. What resolution technique did this vendor use to address the issue?",
    "choice_a": "Transfer",
    "choice_b": "Work-around",
    "choice_c": "Exploit",
    "choice_d": "Share",
    "correct_answer": "B",
    "explanation": "The vendor used a work-around to address this issue. Work-arounds can hold off the impacts to the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      317,
      24,
      276,
      277,
      286
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 140,
    "question": "All of the following are examples of IT security policies except which one?",
    "choice_a": "Cybersecurity incident response",
    "choice_b": "PII data handling procedures for paper job applications",
    "choice_c": "Protection for electronic confidential and sensitive information",
    "choice_d": "Acceptable use policy",
    "correct_answer": "B",
    "explanation": "IT security policies discuss the minimum standard requirements to secure systems, data, and other IT assets. Paper job descriptions handled by the HR department would not be covered by an IT security policy. If the job applications are scanned into the system, they would be covered.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      190,
      191,
      192,
      194,
      195
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 141,
    "question": "Which of the following describes the difference between deliverables and milestones? (Choose two.)",
    "choice_a": "Milestones are used to measure performance.",
    "choice_b": "Deliverables are used to measure performance.",
    "choice_c": "Milestones are an output or result that must be completed in order to consider the project complete.",
    "choice_d": "Deliverables are an output or result that must be completed in order to consider the project complete.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Deliverables are an output or result that must be completed in order to consider the project complete. Milestones are used to measure performance.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      70,
      150,
      69,
      122,
      10
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 142,
    "question": "Which of the following is the least precise of all the cash flow techniques?",
    "choice_a": "NPV",
    "choice_b": "ROI",
    "choice_c": "Discounted cash flow",
    "choice_d": "Payback period",
    "correct_answer": "D",
    "explanation": "Payback period is the least precise of all cash flow techniques.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      203,
      96,
      84,
      188,
      206
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 143,
    "question": "You are taking over a project that is already underway. The previous project manager left the organization. You discover that some of the key requirements for the product of the project are missing and that risks have not been identified. Since the project work has already begun, you determine which of the following to be the best next step?",
    "choice_a": "The work of the project is underway, and the team members know the requirements, even though they haven\u2019t been documented. You decide the next step is to hold a risk identification and prioritization meeting and create the risk register.",
    "choice_b": "Submit a change request and after approval, update the scope statement with the new requirements and hold a risk identification and prioritization meeting, record new risks on the risk register, and assign risk owners to write response plans.",
    "choice_c": "Hold a meeting with the team members to discuss their level of understanding of the project goals and objectives. Depending on the outcome of this meeting, you may or may not submit a change request, but you will document the risks and prioritize them based on what the team members tell you in this meeting.",
    "choice_d": "Inform the project sponsor and ask to suspend the project temporarily so you can meet with all the key stakeholders, document the requirements appropriately, and hold a risk identification and prioritization meeting before restarting the work of the project.",
    "correct_answer": "B",
    "explanation": "Since the work of the project is underway, the next best step is to submit a change request and then update the scope statement with the new features. You should hold a risk identification and prioritization meeting and document the risks in a risk register and document the response plans.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      217,
      216,
      86,
      280,
      88
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 144,
    "question": "You are a project manager for a telecommunications company assigned to a project to deploy a new wireless network using a technology that does not have a proven track record. The sponsor has told you that the budget cannot be exceeded. This project sponsor leaves mid-project, and a new sponsor takes over. The new sponsor wants to make certain the technology is tested thoroughly and is willing to spend a little more money if needed to assure a quality product. Which of the following does this describe?",
    "choice_a": "Communication trigger",
    "choice_b": "Factor influencing communication",
    "choice_c": "Constraint reprioritization",
    "choice_d": "Change request",
    "correct_answer": "C",
    "explanation": "This sponsor has changed and reprioritized the project constraints. Change requests are typically submitted for changes to the schedule or scope. This sponsor is putting more emphasis on quality than the last sponsor, so it\u2019s a reprioritization of constraints.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      91,
      279,
      53,
      281
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 145,
    "question": "You are working on a project in the automotive industry that requires specialized knowledge of robotics. The team members are well versed in this technology and eager to start the project. They are using an agile methodology to conduct the project. The product owner is now pulling the user stories from the backlog for the team members to breakdown into tasks and estimate. What is the meeting called where these activities occur?",
    "choice_a": "Sprint planning meeting",
    "choice_b": "Backlog planning meeting",
    "choice_c": "Project status meeting",
    "choice_d": "Retrospective meeting",
    "correct_answer": "A",
    "explanation": "The sprint planning meeting occurs at the beginning of the sprint. This is where the product owner pulls user stories from the backlog and also where team members breakdown the user stories into tasks and estimate their duration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      108,
      119,
      120,
      253
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 146,
    "question": "You are procuring professional services for your agile project. This procurement document will include tasks the vendor will complete in the iteration and any standards that apply to the project. This document also states that each iteration is two weeks. What document does this describe and what contract type is it used with?",
    "choice_a": "SOW with an RFP",
    "choice_b": "TOR with an RFP",
    "choice_c": "TOR with an MSA",
    "choice_d": "SOW with an MSA",
    "correct_answer": "C",
    "explanation": "A term of reference is often used within a master service agreement for agile projects. It is similar to a statement of work.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      119,
      6,
      123,
      86
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 147,
    "question": "You are working with a vendor to manage and perform the work of the project. Your job is to ensure the vendor meets scope requirements, quality standards, that they stay within budget and schedule, and that deliverables meet the standards outlined in the contract. Which of the following options is not true regarding this question?",
    "choice_a": "This is known as a vendor review, which is used to determine if the vendor is meeting scope, quality, cost, schedule, and other requirements of the contract statement of work.",
    "choice_b": "You\u2019ll use the contract statement of work and terms of the contract to determine performance compliance.",
    "choice_c": "Procurement audits can be performed by the buyer or the seller.",
    "choice_d": "The vendor needs to manage stakeholder expectations for this project.",
    "correct_answer": "D",
    "explanation": "You as the project manager are responsible for managing stakeholder expectations for the project, not the vendor.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      78,
      188,
      273,
      76,
      71
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "This can be conducted using inspections or audits."
  },
  {
    "id": 148,
    "question": "You are procuring a new ERDMS in the cloud. You know that there are several resource procurement methods you could use. Which of the following resource procurement methods will you use for this purchase?",
    "choice_a": "A lease",
    "choice_b": "A subscription",
    "choice_c": "A combination of build and subscription",
    "choice_d": "A combination of buy and lease",
    "correct_answer": "B",
    "explanation": "Cloud systems are purchased on a subscription or use the pay-as-you-go method.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      204,
      185,
      20,
      162
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 149,
    "question": "Documentation of the network, infrastructure, software, and more is important so that IT staff members have a reference when changes need to be made to the environment, when new equipment is introduced or retired, and for troubleshooting. Which of the following are examples of documentation?",
    "choice_a": "Purchase date and license codes",
    "choice_b": "Vendor contact information",
    "choice_c": "Inventory of hardware",
    "choice_d": "Diagrams of the network",
    "correct_answer": "F",
    "explanation": "All of the options are examples of documentation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      99,
      236,
      294,
      103
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Change logs.",
    "choice_f": "All of the above"
  },
  {
    "id": 150,
    "question": "You have an easily understood, succinct message to send to some of the stakeholders on your project. Which of the following methods are the best ways to communicate this message? (Choose two.)",
    "choice_a": "Virtual meeting",
    "choice_b": "Printed media",
    "choice_c": "Email",
    "choice_d": "Videoconference",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Meetings, conferences, and printed media are typically used for complex messages that aren\u2019t easily understood. Email and instant message are good methods to use when the message is clear and succinct and will be easily understood by the receiver.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      233,
      244,
      253,
      232
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Instant message"
  },
  {
    "id": 151,
    "question": "This stakeholder analysis technique uses a model that analyzes elements such as power levels, interest levels, attitudes, influence levels, and ability to impact or change the project.",
    "choice_a": "Power/influence grid",
    "choice_b": "Power/interest grid",
    "choice_c": "Salience model",
    "choice_d": "Stakeholder cube",
    "correct_answer": "D",
    "explanation": "This question describes a 3D stakeholder cube, which analyzes combinations of stakeholder influence, interest, attitudes, power, and more.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      16,
      59,
      63,
      231,
      8
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 152,
    "question": "You are a project manager for Uncle Sam\u2019s Flag Company. Your company has an idea for a new line of non-fungible tokens (NFT) featuring the American flag. They don\u2019t know all the features of the NFTs at this time. They will be offered in the company\u2019s online marketplace alongside other NFTs but not much is known about this new product yet. Which of the following actions should you take?",
    "choice_a": "Work with the product owner to begin creating user stories for this new product.",
    "choice_b": "Engage the agile team to break down this idea into story points that can easily be estimated.",
    "choice_c": "Create a user story that depicts the NFT as a minimally viable product.",
    "choice_d": "Use an epic to capture the idea of the NFTs and then decompose them into user stories as more becomes known.",
    "correct_answer": "D",
    "explanation": "Epics are placeholders that are used to capture ideas for business requirements or functionality that isn\u2019t fully known yet. They are then decomposed into user stories as more information becomes known.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      153,
      117,
      108,
      97,
      57
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 153,
    "question": "The executives in your organization often travel up to 75 percent of their workdays. The IT department is implementing MFA to enforce a verification of identity to help mitigate exploits of their accounts. Which of the following option is not true about this process?",
    "choice_a": "MFA requires at least two methods to verify identity.",
    "choice_b": "The first step in MFA occurs with a username and password.",
    "choice_c": "MFA procedures are outlined in the data security policy.",
    "choice_d": "MFA provides a way for users to log in remotely to access corporate systems and data.",
    "correct_answer": "C",
    "explanation": "Multifactor authentication (MFA) is a process whereby the user must provide two or more methods to verify their identity during the sign-in process. MFA is outlined in the data security policy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      195,
      190,
      192,
      191
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 154,
    "question": "Your sponsor is recommending a scope change. What other elements may require changes due to changing scope? (Choose three.)",
    "choice_a": "Risk",
    "choice_b": "Resources",
    "choice_c": "Cost",
    "choice_d": "Schedule",
    "correct_answer": [
      "C",
      "D",
      "F"
    ],
    "explanation": "Scope changes may require changes to the project budget (cost), the schedule, and the product scope description. New risks may occur as a result of the scope change, but this is not always the case.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      248,
      86,
      214,
      91,
      287
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Equipment",
    "choice_f": "Product scope"
  },
  {
    "id": 155,
    "question": "Which of the following histograms rank-orders the frequency of data values over time?",
    "choice_a": "Histogram",
    "choice_b": "Decision tree",
    "choice_c": "Scatter diagram",
    "choice_d": "Pareto chart",
    "correct_answer": "D",
    "explanation": "A Pareto chart rank orders the frequency of data values over time and is a type of histogram.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      266,
      154,
      267
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 156,
    "question": "You are working on a Scrum project and wish to determine how long it will take to complete the backlog, which reflects how fast the team is working. What does this describe?",
    "choice_a": "Burndown chart",
    "choice_b": "Burnup chart",
    "choice_c": "Velocity",
    "choice_d": "Scrum board",
    "correct_answer": "C",
    "explanation": "Velocity reflects the speed at which the Scrum team is working. Burndown charts show the remaining amount of work in the iteration, and the burnup chart shows the remaining amount of time. The Scrum board shows the tasks in an iteration and their stages of completion.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      155,
      108,
      133,
      118,
      301
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 157,
    "question": "This type of change helps reduce the probability of a negative risk event from occurring.",
    "choice_a": "Preventive actions",
    "choice_b": "Defect repairs",
    "choice_c": "Corrective actions",
    "choice_d": "Change control",
    "correct_answer": "A",
    "explanation": "Preventive actions are a type of change that helps reduce the probability of a negative risk event.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      285,
      222,
      216,
      217,
      220
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 158,
    "question": "Your project involves developing a new game for your mobile app division. You work closely with the person who oversees the entire line of games available on a mobile platform. They will meet with stakeholders and customers to determine strategy. They are planning on holding a series of focus groups to determine new features and functionality that could be incorporated into the new game. What role does this describe?",
    "choice_a": "Solutions architect",
    "choice_b": "Product manager",
    "choice_c": "Project sponsor",
    "choice_d": "Product owner",
    "correct_answer": "B",
    "explanation": "This question describes a product manager. A product manager oversees the products and the development of new products for the organization. They meet with stakeholders and customers, determine strategy, create requirements, and oversee development of the product.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      54,
      28,
      108,
      118
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 159,
    "question": "The business case presented for your project outlines the initial cost of the project at $100,000. Expected inflows are $25,000 year 1, $50,000 year 2, and $125,000 year 3. The cost of capital is 4 percent. What is NPV (options are rounded)?",
    "choice_a": "$118,730",
    "choice_b": "$100,000",
    "choice_c": "$200,000",
    "choice_d": "$218,730",
    "correct_answer": "A",
    "explanation": "NPV calculates the present value of each inflow and then sums the inflows to come up with a total. The formula for present value is <br>PV = FV / (1 + i)<sup><i> n</i></sup><br>Year 1 inflows are $24,038 calculated as: 25,000/(1+.04)<sup><i> 1</i></sup><br>Year 2 inflows are $54,080 calculated as: 50,000/(1+.04)<sup><i> 2</i></sup><br>Year 3 inflows are $140,612 calculated as: 125,000/(1+.04)<sup><i> 3</i></sup><br>The sum of the cash inflows is $218,730.<br>$218,730 \u2013 $100,000 (initial investment) \u2013 $118,730.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      70,
      102,
      19,
      8
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 160,
    "question": "All of the following are typically included in an IT security policy except which one?",
    "choice_a": "A business justification section that describes how the policy came about and why it\u2019s important to secure the assets",
    "choice_b": "The minimum standards required to secure the organization\u2019s assets",
    "choice_c": "A purpose section that states what the policy is protecting and why",
    "choice_d": "A scope section that defines the people impacted by the policy and a description of the systems the policy applies to",
    "correct_answer": "A",
    "explanation": "The policy does not contain information on how or why it came about.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      190,
      191,
      192,
      194,
      195
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "A description of the rules and procedures needed to access systems and information"
  },
  {
    "id": 161,
    "question": "All of the following are true about the business case, preliminary scope statement, and project charter except for which one?",
    "choice_a": "The project charter names the project manager.",
    "choice_b": "The project charter includes key deliverables, preapproved budget, overall risks, and project success criteria.",
    "choice_c": "The business case outlines assumptions and constraints.",
    "choice_d": "The preliminary scope statement describes the objectives and the reason for the project.",
    "correct_answer": "C",
    "explanation": "The project charter outlines assumptions and constraints.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      68,
      66,
      92,
      14,
      8
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 162,
    "question": "What component of a project\u2019s documentation do team members typically want to review before starting a new project?",
    "choice_a": "Project closeout report",
    "choice_b": "Post-mortem analysis",
    "choice_c": "Lessons learned",
    "choice_d": "Customer satisfaction survey",
    "correct_answer": "C",
    "explanation": "Lessons learned are helpful when starting new projects that are similar in scope and complexity to the previous project. Lessons learned document what went well and what didn\u2019t work so well so that you can perform the next project more efficiently.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      293,
      286,
      275,
      88,
      95
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 163,
    "question": "You are looking for a contractor to help you with some engineering functions needed for your project. You are not ready to purchase but are curious as to what type of vendors there are and what they might charge for these types of services. Which contract document would you use in this case?",
    "choice_a": "RFP",
    "choice_b": "RFI",
    "choice_c": "RFB",
    "choice_d": "RFF",
    "correct_answer": "B",
    "explanation": "A request for information (RFI) is the best document to use in this case. You aren\u2019t ready for a proposal from the vendor (RFP), and request for bid (RFB) is used when the materials are readily available on the market and you\u2019re looking for the best price option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      185,
      24,
      51,
      86
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 164,
    "question": "You are moving most of your datacenter to the cloud. Much of the equipment in the datacenter will be disposed of once the cloud goes live. Which of the following are true regarding this question? (Choose all that apply.)",
    "choice_a": "You have already performed successor planning.",
    "choice_b": "Your procedures should include degaussing or other techniques to be performed before decommissioning the hardware.",
    "choice_c": "The resource life cycle phases include acquisition, maintenance, hardware decommissioning, and successor planning.",
    "choice_d": "You are in the hardware decommissioning phase of the resource life cycle.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Option C missed the end-of-life software phase in the resource life cycle. Option E is not correct\u2014you should always meet with the stakeholders to determine what to do with the data and get their sign-off.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      272,
      72,
      53,
      62
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "You and your team have worked for years with this hardware and the systems and data that reside on it. You already know what to do with the data."
  },
  {
    "id": 165,
    "question": "Which of the following is true regarding resources on a Scrum team?",
    "choice_a": "Resources are assigned by the Scrum master at the beginning of the iteration.",
    "choice_b": "Resources on an agile project are a self-organized team.",
    "choice_c": "Resources are assigned by the project manager.",
    "choice_d": "Resources will remain the same throughout all iterations.",
    "correct_answer": "B",
    "explanation": "The resources on a Scrum team are self-organized and self-directed. It\u2019s important that they have strong communication, collaboration, and problem-solving skills.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      108,
      24,
      26
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 166,
    "question": "All of the following describe the model of communication exchange except for which one?",
    "choice_a": "Sender-message-receiver.",
    "choice_b": "Senders are responsible for encoding the message and presenting it in such a way that the receiver can correctly understand it.",
    "choice_c": "Receivers decode the message and make certain the message is clear and concise.",
    "choice_d": "The message can take many forms, including written, verbal, formal, and informal.",
    "correct_answer": "C",
    "explanation": "Receivers decode the message and make certain they understand and have received all the information. Senders are responsible for making certain the message is clear and concise.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      227,
      229,
      233,
      234,
      228
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 167,
    "question": "Ella is the voice of the customer, Justin is a programmer, David works with Ella to determine backlog items for the next iteration and works with the team to resolve issues and remove roadblocks, and Ava is a tester. There are 12 other team members on this team. Which of the following options describes this question? (Choose three.)",
    "choice_a": "Justin is an extended/functional team member.",
    "choice_b": "Ella is the product owner.",
    "choice_c": "This team is too large.",
    "choice_d": "Ella is the Scrum master.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "This question describes an agile team. Justin is a core team member, Ella is the product owner, and David is the Scrum master. This team is too large. Agile teams are small and range in size from 5 to 11 members.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      119,
      120,
      168,
      108,
      117
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "This question describes a Scrum, or agile, team.",
    "choice_f": "David is the product owner."
  },
  {
    "id": 168,
    "question": "You are attending a meeting that includes the agile team members, product owner, and stakeholders to demonstrate the functionality developed to date. After this, you will attend a meeting with agile team members and the product owner to review the overall progress to date, discuss lessons learned, and more. What two meetings does this question describe?",
    "choice_a": "The iteration review and then the retrospective",
    "choice_b": "The daily standup and then the retrospective",
    "choice_c": "The daily standup and then the iteration review",
    "choice_d": "The iteration review and then the backlog refinement",
    "correct_answer": "A",
    "explanation": "This question describes the iteration review and the retrospective. The iteration review is held with stakeholders, management team, team members, the product owner, and more. The retrospective is attended only by the product owner, Scrum master, and agile team members.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      108,
      120,
      253,
      254
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 169,
    "question": "Which of the following describes the sharing of software, information, data, and services with technology devices on demand?",
    "choice_a": "Infrastructure",
    "choice_b": "Multitiered architecture",
    "choice_c": "Cloud computing",
    "choice_d": "Networking and connectivity",
    "correct_answer": "C",
    "explanation": "Cloud computing provides data, information, software, and services on demand.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      49,
      36,
      38
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 170,
    "question": "You are conducting a lessons-learned session with your team after the conclusion of your project. From the following options, select the most effective technique to get the information you need.",
    "choice_a": "Get the team together informally. Conduct a whiteboard session in which people write down the positive and negative elements of the project.",
    "choice_b": "Send an email to all project team members asking them for the input. Produce a report from their observations.",
    "choice_c": "Conduct a formal session with the team and ask team members to identify the successes and failures for each phase. Ask for recommendations regarding what to do for the weak areas they\u2019ve denoted.",
    "choice_d": "A meeting isn\u2019t really needed to formulate a good-quality lessons-learned document. You can meet individually with each team member and gather their input.",
    "correct_answer": "C",
    "explanation": "You\u2019re trying to figure out what went well and what did not on the project, so it\u2019s important to meet formally with the team and keep them focused during the lessons learned session. It\u2019s not practical to simply solicit email input without putting together a formal meeting, and a report that you write alone may not hit all of the high points. It\u2019s best to meet with all the team members together, if possible, because one comment may lead to another, which will provide valuable feedback for future projects.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      230,
      271,
      173,
      168,
      25
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 171,
    "question": "You have received a contingent offer of employment as a project manager for a government contractor. The HR recruiter has told you that this position is exposed to classified governmental information and you\u2019ll need to undergo a process to verify your identity and level of trustworthiness. Which option is true regarding this question?",
    "choice_a": "This position requires a background check, which is defined in the operational security policy.",
    "choice_b": "The process for this identity security check is outlined in the digital security policy.",
    "choice_c": "This position requires a security clearance, which is defined in the operational security policy.",
    "choice_d": "The process for this identity security check is outlined in the physical security policy.",
    "correct_answer": "C",
    "explanation": "This question describes the need for a security clearance, which is outlined in the operational security policy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      190,
      191,
      192,
      194
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 172,
    "question": "Your project is to be performed outdoors. You are only four days from the big event, and there is a hurricane headed for shore. This is an example of which of the following?",
    "choice_a": "Risk",
    "choice_b": "Assumption",
    "choice_c": "Deliverable",
    "choice_d": "Constraint",
    "correct_answer": "A",
    "explanation": "Risks are potential future events that pose either opportunities or threats to the project. This is a potential event that would have negative consequences to the project if it were to occur.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      219,
      222,
      315,
      218
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 173,
    "question": "The business case presented for your project outlines the initial cost of the project at $120,000. Today\u2019s current value of the project is $150,000. The cost of investment is 6 percent. What is ROI?",
    "choice_a": "2.7%",
    "choice_b": "<3%>",
    "choice_c": "3%",
    "choice_d": "<2.7%>",
    "correct_answer": "C",
    "explanation": "ROI is calculated this way:<br>ROI = (Current Value or Gain from the Investment \u2013 Cost of Investment) / (Cost of the Investment)<br>ROI for this question is: (150,000 \u2013 120,000) / (100,000) = .03 <br>.03  100 = 3%.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      19,
      102,
      70,
      67
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 174,
    "question": "Your project is in the Executing phase and the stakeholders are requesting a change. All of the following should be included in the change request except for which one?",
    "choice_a": "Justification for the change",
    "choice_b": "Alternative approaches for the change",
    "choice_c": "Unique identifier for tracking purposes",
    "choice_d": "Impacts of the change",
    "correct_answer": "C",
    "explanation": "The unique identifier is assigned once the change is recorded on the change request log.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      279,
      282,
      286,
      274
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 175,
    "question": "Which of the following statements is not correct?",
    "choice_a": "Project life cycles are all of the phases of a project from beginning to end.",
    "choice_b": "Project life cycles provide the basic framework for managing a project.",
    "choice_c": "Development life cycles include the phases of the project associated with producing the product.",
    "choice_d": "Development life cycles are independent of project life cycles.",
    "correct_answer": "D",
    "explanation": "Development life cycles are performed within a project life cycle and are not independent.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      101,
      105,
      107,
      123,
      6
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 176,
    "question": "You are a project manager for Uncle Sam\u2019s Flag Company. Your company has designed a new line of products featuring the American flag. Because of some unique circumstances, the products are in hot demand. The project sponsor has asked you to do whatever it takes to get this project completed early and make the products available. You decide to use an agile approach to complete this project. Your team\u2019s velocity, based on past experience, is 7 story points per sprint. Your project has a total of 98 story points. Your sprints are two weeks in duration. Which of the following is true?",
    "choice_a": "Your project duration is 28 weeks.",
    "choice_b": "You are using the extreme programming methodology.",
    "choice_c": "Your project duration is 14 weeks.",
    "choice_d": "You are using a Kanban methodology.",
    "correct_answer": "A",
    "explanation": "There are 98 story points, and the team can complete 7 story points per sprint. 98 \u00f7 7 = 14. It will take 14 sprints to complete the story points. The sprints are two weeks in duration. 14 \u00d7 2 = 28 weeks total. Velocity is used in Scrum.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      155,
      157,
      108,
      153,
      89
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 177,
    "question": "You are working on a change to an information technology system and know that the change may have significant impacts if something goes wrong. Which of the following should you do to protect end users if the changes don\u2019t work?",
    "choice_a": "Perform an impact assessment to determine if the change should be implemented.",
    "choice_b": "Determine who the decision maker for this change should be.",
    "choice_c": "Document the change and its impact in the change control log.",
    "choice_d": "Create a rollback plan to restore the system to the last known good state if the changes don\u2019t go as planned.",
    "correct_answer": "D",
    "explanation": "All of the options should be performed regarding the change, but only the rollback plan will protect the end users if the change doesn\u2019t go as planned.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      281,
      279,
      282,
      285,
      50
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 178,
    "question": "You are implementing a new ERP system that involves human resources and payroll. This requires several unique skill sets. You are contracting out some of these skill sets and using staff members internal to the organization for others. You will assign the following people to the project: Ella, an SME in human resources and payroll; Justin, a programmer who supports the time-keeping system that will interface with the new payroll module; David, project manager for this project from the vendor organization; and Ava, the lead programmer who configures, modifies, and supports the existing ERP system. Which of the following is not true about these resources?",
    "choice_a": "Justin is an extended/functional team member.",
    "choice_b": "Ella is a core team member.",
    "choice_c": "Ava is an extended/functional team member.",
    "choice_d": "David is a core team member.",
    "correct_answer": "C",
    "explanation": "Ava is a core team member. She has deep understanding and knowledge of the existing system and will need to provide that expertise throughout the entire project. Justin will provide his expertise for the payroll module only and is not needed throughout the project. David and Ella are both required throughout the entire project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      168,
      55,
      162,
      161,
      58
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 179,
    "question": "Daily standups are used to review the work of the sprint and for what other purpose? (Choose two.)",
    "choice_a": "To discuss any changes that are needed to schedule or scope",
    "choice_b": "To make adjustments to the sprint that are necessary to ensure the work can be completed",
    "choice_c": "To keep the team informed and alert them to any obstacles standing in the way of completing tasks",
    "choice_d": "To give the team a chance to show off their work to the stakeholders",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Option A describes the retrospective meeting. Option D describes the iteration review meeting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      253,
      120,
      109
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 180,
    "question": "Your project involves implementing a new human resources system. This system will contain all records pertaining to hiring, performance appraisals, salaries, and more. It will also have time tracking functions, and all employees will use this system to document time worked and to request time-off. All of the following are true regarding access to this system except which one?",
    "choice_a": "Access controls should be assigned by role.",
    "choice_b": "The principle of least privilege should be used for all employees.",
    "choice_c": "Access controls are determined by the system administrator.",
    "choice_d": "Access controls should be audited and reviewed on a periodic basis.",
    "correct_answer": "C",
    "explanation": "Access controls are usually assigned to roles and approved by the senior managers who own the system. This process is defined in the access control policy.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      194,
      195,
      190,
      42,
      45
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 181,
    "question": "You are working on an agile project and wish to show the team members the progress of the remaining work of the sprint on a timeline. At the end of each day, the team members update their estimates, which keeps the chart up to date. What does this describe?",
    "choice_a": "Resource leveling chart",
    "choice_b": "Burnup chart",
    "choice_c": "Velocity chart",
    "choice_d": "Burndown chart",
    "correct_answer": "D",
    "explanation": "The function of a burndown chart is to show the remaining work of the iteration (or a small project). It is a moment-in-time type of measure. A burnup chart shows the work that has already been completed. There is no such thing as a resource leveling chart or a velocity chart.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      154,
      267,
      212,
      322,
      146
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 182,
    "question": "The executives in your organization often travel up to 75 percent of their workdays. Recently, one of your executives\u2019 accounts was hacked. As a result, your IT department decides to implement a process to enforce a verification of identify and help mitigate this problem in the future. Which option describes the name of this process?",
    "choice_a": "ETC",
    "choice_b": "CPM",
    "choice_c": "MVP",
    "choice_d": "MFA",
    "correct_answer": "D",
    "explanation": "Multifactor authentication (MFA) is a process whereby the user must provide two or more methods to verify their identity during the sign-in process. ETC stands for estimate to complete, CPM is the critical path method, and MVP is a minimally viable product.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      190,
      191,
      192,
      195
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 183,
    "question": "This is the ideal type of resource any project manager would want on their project. They work full-time on the project and report to the project manager.",
    "choice_a": "Shared resources",
    "choice_b": "Remote resources",
    "choice_c": "Dedicated resources",
    "choice_d": "Internal resource",
    "correct_answer": "C",
    "explanation": "Dedicated resources are those who work full-time on the project and report to the project manager.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      163,
      161,
      55,
      26,
      160
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 184,
    "question": "Which of these activities occur during the planning phase? (Choose three.)",
    "choice_a": "Creating the preliminary scope statement",
    "choice_b": "Creating the project budget for approval",
    "choice_c": "Writing the business case",
    "choice_d": "Creating the project schedule",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "Some of the activities in the planning process are identifying resources and creating the project schedule, work breakdown structure, detailed risks, requirements, communication plan, procurement plan, change management plan, and budget. The preliminary scope statement and business case are created in the discovery life cycle phase.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      9,
      85,
      128,
      84,
      134
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Documenting change control processes",
    "choice_f": "Identifying resource needs"
  },
  {
    "id": 185,
    "question": "You are using a Scrum methodology to manage your project. This team member is responsible for determining the project scope, determining what user stories will be worked during the sprint, and requesting the funding needed to complete the work of the project. Which role does this describe?",
    "choice_a": "The Scrum master",
    "choice_b": "The product owner",
    "choice_c": "The project manager",
    "choice_d": "The product manager",
    "correct_answer": "B",
    "explanation": "The Scrum master works with the product owner to manage the backlog and prioritize work, but the product owner is responsible for determining project scope and schedule and for requesting the funding needed to complete the work of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      108,
      51,
      53
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 186,
    "question": "This is an action taken as a result of quality activities to correct a defect.",
    "choice_a": "Process adjustments",
    "choice_b": "Rework",
    "choice_c": "Acceptance",
    "choice_d": "Prevention",
    "correct_answer": "B",
    "explanation": "Rework is an action that is taken as a result of quality activities to correct a defect. Process adjustments are made when there are quality problems because of a bad process, acceptance accepts the quality results, and prevention keeps errors from getting into the hands of the customers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      306,
      309,
      90,
      56
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 187,
    "question": "Which of the following is not true for critical path tasks?",
    "choice_a": "The early start date is less than the late start date.",
    "choice_b": "These activities are on the longest full path on the project schedule.",
    "choice_c": "The float time for tasks is zero.",
    "choice_d": "The late finish date is the same as the early finish date.",
    "correct_answer": "A",
    "explanation": "Float is always zero for the critical path activities, so early start and late start are the same date.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      144,
      147,
      210,
      274,
      216
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 188,
    "question": "All of the following are types of organizational change except for which one?",
    "choice_a": "Product change",
    "choice_b": "Business process change",
    "choice_c": "Internal reorganization",
    "choice_d": "Relocation",
    "correct_answer": "A",
    "explanation": "Product change is not a type of organizational change. The other organizational change types not listed in the options are a merger/acquisition, demerger/split, and outsourcing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      289,
      288,
      292,
      291,
      293
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 189,
    "question": "You have been assigned as the project manager for your new ERP implementation. You have overseen the development of the scope statement and are working on other parts of the project management plan. You report to the agile PMO director and have recommended using an agile approach for the work of the project. Your executive stakeholder is uneasy about using an agile approach. What actions should you take? (Choose two.)",
    "choice_a": "You could consider using a hybrid approach to introduce some aspects of waterfall and some aspects of the agile methodology to the project.",
    "choice_b": "You should consider using a waterfall methodology for this project since the stakeholder is uneasy and then insist that the agile approach should be used for the next project.",
    "choice_c": "You should implement agile and let your stakeholder witness the success of this methodology as the project progresses.",
    "choice_d": "You should provide training and mentoring by encouraging the stakeholder to attend agile events and inform them of the benefits of agile in terms of lean thinking principles.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The PMO and the project manager are responsible for ensuring that the stakeholders, especially key stakeholders, commit to the project and commit to the methodology. You could use hybrid to slowly introduce some key aspects of agile, and/or you could mentor the stakeholder to increase their understanding of the agile processes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      123,
      51,
      232,
      57,
      112
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 190,
    "question": "Which of the persons listed has the authority to cancel a project?",
    "choice_a": "Project manager",
    "choice_b": "Executive-level stakeholder",
    "choice_c": "Project sponsor",
    "choice_d": "Executive director or manager in the organization",
    "correct_answer": "C",
    "explanation": "In most organizations, the project sponsor is the one who has the authority to cancel a project. The project manager will likely be the one who recommends project cancellation, and it\u2019s always a good idea to have stakeholder consensus regarding this decision as well.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      51,
      263,
      24,
      57
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 191,
    "question": "You are a project manager for Fountain of Youth Spring Water bottlers. Your project involves installing a new accounting system. You have identified several problems, along with the causes of those problems. Which of the following diagrams will you use to show each problem and its causes and effects?",
    "choice_a": "Pareto chart",
    "choice_b": "Histogram",
    "choice_c": "Scatter diagram",
    "choice_d": "Fishbone diagram",
    "correct_answer": "D",
    "explanation": "A fishbone diagram shows the cause and effects of issues that are plaguing the project.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      311,
      310,
      316,
      319,
      283
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 192,
    "question": "You work for a consulting company called WhizBang systems that specializes in placing technically skilled staff with organizations that are implementing EDRMS systems. You have specialized knowledge and experience with the system and are just finishing up a project with another client and are ready to be placed on a new project. WhizBang just received a notification from Tell It Like It Is Corporation that they\u2019d like to begin negotiations on their implementation contract. Tell It Like It Is Corporation did not put this contract out for bid. You are employed full-time with WhizBang. Tell It Like It Is will issue a contract that\u2019s structured to pay WhizBang upon completion of each major deliverable, including labor and materials. Which of the following options describes elements of this question? (Choose three.)",
    "choice_a": "Tell It Like It Is Corporation is a functional organization.",
    "choice_b": "They are using a cost reimbursable contract.",
    "choice_c": "WhizBang is a projectized organization.",
    "choice_d": "Tell It Like It Is has certified WhizBang as a prequalified vendor.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "There is not enough information in the question to determine if Option A is correct. The question describes a unit price contract whereby WhizBang is paid upon completion of major deliverables. There was no bidding process for this contract, which means WhizBang is a prequalified vendor. You are not a benched resource because the question states you are still finishing up work with the existing client.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      278,
      277,
      204,
      28,
      86
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "They are using a unit price contract.",
    "choice_f": "You are a benched resource at WhizBang."
  },
  {
    "id": 193,
    "question": "Stakeholder communication requirements, distribution of information, time frame and frequency of information, and methods used to convey the information are elements of which of the following?",
    "choice_a": "Communications plan",
    "choice_b": "Project management plan",
    "choice_c": "Communication requirements analysis",
    "choice_d": "Stakeholder engagement plan",
    "correct_answer": "A",
    "explanation": "The communications plan describes stakeholder communication requirements, among other factors. It is a component plan of the project management plan, so option B is partially correct but not the most correct response.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      274,
      269,
      265,
      246
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 194,
    "question": "Which of the following helps determine the reasons for problems, risks, and issues by going beyond the obvious symptoms?",
    "choice_a": "Root cause analysis",
    "choice_b": "Decision tree analysis",
    "choice_c": "Monte Carlo analysis",
    "choice_d": "Variance analysis",
    "correct_answer": "A",
    "explanation": "Root cause analysis examines the deeper reasons for the problems or issues and goes beyond looking at the symptoms. Decision trees are used to show the sequence of interrelated decisions. Monte Carlo analysis is a simulation technique to examine various scenarios, and variance analysis looks at differences in the process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      317,
      24,
      216,
      281,
      315
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 195,
    "question": "The work effort multiplied by which of the following will bring about the total estimate for each task?",
    "choice_a": "Duration",
    "choice_b": "Rate",
    "choice_c": "Number of resources",
    "choice_d": "Number of hours",
    "correct_answer": "B",
    "explanation": "The rate that is established for a given resource times the work effort (usually expressed in hours) will yield the total estimate for the task.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      199,
      200,
      140,
      141,
      162
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 196,
    "question": "When preparing a project charter, which of the elements listed should you always include?",
    "choice_a": "Project justification",
    "choice_b": "Name of the project manager",
    "choice_c": "High-level milestones",
    "choice_d": "High-level risks",
    "correct_answer": "G",
    "explanation": "The project charter should include all the options listed. In addition, the project charter also includes the name of the project sponsor, project goals and objectives, key deliverables, a high-level list of requirements, high-level assumptions, high-level constraints, and criteria for project approval.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      67,
      68,
      69,
      8
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "High-level budget",
    "choice_f": "Project description",
    "choice_g": "All of the above"
  },
  {
    "id": 197,
    "question": "The initiating phase includes which important task?",
    "choice_a": "Assigning work to team members",
    "choice_b": "Creating the work breakdown structure",
    "choice_c": "Coordinating the resources necessary to complete the project work",
    "choice_d": "Approving the project and authorizing work to begin",
    "correct_answer": "D",
    "explanation": "The initiating phase involves both the formal acceptance of the project and the authorization for the project manager to start the work. The other options are important tasks undertaken during the planning phases.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      66,
      71,
      81,
      7
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 198,
    "question": "You are working on a change request and know that the change request is like a mini-business case that describes the changes, the reasons for the changes, and the goals the change will achieve. Goals are best defined using which of the following acronyms?",
    "choice_a": "MSART",
    "choice_b": "SMRT",
    "choice_c": "SMART",
    "choice_d": "ASMT",
    "correct_answer": "C",
    "explanation": "SMART stands for specific, measurable, achievable, realistic, and time bound.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      290,
      280,
      95,
      281,
      86
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 199,
    "question": "Organizational structure can affect how readily an organization will adapt to an agile methodology approach. Which of the following is not a factor in choosing a methodology according to CompTIA?",
    "choice_a": "Environment",
    "choice_b": "Risk",
    "choice_c": "Budget",
    "choice_d": "Industry standards",
    "correct_answer": "B",
    "explanation": "The other factors not listed here are tolerance for change/flexibility, requirements, schedules, and culture.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      112,
      133,
      244,
      159,
      161
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Developmental standards"
  },
  {
    "id": 200,
    "question": "What are the most commonly used forms to display project schedules? (Choose two.)",
    "choice_a": "PERT charts",
    "choice_b": "Gantt charts",
    "choice_c": "CPM diagrams",
    "choice_d": "A spreadsheet",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "PERT charts and Gantt charts, a type of bar chart, are the most common ways to display a project schedule.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      133,
      127,
      86,
      6
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Milestone chart"
  },
  {
    "id": 201,
    "question": "You are working on a large-scale ERP project and the team is experienced in agile methodologies. They\u2019d like to try an agile framework approach and combine the best of the agile methodologies they\u2019ve used in the past. They will also need to incorporate information from finance, human resources, and payroll into the methodology. Which methodology does this describe?",
    "choice_a": "Scrum of Scrums",
    "choice_b": "Disciplined Agile",
    "choice_c": "PRINCE2",
    "choice_d": "Lean",
    "correct_answer": "B",
    "explanation": "This question describes the Disciplined Agile methodology. This allows the team to tailor the methodology to meet their needs and may also incorporate information about business functions in the methodology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      301,
      300,
      113,
      112,
      120
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 202,
    "question": "Which of the following helps to build an efficient and effective team, improves morale, and builds social bonds?",
    "choice_a": "Team building",
    "choice_b": "Trust building",
    "choice_c": "Having dedicated resources on the project team",
    "choice_d": "Using appropriate conflict-resolution techniques at the right time",
    "correct_answer": "A",
    "explanation": "Team-building activities help to build effective and efficient teams, improve morale, and build social bonds. Trust building will help form high-performing work teams but doesn\u2019t directly lead to building social bonds or effective and efficient teams.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      245,
      175,
      23,
      335
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 203,
    "question": "This project management methodology works well for projects that are not well defined and may experience several changes during the course of the project. It also allows you to subdivide tasks into the minimum viable product by the end of the iteration.",
    "choice_a": "Predictive",
    "choice_b": "Hybrid",
    "choice_c": "Agile",
    "choice_d": "Waterfall",
    "correct_answer": "C",
    "explanation": "The agile approach to project management allows you to deliver outcomes incrementally, subdivide tasks into the minimum viable product, and make changes as needed during the project.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      158,
      108,
      117,
      153,
      123
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 204,
    "question": "Your project team members and stakeholders work in different locations throughout Europe. You have never been to Europe, and you will be traveling there to work with team members for a few weeks at a time on occasion. Which option best describes the action you should take?",
    "choice_a": "You will document the culture differences as a risk in the communications plan.",
    "choice_b": "You know that culture differences are a factor in communication, so you will research the cultures of the countries you will be working in before leaving.",
    "choice_c": "You know that technology barriers may exist, so you will research the technology capabilities of the countries you will be working in before leaving.",
    "choice_d": "You know that interorganizational differences are a factor in communication, so you will research the communication procedures for each location you will be working in before leaving.",
    "correct_answer": "B",
    "explanation": "Options B, C, and D all describe factors that influence communication. Option B is the action you should take so that you can gain some understanding of the culture of each of the countries you\u2019ll be working in.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      51,
      229,
      173,
      27
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 205,
    "question": "This document describes the project deliverables, a code of accounts identifier, estimates, resources, and criteria for acceptance.",
    "choice_a": "Project scope statement",
    "choice_b": "WBS dictionary",
    "choice_c": "Scope management plan",
    "choice_d": "Project concept document",
    "correct_answer": "B",
    "explanation": "The WBS dictionary describes the project deliverables, a code of accounts identifier, estimates, resources, criteria for acceptance, and other information that helps clarify the deliverables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      122,
      327,
      12,
      64
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 206,
    "question": "Your agile project team is conducting a meeting that is focused on developing the requirements for the application the team is creating. It\u2019s important all team members understand the business problem they are trying to solve, and to have a thorough understanding of requirements. What type of meeting is this? (Choose two.)",
    "choice_a": "JAD session",
    "choice_b": "Collaborative",
    "choice_c": "Brainstorming",
    "choice_d": "Informational",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "This question describes a joint application development (JAD) session, which is a type of collaborative meeting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      97,
      120,
      55,
      255
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Focus group",
    "choice_f": "Decisive"
  },
  {
    "id": 207,
    "question": "The project manager is responsible for many aspects of project management. Which of the following describes the role of a project manager? (Choose three.)",
    "choice_a": "Estimating task durations",
    "choice_b": "Manage project team members",
    "choice_c": "Manage budget",
    "choice_d": "Responsible for artifacts",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The project manager is responsible for managing the team, communication, scope, risk, budget, time, and quality assurance. The person is also responsible for maintaining the project artifacts. The project team members are responsible for providing input to the requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      56,
      23,
      232,
      55
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Provide input on requirements"
  },
  {
    "id": 208,
    "question": "Which of the following is not a key component of scope planning?",
    "choice_a": "Work breakdown structure (WBS)",
    "choice_b": "Scope statement",
    "choice_c": "Project charter",
    "choice_d": "Scope management plan",
    "correct_answer": "C",
    "explanation": "The key components of scope planning are the scope management plan, scope statement, and work breakdown structure. The project charter is created during project initiation.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      84,
      12,
      128,
      9,
      81
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 209,
    "question": "Your project is progressing nicely. The planned value for the project is $75,000. The earned value is $61,000 to date. Actual expenses to date are $58,000. What is CV?",
    "choice_a": "3,000",
    "choice_b": "\u201314,000",
    "choice_c": "14,000",
    "choice_d": "\u20133,000",
    "correct_answer": "A",
    "explanation": "The formula for cost variance is CV = EV \u2013 AC. Let\u2019s plug in the numbers: 61,000 \u2013 58,000 = 3,000.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      209,
      210,
      211,
      214,
      274
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 210,
    "question": "The documents, templates, agendas, diagrams, and other work products used in managing the project are known as which of the following?",
    "choice_a": "Project documents",
    "choice_b": "PMO documents",
    "choice_c": "Artifacts",
    "choice_d": "Work products",
    "correct_answer": "C",
    "explanation": "Artifacts are the documents, templates, agendas, diagrams, and other work products used in managing the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      84,
      132,
      18,
      64
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 211,
    "question": "You\u2019re heading up a project to produce a show live on YouTube. You are using an adaptive methodology to manage the project. Which of the following are true regarding user stories you\u2019ll use for this project? (Choose three.)",
    "choice_a": "User stories are created by the project manager working in collaboration with the product owner.",
    "choice_b": "User stories are contained and prioritized in the product backlog. Once the sprint begins, user stories will be pulled from the product backlog to the sprint backlog.",
    "choice_c": "User stories are similar to requirements as they describe what needs to be accomplished and for whom.",
    "choice_d": "User stories are written from the perspective of the customer.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "User stories are written from the perspective of the customer, usually by the product owner, and are contained in the product backlog.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      117,
      153,
      119,
      158,
      157
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 212,
    "question": "Your project is coming to a close. You need to perform several actions to ensure the closing process is performed adequately. You will perform all of the following activities during the Closing phase except for which one?",
    "choice_a": "Celebrate",
    "choice_b": "Revoke access",
    "choice_c": "Budget reconciliation",
    "choice_d": "Collect feedback from stakeholders",
    "correct_answer": "E",
    "explanation": "Vendor performance should be evaluated before the Closing phase. If the vendor has not performed, or has not delivered according to the contract, you would not proceed to closing out the contract until these issues are resolved.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      331,
      11,
      10,
      273,
      327
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Evaluate vendor performance",
    "choice_f": "Validate deliverables"
  },
  {
    "id": 213,
    "question": "Starting two activities at the same time that were previously scheduled to start simultaneously is known as which of the following?",
    "choice_a": "Fast tracking",
    "choice_b": "Mandatory dependency",
    "choice_c": "Crashing",
    "choice_d": "Buffer",
    "correct_answer": "A",
    "explanation": "Fast tracking is a technique where you perform multiple tasks in parallel that were previously scheduled to start simultaneously.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      147,
      90,
      136,
      210,
      25
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 214,
    "question": "You will use a globally accepted project management methodology that manages projects in stages in a step-by-step fashion. At the end of each step, the board holds a stage boundary meeting to review the work of the stage before proceeding to the next stage. This methodology can be used for any size project in any industry. What is this methodology called?",
    "choice_a": "DSDM",
    "choice_b": "FDD",
    "choice_c": "AUP",
    "choice_d": "PRINCE2",
    "correct_answer": "D",
    "explanation": "This question describes PRINCE2, which has seven guiding principles and a defined set of stages the project follows.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      302,
      105,
      253,
      305,
      133
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 215,
    "question": "You purchase a bond to protect your organization in the case of a negative risk event. What risk strategy is this known as?",
    "choice_a": "Avoid",
    "choice_b": "Mitigate",
    "choice_c": "Transfer",
    "choice_d": "Accept",
    "correct_answer": "C",
    "explanation": "Transfer is a negative risk response strategy that moves the liability for risk to a third party.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      220,
      219,
      221
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 216,
    "question": "All projects face constraints. Some of the typical constraints on any project include which of the following? (Choose three.)",
    "choice_a": "Cost",
    "choice_b": "Scope creep",
    "choice_c": "Time",
    "choice_d": "Resources",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Constraints are anything that dictates or restricts the actions of the project team. Influencers are those things that can change, impact, or cause a new constraint. Options B, E, and F describe influencers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      91,
      279,
      177,
      6
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Change request",
    "choice_f": "Stakeholders or management"
  },
  {
    "id": 217,
    "question": "Your project is ending, and you will be transitioning the product of the project to the business department, who will be using the product in their day-to-day operations. Which of the following options are true regarding this question?",
    "choice_a": "You need to create a transition plan.",
    "choice_b": "The transition plan should include information about the ongoing maintenance and care of this product.",
    "choice_c": "You need to ensure operational training has occurred or has been provided for the new business unit.",
    "choice_d": "Include the warranty information with the transition plan.",
    "correct_answer": "E",
    "explanation": "All of the options are true. The transition plan should outline product information, operational training needs, special skills, maintenance requirements, warranty information, and anything else the new owner needs to know about the product.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      329,
      334,
      327,
      11,
      325
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "All of the above"
  },
  {
    "id": 218,
    "question": "One of the key project team members is assigned to two other projects. The project schedule shows this resource needed during the same time they\u2019re needed on one of the other projects. What does this describe?",
    "choice_a": "Resource allocation",
    "choice_b": "Interproject resource contention",
    "choice_c": "Resource shortage",
    "choice_d": "Resource conflict",
    "correct_answer": "B",
    "explanation": "This question defines interproject resource contention. A resource shortage would occur if there was only one resource available or if resources were scarce. Since this question describes more than one project, it involves an interproject resource contention.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      164,
      163,
      148,
      159,
      177
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 219,
    "question": "This document ensures that each requirement is linked to a business objective and a project objective.",
    "choice_a": "Project charter",
    "choice_b": "Project scope statement",
    "choice_c": "Traceability matrix",
    "choice_d": "Requirements documentation",
    "correct_answer": "C",
    "explanation": "The traceability matrix ensures that business value is realized and associates each requirement with a business objective and project objective.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      130,
      171,
      283,
      316,
      170
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 220,
    "question": "You\u2019ll need to use several collaboration tools on your communication platform to create, edit, and share information with the project team, including the stakeholders. All of the following are types of collaboration tools except for which one?",
    "choice_a": "Whiteboards",
    "choice_b": "Wiki knowledge base",
    "choice_c": "Version control tools",
    "choice_d": "File sharing platforms",
    "correct_answer": "C",
    "explanation": "Versions control tools are a type of meeting tool and not a collaboration tool, as outlined in the CompTIA exam objectives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      258,
      268,
      235,
      152
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Multi-authoring and editing software"
  },
  {
    "id": 221,
    "question": "Which of the following are conflict-resolution techniques? (Choose three.)",
    "choice_a": "Adjourning",
    "choice_b": "Collaborating",
    "choice_c": "Norming",
    "choice_d": "Avoiding",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "The conflict-resolutions techniques are smoothing, forcing, compromising, and avoiding. Adjourning, norming, and storming are stages of team development.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Compromising",
    "choice_f": "Storming"
  },
  {
    "id": 222,
    "question": "One of the risks identified on your risk list has come about. The risk owner informed you the risk event is in motion. All of the following are true regarding this scenario except which one?",
    "choice_a": "Risks are potential future events and become issues once they occur.",
    "choice_b": "Contingency reserves and work-arounds are possible solutions to help resolve this.",
    "choice_c": "Because the risk has occurred, it should now be managed using the issue management process.",
    "choice_d": "Issues are potential events that could adversely affect the project outcomes.",
    "correct_answer": "D",
    "explanation": "Risks are potential future events and issues are events that have occurred (or are in the process of happening). Issues are not potential, they are real. Risks become issues once they happen and should be managed using the issue management process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      315,
      317,
      216,
      222,
      215
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 223,
    "question": "You want to use the most efficient report possible for reporting project status to company executives. Which of the following report should you use?",
    "choice_a": "Project status report",
    "choice_b": "Dashboard",
    "choice_c": "Burnup chart",
    "choice_d": "Burndown chart",
    "correct_answer": "B",
    "explanation": "Executives prefer dashboards over other reports because they are concise, usually only one page, and easy to see at a glance.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      266,
      322,
      212,
      235,
      252
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 224,
    "question": "Your project budget for this period of work is $5,300 and you have spent $4,500 to date. The value of the work completed during this period of work is $5,500. What is the SV?",
    "choice_a": "\u2013200",
    "choice_b": ".96",
    "choice_c": "1.03",
    "choice_d": "200",
    "correct_answer": "D",
    "explanation": "The formula for SV is EV \u2013 PV. Earned value is $5,500, and planned value is $5,300. Therefore, the SV is 200.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      209,
      199,
      201,
      204
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 225,
    "question": "For what reasons should you create milestones in your project plans? (Choose two.",
    "choice_a": "To signal the end of a task",
    "choice_b": "To provide a budgetary checkpoint",
    "choice_c": "To indicate the completion of a deliverable",
    "choice_d": "To provide a comparison of actual versus estimated time",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Milestones are used as checkpoints to determine whether the project is on time and on budget, and they may also note the completion of a deliverable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      70,
      250,
      69,
      126
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "To perform a hand-off",
    "choice_f": "To measure quality assurance"
  },
  {
    "id": 226,
    "question": "Your team has settled into day-to-day interactions and is comfortable with their positions within the team. Decisions are made jointly, and the team members show mutual respect. Which stage of team development is this team in?",
    "choice_a": "Forming",
    "choice_b": "Performing",
    "choice_c": "Norming",
    "choice_d": "Smoothing",
    "correct_answer": "C",
    "explanation": "Norming is the stage in team development when the team members are comfortable with each other, show mutual respect, and make decisions jointly. Option D is a conflict resolution technique, not a stage of team formation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      173,
      245,
      174,
      120
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 227,
    "question": "You are working on a large software development project for your company. You want to implement an agile approach for this project. You determine to use a methodology whereby each working team focuses on a portion of the project, they hold their own standup meetings, and work from their own backlog. What is this methodology called?",
    "choice_a": "Scrum of Scrums",
    "choice_b": "Disciplined Agile",
    "choice_c": "SAFe",
    "choice_d": "PRINCE2",
    "correct_answer": "A",
    "explanation": "This question describes Scrum of Scrums. Multiple Scrum teams work on the project together, but each team focuses on only a portion of the project, they work from their own backlog, and they hold their own retrospective meetings.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      301,
      108,
      119,
      107,
      113
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 228,
    "question": "When using an agile methodology, you don\u2019t usually know all the requirements at the beginning of the project. Which of the following are true about scope and requirements in an agile methodology? (Choose three.)",
    "choice_a": "Agile projects have continually evolving requirements.",
    "choice_b": "Agile methodologies are focused on continually discovering requirements and fine-tuning requirements.",
    "choice_c": "The product backlog is similar to the scope statement because it contains the user stories that describe the requirements and what the project will accomplish.",
    "choice_d": "All user stories need to be documented at the beginning of the project so the team can determine which user stories to work on during which iteration.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "User stories can be documented at the beginning of the project but not all user stories are documented then. They will be developed and documented as the project progresses.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      117,
      153,
      158,
      133,
      108
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 229,
    "question": "Which of the following are true regarding Kanban? (Choose three.)",
    "choice_a": "Kanban uses story cards, refactoring, and automated testing.",
    "choice_b": "One Kanban principle is to start with the current state and work incrementally toward the future state.",
    "choice_c": "Kanban is based on lean-thinking principles and encourages all team members to act as leaders.",
    "choice_d": "Kanban uses a test-driven development approach.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "Options A and D describe extreme programming.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      120,
      153,
      301,
      127
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Kanban allows for visualization of the work in each of the stages the work is progressing through on a Kanban board."
  },
  {
    "id": 230,
    "question": "You\u2019re working on a project that you and your team have estimated takes 15 business days to complete. Your team does not work on Saturday, Sunday, or holidays. Given the work calendar shown here and a start date of Tuesday, November 1, what is the scheduled completion date for this task?<img src=\"/question_assets/Project+/pe1_01.png\"/>",
    "choice_a": "21",
    "choice_b": "15",
    "choice_c": "22",
    "choice_d": "23",
    "correct_answer": "C",
    "explanation": "The task will take 15 business days to complete (not counting weekends or holidays), so that makes the task completion date the 22nd. Day 1 counts as the first full day of work.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      141,
      137,
      144,
      140,
      136
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 231,
    "question": "A project manager has the most authority under which organizational structure?",
    "choice_a": "Projectized",
    "choice_b": "Functional",
    "choice_c": "Balanced matrix",
    "choice_d": "Strong matrix",
    "correct_answer": "A",
    "explanation": "A projectized organization is designed around project work, and project managers have the most authority in this type of structure. Project managers have the least amount of authority in a functional organization; they have some authority in a balanced matrix, and, a little more authority in a strong matrix, but not as much authority as they have in a project-based organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      160,
      159,
      53,
      282
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 232,
    "question": "Your team is using the tool in below figure to monitor project work on an agile project. What is this tool called?<img src=\"/question_assets/Project+/BE1f002.png\"/>",
    "choice_a": "Task board",
    "choice_b": "Burndown chart",
    "choice_c": "Scrum chart",
    "choice_d": "Burnup chart",
    "correct_answer": "D",
    "explanation": "Burnup charts start at zero and show the work completed for the iteration and the remaining work for the project.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      267,
      154,
      266,
      213,
      322
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 233,
    "question": "The marketing staff has started a project that was requested by another area of the company. Now they have discovered that the project scope is larger than they\u2019d originally anticipated and they require the assistance of a project manager. No formal project documents were created. You\u2019ve been asked to fill the role of project manager. What is the first step you\u2019ll take for this project?",
    "choice_a": "Write the project charter.",
    "choice_b": "Determine the high-level requirements.",
    "choice_c": "Determine the milestones.",
    "choice_d": "Write the preliminary scope statement.",
    "correct_answer": "D",
    "explanation": "The first thing to do is write the preliminary scope statement. This will help everyone understand the objectives and the reason for the project. From there, you will write the product scope description (also referred to as high-level deliverables).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      65,
      67,
      93,
      82
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 234,
    "question": "You\u2019re in the process of developing a project schedule for a new project. You\u2019ve just completed the WBS. What would be the project manager\u2019s next step in figuring out what tasks go into the project schedule?",
    "choice_a": "Develop a task list.",
    "choice_b": "Determine the critical path tasks.",
    "choice_c": "Develop a project schedule.",
    "choice_d": "Estimate activity duration.",
    "correct_answer": "A",
    "explanation": "After the WBS is developed, the next step involves creating an activity list that describes the activities required to complete each work package on the WBS.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      136,
      127,
      129,
      86,
      144
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 235,
    "question": "You are performing risk analysis on your project and are examining several elements, including how quickly a response needs to be implemented, how easily it will be to identify when a risk trigger has occurred, and how each individual risk may raise or lower the probability and impact of other risks occurring. All of the following are true regarding this question except for which one?",
    "choice_a": "Urgency refers to how quickly a response is needed.",
    "choice_b": "Interconnectivity refers to the connections between each individual risk on the project.",
    "choice_c": "Detectability refers to the ability to detect a risk trigger is occurring.",
    "choice_d": "These are all elements of situation/scenario risk analysis.",
    "correct_answer": "D",
    "explanation": "Situation/scenario risk analysis looks at internal and external factors that could impact the organization. It involves looking at situations such as new projects, new management, cybersecurity events, and more.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      226,
      220,
      222,
      216,
      221
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "These are all elements of qualitative risk analysis."
  },
  {
    "id": 236,
    "question": "All of the following describe a Scrum team except which one?",
    "choice_a": "Their work is managed and prioritized in the product backlog.",
    "choice_b": "They usually have between 3 and 12 team members.",
    "choice_c": "There is only one product owner.",
    "choice_d": "They are self-directed and self-organized.",
    "correct_answer": "B",
    "explanation": "An agile team has between 5 and 9 members, and 7 members is the ideal size.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      108,
      168,
      119,
      157
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 237,
    "question": "After the schedule is approved by the sponsor, customer, and key stakeholders, what happens next?",
    "choice_a": "The resources are assigned.",
    "choice_b": "The schedule baseline is established.",
    "choice_c": "The task start and end dates are finalized.",
    "choice_d": "The critical path is finalized.",
    "correct_answer": "B",
    "explanation": "Once the schedule is approved by the sponsor, customer, and stakeholders, the schedule baseline is set. The baseline is the approved project schedule and shows task start and end dates, and resource assignments.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      134,
      132,
      9,
      84
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 238,
    "question": "You have the following figures: PV = 85, AC = 83, and EV = 81. What is CPI?",
    "choice_a": ".98",
    "choice_b": "\u20133",
    "choice_c": ".95",
    "choice_d": "\u20132",
    "correct_answer": "A",
    "explanation": "The formula for CPI is EV / AC, so the formula looks like this: 81 / 83 = .98.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      274,
      6,
      15
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 239,
    "question": "All of the following describe characteristics of archived information except for which one?",
    "choice_a": "Archiving frees up storage space.",
    "choice_b": "Archiving allows documents to be restored to a previous state.",
    "choice_c": "Archiving helps reduce costs.",
    "choice_d": "Archiving allows previous project documents to be referenced for historical purposes.",
    "correct_answer": "B",
    "explanation": "Archived files are static and don\u2019t have a previous state. Backups restore files to their previous state.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      325,
      12,
      231,
      225
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 240,
    "question": "This framework provides synergies between teams and functions so that projects are delivered more quickly with more reliability and fidelity.",
    "choice_a": "DevSecOps",
    "choice_b": "PRINCE2",
    "choice_c": "SDLC",
    "choice_d": "Dynamic systems development methodology",
    "correct_answer": "A",
    "explanation": "DevSecOps is a framework that embeds the development team, security team, and operations team to improve collaboration and communication, and deliver projects faster with more reliability and fidelity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      119,
      108,
      245,
      172
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 241,
    "question": "You work for a nonprofit organization and are currently heading up a project to bring clean drinking water to several villages on a remote island in South America. This island has recently been at civil war, and there is concern that civil unrest may erupt during the implementation phase of this project. All of the following statements are true regarding this question except for which one?",
    "choice_a": "A management reserve can be used to help address this risk.",
    "choice_b": "This is a force majeure risk.",
    "choice_c": "This is an external risk.",
    "choice_d": "The team should create a risk response plan for this risk.",
    "correct_answer": "D",
    "explanation": "This is an example of a force majeure risk, which in this case is external to the project and is so catastrophic that risk responses are not applicable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      217,
      215,
      315,
      27,
      272
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 242,
    "question": "Which is the most commonly used logical relationship?",
    "choice_a": "Finish-to-start",
    "choice_b": "Start-to-finish",
    "choice_c": "Start-to-start",
    "choice_d": "Finish-to-finish",
    "correct_answer": "A",
    "explanation": "Finish-to-start is the most commonly used logical relationship in network and schedule diagrams.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      147,
      136,
      140,
      274,
      135
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 243,
    "question": "This is an on-demand scheduling methodology that is described as a pull-based system. The work is balanced against available resources. Which of the following options are true regarding this question? (Choose two.)",
    "choice_a": "There is only one product owner in this methodology.",
    "choice_b": "The work of the project is performed in iterations.",
    "choice_c": "This is known as Kanban.",
    "choice_d": "There is only one team working on the product of the project.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Kanban is a pull-based system (as is Scrum), and may have more than one product owner, and more than one project team working on the product. All teams work from the same Kanban board. The work is performed as there are resources available. There is no time limit like there is with iterations.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      109,
      108,
      113,
      300,
      133
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "The work of the project is balanced against available resources."
  },
  {
    "id": 244,
    "question": "All of the following are situational/scenario-based risks according to the CompTIA exam objectives except for which two?",
    "choice_a": "New projects",
    "choice_b": "Technical issues",
    "choice_c": "Change in management",
    "choice_d": "Infrastructure end-of-life",
    "correct_answer": [
      "B",
      "F"
    ],
    "explanation": "Options B and F are risks that could occur to the project but are not situational/scenario-based risks as listed in the CompTIA exam objectives. The other risks on this list are regulatory environment changes, merger and acquisitions, and reorganization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      226,
      289,
      218,
      215,
      220
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Cybersecurity events",
    "choice_f": "Scope changes",
    "choice_g": "Digital transformation"
  },
  {
    "id": 245,
    "question": "How long is the critical path in days in the graphic shown here if you eliminate Task B?<img src=\"/question_assets/Project+/BE1uf001.png\"/>",
    "choice_a": "13 days",
    "choice_b": "20 days",
    "choice_c": "27 days",
    "choice_d": "30 days",
    "correct_answer": "B",
    "explanation": "Eliminating Task B leaves you with the longest path through the network diagram, which is path A-C-E for a duration of 20 days.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      137,
      136,
      142,
      147
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 246,
    "question": "You have been hired as a contract project manager for Grapevine Vineyards. Grapevine wants you to design an Internet wine club for its customers. Customers must register before being allowed to order wine over the Internet so that legal age can be established. You know that the module to verify registration must be written and tested using data from Grapevine\u2019s existing database. This new module cannot be tested until the data from the existing system is loaded. This is an example of which of the following?",
    "choice_a": "Preferential logic",
    "choice_b": "Soft logic",
    "choice_c": "Discretionary dependency",
    "choice_d": "Hard logic",
    "correct_answer": "D",
    "explanation": "This is an example of a mandatory dependency, also known as hard logic. Mandatory dependencies are inherent in the nature of the work. Discretionary dependencies, also called preferred logic, preferential logic, and soft logic, are defined by the project management team.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      127,
      88,
      275,
      6
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 247,
    "question": "All of the following are either risk identification or risk analysis techniques except for which one?",
    "choice_a": "Situational/scenario analysis",
    "choice_b": "Qualitative analysis",
    "choice_c": "SWOT analysis",
    "choice_d": "Brainstorming",
    "correct_answer": "G",
    "explanation": "Risk triggers are a sign or precursor that a risk is about to occur. Risk triggers are identified during the risk analysis or risk response planning process for the identified risks.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      222,
      216,
      217,
      219,
      220
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Quantitative analysis",
    "choice_f": "Impact analysis",
    "choice_g": "Risk trigger analysis"
  },
  {
    "id": 248,
    "question": "What is the following chart an example of?<img src=\"/question_assets/Project+/pe1_02.png\"/>",
    "choice_a": "RACI chart",
    "choice_b": "RAC chart",
    "choice_c": "Responsibility matrix",
    "choice_d": "Assignment matrix",
    "correct_answer": "A",
    "explanation": "A RACI chart is a type of responsibility assignment matrix that details the tasks and resources and whether they are responsible, accountable, consulted, or informed about the task.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      8,
      12,
      59,
      76,
      236
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 249,
    "question": "This project management methodology divides projects up into small stages that are logically organized and managed step by step. Which of the following methodologies does this describe?",
    "choice_a": "Hybrid",
    "choice_b": "Waterfall",
    "choice_c": "SDLC",
    "choice_d": "PRINCE2",
    "correct_answer": "D",
    "explanation": "PRINCE2 is a project management methodology. All the other options are development methodologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      302,
      304,
      106,
      133
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 250,
    "question": "You are a project manager for Move It Now trucking company. Your company specializes in moving household goods across the city or across the country. Your project involves upgrading the nationwide computer network for the company and moving servers and software applications to the cloud. You have a very large project on your hands and know that creating a project schedule for this undertaking could be daunting. Which of the following are true regarding this question?",
    "choice_a": "You should use a project scheduling software tool to help you with this task.",
    "choice_b": "Project scheduling software will help you calculate task durations and recalculate start and end dates if the tasks need to move.",
    "choice_c": "You can collapse the schedule view to make the graphical representation easier for executives to review.",
    "choice_d": "The software will perform schedule revisions and re-baselining and keep your versions up to date.",
    "correct_answer": "E",
    "explanation": "All of the options are true regarding project scheduling software.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      274,
      127,
      88,
      301,
      106
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "All of the options are true."
  },
  {
    "id": 251,
    "question": "You have two resources that are both working more than 50 hours per week on your project. What is this called?",
    "choice_a": "Resource overallocation",
    "choice_b": "Interproject resource contention",
    "choice_c": "Low-quality resources",
    "choice_d": "Shared resource",
    "correct_answer": "A",
    "explanation": "This describes resource overallocation because the resources are scheduled to work and are working more hours than they have available.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      164,
      148,
      163,
      162,
      140
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 252,
    "question": "You are starting work on a software development project with a high amount of risk associated with the project. The customer is not certain of all the requirements at the beginning of the project. You decide to use the XP methodology for this project. Which of the following are not true regarding XP?",
    "choice_a": "XP uses refactoring to reduce duplication.",
    "choice_b": "XP uses a test-driven development technique.",
    "choice_c": "XP focuses on continuous integration.",
    "choice_d": "XP allows team members to work on their own.",
    "correct_answer": "D",
    "explanation": "XP teams work as teams using pair programming techniques. They do not work on their own. Option D describes a characteristic of the dynamic systems development method, which does allow team members to work on their own.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      115,
      107,
      108,
      168
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 253,
    "question": "You are the project manager for a new ERP implementation in your organization and have just been altered to a potential risk to the project. One of the project team members informed you that a key business area involved in this project is going to undergo a reorganization, which will be disruptive to the project and potentially cause changes to the project team makeup. All of the following are true regarding this question except which one?",
    "choice_a": "This risk should have been analyzed using quantitative risk analysis and had a risk response plan prepared.",
    "choice_b": "As the project manager, you are the point of escalation for risks like these and the risk owner should notify you once a risk trigger occurs or once the risk event itself occurs.",
    "choice_c": "This is a situational/scenario-based risk event.",
    "choice_d": "The next point of escalation after the project manager is the project sponsor.",
    "correct_answer": "A",
    "explanation": "This risk event does not need the rigor of quantitative risk analysis. The situational/scenario-based analysis should be sufficient, along with the preparation of the risk response plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      220,
      219,
      216,
      315,
      251
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 254,
    "question": "Your project is slow-paced and your stakeholders want more up-to-date information available to them in an easy-to-use format. They are monitoring the project to determine if it should be cancelled, or if further actions need to be taken to get it back on track. All of the following options could help with this situation except which one?",
    "choice_a": "Publish dashboards more frequently.",
    "choice_b": "Provide more frequent status reports.",
    "choice_c": "Produce a daily email with status.",
    "choice_d": "Invite the stakeholders to the daily stand-up meetings so they can hear up to date status for themselves.",
    "correct_answer": "D",
    "explanation": "Executives don\u2019t have time to attend daily stand-up meetings; stand-ups are for agile team members only, not stakeholders.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      265,
      272,
      232,
      62,
      51
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 255,
    "question": "You are using an agile approach to manage your project. You know that velocity for your team is 12 story points per time period. You use four-week increments of time to produce the work of the project. There are 144 total story points. Which of the following are true?",
    "choice_a": "This is a Scrum approach.",
    "choice_b": "It will take the team 48 weeks to complete the work.",
    "choice_c": "This is a Kanban approach.",
    "choice_d": "It will take the team 12 weeks to complete the work.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Kanban is a pull-based concept that balances work against available resources, it is capacity based. Scrum is time based and uses velocity to determine how quickly the team can complete the work. There are 144 total story points. If you can complete 12 story points per sprint, it will take 12 sprints to complete the work. The sprints are four-week periods of the time. Therefore, 12 sprints \u00d7 4 weeks = 48 weeks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      155,
      108,
      109,
      157,
      300
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 256,
    "question": "This software methodology establishes the cost of the project, the quality standards, and time frames at the beginning of the project. It is a constraint-driven process that uses eight guiding principles, some which are ensure on-time delivery, never compromise on quality, and demonstrate control. It focuses on the entire project life cycle. Which methodology does this describe?",
    "choice_a": "AUP",
    "choice_b": "DSDM",
    "choice_c": "FDD",
    "choice_d": "XP",
    "correct_answer": "B",
    "explanation": "This question describes the dynamic systems development method, which defines costs, quality standards, and time frames at the beginning of the project and is constraint driven. It is performed using eight guiding principles.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      302,
      123,
      90,
      111
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 257,
    "question": "Which of the following is true regarding CapEx and OpEx?",
    "choice_a": "OpEx applies to assets expected to provide benefit to the organization for an extended time into the future. CapEx are for day-to-day activities of running the business.",
    "choice_b": "CapEx includes administrative costs, supplies, materials, rent, and salaries. OpEx includes building purchases, vehicle purchases, and IT hardware purchases.",
    "choice_c": "The project budget only includes OpEx, not CapEx.",
    "choice_d": "CapEx applies to assets expected to provide benefit to the organization for an extended time into the future. OpEx are for day-to-day activities of running the business.",
    "correct_answer": "D",
    "explanation": "CapEx applies to assets that are expected to provide benefit to the organization into the future. OpEx are used for day-to-day activities of doing business such as paying contract labor and salaries. The project budget may include both CapEx and OpEx.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      70,
      14,
      206,
      68
    ],
    "source": "892458_Practice Exam1"
  },
  {
    "id": 258,
    "question": "Which of the following are examples of KPIs that could be documented in the project scope statement? (Choose three.)",
    "choice_a": "Increase revenues by 5 percent.",
    "choice_b": "Improve customer satisfaction scores on the annual survey by 3 percent.",
    "choice_c": "Decrease the number of call center interactions and drive customers to the website.",
    "choice_d": "Reduce employee turnover by paying them bonuses based on profits at the end of the year.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Key performance indicators help determine whether the project is on track and provide specific measures to determine if the deliverables have met expectations. Options C and D do not have a metric associated with them, so they are not KPIs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      320,
      88,
      95,
      90
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "Incur zero penalties for regulatory compliance issues at the end of the first 12 months that the system is live."
  },
  {
    "id": 259,
    "question": "You have just started your new role as a project manager and are working on a medium-sized project that is experiencing some risk to the timeline. You have a unique resource that\u2019s needed at a specific point in time during the project, and if they are not available to perform their tasks at the required time, the schedule end date will be impacted. Your stakeholders wish to see the entire project timeline with tasks and resources on one page. Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "You should use a Gantt chart because they can display the project milestones, tasks, and resources on one page.",
    "choice_b": "You should use reverse resource allocation scheduling when scheduling the unique resource that\u2019s needed at a specific point in time.",
    "choice_c": "You should use a PERT chart because they can display the project milestones, tasks, and resources on one page.",
    "choice_d": "You should use a milestone chart because they display assigned resources and can be displayed on one page.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A PERT chart does not display the entire project timeline unless it\u2019s a very small project. A Gantt chart that is too big for a single page can be decreased in size by displaying milestones instead of tasks. Milestones represent a major deliverable and do not have resources assigned to them. Resource leveling is used when resources are overallocated. Reverse resource allocation scheduling should be used when a unique resource is required at a specific point in time on the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      148,
      144,
      141,
      164,
      271
    ],
    "source": "892458_Practice Exam1",
    "choice_e": "You should use resource leveling when scheduling the unique resource that\u2019s needed at a specific point in time."
  },
  {
    "id": 260,
    "question": "You are working on a project that involves repaving 10 miles of a major highway in your city. The work has been contracted to a vendor. You and the vendor have agreed on a price that includes the materials, labor, and other supplies needed for each mile. You agree to paid the vendor at the completion of each mile of paving. What type of contract does this describe?",
    "choice_a": "Cost plus incentive fee",
    "choice_b": "Cost plus award fee",
    "choice_c": "Time and materials",
    "choice_d": "Unit price",
    "correct_answer": "D",
    "explanation": "This question describes a unit price contract. The price for labor and materials was agreed to for the entire unit of work, or one mile in this case. Once one mile of paving was completed (the mile is the unit of work), the vendor was paid.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      278,
      276,
      277,
      90,
      136
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 261,
    "question": "You are new to agile and are working on creating a burndown chart. You know all of the following are true about burndown charts except which one?",
    "choice_a": "They don\u2019t account for changes to scope.",
    "choice_b": "They go to zero over time.",
    "choice_c": "They are best suited to show the work completed to date.",
    "choice_d": "They are only as accurate as the task estimates created by the team",
    "correct_answer": "C",
    "explanation": "The function of a burndown chart is to show the remaining work of the iteration (or a small project), not the completed work.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      267,
      154,
      212,
      266,
      310
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 262,
    "question": "Your organization is considering implementing a cloud-based content management system. The new system will need to interface with existing systems on-premises until they are retired. This will take a good deal of planning and working with the IT team to understand the existing infrastructure. The business users need to work with someone who understands the business process, how the documents are interrelated, and how the different systems will need to communicate with each other. Which of the following does this describe?",
    "choice_a": "Solutions design",
    "choice_b": "Requirements gathering",
    "choice_c": "Enterprise architecture",
    "choice_d": "SDLC",
    "correct_answer": "A",
    "explanation": "This question describes solutions design. The question states the person performing this role (the solutions architect in this case) needs to understand the business processes as well as have technical knowledge of the systems involved in this project. It also states they will need to work with the IT team to understand the existing infrastructure.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      19,
      65,
      124,
      99,
      81
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 263,
    "question": "You are reporting on the project budget. Below figure shows the total budget and expenditures at the measurement date are $45,000. What is the actual burn rate, and is it exceeding the expected burn rate or lower than the expected burn rate?<img src=\"/question_assets/Project+/BE2f001.png\"/>",
    "choice_a": "Actual burn rate is $15,000, which is under the expected burn rate.",
    "choice_b": "Actual burn rate is $55,000, which is higher than the expected burn rate.",
    "choice_c": "Actual burn rate is $20,000 per month, which is the same as the expected burn rate.",
    "choice_d": "Actual burn rate is $25,000 per month, which is higher than the expected burn rate.",
    "correct_answer": "A",
    "explanation": "Burn rate is calculated as expenses to date/time periods at measurement date. First, we calculate how much has been spent to date. We started with a $100,000 budget and at the measurement date in October, we have $55,000 remaining ($100,000 \u2013 $45,000 = $55,000). Expected burn rate is total budget $100,000 / 5 months = $20,000 expected burn rate per month. Actual burn rate is expenses to date/time periods at measurement date. The actual burn rate in this question is $45,000 / 3 months = $15,000 per month. You are spending less than the expected burn rate per month.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      211,
      209,
      210,
      214,
      205
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 264,
    "question": "The role of this project member involves managing the team, managing communication, managing time, overseeing quality assurance, negotiating, and more.",
    "choice_a": "Project sponsor",
    "choice_b": "Product owner",
    "choice_c": "Scrum master",
    "choice_d": "Project manager",
    "correct_answer": "D",
    "explanation": "The project manager\u2019s role is diverse and includes activities such as managing the team, managing communication, defining scope, managing risk, managing budgets, managing time, managing quality assurance, planning, negotiating, solving problems, and more.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      6,
      22,
      25,
      174
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 265,
    "question": "This is used to display project schedules.",
    "choice_a": "Gantt chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Run chart",
    "correct_answer": "A",
    "explanation": "Gantt charts are a type of bar chart used to display the project schedule.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      152,
      154,
      266,
      145
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 266,
    "question": "Which of the following describes the role of the product manager?",
    "choice_a": "They speak on behalf of the stakeholders and are responsible for prioritizing user stories in the backlog list.",
    "choice_b": "They oversee the project management phases and keep the deliverables in line with the project management plan to ensure the final product meets the project objectives.",
    "choice_c": "They work with the development team to determine a design or to develop a prototype of the final product and measure the outcomes to ensure the final product meets the project objectives.",
    "choice_d": "They oversee the development of new products for the organization and determine strategy for existing and new products.",
    "correct_answer": "D",
    "explanation": "Option A describes a product owner, Option B describes a project manager, and Option C describes a solutions architect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      121,
      56,
      6
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 267,
    "question": "Your organization was acquired by another four years ago. They have decided to have an outside entity perform all their payroll functions. What type of business organizational change is this?",
    "choice_a": "Business split",
    "choice_b": "Business demerger",
    "choice_c": "Internal reorganization",
    "choice_d": "Outsourcing",
    "correct_answer": "D",
    "explanation": "Outsourcing is the process of having outside entities perform functions on behalf of the organization. Payroll, human resources, information technology, and security are common functions that organizations outsource.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      289,
      296,
      292,
      293,
      28
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 268,
    "question": "Your project has experienced some changes to the agreed-on WBS elements. The changes were approved through the proper change control process. The WBS changes might in turn require which of the following? (Choose two.)",
    "choice_a": "Scope changes",
    "choice_b": "Cost changes",
    "choice_c": "Schedule revisions",
    "choice_d": "You may need to repeat some of the project planning processes to incorporate the change.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "WBS element changes are scope changes. Schedule revisions are often required as a result of scope changes. Changes in scope also may require a repeat of some of the planning processes.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      279,
      281,
      135,
      136,
      274
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 269,
    "question": "Your selection committee has examined the business case and ROI. They chose two of the five projects presented to move forward. What phase are you working in?",
    "choice_a": "Discovery",
    "choice_b": "Initiating",
    "choice_c": "Planning",
    "choice_d": "Executing",
    "correct_answer": "A",
    "explanation": "The Discovery phase is where the business case is developed and projects are evaluated by the steering committee.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      8,
      14,
      7,
      16
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Closing"
  },
  {
    "id": 270,
    "question": "You are reviewing the IT organization\u2019s data classifications as outlined in the data security policy. Which of the following is not correct in regard to data classification?",
    "choice_a": "This is a way to describe data according to its sensitivity, type, and value to the organization.",
    "choice_b": "This describes the rules for access and permissions to data.",
    "choice_c": "Need to know is a type of data classification.",
    "choice_d": "PII and PHI are two types of data classification.",
    "correct_answer": "B",
    "explanation": "Option B describes the digital security policy.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      195,
      194,
      190,
      29,
      30
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 271,
    "question": "What are the triple constraints that are common to all projects? (Choose three.)",
    "choice_a": "Procurement",
    "choice_b": "Scope",
    "choice_c": "Cost",
    "choice_d": "Management decisions",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The triple constraints are scope, time, and cost. All of these constraints impact quality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      248,
      90,
      91,
      281,
      279
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Time",
    "choice_f": "Goals",
    "choice_g": "Quality"
  },
  {
    "id": 272,
    "question": "Your project is progressing nicely. The planned value for the project is $100,000. The earned value is $88,000 to date. Actual expenses to date are $90,000. What is the cost variance?",
    "choice_a": "12,000",
    "choice_b": "2,000",
    "choice_c": "-12,000",
    "choice_d": "-2,000",
    "correct_answer": "D",
    "explanation": "The formula for cost variance is CV = EV \u2013 AC. Let\u2019s plug in the numbers: 88,000 \u2013 90,000 = \u20132,000.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      210,
      209,
      211,
      214,
      198
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 273,
    "question": "Leah is a key stakeholder on the project. She\u2019s a big believer in the benefits of the project and provides enthusiasm, energy, communication, and motivation to the organization about this project. What is Leah\u2019s role?",
    "choice_a": "Project stakeholder",
    "choice_b": "Project champion",
    "choice_c": "Project team member",
    "choice_d": "Business analyst",
    "correct_answer": "B",
    "explanation": "The project champion is someone who understands the goals of the project and serves as a voice of enthusiasm throughout the organization regarding the benefits of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      51,
      60,
      232,
      57
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 274,
    "question": "You are working on project to implement an IaaS solution for your organization. So far, you have created a scope baseline and a schedule baseline. You know which of the following are true regarding this question? (Choose three.)",
    "choice_a": "The scope baseline is made up of the approved scope statement, the WBS, and the WBS dictionary.",
    "choice_b": "Changes to scope require an update to the schedule baseline.",
    "choice_c": "The project management plan is made up of project management documents, plans, and baselines and should include the development approach you\u2019ll use to manage the project.",
    "choice_d": "Once you\u2019ve created the cost baseline, you\u2019ll have established a performance measurement baseline for the project.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "A schedule revision can be used to manage noncritical path tasks that do not require a new schedule baseline. The original schedule baseline should always be retained for historical purposes and to perform lessons learned at the end of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      84,
      132,
      330,
      11
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Schedule baselines may change throughout the project, and the latest version of the baseline is the one the team works from and the only one that should be retained."
  },
  {
    "id": 275,
    "question": "You are a project manager for Fountain of Youth Spring Water bottlers. Your project involves installing a new accounting system. You want to show the sequence of interrelated information with their expected results so that you can choose one alternative over another. Which of the following charts would you use?",
    "choice_a": "Pareto chart",
    "choice_b": "Decision tree",
    "choice_c": "Run chart",
    "choice_d": "Ishikawa diagram",
    "correct_answer": "B",
    "explanation": "A decision tree shows the sequence of interrelated decisions and the expected results of each alternative.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      145,
      146,
      267,
      212
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 276,
    "question": "These resources are used to create the product of the project or are used by the organization to perform the project, such as a building or vehicle. These resources are typically high priced and have a useful life of more than a few years. What is this resource type?",
    "choice_a": "Low-quality",
    "choice_b": "Internal resources",
    "choice_c": "Shared resources",
    "choice_d": "Capital resources",
    "correct_answer": "D",
    "explanation": "Capital resources are physical resources used on the project that are typically high priced and have a useful life of several years.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      204,
      26,
      140,
      53
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 277,
    "question": "As you decompose the WBS, you discover a requirement that wasn\u2019t listed in the requirements section of the scope statement. This requirement is essential to a successful project because it details industry standard measurements that your team must comply with in order to complete the deliverable. Which of the following is true regarding this scenario?",
    "choice_a": "This is an example of a constraint.",
    "choice_b": "This is an example of an influence.",
    "choice_c": "This is an example of an assumption.",
    "choice_d": "This is an example of a dependency.",
    "correct_answer": "A",
    "explanation": "This is an example of a constraint because it dictates the actions of the project team.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      86,
      97,
      127,
      88
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 278,
    "question": "You need to send a quick, succinct message to one of your team members asking them if the delivery you expected showed up at the warehouse on time. Which method is the best option to use in this case?",
    "choice_a": "Email",
    "choice_b": "Phone call",
    "choice_c": "Text",
    "choice_d": "Face-to-face meeting",
    "correct_answer": "C",
    "explanation": "A text message is an effective method to communicate with one team member using a succinct, clearly understood message. Email would be useful if you have multiple team members who need to respond.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      233,
      237,
      227,
      23
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 279,
    "question": "You have two stakeholders who are at odds about the scope of the project work. This is such a large conflict that the project sponsor is involved in the meeting to discuss the issues. After listening to the issues, the sponsor makes a final decision. Which conflict-resolution technique does this describe?",
    "choice_a": "Collaborating",
    "choice_b": "Smoothing",
    "choice_c": "Forcing",
    "choice_d": "Avoiding",
    "correct_answer": "C",
    "explanation": "Forcing is a technique where one party forces the resolution on the other parties.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      16,
      79,
      82,
      69,
      67
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 280,
    "question": "The business case examines the alignment of the project to the company\u2019s vision, mission, and values. The project manager must have an awareness of these elements. While these are examined as part of the business case and project selection process, they are also part of which of the following?",
    "choice_a": "NIST standards",
    "choice_b": "ESG factors",
    "choice_c": "Compliance considerations",
    "choice_d": "Social considerations",
    "correct_answer": "B",
    "explanation": "Environmental, social, and governance factors influence project management activities. Awareness of the company\u2019s mission, vision, and values is part of the ESG factors.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      190,
      191,
      192,
      194,
      195
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 281,
    "question": "All of the following are examples of communication triggers except which one?",
    "choice_a": "Constraint reprioritization",
    "choice_b": "Gate reviews",
    "choice_c": "Audits",
    "choice_d": "Project planning",
    "correct_answer": "A",
    "explanation": "Constraint reprioritization is an influence on project constraints, not a communication trigger.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      272,
      247,
      251,
      248,
      91
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Stakeholder changes",
    "choice_f": "Resource changes"
  },
  {
    "id": 282,
    "question": "Your project involves building a new website. Your organization is going to measure the number of clicks on photos, the number of visitors to the site, the number of page views, and the abandon rate. What performance management tool are they using?",
    "choice_a": "RACI",
    "choice_b": "KPI",
    "choice_c": "EVM",
    "choice_d": "CPM",
    "correct_answer": "B",
    "explanation": "They are using key performance indicators. A RACI is a type of chart showing responsibility and accountability among team members, EVM is earned value management and is used to measure project performance, and CPM is the critical path method used in scheduling projects.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      320,
      209,
      210,
      211
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 283,
    "question": ".You are implementing a new ERP system for your organization. It will include accounting, payroll, and human resource modules. Procurement and inventory modules will be considered at a future time. You invited three vendors to give demos of their system prior to issuing the RFP. All the team members were impressed by the presentation given by the first vendor and requested their system engineer be assigned to the project if they were the winning bidder. This vendor assured your team they will do everything they can to assign this system engineer to your project. You awarded the project to the first vendor. The team is using a waterfall development methodology. Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "The scope statement should include order of magnitude estimates for time and cost.",
    "choice_b": "Procurement and inventory modules should be listed as exclusions from scope in the scope management plan.",
    "choice_c": "The vendor system engineer\u2019s assignment to this project is a constraint because it was one of the conditions of the award.",
    "choice_d": "The demo was given at the bidders conference and the first vendor was awarded the contract.",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Procurement and inventory modules are exclusions from scope, but they are listed in the scope statement, not the scope management plan. Option C describes an assumption, not a constraint. A bidders conference is held after an RFP is submitted. Vendor demos typically occur prior to the issuance of an RFP.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      86,
      185,
      168,
      90
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "The development of the scope statement is an iterative process."
  },
  {
    "id": 284,
    "question": "The executives in your organization often travel up to 75 percent of their workdays. Recently, one of your executives\u2019 accounts was hacked. It likely occurred while they were logging in remotely from the hotel. As a result, your IT department decides to implement a process to enforce at least two methods of verification of identity to help mitigate this problem in the future. Which option describes the name of this process?",
    "choice_a": "ETC",
    "choice_b": "CPM",
    "choice_c": "MVP",
    "choice_d": "MFA",
    "correct_answer": "D",
    "explanation": "Multifactor authentication (MFA) is a process whereby the user must provide two or more methods to verify their identity during the sign-in process. ETC stands for estimate to complete, CPM is the critical path method, and MVP is a minimally viable product.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      190,
      191,
      192,
      195
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 285,
    "question": "You work for a program manager in the PMO. You\u2019re working on a project to implement a cloud software application developed by a well-known vendor. Your company\u2019s sales department will equip their field personnel with wireless tablets that will connect to the cloud. The success of this project will largely depend on the field personnel\u2019s acceptance of the final application. Which of the following are true regarding this question? (Choose three.)",
    "choice_a": "This is a PaaS cloud model.",
    "choice_b": "You need a developer from the IT department to oversee the integration of this application within the IT cloud environment.",
    "choice_c": "You need an architect from the IT department to oversee the integration of this application within the IT cloud environment.",
    "choice_d": "This is a SaaS cloud model.",
    "correct_answer": [
      "C",
      "D",
      "E"
    ],
    "explanation": "The architect develops and defines solutions and services for the IT environment. This question describes a software as a service (SaaS) model. The cloud software is already developed by a vendor. The field engineers are known as end users, and it\u2019s imperative you get their input on the software chosen. If they don\u2019t like the program or think it\u2019s inefficient, it could kill the project. A PaaS model allows IT developers to develop their own applications on the platform. A developer is responsible for developing applications, and you need the architect to determine how this solution fits in the environment. The business analyst works for the PMO, not the business unit.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      57,
      121,
      58,
      50
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "The field personnel are known as end users.",
    "choice_f": "You need a business analyst from the business unit who will act as an SME to write the requirements"
  },
  {
    "id": 286,
    "question": "Your project has entered the Executing phase and you\u2019ve discovered that the project schedule needs adjusted. Which of the following is true regarding this question? (Choose two.)",
    "choice_a": "You need to adjust the schedule in the Executing phase and continue with the work of the project.",
    "choice_b": "You need to modify the schedule in the Planning phase and review other planning documents that could be impacted by this change, then proceed to the Executing phase.",
    "choice_c": "This describes an iterative process.",
    "choice_d": "This describes an initiating process.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Project management is an iterative process and phases may need to be repeated during the course of the project, especially when a major change occurs such as a schedule change. Schedules are created in the Planning phase. You\u2019ll need to repeat the Planning phase and review other planning documents to determine if this change impacts other elements of the project and then proceed to the Executing phase.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      274,
      275,
      279,
      86,
      135
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "You need to repeat the Discovery phase and adjust the schedule in the Planning phase, then review other planning documents that could be impacted by this change, and then proceed to the Executing phase."
  },
  {
    "id": 287,
    "question": "Your project has experienced some changes. A new sponsor has started on the project, and they requested some new features be included in the project you\u2019re working on. They\u2019ve also added two new stakeholders and understand that you\u2019ll need additional time to add the new features. Which of the following documents should be updated as a result of these changes?",
    "choice_a": "Scope statement, project schedule, communications plan",
    "choice_b": "Project schedule, risk register, communications plan",
    "choice_c": "Scope statement, project schedule",
    "choice_d": "Scope statement, project schedule, risk register",
    "correct_answer": "A",
    "explanation": "The scope statement needs updating to document the new features. The project schedule will be updated to reflect the additional time to complete the new features. The communications plan should be updated to document the new stakeholders and their communication needs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      274,
      271,
      272,
      53
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 288,
    "question": "Which element is not a component or function of the scope management plan?",
    "choice_a": "Describes the deliverables acceptance criteria",
    "choice_b": "Describes how scope changes will be handled",
    "choice_c": "Describes the procedures for preparing the scope statement",
    "choice_d": "Describes the procedures for preparing the WBS",
    "correct_answer": "A",
    "explanation": "The scope management plan contains a definition of how the deliverables will be validated, but the acceptance criteria are documented in the scope statement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      84,
      327,
      93,
      99
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 289,
    "question": "You are a new project manager for your company. You are developing the WBS for your project. You know the following options are true regarding the WBS. (Choose two.)",
    "choice_a": "The WBS is developed by the project scheduler, who works alone to determine its elements.",
    "choice_b": "The WBS is developed after the scope statement.",
    "choice_c": "The WBS is a deliverables-oriented hierarchy that describes the work of the project.",
    "choice_d": "The WBS is developed after the project charter.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The WBS is a deliverables-oriented hierarchy that defines the work of the project. It is constructed with the help of key team members, not the project scheduler alone. It is written after the scope statement is completed. The scope statement contains the project deliverables that are used to construct the WBS.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      128,
      12,
      93,
      9,
      84
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "The WBS helps to sequence tasks."
  },
  {
    "id": 290,
    "question": "You\u2019re a project manager for a complex software development project that has been completed and turned over to the end users. They determine they need some additional functionality and changes to workflow. They\u2019ve prepared a change request and the team is working on an impact analysis. This change could have significant impacts if not performed correctly. You determine that the best next step in evaluating the impact of this change is which of the following?",
    "choice_a": "Develop a rollback plan.",
    "choice_b": "Write a change request response describing the possible effects.",
    "choice_c": "Update the project management documents with the change.",
    "choice_d": "Tell the team to implement the change.",
    "correct_answer": "A",
    "explanation": "The next best step is to develop a rollback, or reverse changes, plan, so that if the change is approved and doesn\u2019t go as planned, you have a backup of the work you\u2019ve done to date. You are in the process of analyzing the change, so the change request is already written. You wouldn\u2019t update the project management documents or tell the team to implement the change until the change is approved.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      281,
      279,
      87,
      285,
      309
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 291,
    "question": "This meeting is held after the project charter is signed or at the beginning of the Executing phase when all of the project team members have been assigned to the project. It formally introduces the team members and stakeholders and outlines the goals and objectives of the project for the team.",
    "choice_a": "Project status meeting",
    "choice_b": "Kickoff meeting",
    "choice_c": "Project introductory meeting",
    "choice_d": "Steering-committee meeting",
    "correct_answer": "B",
    "explanation": "The kickoff meeting is where the project team members and stakeholders are introduced to each other, and it\u2019s held at the beginning of the Executing process group.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      76,
      77,
      80,
      78,
      10
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 292,
    "question": "You have created a scope baseline, a schedule baseline, and a cost baseline. Which of the following are true regarding these documents? (Choose three.)",
    "choice_a": "Scope and schedule baselines may only be changed with an approved change that has been vetted by the change control board. Cost baselines may change with the approval of the project sponsor.",
    "choice_b": "The scope baseline is made up of the approved scope statement, the WBS, and the WBS dictionary.",
    "choice_c": "These documents are part of the project management plan.",
    "choice_d": "Schedule baselines may change throughout the project and the latest version of the baseline is the one the team works from and the only one that should be retained.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "Cost changes must also be approved by the change control board. The original schedule baseline should always be retained for historical purposes and to perform lessons learned at the end of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      84,
      203,
      11,
      132
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Together, these three baselines are known as the performance measurement baseline for the project."
  },
  {
    "id": 293,
    "question": "Your project involves collecting sensitive data for customers. As the project manager, you understand that the system being developed must have safeguards to protect individual identities and personal information relating to those individuals. What is this concept known as?",
    "choice_a": "Data confidentiality",
    "choice_b": "PII protection",
    "choice_c": "SPII protection",
    "choice_d": "GDPR confidentiality",
    "correct_answer": "B",
    "explanation": "Data confidentiality involves protecting data such as PII, SPII, PHI, and EPHI.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      30,
      195,
      31,
      190
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 294,
    "question": "You are working on a project where project status meetings generally have 12 participants. How many lines of communication are there?",
    "choice_a": "12",
    "choice_b": "66",
    "choice_c": "72",
    "choice_d": "60",
    "correct_answer": "B",
    "explanation": "There are 66 lines of communication. The formula for this equation is as follows: 12(12 \u2013 1) / 2 = 66.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      228,
      227,
      253,
      232,
      245
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 295,
    "question": "When creating your WBS, what is the lowest level that you\u2019ll develop?",
    "choice_a": "Work package level",
    "choice_b": "Task level",
    "choice_c": "Milestone level",
    "choice_d": "Level 6",
    "correct_answer": "A",
    "explanation": "The work package is at the lowest level of a WBS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      9,
      85,
      94,
      134
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 296,
    "question": "You are starting a new project management podcast that will tackle topics, questions and answers, and example scenarios project managers face on the job. You are investigating branding restrictions and will use which of the following for the podcast?",
    "choice_a": "Patent Pending",
    "choice_b": "Trademark",
    "choice_c": "Registered trademark",
    "choice_d": "Copyright",
    "correct_answer": "D",
    "explanation": "A copyright is used to protect intellectual property such as recordings, writings, and artwork.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      195,
      191,
      190,
      45
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 297,
    "question": "Which of the following options are documented in a business case? (Choose three.)",
    "choice_a": "How the project goals align to the strategic plan",
    "choice_b": "Resource availability",
    "choice_c": "Determining the decision model you\u2019ll use for project selection",
    "choice_d": "Feasibility study results",
    "correct_answer": "H",
    "explanation": "The business case document includes description, justification, alignment to the strategic plan, stakeholders, analysis of the problem or opportunity, high-level risk analysis, alternative solutions, recommended solution, and feasibility study results (if one was undertaken).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      14,
      8,
      66,
      102,
      16
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "High-level risk analysis",
    "choice_f": "Financial analysis of the alternative solutions",
    "choice_g": "A, B, D, E, F",
    "choice_h": "A, D, E, F"
  },
  {
    "id": 298,
    "question": "These project members provide input and requirements, help with steering the project, provide expertise, and have an interest in the outcomes of the project. Which option describes these project members?",
    "choice_a": "Stakeholders",
    "choice_b": "Project team members",
    "choice_c": "Project coordinator",
    "choice_d": "Project sponsor",
    "correct_answer": "A",
    "explanation": "The project stakeholders have a vested interest in the outcome of the project; they provide expertise, inputs, and requirements; and they help to steer the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      62,
      26,
      53,
      60
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 299,
    "question": "Your existing financial, human resources, and procurement systems are all disparate systems that require a significant amount of coding to provide interfaces for data exchange among the systems, and maintenance is a full-time job for several staff members. You are comparing the existing features, functionality, utilization, and other elements of your existing systems to those your stakeholders have requested that are available in the marketplace. You are likely going to choose a cloud-based system as the replacement for these aging systems. Which of the following is true regarding this question?",
    "choice_a": "You have performed requirements gathering and are in the acquisition software resource life cycle.",
    "choice_b": "You have performed a resource assessment and are in the maintenance phase of the resource life cycle.",
    "choice_c": "You have performed a gap analysis and are in the successor planning phase of the resource life cycle.",
    "choice_d": "You have performed vendor evaluation process and are in the end-of-life phase of resource life cycle.",
    "correct_answer": "C",
    "explanation": "This question describes a gap analysis. You are comparing the existing software to the features and functionality available on the marketplace. This is the successor planning phase of the resource life cycle.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      169,
      88,
      279,
      13,
      204
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 300,
    "question": "From the following list, choose the chart that represents variations in the process over time to help determine whether processes are in control. This chart can also display positive or negative change.",
    "choice_a": "Flowchart",
    "choice_b": "Scatter diagram",
    "choice_c": "Histogram",
    "choice_d": "Run chart",
    "correct_answer": "D",
    "explanation": "A run chart plots data points over time to show variations in the process, and to display positive or negative change.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      154,
      267,
      314
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 301,
    "question": "Many countries, and even individual regions within countries, have developed their own standards and regulations for controlling, storing, and transmitting PII data. Which of the following describe the standards for PII for those organizations doing business in Europe?",
    "choice_a": "EPHI",
    "choice_b": "CCPA",
    "choice_c": "PIPEDA",
    "choice_d": "GDPR",
    "correct_answer": "D",
    "explanation": "GDPR is the General Data Protection Regulation developed in Europe. The Electronic Protected Health Information (EPHI) is found in the United States, the California Consumer Privacy Act (CCPA) was developed in California, and the Personal Information Protection and Electronic Documents Act (PIPEDA) was developed in Canada.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      195,
      32,
      190,
      191
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 302,
    "question": "When developing the project schedule, which methodology will reveal the tasks with zero float?",
    "choice_a": "Activity sequencing",
    "choice_b": "Logical relationships",
    "choice_c": "Critical path method",
    "choice_d": "Activity definition",
    "correct_answer": "C",
    "explanation": "The critical path method determines the critical path on the project, which is defined by those projects with zero float.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      136,
      90,
      147,
      219
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 303,
    "question": "One of the key stakeholders on your project submitted a change request to add new requirements. The change was approved and implemented. What are your next steps?",
    "choice_a": "Validate the change and perform a quality check to ensure it meets specifications.",
    "choice_b": "Update the project management documents to reflect the new requirements.",
    "choice_c": "Communicate the change to all the stakeholders.",
    "choice_d": "Provide an update at the next CCB to confirm the change was made and was successful.",
    "correct_answer": "E",
    "explanation": "The project management documents should be updated to reflect the new requirements. Validating the change and performing a quality check ensures it meets the specifications of the change. Communication with the stakeholders occurs throughout the change process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      279,
      274,
      306,
      87,
      247
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "All of the above."
  },
  {
    "id": 304,
    "question": "Your project budget for this period of work is $75,000 and you have spent $71,000 to date. The value of the work completed during this period of work is $70,000. What is the SV and are you ahead or behind schedule? (Choose two.)",
    "choice_a": "\u20131,000",
    "choice_b": "5,000",
    "choice_c": "\u20135,000",
    "choice_d": "You are behind schedule.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The formula for SV is EV \u2013 PV. Earned value is 70,000, and planned value is 75,000. Therefore, the SV is \u20135,000. A negative result means the project is behind schedule.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      209,
      204,
      199,
      201
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "You are ahead of schedule."
  },
  {
    "id": 305,
    "question": "Your project selection committee is debating between project A with an IRR of 7% and project B with an IRR of 5%. Which of the following statements are true regarding this question?",
    "choice_a": "You shouldn\u2019t rely on IRR alone to determine selection.",
    "choice_b": "Project A should move forward.",
    "choice_c": "Project B should move forward.",
    "choice_d": "IRR is the least precise of the cash flow techniques.",
    "correct_answer": "B",
    "explanation": "The general rule is that projects with the higher IRR values should be chosen over projects with lower IRR values. IRR can be used as a stand-alone analysis technique.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      19,
      96,
      203,
      67
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 306,
    "question": "You have received a contingent offer of employment as a project manager for a research and development firm. The HR recruiter has told you that this position is exposed to classified R&D information in the lab itself and in the systems you\u2019ll be accessing for the projects you manage. You will need to undergo a process to verify your identity and level of trustworthiness. You\u2019ll also need special access to the laboratory area, which will be restricted to certain hours during the workday. Which of the following options are true regarding this question? (Choose two.)",
    "choice_a": "This position requires a background check, which is defined in the operational security policy.",
    "choice_b": "The process for the identity security check and facilities access is outlined in the operational security policy.",
    "choice_c": "The procedures for access to the R&D lab are outlined in the facilities security policy.",
    "choice_d": "The process for this identity security check is outlined in the digital security policy.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "This question describes the need for a background check, which is outlined in the operational security policy, and special facilities access, which is outlined in the physical security policy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      192,
      195,
      190,
      194
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 307,
    "question": "This stakeholder is the recipient of the product or service created by the project. (Choose two.)",
    "choice_a": "Sponsor",
    "choice_b": "Customer",
    "choice_c": "Senior management",
    "choice_d": "End user",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The customer and the end user are sometimes one and the same. They are the recipients of the product or service created by the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      51,
      119,
      272,
      60
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Subject matter experts"
  },
  {
    "id": 308,
    "question": "Why should you obtain formal sign-off when you conclude your project?",
    "choice_a": "Sign-off allows the project manager to start a new assignment.",
    "choice_b": "Sign-off acknowledges that the project team is no longer accountable for this product.",
    "choice_c": "Sign-off is the trigger for releasing team members back to their functional organization.",
    "choice_d": "Sign-off indicates that the project meets the documented requirements and the stakeholders have accepted the project deliverables.",
    "correct_answer": "D",
    "explanation": "A sign-off is the formal acceptance of the project. Team members are released according to the staffing management plan, but both the project manager and the project team members may continue to be involved in the project until all closure activities are complete.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      328,
      11,
      327,
      331,
      325
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 309,
    "question": "Team-building efforts will have the greatest impact in which of the following situations? (Choose three.)",
    "choice_a": "Schedule changes",
    "choice_b": "Organizational changes",
    "choice_c": "Personality clashes",
    "choice_d": "Budget changes",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "Personality clashes and staff changes are situations where team-building activities can assist in solving problems. Organizational changes require immediate communication from the project manager. As a rule, most people are generally sensitive to change and are asking, \u201cWhat does this mean for me?\u201d This has a tendency to disrupt working patterns and decrease efficiencies, and it requires that you act as a change agent\u2014getting people through the change while continuing the work of your project. Additionally, it\u2019s quite possible that an organizational change may directly affect your project, in which case you, too, need to ask, \u201cWhat does this mean for the project?\u201d.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      289,
      291,
      292,
      60,
      232
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Staff changes",
    "choice_f": "Project scope changes"
  },
  {
    "id": 310,
    "question": "You are the project manager for a moderately sized project well into the Executing phase. What is the largest risk that you will be monitoring for during this time?",
    "choice_a": "Scope creep",
    "choice_b": "A vendor going out of business",
    "choice_c": "A team member leaving the company",
    "choice_d": "The sponsor losing interest in the project",
    "correct_answer": "A",
    "explanation": "By far the largest risk to the project at this stage is scope creep. Adding extra requirements now is out of scope, and if it isn\u2019t stopped, it has the potential to impact the schedule and budget.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      288,
      56,
      216,
      315,
      281
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 311,
    "question": "Which of the following involves satisfying stakeholder needs, communicating, resolving issues, improving project performance, and managing concerns?",
    "choice_a": "Communications planning for stakeholders",
    "choice_b": "Managing stakeholders\u2019 expectations",
    "choice_c": "Developing the stakeholder team",
    "choice_d": "Distributing information",
    "correct_answer": "B",
    "explanation": "Managing stakeholders\u2019 expectations involves satisfying the needs of the stakeholders, communicating, resolving issues, improving project performance, and managing concerns. Communications planning is where you develop the plan for communicating to stakeholders throughout the project. Developing the stakeholder team isn\u2019t an actual activity, but you are responsible for developing project teams, and this is where team-building and conflict-resolution techniques are used, and distributing information is where the communication plan is put into action.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      51,
      271,
      60,
      232,
      317
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 312,
    "question": "What is the name of the resource requirement tool shown in the following table?<img src=\"/question_assets/Project+/pe2_01.png\"/>",
    "choice_a": "Resource requirement matrix",
    "choice_b": "Responsibility requirement matrix",
    "choice_c": "Resource definition matrix",
    "choice_d": "Responsibility assignment matrix",
    "correct_answer": "D",
    "explanation": "The RACI chart shown here is a type of responsibility assignment matrix (RAM) that allows you to denote the types of skills you require in your project team and which project tasks they\u2019ll be needed for.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      12,
      8,
      128,
      98,
      69
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 313,
    "question": "Which of the following are true regarding multitiered architecture?",
    "choice_a": "Multitiered architecture physically separates technology functions into their own modules.",
    "choice_b": "Web pages are an example of the application tier.",
    "choice_c": "Inputting data into a form is an example of the presentation tier.",
    "choice_d": "Performing calculations on the input into a form is an example of the data tier.",
    "correct_answer": "A",
    "explanation": "Web pages are an example of the presentation tier, inputting data into a form is an example of the presentation tier, and performing calculations is an example of the application tier.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      37,
      36,
      40,
      42,
      46
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 314,
    "question": "Use the chart shown in below figure to determine which of the following options are true. (Choose three.)<img src=\"/question_assets/Project+/BE2f002.png\"/>",
    "choice_a": "This is a burndown chart, and its primary function is to show the completed work of the iteration.",
    "choice_b": "The cycle time estimate of the remaining work is 7 days.",
    "choice_c": "This chart is an in the moment type of measure.",
    "choice_d": "Estimates used in this burndown chart are unique to the team that created them.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The function of a burndown chart is to show the remaining work of the iteration. A burnup chart shows the work completed. It takes the team between four and eight iterations to reach a steady cadence whereby estimates improve.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      133,
      131,
      140,
      201,
      219
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "It takes the team between four and six iterations to reach a steady velocity cadence."
  },
  {
    "id": 315,
    "question": "This performance measurement tool is used to determine whether the performance of the organization is meeting their goals. It may measure financial goals, business processes, customer satisfaction, and more. This tool focuses on strategic areas of the business and monitors only a small number of important data elements.",
    "choice_a": "Key performance indicators",
    "choice_b": "Dashboard",
    "choice_c": "Key performance parameters",
    "choice_d": "Balanced scorecard",
    "correct_answer": "D",
    "explanation": "This question describes a balanced scorecard. KPIs could be used to measure the goals mentioned as well, but the clue in this question is that balanced scorecards focus on organizational goals and only on a small number of important data elements.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      323,
      89,
      320,
      210,
      290
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 316,
    "question": "Top-down estimating is another name for which type of estimating technique?",
    "choice_a": "Parametric estimating",
    "choice_b": "Analogous estimating",
    "choice_c": "Three-point estimating",
    "choice_d": "Expert judgment",
    "correct_answer": "B",
    "explanation": "Top-down estimating is another name for analogous estimating.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      142,
      198,
      199,
      201,
      202
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 317,
    "question": "What is the purpose of the preliminary scope statement and when is it created? (Choose three.)",
    "choice_a": "It documents the reason for the project.",
    "choice_b": "It names the project manager.",
    "choice_c": "It documents the objectives of the project.",
    "choice_d": "It\u2019s created prior to the project charter.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The preliminary scope statement describes the objectives for the project and the business problem the project is trying to solve\u2014that is, the reason for the project. It is created after the business case and before the project charter.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      8,
      19,
      64,
      66,
      9
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "It\u2019s created prior to the business case."
  },
  {
    "id": 318,
    "question": "Your project will bring about efficiencies in the employee expense reimbursement process. You initiate performance analysis that examines gaps in the process and compares them to the expected results the project will bring about. What is this known as?",
    "choice_a": "Current state vs. future state",
    "choice_b": "Gap analysis",
    "choice_c": "Present value vs. future value",
    "choice_d": "Iterative analysis",
    "correct_answer": "A",
    "explanation": "This question describes current state vs. future state, which is a form of performance analysis that examines business processes or potential project outcomes and compares the current state to the future state.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      14,
      19,
      65,
      67,
      102
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 319,
    "question": "The difference between project life cycles and project management phases are best described in which option?",
    "choice_a": "Feasibility studies may be performed as part of the project management phases.",
    "choice_b": "Project life cycles describe how the project activities will be conducted to meet the project objectives.",
    "choice_c": "Project management phases are performed within a project life cycle.",
    "choice_d": "Project life cycles are performed within project management phases.",
    "correct_answer": "C",
    "explanation": "Project management phases (Discovery, Initiating, Planning, Executing, and Closing) are performed within a project life cycle (beginning/feasibility study, planning, performing the work, closing). Feasibility studies are part of the project life cycle. Project life cycles describe how the work associated with the project will be completed. Project management phases describe how the project activities will be conducted to meet the project requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      6,
      127,
      106,
      133
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 320,
    "question": "This type of organization change involves engaging external resources to help perform project functions or business functions.",
    "choice_a": "Business acquisition",
    "choice_b": "Outsourcing",
    "choice_c": "Internal reorganization",
    "choice_d": "Business process change",
    "correct_answer": "B",
    "explanation": "Outsourcing occurs when an organization doesn\u2019t have the resources, or their resources don\u2019t have the skill sets available to perform the tasks. Some organizations choose to outsource standard business functions such as payroll, IT, and security as well.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      296,
      182,
      162,
      289,
      163
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 321,
    "question": "You have the following figures: PV = 100, AC = 75, and EV = 80. What is CPI?",
    "choice_a": "\u201320",
    "choice_b": "1.06",
    "choice_c": ".80",
    "choice_d": ".94",
    "correct_answer": "B",
    "explanation": "The formula for CPI is EV / AC, so the formula looks like this: 80 / 75 = 1.06.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      274,
      6,
      15
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 322,
    "question": "Why is a scope management plan necessary?",
    "choice_a": "It describes how the project team will define project scope.",
    "choice_b": "It describes how the project team will verify the work of the project.",
    "choice_c": "It describes how the project\u2019s activities will be scheduled.",
    "choice_d": "It describes the process to manage scope change requests.",
    "correct_answer": "F",
    "explanation": "The scope management plan describes how the project team will define project scope, verify the work, and manage and control scope. One of the most important functions of the scope management plan is to help keep scope creep under control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      87,
      286,
      131,
      88
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "It is effective at taming scope creep.",
    "choice_f": "A, B, D, E"
  },
  {
    "id": 323,
    "question": "Determining durations, determining dependencies, sequencing, assigning resources, and setting quality gates are all associated with which of the following activities?",
    "choice_a": "Developing the RACI",
    "choice_b": "Developing the WBS",
    "choice_c": "Developing the milestone chart",
    "choice_d": "Developing the project schedule",
    "correct_answer": "D",
    "explanation": "The tasks stated in the question, along with determining the critical path, allocating resources, determining predecessors, and setting governance gates, are all part of developing a project schedule.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      136,
      86,
      56,
      90
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 324,
    "question": "You are working on implementing a new SaaS application and are working with a vendor to stand up the new system. They are responsible for most aspects of this project. Which of the following is not true regarding this question?",
    "choice_a": "Changes are managed using a contract change control system.",
    "choice_b": "Claims administration is used to manage contested changes.",
    "choice_c": "Contested changes usually involve a disagreement about the scope of the change.",
    "choice_d": "Arbitration can be an effective tool for managing contested changes.",
    "correct_answer": "C",
    "explanation": "Contested changes usually involve a disagreement about the compensation paid to the vendor for implementing the change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      277,
      276,
      280,
      278,
      51
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 325,
    "question": "You\u2019re a project manager working on a midsized project that\u2019s well into the Executing phase. One of your more powerful stakeholders is somewhat overbearing at the regular project status meetings and insists that her solution is the only solution and will not let anyone else present alternative ideas. What conflict-resolution technique does this describe?",
    "choice_a": "Confronting",
    "choice_b": "Forcing",
    "choice_c": "Smoothing",
    "choice_d": "Negotiating",
    "correct_answer": "B",
    "explanation": "Forcing is when a team member forces a solution on the other parties. This is a win-lose conflict-resolution technique.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      259,
      273,
      78,
      236,
      59
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 326,
    "question": "You are working on an agile project to develop an expense tracking app for employees to track the number of business miles driven using their personal cars. This app will have three functions: capturing business miles driven, tracking vehicle maintenance, and reimbursement calculations. You\u2019ll need to break down this project and tackle each of these functions as an independent phase. For each phase, you will use a board to visually display the work that the iteration team is working on for that iteration. What does this question describe? (Choose two.)",
    "choice_a": "The team should use agile release planning to break this project into phases.",
    "choice_b": "The team is using a Kanban board to show the work of the iteration.",
    "choice_c": "The team is using a Scrum board and should assign multiple teams to the project to work on each phase of the project.",
    "choice_d": "The team should use velocity planning and display the work on a Kanban work.",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Kanban boards show the work of the project, not an iteration. Option C is not correct because it states they\u2019re using a Scrum board. Only one team working on one iteration at a time uses a Scrum board. Multiple teams can use a Kanban board, but not a Scrum board. Velocity planning is used in Scrum to determine how long it will take to complete the backlog.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      109,
      108,
      127,
      113,
      300
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "The team is using a Scrum board to show the work of the iteration."
  },
  {
    "id": 327,
    "question": "All of the following are true regarding a SAN except which one?",
    "choice_a": "A SAN manages data and files in a central location.",
    "choice_b": "A SAN provides fast access to data.",
    "choice_c": "A SAN is easy to set up and administer.",
    "choice_d": "A SAN is more expensive than a NAS.",
    "correct_answer": "C",
    "explanation": "A storage area network device requires extensive knowledge and experience to set up and maintain.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      36,
      38,
      39,
      40,
      41
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 328,
    "question": "You are preparing for an upcoming project status meeting and have prepared a written status report and agenda you will send out ahead of the meeting. At the meeting, you will discuss the items on the agenda, and you\u2019ve set aside time at the end for questions and answers. All of the following options are true regarding this scenario except for which one?",
    "choice_a": "The question-and-answer session is a type of asynchronous communication.",
    "choice_b": "The agenda and status report are a type of formal communication.",
    "choice_c": "The agenda should be timeboxed.",
    "choice_d": "The agenda and project status are written because they contain complex messages and a lot of information that isn\u2019t easy to convey verbally.",
    "correct_answer": "A",
    "explanation": "Synchronous communication happens in real time. A question-and-answer session happens in real time, so it is not asynchronous.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      253,
      255,
      230
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 329,
    "question": "You have received the following estimates for a complex activity that is critical to the success of your project. The three-point estimates are as follows: the most likely estimate is $42, the optimistic estimate is $35, and the pessimistic estimate is $54. What is the expected activity cost of this activity using the beta distribution formula (rounded to the nearest dollar)?",
    "choice_a": "49",
    "choice_b": "39",
    "choice_c": "43",
    "choice_d": "44",
    "correct_answer": "C",
    "explanation": "The expected activity cost using the three-point beta distribution formula (also known as PERT) is calculated this way: ((4 \u00d7 most likely) + optimistic + pessimistic) / 6. Therefore, the answer is ((4 \u00d7 42) + 35 + 54) / 6 = 43.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      198,
      200,
      199,
      201
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 330,
    "question": "You are part of an overall program consisting of three projects for a plumbing and electric company. The projects are implementing a CRM developed by a leading vendor in this space. The other two projects will be part of the CRM and involve developing text messages that inform customers the repair person is on the way and developing a customer survey to rank the service received. The text message and customer survey project are customizations that developers will need to make on the CRM platform. The governance processes for project management activities are well established in your organization. You are a project manager who works within this organization. Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "This is a PaaS cloud model.",
    "choice_b": "You report to the IT department.",
    "choice_c": "You report to the program manager.",
    "choice_d": "This is an SaaS cloud model.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "This question describes a PMO, which establishes governance processes for projects as well as providing tools, templates, and more for managing projects. As a project manager of one of three projects within this program, you report to the program manager. This is an example of a software as a service model. The CRM is already developed and provided by a vendor. There are customization options you can implement involving the text and survey projects, but these will be part of the CRM.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      57,
      53,
      6,
      28
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 331,
    "question": "This hierarchical chart displays the resources on the project starting with the project manager in the top box and team leads at the second level and resources under the team leads as the third level.",
    "choice_a": "Resource breakdown structure",
    "choice_b": "Project organization chart",
    "choice_c": "Organizational breakdown structure",
    "choice_d": "Responsibility assignment matrix",
    "correct_answer": "B",
    "explanation": "This question describes a project organization chart. The resource breakdown structure shows the work of the project according to the types of resources needed. An organizational breakdown structure shows the departments or work units and the work assigned to them. A RAM is not a hierarchical chart.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      244,
      159,
      161,
      26,
      140
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 332,
    "question": "Which document are you working on when you\u2019re decomposing the project deliverables?",
    "choice_a": "Scope statement",
    "choice_b": "Activity list",
    "choice_c": "Work breakdown structure",
    "choice_d": "Project schedule",
    "correct_answer": "C",
    "explanation": "The work breakdown structure is created by decomposing deliverables to a level where cost and time estimates can be performed.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      128,
      69,
      99,
      143,
      203
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 333,
    "question": "This agile methodology encourages team members to physically sit in proximity of one another. They use a technique that allows them to improve the quality of the code without changing its functionality. This is known as which of the following?",
    "choice_a": "This is a technique in the XP methodology known as test-driven development.",
    "choice_b": "This is a technique in the XP methodology known as refactoring.",
    "choice_c": "This is a technique in the FDD methodology known as pair programming.",
    "choice_d": "This is a technique in the FDD methodology known as refactoring.",
    "correct_answer": "B",
    "explanation": "This question describes the XP methodology and a technique known as refactoring.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      114,
      300,
      120,
      168,
      111
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 334,
    "question": "Your project requires working with external contractors to supply hardware for the project your development team is working on. The project is under a tight timeline and the hardware needs to be delivered and installed within the next few weeks. Your procurement department recommends which of the following to speed up the process?",
    "choice_a": "Contact vendors you\u2019ve used in the past and obtain bids for the hardware and installation.",
    "choice_b": "Use the prequalified vendor list to find a vendor who sells the equipment you need at their listed price.",
    "choice_c": "Use a time and materials contract to ensure the price of the equipment and the charges for installation remained fixed.",
    "choice_d": "Use the predetermined clients to obtain bids for the hardware and installation.",
    "correct_answer": "B",
    "explanation": "These vendors have already been vetted by the procurement department and will speed up the process if you use one of them.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      185,
      182,
      276,
      53,
      90
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 335,
    "question": "This development methodology allows for continuous requirements gathering and readily adapts to new and changing requirements.",
    "choice_a": "Hybrid",
    "choice_b": "Agile",
    "choice_c": "Waterfall",
    "choice_d": "PRINCE2",
    "correct_answer": "B",
    "explanation": "The agile methodology allows for continuous requirements gathering and easily adapts to new and changing requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      158,
      112,
      300,
      123
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 336,
    "question": "You are a project manager for a medium-sized project. Some of the stakeholders, not including the project sponsor, have asked to meet with you as a group. They tell you that they\u2019re not happy with the deliverables, even though the acceptance criteria for each requirement have been met. They want you to immediately kill the project because any further expenditure of resources would simply be throwing good money after bad. What do you tell them?",
    "choice_a": "That you\u2019ll close the project immediately.",
    "choice_b": "You ask for a few more days to see whether you can complete the remainder of the project.",
    "choice_c": "You tell them they\u2019re too far into the project and too many deliverables have been accepted to kill the project at this stage.",
    "choice_d": "You tell them the sponsor is the only one authorized to cancel the project prior to completion, and they should talk to the sponsor about this request.",
    "correct_answer": "D",
    "explanation": "Since the sponsor isn\u2019t involved in these conversations, you\u2019re not authorized to cancel the project until the sponsor tells you it\u2019s okay. You\u2019ll need to have the sponsor meet with the group and get to the bottom of their grievances and then take whatever action the sponsor requires.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      51,
      263,
      230,
      232
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 337,
    "question": "Your project involves developing a new sales application for your organization. The organization experiences seasonal bursts in sales requiring more computing power at certain times of the year. You recommend hosting the new application in the cloud so that the organization can take advantage of which of the following that the cloud provides?",
    "choice_a": "Robust reporting and analysis",
    "choice_b": "Fast access to data",
    "choice_c": "Cloud computing",
    "choice_d": "Rapid elasticity",
    "correct_answer": "D",
    "explanation": "Rapid elasticity allows the organization to grow or shrink their need for memory, power, storage, and more.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      49,
      40,
      41,
      36,
      37
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 338,
    "question": "You are in the process of determining the cost baseline. All of the following are used in the cost baseline except for which one?",
    "choice_a": "Management reserves",
    "choice_b": "Contingency reserves",
    "choice_c": "Human resource cost estimates",
    "choice_d": "Materials and equipment estimates",
    "correct_answer": "A",
    "explanation": "Management reserves are not part of the project cost budget or the cost baseline.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      84,
      70,
      206,
      149
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 339,
    "question": "By basing your cost estimates for the project on previous projects that are similar in size and scope to this one, which type of estimating are you using?",
    "choice_a": "Parametric modeling",
    "choice_b": "Analogous",
    "choice_c": "Bottom-up",
    "choice_d": "Expert judgment",
    "correct_answer": "B",
    "explanation": "Analogous estimating involves looking at previous projects in order to obtain a high-level picture of what a project might cost.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      198,
      142,
      201,
      199,
      200
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 340,
    "question": "All of the following options describe the SDLC methodology except for which one?",
    "choice_a": "SDLC consists of several phases such as planning, defining, designing, building, testing, and deploying.",
    "choice_b": "Waterfall and agile are types of SDLC.",
    "choice_c": "SDLC uses a step-by-step process in order to keep the requirements aligned with the objectives.",
    "choice_d": "SDLC helps teams deliver high-quality software.",
    "correct_answer": "C",
    "explanation": "SDLC is performed in phases, but not necessarily in a step-by-step fashion. Waterfall is step-by-step but agile is not. Waterfall and agile are both types of SDLC.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      106,
      133,
      123,
      300
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 341,
    "question": "Which of the following is a form of alternative dispute resolution?",
    "choice_a": "Negotiation",
    "choice_b": "Mediation",
    "choice_c": "Arbitration",
    "choice_d": "Claims administration",
    "correct_answer": "C",
    "explanation": "Arbitration is a form of alternative dispute resolution.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      277,
      216,
      315,
      6,
      88
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 342,
    "question": "You are developing your project schedule and have decided to use the PERT method to determine project duration. The estimates you\u2019ve gathered so far include the following: most likely is 1,040 hours, optimistic is 960 hours, and pessimistic is 1,120 hours. Which of the following is the correct PERT estimate?",
    "choice_a": "1126",
    "choice_b": "1000",
    "choice_c": "1080",
    "choice_d": "1040",
    "correct_answer": "D",
    "explanation": "PERT\u2019s expected value calculation is as follows: (optimistic + pessimistic + (4  most likely)) / 6. The calculation for this question looks like this: (960 + 1120 + (4  1040)) / 6 = 1040. Although PERT equals the most likely estimate in this example, that is not always the case.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      202,
      144,
      219,
      199,
      209
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 343,
    "question": "Your project has an initial investment of $75,000. Year one cash inflows are expected to be $18,000, year two $27,000, and year three $50,000. The cost of capital is 7 percent. What is the discounted cash flow for this investment?",
    "choice_a": "$77,551",
    "choice_b": "$68,779",
    "choice_c": "$6,221",
    "choice_d": "$81,221",
    "correct_answer": "D",
    "explanation": "Discounted cash flow sums the present value of each years\u2019 inflow and sums them. The initial investment is not used in this calculation. If you subtract the initial investment from the sum of the cash flows, you\u2019ve performed the net present value formula.<br>Present value calculation is: PV = FV / (1 + i)<sup><i>n</i></sup><br>Year one returns = $16,822 <br>Year two returns = $23,583 <br>Year three returns = $40,816 <br>The sum of these returns = $81,221.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      102,
      96,
      203,
      67
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 344,
    "question": "Your project budget for this period of work is $100,000. You have completed 60 percent of the work to date. What is the SPI?",
    "choice_a": "\u2013.60",
    "choice_b": "\u201340,000",
    "choice_c": ".60",
    "choice_d": "40,000",
    "correct_answer": "C",
    "explanation": "First you need to calculate earned value. EV is 60% of the $100,000 PV (or budget), which is $60,000. The formula for SPI is EV / PV, so the formula looks like this: 60,000/100,000 = .60.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      209,
      199,
      201,
      204
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 345,
    "question": "What is the critical path?<img src=\"/question_assets/Project+/BE2uf001.png\"/>",
    "choice_a": "A-B-E-C-H",
    "choice_b": "A-F-G-H",
    "choice_c": "A-B-C-D-E-F-G-H",
    "choice_d": "A-D-H",
    "correct_answer": "D",
    "explanation": "The critical path is the longest path on the project. Path A-D-H is 19 days, which is the longest full path on the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      141,
      210,
      147,
      91
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 346,
    "question": "Which of the following are true regarding agile project teams? (Choose two.)",
    "choice_a": "Scrum teams do not need to classify stakeholders because they work closely with them on a daily basis and know their interests and expectations.",
    "choice_b": "In a functional organization, you will likely need to negotiate with functional managers to get approval for team members to work on an agile team.",
    "choice_c": "When using hybrid and adaptive methodologies in a functional organization, it could be challenging to obtain resources because of the hierarchal structure and the inability for teams to be self-organized.",
    "choice_d": "Teams using the Kanban methodology work in short periods of time called iterations to produce small portions of work for the stakeholders to examine and determine if business value was created.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Classification of stakeholders should occur no matter what project management methodology you are using, so option A is incorrect. The work in Kanban is continuous; there are no iterations in Kanban.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      113,
      109,
      300,
      168
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 347,
    "question": "This document names the project manager and the project sponsor, and allows resources to be assigned to the project. Which of the following are true regarding this document? (Choose two.)",
    "choice_a": "This describes the feasibility study.",
    "choice_b": "This is created in the Discovery phase.",
    "choice_c": "This describes the project charter.",
    "choice_d": "This describes the preliminary scope statement.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "This question describes the project charter and is created in the Initiating phase.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      66,
      71,
      8,
      67,
      12
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "This is created in the Initiating phase."
  },
  {
    "id": 348,
    "question": "CPI is a quality performance measure that helps you know if the project is on track. You know that EV = 230, PV = 230, and AC = 250. What is the CPI?",
    "choice_a": "0",
    "choice_b": "\u201320",
    "choice_c": "1.08",
    "choice_d": ".92",
    "correct_answer": "D",
    "explanation": "The formula for CPI is EV / AC. Plugging in the numbers, you get 230 / 250 = .92.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      89,
      90,
      56
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 349,
    "question": "A project manager has the least amount of authority in which of the following type of organization?",
    "choice_a": "Projectized",
    "choice_b": "Functional",
    "choice_c": "Balanced matrix",
    "choice_d": "Strong matrix",
    "correct_answer": "B",
    "explanation": "The project manager has the least amount of authority in a functional organization.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      159,
      160,
      161,
      56,
      23
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 350,
    "question": "You are working on a large, complex project with a group of stakeholders who are actively involved in the project every step of the way. You have decided to use a life cycle methodology that produces deliverables every two weeks. Which type of life cycle does this describe?",
    "choice_a": "Agile",
    "choice_b": "Predictive",
    "choice_c": "Hybrid",
    "choice_d": "Plan-driven",
    "correct_answer": "A",
    "explanation": "The agile life cycle method, also known as the adaptive or change-driven method, produces deliverables in short time periods and the stakeholders are actively involved in all phases of the project.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      133,
      153,
      123,
      51,
      272
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 351,
    "question": "You are attending a meeting where each team member will discuss what they accomplished yesterday, what they plan to work on today, and what roadblocks are in their way. What is this meeting called and when does it occur? (Choose two.)",
    "choice_a": "It is called the print planning meeting.",
    "choice_b": "It is called the daily standup meeting.",
    "choice_c": "It occurs at the beginning of every sprint and shouldn\u2019t last longer than 15 minutes.",
    "choice_d": "It is called the retrospective meeting.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Daily standups are held daily to establish progress on the project. They are typically limited to 15 minutes in length and should occur at the same time every day.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      254,
      256,
      232,
      25
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "It occurs at the same time every day and shouldn\u2019t last longer than 15 minutes.",
    "choice_f": "It occurs at the end of every sprint and shouldn\u2019t last longer than 15 minutes."
  },
  {
    "id": 352,
    "question": "You are working on an agile project and wish to estimate the amount of time to complete the backlog using story points and velocity estimates. All of the following describe these concepts except which one?",
    "choice_a": "Story points are a unit of measure defined by the project team.",
    "choice_b": "Velocity reflects the speed at which the team is working.",
    "choice_c": "Velocity is used in Scrum.",
    "choice_d": "Story points are a unit of measure used to estimate the amount of time needed to complete a task.",
    "correct_answer": "D",
    "explanation": "Story points are used to estimate the amount of time needed to complete a user story, not a task.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      155,
      157,
      153,
      117,
      201
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 353,
    "question": "Equipment, materials, and supplies are considered this type of resource.",
    "choice_a": "Physical",
    "choice_b": "Low quality",
    "choice_c": "Benched",
    "choice_d": "Dedicated",
    "correct_answer": "A",
    "explanation": "Physical resources include equipment, materials, and supplies. The other options describe the qualities or characteristics of resources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      182,
      164,
      26,
      55
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 354,
    "question": "Which of the following statements are true regarding the iteration review meeting? (Choose three.)",
    "choice_a": "This meeting is a decision-making meeting.",
    "choice_b": "This meeting includes team members, the Scrum master, the product owner, customers, stakeholders, and management.",
    "choice_c": "This meeting occurs at the end of the sprint.",
    "choice_d": "This meeting includes the cross-functional team members, Scrum master, and product owner.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "Sprint review meetings are not decision-making meetings. Option D describes the team members present at the sprint retrospective meeting.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      119,
      253,
      254,
      255,
      120
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "This meeting may include a demonstration of functionality."
  },
  {
    "id": 355,
    "question": "Your research organization has an interest in offloading all their computing environment to the cloud. They frequently share information with others but need the research and data to remain private. Which type of cloud model should they use?",
    "choice_a": "Community cloud",
    "choice_b": "Public cloud",
    "choice_c": "Private cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "A",
    "explanation": "A community cloud is a form of private cloud that involves more than one tenant. This allows organizations to share resources and information with each other.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      41,
      40,
      49,
      36,
      38
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 356,
    "question": "Your project concerns producing a product that must meet a specific quality standard. You are periodically pulling completed components of the product and determining if the components have tolerable results. What technique are you using?",
    "choice_a": "Prevention",
    "choice_b": "Histogram",
    "choice_c": "Inspection",
    "choice_d": "Unit sampling",
    "correct_answer": "C",
    "explanation": "Inspection involves physically looking at the product results to determine if the results are tolerable. Prevention keeps errors from reaching the customers, histograms plot information on a bar chart, and unit sampling is not a valid option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      309,
      306,
      86,
      285,
      216
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 357,
    "question": "This is a type of acceptance criteria that provides specific measures that help determine if the project is on track and progressing as planned. They are documented in the scope statement.",
    "choice_a": "MVP",
    "choice_b": "EVM",
    "choice_c": "KPI",
    "choice_d": "ROI",
    "correct_answer": "C",
    "explanation": "Key performance indicators (KPIs) help determine whether the project is on track and provide specific measures to determine if the deliverables have met expectations. Minimally viable product (MVP) is a prototype of the product. KPIs may include earned value management (EVM) results or return on investment (ROI), but the calculations themselves are not a KPI unless documented in the scope statement.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      89,
      320,
      88,
      209,
      211
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 358,
    "question": "A risk owner has informed you of a risk trigger that\u2019s just occurred. The risk event has negative consequences. You can use all of the following strategies to respond to this type of risk except which ones? (Choose two.)",
    "choice_a": "Exploit",
    "choice_b": "Share",
    "choice_c": "Accept",
    "choice_d": "Mitigate",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The strategies for negative risk events include accept, mitigate, transfer, and avoid. Exploit and share are examples of strategies to use for positive risk events.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      222,
      215,
      216,
      219,
      220
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Avoid"
  },
  {
    "id": 359,
    "question": "You work in a highly competitive industry, and the secret sauce recipe for your burger is what differentiates you from others. This recipe is highly guarded and only certain individuals at corporate headquarters know the specific ingredients that go into the sauce. Your project involves replacing some kitchen equipment that must meet certain specifications so as not to overcook the sauce. The recipe itself will not be revealed to the vendors, but some portions or instructions regarding the recipe may have to be revealed in order to ensure the equipment standards are up to par. The bid process is complete, and you are narrowing down the process to three vendors. You will meet with each vendor separately to see a demo of their equipment at their site, and some specifications about the recipe may need to be revealed to them during these visits. What will you do to ensure protection of the secret sauce recipe?",
    "choice_a": "Ask the vendors to sign an NDA before you visit their site and before the demonstrations begin.",
    "choice_b": "Ask the vendors for documented references ensuring their trustworthiness.",
    "choice_c": "Ask the vendors to demonstrate the equipment and refuse to answer any questions about your recipe specifications.",
    "choice_d": "Ask the vendors for their technical approach outlining past projects with a similar approach and how they kept trade secrets secure.",
    "correct_answer": "A",
    "explanation": "You should ask the vendor to sign a nondisclosure agreement. The other options offer no recourse if the secret is leaked.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      185,
      72,
      62,
      51,
      272
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 360,
    "question": "You work for a program manager in the PMO. You\u2019re working on a project to implement a records management system that is a cloud application developed by a well-known vendor. One of the functions of this system will help identify the types of records such as personnel records and construction diagrams, and another function identifies how long the records should be kept before disposal. Which of the following are true regarding this question? (Choose three.)",
    "choice_a": "The life cycle management of records are defined in the records management system.",
    "choice_b": "This describes a records classification function.",
    "choice_c": "This describes the retention period function.",
    "choice_d": "This describes the disposition procedures.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "A records management plan describes the policies involved to manage the records, and the records management system manages the records according to the plan. The disposition procedures are documented in the records management plan.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      12,
      9,
      69,
      188
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "The PII data in the personnel records should be shredded at disposal."
  },
  {
    "id": 361,
    "question": "From the following options, select those that best describe the definition of an objective. (Choose three.)",
    "choice_a": "Marks the completion of a project phase",
    "choice_b": "Describes measurable outcomes or results",
    "choice_c": "Is a specific item that must be produced to consider the project complete",
    "choice_d": "Is easy to understand",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Objectives are clear (easy to understand), measurable, and actionable. They are not used to describe detailed characteristics of the project. This is documented in the scope statement in the form of deliverables and requirements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      64,
      69,
      99,
      68
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Is actionable",
    "choice_f": "Describes detailed characteristics of the project"
  },
  {
    "id": 362,
    "question": "Governance gates include which of the following? (Choose three.)",
    "choice_a": "Deliverable approvals",
    "choice_b": "Client sign-off",
    "choice_c": "Milestone approval",
    "choice_d": "Management approval",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "Governance gates are included on the project schedule to account for client sign-off, management approval, and legislative approval.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      132,
      149,
      12,
      84
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "KPI approvals",
    "choice_f": "Legislative approval"
  },
  {
    "id": 363,
    "question": "Which of the following describes the difference between product and project change?",
    "choice_a": "Product change always brings about project change.",
    "choice_b": "Project change always brings about product change.",
    "choice_c": "Product change involves changes to project scope.",
    "choice_d": "Product change costs more than project change.",
    "correct_answer": "A",
    "explanation": "Project change does not always bring about product change. Product change involves changes to the product of the project, not to the project scope. Product change does not necessarily cost more than project change. This is dependent on the type of change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      288,
      279,
      87,
      281,
      91
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 364,
    "question": "You are evaluating proposals from three vendors for a new CRM system. You are specifically focusing on how the vendors will go about implementing the solution. It is critical that their process and techniques will work best for your organization. Which of the following vendor evaluation techniques does this describe?",
    "choice_a": "Physical capacity",
    "choice_b": "Cost\u2013benefit",
    "choice_c": "Qualifications",
    "choice_d": "Market research",
    "correct_answer": "E",
    "explanation": "This question describes technical approach.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      185,
      121,
      58,
      15,
      61
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Technical approach",
    "choice_f": "Competitive analysis"
  },
  {
    "id": 365,
    "question": "Which options accurately describe their development life cycle management methodology? (Choose two.)",
    "choice_a": "Using a hybrid approach, after the project plan is documented and approved, any changes that impact scope, time or budget during development are controlled and minimized.",
    "choice_b": "Progressive elaboration of scope occurs based on continuous feedback in short periods of time in a highly adaptive methodology.",
    "choice_c": "High-level or semi-detailed plans are developed at the beginning of the project and further elaborated once the project progresses in a hybrid methodology.",
    "choice_d": "Using a predictive approach, scope is progressively elaborated based on continuous feedback in short periods of time.",
    "correct_answer": "E",
    "explanation": "Option A does not describe a hybrid approach. This option says the project plan was documented and approved, which would have been done using a waterfall approach. The hybrid part of the project would be the development phase, and scope, time, and budget are fluid and subject to change during the iterations. Option D describes waterfall. The predictive approach documents all of the project scope up front. Continuous feedback in short periods of time occur in an agile environment.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      113,
      133,
      107,
      106,
      158
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "B, C"
  },
  {
    "id": 366,
    "question": "Which of the following is the stage of team development where team members are released?",
    "choice_a": "Performing",
    "choice_b": "Adjourning",
    "choice_c": "Releasing",
    "choice_d": "Transitioning",
    "correct_answer": "B",
    "explanation": "Adjourning is the stage in team development where team members are released. The other stages of team development are forming, storming, norming, and performing.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      172,
      173,
      174,
      335,
      245
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 367,
    "question": "This is an on-demand scheduling methodology that is described as a pull-based system. The work is balanced against available resources. Which of the following options are true regarding the methodology this question describes? (Choose two.)",
    "choice_a": "This is known as a lean methodology.",
    "choice_b": "The work of the project is balanced against available resources and is not time boxed.",
    "choice_c": "There is only one product owner in this methodology who pulls user stories from one column to the next as resources are available.",
    "choice_d": "This describes Kanban which can involve more than one development team working from their own Kanban board.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Kanban is a pull system (as is Scrum), and may have more than one product owner, and more than one project team working on the product. However, all teams work from the same Kanban board. The work is performed as there are resources available.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      109,
      108,
      113,
      300,
      133
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "This describes Kanban and requirements on the Kanban board may be known as stories, tasks, or cards."
  },
  {
    "id": 368,
    "question": "Agile team members are collocated, self-directed, and self-managed. As such, which of the following types of communication do they use most often to communicate among the team? (Choose two.)",
    "choice_a": "Presentations",
    "choice_b": "Formal communication",
    "choice_c": "JAD sessions",
    "choice_d": "Informal communication",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "Agile teams work closely together, face to face. In-person, real-time information exchange is synchronous and informal.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      233,
      120,
      228,
      181,
      241
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Synchronous"
  },
  {
    "id": 369,
    "question": "These are large units of work on an agile project that reflect a business requirement or functionality that isn\u2019t well known. What does this describe?",
    "choice_a": "User story",
    "choice_b": "Story point",
    "choice_c": "Epic",
    "choice_d": "Backlog",
    "correct_answer": "C",
    "explanation": "Epics are placeholders that are used to capture ideas for business requirements or functionality that isn\u2019t fully known yet. They are then decomposed into user stories as more information becomes known.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      153,
      117,
      108,
      157,
      127
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 370,
    "question": "You are defining the section in the project charter that describes how the stakeholders will determine whether the deliverables of the project are acceptable and satisfactory. What does this describe?",
    "choice_a": "Success criteria",
    "choice_b": "Milestones",
    "choice_c": "Project objectives",
    "choice_d": "Project description",
    "correct_answer": "A",
    "explanation": "Success criteria describe how the stakeholders will determine if the project is acceptable and satisfactory.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      67,
      69,
      66,
      122,
      327
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 371,
    "question": "Which schedule format shows the duration of a task on a horizontal timeline, along with milestones and resource assignments?",
    "choice_a": "PERT",
    "choice_b": "Gantt",
    "choice_c": "Milestone chart",
    "choice_d": "Burndown chart",
    "correct_answer": "B",
    "explanation": "A Gantt chart shows a task on a horizontal timeline. Dependencies are shown as well as milestones. Gantt charts are useful for providing a visual image of how long each task will take to complete. PERT charts are a type of network diagram and show the activities in order of precedence, but they are not on a timeline.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      146,
      145,
      138,
      152,
      310
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 372,
    "question": "This EVM technique tells you whether your costs are higher than budgeted or lower than budgeted. It measures the actual performance to date against what\u2019s been spent.",
    "choice_a": "CPI",
    "choice_b": "CV",
    "choice_c": "EV",
    "choice_d": "PI matrix",
    "correct_answer": "B",
    "explanation": "The cost variance EVM technique measures the cost performance to date for the project and tells you whether your costs are higher or lower than budgeted.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      209,
      211,
      214,
      198
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 373,
    "question": "The Closing phase addresses which of the following? (Choose three.)",
    "choice_a": "Project sign-off",
    "choice_b": "Lessons learned",
    "choice_c": "Governance processes",
    "choice_d": "Change control closeout",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "The Closing process is where the integration plan and transition of the product of the project to other areas of the organization is performed. Lessons learned, project sign-off, close contracts, releasing resources, and archiving documents occur during this process as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      11,
      325,
      7,
      12,
      10
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Integration plan is put into place.",
    "choice_f": "Deliverables verification"
  },
  {
    "id": 374,
    "question": "Your project budget for this period of work is $200,000. AC to date are $90,000 and you have completed 40 percent of the work to date. What is the SPI?",
    "choice_a": "\u2013120,000",
    "choice_b": ".45",
    "choice_c": ".88",
    "choice_d": ".40",
    "correct_answer": "D",
    "explanation": "First you need to calculate earned value. EV is 40% of the $200,000 PV (or budget), which is $80,000. The formula for SPI is EV / PV, so the formula looks like this: 80,000 / 200,000 = .40.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      209,
      210,
      199,
      201
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 375,
    "question": "The project manager and project team are responsible for determining which aspects of the development methodology will work best for the project and the organization. Which of the following is true about this question? (Choose two.)",
    "choice_a": "This describes a predictive life cycle approach.",
    "choice_b": "You should consider the size and complexity of the project to determine which aspects of each methodology are appropriate.",
    "choice_c": "This describes a hybrid development life cycle.",
    "choice_d": "This is called tailoring.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "This describes tailoring, which is the process of determining which processes within each process group are appropriate for the project. You should consider the size and complexity of the project and the various inputs and outputs of each of the processes when determining which processes to implement and perform.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      6,
      129,
      131,
      87,
      169
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 376,
    "question": "You\u2019re the new director of the PMO. You\u2019ve noticed several tasks and inefficiencies in the processes established by the old PMO director. One of the ways your project managers could be more effective is by eliminating the need for approvals for all task completions. Which methodology does this question describe?",
    "choice_a": "This question describes Kanban, a lean thinking methodology.",
    "choice_b": "This question describes Kaizen, a lean thinking methodology.",
    "choice_c": "This question describes PRINCE2, a lean thinking methodology.",
    "choice_d": "This question describes Scrum, a lean thinking methodology.",
    "correct_answer": "B",
    "explanation": "This question describes Kaizen, a lean thinking methodology. PRINCE2 is a project management methodology; Kanban and Scrum are agile methodologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      112,
      300,
      57,
      123
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 377,
    "question": "What are the three types of variances that make up common causes of variances? (Choose three.)",
    "choice_a": "Random",
    "choice_b": "Tolerable",
    "choice_c": "Trends",
    "choice_d": "Known or predictable",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "The three types of variances that make up common causes of variance are random variances, known or predictable variances, and variances that are always present in the process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      312,
      210,
      285,
      6,
      137
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Acceptable",
    "choice_f": "Variances that are always present"
  },
  {
    "id": 378,
    "question": "This chart plots the remaining work for the sprint time period on the horizontal axis and the backlog items (in work effort time) on the vertical axis.",
    "choice_a": "Burnup chart",
    "choice_b": "Velocity chart",
    "choice_c": "Histogram chart",
    "choice_d": "Burndown chart",
    "correct_answer": "D",
    "explanation": "A burndown chart shows the remaining work effort for a sprint. It plots the sprint time period on the horizontal axis and the backlog items (in work effort time) on the vertical axis. A burnup chart shows the completed work to date.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      267,
      154,
      322,
      266,
      213
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 379,
    "question": "You are working on a change that involves workflow processes for the checkout procedure for fleet vehicles. This will be a transformational change and allow employees to use an app to check out fleet vehicles and record important information such as mileage and fuel levels right on the app. What type of change does this question describe?",
    "choice_a": "Infrastructure change",
    "choice_b": "Business process change",
    "choice_c": "Software change",
    "choice_d": "Contract change",
    "correct_answer": "B",
    "explanation": "This describes a business process change.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      289,
      17,
      100,
      292,
      291
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 380,
    "question": "Which of the following options are project management life cycle phases? (Choose three.)",
    "choice_a": "Risk",
    "choice_b": "Initiating",
    "choice_c": "Discovery",
    "choice_d": "Procurement",
    "correct_answer": [
      "B",
      "C",
      "F"
    ],
    "explanation": "The five project management life cycle phases are Discovery/Concept, Initiating, Planning, Executing, and Closing. Options A, D, and E are activities performed within the life cycle phases.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      106,
      133,
      123,
      6
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Scope",
    "choice_f": "Planning"
  },
  {
    "id": 381,
    "question": "This is the process of aggregating all of the cost estimates and establishing a cost baseline for the project.",
    "choice_a": "Cost estimating",
    "choice_b": "Cost control",
    "choice_c": "Cost tracking",
    "choice_d": "Resource estimating",
    "correct_answer": "A",
    "explanation": "Cost estimating is the process of aggregating the cost estimates and establishing a cost baseline for the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      84,
      132,
      70,
      94
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 382,
    "question": "You are reviewing project results to see if they comply with the standards documented in its associated management plan and then making changes to remove unacceptable elements. What does this describe?",
    "choice_a": "Quality control",
    "choice_b": "Post-project review",
    "choice_c": "Verification and validation",
    "choice_d": "Lessons learned",
    "correct_answer": "A",
    "explanation": "This question describes quality control. Quality standards are documented in the quality management plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      306,
      309,
      285,
      312,
      304
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 383,
    "question": "Resources are typically in limited supply. Which of the following assures that scarce resources are scheduled for the right tasks at the right time?",
    "choice_a": "Resource management plan",
    "choice_b": "Resource assignment plan",
    "choice_c": "Resource interproject dependencies plan",
    "choice_d": "Resource allocation plan",
    "correct_answer": "D",
    "explanation": "The resource allocation plan ensures that the right resources are identified, that they have the right skills and abilities, and that they are scheduled at the right time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      140,
      26,
      163,
      164,
      169
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 384,
    "question": "Which of the following describes the minimum viable product?",
    "choice_a": "It is a prototype of the final product.",
    "choice_b": "It should be created with the least effort possible.",
    "choice_c": "It allows the customer to validate whether business value and project needs are being met.",
    "choice_d": "It allows the project team to adapt the product based on feedback received.",
    "correct_answer": "E",
    "explanation": "Creating the minimum viable product is like creating a prototype or mock-up. It should take the least effort possible, allows the customer to validate whether the business value is being met, and allows the project team to adapt the product based on the feedback received.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      264,
      19,
      14,
      9,
      10
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "All of the above."
  },
  {
    "id": 385,
    "question": "All of the following are factors that influence communication except for which one?",
    "choice_a": "Differing time zones",
    "choice_b": "Cultural differences",
    "choice_c": "Technology barriers",
    "choice_d": "Stakeholder changes",
    "correct_answer": "D",
    "explanation": "Stakeholder changes are a communication trigger.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      247,
      272,
      251,
      248,
      246
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 386,
    "question": "This type of document outlines the performance expectations of each party. It\u2019s used when a contract isn\u2019t a viable option.",
    "choice_a": "KPP",
    "choice_b": "SLA",
    "choice_c": "MOU",
    "choice_d": "SOW",
    "correct_answer": "C",
    "explanation": "A memorandum of understanding (MOU) is used to define performance expectations between parties. Government entities use these documents often when dealing with other agencies because contracts are not a viable option. KPP is a key performance parameter, SLA is a service level agreement, and SOW is a statement of work.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      86,
      271,
      276,
      323
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 387,
    "question": "This agile methodology relies heavily on feedback from the end user and uses an approach whereby code is released by pair programmers and is tested rigorously at each release. Which of the following is true regarding this question?",
    "choice_a": "This is a technique in the Kanban methodology known as test-driven development whereby the story card is not moved forward on the board until it passes all tests.",
    "choice_b": "This is a technique in the XP methodology known as test-driven development whereby each test is run against the entire program at every release.",
    "choice_c": "This is a technique in the FDD methodology known as refactoring that is based on releasing code in frequent cycles that is tested rigorously during each iteration and again at the completion of an agreed upon number of iterations.",
    "choice_d": "This is a technique in the DSDM methodology known as refactoring that is based on releasing code in frequent cycles that is tested rigorously during each iteration and again at the completion of an agreed upon number of iterations.",
    "correct_answer": "B",
    "explanation": "This question describes the test-driven approached used in the XP methodology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      107,
      158,
      118,
      117
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 388,
    "question": "Your team members are using an agile methodology to conduct the project. The product owner has been working on a task to put the user stories in order of importance and expects this to take the remainder of the day. The first iteration will start tomorrow. Which options are true regarding this question? (Choose two.)",
    "choice_a": "The team will participate in the sprint planning meeting tomorrow and prioritize the user stories chosen by the product owner in order of importance.",
    "choice_b": "The product owner is working on the backlog prioritization to put the user stories in order of importance.",
    "choice_c": "The product owner is working on developing and prioritizing epics prior to the start of the iteration.",
    "choice_d": "The team is working to develop story points and velocity estimates so the Scrum master can construct a burndown chart.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "This question describes backlog prioritization, which is performed by the product owner. It also describes the sprint planning meeting that occurs at the beginning of the sprint. This is where the product owner pulls user stories from the backlog for the team to work on. The user stories are already prioritized by the product owner, not the team.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      119,
      157,
      108,
      158
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "The product owner will pull user stories for the team to work on at the sprint planning meeting tomorrow."
  },
  {
    "id": 389,
    "question": "This positive risk strategy looks for opportunities to take advantage of positive impacts to the project if the risk event occurs.",
    "choice_a": "Exploit",
    "choice_b": "Contingency",
    "choice_c": "Enhance",
    "choice_d": "Share",
    "correct_answer": "A",
    "explanation": "Exploit is a positive risk response strategy that looks for opportunities to take advantage of the positive impacts of a potential risk event.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      215,
      220,
      219,
      216
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 390,
    "question": "Your project concerns developing a new software app that tracks employee\u2019s expense. There are several modules involved in this system that work together to produce the final expense report; one of them allows employees to take pictures of their receipts to include with their final expense report. You have just completed unit testing. Which test will you perform next?",
    "choice_a": "Regression",
    "choice_b": "End-to-end",
    "choice_c": "Integration",
    "choice_d": "User acceptance",
    "correct_answer": "C",
    "explanation": "Integration testing combines software modules and tests them as a group. This may also involve testing programs or modules that need to interact with one another. An integration test typically occurs after unit testing is completed.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      58,
      110,
      50,
      309,
      6
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 391,
    "question": "During the budgeting process, you may set aside a certain amount of funds to cover the cost of possible adverse events to the project, including the potential to deal with impacts from unknown risks. These costs are included in the project budget. They are known as which of the following?",
    "choice_a": "Management reserves",
    "choice_b": "Prevention costs",
    "choice_c": "Contingency reserves",
    "choice_d": "Control limits",
    "correct_answer": "C",
    "explanation": "Contingency reserves and management reserves are monies set aside to deal with the cost of possible adverse events on the project. Management reserves are not included in the budget or the cost baseline.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      205,
      209,
      274,
      214,
      210
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 392,
    "question": "Some of the tools you might use to analyze the impacts and responses to change include all of the following except which one?",
    "choice_a": "SMART analysis",
    "choice_b": "Focus groups",
    "choice_c": "Monte Carlo analysis",
    "choice_d": "Polling and surveys",
    "correct_answer": "A",
    "explanation": "Option A describes the acronym for defining goals. SMART stands for specific, measurable, attainable, realistic, and time bound. Monte Carlo analysis is a what-if analysis technique and is appropriate to use to determine impacts and responses of change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      221,
      290,
      292,
      219,
      17
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 393,
    "question": "You have proposed a new, high-risk project for your company that will significantly expand its production capabilities. Your company is willing to take risks, encourages learning new things, and encourages an atmosphere of communication, collaboration, and continual improvement. Project teams are always collocated and provided with the best and newest technology to assist them in planning iterations and developing code. They are also willing to learn from their mistakes and make changes to the processes as needed to ensure a quality product and high-performing team. This question describes several of the criteria for choosing a methodology. The following options are criteria for choosing a methodology except for which two? (Choose two).",
    "choice_a": "Environmental factors",
    "choice_b": "Culture",
    "choice_c": "Focus on the value to customers",
    "choice_d": "Tolerance for change",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Criteria for selecting a methodology include environmental factors (described as willingness to take risks and collocating team members in the question or geography), culture (described as a culture of learning, communication, collaboration), and tolerance for change (described as continual improvement and willingness to make changes). Option C is the key concept behind the <i>Agile Manifesto, </i>and option E describes the Kaizen methodology. It is not a selection criterion. Requirements, budget, schedule, developmental factors, and industry standards are the other selection criteria not mentioned in this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      112,
      111,
      28,
      50,
      51
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Continuous improvement"
  },
  {
    "id": 394,
    "question": "Infrastructure changes typically involve three stages, including development, testing, and release to the environment where the end users can access the change. Which of the following is the name of the testing environment, according to CompTIA?",
    "choice_a": "Sandbox",
    "choice_b": "Test",
    "choice_c": "Development",
    "choice_d": "Beta-staging",
    "correct_answer": "D",
    "explanation": "CompTIA calls the test environment the beta-staging environment.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      298,
      297,
      299,
      36,
      37
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 395,
    "question": "What is the critical path in the following?<img src=\"/question_assets/Project+/pe2_02.png\"/>",
    "choice_a": "51",
    "choice_b": "24",
    "choice_c": "33",
    "choice_d": "27",
    "correct_answer": "C",
    "explanation": "The critical path is path A-D-E and is 33 days in duration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      141,
      210,
      147,
      127
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 396,
    "question": "You are preparing to have performance reviews with your team members. All of the following are appropriate except for which one?",
    "choice_a": "Determine rewards for superior performance.",
    "choice_b": "Review performance expectations and specify new expectations for the next performance review.",
    "choice_c": "Outline specific consequences for poor behavior that has not been corrected since the last discussion with the team member on this topic.",
    "choice_d": "Provide feedback about inadequate performance behaviors that occurred months ago for the first time.",
    "correct_answer": "D",
    "explanation": "Performance feedback, particularly when it\u2019s negative, should be given in a timely fashion. This project has been underway for more than nine months. Bringing up a situation from early in the project for the first time months later is not an effective way to help team members correct their behaviors.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      174,
      173,
      245,
      230,
      25
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 397,
    "question": "These project participants contribute expertise to the project, contribute deliverables according to the schedule, estimate task durations, estimate costs, and determine dependencies.",
    "choice_a": "IT architect, developer, and QA/tester",
    "choice_b": "Program manager",
    "choice_c": "Subject matter experts",
    "choice_d": "Key stakeholders",
    "correct_answer": "C",
    "explanation": "The project team members are responsible for contributing expertise to the project, contributing deliverables according to the schedule, estimating task durations, estimating costs, and determining dependencies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      140,
      137,
      201,
      142
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 398,
    "question": "You believe your project costs are in control. You know the total budget for the project is $850. You have spent $795 for this period of performance, and the value of the work you have completed to date is $800. What is the CV?",
    "choice_a": "5",
    "choice_b": "1.0",
    "choice_c": "\u20135",
    "choice_d": ".99",
    "correct_answer": "A",
    "explanation": "CV is calculated this way: EV \u2013 AC or 800 \u2013 795 = 5.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      209,
      210,
      205,
      199,
      201
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 399,
    "question": "You are new to your organization and have been tasked with managing the backlog, prioritizing the backlog, and updating stakeholders with team progress. What is your role known as?",
    "choice_a": "Product owner",
    "choice_b": "Scrum master",
    "choice_c": "Sprint owner",
    "choice_d": "Project manager",
    "correct_answer": "A",
    "explanation": "The product owner is responsible for prioritizing the backlog and communicating with the project stakeholders.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      108,
      51,
      272
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 400,
    "question": "This type of contract bears the most risk to the seller.",
    "choice_a": "Cost reimbursable",
    "choice_b": "Time and materials",
    "choice_c": "Cost reimbursable plus incentive",
    "choice_d": "Fixed price",
    "correct_answer": "D",
    "explanation": "Fixed-price contracts are riskiest to the seller.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      216,
      219,
      220,
      24
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 401,
    "question": "Your project concerns developing a new software app that tracks employees\u2019 expenses. There are several modules involved in this system that work together to produce the final expense report; one of them allows employees to take pictures of their receipts to include with the final expense report. You have just completed several rounds of testing and will now ask the project stakeholders to perform their test. What is this testing called?",
    "choice_a": "Regression",
    "choice_b": "End-to-end",
    "choice_c": "Integration",
    "choice_d": "User acceptance",
    "correct_answer": "D",
    "explanation": "User acceptance testing is performed by the people who will use the system. They will test all functionality for adherence to requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      51,
      50,
      58,
      89
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 402,
    "question": "A task that must finish before the next task begins is known as which of the following? (Choose two.)",
    "choice_a": "Successor",
    "choice_b": "FF relationship",
    "choice_c": "SF relationship",
    "choice_d": "Predecessor",
    "correct_answer": [
      "D",
      "F"
    ],
    "explanation": "A predecessor task is one that comes before another task. A finish-to-start (FS) relationship is the most common type of logical relationship and says that the first task must finish before the next task can start.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      144,
      136,
      140,
      142
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Dependency",
    "choice_f": "FS relationship"
  },
  {
    "id": 403,
    "question": "You are working on software development project and wish to use a methodology that helps improve the quality of the code and the pace of delivery. The team will check the code into a central repository and the system will perform automated build and test processes. This process is also used to make programming changes. Which of the following methodologies does this describe?",
    "choice_a": "Lean",
    "choice_b": "Hybrid",
    "choice_c": "Pair-programming",
    "choice_d": "Continuous integration",
    "correct_answer": "D",
    "explanation": "This question describes continuous integration, which allows small segments of code or changes to be introduced on a frequent basis.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      110,
      104,
      113,
      123,
      309
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 404,
    "question": "Which of the following can be used as a quantitative, risk analysis technique to estimate potential outcomes for multiple scenarios related to cost and schedule risks?",
    "choice_a": "Quantitative analysis",
    "choice_b": "Qualitative analysis",
    "choice_c": "Situational/scenario analysis",
    "choice_d": "Monte Carlo analysis",
    "correct_answer": "D",
    "explanation": "Monte Carlo is a simulation technique, used most often for cost and schedule risk, that helps estimate outcomes for multiple scenarios. Monte Carlo is also a quantitative risk analysis technique, but this question asks specifically about producing multiple estimates, which describes Monte Carlo analysis.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      221,
      219,
      202,
      226,
      216
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 405,
    "question": "Which of the following options describe the role of the project sponsor? (Choose two.)",
    "choice_a": "Writes the project charter",
    "choice_b": "Appoints team members",
    "choice_c": "Approves and signs the project charter",
    "choice_d": "Is the final decision maker on the project",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The project sponsor approves and signs the project charter and serves as the final decision maker on the project. Generally, the project manager is responsible for all the other tasks listed in the options.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      56,
      57,
      88,
      52
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Develops the project budget and schedule"
  },
  {
    "id": 406,
    "question": "You are documenting issues in the issue log and need to work with the team to determine prioritization of the issues. All of the following are used to help determine priority except for which one?",
    "choice_a": "Root cause analysis helps to determine the severity of the impact of the issue.",
    "choice_b": "Urgency will help determine how quickly actions need to be taken to mitigate the issue.",
    "choice_c": "The amount of contingency reserves available for mitigation will help determine priority.",
    "choice_d": "The scope of the impact to the organization will help determine priority based on predetermined criteria related to schedule and budget, among others.",
    "correct_answer": "C",
    "explanation": "The amount of contingency reserves does not influence priority. These are funds available to help mitigate risks and issues that were unplanned, unknown, or exceeded estimates needed to resolve the issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      317,
      220,
      219,
      205,
      151
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 407,
    "question": "You are working on procuring a vendor to assist with the project. The legal department has recommended you use a contract that reimburses the seller\u2019s allowable costs and builds in a bonus based on the vendor achieving the performance criteria they\u2019ve outlined in their memo. Which of the following contract types will you use?",
    "choice_a": "CPIF",
    "choice_b": "CPAF",
    "choice_c": "CPPC",
    "choice_d": "CPFF",
    "correct_answer": "A",
    "explanation": "The cost plus incentive fee contract reimburses the seller for the seller\u2019s allowable costs and includes an incentive or bonus for exceeding the performance criteria laid out in the contract.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      209,
      276,
      89,
      200,
      199
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 408,
    "question": "You are working on a project that involves developing an autonomous vehicle that will shuttle students between seven stops on a predetermined route on campus. You don\u2019t know much about the requirements for this project and understand that they will be discovered as the project progresses. You want to avoid the surprised stakeholder effect and decide to deliver business value incrementally using a minimum viable product throughout the project. This will ensure immediate feedback from the stakeholders and the ability to make corrections as you go. What does this describe?",
    "choice_a": "JAD sessions",
    "choice_b": "Agile methodology",
    "choice_c": "QFD sessions",
    "choice_d": "Hybrid methodology",
    "correct_answer": "B",
    "explanation": "This question describes the agile methodology. Delivering business value incrementally, discovering requirements as the project progresses, and active participation by the stakeholders are all characteristics of an agile approach.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      158,
      118,
      153,
      51,
      60
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 409,
    "question": "Which of the following options correctly describes meetings that are categorized as decisive?",
    "choice_a": "Workshops and JAD sessions",
    "choice_b": "Brainstorming meetings and focus groups",
    "choice_c": "Project status meetings and standups",
    "choice_d": "Refinement meetings and project steering committee meetings",
    "correct_answer": "D",
    "explanation": "Options A and B describe collaborative meetings, and option C describes informative meetings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      255,
      254,
      261,
      256
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 410,
    "question": "Your IT department is undergoing a reorganization. The development team adheres to a tailored version of SDLC that works well for the team. The infrastructure team has a project manager embedded in the team to help manage their priorities. You\u2019ve heard rumors that several projects have come in behind schedule and there is a lack of coordination and communication among the various teams within the IT department. One team or another has consistently been left out of important project meetings and IT needs to improve collaboration and delivery times to the end user. You suspect the IT manager may be doing which of the following?",
    "choice_a": "Setting up a Kaizen exercise",
    "choice_b": "Setting up pair-programming teams",
    "choice_c": "Setting up a DevOps team",
    "choice_d": "Setting up a test-driven approach to development",
    "correct_answer": "C",
    "explanation": "This question describes issues that arise when the development and operations teams (also known as an infrastructure team as stated in this question) are separated and report to different managers. Setting up a DevOps team will improve collaboration, delivery times, communication, and efficiencies among the team. No one will be left out of important project meetings going forward. A Kaizen exercise may help identify some of the waste, but the question does not describe this as an issue. Options B and D are extreme programming techniques for development teams.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      120,
      168,
      245,
      232
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 411,
    "question": "You have been assigned as project manager for an important project to your organization. Brett is the functional manager who will give you the human resources for your team. However, Brett is forced to supply resources to several concurrent projects. You have a \u201cdream-team\u201d list of the people you want assigned to your team, but you\u2019re worried other project managers may want these same people. What does this situation best represent?",
    "choice_a": "Interproject resource contention",
    "choice_b": "Resource overallocation",
    "choice_c": "Shared resources",
    "choice_d": "Interproject dependencies",
    "correct_answer": "A",
    "explanation": "The best answer to this question is interproject resource contention. The key to this question is that the same resources are available for differing projects. Overallocation occurs when resources are assigned to more tasks than they can physically complete within the time frame given. Shared resources could apply here, but the resources are in contention for multiple projects. Interproject dependencies doesn\u2019t relate to resources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      164,
      163,
      160,
      26,
      148
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 412,
    "question": "Your town experienced a devastating tornado, and it destroyed your organization\u2019s office building. Which of the following plans should you refer to, and what is the tornado known as in this scenario? (Choose two.)",
    "choice_a": "Business continuity response plan",
    "choice_b": "Incident response plan",
    "choice_c": "This is a communication trigger.",
    "choice_d": "This is a factor that influences communication.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The business continuity response plan is a communication trigger. It describes how the business will continue operating, where employees should report for work, emergency contact information, and more. An incident response plan describes how to respond to a single incident, or one that impacts only a portion of the business.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      249,
      51,
      232,
      271,
      317
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 413,
    "question": "Your project involves a digital transformation for your organization, and you are using agile development methodologies to implement a new ERDMS system. This requires some documents that exist on paper to be scanned into the new system. The new system will automate data workflow processes. In addition, some of the project team members will be working on the processes for entering, storing, and securing the data in this new system. All of the following are actions the team should take regarding this project except which one?",
    "choice_a": "Perform situational/scenario-based risk analysis because this is a new project and it involves digital transformation.",
    "choice_b": "Use Monte Carlo analysis to determine probability and impact.",
    "choice_c": "Create a digital security policy.",
    "choice_d": "Create a data security policy.",
    "correct_answer": "B",
    "explanation": "Monte Carlo analysis is a what-if scenario, simulation tool typically used to assess cost and schedule risk. Monte Carlo does not determine probability and impact.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      219,
      221,
      72,
      74,
      293
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Perform risk analysis at the beginning of each iteration."
  },
  {
    "id": 414,
    "question": "You have created the project schedule and it has been baselined, approved, and published. Later in the project, an approved change has made its way through the change control board. This change will impact the schedule end date. Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "The schedule will need to be revised as a result of the approved change.",
    "choice_b": "A baselined schedule should be updated to reflect approved schedule changes and the new baseline overwrites previous versions of the baseline.",
    "choice_c": "A baselined schedule is one the stakeholders have approved that includes the start and finish dates and resource assignments.",
    "choice_d": "The schedule will need to be re-baselined as a result of the approved change.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "A baselined schedule is the original, approved schedule that includes start and end dates and resource assignments. The original baselined schedule should be kept for future reference so that the original estimates are not lost. You can compare changes to the baselines during the lessons learned session but need the original version to do this. A revision to a schedule usually occurs when the project end date does not move as a result of the approved change. A new baseline should be established when the project end date has moved. Only critical path tasks will impact the final end date.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      274,
      144,
      281,
      214,
      87
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "A new baseline should be established when a non\u2013critical path task is impacted as a result of an approved change."
  },
  {
    "id": 415,
    "question": "Which element of the project charter lists certain resources that will be available during the months of April through September while the project moves forward?",
    "choice_a": "Product description",
    "choice_b": "Deliverables",
    "choice_c": "Assumptions",
    "choice_d": "Constraints",
    "correct_answer": "C",
    "explanation": "Assumptions are things that are believed to be true. Stating that certain resources will be available during specific months of the project is an assumption.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      66,
      70,
      69,
      71
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 416,
    "question": "You are working on a large software development project and wish to use an agile methodology. You have decided to use a single Scrum team whose members will all share the same backlog while focusing on systems thinking, decentralizing decisions making, and tapping into the intrinsic motivation of the team members. Which methodology does this describe?",
    "choice_a": "Scrum",
    "choice_b": "SAFe",
    "choice_c": "PRINCE2",
    "choice_d": "DA",
    "correct_answer": "B",
    "explanation": "This question describes Scaled Agile Frameworks. PRINCE2 is not an agile methodology. Scrum involves a single team, and Disciplined Agile (DA) tailors agile approaches from several methodologies into a system that works for the team.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      301,
      300,
      120,
      108,
      116
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 417,
    "question": "This contains the deliverables and requirements, in the form of user stories, for an agile project. It is prioritized in order of importance, with the most important user story at the top of the list. The product owner defines the user stories and prioritizes them here. What is this referring to?",
    "choice_a": "Product backlog",
    "choice_b": "Sprint backlog",
    "choice_c": "User story backlog",
    "choice_d": "Kanban board",
    "correct_answer": "A",
    "explanation": "This question describes the product backlog, which consists of user stories that document the requirements of the project. The product owner writes the user stories and prioritizes them in the product backlog.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      153,
      108,
      119,
      157
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 418,
    "question": "You are an employee for Pike Summit Sports and are working on a project that will introduce a new line of weatherproof jackets and vests. Your company is not in the manufacturing business, so one decision made in this process was to contract with a vendor for the new clothing line. Another decision was to bring in a consulting company to help with the new marketing materials. The contract terms for this vendor state that the rate for a senior marketing tech is $125 per hour, a junior marketing tech is $95 per hour, and the marketing administrative support function is $55 an hour. What type of contract does this describe?",
    "choice_a": "Cost reimbursable",
    "choice_b": "CPIC",
    "choice_c": "CPAF",
    "choice_d": "T&M",
    "correct_answer": "D",
    "explanation": "This describes a time and materials (T&M) contract because you\u2019re using unit rates for the marketing skills.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      185,
      276,
      278,
      86,
      90
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 419,
    "question": "When initially developing your WBS, which of the following isn\u2019t required?",
    "choice_a": "Define the highest level of deliverables.",
    "choice_b": "Make sure that each item in a lower level is a component of the level above.",
    "choice_c": "Sequence all the work components.",
    "choice_d": "Involve project team members in the process.",
    "correct_answer": "C",
    "explanation": "The purpose of a WBS is to identify all the work required to complete a project. It is not important at this point to define the order of the work. That will come later when the schedule is developed.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      128,
      134,
      85,
      77,
      93
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 420,
    "question": "The stages involved in this project management methodology include startup, initiating, directing, controlling, delivering, stage boundaries, and closing. This methodology also follows seven guiding principles, including continually justifying the business need for the project, learning from experience, defining roles and responsibilities, managing the work in stages, managing exceptions to scope, focusing on quality, and tailoring the process. What is this methodology called?",
    "choice_a": "DSDM",
    "choice_b": "Kaizen",
    "choice_c": "AUP",
    "choice_d": "PRINCE2",
    "correct_answer": "D",
    "explanation": "This question describes PRINCE2, which has seven guiding principles and a defined set of stages the project follows.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      302,
      105,
      305,
      106,
      133
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 421,
    "question": "The project manager and project team members within the various departments of the organization all have roles and responsibilities throughout the project. As the project manager, you might link departments to each WBS element and display this information in which of the following ways?",
    "choice_a": "OBS",
    "choice_b": "RAM",
    "choice_c": "RACI",
    "choice_d": "RBS",
    "correct_answer": "B",
    "explanation": "The responsibility assignment matrix (RAM) links the OBS to the WBS, or the project roles (or individuals) to the activities. The RAM usually has a row and column format showing activities and the roles assigned to those activities.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      8,
      128,
      12,
      98,
      84
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 422,
    "question": "Your project status report contains sensitive information that should only be shared with those who need to know. What should you do when managing project communication given this scenario?",
    "choice_a": "You should refer to the organization\u2019s security policies and ensure this document adheres to version control standards outlined in the policy.",
    "choice_b": "You should refer to the organization\u2019s security policies and ensure this document adheres to document integrity standards outlined in the policy.",
    "choice_c": "You should refer to the organization\u2019s security policies and ensure this document adheres to the auditing standards outlined in this policy.",
    "choice_d": "You should refer to the organization\u2019s security policies and ensure this document adheres to the document security standards outlined in this policy.",
    "correct_answer": "D",
    "explanation": "Document security is important to consider when the project you are working on deals with sensitive information or trade secrets. Only those who need to know should have access to project documents in this scenario. Make certain to document access controls in the communication plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      271,
      269,
      74,
      265
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 423,
    "question": "You are the project manager working on a research project for a new drug treatment. Your\u00a0preliminary project schedule runs past the due date for a federal grant application. The manager of the RD department has agreed to release two resources to work on your project to meet the federal grant application date. This is an example of ______________.",
    "choice_a": "Crashing",
    "choice_b": "Fast tracking",
    "choice_c": "Resource leveling",
    "choice_d": "Adjusting the resource calendar",
    "correct_answer": "A",
    "explanation": "Crashing the schedule includes tasks such as adding resources to the critical path tasks or speeding up deliveries of materials and resources.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      147,
      144,
      56,
      53,
      162
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 424,
    "question": "You know that risk planning is an important practice on all projects. Risk planning includes all of the following except for which one?",
    "choice_a": "Using the risk register to monitor risks",
    "choice_b": "Analyzing the risks with the greatest probability and impact",
    "choice_c": "Identifying the potential risks to the project",
    "choice_d": "Defining how to manage the areas of uncertainty for the project",
    "correct_answer": "A",
    "explanation": "Option A describes what happens after you have performed risk planning. Risk monitoring occurs throughout the life of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      222,
      220,
      219,
      251
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Preparing risk responses"
  },
  {
    "id": 425,
    "question": "When starting a new project, you\u2019ll need to consider the development and life cycle approach used to manage the project. Why is this important? (Choose two.)",
    "choice_a": "When using a predictive approach, you\u2019ll want to know the size and complexity of the project so that you don\u2019t spend more time than needed documenting how scope will be defined.",
    "choice_b": "When using an adaptive approach, the requirements will be gathered and documented, and the scope statement will be developed, further elaborating on the requirements.",
    "choice_c": "Special consideration should be given to the quality management plan in an adaptive approach. This plan documents how the quality policy, methodologies, and standards will be managed for the project.",
    "choice_d": "The development approach will dictate how scope will be defined.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Option B is true for predictive or waterfall approaches, not adaptive or agile approaches. Option C is true for predictive or waterfall approaches, not adaptive or agile approaches.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      133,
      107,
      106,
      112,
      101
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 426,
    "question": "You are documenting the processes you\u2019ll use to perform each phase of the project, the life cycle you\u2019ll use for each phase of the project, the development approach you\u2019ll use, the methods for determining and maintaining the performance baselines, and more. What does this describe? (Choose two.)",
    "choice_a": "You are using a predictive life cycle methodology.",
    "choice_b": "You are using an adaptive life cycle methodology.",
    "choice_c": "This describes the project management plan.",
    "choice_d": "This describes the scope management plan.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "This describes a predictive life cycle methodology, and the question described the project management plan.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      132,
      9,
      85,
      12
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 427,
    "question": "Which of the following are true regarding a user story?",
    "choice_a": "They use actors to describe the \u201cwho\u201d that will realize the benefits or value the user story will bring about",
    "choice_b": "They are written from the perspective of the customer",
    "choice_c": "They contain descriptions of features or functionality that are desired by the actor.",
    "choice_d": "They contain acceptance criteria.",
    "correct_answer": "E",
    "explanation": "User stories describe features or functionality that actors desire. The actors are the people or roles that will realize the benefit of the requirement. User stories are written from the perspective of the customer and should describe acceptance criteria.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      153,
      119,
      158,
      54
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "All of the above."
  },
  {
    "id": 428,
    "question": "What is the difference between effective and efficient communications? (Choose two.)",
    "choice_a": "Efficient communication refers to providing the information in the right format for the intended audience at the right time.",
    "choice_b": "Efficient communication refers to providing the appropriate information at the right time and only the information that\u2019s needed at the time.",
    "choice_c": "Effective communication refers to providing the information in the right format for the intended audience at the right time.",
    "choice_d": "Effective communication refers to providing the appropriate information at the right time and only the information that\u2019s needed at the time",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Effective communication is providing the information in the right format for the audience at the right time. Efficient communication provides information at the right time, and it provides only the information that\u2019s needed at the time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      229,
      234,
      237,
      246,
      271
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 429,
    "question": "The following exhibit shows a series of tasks in a project schedule. Which path represents the critical path?<img src=\"/question_assets/Project+/BE2uf002.png\"/>",
    "choice_a": "A-E-F-G",
    "choice_b": "A-C-D-G",
    "choice_c": "A-B-D-G",
    "choice_d": "A-B-D-F-G",
    "correct_answer": "C",
    "explanation": "Tasks A, B, D, and G represent the longest dependent path through the network diagram at 41 days.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      147,
      136,
      210,
      219
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 430,
    "question": "You have been assigned to a large software development project. You\u2019ve decided your project should use a methodology that allows your team to deliver usable, working software continually in a timely manner. You will use a five-step process, including develop a model, create a features list, plan, design, and build. You may have more than one team working on the requirements in any one iteration. Which methodology does this question describe?",
    "choice_a": "Kanban",
    "choice_b": "FDD",
    "choice_c": "Scrum",
    "choice_d": "XP",
    "correct_answer": "B",
    "explanation": "This question describes feature-driven development. FDD is used for large software projects and involves a five-step process to determine, create, plan, design, and build the features of the product. FDD may utilize more than one team to work on different features during the same iteration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      113,
      123,
      301,
      119
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 431,
    "question": "You have identified risks on the project, performed risk analysis, and prepared response plans for those risks with the highest probability of occurring and/or with the greatest impact to the project. All of the following include next steps you should take except for which one?",
    "choice_a": "Assign risk owners to the risks.",
    "choice_b": "Create a risk register documenting the risk score, the risk owner, and the location of the response plan if applicable.",
    "choice_c": "Define strategies to respond to positive and negative risks.",
    "choice_d": "Define risk triggers that the project manager will monitor for potential risk events.",
    "correct_answer": "D",
    "explanation": "Option D is not correct because the risk triggers are assigned to risk owners, not the project manager.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      222,
      251,
      217,
      272,
      247
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 432,
    "question": "A Kanban board and a Scrum board are similar. The primary difference between them is described in which of the following options?",
    "choice_a": "A Scrum board is capacity based.",
    "choice_b": "A Kanban board is known as iterative scheduling.",
    "choice_c": "A Scrum board is known as on-demand scheduling.",
    "choice_d": "A Kanban board is capacity based.",
    "correct_answer": "D",
    "explanation": "A Kanban board is capacity based and a Scrum board is time bound. Scrum boards use iteration scheduling, which is similar to rolling wave planning, and progressive elaboration. Kanban boards use pull-based, or on-demand, scheduling techniques.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      109,
      113,
      300,
      133
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 433,
    "question": "Which of the following are the most important functions the project manager fulfills? (Choose two.)",
    "choice_a": "Managing project resources appropriately and communicating project status",
    "choice_b": "Ensuring the project comes in on time and under budget",
    "choice_c": "Integrating the project work and assuring the satisfaction of the stakeholders",
    "choice_d": "Communicating with all stakeholders",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The project manager fulfills all the functions listed in the options, but the two most important are integrating project work and communicating.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      6,
      23,
      56,
      232,
      22
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "Developing the project plan and obtaining approval from stakeholders"
  },
  {
    "id": 434,
    "question": "You are starting work on a software development project with a high amount of risk associated with the project. The customer is not certain of all the requirements at the beginning of the project. This project will have dynamically changing requirements and involves delivering software that\u2019s needed when the customer needs it. The development team consists of five developers who use pair programming and test-driven development to produce the code. Which life cycle methodology does this question describe?",
    "choice_a": "Scrum",
    "choice_b": "FDD",
    "choice_c": "DSDM",
    "choice_d": "XP",
    "correct_answer": "D",
    "explanation": "This question describes extreme programming. The keys in the question are pair programming and test-driven development, both techniques used in XP.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      112,
      107,
      153,
      118
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 435,
    "question": "This analysis specifically helps identify risks internal and external to the project and is also known as internal-external analysis.",
    "choice_a": "Qualitative",
    "choice_b": "SWOT",
    "choice_c": "Monte Carlo",
    "choice_d": "Situational/scenario",
    "correct_answer": "B",
    "explanation": "SWOT analysis stands for strengths, weaknesses, opportunities, and threats. Strengths and weaknesses are generally internal to the organization, and opportunities and threats are generally external to the organization.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      218,
      292,
      220,
      219,
      222
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 436,
    "question": "You want to assure version control of project documents and provide a collaborative platform for team members and stakeholders to review and update certain documents. You could use all of the following knowledge management tools to accomplish this except which one?",
    "choice_a": "Wiki pages",
    "choice_b": "Intranet site",
    "choice_c": "Dashboards",
    "choice_d": "Collaboration software",
    "correct_answer": "C",
    "explanation": "Communication tools include intranet sites, Internet sites, wiki knowledge bases, and collaboration tools. A dashboard is a reporting tool.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      268,
      258,
      266,
      252
    ],
    "source": "892458_Practice Exam2"
  },
  {
    "id": 437,
    "question": "You are working on a project and are contracting most of the resources needed to develop the application. You need resources with various skills at different times during the project. You want to ensure you can obtain the resources quickly as needed and wrote the contract with a general scope of work so that specific work details could be requested throughout the project as needed. Which of the following will you use to procure these resources? (Choose two.)",
    "choice_a": "TOR",
    "choice_b": "RFQ",
    "choice_c": "SOW",
    "choice_d": "PO",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The purchase order (PO) or a terms of reference (TOR) can be used to describe the scope of work, timelines, resources, and more that are needed for the project under the scope of the existing contract.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      274,
      88,
      286,
      26,
      162
    ],
    "source": "892458_Practice Exam2",
    "choice_e": "T&M"
  },
  {
    "id": 438,
    "question": "What is the definition of a project? (Choose two.)",
    "choice_a": "A group of interrelated activities that create a unique benefit to the organization",
    "choice_b": "A set of processes repeated multiple times to produce the same result",
    "choice_c": "A temporary endeavor undertaken to create a unique product, service, or result",
    "choice_d": "A process used to generate profit, improve market share, or adhere to legal requirements",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "A project creates a unique product, service, or result and has defined start and finish dates. Interrelated activities or processes repeated multiple times are not projects because they don\u2019t have start and finish dates, and they don\u2019t produce unique results. Option D outlines some of the reasons a project might come about.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      6,
      88,
      101
    ],
    "source": "892458_c01",
    "choice_e": "A time-constrained activity used to bring about unique results that align with the organization\u2019s goals"
  },
  {
    "id": 439,
    "question": "What is the definition of operations?",
    "choice_a": "Activities that have a definitive start and end date",
    "choice_b": "Activities that are ongoing that support the organization\u2019s business",
    "choice_c": "Activities that are unique to the organization and are temporary in nature",
    "choice_d": "Activities that are time bound",
    "correct_answer": "B",
    "explanation": "Options A, C, and D describe a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      6,
      86,
      105,
      106
    ],
    "source": "892458_c01"
  },
  {
    "id": 440,
    "question": "What is the term for a group of related projects managed in a coordinated fashion?",
    "choice_a": "Life cycle",
    "choice_b": "Phase",
    "choice_c": "Process group",
    "choice_d": "Program",
    "correct_answer": "D",
    "explanation": "A program is a group of related projects that can benefit from coordinated project management. Life cycles are the various stages a project goes through, and process groups consist of Discovery/Concept, Initiating, Planning, Executing, and Closing.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      5,
      57,
      6,
      101,
      3
    ],
    "source": "892458_c01"
  },
  {
    "id": 441,
    "question": "Which of the following are true regarding project portfolios? (Choose two.)",
    "choice_a": "The independent projects in the portfolio may not have anything in common.",
    "choice_b": "The programs in the portfolio are related to one another.",
    "choice_c": "The programs and projects within the portfolio support the strategic goals of the portfolio.",
    "choice_d": "An organization has only one portfolio.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Portfolios consist of programs, subportfolios, and independent projects that are not necessarily related to one another. An organization could have any number of portfolios.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      28,
      301,
      6,
      53
    ],
    "source": "892458_c01",
    "choice_e": "Portfolios consist of programs and do not contain stand-alone projects."
  },
  {
    "id": 442,
    "question": "Which of the following make up the life cycle phases according to the CompTIA exam objectives?",
    "choice_a": "Initiating, Planning, Executing, Closing",
    "choice_b": "Discovery/Concept, Initiating, Planning, Executing, Closing",
    "choice_c": "Discovery/Concept, Planning, Executing, Monitoring and Controlling, Closing",
    "choice_d": "Initiating, Planning, Executing, Monitoring and Controlling, Closing",
    "correct_answer": "B",
    "explanation": "The life cycle phases of project management according to CompTIA are Discovery/Concept, Initiating, Planning, Executing, and Closing. The <i>PMBOK</i>\u00ae<i> Guide </i>calls these process groups and they are as follows: Initiating, Planning, Executing, Monitoring and Controlling, and Closing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      6,
      106,
      133,
      123
    ],
    "source": "892458_c01"
  },
  {
    "id": 443,
    "question": "You receive a request from customer service to purchase and implement a customer management system for the service-support staff. What type of need or demand does this describe?",
    "choice_a": "Organizational need",
    "choice_b": "Market demand",
    "choice_c": "Legal requirement",
    "choice_d": "Technological advance",
    "correct_answer": "A",
    "explanation": "A request to develop a product for use by an internal department is an organizational need. Market demands are driven by the needs of the market, legal requirements come about because of rules or regulations that must be complied with, and technological advances come about due to changes or advancements in technology. This question describes purchasing and implementing a new system for the organization but doesn\u2019t imply the technology itself is new or advanced.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      14,
      65,
      99,
      102,
      66
    ],
    "source": "892458_c01"
  },
  {
    "id": 444,
    "question": "Your project stakeholder is working on the business case. They ask you for some assistance. You suggest to them that the business case should include which of the following?",
    "choice_a": "Feasibility study",
    "choice_b": "Alignment to the strategic plan",
    "choice_c": "Justification",
    "choice_d": "Alternative solutions",
    "correct_answer": "E",
    "explanation": "The business case analysis may include the feasibility study but should always include the justification for the project, alignment to the strategic plan, benefits and rewards (using financial analysis), alternative solutions, and more.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      19,
      8,
      65,
      102
    ],
    "source": "892458_c01",
    "choice_e": "All of the above"
  },
  {
    "id": 445,
    "question": "Preexisting contracts, prequalified vendors, and project documents such as the scope statement, schedule, risk log, and lessons learned are known as which of the following? (Choose two.)",
    "choice_a": "Vestige",
    "choice_b": "Relic",
    "choice_c": "Historical information",
    "choice_d": "Artifacts",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Artifacts, also known as historical information, include any documents, physical elements, evidence, or information associated with past projects.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      18,
      12,
      11,
      84,
      132
    ],
    "source": "892458_c01"
  },
  {
    "id": 446,
    "question": "Your project has expected cash inflows of $1.2 million in year 1, $2 million in year 2, and $4.4 million in year 3, for a total of $7.6 million in today\u2019s dollars. Which technique was used to determine this?",
    "choice_a": "Discounted cash flow",
    "choice_b": "IRR",
    "choice_c": "NPV",
    "choice_d": "Cost-benefit analysis",
    "correct_answer": "A",
    "explanation": "The discounted cash flow technique compares the total value of each year\u2019s expected cash inflow to today\u2019s dollar. IRR calculates the internal rate of return, NPV determines the net present value, and cost-benefit analysis determines the cost of the project versus the benefits received.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      14,
      203,
      70,
      96,
      19
    ],
    "source": "892458_c01"
  },
  {
    "id": 447,
    "question": "Your selection committee wants to compare the profitability of three projects against each other to determine which should move forward. The projects do not have equal timelines. You are using this formula:<br>(Current Value or Gain from the Investment \u2013 Cost of Investment) / (Cost of the Investment)<br>Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "This is the formula for discounted cash flows.",
    "choice_b": "This is the formula for ROI.",
    "choice_c": "You\u2019ll need to annualize the returns since each project has a different time period.",
    "choice_d": "This is the formula for NPV.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "This is the formula for ROI. ROI does not take time periods into account, so you\u2019ll need to annualize the returns for comparison purposes.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      14,
      70,
      67,
      102,
      12
    ],
    "source": "892458_c01",
    "choice_e": "The returns are calculated by year and the total return for each project should be used for comparison."
  },
  {
    "id": 448,
    "question": "The idea behind most cash flow techniques is that money today is worth more than money in the future. What is this known as?",
    "choice_a": "Present value of money",
    "choice_b": "Future value of money",
    "choice_c": "Time value of money",
    "choice_d": "Discounted value of future money",
    "correct_answer": "C",
    "explanation": "Money received today is worth more than the same amount of money received in the future due to the time value of money. Inflation and other factors will erode the value of money over time.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      96,
      68,
      102,
      188
    ],
    "source": "892458_c01"
  },
  {
    "id": 449,
    "question": "Federico, the director of the marketing department, has approached you with an idea for a project. He has prepared a draft business case and included two alternative solutions. What should this section of the business case contain?",
    "choice_a": "High-level description of the costs",
    "choice_b": "Feasibility of implementing each alternative",
    "choice_c": "Expected results of each solution",
    "choice_d": "Description of the impacts of the alternative to the organization",
    "correct_answer": "F",
    "explanation": "The alternative solutions section should contain the information in all the options.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      102,
      68,
      67,
      69
    ],
    "source": "892458_c01",
    "choice_e": "A, B, C",
    "choice_f": "A, B, C, D"
  },
  {
    "id": 450,
    "question": "Your project has projected revenues of $500,000 in year 1 and $700,000 in year 2. Your initial investment was $850,000. What is the payback period?",
    "choice_a": "21 months",
    "choice_b": "20 months",
    "choice_c": "2 years",
    "choice_d": "18 months",
    "correct_answer": "D",
    "explanation": "Payback period is a technique that calculates the expected cash inflows over time to determine how many periods it will take to recover the original investment. In this case, our initial investment is $850,000. Subtract year 1 inflows from this to see what\u2019s remaining. This leaves us with a $350,000 balance. If you annualize year 2 returns of $700,000, you get approximately $58,343 per month. It will take six months of inflows at $58,343 to recoup the $350,000.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      102,
      203,
      126,
      96
    ],
    "source": "892458_c01"
  },
  {
    "id": 451,
    "question": "You\u2019ve been given an idea for a project by an executive in your organization. After writing the business case, you submit it to the executive for review. After reading the business case, they determine that the project poses a significant amount of risk to the organization. What do you recommend next?",
    "choice_a": "Proceed to the project selection committee.",
    "choice_b": "Reject the project based on the analysis.",
    "choice_c": "Proceed to writing the project plan.",
    "choice_d": "Perform a feasibility study.",
    "correct_answer": "D",
    "explanation": "The next best step to take in this situation is to perform a feasibility study. Feasibility studies are typically undertaken for projects that are risky, projects that are new to the organization, or projects that are highly complex. Projects of significant risk to the organization shouldn\u2019t be taken to the selection committee without having a feasibility study first. Writing the project plan doesn\u2019t make sense at this point because you don\u2019t know if the project will be approved to move forward yet. You also can\u2019t reject the project because there isn\u2019t enough information to determine whether it should be rejected until the feasibility study is completed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      21,
      215,
      28,
      53
    ],
    "source": "892458_c01"
  },
  {
    "id": 452,
    "question": "Your selection committee has approved a project that requires specialized skills that are not available in the organization. This project has a tight timeline and you are looking for ways to get resources on board as quickly as possible. Which of the following will help you speed up the procurement of resources? (Choose two.)",
    "choice_a": "Preexisting contract",
    "choice_b": "Predetermined clients",
    "choice_c": "Prequalified vendor list",
    "choice_d": "Predetermined selection process",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Preexisting contracts are active contracts in place at the organization. You could use an existing contract to bring these resources on board. Likewise, prequalified vendors will help speed the process. You can go directly to this list and choose a vendor who has the resource type you need at the price they stated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      185,
      26,
      276,
      169
    ],
    "source": "892458_c01"
  },
  {
    "id": 453,
    "question": "Which of the following are used as project selection methods?",
    "choice_a": "Cash flow techniques",
    "choice_b": "Constrained optimization models",
    "choice_c": "Expert judgment",
    "choice_d": "Decision models",
    "correct_answer": "G",
    "explanation": "All of the options are types of project selection methods.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      19,
      102,
      66,
      84
    ],
    "source": "892458_c01",
    "choice_e": "A, D",
    "choice_f": "A, B, D",
    "choice_g": "A, B, C, D"
  },
  {
    "id": 454,
    "question": "Your project involves implementing a software platform to manage the organization\u2019s general ledger, budget, and financial information. The company you have engaged with recommended three implementation firms for you to choose from in helping to configure the system. What is this known as?",
    "choice_a": "Predetermined clients",
    "choice_b": "Predetermined vendor list",
    "choice_c": "Prequalified clients",
    "choice_d": "Prequalified vendor list",
    "correct_answer": "A",
    "explanation": "This is known as predetermined clients. These are partners who have been prequalified to work with the software platform you are implementing.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      276,
      51,
      88,
      280,
      21
    ],
    "source": "892458_c01"
  },
  {
    "id": 455,
    "question": "Your project has expected cash inflows of $7.8 million in today\u2019s dollars. The project\u2019s initial investment is $9.2 million. Which of the following is true?",
    "choice_a": "The discounted cash flows are lower than the initial investment, so this project should be rejected.",
    "choice_b": "The discounted cash flows are lower than the initial investment, so this project should be accepted.",
    "choice_c": "NPV is less than 0, so this project should be rejected.",
    "choice_d": "NPV is greater than 0, so this project should be accepted.",
    "correct_answer": "C",
    "explanation": "NPV is calculated by subtracting the total of the expected cash inflows stated in today\u2019s dollars from the initial investment. In this question, the initial investment is higher than the cash flows, so the resulting NPV is less than 0, and the project should be rejected. Discounted cash flows tell you the value of the cash flows in today\u2019s dollars.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      102,
      203,
      84,
      8
    ],
    "source": "892458_c01"
  },
  {
    "id": 456,
    "question": "Which of the following are the steps required to validate a project? (Choose two.)",
    "choice_a": "Analyze the feasibility.",
    "choice_b": "Justify the project.",
    "choice_c": "Align it to the strategic plan.",
    "choice_d": "Create the business case.",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "Validating a project requires writing the business case and identifying and analyzing the stakeholders.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      16,
      14,
      8,
      19,
      102
    ],
    "source": "892458_c01",
    "choice_e": "Identify and analyze stakeholders."
  },
  {
    "id": 457,
    "question": "Your selection committee is reviewing two projects that will attempt to improve the efficiency of your current procurement process. They have engaged key team members and subject matter experts to compare two projects. This team is charged with analyzing the current process and determining how this might change or improve, and how it will change, if the project were implemented. What is this technique called? (Choose three.)",
    "choice_a": "As is\u2014to be",
    "choice_b": "Current state versus future state",
    "choice_c": "Project selection methodology",
    "choice_d": "Alignment to the strategic plan",
    "correct_answer": [
      "A",
      "B",
      "F"
    ],
    "explanation": "Current state versus future state examines the impact of changes on the future state of the organization. First, however, you need to understand the current state and document the process using diagrams or other techniques, to understand what the future state may look like. This is also known as \u201cas is\u2014to be,\u201d which is a type of performance analysis.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      102,
      14,
      85,
      132,
      324
    ],
    "source": "892458_c01",
    "choice_e": "Justification",
    "choice_f": "Performance analysis"
  },
  {
    "id": 458,
    "question": "Which of the following general management skills consumes up to 90 percent of a project manager\u2019s time?",
    "choice_a": "Programming",
    "choice_b": "Communicating",
    "choice_c": "Leading",
    "choice_d": "Problem solving",
    "correct_answer": "B",
    "explanation": "Project managers can spend up to 90 percent of their time communicating. The other skills listed here are important as well, but the clue in this question is the 90 percent figure that relates to the amount of time project managers may spend communicating.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      232,
      23,
      227,
      228,
      22
    ],
    "source": "892458_c02"
  },
  {
    "id": 459,
    "question": "Which general management skill concerns obtaining mutually acceptable agreements with individuals or groups?",
    "choice_a": "Leadership",
    "choice_b": "Problem solving",
    "choice_c": "Negotiating",
    "choice_d": "Communicating",
    "correct_answer": "C",
    "explanation": "Negotiating involves obtaining mutually acceptable agreements with individuals or groups. Leadership involves imparting a vision and motivating others to achieve the goal. Problem solving involves working together to reach a solution. Communicating involves exchanging information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      26,
      23,
      51,
      271
    ],
    "source": "892458_c02"
  },
  {
    "id": 460,
    "question": "All of the following are true regarding ESG except which one?",
    "choice_a": "It\u2019s imperative the project manager understands ESG as it relates to the project so that regulations, standards, and guidelines are followed.",
    "choice_b": "S in ESG stands for social.",
    "choice_c": "Awareness of applicable regulations and standards are an ESG factor.",
    "choice_d": "PII is an ESG factor that relates to the social factor.",
    "correct_answer": "D",
    "explanation": "PII stands for personally identifiable information and is not part of ESG. ESG stands for environmental, social, and governance.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      190,
      195,
      196,
      42,
      48
    ],
    "source": "892458_c02",
    "choice_e": "Project impact to company brand value is an ESG factor."
  },
  {
    "id": 461,
    "question": "You work for a company that is growing rapidly. The company\u2019s leadership wants to install a system that will allow both current and future customers to interact with the company to learn more about the company\u2019s products and to obtain support. What kind of a system will you recommend be implemented?",
    "choice_a": "CMS",
    "choice_b": "ERP",
    "choice_c": "CRM",
    "choice_d": "IaaS",
    "correct_answer": "C",
    "explanation": "A customer relationship management (CRM) system is one that is used by companies to interact with their customers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      46,
      40,
      36
    ],
    "source": "892458_c02"
  },
  {
    "id": 462,
    "question": "Your company currently has a large data center that consists of hundreds of servers and a host of enterprise applications such as large databases. Corporate stakeholders want to get away from the costs of maintaining a data center but also want to continue their operations in much the same way as they currently do. You know that a cloud solution is the way to go. Which cloud environment should you pursue?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "XaaS",
    "choice_d": "SaaS",
    "correct_answer": "B",
    "explanation": "This question states the company is looking to decommission their on-premises data center consisting of servers, databases, and applications. Data centers consist of infrastructure; therefore IaaS is the correct option. Infrastructure as a service allows the cloud consumer to provision servers, storage, networking, operating systems, and other computing resources on demand. With IaaS, companies have the ability to stand up servers, operating systems, networking hardware, databases, and applications that mirror (or even improve on) the current data center environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      36,
      49,
      37
    ],
    "source": "892458_c02"
  },
  {
    "id": 463,
    "question": "A database that consists of tables and relationships can be considered which kind of data?",
    "choice_a": "Structured",
    "choice_b": "Unstructured",
    "choice_c": "Flat",
    "choice_d": "Unregulated",
    "correct_answer": "A",
    "explanation": "Data entered into a database system is structured data that is organized in a meaningful way. Unstructured data is a blob of data that has not yet been organized with any meaning in mind. Flat data is a term that is often used to describe data that\u2019s entered into spreadsheets.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      44,
      42,
      48,
      37,
      36
    ],
    "source": "892458_c02"
  },
  {
    "id": 464,
    "question": "Which of the following data sources are considered SPII? (Choose two.)",
    "choice_a": "First name",
    "choice_b": "Social Security number (SSN)",
    "choice_c": "City",
    "choice_d": "Political party",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Sensitive personally identifiable information is stand-alone data that by itself can identify an individual. Options A, C, and D are linkable data and, if combined with PII, will become SPII.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      29,
      195,
      31,
      44,
      45
    ],
    "source": "892458_c02",
    "choice_e": "Driver\u2019s license number"
  },
  {
    "id": 465,
    "question": "Which of the following is an example of linkable data becoming SPII?",
    "choice_a": "When the link connects an individual\u2019s name to a corporate website",
    "choice_b": "When an individual\u2019s name is linked to their Taxpayer Identification Number (TIN)",
    "choice_c": "When the IP address of an individual\u2019s cable modem is shown",
    "choice_d": "When an individual is shown to live within a specific zip code",
    "correct_answer": "B",
    "explanation": "Linkable data such as zip code, date of birth, and more become sensitive personally identifiable information when it is linked to a PII element.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      31,
      44,
      45
    ],
    "source": "892458_c02"
  },
  {
    "id": 466,
    "question": "Why are you required to stand far back from the pharmacy counter when you are waiting to talk to a customer service person about refilling a prescription?",
    "choice_a": "It is PHI data and is required by HIPAA.",
    "choice_b": "It is not a requirement, but it is a good idea in a place where there are so many sick people.",
    "choice_c": "It is required by PIPEDA.",
    "choice_d": "It is required by GDPR.",
    "correct_answer": "A",
    "explanation": "The Health Insurance\u00a0Portability and Accountability Act (HIPAA) concerns the electronic protected health information (ePHI) of patients. A patient might be talking with a customer service representative about their prescriptions. This is protected information that someone else should not overhear.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      30,
      195,
      31,
      190,
      194
    ],
    "source": "892458_c02"
  },
  {
    "id": 467,
    "question": "Suppose that you work for a company that has several campuses located in different locations in the city. Which network will connect them together?",
    "choice_a": "LAN",
    "choice_b": "SAN",
    "choice_c": "WAN",
    "choice_d": "GAN",
    "correct_answer": "C",
    "explanation": "A wide area network (WAN) is a style of networking that is able to connect various campuses spread across locations within a city.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      38,
      36,
      37,
      49,
      297
    ],
    "source": "892458_c02"
  },
  {
    "id": 468,
    "question": "In a multitiered architecture, which tier helps the user interact with the system?",
    "choice_a": "Presentation",
    "choice_b": "Processing",
    "choice_c": "Data",
    "choice_d": "Application",
    "correct_answer": "A",
    "explanation": "The presentation layer collects and displays the information the user needs to interact with the system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      37,
      36,
      38,
      39,
      40
    ],
    "source": "892458_c02"
  },
  {
    "id": 469,
    "question": "Suppose that you work for a company that has gone through a rapid growth cycle and now has several one-off systems for activities like the company\u2019s finances, manufacturing, and human resources. The leaders of the company want to have a system that brings these activities together. What kind of system will you recommend?",
    "choice_a": "Cloud",
    "choice_b": "LAN",
    "choice_c": "ERP",
    "choice_d": "SAN",
    "correct_answer": "C",
    "explanation": "A common word that is used to generically refer to a company\u2019s computing resources is called \u201cthe enterprise.\u201d Thus, when architecting a system that brings various corporate functionality together, an enterprise resource planning (ERP) system is often chosen.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      36,
      37,
      40,
      48
    ],
    "source": "892458_c02"
  },
  {
    "id": 470,
    "question": "A user you support has worked for hours on a spreadsheet document. A sudden power outage to the building causes their computer to power down. When the power comes back, they cannot find the spreadsheet they\u2019ve been working on. Why is this? (Choose two.)",
    "choice_a": "The user was working on the document in RAM memory. When the computer went down, everything in RAM was erased.",
    "choice_b": "There must have been a glitch in the computer\u2019s memory when the power went down. Thus, the user cannot restore it.",
    "choice_c": "The user neglected to save the document to the computer\u2019s hard drive.",
    "choice_d": "When the power went down and came back up, there was a power glitch in the computer\u2019s ROM.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When users are working with a document, the contents of the document are stored in the computer\u2019s RAM. When the user saves what they are working on, a copy of the document is saved to the hard drive or to a NAS, the cloud, or some other form of storage. This person could not find their document because they did not save it to the hard drive and the working copy was only stored in RAM.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      39,
      36,
      38,
      40,
      41
    ],
    "source": "892458_c02"
  },
  {
    "id": 471,
    "question": "What is the purpose of a data warehouse?",
    "choice_a": "To bring all the company\u2019s unstructured data together in a central location",
    "choice_b": "To bring various data sources together for the purpose of analysis and decision-making",
    "choice_c": "To handle an extremely large data environment",
    "choice_d": "To separate the data\u2019s physical location from other applications",
    "correct_answer": "B",
    "explanation": "A data warehouse is a collection of data for the purpose of helping stakeholders make sense out of the data for the purpose of analysis and decision-making. Data in a data warehouse may include internal as well as external data resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      42,
      43,
      44,
      47
    ],
    "source": "892458_c02"
  },
  {
    "id": 472,
    "question": "Who is responsible for documenting the various systems, applications, databases, and other computing infrastructure the company owns?",
    "choice_a": "Risk management",
    "choice_b": "Human resources",
    "choice_c": "The Procurement department",
    "choice_d": "Information technology",
    "correct_answer": "D",
    "explanation": "IT is responsible for documenting the corporate computing resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      36,
      42,
      43,
      44,
      48
    ],
    "source": "892458_c02"
  },
  {
    "id": 473,
    "question": "Your company has decided to use an application that was developed by a cloud provider and hosted on the cloud. The executives like this because someone else is responsible for the development and support of the application. What kind of cloud does this describe?",
    "choice_a": "XaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "PaaS",
    "correct_answer": "C",
    "explanation": "This type of cloud environment is called software as a service (SaaS) and provides a platform to develop and/or host software applications.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      40,
      41,
      49,
      36,
      37
    ],
    "source": "892458_c02"
  },
  {
    "id": 474,
    "question": "In the multitenant model of cloud computing, providers that offer their services to a variety of customers can utilize which of the following?",
    "choice_a": "Single-source computing",
    "choice_b": "Resource pooling",
    "choice_c": "Multitiered architecture",
    "choice_d": "CMS",
    "correct_answer": "B",
    "explanation": "In the multitenant model, cloud providers can offer their computing resources to multiple customers. This is called resource pooling.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      49,
      40,
      41,
      36,
      38
    ],
    "source": "892458_c02"
  },
  {
    "id": 475,
    "question": "In the United States, which organization is responsible for publishing rules that control personally identifiable information standards (PII)?",
    "choice_a": "GDPR",
    "choice_b": "HIPAA",
    "choice_c": "EPHI",
    "choice_d": "NIST",
    "correct_answer": "D",
    "explanation": "In the United States the National Institute of Standards and Technology (NIST) publishes the rules for personally identifiable information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      190,
      32,
      33
    ],
    "source": "892458_c02"
  },
  {
    "id": 476,
    "question": "All of the following are examples of secondary storage except which one?",
    "choice_a": "NAS",
    "choice_b": "SAN",
    "choice_c": "Flash drive",
    "choice_d": "RAM",
    "correct_answer": "D",
    "explanation": "Random access memory is a type of primary storage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      39,
      36,
      38,
      37,
      40
    ],
    "source": "892458_c02"
  },
  {
    "id": 477,
    "question": "Your organization was hacked and PII data was exposed. All of the following are true except which one?",
    "choice_a": "This is a breach of confidentiality.",
    "choice_b": "Significant fines could be imposed on the organization as a result of exposing this data.",
    "choice_c": "This could cause emotional distress to those individuals who were impacted by the exposure.",
    "choice_d": "According to NIST, there are four levels of impact that can affect the organization.",
    "correct_answer": "D",
    "explanation": "According to NIST, there are three levels of impact that can affect the organization when a breach occurs: low, medium, or high impacts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      31,
      29,
      195,
      190,
      32
    ],
    "source": "892458_c02"
  },
  {
    "id": 478,
    "question": "The Initiating phase includes which task?",
    "choice_a": "Assigning work to project team members",
    "choice_b": "Sequencing project activities",
    "choice_c": "Approving a project and authorizing work to begin",
    "choice_d": "Coordinating resources to complete the project work",
    "correct_answer": "C",
    "explanation": "The Initiating phase is the second phase in the project management life cycle. This is where the project charter that authorizes the project to begin is created and published.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      66,
      7,
      81,
      12
    ],
    "source": "892458_c03"
  },
  {
    "id": 479,
    "question": "Which person is responsible for authorizing the project to begin and for signing the project charter?",
    "choice_a": "Project sponsor",
    "choice_b": "Executive in the organization who requested the project",
    "choice_c": "Program manager",
    "choice_d": "Project manager",
    "correct_answer": "A",
    "explanation": "The project sponsor is responsible for authorizing the project to begin and is the person who signs the project charter.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      71,
      8,
      67,
      16
    ],
    "source": "892458_c03"
  },
  {
    "id": 480,
    "question": "You have identified all the key stakeholders on the project. You\u2019ve listed their names, departments, interests in the project, and level of influence. What have you created? (Choose two.)",
    "choice_a": "A stakeholder contact list",
    "choice_b": "A stakeholder register",
    "choice_c": "An artifact",
    "choice_d": "A business case with a list of key stakeholders",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A stakeholder register includes the stakeholder name, department, contact information, role on the project, needs, concerns, interests, level of involvement on the project, level of influence over the project, and notes for your own reference. A stakeholder register is an artifact. The question does not mention that project objectives, timelines, budgets, or any other information is included, which rules out options D and E.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      59,
      63,
      16,
      12,
      8
    ],
    "source": "892458_c03",
    "choice_e": "A preliminary scope statement with a list of key stakeholders"
  },
  {
    "id": 481,
    "question": "Zoe is a key resource for the project. She has certifications on the PaaS product you are implementing. She will help determine duration estimates, cost estimates, and perform application development. What type of stakeholder is Zoe?",
    "choice_a": "Tester/QA technician",
    "choice_b": "SME",
    "choice_c": "Business analyst",
    "choice_d": "Architect",
    "correct_answer": "B",
    "explanation": "Zoe is a SME. She is also considered a developer/engineer, which is not an option for this question.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      51,
      62,
      272,
      200,
      199
    ],
    "source": "892458_c03"
  },
  {
    "id": 482,
    "question": "Zack is a key resource for the project. He is responsible for designing the overall technology infrastructure, network, storage, and security for the cloud application the IT team is developing. What type of stakeholder is Zack?",
    "choice_a": "QA technician",
    "choice_b": "Developer/engineer",
    "choice_c": "End user",
    "choice_d": "Architect",
    "correct_answer": "D",
    "explanation": "Zack is an IT architect. Testers ensure the code works as designed. Developers write programming code, and end users are the ones who use the program to perform business functions once it\u2019s written.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      51,
      55,
      57,
      121
    ],
    "source": "892458_c03"
  },
  {
    "id": 483,
    "question": "Your project\u2019s objective is to implement a new financial system. Ravi is a key stakeholder on the project. He, along with others from his team, will provide critical input on the functioning of the system. One of the objectives Ravi would like to see is reducing the amount of clicks it takes to process and invoice. He\u2019d really like to see this process streamlined. What type of stakeholder is Ravi? (Choose two.)",
    "choice_a": "Architect",
    "choice_b": "Developer/engineer",
    "choice_c": "End user",
    "choice_d": "QA technician",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Ravi is both an end user and a subject matter expert. Options A, B, and D describe IT team members. The question hints at his business unit, which is not IT.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      55,
      51,
      61,
      62
    ],
    "source": "892458_c03",
    "choice_e": "SME"
  },
  {
    "id": 484,
    "question": "You are using a document from the Discovery phase to help you write a document produced in the Initiating phase. You have documented the objectives of the project as well as the business problem the project is attempting to resolve, which you know are the primary purposes for this document. Which document are you writing?",
    "choice_a": "Business case",
    "choice_b": "Objectives",
    "choice_c": "Project charter",
    "choice_d": "Preliminary scope statement",
    "correct_answer": "D",
    "explanation": "The preliminary scope statement\u2019s primary purpose is to document the objectives and the business problem you\u2019re trying to solve. The primary purpose of the project charter is to authorize the project to begin.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      66,
      8,
      65,
      67
    ],
    "source": "892458_c03"
  },
  {
    "id": 485,
    "question": "Which of the following does a PMO provide to the overall project management processes? (Choose three.)",
    "choice_a": "Preliminary scope statement",
    "choice_b": "Business case",
    "choice_c": "Tools",
    "choice_d": "Governance process",
    "correct_answer": [
      "C",
      "D",
      "F"
    ],
    "explanation": "The PMO provides standards and practices for the organization, including tools, templates, and governance processes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      6,
      280,
      304,
      300
    ],
    "source": "892458_c03",
    "choice_e": "Change control",
    "choice_f": "Templates"
  },
  {
    "id": 486,
    "question": "The project sponsor (who is also the project champion in this question) provides which of these functions to the project? (Choose three.)",
    "choice_a": "Preparing the stakeholder matrix",
    "choice_b": "Marketing the project",
    "choice_c": "Removing roadblocks",
    "choice_d": "Preparing the project charter",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The project sponsor/champion approves funding, approves the project charter, markets the project benefits, removes roadblocks, and defines the business justification for the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      52,
      51,
      26,
      281
    ],
    "source": "892458_c03",
    "choice_e": "Defining the business justification",
    "choice_f": "Managing project artifacts"
  },
  {
    "id": 487,
    "question": "Your project team members and key stakeholders are confused about the project you are all working on. What is the most compelling reason for this?",
    "choice_a": "The problem or need generating the project request was not defined well in the preliminary scope statement.",
    "choice_b": "The project sponsor has not signed the project charter document authorizing the project to begin.",
    "choice_c": "The business case is not well documented.",
    "choice_d": "The project team members don\u2019t understand their roles and responsibilities.",
    "correct_answer": "A",
    "explanation": "The project manager should take the time to define the problem or need generating the project request and document this in the high-level scope definition. It could be that the business case was not well-defined, but the reason for that is also because the problem or need was not well-defined.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      64,
      65,
      67,
      14,
      99
    ],
    "source": "892458_c03"
  },
  {
    "id": 488,
    "question": "Which of the following are true regarding the project baseline? (Choose four.)",
    "choice_a": "The project baseline is approved by the project manager.",
    "choice_b": "The project baseline includes the approved project scope.",
    "choice_c": "The project baseline includes the approved business justification.",
    "choice_d": "The project baseline includes the approved project quality plan.",
    "correct_answer": [
      "B",
      "D",
      "F",
      "G"
    ],
    "explanation": "The project baseline includes the approved schedule, cost, scope, and quality plans and documents and is approved by the project sponsor. The project baseline is then used to measure performance as the project progresses. You can refer back to the project baseline at any time to determine whether you are on schedule, within scope, and within budget, and to determine whether the quality standards are on target.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      84,
      132,
      203,
      149,
      134
    ],
    "source": "892458_c03",
    "choice_e": "The project baseline includes the approved project request.",
    "choice_f": "The project baseline includes the approved project schedule.",
    "choice_g": "The project baseline is approved by the project sponsor."
  },
  {
    "id": 489,
    "question": "Which of the following is true concerning the project charter?",
    "choice_a": "Describes the project schedule",
    "choice_b": "Contains cost estimates for each task",
    "choice_c": "Authorizes the start of the project work",
    "choice_d": "Lists the responsibilities of the project selection committee",
    "correct_answer": "C",
    "explanation": "The project charter formally approves the project and authorizes work to begin. The project schedule and cost estimates are developed later in the Planning process.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      67,
      8,
      9,
      84
    ],
    "source": "892458_c03"
  },
  {
    "id": 490,
    "question": "Which of the following is performed once the project charter is signed?",
    "choice_a": "You should hold a project kickoff meeting.",
    "choice_b": "You should write the preliminary scope statement.",
    "choice_c": "You should begin the Planning phase.",
    "choice_d": "You should develop the project schedule.",
    "correct_answer": "A",
    "explanation": "After the project charter is signed and approved, you should hold a kickoff meeting with key stakeholders and key team members to discuss the goals of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      76,
      81,
      77,
      79,
      8
    ],
    "source": "892458_c03"
  },
  {
    "id": 491,
    "question": "This software system manages the life cycle of these items that starts with creation, use, maintenance, and archival or disposal.",
    "choice_a": "Enterprise resource planning system",
    "choice_b": "Customer relationship management system",
    "choice_c": "Records management system",
    "choice_d": "Cloud management system",
    "correct_answer": "C",
    "explanation": "A records management system manages records according to the life cycle of records and the processes defined by the records management plan.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      165,
      84,
      132,
      11,
      14
    ],
    "source": "892458_c03"
  },
  {
    "id": 492,
    "question": "This stakeholder analysis tool is most useful on small projects where it\u2019s easier to identify the relationship. It\u2019s a quadrant that describes how to maintain relationships, including whether you should meet expectations, maintain good relationships, keep stakeholders updated, or keep them engaged and informed.",
    "choice_a": "Salience model",
    "choice_b": "Prioritization model",
    "choice_c": "Stakeholder cube",
    "choice_d": "Power/interest grid",
    "correct_answer": "D",
    "explanation": "A power/interest grid is a quadrant grid with power on one axis and interest on the other.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      16,
      59,
      208,
      236,
      79
    ],
    "source": "892458_c03"
  },
  {
    "id": 493,
    "question": "Your project involves implementing a new human resources system. Certain roles with the human resources department will have differing levels of access. The director of human resources can access all human resources\u2013related data while a recruiting manager may only access applicant data. Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "This describes the functions each stakeholder will perform for testing purposes.",
    "choice_b": "This describes an access control system that restricts access to data based on roles.",
    "choice_c": "This describes one of the success criteria for the project.",
    "choice_d": "You should implement the principle of least privilege to guard against cyberattacks.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "An access control system restricts access to systems, data, functions, and more. You should implement the principle of least privilege to guard against cyberattacks.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      206,
      71,
      66,
      78,
      93
    ],
    "source": "892458_c03"
  },
  {
    "id": 494,
    "question": "You have just defined the major events for the project that will be used to determine and measure checkpoints throughout the project and determine whether the project is on time. What are they?",
    "choice_a": "Deliverables",
    "choice_b": "Objectives",
    "choice_c": "Milestones",
    "choice_d": "Tasks",
    "correct_answer": "C",
    "explanation": "Milestones are major events in a project that are used to measure progress. They may also mark when key deliverables are completed and approved. Milestones are also used as checkpoints during the project to determine whether the project is on time and on schedule.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      90,
      95,
      320,
      89,
      253
    ],
    "source": "892458_c03"
  },
  {
    "id": 495,
    "question": "Identify the items that should <i>not</i> be included in a project charter. (Choose two.)",
    "choice_a": "High-level budget",
    "choice_b": "Project objectives",
    "choice_c": "High-level cost\u2013benefit analysis",
    "choice_d": "Equipment and resources",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The project charter does not include a high-level cost\u2013benefit analysis, or the equipment and resources needed for the project. The business case is where the cost\u2013benefit analysis is documented.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      66,
      14,
      68,
      69,
      70
    ],
    "source": "892458_c03",
    "choice_e": "Project description",
    "choice_f": "High-level list of risks"
  },
  {
    "id": 496,
    "question": "Greg is a key technical resource for your project. You\u2019ve worked with Greg on past projects and have identified him as one of the team members who will work on the project. The charter has been published, and there is great excitement about this project. You\u2019ve scheduled a meeting to talk to Greg\u2019s manager next week about his participation on the project. Which of the following conditions does this describe?",
    "choice_a": "Risk",
    "choice_b": "Assumption",
    "choice_c": "Deliverable",
    "choice_d": "Constraint",
    "correct_answer": "B",
    "explanation": "Assumptions are things believed to be true. In this case, you have not verified Greg\u2019s availability and are assuming the functional manager will agree to assign him to the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      62,
      160,
      53,
      24
    ],
    "source": "892458_c03"
  },
  {
    "id": 497,
    "question": "Which of the following does <i>not</i> describe a constraint?",
    "choice_a": "The project team is directed to report to the main headquarters for all project meetings.",
    "choice_b": "The budget is $1.8 million.",
    "choice_c": "The deadline to complete the project is June 27.",
    "choice_d": "The project sponsor will remain the sponsor for the duration of the project.",
    "correct_answer": "D",
    "explanation": "Constraints restrict or dictate the actions of the project team and may take the form of budget, resources, schedules, or other limitations. Situations believed to be true are assumptions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      200,
      177,
      6,
      248
    ],
    "source": "892458_c03"
  },
  {
    "id": 498,
    "question": "The scope statement provides which of the following?",
    "choice_a": "A basis for a common understanding of the project and for making future decisions regarding the project",
    "choice_b": "A detailed list of all resources required for project completion",
    "choice_c": "A schedule of all the key project activities",
    "choice_d": "A process for managing change control",
    "correct_answer": "A",
    "explanation": "The scope statement serves as a basis for understanding the work of the project and for future decision-making.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      82,
      84,
      92,
      69,
      99
    ],
    "source": "892458_c04"
  },
  {
    "id": 499,
    "question": "Which of the following are components of a scope statement? (Choose three.)",
    "choice_a": "General project approach",
    "choice_b": "Project description",
    "choice_c": "Assumptions and constraints",
    "choice_d": "Exclusions",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The sections of a scope statement are project description, key deliverables, success and acceptance criteria, exclusions, time and cost estimates, assumptions, and constraints.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      122,
      92,
      96,
      68
    ],
    "source": "892458_c04",
    "choice_e": "Stakeholder list",
    "choice_f": "High-level milestones",
    "choice_g": "Change request process"
  },
  {
    "id": 500,
    "question": "Which of the following describes influencers?",
    "choice_a": "Influencers can impact, change, or create a new constraint.",
    "choice_b": "Scope creep is an example of an influencer.",
    "choice_c": "Change request is an influencer.",
    "choice_d": "Interaction between constraints is an example of an influencer.",
    "correct_answer": "E",
    "explanation": "All of the options describe and provide examples of influences.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      57,
      55,
      56,
      289
    ],
    "source": "892458_c04",
    "choice_e": "All of the above.",
    "choice_f": "A, B, D."
  },
  {
    "id": 501,
    "question": "Which of the following involves changing the project or product scope without considering the impacts it will have to the project schedule, budget, and scope statement?",
    "choice_a": "Change request",
    "choice_b": "Scope creep",
    "choice_c": "Stakeholder/management directive",
    "choice_d": "Quality deficiency",
    "correct_answer": "B",
    "explanation": "Scope creep involves changing the product or project scope without regard to impacts to the schedule, budget, and/or resources. KPIs are key performance indicators that help you incrementally monitor project performance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      86,
      288,
      91,
      131
    ],
    "source": "892458_c04"
  },
  {
    "id": 502,
    "question": "There are three primary constraints on most projects. Your customer, or project sponsor, will stipulate which of the three is the most important to them. Which three are the typical constraints found on the majority of projects? (Choose three.)",
    "choice_a": "Budget",
    "choice_b": "Team members",
    "choice_c": "Scope",
    "choice_d": "Quality",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "They are budget, scope, and time, all of which impact quality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      248,
      91,
      56,
      53
    ],
    "source": "892458_c04",
    "choice_e": "Time",
    "choice_f": "Sponsors and stakeholders",
    "choice_g": "Scope management plan"
  },
  {
    "id": 503,
    "question": "Your sprint is nearing completion. The product owner reminds you they will not accept the deliverable unless it measures 3 centimeters exactly. If the measurements are off, the next sprint will be delayed, and the entire project could be at risk. This is an example of which of the following?",
    "choice_a": "Acceptance criteria",
    "choice_b": "Change request",
    "choice_c": "Stability of scope",
    "choice_d": "Product scope description",
    "correct_answer": "A",
    "explanation": "This is an example of acceptance criteria for the user story.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      69,
      327,
      262,
      156
    ],
    "source": "892458_c04"
  },
  {
    "id": 504,
    "question": "Agile project life cycle methodologies are characterized by which of the following? (Choose three.)",
    "choice_a": "Dividing tasks into small deliverables that can be completed in a short time frame.",
    "choice_b": "Using a step-by-step process where one task is completed followed by another.",
    "choice_c": "This methodology is used primarily in the software development industry but can be applied across other industry areas.",
    "choice_d": "This methodology allows the project team to quickly adapt to new requirements and receive continuous feedback.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Option B describes the waterfall, or predictive, process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      133,
      158,
      300,
      120
    ],
    "source": "892458_c04"
  },
  {
    "id": 505,
    "question": "Which of the following agile methodologies describes the seven wastes?",
    "choice_a": "Scrum",
    "choice_b": "Six Sigma",
    "choice_c": "Kaizen",
    "choice_d": "Kanban",
    "correct_answer": "C",
    "explanation": "The seven wastes are associated with Kaizen, a lean methodology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      107,
      300,
      112,
      158
    ],
    "source": "892458_c04"
  },
  {
    "id": 506,
    "question": "Which of the following agile methodologies are a type of pull system? (Choose two.)",
    "choice_a": "Kaizen",
    "choice_b": "AUP",
    "choice_c": "Lean",
    "choice_d": "XP",
    "correct_answer": [
      "E",
      "F"
    ],
    "explanation": "Scrum and Kanban are considered pull systems because user stories are moved from one point in the process to the next, thereby freeing up space to pull other user stories from the backlog.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      108,
      113,
      300,
      107
    ],
    "source": "892458_c04",
    "choice_e": "Scrum",
    "choice_f": "Kanban"
  },
  {
    "id": 507,
    "question": "Which agile methodology strongly encourages teams to sit in collocated workspaces and programmers make use of refactoring techniques?",
    "choice_a": "FDD",
    "choice_b": "XP",
    "choice_c": "Scrum",
    "choice_d": "Kanban",
    "correct_answer": "B",
    "explanation": "Extreme Programming (XP) strongly encourages collocation of team members. Refactoring reduces duplication and eliminates poor code.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      112,
      107,
      119,
      161
    ],
    "source": "892458_c04"
  },
  {
    "id": 508,
    "question": "Which of the following are characteristics of a waterfall methodology? (Choose three.)",
    "choice_a": "The results of the work of the project are often not delivered until the end of the project.",
    "choice_b": "This methodology requires continuous feedback from your stakeholders throughout the project.",
    "choice_c": "Changes to the project require a review of project plans and documenting the changes in the project plan.",
    "choice_d": "Predictive methodologies might use a phased approach where deliverables are produced at the end of each phase.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The agile methodologies require close contact with the stakeholders, and this provides continuous feedback to the project team throughout the project. In a waterfall approach, stakeholders typically have a lot of contact and involvement with the team at the beginning of the project, and this involvement tapers off toward the end of the project. Option E also describes an agile methodology approach. Waterfall, or predictive, methodologies do not have iterative reviews, and changes are rigorously controlled and managed.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      106,
      133,
      107,
      112,
      51
    ],
    "source": "892458_c04",
    "choice_e": "The project team reviews the work of the project with the stakeholders in an iterative fashion so that they can incorporate modifications to functionality in the next phase."
  },
  {
    "id": 509,
    "question": "Which of the following are true regarding the <i>Agile Manifesto</i>? (Choose two.)",
    "choice_a": "It is concerned with the quality of the deliverable.",
    "choice_b": "Success is measured in incremental steps.",
    "choice_c": "The focus is on the value to the customer.",
    "choice_d": "It measures how efficient the process was performed.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The <i>Agile Manifesto</i> focuses on value to the customer, not in measuring processes or the quality of deliverables. Success is measured in incremental steps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      153,
      89,
      320,
      209
    ],
    "source": "892458_c04",
    "choice_e": "It is concerned with business process improvements."
  },
  {
    "id": 510,
    "question": "Your project team has a solid idea of the requirements for the project up front. Some specific elements of the deliverables are known at this point. Not all deliverables have been completely defined yet. The team would like to start with the known requirements and specific deliverables and then change their approach later in the development phase to incrementally deliver results. What development life cycle does this describe?",
    "choice_a": "Incremental",
    "choice_b": "Predictive",
    "choice_c": "Hybrid",
    "choice_d": "Agile",
    "correct_answer": "C",
    "explanation": "This describes a hybrid development life cycle. Early on, requirements might be gathered in detail, and as the project progresses, the team reverts to an agile approach to deliver functionality incrementally.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      123,
      113,
      133,
      101,
      106
    ],
    "source": "892458_c04"
  },
  {
    "id": 511,
    "question": "You are using an agile project management methodology to deliver your project. During each iteration, you and the team members are breaking down tasks into tangible components that have enough features and functionality to allow the customer to examine value and provide feedback to the team. Which of the following are true regarding this question when using a Scrum methodology? (Choose two.)",
    "choice_a": "The product owner will determine whether the requirements have been achieved.",
    "choice_b": "The project team will manage and prioritize the product backlog and choose the user stories for the upcoming sprint that can be broken down to the minimum viable product.",
    "choice_c": "The Scrum master will assist the team in breaking down the user stories and assign each team member tasks for the upcoming iteration.",
    "choice_d": "You are creating the minimum viable product.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The minimum viable product is a component of work, or a task, that\u2019s been broken down into the lowest tangible feature, function, or result possible. The product owner is responsible for determining if the requirements have been met. The project team does not manage or prioritize the backlog; the product owner does. The Scrum master is a facilitator. Team members do not report to the Scrum master, and they do not assign tasks to team members. The Scrum team is self-directed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      119,
      117,
      158,
      157
    ],
    "source": "892458_c04"
  },
  {
    "id": 512,
    "question": "Which of the following are true regarding assisting the team in subdividing tasks into the minimum viable product?",
    "choice_a": "Each iteration will produce enough features to examine whether the product is viable.",
    "choice_b": "Each iteration will provide an opportunity for feedback on future iterations.",
    "choice_c": "The minimum viable product allows the customer to see or experience the results and business value that was created.",
    "choice_d": "All the options are correct.",
    "correct_answer": "D",
    "explanation": "All of the options are true regarding the minimum viable product.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      128,
      94,
      69,
      84,
      10
    ],
    "source": "892458_c04"
  },
  {
    "id": 513,
    "question": "You are working on a project where the requirements and scope are well-defined, but you know there will be changes when performing the work of the project. Your stakeholders will need to provide continuous feedback during the development stages of this project. Which of the following are true when determining the deliverables for the project? (Choose three.)",
    "choice_a": "You should use a waterfall approach to manage this project. You will document a project scope statement because it describes how the team will define and develop the work breakdown structure.",
    "choice_b": "You should use a hybrid approach for this project. Because the requirements and deliverables are well-defined, you may choose to document a project scope statement that further elaborates the deliverables of the project and serves as a basis for future project decisions.",
    "choice_c": "You should document the project scope statement so there is agreement between the project management team and the project customer and everyone knows what the work of the project will produce.",
    "choice_d": "You may choose to document the project scope statement because it assesses the reliability of the project scope and describes the process for verifying and accepting completed deliverables.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The project scope statement further elaborates the project deliverables and documents the product scope description, acceptance criteria, and project exclusions. It serves as a basis for future project decisions. It is an agreement between the project team and customer on the precise work of the project. This question describes a hybrid approach, so you could use either a project scope statement or a product backlog to compile user stories, which are the deliverables and requirements for the project. Options A and D describe the scope management plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      117,
      86,
      127,
      286
    ],
    "source": "892458_c04",
    "choice_e": "You should use a hybrid approach for this project because the stakeholders would like to provide continuous feedback on the deliverables once the work of the project starts. User stories will be used to fulfill the deliverables of the project and will be pulled to the backlog."
  },
  {
    "id": 514,
    "question": "You are a project manager for a plumbing supply company and are heading up a project that will replace the current inventory system. You have interviewed stakeholders and gathered their project requirements. Which of the following is true regarding this question?",
    "choice_a": "The requirements traceability matrix ties requirements to project objectives, business needs, WBS deliverables, product design, and test strategies and traces them through to project completion.",
    "choice_b": "Requirements documentation consists of formal, complex documents that include elements such as the business need of the project, functional requirements, nonfunctional requirements, impacts to others inside and outside the organization, and requirements assumptions and constraints.",
    "choice_c": "The requirements documentation details the work required to create the deliverables of the project, including deliverables description, product acceptance criteria, exclusions from requirements, and requirements assumptions and constraints.",
    "choice_d": "The requirements document lists the requirements and describes how they will be analyzed, documented, and managed throughout the project.",
    "correct_answer": "A",
    "explanation": "The requirements traceability matrix links requirements to their origin and traces them throughout the project. Option B is partially true but does not include the business need of the project, assumptions, or constraints. Requirements documents do not have to be formal or complex. Option C refers to the project scope statement, not the requirements. Option D describes a requirements management plan, not the requirements document.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      99,
      98,
      68,
      64,
      84
    ],
    "source": "892458_c04"
  },
  {
    "id": 515,
    "question": "This person assists the business analyst in requirements gathering and serves as a translator of sorts between the business and development team. They are responsible for ensuring the technical solution will solve the business problem. What role does this question describe?",
    "choice_a": "Enterprise architect",
    "choice_b": "Scrum master",
    "choice_c": "Solutions architect",
    "choice_d": "Project manager",
    "correct_answer": "C",
    "explanation": "The solutions architect may assist the business analyst in requirements gathering to understand the needs and to be able to relay this information, in technical terms, to the team.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      121,
      57,
      58,
      54,
      50
    ],
    "source": "892458_c04"
  },
  {
    "id": 516,
    "question": "Which framework combines teams from different areas in IT to deliver projects faster, provide more reliable systems, and improve collaboration and communication among team members?",
    "choice_a": "XP",
    "choice_b": "DevOps",
    "choice_c": "PRINCE2",
    "choice_d": "FDD",
    "correct_answer": "B",
    "explanation": "DevOps and DevSecOps combines the operations, development, and security team (in the case of DevSecOps) to deliver projects faster and encourage collaboration and communication among the team members.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      120,
      121,
      245,
      23
    ],
    "source": "892458_c04"
  },
  {
    "id": 517,
    "question": "Which of the following is a characteristic of a WBS?",
    "choice_a": "A cost center structure for the project that describes the work of the project and the costs per work component to complete the deliverable",
    "choice_b": "A deliverables-oriented chart of the work of the project, with assignments showing the project teams responsible for the work components",
    "choice_c": "A deliverables-oriented structure that describes the detailed tasks required to complete the deliverables",
    "choice_d": "A deliverables-oriented structure that defines the work of the project",
    "correct_answer": "D",
    "explanation": "A WBS is a deliverables-oriented hierarchy that defines the work of the project and can be used on projects of any size or complexity.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      128,
      85,
      132,
      7,
      76
    ],
    "source": "892458_c05"
  },
  {
    "id": 518,
    "question": "A WBS is created using a technique called decomposition. What is decomposition?",
    "choice_a": "Matching resources with deliverables",
    "choice_b": "Breaking down the project deliverables into smaller, more manageable components",
    "choice_c": "Estimating the cost of each individual deliverable",
    "choice_d": "Creating a detailed to-do list for each work package",
    "correct_answer": "B",
    "explanation": "Decomposition breaks the major deliverables down into smaller, more manageable units of work that can be used to estimate cost and time and perform resource planning.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      85,
      94,
      69,
      143
    ],
    "source": "892458_c05"
  },
  {
    "id": 519,
    "question": "What is the lowest level of the WBS?",
    "choice_a": "Work package",
    "choice_b": "Level 5",
    "choice_c": "Milestone",
    "choice_d": "Activities",
    "correct_answer": "A",
    "explanation": "The lowest level of a WBS is the work package. The number of levels will vary by project and complexity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      84,
      12,
      85,
      134
    ],
    "source": "892458_c05"
  },
  {
    "id": 520,
    "question": "Which of the following is not a benefit of a WBS?",
    "choice_a": "A WBS is an excellent tool for team building.",
    "choice_b": "A WBS helps prevents critical work from being overlooked.",
    "choice_c": "A WBS can become a template for future projects.",
    "choice_d": "A WBS can be used to describe how the deliverables will be validated.",
    "correct_answer": "D",
    "explanation": "The scope management plan, not the WBS, describes how the deliverables will be validated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      84,
      122,
      69,
      93
    ],
    "source": "892458_c05"
  },
  {
    "id": 521,
    "question": "All of the following are true regarding code of accounts identifiers except for which one?",
    "choice_a": "They are unique numbers for each component on the WBS.",
    "choice_b": "They are documented in the WBS dictionary.",
    "choice_c": "They are tied to the organization\u2019s chart of accounts.",
    "choice_d": "They are assigned to the resources who are associated with the work package level.",
    "correct_answer": "D",
    "explanation": "The code of accounts identifier is a unique number assigned to each component of the WBS. It is documented in the WBS dictionary and is tied to the chart of accounts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      98,
      206,
      11,
      93
    ],
    "source": "892458_c05"
  },
  {
    "id": 522,
    "question": "Your team has already created a WBS for the ABC product launch project. You are kicking off phase II of this project, which is the product Development phase. Which of the following is an example of what might appear in the second level of your project\u2019s WBS?",
    "choice_a": "ABC Product Launch Project",
    "choice_b": "Project deliverables",
    "choice_c": "Project phases",
    "choice_d": "Activities",
    "correct_answer": "C",
    "explanation": "The first level of the WBS is the project name, in this case ABC Product Launch. The second level of the WBS represents major project deliverables, project phases, or subprojects. If the project has phases or subprojects, these are listed at the second level, with deliverables listed at the third level. Since the question asks about phase II of the project and option C is project phases, this is the correct second-level entry for the WBS.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      128,
      9,
      12,
      103,
      84
    ],
    "source": "892458_c05"
  },
  {
    "id": 523,
    "question": "Which of the following is not true for the critical path?",
    "choice_a": "It has zero float.",
    "choice_b": "It\u2019s the shortest activity sequence in the network.",
    "choice_c": "You can determine which tasks can start late without impacting the project end date.",
    "choice_d": "It controls the project finish date.",
    "correct_answer": "B",
    "explanation": "The critical path is the longest path on the project. The tasks have zero float because the critical path controls the project end date. Using critical path, you can determine which tasks can start late or go longer than planned without impacting the project end date.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      144,
      147,
      136,
      210,
      248
    ],
    "source": "892458_c05"
  },
  {
    "id": 524,
    "question": "You are a project manager for a major movie studio. You need to schedule a shoot in Vail, Colorado during ski season. This is an example of which of the following?",
    "choice_a": "External dependency",
    "choice_b": "Finish-to-start relationship",
    "choice_c": "Mandatory dependency",
    "choice_d": "Discretionary dependency",
    "correct_answer": "A",
    "explanation": "A requirement such as weather conditions or a specific season that drives the scheduling of a task is an example of an external dependency.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      144,
      136,
      86,
      88
    ],
    "source": "892458_c05"
  },
  {
    "id": 525,
    "question": "What is analogous estimating also referred to as?",
    "choice_a": "Bottom-up estimating",
    "choice_b": "Expert judgment",
    "choice_c": "Parametric estimating",
    "choice_d": "Top-down estimating",
    "correct_answer": "D",
    "explanation": "Analogous estimating is also called top-down estimating. It is used early in the project when there is not enough detail to do a detailed estimate.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      198,
      142,
      201,
      199,
      200
    ],
    "source": "892458_c05"
  },
  {
    "id": 526,
    "question": "You are working on your network diagram. Activity A is a predecessor to Activity B. Activity B cannot begin until Activity A is completed. What is this telling you?",
    "choice_a": "There is a mandatory dependency between Activity A and Activity B.",
    "choice_b": "There is a finish-to-start dependency relationship between Activity A and Activity B.",
    "choice_c": "Activity A and Activity B are both on the critical path.",
    "choice_d": "Activity B is a successor to multiple tasks.",
    "correct_answer": "B",
    "explanation": "There is a finish-to-start dependency relationship between Activity A and Activity B. You do not have enough information to determine whether the dependency between the two activities is mandatory, discretionary, or external or if they are critical path activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      144,
      86,
      136,
      88
    ],
    "source": "892458_c05"
  },
  {
    "id": 527,
    "question": "What are the crashing and fast-track techniques used for?",
    "choice_a": "Duration compression",
    "choice_b": "Activity sequencing",
    "choice_c": "Precedence diagramming",
    "choice_d": "Task definition",
    "correct_answer": "A",
    "explanation": "Duration compression involves either crashing the schedule by adding more resources or creating a fast track by working activities in parallel that would normally be done in sequence.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      144,
      142,
      135,
      151
    ],
    "source": "892458_c05"
  },
  {
    "id": 528,
    "question": "Which of the following is true for float?",
    "choice_a": "It\u2019s calculated by adding the durations of all tasks and dividing by the number of tasks.",
    "choice_b": "It\u2019s time that you add to the project schedule to provide a buffer or contingency.",
    "choice_c": "It\u2019s the amount of time an activity can be delayed without affecting the project completion date.",
    "choice_d": "It is calculated only on the longest path of the project schedule.",
    "correct_answer": "C",
    "explanation": "Float time is the length of time a task may be started late or the additional duration a task may take without impacting the project completion date. The early start and late start dates are the same, and the early finish and late start finish dates are the same.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      144,
      137,
      151,
      147,
      142
    ],
    "source": "892458_c05"
  },
  {
    "id": 529,
    "question": "Activity B on your project schedule starts on Monday, October 3, and ends on Wednesday, October 12. You calculate duration in workdays, and the team does not work on Saturdays or Sundays. How many days is the total duration of this task in workdays?",
    "choice_a": "9 days",
    "choice_b": "10 days",
    "choice_c": "8 days",
    "choice_d": "7 days",
    "correct_answer": "C",
    "explanation": "The total workday duration is 8 days. The first day counts as one full day.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      141,
      142,
      144,
      137,
      136
    ],
    "source": "892458_c05"
  },
  {
    "id": 530,
    "question": "You have been hired as a contract project manager for Grapevine Vineyards. You have been told to use an agile methodology to develop this project. Grapevine wants you to design an Internet wine club for its customers. You\u2019ll need to develop a programming routine for customers to register with Grapevine before being allowed to order wine so that legal age can be established. You will also develop a module to allow customers to pick wine selections for the month based on their preferences. Lastly, you also need to develop a module to determine inventory on hand, which will interface with the monthly wine selection code. Which of the following techniques is the most beneficial for completing the work of this project?",
    "choice_a": "Using agile release planning, because this is a large project that can be broken into releases and user stories can be created for each release",
    "choice_b": "Using a Kanban board, because this is a large project that can be broken into releases that can be easily managed in small increments of time",
    "choice_c": "Using a Scrum board, because this is a large project that can be broken into releases that can be easily managed as resources are available",
    "choice_d": "Using epics, because this is a large project that can be broken into releases and user stories can be created for each release",
    "correct_answer": "A",
    "explanation": "Agile release planning is the best option for the project described. Release planning breaks a large project into releases, similar to phases, that can be accomplished using either Kanban or Scrum, or other agile methodologies to complete. Option B describes Kanban with the exception of the last part of the sentence. Kanban is capacity-based, not time- based. Option C describes Scrum but it is time- based, not capacity-based. Epics are placeholders, large user stories, or descriptions of features or functionality for the project. These modules or releases could be considered epics; however, epics are not a method of planning or implementing the project. They are placeholders for big ideas.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      300,
      113,
      153,
      118,
      136
    ],
    "source": "892458_c05"
  },
  {
    "id": 531,
    "question": "Your task requires 4 miles of paving, and it will take 30 hours to complete one mile. On a past project similar to this one, it took 150 hours to complete. Which of the following is true regarding this estimate?",
    "choice_a": "The total estimate for this task is 120 hours, which was derived using expert judgment.",
    "choice_b": "The total estimate for this task is 120 hours, which was derived using parametric estimating.",
    "choice_c": "The total estimate for this task is 150 hours, which was derived using analogous estimating.",
    "choice_d": "The total estimate for this task is 150 hours, which was derived using expert judgment.",
    "correct_answer": "B",
    "explanation": "If you didn\u2019t know the quantity and rate, option C or D would be acceptable. In this case, you\u2019d use the parametric estimating technique because you do know the quantity and rate; 30 hours times 4 miles is a total duration of 120 hours.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      142,
      198,
      141,
      199,
      201
    ],
    "source": "892458_c05"
  },
  {
    "id": 532,
    "question": "All of the following are true regarding milestone charts except for which one?",
    "choice_a": "Milestone charts list the major deliverables or phases of a project.",
    "choice_b": "Milestone charts show the scheduled completion dates.",
    "choice_c": "Milestone charts show the actual completion dates.",
    "choice_d": "Milestone charts are commonly displayed in bar chart format.",
    "correct_answer": "D",
    "explanation": "Milestone charts list the major deliverables, key events, or project phases and show the scheduled and actual completion dates of each milestone. They may include other information, but that information would not be displayed as bar charts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      267,
      154,
      212,
      310
    ],
    "source": "892458_c05"
  },
  {
    "id": 533,
    "question": "Your Scrum team\u2019s velocity rate is 24 story points per iteration. There are 165 total story points. Which of the following statements are true regarding this question? (Choose two.)",
    "choice_a": "Velocity is used to estimate the capacity of the Scrum team.",
    "choice_b": "This information can be tracked on a burndown chart.",
    "choice_c": "The project needs 7 iterations to complete all of the work of the project.",
    "choice_d": "A Kanban board can display this information.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Velocity is used to determine how long it will take to complete the work of the iteration. It measures the speed the team progresses, not capacity as stated in Option A. In this case, it will take seven iterations to complete the work (165 story points / 24 story points per iteration). The remaining work for each of the seven iterations can be tracked on a burndown chart. Kanban boards display work based on capacity and this questions is asking about velocity, or speed of work.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      155,
      108,
      157,
      109,
      210
    ],
    "source": "892458_c05"
  },
  {
    "id": 534,
    "question": "Which of the following describes the difference between a Kanban board and a Scrum board?",
    "choice_a": "A Scrum board is capacity-based.",
    "choice_b": "A Kanban board is known as on-demand scheduling.",
    "choice_c": "A Scrum board is developed using rolling wave planning.",
    "choice_d": "A Kanban board is capacity-based.",
    "correct_answer": "D",
    "explanation": "A Kanban board is capacity-based and a Scrum board is time-bound. Both Kanban and Scrum boards are known as on-demand scheduling, and both may use rolling wave planning and progressive elaboration.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      108,
      109,
      113,
      300,
      118
    ],
    "source": "892458_c05"
  },
  {
    "id": 535,
    "question": "Which of the following options describes iterative scheduling? (Choose two.)",
    "choice_a": "User stories are pulled from the product backlog as the team has the capacity to work on them.",
    "choice_b": "User stories are decomposed into tasks and managed on a task board. Tasks cannot proceed from one work column to another on the board until the team has the capacity to work on them.",
    "choice_c": "User stories are pulled from the product backlog and placed on the sprint backlog for the team to work on in the upcoming sprint.",
    "choice_d": "User stories that are in the sprint backlog will be decomposed into tasks and team members will choose the tasks they want to work on during the sprint.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Options C and D describe iterative scheduling. Options A and B describe on-demand scheduling or pull-based scheduling.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      158,
      109,
      116,
      123
    ],
    "source": "892458_c05"
  },
  {
    "id": 536,
    "question": "Your project entails developing an app that will unlock your front door to allow deliveries from your favorite online services. The app will unlock the front door, detect and record how long the door was open, detect that a package or box was deposited on a delivery mat that is just inside the door, and then relock the door 60 seconds after the mat senses a package was placed there. At the beginning of the sprint, the product owner will pull the user stories that should be worked on during the upcoming sprint and team members will break them down into tasks and estimate their durations. Which of the following are true regarding this question?",
    "choice_a": "The product owner will develop the project timeline based on the estimates the team members give for each sprint.",
    "choice_b": "This question describes the sprint planning meeting that is held at the beginning of each sprint.",
    "choice_c": "The Scrum master will provide the team with the tools and techniques that will work best to break down tasks and determine estimates.",
    "choice_d": "This question describes agile release planning because it\u2019s a large project that can be broken down into releases and then user stories can be created for each release.",
    "correct_answer": "B",
    "explanation": "This question describes the sprint planning meeting. The product owner does not determine the project timeline\u2014the team determines this with assistance from the Scrum master. An agile team is self-directed, and they will determine the tools and techniques that will work best to break down tasks and determine estimates. This question does not describe a large project conducive to release planning.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      119,
      108,
      117,
      140
    ],
    "source": "892458_c05"
  },
  {
    "id": 537,
    "question": "Your project is underway, and your team members are working well together, anticipating the needs of the project, and they all understand their roles in the project. A new team member has been introduced and started working with the team this week. Which stage of team development does this situation represent?",
    "choice_a": "Forming",
    "choice_b": "Storming",
    "choice_c": "Performing",
    "choice_d": "Norming",
    "correct_answer": "A",
    "explanation": "When a new team member is introduced on the project, the team development stage starts again at the forming stage, no matter which stage the team was in before.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      172,
      173,
      168,
      245,
      296
    ],
    "source": "892458_c06",
    "choice_e": "Adjourning"
  },
  {
    "id": 538,
    "question": "Which type of contract assigns a unit rate for work or goods, but the total cost is unknown?",
    "choice_a": "Time and materials",
    "choice_b": "Fixed price",
    "choice_c": "Cost plus incentive fee",
    "choice_d": "Cost reimbursable",
    "correct_answer": "A",
    "explanation": "Time and materials contracts are a cross between fixed-price and cost-reimbursable contracts. They assign a unit rate for work, but the total cost isn\u2019t known until the work is complete.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      198,
      199,
      200,
      214,
      209
    ],
    "source": "892458_c06"
  },
  {
    "id": 539,
    "question": "A team member has come to your office to complain that a fellow team member is never available for meetings before noon and seems to ignore their requests to follow proper processes. Which of the following does this describe? (Choose two.)",
    "choice_a": "This describes an interproject resource contention.",
    "choice_b": "This describes a low-quality resource.",
    "choice_c": "This describes a conflict.",
    "choice_d": "This describes a situation where the negotiating conflict technique should be used.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "This situation describes varying work styles, which are a common cause of conflict. An interproject resource contention is where resources are working on multiple projects and there are scheduling issues. Low-quality resources lack skills or abilities. The negotiating conflict technique often uses a third party to help the two conflicting sides reach a resolution.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      177,
      179,
      241,
      174,
      24
    ],
    "source": "892458_c06",
    "choice_e": "This describes varying work styles."
  },
  {
    "id": 540,
    "question": "All of the following are stages of team development except for which one?",
    "choice_a": "Adjourning",
    "choice_b": "Collaborating",
    "choice_c": "Performing",
    "choice_d": "Storming",
    "correct_answer": "B",
    "explanation": "The stages of team development are forming, storming, norming, performing, and adjourning. Collaborating is a conflict-resolution technique.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      172,
      120,
      119,
      168,
      179
    ],
    "source": "892458_c06"
  },
  {
    "id": 541,
    "question": "What is one disadvantage of a projectized organization?",
    "choice_a": "The organization doesn\u2019t work on anything that isn\u2019t project-related.",
    "choice_b": "Costs are high because specialized skills are required to complete projects in this type of structure.",
    "choice_c": "The functional managers have control over which team members are assigned to projects.",
    "choice_d": "Once the project is completed, the project team members may not have other projects to work on.",
    "correct_answer": "D",
    "explanation": "The key problem with a projectized organization is that there may not be a new project in place at the conclusion of the one team members were released from. This leaves specialists \u201csitting on the bench\u201d with no work to do and is costly to the organization. It\u2019s an advantage to a projectized organization to work on projects. Costs aren\u2019t necessarily any higher in this type of organization than others. Costs will depend on the type of project you\u2019re working on, not the organizational structure. And the project managers have control over who works on the projects in a project-based organization.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      161,
      159,
      244,
      168,
      90
    ],
    "source": "892458_c06"
  },
  {
    "id": 542,
    "question": "Your project is undergoing some difficulties. You\u2019ve determined that the primary problem is vendor performance. A key stakeholder insists the problem is not the vendor; the problem is the project team. However, the key stakeholder spends most of the meeting emphasizing the areas of agreement. Which conflict-resolution technique does this describe?",
    "choice_a": "Avoiding",
    "choice_b": "Forcing",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "D",
    "explanation": "The smoothing conflict resolution technique is temporary, and one of its symptoms is emphasizing the areas of agreement and keeping the real issue buried.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      259,
      321,
      10,
      79
    ],
    "source": "892458_c06"
  },
  {
    "id": 543,
    "question": "Which vendor selection method weighs various criteria from the RFP, scores each vendor on each of the criteria, and determines an overall score for each vendor?",
    "choice_a": "Weighted scoring model",
    "choice_b": "Screening system",
    "choice_c": "Seller rating system",
    "choice_d": "Independent estimates",
    "correct_answer": "A",
    "explanation": "Weighted scoring models weigh various criteria from the RFP and SOW, which allows you to score each vendor on each of the criteria and determine an overall score for each vendor.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      185,
      20,
      15,
      276,
      277
    ],
    "source": "892458_c06"
  },
  {
    "id": 544,
    "question": "Which type of contract is the riskiest for the buyer?",
    "choice_a": "Time and materials",
    "choice_b": "Fixed price",
    "choice_c": "Fixed price plus incentive",
    "choice_d": "Cost reimbursable",
    "correct_answer": "D",
    "explanation": "Cost-reimbursable contracts are the riskiest for buyers since the buyer is responsible for reimbursing the seller on the costs of producing the goods or services.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      277,
      200,
      216,
      215
    ],
    "source": "892458_c06"
  },
  {
    "id": 545,
    "question": "Your system engineer has started making negative comments during your weekly team meeting. He has had a heated argument with the marketing manager, and you have heard from various team members that he has become difficult to work with. What is the best course of action for you to take?",
    "choice_a": "You should write a memo to the system engineer\u2019s functional manager and request a replacement as soon as possible.",
    "choice_b": "The system engineer is critical to the project, so you should give him some slack and wait to see whether the behavior stops.",
    "choice_c": "You should confront the system engineer openly at the next team meeting. Let him know that his behavior is unacceptable and that he will be replaced if there is not an immediate change.",
    "choice_d": "You should schedule an individual meeting with the system engineer to determine whether he has issues with the project that need to be resolved. Get his perspective on how the project is progressing and how he feels about his role.",
    "correct_answer": "D",
    "explanation": "To address the issue, you need to understand what is behind the system engineer\u2019s current behavior. He may have been given additional work that you are not aware of, or he may misunderstand the project goals, to name just a couple of possibilities. The situation cannot be ignored, no matter how valuable the person is, and it should be handled in private.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      179,
      173,
      230,
      51,
      26
    ],
    "source": "892458_c06"
  },
  {
    "id": 546,
    "question": "Which of the following is true regarding a RACI chart? (Choose three.)",
    "choice_a": "A RACI chart shows roles and responsibilities of team members or business units and how they intersect with project tasks.",
    "choice_b": "RACI stands for responsible, approved, consulted, and informed.",
    "choice_c": "A RACI is a matrix-based chart.",
    "choice_d": "A RACI is a type of organization breakdown structure.",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "A RACI is a matrix-based chart that shows resources (or business units) responsible for project tasks. It stands for responsible, accountable, consulted, and informed. Accountable does mean this resource approves the work, but the A in RACI stands for accountable.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      8,
      12,
      59,
      236,
      76
    ],
    "source": "892458_c06",
    "choice_e": "RACI stands for responsible, accountable, consulted, and informed."
  },
  {
    "id": 547,
    "question": "All of the following are true regarding rewards and recognition except for which one?",
    "choice_a": "You should have a written procedure describing the criteria for rewarding team members.",
    "choice_b": "Rewards and recognition are a form of motivation.",
    "choice_c": "Rewards and recognition should be applied consistently to all project team members.",
    "choice_d": "Rewards and recognition almost always involve money.",
    "correct_answer": "D",
    "explanation": "Rewards and recognition do not have to involve money, and many times they may include rewards such as a thank-you, a letter to the functional manager, a public mention of the accomplishment at a team meeting, and so on.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      79,
      83,
      76,
      78,
      240
    ],
    "source": "892458_c06"
  },
  {
    "id": 548,
    "question": "You are working on a construction project. Your organization owns one crane, and the crane is needed for two tasks on your project at the same time. This is known as which of the following?",
    "choice_a": "Resource shortage",
    "choice_b": "Resource allocation",
    "choice_c": "Interproject dependencies",
    "choice_d": "Shared resource",
    "correct_answer": "A",
    "explanation": "This question refers to a resource shortage. You have one resource that\u2019s needed for two tasks. Resource allocation is assigning the resource with the right skills and abilities to the task. Interproject dependencies rely on one project finishing before the next can start, and shared resources are typically resources that are shared among departments or between the functional manager and the project manager.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      164,
      163,
      148,
      160,
      159
    ],
    "source": "892458_c06"
  },
  {
    "id": 549,
    "question": "You are working in a matrix organization. Choose two responses that describe this type of structure.",
    "choice_a": "Project resources are members of another business unit and may or may not be able to help you full-time.",
    "choice_b": "Matrix organizations can be structured as strong, weak, or balanced.",
    "choice_c": "Project managers have the majority of power in this type of structure.",
    "choice_d": "This organizational structure is similar to a functional organization.",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "A matrix organization can be structured as a strong, weak, or balanced matrix. Employees are assigned to projects by their functional managers, and the project tasks are assigned to them by the project manager. The project manager has the majority of power in a projectized organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      160,
      161,
      159,
      56,
      6
    ],
    "source": "892458_c06",
    "choice_e": "Employees are assigned project tasks by their project manager in this type of structure."
  },
  {
    "id": 550,
    "question": "The project sponsor will approve the final deliverables of the project. On a RACI chart, how would this be designated?",
    "choice_a": "R",
    "choice_b": "I",
    "choice_c": "A",
    "choice_d": "C",
    "correct_answer": "C",
    "explanation": "The RACI chart acronym stands for responsible, accountable, consulted, and informed. The person accountable also is an approver of the work.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      12,
      8,
      11,
      69,
      150
    ],
    "source": "892458_c06"
  },
  {
    "id": 551,
    "question": "Your team is working well together. They understand their roles on the project, perform the work with the best effort possible, and really enjoy working with one another. A new team member will be introduced next week who is well respected by the current team. Which of the following is true regarding this situation? (Choose two.)",
    "choice_a": "The team is currently in the performing stage of team development.",
    "choice_b": "Once the new team member is introduced, the team will revert to the forming stage of team development.",
    "choice_c": "The team is currently in the performing stage of team development and will stay in performing because they know the new team member.",
    "choice_d": "Once the new team member is introduced, the team will revert to the norming stage of team development.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Whenever a new team member is introduced, the team development stage reverts to the forming stage and progresses through all the stages once again with the new team member.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      173,
      168,
      120,
      296
    ],
    "source": "892458_c06",
    "choice_e": "The team is currently in the performing stage of team development and will revert to the storming stage of team development because they know the new team member."
  },
  {
    "id": 552,
    "question": "You are working on resource assignments and need to determine the types and criticality of the resources needed for the project, along with the skill sets of the existing project team members. If you don\u2019t have the skills on staff, you\u2019ll need to contract with an external vendor to procure the resources needed. You are examining resources that will need to be engaged for the entire project. What does this question describe? (Choose three.)",
    "choice_a": "These are extended resources.",
    "choice_b": "You are performing a gap analysis.",
    "choice_c": "These are core resources.",
    "choice_d": "The size of this team should be between 5 and 11 team members.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The resources this question describes are core resources because they are required for the entire project. Option D describes the team size for an agile development methodology. The question does not state what development methodology the project team is using, so there is not enough information to know if option D is correct. A waterfall project may have dozens of team members.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      168,
      169,
      162,
      163,
      26
    ],
    "source": "892458_c06",
    "choice_e": "You can procure resources much faster by using a prequalified vendor."
  },
  {
    "id": 553,
    "question": "All the following are elements of the project kickoff meeting except for which one?",
    "choice_a": "Introductions",
    "choice_b": "Overview of goals and objectives",
    "choice_c": "High-level budget overview",
    "choice_d": "Roles and responsibilities overview",
    "correct_answer": "E",
    "explanation": "The WBS is too detailed to review at a project kickoff meeting and is better handled during a meeting with project team members only.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      77,
      76,
      128,
      82,
      78
    ],
    "source": "892458_c06",
    "choice_e": "WBS overview",
    "choice_f": "Stakeholder expectations"
  },
  {
    "id": 554,
    "question": "Which conflict-resolution technique is known as win-lose?",
    "choice_a": "Smoothing",
    "choice_b": "Avoiding",
    "choice_c": "Confronting",
    "choice_d": "Forcing",
    "correct_answer": "D",
    "explanation": "Smoothing is lose-lose technique, forcing is win-lose, confronting is win-win, and avoiding is lose-lose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      321,
      223,
      287,
      313,
      260
    ],
    "source": "892458_c06"
  },
  {
    "id": 555,
    "question": "Resources who are awaiting new assignments between projects are costly to an organization and typically reside in a projectized organizational structure. Which of the following does this describe?",
    "choice_a": "Overallocated resources",
    "choice_b": "Benched resources",
    "choice_c": "In-house resources",
    "choice_d": "Remote resources",
    "correct_answer": "B",
    "explanation": "Benched resources are costly to an organization. These are resources who are not currently assigned to project tasks and are typically between projects. This generally occurs in a projectized organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      163,
      164,
      162,
      160
    ],
    "source": "892458_c06"
  },
  {
    "id": 556,
    "question": "One way you are presenting the work of the project is by listing the departments responsible for the work along the work packages they\u2019re assigned to. What type of chart is this?",
    "choice_a": "RBS",
    "choice_b": "Project organization chart",
    "choice_c": "OBS",
    "choice_d": "Organization chart",
    "correct_answer": "C",
    "explanation": "An organization breakdown structure shows work by the department or work unit responsible for completing the work packages. A resource breakdown structure shows the types of resources needed and the work packages. A project organization chart shows the hierarchy of the project team members, and an organization chart shows the hierarchy of the reporting structure within an organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      140,
      159,
      160,
      163,
      162
    ],
    "source": "892458_c06"
  },
  {
    "id": 557,
    "question": "You are creating a document that describes the access rights to the financial system in your organization. It defines access by roles and responsibilities and describes the approval process for obtaining access. One of the rules stated in the document dictates that remote access to systems requires MFA. Which of the following are true regarding this question? (Choose two.)",
    "choice_a": "This question describes an operational security policy.",
    "choice_b": "This question describes a digital security policy.",
    "choice_c": "This question describes a process of verifying identity by requiring two or more forms of identification at sign-in.",
    "choice_d": "This question describes a form of data classification.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "This question describes a digital security policy. Multifactor authentication uses at least two forms of verification of identity at the sign-in process.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      194,
      190,
      47,
      45,
      195
    ],
    "source": "892458_c07",
    "choice_e": "This question describes a data security policy."
  },
  {
    "id": 558,
    "question": "Your organization is involved in research and development of botanical cleaning products. Your recent product has just received approval to display the \u00ae (registered) symbol. All potential employees must undergo a background check before being hired and again yearly on the anniversary of their hire date. One of the laboratories contains top-secret research and only certain employees have access to this lab. One of the employees on the project team has just been promoted and will be leaving the team to join their new functional area. This team member previously had access to the top-secret lab, but their new role no longer requires this access. Which of the following is not true regarding this question?",
    "choice_a": "The operational security policy outlines the process for background checks for employees.",
    "choice_b": "Access to the top-secret lab is outlined in the physical security policy.",
    "choice_c": "The new product has not been registered at the U.S. Patent and Trademark office.",
    "choice_d": "The physical security policy should outline the process for revoking access to the top-secret lab as soon as the employee is transferred to their new role.",
    "correct_answer": "C",
    "explanation": "Registered products are those that have been trademarked and registered with the U.S. Patent and Trademark office.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      195,
      196,
      194,
      192
    ],
    "source": "892458_c07"
  },
  {
    "id": 559,
    "question": "A stranger comes to your door posing as a census taker. They look official in their bright orange vest and have some type of tag or badge hanging from the vest, but you can\u2019t read what it says. They begin to ask questions that become rather personal, including your household income on an annual basis, your birthdate, your health status, and more. You become suspicious of this person and stop to think through what to do next. Which of the following are true regarding this question?",
    "choice_a": "Due to your suspicion of this individual, you are classifying your answers as PII and refuse to answer.",
    "choice_b": "Due to your suspicion of this individual, you are classifying your answers as PHI and refuse to answer.",
    "choice_c": "Due to your suspicion of this individual, you ask to see their badge before you decide to answer.",
    "choice_d": "Due to your suspicion of this individual, you are classifying your answers as need-to-know basis and refuse to answer.",
    "correct_answer": "E",
    "explanation": "All of the options are true. You may still decide to refuse to answer after viewing their badge, as option C describes. You should always verify the identity of the person asking for personally identifiable information (PII).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      194,
      190,
      191
    ],
    "source": "892458_c07",
    "choice_e": "All of the answers are true.",
    "choice_f": "Options A, B, and D are true."
  },
  {
    "id": 560,
    "question": "You are asked to prepare an estimate for a project that involves planting new trees in the parking lot. The trees cost $800 each, and the labor to install them is $75 per hour. You are planting 10 new trees, and each tree takes one hour of labor to plant, stake, and water. What is the estimated cost of the labor for this project, and which technique are you using to determine this estimate? (Choose two.)",
    "choice_a": "$8,000",
    "choice_b": "Three-point estimate",
    "choice_c": "Bottom-up method",
    "choice_d": "$750",
    "correct_answer": [
      "D",
      "F"
    ],
    "explanation": "The labor, $75/hour, times 10 trees is $750. This is the parametric method of estimating because you are multiplying the quantity times the rate. Analogous estimating involves using estimates from similar projects, and three-point estimates use the average of three estimates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      198,
      142,
      199,
      202,
      200
    ],
    "source": "892458_c07",
    "choice_e": "Analogous method",
    "choice_f": "Parametric method",
    "choice_g": "$8,750"
  },
  {
    "id": 561,
    "question": "The total time it will take for one person to complete a task from beginning to end without taking into account holidays, time off, or other project work is known as this.",
    "choice_a": "Duration estimate",
    "choice_b": "Work effort estimate",
    "choice_c": "Bottom-up estimate",
    "choice_d": "Parametric estimate",
    "correct_answer": "B",
    "explanation": "A work effort estimate or person-hour estimate is used to develop the cost estimates. This is the amount of time it will take to complete the task from beginning to end without accounting for work breaks, holidays, and so on. Duration estimates account for holidays, work breaks, and so on. Bottom-up estimates are estimates for individual components of work that are rolled up into the overall estimate, and parametric estimates are usually derived by multiplying quantity by rate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      199,
      198,
      142,
      141,
      140
    ],
    "source": "892458_c07"
  },
  {
    "id": 562,
    "question": "A discretionary fund used by the project manager to cover the cost of possible adverse events during the project is known as which of the following?",
    "choice_a": "Management reserve",
    "choice_b": "Chart of accounts",
    "choice_c": "Contingency fund",
    "choice_d": "Cost baseline",
    "correct_answer": "C",
    "explanation": "A contingency fund is an amount allocated to cover the cost of possible adverse events, and the project manager generally has the ability to use this fund. The project manager does not usually have the authority to spend money from the management reserve. The chart of accounts is a description of the accounts listed in the accounting ledger, and the cost baseline is the total expected cost for the project.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      205,
      214,
      56,
      274,
      315
    ],
    "source": "892458_c07"
  },
  {
    "id": 563,
    "question": "You are developing a bottom-up cost estimate for the first phase of your project. Which of the following is the most important input to complete this task?",
    "choice_a": "Historic data from a similar project",
    "choice_b": "Chart of accounts",
    "choice_c": "The WBS",
    "choice_d": "The scope statement",
    "correct_answer": "C",
    "explanation": "Bottom-up estimates start at the work package level of the WBS. Each work package on the WBS for the first phase of the project is summed to come up with an overall estimate for this phase. Historical data would be useful if you were using the analogous estimating technique. The chart of accounts doesn\u2019t help at all with this exercise, and the scope statement will give you an understanding of what\u2019s detailed on the WBS, but it won\u2019t help with estimating.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      128,
      9,
      203,
      64,
      84
    ],
    "source": "892458_c07"
  },
  {
    "id": 564,
    "question": "What is considered the most accurate estimate?",
    "choice_a": "Analogous estimate",
    "choice_b": "Bottom-up estimate",
    "choice_c": "Estimates based on expert judgment",
    "choice_d": "Parametric estimate",
    "correct_answer": "B",
    "explanation": "Bottom-up estimates are the most accurate estimates, and analogous estimates are the least accurate. Estimates based on expert judgment are analogous estimates. Parametric estimates are only as accurate as the data you\u2019re using for the parametric model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      198,
      201,
      199,
      142,
      200
    ],
    "source": "892458_c07"
  },
  {
    "id": 565,
    "question": "You are asked to present and explain your project cost baseline. All of the following are true except which one?",
    "choice_a": "The baseline will be used to track actual spending against the cost estimates.",
    "choice_b": "The baseline can be used to predict future project costs.",
    "choice_c": "The baseline is calculated and approved by the project manager.",
    "choice_d": "The baseline is the total expected cost for the project.",
    "correct_answer": "C",
    "explanation": "The cost baseline is approved by the project sponsor, not the project manager.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      132,
      84,
      66,
      149
    ],
    "source": "892458_c07"
  },
  {
    "id": 566,
    "question": "Your project task is complex, and you decide to use a three-point estimating technique. Which of the following options determine the three-point estimate? (Choose three.)",
    "choice_a": "Quantity estimate",
    "choice_b": "Work package level estimate",
    "choice_c": "Materials estimate",
    "choice_d": "Pessimistic estimate",
    "correct_answer": [
      "D",
      "G",
      "H"
    ],
    "explanation": "Three-point estimates are the average of the most likely, optimistic, and pessimistic estimates.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      202,
      198,
      142,
      219,
      199
    ],
    "source": "892458_c07",
    "choice_e": "Resource estimate",
    "choice_f": "Rate estimate",
    "choice_g": "Optimistic estimate",
    "choice_h": "Most likely estimate"
  },
  {
    "id": 567,
    "question": "Which of the following is used in a burn rate calculation?",
    "choice_a": "CV",
    "choice_b": "Determining spending rates over time",
    "choice_c": "CPI",
    "choice_d": "AC - PV",
    "correct_answer": "C",
    "explanation": "The burn rate is typically calculated using the cost performance index (CPI). This tells you the efficiency or benefits of the money spent at any point in the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      209,
      214,
      199,
      200
    ],
    "source": "892458_c07"
  },
  {
    "id": 568,
    "question": "Your project has a potential for a future risk event. The sponsor has told you that the organization cannot sustain the consequences of this risk. You recommend purchasing insurance so that if the risk event occurs, the organization can recoup their expenditures for the impacts of the risk. What risk strategy is this known as?",
    "choice_a": "Avoid",
    "choice_b": "Mitigate",
    "choice_c": "Accept",
    "choice_d": "Transfer",
    "correct_answer": "D",
    "explanation": "Transfer is a risk strategy that transfers the consequences of the risk to another party.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      219,
      220,
      221
    ],
    "source": "892458_c07"
  },
  {
    "id": 569,
    "question": "Which technique can be used to help identify risks?",
    "choice_a": "SWOT",
    "choice_b": "CPI",
    "choice_c": "EVM",
    "choice_d": "CV",
    "correct_answer": "A",
    "explanation": "SWOT stands for strengths, weaknesses, opportunities, and threats. Examining the project from each of these perspectives helps you identify risks. The other options are cost performance measurements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      218,
      217,
      219,
      210,
      24
    ],
    "source": "892458_c07"
  },
  {
    "id": 570,
    "question": "The risk register typically contains several pieces of information. Which of the following would you expect to see on a risk register? (Choose three.)",
    "choice_a": "Risk owner",
    "choice_b": "Description of risk",
    "choice_c": "Risk score",
    "choice_d": "Cost estimate for response plan",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "During the early stages of risk planning, a risk register typically has a risk identification number, a description of the risk, the probability and impact of the risk event, risk score, and risk owner. Your risk register could also contain the risk trigger and other pertinent information about the risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      217,
      219,
      220,
      216,
      251
    ],
    "source": "892458_c07",
    "choice_e": "Resource costs to track risks",
    "choice_f": "Cost estimate of the consequences of the risk"
  },
  {
    "id": 571,
    "question": "You have identified a risk on your project, and the team decides they won\u2019t create a response plan; if the risk happens, they\u2019ll deal with consequences when they occur. This is an example of which risk strategy?",
    "choice_a": "Exploit",
    "choice_b": "Avoid",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "D",
    "explanation": "The risk strategy of accepting a risk involves dealing with the consequences when they occur. You don\u2019t prepare a risk response plan for risks you plan to accept.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      220,
      215,
      221
    ],
    "source": "892458_c07"
  },
  {
    "id": 572,
    "question": "The difference between planned expenditures and actual expenditures is known as which of the following?",
    "choice_a": "Planned value",
    "choice_b": "Variance",
    "choice_c": "Expenditure reporting",
    "choice_d": "Burn rate",
    "correct_answer": "B",
    "explanation": "The difference between what you planned to spend and what was actually spent is known as a budget variance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      209,
      205,
      274,
      312
    ],
    "source": "892458_c07"
  },
  {
    "id": 573,
    "question": "The clouds are rolling in over the horizon and the wind is picking up. Your outdoor event is about to get rained out. What is this an example of?",
    "choice_a": "Risk trigger",
    "choice_b": "Risk analysis",
    "choice_c": "Risk probability",
    "choice_d": "Risk response",
    "correct_answer": "A",
    "explanation": "Risk triggers are symptoms or signs that a risk event is about to occur.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      216,
      217,
      220,
      222,
      219
    ],
    "source": "892458_c07"
  },
  {
    "id": 574,
    "question": "All of the following are strategies for dealing with negative risks, except for which one?",
    "choice_a": "Accept",
    "choice_b": "Transfer",
    "choice_c": "Share",
    "choice_d": "Mitigate",
    "correct_answer": "C",
    "explanation": "Sharing is a positive risk strategy. The negative risk strategies are avoid, transfer, mitigate, and accept.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      218,
      220,
      215
    ],
    "source": "892458_c07"
  },
  {
    "id": 575,
    "question": "Cost baselines when displayed graphically over time represent which of the following?",
    "choice_a": "S curve",
    "choice_b": "C curve",
    "choice_c": "Evenly distributed expenditures",
    "choice_d": "Erratic expenditures",
    "correct_answer": "A",
    "explanation": "When project costs are displayed graphically over time, they represent an S curve. This is because spending starts out slowly on the project, picks up speed during the middle of the project, and tapers off at the end.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      203,
      84,
      132,
      10,
      273
    ],
    "source": "892458_c07"
  },
  {
    "id": 576,
    "question": "You are determining the risk score for each of the risks in your risk register. You need which of the following to determine this score? (Choose two.)",
    "choice_a": "Risk tolerance levels of the stakeholders",
    "choice_b": "Risk owners",
    "choice_c": "Probability the risk will occur",
    "choice_d": "Contingency reserves",
    "correct_answer": [
      "C",
      "F"
    ],
    "explanation": "The risk score is calculated by multiplying the probability by the impact. Probability is the likelihood a risk event will occur. It is expressed as a number from 0.0 to 1.0. Impact is the consequence of the risk event if it occurs and is expressed as a range of numbers or costs determined by the team, the PMO, or the organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      219,
      220,
      216,
      217,
      222
    ],
    "source": "892458_c07",
    "choice_e": "Risk trigger scores",
    "choice_f": "Impact if the risk occurs"
  },
  {
    "id": 577,
    "question": "Why should you spend time developing a solid communication plan? (Choose three.)",
    "choice_a": "To set performance goals",
    "choice_b": "To set aside time for your own needs",
    "choice_c": "To keep vendors informed",
    "choice_d": "To understand where the blame lies when something goes wrong",
    "correct_answer": [
      "C",
      "E",
      "F"
    ],
    "explanation": "A communication plan is developed to determine who needs communication, when, and in what format, and the frequency of the communications. Once the plan is developed, it\u2019s used to update stakeholders, team members, vendors, and others who need information on the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      269,
      265,
      272,
      51
    ],
    "source": "892458_c08",
    "choice_e": "To keep stakeholders updated on your progress",
    "choice_f": "To keep team members informed of project progress"
  },
  {
    "id": 578,
    "question": "Which person is responsible for understanding the information correctly and making certain they\u2019ve received all the information?",
    "choice_a": "Sender",
    "choice_b": "Messenger",
    "choice_c": "Project manager",
    "choice_d": "Receiver",
    "correct_answer": "D",
    "explanation": "In the sender-message-receiver model, the receiver is responsible for understanding the information correctly and making certain they\u2019ve received all the information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      227,
      230,
      229,
      234,
      247
    ],
    "source": "892458_c08"
  },
  {
    "id": 579,
    "question": "There are four participants in your upcoming meeting. How many lines of communication are there?",
    "choice_a": "6",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "16",
    "correct_answer": "A",
    "explanation": "There are four participants in the meeting and six lines of communication. The formula for this is 4 (4 \u2013 1) \u00f7 2 = 6.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      228,
      232,
      227,
      245,
      253
    ],
    "source": "892458_c08"
  },
  {
    "id": 580,
    "question": "You are working on a project that is being implemented in a country different from your country of origin. You also have team members in several locations around the globe. You should consider all of the following specifically in regard to managing and communicating with team members in this situation except for which one?",
    "choice_a": "Time zones",
    "choice_b": "Cultural differences",
    "choice_c": "Gate reviews",
    "choice_d": "Language barriers",
    "correct_answer": "C",
    "explanation": "Gate reviews are meetings held to discuss status and determine if the project should move forward. Language barriers, cultural differences, and others are factors that influence communication methods.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      242,
      233,
      245,
      232
    ],
    "source": "892458_c08"
  },
  {
    "id": 581,
    "question": "A JAD session is an example of which of the following meeting types?",
    "choice_a": "Informative",
    "choice_b": "Collaborative",
    "choice_c": "Demonstrative",
    "choice_d": "Decisive",
    "correct_answer": "B",
    "explanation": "Joint application development sessions are a type of collaborative meeting where the focus is developing requirements for the system or application the team is developing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      261,
      54,
      255,
      121
    ],
    "source": "892458_c08"
  },
  {
    "id": 582,
    "question": "Your project team is located in differing time zones. You need to hold a kickoff meeting, and you decide to use which communication method?",
    "choice_a": "Videoconferencing",
    "choice_b": "Email",
    "choice_c": "In-person meeting",
    "choice_d": "Voice conferencing",
    "correct_answer": "A",
    "explanation": "One of the purposes of a kickoff meeting is to introduce team members to one another. Videoconferencing would be the best choice so that team members can see one another during introductions as well as hear the project goals and so on.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      181,
      233,
      241,
      23,
      254
    ],
    "source": "892458_c08"
  },
  {
    "id": 583,
    "question": "Which of the following are considered communication methods?",
    "choice_a": "Email",
    "choice_b": "Meetings",
    "choice_c": "Social media",
    "choice_d": "Distribution of printed media",
    "correct_answer": "G",
    "explanation": "All of the options are considered communication methods. You should tailor the method of communication to the audience.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      246,
      271,
      269
    ],
    "source": "892458_c08",
    "choice_e": "Text message",
    "choice_f": "Face-to-face",
    "choice_g": "All of the above",
    "choice_h": "A, B, C, E, and F"
  },
  {
    "id": 584,
    "question": "Communications planning is the process of which of the following?",
    "choice_a": "Scheduling a regular meeting for the project team",
    "choice_b": "Developing a distribution list for the stakeholders",
    "choice_c": "Identifying the people or groups that need information on your project",
    "choice_d": "Creating a template to report project status",
    "correct_answer": "C",
    "explanation": "Communications planning is the process of identifying who needs to receive information on the project, what information they need, and how they will get that information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      272,
      51,
      52,
      265,
      229
    ],
    "source": "892458_c08"
  },
  {
    "id": 585,
    "question": "Which type of meeting is used to discuss project status at certain points in the project, normally after a project phase is completed or after a milestone has been met? These meetings may also be used as go/no-go decision points.",
    "choice_a": "Retrospective",
    "choice_b": "Project status meeting",
    "choice_c": "Iteration reviews",
    "choice_d": "Phase gate reviews",
    "correct_answer": "D",
    "explanation": "This question describes phase gate reviews. Reviews and retrospectives are meetings held on agile projects. The iteration review is held at the end of the sprint to review the work accomplished to date. The retrospective is held after the review meeting and involves all cross-functional team members. It reviews overall progress to date, changes, ideas for improvements, and more. Project status meetings are intended to review the status of the project and are held at regular intervals such as weekly or monthly. They are not go/no-go decision points.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      250,
      238,
      259,
      77,
      10
    ],
    "source": "892458_c08"
  },
  {
    "id": 586,
    "question": "You are a new project manager working in the PMO. Your project customer is the Finance department. The Finance department is uncooperative when working with the PMO. You have experienced some pushback from members of the finance team on following established project management processes, and they repeatedly go around you to team members and other stakeholders with project information. What factor of influence on communication does this represent?",
    "choice_a": "Cultural differences",
    "choice_b": "Personal preferences",
    "choice_c": "Interorganizational differences",
    "choice_d": "Intraorganizational differences",
    "correct_answer": "D",
    "explanation": "Intraorganizational differences affect different departments across the organization. This question states you work for the PMO and the Finance department is uncooperative, meaning you have two departments involved in the difference.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      244,
      62,
      51,
      177,
      230
    ],
    "source": "892458_c08"
  },
  {
    "id": 587,
    "question": "You are a project manager for a telecommunications company assigned to a project to deploy a new wireless network using a technology that does not have a proven track record. One of the key stakeholders introduces a change that could impact the schedule. Which of the following does this describe?",
    "choice_a": "Communication method",
    "choice_b": "Factor influencing communication",
    "choice_c": "Communication trigger",
    "choice_d": "Communication preferences",
    "correct_answer": "C",
    "explanation": "A stakeholder change is an example of a communication trigger.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      272,
      247,
      281,
      271,
      60
    ],
    "source": "892458_c08"
  },
  {
    "id": 588,
    "question": "The basic communication model consists of which of the following elements? (Choose three.)",
    "choice_a": "Decoder",
    "choice_b": "Sender",
    "choice_c": "Transmission",
    "choice_d": "Listen",
    "correct_answer": [
      "B",
      "E",
      "F"
    ],
    "explanation": "The basic communication model is the sender-message-receiver model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      227,
      230,
      229,
      233,
      234
    ],
    "source": "892458_c08",
    "choice_e": "Message",
    "choice_f": "Receiver",
    "choice_g": "Encrypt"
  },
  {
    "id": 589,
    "question": "You have a project employee who had an inappropriate outburst in a meeting. You need to coach this team member and let them know how to better handle a similar situation in the future. What should the project manager\u2019s next step be with this employee in this circumstance?",
    "choice_a": "Set up a face-to-face meeting with the employee.",
    "choice_b": "Email the employee and explain this is not appropriate behavior.",
    "choice_c": "Set up a meeting with the functional manager and the employee.",
    "choice_d": "Text message the employee and demand they stop this behavior.",
    "correct_answer": "A",
    "explanation": "A face-to-face meeting with the employee is the best method of communicating when you need to discuss sensitive information. If the employee refuses to change their behaviour, the next step might be meeting with the functional manager. However, you should always try to resolve the problem first with just the employee.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      173,
      230,
      179,
      233,
      271
    ],
    "source": "892458_c08"
  },
  {
    "id": 590,
    "question": "All of the following are types of synchronous communication except for which one?",
    "choice_a": "Face-to-face",
    "choice_b": "Instant messaging",
    "choice_c": "Phone call",
    "choice_d": "Email",
    "correct_answer": "D",
    "explanation": "Synchronous communication happens in real time. Emails are a form of asynchronous communication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      227,
      230,
      253,
      271
    ],
    "source": "892458_c08"
  },
  {
    "id": 591,
    "question": "You engage in hallway conversations, emails, and phone calls with your team members. What is this considered?",
    "choice_a": "Communication triggers",
    "choice_b": "Factors that influence communication",
    "choice_c": "Communication requirements",
    "choice_d": "Informal communication",
    "correct_answer": "D",
    "explanation": "Informal communications include email, hallway conversations, and phone calls. They are typically unplanned and causal in nature.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      265,
      242,
      241,
      230,
      173
    ],
    "source": "892458_c08"
  },
  {
    "id": 592,
    "question": "Your agile team is having a meeting to discuss upcoming user stories for the next sprint. They need to understand the context of the user stories and how they relate to each other and to the project as a whole. What type of meeting is this?",
    "choice_a": "Standup",
    "choice_b": "Review",
    "choice_c": "Backlog refinement",
    "choice_d": "Retrospective",
    "correct_answer": "C",
    "explanation": "Backlog refinements are conducted midway to a few days before the end of the current sprint.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      153,
      157,
      253,
      119
    ],
    "source": "892458_c08"
  },
  {
    "id": 593,
    "question": "You have an important message to deliver to stakeholders. Which of the following should you do?",
    "choice_a": "Write the message in an email and distribute it to those who need to know.",
    "choice_b": "Tailor the communication method based on the content of the message.",
    "choice_c": "Call an impromptu meeting.",
    "choice_d": "Set up a voice conference meeting.",
    "correct_answer": "B",
    "explanation": "The first step is to tailor the communication method based on the content of the message. There isn\u2019t enough information in the question to determine the content of the message, so we don\u2019t know which method is best to use.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      227,
      271,
      234,
      237
    ],
    "source": "892458_c08"
  },
  {
    "id": 594,
    "question": "You have a complex message to communicate to the project stakeholders. Which of the following are the best methods to use? (Choose two.)",
    "choice_a": "In-person meeting",
    "choice_b": "Email",
    "choice_c": "Instant message",
    "choice_d": "Voice conference",
    "correct_answer": [
      "A",
      "F"
    ],
    "explanation": "Complex information is best delivered in a written format and then explained at an in-person meeting so the stakeholders can ask questions and you are able to determine if their body language indicates they understand.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      234,
      246,
      253,
      271,
      229
    ],
    "source": "892458_c08",
    "choice_e": "Informal",
    "choice_f": "Written format"
  },
  {
    "id": 595,
    "question": "Frequency, level of report detail, types of communication, confidentiality constraints, and tailoring your communication style are examples of which of the following? (Choose two.)",
    "choice_a": "Rapport building/relationship building",
    "choice_b": "Elements of the communication plan",
    "choice_c": "Communication methods",
    "choice_d": "Stakeholder communication requirements",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "These are all stakeholder communication requirements and should be recorded in the communication plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      265,
      246,
      269,
      270
    ],
    "source": "892458_c08"
  },
  {
    "id": 596,
    "question": "Interorganizational differences, personal preferences, rapport building/relationship building, and technological factors are examples of which of the following?",
    "choice_a": "Factors influencing communication methods",
    "choice_b": "Specific stakeholder communication requirements",
    "choice_c": "Communication triggers",
    "choice_d": "Determining the target audience and rationale",
    "correct_answer": "A",
    "explanation": "The question describes factors that influence communication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      227,
      244,
      232,
      177
    ],
    "source": "892458_c08"
  },
  {
    "id": 597,
    "question": "You are a project manager for a project developing a new software application. You have just learned that one of your programmers is adding several new features to one of the deliverables. What is the best action to take?",
    "choice_a": "Make any needed adjustments to the schedule and cost baseline and tell the programmer that any future changes must be approved by you.",
    "choice_b": "Request that the programmer remove the coding for the new features because they are outside the boundaries of the original scope statement.",
    "choice_c": "Contact the appropriate functional manager and request a replacement for this programmer.",
    "choice_d": "Determine the source of the request for the new features and put this change through the change control process to determine the impact of the changes and obtain formal approval to change the scope.",
    "correct_answer": "D",
    "explanation": "The customer or a stakeholder may have requested the new features. If these are required features that were omitted from the original scope statement, you need to analyze the impact to the project and obtain approval for the change. If you just make adjustments to the budget and schedule without any analysis, not only do you risk being late and over budget, but there may be impacts to other areas of the plan or risks associated with this change. Removing the new features may add cost and time to the schedule as well as create a potentially hostile relationship with the customer. Unless this is a situation where the programmer has repeatedly changed scope outside of the approval process, requesting a replacement resource is not an appropriate response.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      288,
      214,
      51,
      56
    ],
    "source": "892458_c09"
  },
  {
    "id": 598,
    "question": "Which of the following is not a type of change?",
    "choice_a": "Corrective actions",
    "choice_b": "Defect repairs",
    "choice_c": "Performance corrections",
    "choice_d": "Preventive actions",
    "correct_answer": "C",
    "explanation": "Corrective actions, defect repairs, and preventive actions are all types of change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      289,
      309,
      86,
      6
    ],
    "source": "892458_c09"
  },
  {
    "id": 599,
    "question": "This entity is responsible for reviewing change requests, reviewing the analysis of the impact of the change, and determining whether the change is approved, denied, or deferred.",
    "choice_a": "CTB",
    "choice_b": "CCB",
    "choice_c": "CRB",
    "choice_d": "TRB",
    "correct_answer": "B",
    "explanation": "The change request board (CCB) is responsible for reviewing and approving, denying, or deferring change requests. The CCB is also sometimes known as the change advisory board (CAB).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      281,
      280,
      279,
      86
    ],
    "source": "892458_c09"
  },
  {
    "id": 600,
    "question": "Which of the following should be established as part of the change control system in the event the change control board cannot meet in a timely manner?",
    "choice_a": "Emergency change request procedures",
    "choice_b": "Procedures for analyzing the impacts of change and preestablished criteria for determining which changes can be implemented",
    "choice_c": "Process for documenting the change in the change request log",
    "choice_d": "Coordination and communication with stakeholders",
    "correct_answer": "A",
    "explanation": "Emergency change request procedures should be documented so that changes that must be made on an emergency basis prior to the next CCB meeting can be made. All changes should be documented and reported at the next CCB meeting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      279,
      280,
      281,
      274
    ],
    "source": "892458_c09"
  },
  {
    "id": 601,
    "question": "After a change request is submitted, all of the following steps occur prior to being reviewed by the change control board except for which one?",
    "choice_a": "The change request is recorded in the change log.",
    "choice_b": "Analysis of the impacts of the change is performed.",
    "choice_c": "Specific elements of the project, such as additional equipment needs, resource hours, quality impacts, and more, are analyzed.",
    "choice_d": "Update the appropriate project management planning document to reflect the change.",
    "correct_answer": "D",
    "explanation": "After options A\u2013C are conducted, the change request and analysis are given to the CCB to make a decision. The appropriate project planning document is not updated until the CCB makes a decision regarding the disposition of the change request.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      281,
      279,
      87,
      274
    ],
    "source": "892458_c09"
  },
  {
    "id": 602,
    "question": "Stakeholders have come to you to tell you they want to change the scope. Before agreeing to the change, what things should you do? (Choose two.)",
    "choice_a": "Determine which project constraint (time, budget, quality) is most important to stakeholders.",
    "choice_b": "Discuss the proposed scope change with the sponsor.",
    "choice_c": "Ask team members what they think about the scope change.",
    "choice_d": "Define alternatives and trade-offs that you can offer the stakeholders.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Determining the constraint that stakeholders think is driving the project will help you determine the kinds of trade-offs or alternatives you can propose to lessen the effect of the proposed scope change.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      90,
      91,
      60,
      248,
      286
    ],
    "source": "892458_c09",
    "choice_e": "Implement the change."
  },
  {
    "id": 603,
    "question": "You have just received the latest status updates from the team. Based on the progress to date, system testing is projected to take three weeks longer than planned. If this happens, user acceptance testing will have to start three weeks late, and the project will not complete on the planned finish date. The customer scheduled the user acceptance testing participants weeks in advance. What is the best course of action?",
    "choice_a": "Explain to the test team that the system test must end on the scheduled date, and they are accountable for the accuracy of the testing results.",
    "choice_b": "Meet with the test team to determine the cause of the delay. If you determine that there are not enough testers to complete all of the scenarios in the time allotted, work with the sponsor to secure additional testers to complete the system test as planned.",
    "choice_c": "Submit the change request to the CCB and, if it\u2019s approved, baseline the schedule again.",
    "choice_d": "Escalate the issue of the system test delay to the sponsor and let them decide what action to take.",
    "correct_answer": "C",
    "explanation": "The correct action to take in this situation is to submit the change request to the CCB. If it is approved, it will require that you re-baseline the schedule to reflect the new dates.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      280,
      214,
      315,
      272,
      253
    ],
    "source": "892458_c09"
  },
  {
    "id": 604,
    "question": "Your company is implementing a significant change in staffing. Some departments are being consolidated, others are being eliminated, and some new ones are being created. Which of the following are true regarding this change? (Choose two.)",
    "choice_a": "This is an operational change.",
    "choice_b": "You should have a rollback plan in place in case the changes do not go as planned and employees need time to adjust to the new structure.",
    "choice_c": "You should ensure adoption of the change over time.",
    "choice_d": "New knowledge bases should be created for information and frequently asked questions about the change.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "This is an organizational change. Organizational change involves transforming processes, systems, organizations, and more and requires communication, analysis, training, ensuring adoption over time, documenting the change, and creating new knowledge bases and new processes. Rollback plans are used for infrastructure changes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      294,
      125,
      287,
      329,
      295
    ],
    "source": "892458_c09",
    "choice_e": "This is an infrastructure change."
  },
  {
    "id": 605,
    "question": "Your project is in danger of being canceled because of an organizational change. Despite the protests of your executive manager, several of the department managers in your old company have been laid off and replaced by the new organization\u2019s management team. Which of the following options does this scenario describe?",
    "choice_a": "Your company has experienced a demerger from another organization.",
    "choice_b": "Your company has been merged with another organization.",
    "choice_c": "Your company has been acquired by another organization.",
    "choice_d": "Your company has split from another organization.",
    "correct_answer": "C",
    "explanation": "An acquisition gives power to the organization that is taking over. In this scenario, your old company has experienced some layoffs and managers from the new organization have taken over. This describes an acquisition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      289,
      28,
      53,
      51,
      293
    ],
    "source": "892458_c09"
  },
  {
    "id": 606,
    "question": "Your company has implemented a new ERP system. This is a type of change that might require all of the following except which one?",
    "choice_a": "Training",
    "choice_b": "Ensuring adoption over time",
    "choice_c": "Creating new processes",
    "choice_d": "Updating the project management plan",
    "correct_answer": "D",
    "explanation": "This is an organizational change. Updating the project management plan would come about as a result of a project management change, not an organizational change.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      294,
      284,
      125,
      132,
      85
    ],
    "source": "892458_c09"
  },
  {
    "id": 607,
    "question": "You are in the Executing phase of your project implementing a new CRMS. The business expert (one of the key stakeholders on the project) has requested a change to the workflow process in the system for customer escalations. All of the following are true regarding this change except for which one?",
    "choice_a": "The change should be documented and submitted in writing.",
    "choice_b": "This is a project management change.",
    "choice_c": "Analysis of the impacts of the change should be performed before going to the CCB.",
    "choice_d": "The change should be logged in the change control log.",
    "correct_answer": "B",
    "explanation": "This is a product change, not a project management change. Product changes almost always result in a project management change, but the question is describing the product change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      288,
      279,
      87,
      86,
      247
    ],
    "source": "892458_c09"
  },
  {
    "id": 608,
    "question": "What is the final, approved, documented plan that is used throughout the Executing phase to measure project progress and to help analyze change requests?",
    "choice_a": "Project management plan",
    "choice_b": "Schedule baseline",
    "choice_c": "Scope baseline",
    "choice_d": "Cost baseline",
    "correct_answer": "A",
    "explanation": "The project management plan is the documented plan that\u2019s used to monitor the work of the project throughout the Executing phase and to analyze change requests.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      84,
      132,
      10,
      273,
      324
    ],
    "source": "892458_c09"
  },
  {
    "id": 609,
    "question": "You are in the Executing phase of your project and are working with a vendor who is responsible for implementing configuration changes to your cloud-based system. You need to review their activities and determine if they are being performed correctly, according to the contract statement of work. Which two actions might you use to make this determination? (Choose two.)",
    "choice_a": "Inspections",
    "choice_b": "Preventive actions",
    "choice_c": "Corrective actions",
    "choice_d": "Audits",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Audits consist of reviews of vendor activities to determine whether they are meeting the right needs and whether the activities are being performed correctly and according to standards. Inspections involve physically inspecting the results to determine if they meet the requirements or standards set out in the SOW.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      276,
      278,
      277,
      185,
      89
    ],
    "source": "892458_c09",
    "choice_e": "Defect repairs"
  },
  {
    "id": 610,
    "question": "Your vendor is contesting a recent change request. They believe they implemented the change as requested; the project team believes the change is not functioning as required. Which of the following documents, monitors, and manages these types of contested changes?",
    "choice_a": "Contested change control",
    "choice_b": "Contract change control system",
    "choice_c": "Claims administration",
    "choice_d": "Compensation administration",
    "correct_answer": "C",
    "explanation": "Claims administration involves documenting, monitoring, and managing contested changes to the contract. Contested changes usually involve a disagreement about the compensation to the vendor for implementing the change. You might believe the change is not significant enough to justify additional compensation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      277,
      279,
      282,
      281,
      280
    ],
    "source": "892458_c09"
  },
  {
    "id": 611,
    "question": "You know that the project management plan consists of several project documents and, once approved, serves as the baseline for the project. All of the following are true regarding the project management plan except which one?",
    "choice_a": "It\u2019s used during the Executing phase to determine whether the project is on track.",
    "choice_b": "It\u2019s used during the procurement processes to negotiate with the vendor.",
    "choice_c": "It is a communication tool.",
    "choice_d": "It\u2019s used when changes are requested to determine whether the change is in keeping with the original goals and objectives of the project.",
    "correct_answer": "B",
    "explanation": "The project management plan serves as the baseline for project progress and is used throughout the Executing phase to determine whether the project is on track. It is used to help evaluate changes against the original goals and objectives of the project and serves as a communication tool.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      84,
      132,
      273,
      10,
      9
    ],
    "source": "892458_c09"
  },
  {
    "id": 612,
    "question": "The project team is performing testing on some of the work of the project. The testing does not appear to be lining up with the project management plan. Which of the following is required to get the project back on track?",
    "choice_a": "Defect repair",
    "choice_b": "Integrated change",
    "choice_c": "Preventive action",
    "choice_d": "Corrective action",
    "correct_answer": "D",
    "explanation": "Corrective actions bring the work of the project into alignment with the project management plan. Preventive actions help reduce the probability of a negative risk event. Defect repairs correct or replace components that are not functional. Integrated change control manages change requests and their global impacts to the project and the organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      274,
      279,
      315,
      86
    ],
    "source": "892458_c09"
  },
  {
    "id": 613,
    "question": "You have conducted several successful agile projects and the organization is interested in scaling agile principles for a large project that is set to kick off in a few months. The organization wants to tailor an approach that will be best for them, and your executive sponsor has emphasized the importance of incorporating human resources principles when tailoring the agile process. Which agile framework does this describe?",
    "choice_a": "PRINCE2",
    "choice_b": "Scrum of Scrums",
    "choice_c": "SAFe",
    "choice_d": "DA",
    "correct_answer": "D",
    "explanation": "This question describes Disciplined Agile.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      301,
      300,
      116,
      112,
      120
    ],
    "source": "892458_c09"
  },
  {
    "id": 614,
    "question": "This waterfall methodology divides projects into specific stages such as startup, directing, and delivery.",
    "choice_a": "Scrum of Scrums",
    "choice_b": "PRINCE2",
    "choice_c": "DA",
    "choice_d": "SAFe",
    "correct_answer": "B",
    "explanation": "PRINCE2 divides projects into stages, and stage boundaries are performed at the end of each stage before proceeding to the next.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      105,
      302,
      106,
      133,
      305
    ],
    "source": "892458_c09"
  },
  {
    "id": 615,
    "question": "You have recommended using an agile methodology for a project the organization is ready to move to the Executing phase. This is a large, complex project and will require more than one agile team. You decide to use a methodology whereby each agile team will consist of three to nine members, they will all work on the same project but will have their own backlog to work from, and you will hold a daily standup with all the teams whereby one representative from each team will join the collective standup meeting. What methodology is this describing?",
    "choice_a": "DA",
    "choice_b": "PRINCE2",
    "choice_c": "Scrum of Scrums",
    "choice_d": "SAFe",
    "correct_answer": "C",
    "explanation": "This question describes Scrum of Scrums. This methodology uses more than one Scrum team who each work from their own backlog.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      301,
      108,
      120,
      119,
      300
    ],
    "source": "892458_c09"
  },
  {
    "id": 616,
    "question": "You have recommended using an agile methodology for a project the organization is ready to move to the Executing phase. This is a large, complex project and will require one, large agile team. You decide to use a methodology whereby all team members reside on the same team and work from the same backlog. Team members will collaborate with each other, and the team is self-organized and self-directed. What methodology is this describing?",
    "choice_a": "Scrum of Scrums",
    "choice_b": "SAFe",
    "choice_c": "PRINCE2",
    "choice_d": "DA",
    "correct_answer": "B",
    "explanation": "This question describes Scaled Agile Framework. It uses one large Scrum team. Scrum of Scrums uses multiple Scrum teams, PRINCE2 uses stages to manage the work, and Disciplined Agile is a way to tailor agile methodologies for the team.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      301,
      120,
      108,
      112,
      300
    ],
    "source": "892458_c09"
  },
  {
    "id": 617,
    "question": "You are working on a project that was proceeding well until a manufacturing glitch occurred that requires corrective action. It turns out the glitch was an unintentional enhancement to the product, and the marketing people are enthused about its potential. The corrective action is canceled, and you continue to produce the product with the newly discovered enhancement. As the project manager, you know that a variance has occurred. Which of the following is not true?",
    "choice_a": "Common causes of variance are situations that are unique and not easily controlled at the operational level.",
    "choice_b": "Random variances, known or predictable variances, and variances that are always present in the process are known as common causes of variance.",
    "choice_c": "Inspection determines whether measurements fall within tolerable results.",
    "choice_d": "Scatter diagrams display the relationships between an independent and a dependent variable to show variations in the process over time.",
    "correct_answer": "A",
    "explanation": "Common causes of variance are situations that are common to the process you\u2019re using and are easily controlled at the operational level.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      285,
      288,
      214,
      312,
      90
    ],
    "source": "892458_c10"
  },
  {
    "id": 618,
    "question": "You have just left a meeting with the project sponsor where you were advised that your project has been canceled because of budget cuts. You have called the project team together to fill them in and to review the remaining activities to close out the project. Several of your team members question the benefit of doing a lessons learned review on a project that has been canceled. What should your response be?",
    "choice_a": "Advise the team that part of the review time will be spent on documenting the failure of the lack of clear requirements from the customer.",
    "choice_b": "Tell the team they need to do this to be able to stay on the project payroll another week while they look for a new assignment.",
    "choice_c": "Inform the team that a final report is a requirement from the PMO, regardless of how the project ends.",
    "choice_d": "Explain that there is value both to the team and for future projects in analyzing the phases of the project that have been completed to date to document what went right, what went wrong, and what you would change.",
    "correct_answer": "D",
    "explanation": "There is valuable information to be gained from a review of any project, even projects that do not complete. The assessment should focus on those phases of the project that did finish, as well as a look at whether anything could have been done differently to make the project a success. The purpose of lessons learned is not to assign blame, even for projects that are canceled.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      6,
      53,
      51,
      272,
      271
    ],
    "source": "892458_c10"
  },
  {
    "id": 619,
    "question": "You have just left a meeting with the project sponsor where you were advised that your project has been canceled because of budget cuts. You have called the project team together to fill them in and to review the remaining activities to close out the project. Which of the following describes the type of project ending this project experienced?",
    "choice_a": "Extinction",
    "choice_b": "Starvation",
    "choice_c": "Addition",
    "choice_d": "Integration",
    "correct_answer": "B",
    "explanation": "Starvation is a project ending caused by resources being cut off from the project. Extinction occurs when the project work is completed and is accepted by the stakeholders. Addition occurs when projects evolve into ongoing operations, and integration occurs when resources are distributed to other areas of the organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      325,
      326,
      11,
      321,
      10
    ],
    "source": "892458_c10"
  },
  {
    "id": 620,
    "question": "Which of the following measurement tools are used to measure operational or performance goals for projects?",
    "choice_a": "KPIs",
    "choice_b": "Key objectives",
    "choice_c": "Balanced scorecard",
    "choice_d": "Key results",
    "correct_answer": "A",
    "explanation": "KPIs are used to measure any element of the project or operational areas of the business to determine whether goals are being achieved. A balanced scorecard is used to determine whether organizational goals are being met.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      320,
      89,
      323,
      209,
      210
    ],
    "source": "892458_c10",
    "choice_e": "All of the above"
  },
  {
    "id": 621,
    "question": "Which of the following is the \u201cbest\u201d type of project ending?",
    "choice_a": "Extinction",
    "choice_b": "Addition",
    "choice_c": "Integration",
    "choice_d": "Starvation",
    "correct_answer": "A",
    "explanation": "Extinction occurs when the project work is completed and is accepted by the stakeholders. This is the best type of project ending. Starvation is a project ending caused by resources being cut off from the project. Addition occurs when projects evolve into ongoing operations, and integration occurs when resources are distributed to other areas of the organization.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      325,
      326,
      11,
      10,
      7
    ],
    "source": "892458_c10"
  },
  {
    "id": 622,
    "question": "What is the primary purpose of a formal sign-off at the conclusion of the project work?",
    "choice_a": "The sign-off allows the project manager to start a new assignment.",
    "choice_b": "The sign-off means the project team is no longer accountable for the product of the project.",
    "choice_c": "The sign-off is the trigger for releasing team members back to their functional organization.",
    "choice_d": "The sign-off indicates that the project meets the documented requirements and the customer has accepted the project deliverables.",
    "correct_answer": "D",
    "explanation": "A sign-off is the formal acceptance of the project\u2019s final product, service, or result. Its primary purpose is the customer\u2019s acceptance of the product of the project. Team members are released after sign-off, but this isn\u2019t the primary purpose of a formal sign-off. Both the project manager and the project team members may continue to be involved in the project until all closure activities are complete.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      328,
      11,
      327,
      313,
      69
    ],
    "source": "892458_c10"
  },
  {
    "id": 623,
    "question": "Which of the following charts is a type of histogram?",
    "choice_a": "Scatter diagram",
    "choice_b": "Fishbone",
    "choice_c": "Pareto chart",
    "choice_d": "Run chart",
    "correct_answer": "C",
    "explanation": "A Pareto diagram is a type of histogram that measures the frequency of occurrences of data elements in rank order over time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      154,
      267,
      146
    ],
    "source": "892458_c10"
  },
  {
    "id": 624,
    "question": "What is the focus of the lessons learned report?",
    "choice_a": "The report should cover both the positive and negative aspects of the project, with suggestions for improvement.",
    "choice_b": "The report should primarily summarize the results of the project schedule, the budget, and any approved scope changes.",
    "choice_c": "The report should focus on the project deliverables and any issues that were created by the customer.",
    "choice_d": "The report should cover what went well during the project and should determine which team member or business unit was responsible for failures or issues.",
    "correct_answer": "A",
    "explanation": "Both the successes and failures of a project need to be documented in the lessons learned report. Successes will provide blueprints to follow on future projects, and failures will alert teams on what to avoid. A good lessons learned document covers all aspects of the project from all participants. It should include all project information, not just schedule, budget, and changes, and it should never place blame for the things that went wrong.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      293,
      256,
      51,
      52,
      56
    ],
    "source": "892458_c10"
  },
  {
    "id": 625,
    "question": "Your project concerns writing a new software app to track physical activity such as running, biking, and walking, including time spent on the activity, heart rate, and speeds. You\u2019ve performed some preliminary testing and discovered some changes need to be made to the code. Once the changes are made, you\u2019ll test again to ensure the app is working as expected, starting with logging in, tracking each activity, and measuring each criterion for accuracy. What type of testing does this question describe?",
    "choice_a": "Regression",
    "choice_b": "End-to-end",
    "choice_c": "Unit",
    "choice_d": "User acceptance",
    "correct_answer": "B",
    "explanation": "Regression testing is performed after changes are made to the code, but this question is specific about testing for all modules starting at logon, which indicates an end-to-end test is in order. Unit testing is the testing of one module or one unit of code, such as the biking feature, and user acceptance testing is performed by the end users of the product.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      50,
      309,
      89,
      320
    ],
    "source": "892458_c10"
  },
  {
    "id": 626,
    "question": "You are in the Monitoring and Controlling phase of the project. Several problems have come to light, and you want to know what the causes of the problems are that are generating the effect. You hold a brainstorming meeting with key team members and plot the cause and effect scenarios on this type of chart.",
    "choice_a": "Pareto chart",
    "choice_b": "Histogram",
    "choice_c": "Fishbone diagram",
    "choice_d": "Scatter diagram",
    "correct_answer": "C",
    "explanation": "The fishbone diagram is a cause-and-effect diagram and is also known as an Ishikawa diagram. Brainstorming sessions are a great way to construct this chart and determine what causes are impeding your results.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      311,
      314,
      310,
      316,
      319
    ],
    "source": "892458_c10"
  },
  {
    "id": 627,
    "question": "This document records items that usually arise during a status meeting. They concern the project but do not generally impact the project work directly. This document contains a description, an owner, and status, among other items.",
    "choice_a": "Status report",
    "choice_b": "Action items log",
    "choice_c": "Issue log",
    "choice_d": "Meeting minutes",
    "correct_answer": "B",
    "explanation": "Action items generally arise during the status meetings. They should be documented in an action item list. They are assigned an identification number, a description, and an owner, and their status is recorded and reviewed at status meetings. Issues generally impact the project work directly and may impede progress or bring about a risk. Action items are usually \u201cto dos\u201d or questions that must be answered regarding the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      256,
      253,
      315,
      254,
      72
    ],
    "source": "892458_c10"
  },
  {
    "id": 628,
    "question": "Your team is working on some configuration and coding changes to your human resource software program. The coding changes have just started, and you want to perform a test that will identify simple failures and look at the most critical functions of the program before proceeding. What type of test does this describe?",
    "choice_a": "Unit",
    "choice_b": "Integration",
    "choice_c": "Smoke",
    "choice_d": "Performance",
    "correct_answer": "C",
    "explanation": "A smoke test is a high-level test designed to identify simple failures that could jeopardize the software program or prevent it from being released to production. These tests typically look at the most critical functions of the program and expose issues and problems early in the coding process.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      50,
      58,
      309,
      114,
      90
    ],
    "source": "892458_c10"
  },
  {
    "id": 629,
    "question": "Your project evolved over time into an ongoing operation. What type of project ending is this?",
    "choice_a": "The project ending is because of extinction.",
    "choice_b": "The project ending is because of starvation.",
    "choice_c": "The project ending is because of integration.",
    "choice_d": "The project ending is because of addition.",
    "correct_answer": "D",
    "explanation": "Extinction occurs when the project comes to an end as planned. Starvation occurs when resources are cut off from the project. Integration occurs when the resources on the project are reassigned to other projects or activities. Addition occurs when the project evolves into ongoing operations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      161,
      127,
      88,
      274
    ],
    "source": "892458_c10"
  },
  {
    "id": 630,
    "question": "Which of the following charts are cause-and-effect diagrams or used to determine if there is a cause-and-effect correlation between two numerical variables? (Choose two.)",
    "choice_a": "Pareto chart",
    "choice_b": "Ishikawa diagram",
    "choice_c": "Run chart",
    "choice_d": "Scatter diagram",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Fishbone diagrams are cause-and-effect diagrams. Scatter diagrams are used to determine whether there is a correlation between cause and effect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      314,
      146,
      154
    ],
    "source": "892458_c10",
    "choice_e": "Histogram"
  },
  {
    "id": 631,
    "question": "This document is produced at the end of the project and reports the final project outcomes.",
    "choice_a": "Lessons learned",
    "choice_b": "Status report",
    "choice_c": "Project close report",
    "choice_d": "Postmortem analysis",
    "correct_answer": "C",
    "explanation": "The project close report is produced at the end of the project, and it serves as the final status report. It summarizes the project goals, costs, schedule, lessons learned, and historical data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      333,
      12,
      324,
      7
    ],
    "source": "892458_c10"
  },
  {
    "id": 632,
    "question": "You\u2019re a project manager for a large project. You\u2019re in the middle of the Executing phase. The project sponsor has decided to cancel the project because of unexpected cost overruns and resource shortages. What are your next steps? (Choose two.)",
    "choice_a": "Change vendors to obtain a lower bid for hardware and software components.",
    "choice_b": "Prepare project closure documents.",
    "choice_c": "Perform a lessons learned analysis and release resources.",
    "choice_d": "Ask the sponsor to allow you to redesign the project with fewer deliverables.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "If you have a sponsor who opts to cancel the project, you will still perform project closing procedures. During this process, you\u2019ll assemble the closure documents, perform a lessons learned analysis, and release any resources working on the project.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      11,
      325,
      330,
      331,
      321
    ],
    "source": "892458_c10",
    "choice_e": "Ask the stakeholders to speak to the sponsor."
  },
  {
    "id": 633,
    "question": "You are at the end of the project and need to obtain final sign-off and create the project closure report. According to CompTIA, before obtaining sign off, what should you do?",
    "choice_a": "Inspect the deliverables.",
    "choice_b": "Perform verification and validation of the product of the project.",
    "choice_c": "Test the product of the project.",
    "choice_d": "Audit the deliverables.",
    "correct_answer": "B",
    "explanation": "You need to verify and validate that the product of the project meets the requirements set out in the statement of work and/or contract documents. All of the other options are ways to perform verification and validation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      89,
      88,
      97,
      335
    ],
    "source": "892458_c10"
  },
  {
    "id": 634,
    "question": "All of the following are true regarding the release of team members except for which one?",
    "choice_a": "Team members are released after lessons learned are documented.",
    "choice_b": "The project manager should perform a final performance appraisal for team members when they\u2019re released from the project.",
    "choice_c": "The project manager should inform the functional managers well in advance of the team members\u2019 release date.",
    "choice_d": "The project manager should communicate with the team members about their upcoming release date.",
    "correct_answer": "A",
    "explanation": "Team members can be released prior to the lessons learned session. If your team members are leaving the organization or are located at a different geographical location, you could perform a lessons learned session with them before they leave, or you could include them in the final lessons learned session using videoconferencing or similar technology.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      335,
      241,
      179,
      173,
      51
    ],
    "source": "892458_c10"
  },
  {
    "id": 635,
    "question": "Your project has experienced some setbacks, and your stakeholders are not happy with progress. A hurricane wiped out one of your vendor\u2019s warehouses, and you are scrambling for parts. The hurricane was unexpected and unusual for that area. You work with the vendor and your procurement department to find other suppliers who may have the parts you need. Which of the following is the best option given this scenario?",
    "choice_a": "Cancel the project.",
    "choice_b": "This is a risk that has come about, and you should implement the response plan.",
    "choice_c": "This is an issue that should be recorded and tracked in the issue log.",
    "choice_d": "This is a KPI that the vendor has not met.",
    "correct_answer": "C",
    "explanation": "This question describes an issue that has occurred on the project that will likely impede progress. You will record this issue in the issue log and report regularly on its status. Option B is not true given this question because the hurricane was unlikely and unusual so the team would probably not have documented this as a risk. Once a risk occurs, it becomes an issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      315,
      317,
      318,
      271,
      276
    ],
    "source": "892458_c10"
  },
  {
    "id": 636,
    "question": "Who is responsible for authorizing the closure of the project?",
    "choice_a": "Stakeholders",
    "choice_b": "Project manager",
    "choice_c": "Executive team members",
    "choice_d": "Sponsor",
    "correct_answer": "D",
    "explanation": "The sponsor is the one who signs off on the closure documents. As the project manager, you create the documentation and provide supporting artifacts to demonstrate that all deliverables have been successfully completed.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      11,
      66,
      71,
      67,
      12
    ],
    "source": "892458_c10"
  },
  {
    "id": 637,
    "question": "What are the defining characteristics of a project? (Choose two.)",
    "choice_a": "A group of related tasks",
    "choice_b": "Temporary in nature",
    "choice_c": "Operational activities",
    "choice_d": "Reworking of an existing project",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "A project can be summarized as having the following properties: It is temporary in nature, it creates a unique product or service, it has a definite start and finish, it contains a reason/purpose, and it may be part of a program or portfolio. A group of related tasks is not necessarily a project but could be a to-do list of any kind. Operational activities are activities that take place after a project has been completed. Reworking an existing project is not creating a new product or service, and it doesn't meet the properties of a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      88,
      95,
      6
    ],
    "source": "9781119892502",
    "choice_e": "Creation of a unique product or service"
  },
  {
    "id": 638,
    "question": "The project team is responsible for all of the following, EXCEPT:",
    "choice_a": "Providing governance on the project",
    "choice_b": "Contributing to the deliverables according to the schedule",
    "choice_c": "Contributing expertise to the project",
    "choice_d": "Estimating costs and dependencies",
    "correct_answer": "A",
    "explanation": "Providing governance on the project is the responsibility of a project management office, not the project team. The project team is responsible for contributing expertise to the project, contributing deliverables according to the schedule, estimating task duration, and estimating costs and dependencies.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      55,
      56,
      57,
      201,
      200
    ],
    "source": "9781119892502"
  },
  {
    "id": 639,
    "question": "A team member is upset about having to stay late as he will miss a scouts meeting with his son. He approaches the project manager, who lets him know that it is a one-time thing and if they work tonight, they will not have to come in this weekend. Upset, the team member stays and finishes his work. This is an example of what type of conflict resolution?",
    "choice_a": "Smoothing",
    "choice_b": "Confronting",
    "choice_c": "Compromising",
    "choice_d": "Avoiding",
    "correct_answer": "A",
    "explanation": "The project manager is attempting to make the conflict appear less important than it really is by implying they would have to work this weekend if they didn't stay tonight. No attempt is made to see if there was another solution, like coming in early tomorrow.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      177,
      230,
      245,
      173,
      179
    ],
    "source": "9781119892502",
    "choice_e": "Forcing"
  },
  {
    "id": 640,
    "question": "When evaluating the project phases, in which phase will project costs be the highest?",
    "choice_a": "Initiating",
    "choice_b": "Discovery",
    "choice_c": "Execution",
    "choice_d": "Closing",
    "correct_answer": "C",
    "explanation": "This is where most of the expenditures on materials and people time will occur.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      106,
      275,
      205,
      211
    ],
    "source": "9781119892502"
  },
  {
    "id": 641,
    "question": "As a project nears a critical deadline, Ed approaches the project manager and wants to take a couple of days off. The project manager needs Ed's skills to meet the deadline but can see how exhausted Ed has become. They agree that Ed will work through the deadline and then get a couple of days off. Ed accepts this plan and goes back to work. This is an example of what type of conflict resolution?",
    "choice_a": "Smoothing",
    "choice_b": "Confronting",
    "choice_c": "Compromising",
    "choice_d": "Avoiding",
    "correct_answer": "C",
    "explanation": "This is where both parties give up something to help reach a workable solution. The commitment to meeting the deadline and the agreement to allow for time off but adjusting the timing are the key decision points.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      177,
      23,
      230,
      51
    ],
    "source": "9781119892502",
    "choice_e": "Forcing"
  },
  {
    "id": 642,
    "question": "What plan determines the information needs of the stakeholders, format of information delivery, delivery frequency, and the preparer?",
    "choice_a": "Stakeholder Analysis plan",
    "choice_b": "Project Charter",
    "choice_c": "Human Resources plan",
    "choice_d": "Communication plan",
    "correct_answer": "D",
    "explanation": "The Communication plan is where all the elements of the who, what, when, where, and why of communication needs are documented.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      269,
      229,
      265,
      272
    ],
    "source": "9781119892502"
  },
  {
    "id": 643,
    "question": "What is the definition of a portfolio?",
    "choice_a": "A collection of the sample work a project manager has done that they should bring to an interview",
    "choice_b": "A collection of programs, subportfolios, and projects that support strategic business goals or objectives",
    "choice_c": "A group of related projects that are managed together using shared resources and similar techniques",
    "choice_d": "A group of project investments that are maintained to help finance projects",
    "correct_answer": "B",
    "explanation": "A portfolio is a collection of programs, subportfolios, and projects that support strategic business goals or objectives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      57,
      28,
      323,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 644,
    "question": "In terms of project management, what is a program?",
    "choice_a": "A listing of all individuals involved in the project, including key stakeholders",
    "choice_b": "The software package used to enter and track project management aspects",
    "choice_c": "Related projects that are coordinated and managed with similar techniques",
    "choice_d": "A collection of projects and subportfolios that support strategic goals of the business",
    "correct_answer": "C",
    "explanation": "A program is a group of related projects that are managed together, with coordinated processes and techniques. Option A would be a stakeholder register, which might be a deliverable of the stakeholder analysis. Option B would be the software that is used as a part of the project management information system (PMIS). Option D is the definition of a portfolio. Make sure you know the difference between a project and a portfolio.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      57,
      6,
      3,
      56
    ],
    "source": "9781119892502"
  },
  {
    "id": 645,
    "question": "During an Agile daily stand-up meeting, what are three questions that are asked and answered?",
    "choice_a": "What did I accomplish yesterday? What will I do today? What are the necessary next steps?",
    "choice_b": "What did I accomplish today? Who will I be working with today? What obstacles are preventing progress?",
    "choice_c": "What did I accomplish yesterday? Who will I be working with today? What obstacles are preventing progress?",
    "choice_d": "What did I accomplish yesterday? What will I do today? What obstacles are preventing progress?",
    "correct_answer": "D",
    "explanation": "What did I accomplish yesterday?, What will I do today?, and What obstacles are preventing progress? are the three questions asked during a stand-up, or Scrum, meeting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      300,
      107,
      120,
      117
    ],
    "source": "9781119892502"
  },
  {
    "id": 646,
    "question": "Marcus works for Wigitcom, and he has been assigned to work on a project. Marcus's regular boss pulls him back to work on assignments and will conduct his performance review. What type of organizational structure is Wigitcom using?",
    "choice_a": "Agile",
    "choice_b": "Functional",
    "choice_c": "Matrix",
    "choice_d": "Projectized",
    "correct_answer": "B",
    "explanation": "All authority in this example rests with the functional manager who is pulling Marcus back to work on other assignments rather than the project. In a functional organizational structure, resources typically report to a functional manager and the project manager has limited or no authority.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      160,
      161,
      163,
      244
    ],
    "source": "9781119892502"
  },
  {
    "id": 647,
    "question": "A project has a key contributor who is absent from meetings, not meeting deadlines, and affecting the morale of other individuals on a team. There is no other person within the company with the expertise needed to perform the tasks assigned to this team member. Which of the following would be the appropriate action for the project manager?",
    "choice_a": "Bring the team member in for a counseling session.",
    "choice_b": "Leave the employee alone and distribute work to other team members.",
    "choice_c": "Remove the team member from the project and seek a replacement.",
    "choice_d": "Relocate the team member to a different facility.",
    "correct_answer": "A",
    "explanation": "In this scenario, working with the team member to get the desired result is the best course of action. Removing or replacing a team member is not always an option, and thus is incorrect.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      174,
      55,
      173,
      256,
      230
    ],
    "source": "9781119892502"
  },
  {
    "id": 648,
    "question": "Which of the following is not a role of a project steering committee?",
    "choice_a": "Monitoring project progress",
    "choice_b": "Sprint planning",
    "choice_c": "Advocacy",
    "choice_d": "Offering expert opinion",
    "correct_answer": "B",
    "explanation": "Sprint planning is a tactical activity that is left to the project manager and project team. Steering committees operate in the strategic realm of the project by setting strategies and goals, advocating for different initiatives and projects, and offering their expert opinion to the project team to help guide project success.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      263,
      53,
      6,
      253,
      119
    ],
    "source": "9781119892502"
  },
  {
    "id": 649,
    "question": "How far in advance should an agenda be published?",
    "choice_a": "24 hours",
    "choice_b": "48 hours",
    "choice_c": "1 week",
    "choice_d": "1 month",
    "correct_answer": "A",
    "explanation": "As a general rule, agendas should be published at least 24 hours in advance. Remember that the project communication plan or company norms could set this target to a different threshold.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      254,
      271,
      269,
      247,
      272
    ],
    "source": "9781119892502"
  },
  {
    "id": 650,
    "question": "A meeting held daily or a couple of times a week where participants give updates on project status, often while standing, is what type of meeting?",
    "choice_a": "Status meeting",
    "choice_b": "Focus group",
    "choice_c": "Stand-up meeting",
    "choice_d": "Demonstration",
    "correct_answer": "C",
    "explanation": "In stand-up meetings, participants typically stand, relying on the discomfort of physically standing to help keep the length of the meeting short. Often, stand-ups are held daily and last for approximately 15 minutes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      255,
      253,
      256,
      25,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 651,
    "question": "Kim is a project manager who has just been assigned a software development project. She needs help in identifying all the tasks that need to be completed for the project to be successful. What kind of meeting should she use?",
    "choice_a": "Joint application development",
    "choice_b": "Joint application review",
    "choice_c": "Status meeting",
    "choice_d": "Brainstorming",
    "correct_answer": "D",
    "explanation": "Brainstorming is a great way to generate ideas quickly where a group discussion can produce ideas or solve problems.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      261,
      253,
      136,
      127,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 652,
    "question": "In what organizational structure does a project manager have the most limited authority?",
    "choice_a": "Weak-matrix",
    "choice_b": "Projectized",
    "choice_c": "Strong-matrix",
    "choice_d": "Functional",
    "correct_answer": "D",
    "explanation": "In a functional organization, the authority resides with the functional manager, not the project manager.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      161,
      160,
      163,
      53
    ],
    "source": "9781119892502"
  },
  {
    "id": 653,
    "question": "A building project requires the following steps: construction, purchasing the build site, blueprinting, and inspection. Purchasing the build site has what relationship to construction?",
    "choice_a": "It is a successor task.",
    "choice_b": "It is a mandatory task.",
    "choice_c": "It is a predecessor task.",
    "choice_d": "It is a discretionary task.",
    "correct_answer": "C",
    "explanation": "The purchasing of the build site must occur before the construction activity begins.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      275,
      127,
      86,
      136,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 654,
    "question": "Which of the following is the form in which project schedules are typically displayed?",
    "choice_a": "PERT",
    "choice_b": "Calendar",
    "choice_c": "Gantt chart",
    "choice_d": "Pareto chart",
    "correct_answer": "C",
    "explanation": "The Gantt chart is a type of bar chart that shows task duration and dependencies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      137,
      136,
      141,
      147
    ],
    "source": "9781119892502"
  },
  {
    "id": 655,
    "question": "The project team has been asked to use only the company established tools for instant communication and not use their personal cell phones or computers for such communication. This is an example of:",
    "choice_a": "Communication security",
    "choice_b": "Communication integrity",
    "choice_c": "Communication archiving",
    "choice_d": "Escalating communication issues",
    "correct_answer": "A",
    "explanation": "The best answer is communication security. By utilizing the established communication tools, the organizations can enable encryption and multifactor authentication to prevent unauthorized release of information. Communication integrity deals with ensuring information is protected by policies and rules proving the information to be correct and true. Communication archiving refers to making sure records are stored correctly and are deleting according to an established schedule. (Author's note: There is an argument to be made that A, B, and C are all correct as this kind of company or project policy can have positive effects on communication security, integrity, and archiving. So, if you answered one of those options, give yourself a pass).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      269,
      72,
      271,
      280,
      74
    ],
    "source": "9781119892502"
  },
  {
    "id": 656,
    "question": "When the project team is dependent on an entity outside the organization, like a product vendor delivering equipment, this is known as what type of dependency?",
    "choice_a": "Discretionary",
    "choice_b": "Mandatory",
    "choice_c": "External",
    "choice_d": "Financial",
    "correct_answer": "C",
    "explanation": "An external dependency is where an entity or condition outside of the project drives the scheduling for that task.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      144,
      129,
      127,
      88
    ],
    "source": "9781119892502"
  },
  {
    "id": 657,
    "question": "All electronic communications and meetings notes are stored with the project file at the conclusion of the project. This is an example of:",
    "choice_a": "Communication security",
    "choice_b": "Communication integrity",
    "choice_c": "Communication archiving",
    "choice_d": "Communication planning",
    "correct_answer": "C",
    "explanation": "The best answer is communication archiving. Likely established in the project plan or communication plan, the retention of the emails, instant messages, text messages, and other forms of communication should be established. It is likely the company has a retention schedule already established that would just need to be followed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      271,
      269,
      247,
      25
    ],
    "source": "9781119892502"
  },
  {
    "id": 658,
    "question": "A project has task A, which will take 2 days; task B, which will take 3 days, task C, which will take 2 days; task D, which will take 2 days; and task E, which will take 3 days. Task A is a predecessor for task B and for task C. Task C is a predecessor for task D. Both task B and task D are predecessors for task E. <p>What is the task sequence for the critical path?</p>",
    "choice_a": "A => B => E",
    "choice_b": "A => B => C => D => E",
    "choice_c": "A => B => D => E",
    "choice_d": "A => C => D => E",
    "correct_answer": "D",
    "explanation": "A =&gt; C =&gt; D =&gt; E. The critical path has task A (2 days), task C (2 days), task D (2 days), and task E (3 days) for a total of 9 days.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      137,
      141,
      147,
      136
    ],
    "source": "9781119892502"
  },
  {
    "id": 659,
    "question": "All of the following are aspects of an Agile sprint, EXCEPT:",
    "choice_a": "It is limited to a timeframe such as two weeks.",
    "choice_b": "A planning meeting is held to figure out what the team can accomplish.",
    "choice_c": "A small feature set is taken to completion.",
    "choice_d": "The team works at an incredible pace for the entire time.",
    "correct_answer": "D",
    "explanation": "There is no heroic effort that occurs during an Agile sprint, which is a short burst of activity on a project focusing on a few tasks and working them to a completed state.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      158,
      157,
      120,
      107,
      300
    ],
    "source": "9781119892502"
  },
  {
    "id": 660,
    "question": "April works for Wigitcom and has recently been assigned to a project. She was given assignments from both her functional manager and the project manager but was directed to do the project work. When April requested leave, it was granted by her functional manager but then denied by the project manager. What type of organizational structure is Wigitcom using?",
    "choice_a": "Projectized",
    "choice_b": "Strong-matrix",
    "choice_c": "Balanced-matrix",
    "choice_d": "Weak-matrix",
    "correct_answer": "B",
    "explanation": "In this scenario, all of the power and authority are present with the project manager and not the functional manager, which is indicative of a strong-matrix organizational structure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      160,
      159,
      161,
      163,
      244
    ],
    "source": "9781119892502"
  },
  {
    "id": 661,
    "question": "A meeting to provide a status update on the progress and spending on a project would be what type of meeting?",
    "choice_a": "Collaborative",
    "choice_b": "Informative",
    "choice_c": "Decisive",
    "choice_d": "Focus groups",
    "correct_answer": "B",
    "explanation": "Status meetings are informative meetings. Informative meetings can also include demonstrations, presentations, and stand-ups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      254,
      255,
      265,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 662,
    "question": "Brad is a junior software developer who is having problems remembering where the source code is for a certain routine. He needs to contact Bridget, the senior developer on the project. What would be the ideal way to contact her?",
    "choice_a": "Email",
    "choice_b": "Impromptu meeting",
    "choice_c": "Instant messaging",
    "choice_d": "Fax",
    "correct_answer": "C",
    "explanation": "Instant messaging is less disruptive than an impromptu meeting where Bridget's concentration might be disrupted beyond just answering the question. Instant messaging allows Bridget to respond and return to her work and is also more expedient than email.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      230,
      255,
      253,
      24
    ],
    "source": "9781119892502"
  },
  {
    "id": 663,
    "question": "A project manager is trying to get a safety update to project team members out in the field. What are appropriate methods to communicate the update to the team? (Choose two).",
    "choice_a": "Fax",
    "choice_b": "Text message",
    "choice_c": "Social media",
    "choice_d": "Voice conferencing",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Giving the project team a phone call or sending text messages are preferable because they immediately alert the receiver that you are attempting to communicate with them.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      271,
      272,
      241,
      237
    ],
    "source": "9781119892502",
    "choice_e": "Distribution of printed media"
  },
  {
    "id": 664,
    "question": "New, complex instructions need to be communicated to a project team. What is the best communication method to distribute this information?",
    "choice_a": "Distribution of printed media",
    "choice_b": "Email",
    "choice_c": "Text message",
    "choice_d": "Social media",
    "correct_answer": "B",
    "explanation": "Well-formed, written communication such as email is a great format to share complex information because the receiver can digest and process the information, refer back to it, and send follow-up questions as needed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      234,
      233,
      246,
      229,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 665,
    "question": "What are the defining characteristics of a project? (Choose two.)",
    "choice_a": "Has a definitive start and end date",
    "choice_b": "Is assigned to a portfolio",
    "choice_c": "Creates a unique product or service",
    "choice_d": "Is a part of ongoing operational activities",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The two most correct answers are that the project has a definitive start and end date and that it creates a unique product or service. Projects are considered a success when the goals they set out to accomplish are fulfilled and the stakeholders are satisfied with the results.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      6,
      51,
      95,
      90
    ],
    "source": "9781119892502",
    "choice_e": "Is part of an organization's strategic plan"
  },
  {
    "id": 666,
    "question": "Which of the following describes a portfolio?",
    "choice_a": "A collection of the sample work a project manager has done that should be brought to an interview",
    "choice_b": "A collection of programs, subportfolios, and projects that support strategic business goals or objectives",
    "choice_c": "A group of related projects that are managed together using shared resources and similar techniques",
    "choice_d": "A group of project investments that are maintained to help finance projects",
    "correct_answer": "B",
    "explanation": "A portfolio is a collection of programs, subportfolios, and projects that support strategic business goals or objectives. Programs and projects within a portfolio are not necessarily related to one another in a direct way, and projects may independently exist within the portfolio.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      5,
      57,
      28,
      3,
      4
    ],
    "source": "9781119892502"
  },
  {
    "id": 667,
    "question": "DewDrops is a struggling global start-up with a project team located on three different continents. The customer of the project just radically altered one of the triple constraints. What is the best communication method to share this information with the project team?",
    "choice_a": "Impromptu meetings",
    "choice_b": "Virtual meeting",
    "choice_c": "Email",
    "choice_d": "Instant messaging",
    "correct_answer": "C",
    "explanation": "Working on three different continents would mean one work team is likely off-duty/sleeping at any given time during the day. As such, the best method would be email so that the off-duty team would get the information when they begin their shift, while the other teams would get the information instantly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      233,
      234,
      90,
      232
    ],
    "source": "9781119892502"
  },
  {
    "id": 668,
    "question": "After the project charter is signed, what meeting is held to introduce the project team and stakeholders as well as outlining the goals for the project?",
    "choice_a": "Lessons learned meeting",
    "choice_b": "Project introductory meeting",
    "choice_c": "Kickoff meeting",
    "choice_d": "Team building lunch",
    "correct_answer": "C",
    "explanation": "This is where the project team members and stakeholders are introduced and the goals for the project are outlined.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      181,
      51,
      253,
      88,
      95
    ],
    "source": "9781119892502"
  },
  {
    "id": 669,
    "question": "Which soft skills are important for a project manager?",
    "choice_a": "Time management, earned value calculation, listening, critical path diagrams",
    "choice_b": "Leadership, time management, team building, listening",
    "choice_c": "Time management, earned value calculation, leadership, critical path diagrams",
    "choice_d": "Leadership, following, independence, listening",
    "correct_answer": "B",
    "explanation": "Leadership, time management, team building, and listening are soft skills that are important for a project manager. Critical path diagrams are an artifact, and the creation of them would be considered a hard skill, so options A and C are incorrect. Following and independence are soft skills, but not typically associated with project management, so D is also incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      23,
      24,
      25,
      230
    ],
    "source": "9781119892502"
  },
  {
    "id": 670,
    "question": "A project is entering the Execution phase, the manager has completed the project planning, and is looking to introduce the key points to the project team. What is the appropriate form of communication for the next step?",
    "choice_a": "Video conference",
    "choice_b": "Impromptu meeting",
    "choice_c": "Email",
    "choice_d": "Kickoff meeting",
    "correct_answer": "D",
    "explanation": "The kickoff meeting typically happens at the beginning of the Executing phase and is a primary means of introducing the project team to each other.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      232,
      227,
      247,
      254
    ],
    "source": "9781119892502"
  },
  {
    "id": 671,
    "question": "A project schedule serves what function?",
    "choice_a": "Determines the project cost accounting codes",
    "choice_b": "Creates a deliverable-based decomposition of the project",
    "choice_c": "Lists the actions that should be resolved to fulfill deliverables",
    "choice_d": "Determines start and finish dates for project activities",
    "correct_answer": "D",
    "explanation": "A project schedule determines start and finish dates for project activities and will also have activity durations and order of precedence.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      136,
      144,
      141,
      274
    ],
    "source": "9781119892502"
  },
  {
    "id": 672,
    "question": "Cheryl is a technical lead on a project that is wrapping up remote work at a customer site. What is the best method to communicate the work efforts and next steps with the customer?",
    "choice_a": "Virtual meeting",
    "choice_b": "In-person meeting",
    "choice_c": "Closure meeting",
    "choice_d": "Kickoff meeting",
    "correct_answer": "C",
    "explanation": "The Closure meeting will give the status of all activities, allow the project team to turn in any property like ID badges/key cards, and bring that phase of the work effort to an end.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      253,
      271,
      256,
      335,
      265
    ],
    "source": "9781119892502"
  },
  {
    "id": 673,
    "question": "All of the following are ways to determine whether a project is completed, EXCEPT:",
    "choice_a": "When the project manager declares the project is complete",
    "choice_b": "When the project is canceled",
    "choice_c": "When it has been determined that the goals and objectives of the project cannot be accomplished",
    "choice_d": "When the objectives are accomplished and stakeholders are satisfied",
    "correct_answer": "A",
    "explanation": "The project manager is not the critical role in this answer. Unless it falls into one of the other three phases, this does not hold true.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      88,
      127,
      101,
      302
    ],
    "source": "9781119892502"
  },
  {
    "id": 674,
    "question": "Wigitcom has just been hacked, and millions of records containing personal information of their customers has been stolen. The CEO is in a meeting for the rest of the day. What is the best communication method to let the boss know of the situation?",
    "choice_a": "Social media",
    "choice_b": "Impromptu meeting",
    "choice_c": "Text messaging",
    "choice_d": "Distribution of printed media",
    "correct_answer": "B",
    "explanation": "Where there is a significant change in the situation, interrupting the meeting and letting the CEO know with an in-person meeting would be the best choice due to the urgency.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      232,
      227,
      234,
      237,
      53
    ],
    "source": "9781119892502"
  },
  {
    "id": 675,
    "question": "The creation of a peanut butter and jelly sandwich has the following steps: <p>Serve.</p> <p>Gather bread, peanut butter, and jelly.</p> <p>Place bread on a plate.</p> <p>Get a knife.</p> <p>Spread peanut butter on one slice of bread.</p> <p>Put both slices of bread together.</p> <p>Spread jelly on the other slice of bread.</p> <p>What is the correct sequence for this project?</p>",
    "choice_a": "Serve; put both slices of bread together; gather bread, peanut butter, and jelly; get a knife; spread peanut butter on one slice of bread; place bread on a plate; spread jelly on the other slice of bread.",
    "choice_b": "Gather bread, peanut butter. and jelly; get a knife; spread peanut butter on one slice of bread; place bread on a plate; spread jelly on the other slice of bread; serve; put both slices of bread together.",
    "choice_c": "Gather bread, peanut butter, and jelly; get a knife; place bread on a plate; spread peanut butter on one slice of bread; spread jelly on the other slice of bread; put both slices of bread together; serve.",
    "choice_d": "Gather bread, peanut butter, and jelly; get a knife; place bread on a plate; spread peanut butter on one slice of bread; spread jelly on the other slice of bread; serve; put both slices of bread together.",
    "correct_answer": "C",
    "explanation": "Determining activity sequence is an important part of project management, and you will probably see a question like this on the test. For this question, the correct order is: gather bread, peanut butter, and jelly; get a knife; place bread on a plate; spread peanut butter on one slice of bread; spread jelly on the other slice of bread; put both slices of bread together; serve.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      127,
      88,
      86,
      56,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 676,
    "question": "Which of the following steps are important in the development of the project schedule? (Choose three.)",
    "choice_a": "Determine tasks.",
    "choice_b": "Set the quality plan.",
    "choice_c": "Set the communication plan.",
    "choice_d": "Sequence the tasks.",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "Some of the important steps required in the development of the critical path include determining the tasks, determining task start/finish dates, determining task durations and milestones, putting them in sequential order by identifying predecessors and setting dependencies, and identifying the critical path. Scheduling activities also address the allocation of resources, setting of baselines, and quality/governance gates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      136,
      141,
      137,
      144,
      129
    ],
    "source": "9781119892502",
    "choice_e": "Construct a Pareto diagram.",
    "choice_f": "Identify the critical path."
  },
  {
    "id": 677,
    "question": "The project manager has been gathering a batch of routine organizational messages, project updates, and status reports. What would be the best communication method to share this information?",
    "choice_a": "Video conference",
    "choice_b": "Impromptu meeting",
    "choice_c": "Social media",
    "choice_d": "Scheduled meeting",
    "correct_answer": "D",
    "explanation": "For non-urgent information, regular scheduled meetings would the ideal format to share this type of information. On the standing agenda, including a portion to discuss routine updates is a good practice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      271,
      265,
      234,
      256
    ],
    "source": "9781119892502"
  },
  {
    "id": 678,
    "question": "What type of communication method would make sense for routine status meetings on a project where the team is spread out in different cities on the same continent?",
    "choice_a": "In-person meetings",
    "choice_b": "Virtual meetings",
    "choice_c": "Closure meetings",
    "choice_d": "Kickoff meetings",
    "correct_answer": "B",
    "explanation": "To help control costs and to minimize disruption to project work, a virtual meeting would be the ideal choice to handle routine meetings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      269,
      246,
      254,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 679,
    "question": "To help celebrate the completion of a major project milestone, the project sponsor wants to hold a barbeque on Friday afternoon. What is the best communication method to share this information with the team?",
    "choice_a": "Email",
    "choice_b": "Impromptu meeting",
    "choice_c": "Scheduled meeting",
    "choice_d": "Fax",
    "correct_answer": "A",
    "explanation": "For routine messages, or for very complex messages, email is the best method as it allows the project team to consume the information when they choose and minimizes the disruption of project work.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      234,
      233,
      229,
      227,
      237
    ],
    "source": "9781119892502"
  },
  {
    "id": 680,
    "question": "Which of the following are tools and techniques used for developing a project team? (Choose three.)",
    "choice_a": "Team-building activities",
    "choice_b": "Project requirements",
    "choice_c": "Recognition and rewards",
    "choice_d": "Lessons learned meetings",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Using team-building activities, using recognition and rewards, and setting the ground rules are some of the tools that you can use to develop an effective project team.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      175,
      335,
      23,
      177,
      178
    ],
    "source": "9781119892502",
    "choice_e": "Setting the ground rules",
    "choice_f": "Project kickoff meetings"
  },
  {
    "id": 681,
    "question": "In what stage of team development are teams the most productive and trust levels the highest among team members?",
    "choice_a": "Forming",
    "choice_b": "Storming",
    "choice_c": "Norming",
    "choice_d": "Performing",
    "correct_answer": "D",
    "explanation": "This is the ideal state teams are shooting for, where the team is productive and effective. Not all teams are able to achieve this stage of development.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      173,
      175,
      245,
      177
    ],
    "source": "9781119892502",
    "choice_e": "Adjourning"
  },
  {
    "id": 682,
    "question": "Once a change to the project has been accepted and implemented, what is the next step the project manager should perform?",
    "choice_a": "Conduct a preliminary review.",
    "choice_b": "Collocation.",
    "choice_c": "Determine decision-makers.",
    "choice_d": "Communicate change deployment.",
    "correct_answer": "D",
    "explanation": "The project manager should refer to the communication plan and inform appropriate stakeholders that the change has been implemented.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      271,
      272,
      247,
      51,
      23
    ],
    "source": "9781119892502"
  },
  {
    "id": 683,
    "question": "A start-up company is attempting to compete in an emerging product market. There are constant disruptive technology changes, and the market is shifting in their product tastes. This type of situation would be best served by which of the following?",
    "choice_a": "Agile approach",
    "choice_b": "Projectized environment",
    "choice_c": "Functional environment",
    "choice_d": "Traditional, or waterfall",
    "correct_answer": "A",
    "explanation": "When requirements are changing, an Agile approach allows an organization to be readily able to adapt to the environment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      158,
      108,
      117,
      118,
      123
    ],
    "source": "9781119892502"
  },
  {
    "id": 684,
    "question": "Kayla works for Wigitcom, and she has been assigned to work on a project. Kayla's project manager gives her direction. At the end of the project, the project manager will conduct Kayla's performance review and she will be free to be given a new work assignment. What type of organizational structure is Wigitcom using?",
    "choice_a": "Agile",
    "choice_b": "Functional",
    "choice_c": "Matrix",
    "choice_d": "Projectized",
    "correct_answer": "D",
    "explanation": "The project manager has the authority to task team resources and conduct performance evaluations, making this a projectized organizational structure.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      161,
      159,
      160,
      163,
      244
    ],
    "source": "9781119892502"
  },
  {
    "id": 685,
    "question": "In an Agile methodology, what is a user story?",
    "choice_a": "Key information about stakeholders and their jobs",
    "choice_b": "Short stories about someone using the product or service",
    "choice_c": "Customer survey results after product release",
    "choice_d": "Visual representation of product burndown",
    "correct_answer": "B",
    "explanation": "The user story helps focus on how the product is going to be used to help shape how it is designed.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      117,
      153,
      108,
      158,
      54
    ],
    "source": "9781119892502"
  },
  {
    "id": 686,
    "question": "A large, well-established organization that has been in business for many decades would likely have which organizational structures?",
    "choice_a": "Weak-matrix",
    "choice_b": "Projectized",
    "choice_c": "Strong-matrix",
    "choice_d": "Functional",
    "correct_answer": "D",
    "explanation": "More established organizations with mature processes and tenured staff would most likely have a functional organizational structure centered around specialties.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      160,
      161,
      244,
      163
    ],
    "source": "9781119892502"
  },
  {
    "id": 687,
    "question": "Marcus is working on a project to build a new video game. His boss asks him what it would take to make a major change to the platform engine. What would be Marcus's next step?",
    "choice_a": "Validate the change implementation.",
    "choice_b": "Implement changes.",
    "choice_c": "Conduct an impact assessment.",
    "choice_d": "Escalate to the CCB.",
    "correct_answer": "C",
    "explanation": "Conduct an impact assessment. When a change is being considered, it is important to understand how the proposed change will impact work on the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      281,
      87,
      86,
      91,
      214
    ],
    "source": "9781119892502"
  },
  {
    "id": 688,
    "question": "Identified in the form of user stories, what is a list of all things to be completed, whether technical or user-centric in nature, known as?",
    "choice_a": "Requirements",
    "choice_b": "Backlog",
    "choice_c": "Risk register",
    "choice_d": "Stakeholders",
    "correct_answer": "B",
    "explanation": "A backlog is the artifact that is used within an Agile methodology to keep track of all the elements that need to be included in a project but that may not be a part of this sprint.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      153,
      133,
      300,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 689,
    "question": "Thaala is a project manager creating an agenda for an upcoming meeting. It must be made for the project to stay on track. She gives 15 minutes on the agenda for each of the six items that must have direction for meeting to be successful. What activity has Thaala performed?",
    "choice_a": "Timeboxing",
    "choice_b": "Sprint planning",
    "choice_c": "Creating action items",
    "choice_d": "Joint application development",
    "correct_answer": "A",
    "explanation": "By setting fixed blocks of time for the team to reach a decision or direction in the meeting, Thaala is engaging in timeboxing.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      254,
      253,
      255,
      256,
      25
    ],
    "source": "9781119892502"
  },
  {
    "id": 690,
    "question": "What are milestones?",
    "choice_a": "A measure of the distance traveled on a project",
    "choice_b": "Characteristics of deliverables that must be met",
    "choice_c": "Checkpoints on a project to determine Go/No-Go decisions",
    "choice_d": "Major events in a project used to measure progress",
    "correct_answer": "D",
    "explanation": "Milestones are major events in a project used to measure progress.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      89,
      151,
      216,
      3
    ],
    "source": "9781119892502"
  },
  {
    "id": 691,
    "question": "The DewDrops project team is meeting with product stakeholders to go over recent product builds to ensure it meets expectations and requirements. What type of meeting is this?",
    "choice_a": "Joint application development session",
    "choice_b": "Joint application review session",
    "choice_c": "Joint budget committee",
    "choice_d": "Project steering committee",
    "correct_answer": "B",
    "explanation": "Joint application reviews are a collaboration that helps ensure the project is meeting its expected goals.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      253,
      261,
      51,
      54,
      95
    ],
    "source": "9781119892502"
  },
  {
    "id": 692,
    "question": "Which meeting role is responsible for leading the meeting by ensuring things run smoothly and that all goals of the meeting have been met by its end?",
    "choice_a": "Facilitator",
    "choice_b": "Scribe",
    "choice_c": "Timekeeper",
    "choice_d": "Coordinator",
    "correct_answer": "A",
    "explanation": "Facilitators are primarily impartial stewards of the meeting, helping to navigate conflict, address lack of participation, and keep the meeting on time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      255,
      25,
      256,
      181,
      272
    ],
    "source": "9781119892502"
  },
  {
    "id": 693,
    "question": "All of the following are types of dependencies, EXCEPT:",
    "choice_a": "Mandatory",
    "choice_b": "Discretionary",
    "choice_c": "External",
    "choice_d": "Backlog",
    "correct_answer": "D",
    "explanation": "In the Agile methodology, tasks can get recorded and identified in a backlog, but it is not a dependency important to task sequencing.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      137,
      144,
      136,
      133,
      157
    ],
    "source": "9781119892502"
  },
  {
    "id": 694,
    "question": "A stakeholder has asked to add a feature to a project, but the request is rejected by the project manager. What is the likely reason the scope was rejected?",
    "choice_a": "There is interaction between constraints.",
    "choice_b": "Scope creep is occurring on the project.",
    "choice_c": "The request can be handled without the formality.",
    "choice_d": "The sponsor is on vacation.",
    "correct_answer": "B",
    "explanation": "Remember that a project is temporary in nature, and at times adding too much to the scope changes the temporary aspect of the endeavor. Adding unapproved scope to the project is considered to be scope creep.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      87,
      3,
      88,
      91
    ],
    "source": "9781119892502"
  },
  {
    "id": 695,
    "question": "Creating a list of items that will be covered during a meeting is called:",
    "choice_a": "Task setting",
    "choice_b": "Action items",
    "choice_c": "Follow ups",
    "choice_d": "Agenda setting",
    "correct_answer": "D",
    "explanation": "An agenda outlines the items that will be discussed as well as major decisions that need to be made, and can include materials or topics attendees can read or prepare for in advance to make the meeting more productive.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      254,
      253,
      255,
      256,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 696,
    "question": "The project needs time for the team to work on the creation of an artifact. Which meeting type would be best for the team to use?",
    "choice_a": "Stand-up",
    "choice_b": "Focus groups",
    "choice_c": "Presentation",
    "choice_d": "Workshop",
    "correct_answer": "D",
    "explanation": "This is a meeting dedicated to creating a deliverable, engaging in intensive discussion and/or activity on a particular subject.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      253,
      254,
      255,
      256,
      25
    ],
    "source": "9781119892502"
  },
  {
    "id": 697,
    "question": "A company is expanding and has several projects underway. One project is building a new wing on the headquarters building, and the other is installing a new high-speed fiber network. The framing of the new building must begin before the installation of the new network can begin. This is an example of what type of logical relationship?",
    "choice_a": "Finish-to-finish",
    "choice_b": "Start-to-start",
    "choice_c": "Finish-to-start",
    "choice_d": "Start-to-finish",
    "correct_answer": "B",
    "explanation": "The framing of the walls must begin before the installation of the network cabling can begin, leading to a start-to-start relationship. The wiring must be in place before dry walling and insulation can begin.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      127,
      86,
      6,
      215
    ],
    "source": "9781119892502"
  },
  {
    "id": 698,
    "question": "A project has task A, which will take 2 days; task B which will take 3 days; task C, which will take 2 days; task D, which will take 2 days; and task E, which will take 3 days. Task A is a predecessor for task B and for task C. Task C is a predecessor for task D. Both task B and task D are predecessors for task E. <p>What is the duration of the critical path?</p>",
    "choice_a": "7 days",
    "choice_b": "9 days",
    "choice_c": "10 days",
    "choice_d": "11 days",
    "correct_answer": "B",
    "explanation": "The critical path has A (2 days), C (2 days), D (2 days), and E (3 days), for a total of 9 days.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      137,
      141,
      147,
      136
    ],
    "source": "9781119892502"
  },
  {
    "id": 699,
    "question": "In what project artifact would you find information relating to the quality and availability of resources?",
    "choice_a": "Project schedule",
    "choice_b": "Organization chart",
    "choice_c": "Resource calendar",
    "choice_d": "Risk register",
    "correct_answer": "C",
    "explanation": "The resource calendar will also let you know the dates resources are active or idle.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      148,
      141,
      162,
      163,
      164
    ],
    "source": "9781119892502"
  },
  {
    "id": 700,
    "question": "DewDrops has a project to implement a new human resource information system (HRIS) for the company. They have changed their minds during implementation, and they want to add an additional module to the final product. What type of change is this?",
    "choice_a": "Project change",
    "choice_b": "Organizational change",
    "choice_c": "Product change",
    "choice_d": "Mindset change",
    "correct_answer": "A",
    "explanation": "Changes to the scope while a project is still active, even if it is modifying the end product, is an example of scope creep and a change to the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      288,
      86,
      87,
      286,
      281
    ],
    "source": "9781119892502"
  },
  {
    "id": 701,
    "question": "At the end of a meeting, any assignments that were made, who was given that assignment, and the expected due date for completion are reviewed. This is a review of:",
    "choice_a": "Follow-ups",
    "choice_b": "Refinement",
    "choice_c": "Brainstorming",
    "choice_d": "Action items",
    "correct_answer": "D",
    "explanation": "Action items are specific tasks or activities that have been agreed on that need to be completed to help with project success. Action items should have an owner and a due date, and this ownership should be confirmed with the owner in the meeting, or immediately afterward if an action item was assigned to someone not in the meeting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      256,
      254,
      318,
      232,
      265
    ],
    "source": "9781119892502"
  },
  {
    "id": 702,
    "question": "Nyssa works for Wigitcom and has been assigned to a project. She wants to take a week off for a family reunion, which conflicts with a project deadline. The project manager denied her leave request, but her functional manager lets her attend the family reunion. What type of organizational structure is Wigitcom using?",
    "choice_a": "Projectized",
    "choice_b": "Strong-matrix",
    "choice_c": "Balanced-matrix",
    "choice_d": "Weak-matrix",
    "correct_answer": "D",
    "explanation": "While Nyssa is assigned to the project, it is clear that the power rests with the functional manager, undercutting the project manager's authority.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      159,
      160,
      161,
      163,
      244
    ],
    "source": "9781119892502"
  },
  {
    "id": 703,
    "question": "When is a project considered to be a success?",
    "choice_a": "Stakeholder expectations have been met.",
    "choice_b": "The phase completion has been approved.",
    "choice_c": "All project phases have been completed.",
    "choice_d": "The vendor has been released from the project.",
    "correct_answer": "A",
    "explanation": "Stakeholder expectations having been met is the most critical factor involved when determining whether a project is a success.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      89,
      97,
      3,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 704,
    "question": "Which of the following in an example of a deliverable?",
    "choice_a": "The date work on the project begins",
    "choice_b": "The design for a new product",
    "choice_c": "Time and materials applied to the project",
    "choice_d": "PMO",
    "correct_answer": "B",
    "explanation": "A deliverable can be any tangible or intangible product or service produced as the result of a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      86,
      127,
      3,
      117
    ],
    "source": "9781119892502"
  },
  {
    "id": 705,
    "question": "A project sponsor would be responsible for all of the following, EXCEPT:",
    "choice_a": "Developing high-level requirements for the project",
    "choice_b": "Functioning as the approval authority and removing roadblocks",
    "choice_c": "Marketing the project across the organization",
    "choice_d": "Estimating the costs and dependencies of the project activities",
    "correct_answer": "D",
    "explanation": "The project sponsors' responsibilities include helping define and develop the high-level requirements for the project, functioning as the approval authority, removing roadblocks, marketing the project across the organization, controlling the direction of the project, and defining the business case for the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      56,
      26,
      28,
      57
    ],
    "source": "9781119892502",
    "choice_e": "Serving to help control the direction of the project"
  },
  {
    "id": 706,
    "question": "A building project requires the following steps: construction, purchasing the build site, blueprinting, and inspection. Construction has what relationship to blueprinting?",
    "choice_a": "It is a successor task.",
    "choice_b": "It is a mandatory task.",
    "choice_c": "It is a predecessor task.",
    "choice_d": "It is a discretionary task.",
    "correct_answer": "A",
    "explanation": "It is a successor task. Construction would come after the blueprinting is approved.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      127,
      86,
      140,
      105,
      217
    ],
    "source": "9781119892502"
  },
  {
    "id": 707,
    "question": "All projects are constrained by which three elements as they affect quality?",
    "choice_a": "Time, budget, scope",
    "choice_b": "Time, risks, budget",
    "choice_c": "Cost, benefits, scope",
    "choice_d": "Cost, risks, scope",
    "correct_answer": "A",
    "explanation": "All projects are constrained by what is typically referred to as the \u201ctriple constraints,\u201d which include time, budget, and scope as they pertain to quality. Typically, you can manipulate two elements and will have to live with how they constrain the third element. You can have cheap, feature-rich, or fast: pick two of three.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      86,
      88,
      20,
      274
    ],
    "source": "9781119892502"
  },
  {
    "id": 708,
    "question": "What key milestone is triggered when the project charter is signed?",
    "choice_a": "A project sponsor can now be chosen.",
    "choice_b": "Key stakeholders are freed from project communication.",
    "choice_c": "The project is authorized to begin.",
    "choice_d": "Project resources are released from the project.",
    "correct_answer": "C",
    "explanation": "The charter gives formal authorization to begin and to commit resources to the project. Accordingly, project team selection and procurement can begin at this point.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      53,
      26,
      55,
      161,
      88
    ],
    "source": "9781119892502"
  },
  {
    "id": 709,
    "question": "Amy is a project manager and assigns Oswald to capture the meeting minutes. What role did she assign Oswald?",
    "choice_a": "Facilitator",
    "choice_b": "Scribe",
    "choice_c": "Timekeeper",
    "choice_d": "Coordinator",
    "correct_answer": "B",
    "explanation": "The scribe captures critical discussion points, action items, and follow-ups to document these items for future reference.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      255,
      256,
      253,
      25,
      232
    ],
    "source": "9781119892502"
  },
  {
    "id": 710,
    "question": "All of the following are examples of project resources, EXCEPT:",
    "choice_a": "Team members",
    "choice_b": "Equipment",
    "choice_c": "WBS",
    "choice_d": "Materials",
    "correct_answer": "C",
    "explanation": "The WBS is a project artifact, not resources in the resource management context.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      162,
      127,
      131,
      53,
      26
    ],
    "source": "9781119892502"
  },
  {
    "id": 711,
    "question": "What is resource smoothing?",
    "choice_a": "Accommodating resource availability within activity float times",
    "choice_b": "A schedule compression technique",
    "choice_c": "An attempt to balance assignments to prevent overload",
    "choice_d": "A method for loading heavy equipment",
    "correct_answer": "A",
    "explanation": "This technique does not change the critical path or project completion date but balances specific schedule dates when there is concern about resource availability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      148,
      147,
      141,
      164,
      151
    ],
    "source": "9781119892502"
  },
  {
    "id": 712,
    "question": "What is resource leveling?",
    "choice_a": "A storage technique for physical resources",
    "choice_b": "A schedule compression technique",
    "choice_c": "An attempt to balance assignments to prevent overload",
    "choice_d": "A method for loading heavy equipment",
    "correct_answer": "C",
    "explanation": "Overwhelming individuals on a project can lead to burnout, project turnover, or task slowdowns, which all will negatively impact a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      148,
      141,
      147,
      159,
      90
    ],
    "source": "9781119892502"
  },
  {
    "id": 713,
    "question": "Fast-tracking a project is a technique involving which of the following?",
    "choice_a": "Performing two tasks in parallel that were previously scheduled to start sequentially",
    "choice_b": "Looking at cost and schedule trade-offs such as adding more resources",
    "choice_c": "Moving later deliverables to earlier phases to appease stakeholders",
    "choice_d": "Removing critical path activities that are unnecessary",
    "correct_answer": "A",
    "explanation": "Fast tracking is a schedule compression technique that involves completing two tasks in parallel that were previously scheduled to start sequentially. This can come with a higher cost and with increased risk, but it will help the project be completed faster. Option D might be tempting but remember there are never unnecessary tasks on the critical path and therefore the answer cannot be correct.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      147,
      144,
      90,
      56,
      136
    ],
    "source": "9781119892502"
  },
  {
    "id": 714,
    "question": "The longest full path of any project is known as:",
    "choice_a": "Critical path",
    "choice_b": "Total float",
    "choice_c": "Delphi technique",
    "choice_d": "Pareto analysis",
    "correct_answer": "A",
    "explanation": "The critical path has zero float or slack time and is the shortest amount of time that a project can be completed.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      144,
      141,
      151,
      147,
      135
    ],
    "source": "9781119892502"
  },
  {
    "id": 715,
    "question": "What does a resource shortage mean?",
    "choice_a": "There is a shortage of things for team members to work on.",
    "choice_b": "Not enough resources are available for the task, leading to overallocation.",
    "choice_c": "There are too many resources, leading to underallocation.",
    "choice_d": "There is an abundancy of things for team members to work on.",
    "correct_answer": "B",
    "explanation": "There are not enough resources for the task, leading to overallocation. An individual's workload becomes more severe, leading to longer hours and a higher potential for burnout.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      164,
      148,
      162,
      163,
      26
    ],
    "source": "9781119892502"
  },
  {
    "id": 716,
    "question": "In what stage of team development do the members stop working with one another and return to their functional jobs?",
    "choice_a": "Forming",
    "choice_b": "Storming",
    "choice_c": "Norming",
    "choice_d": "Performing",
    "correct_answer": "E",
    "explanation": "Adjourning refers to the dissolving of the team when work has been completed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      335,
      159,
      168,
      173
    ],
    "source": "9781119892502",
    "choice_e": "Adjourning"
  },
  {
    "id": 717,
    "question": "Kayla is a project manager and has received a request to move up the due date of a project. How should she keep track of this change?",
    "choice_a": "Document the request in the change control log.",
    "choice_b": "Update the scope statement.",
    "choice_c": "Place the change on the Kanban board.",
    "choice_d": "Update this in the requestor's personal file.",
    "correct_answer": "A",
    "explanation": "Kayla should document the request in the change control log. The log can help keep track of the request, decisions that are made on the request, and the status of implementing the request.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      87,
      280,
      214,
      274
    ],
    "source": "9781119892502"
  },
  {
    "id": 718,
    "question": "WigitCom completed a project last year to roll out a new asset management platform of the organization. They are now looking to add an additional module to the platform. What type of change is this?",
    "choice_a": "Project change",
    "choice_b": "Organizational change",
    "choice_c": "Product change",
    "choice_d": "Asset change",
    "correct_answer": "C",
    "explanation": "Since the project was already completed, the asset management platform is considered in production. Upgrades, enhancements, and expansions would all be considered changes to the product.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      288,
      315,
      281,
      86,
      248
    ],
    "source": "9781119892502"
  },
  {
    "id": 719,
    "question": "An organization that has a fixed budget and offers a stable environment would be best suited for which type of project management approach?",
    "choice_a": "Traditional, or waterfall",
    "choice_b": "Projectized environment",
    "choice_c": "Agile approach",
    "choice_d": "Functional environment",
    "correct_answer": "A",
    "explanation": "A more established organization that is working with a fixed budget or other constraints would be best suited for more traditional project management approaches.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      302,
      107,
      112,
      90,
      105
    ],
    "source": "9781119892502"
  },
  {
    "id": 720,
    "question": "All of the following are life cycle phases of a project, EXCEPT:",
    "choice_a": "Planning",
    "choice_b": "Closing",
    "choice_c": "Development",
    "choice_d": "Execution",
    "correct_answer": "C",
    "explanation": "This may be an activity during either the Planning or Execution phase, depending on the nature of the industry the project is in.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      101,
      302,
      105,
      106,
      216
    ],
    "source": "9781119892502"
  },
  {
    "id": 721,
    "question": "What does a change control board (CCB) do to support the project?",
    "choice_a": "Helps vet and manage changes to the scope",
    "choice_b": "Provides an accounting structure for tasks",
    "choice_c": "Sets the standards and templates for the project",
    "choice_d": "Sets the costs of quality for the project",
    "correct_answer": "A",
    "explanation": "The change control board (CCB), in conjunction with the change control process, will approve or reject changes to the scope of the project.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      282,
      279,
      281,
      280,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 722,
    "question": "Which project role is responsible for coordinating resources between projects?",
    "choice_a": "Project management office (PMO)",
    "choice_b": "Project coordinator",
    "choice_c": "Project manager",
    "choice_d": "Project scheduler",
    "correct_answer": "A",
    "explanation": "While not listed, this function could also be done by a program or portfolio within those units only. The PMO performs this function across the organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      5,
      164,
      161,
      53
    ],
    "source": "9781119892502"
  },
  {
    "id": 723,
    "question": "The CCB has approved a change to the project that will add $5,000 to the cost and an additional week to the project duration. What should be the next step that happens?",
    "choice_a": "Escalate the decision to the executive committee.",
    "choice_b": "Consult the communication plan and inform the appropriate stakeholders.",
    "choice_c": "Determine the organization's tolerance for this change.",
    "choice_d": "Hold a Scrum meeting to see what to work on next.",
    "correct_answer": "B",
    "explanation": "Consult the communication plan and inform the appropriate stakeholders. It is crucial that approved changes to the project goals and scope are communicated to appropriate stakeholders. The communication plan should establish who needs to be notified when this event is triggered.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      271,
      272,
      247,
      248,
      281
    ],
    "source": "9781119892502"
  },
  {
    "id": 724,
    "question": "There is a difference of opinion between a group of stakeholders and the project team regarding the need of a change to the agreed upon requirements. They need help in making a decision; who should this be escalated to for a final decision?",
    "choice_a": "Project sponsor",
    "choice_b": "Project manager",
    "choice_c": "Executive steering committee",
    "choice_d": "Change control board",
    "correct_answer": "D",
    "explanation": "The change control board helps govern changes made to the scope of a project and help control against scope creep.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      87,
      279,
      53,
      286
    ],
    "source": "9781119892502"
  },
  {
    "id": 725,
    "question": "When should employee performance expectations be set on a project?",
    "choice_a": "Lessons learned meeting",
    "choice_b": "Employee performance review",
    "choice_c": "Stakeholder identification meeting",
    "choice_d": "First meeting with a new team member",
    "correct_answer": "D",
    "explanation": "Whenever a team member joins the project, or at the beginning of the project, when multiple people join, is when expectations should be set, including roles, due dates, norms, and team interactions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      174,
      181,
      168,
      169,
      120
    ],
    "source": "9781119892502"
  },
  {
    "id": 726,
    "question": "All of the following are used in an Agile approach to project management, EXCEPT:",
    "choice_a": "Burndown charts",
    "choice_b": "WBS",
    "choice_c": "Continuous requirements gathering",
    "choice_d": "Sprint planning",
    "correct_answer": "B",
    "explanation": "The work breakdown structure is characteristic of a more deliberate, up-front requirements gathering, when many of the requirements are identified early in the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      127,
      133,
      153,
      131,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 727,
    "question": "A project team is using a series of meetings where the software developers, business analysts, and product stakeholders meet frequently to collect and analyze software requirements. What type of meetings are these?",
    "choice_a": "Stand-ups",
    "choice_b": "Brainstorming",
    "choice_c": "Joint application review sessions",
    "choice_d": "Joint application development sessions",
    "correct_answer": "D",
    "explanation": "Joint application development sessions help ensure accuracy between the project scope definition and delivery through continuous interactions between the project team and stakeholders. Since the project is still working development, this is not an application review session yet. Note that it is possible for joint application development sessions to use brainstorming or even stand-ups as they work through the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      57,
      51,
      97,
      23
    ],
    "source": "9781119892502"
  },
  {
    "id": 728,
    "question": "Teams normally go through a similar development cycle. Which is the correct order of those stages?",
    "choice_a": "Norming, Forming, Storming, Adjourning, Performing",
    "choice_b": "Forming, Storming, Norming, Performing, Adjourning",
    "choice_c": "Forming, Norming, Performing, Storming, Adjourning",
    "choice_d": "Norming, Storming, Forming, Adjourning, Performing",
    "correct_answer": "B",
    "explanation": "This is the model that was developed by Dr. Bruce Tuckman, and it is known as the stages of team development.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      173,
      120,
      168,
      245
    ],
    "source": "9781119892502"
  },
  {
    "id": 729,
    "question": "In the development of a project schedule, the need to set governance gates is important. All of the following are examples of governance gates, EXCEPT:",
    "choice_a": "Daily stand-up meetings",
    "choice_b": "Client sign-off",
    "choice_c": "Management approval",
    "choice_d": "Legislative approval",
    "correct_answer": "A",
    "explanation": "Daily stand-up meetings are typically used with an Agile methodology. As such, a daily stand-up meeting would not have a governance body in attendance and would normally be attended by project team members.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      263,
      304,
      168,
      253,
      57
    ],
    "source": "9781119892502"
  },
  {
    "id": 730,
    "question": "Which project role outlines the consequences of nonperformance?",
    "choice_a": "Project manager",
    "choice_b": "Project coordinator",
    "choice_c": "Project scheduler",
    "choice_d": "Project management office",
    "correct_answer": "D",
    "explanation": "The PMO helps keep roles like the project manager and project team accountable from a more strategic standpoint.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      57,
      53,
      56,
      263,
      159
    ],
    "source": "9781119892502"
  },
  {
    "id": 731,
    "question": "WigitCom has undertaken a project to build a new app for the medical community. It holds a meeting to demonstrate its project prototype to doctors, nurses, administrators, and medical boards. How would you categorize this group of medical attendees in the context of the meeting?",
    "choice_a": "Steering committee members",
    "choice_b": "Shareholders",
    "choice_c": "Target audience",
    "choice_d": "Business analysts",
    "correct_answer": "C",
    "explanation": "The target audience is the most correct answer as the meeting has been called specifically to demonstrate the project prototype to the community the product is being designed and built for. It is possible that some of these members may be shareholders in the company and might also serve on the steering committee. The purpose of the meeting and size of the invitees makes the target audience the best answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      261,
      253,
      255,
      118,
      246
    ],
    "source": "9781119892502"
  },
  {
    "id": 732,
    "question": "The types of organizational structures include which of the following? (Choose three.)",
    "choice_a": "Agile",
    "choice_b": "Functional",
    "choice_c": "Matrix",
    "choice_d": "Colocation",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The three types of organizational structures are functional, matrix, and projectized. In a functional organization, decisions and control are driven by the specialized function (IT, accounting, HR, and so on). With a projectized organization, the project manager has decision-making authority and control over resources. A matrixed organization is a blended model between functional and projectized.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      160,
      161,
      163,
      162
    ],
    "source": "9781119892502",
    "choice_e": "Projectized"
  },
  {
    "id": 733,
    "question": "A meeting was convened with project decision-makers to discuss new developments in the funding for the project and whether to change the scope of the project or potentially seek other alternatives to funding. What type of meeting is this?",
    "choice_a": "Stand-up",
    "choice_b": "Workshop",
    "choice_c": "Steering committee",
    "choice_d": "Demonstration",
    "correct_answer": "C",
    "explanation": "The project steering committee is the senior decision-making body within the project's governance structure.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      263,
      53,
      51,
      315,
      87
    ],
    "source": "9781119892502"
  },
  {
    "id": 734,
    "question": "DewDrops is about to launch a new software product to the market. They are concerned about a new regulation that is being considered in a large state that may cause modification to the design, specifically around data privacy. It was suggested during a steering committee meeting that this issue get revisited after the final vote on the new law. What is this an example of?",
    "choice_a": "Follow-up",
    "choice_b": "Action item",
    "choice_c": "Task setting",
    "choice_d": "Refinement",
    "correct_answer": "A",
    "explanation": "Follow-ups check on the status of any new developments in the project environment that may have an impact on the scope, cost, or success of the project. These developments can be either internal or external.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      256,
      263,
      315,
      272,
      215
    ],
    "source": "9781119892502"
  },
  {
    "id": 735,
    "question": "A project management office (PMO) has which of the following responsibilities? (Choose three.)",
    "choice_a": "Markets the project across the business",
    "choice_b": "Provides governance for projects",
    "choice_c": "Manages the team, communication, scope, risk, budget, and time of the project",
    "choice_d": "Maintains standard documentation and templates",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "The PMO provides guidance to project managers and helps present a consistent, reliable approach to managing projects across the organization. Responsibilities include providing governance for projects, maintaining standard documentation and templates, and establishing key performance indicators and parameters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      89,
      320,
      72,
      73
    ],
    "source": "9781119892502",
    "choice_e": "Establishes key performance indicators and parameters",
    "choice_f": "Develops and maintains the project schedule"
  },
  {
    "id": 736,
    "question": "Which project role helps to market the need and success of the project and provides a level of control for funding?",
    "choice_a": "Project sponsor or champion",
    "choice_b": "Project manager",
    "choice_c": "Project coordinator",
    "choice_d": "Project scheduler",
    "correct_answer": "A",
    "explanation": "The \u201cchampion\u201d role of the sponsor is really important both initially and as the project commences in order to keep the energy and focus of the whole organization committed to its success.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      54,
      57,
      56,
      214
    ],
    "source": "9781119892502"
  },
  {
    "id": 737,
    "question": "In terms of project management, what is a program?",
    "choice_a": "A listing of all individuals involved in the project, including key stakeholders",
    "choice_b": "The software package used to enter and track project management aspects",
    "choice_c": "Related projects that are coordinated and managed with similar techniques",
    "choice_d": "A collection of projects and subportfolios that support the strategic goals of the business",
    "correct_answer": "C",
    "explanation": "A program is a group of related projects that are managed together with coordinated processes and techniques. Make sure that you know the difference between a project and a portfolio.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      57,
      51,
      28,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 738,
    "question": "Project manager Allison was asked by a project stakeholder why a key piece of functionality on a software project was struck from the scope list. Allision remembers a discussion that took place during a steering committee meeting. Which artifact should Allison review to find out more information on this decision?",
    "choice_a": "Project charter",
    "choice_b": "Ask the project sponsor",
    "choice_c": "Meeting minutes",
    "choice_d": "Action items",
    "correct_answer": "C",
    "explanation": "Minutes help capture when and why key decisions are made, which is helpful to refer back to later in the project. Capturing decisions and action items can be critical for project success.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      263,
      256,
      72,
      271,
      253
    ],
    "source": "9781119892502"
  },
  {
    "id": 739,
    "question": "The project champion is eager to see the new product prototype in action. Which is the best meeting format to share this information?",
    "choice_a": "Status meeting",
    "choice_b": "Demonstration",
    "choice_c": "Brainstorming",
    "choice_d": "Focus group",
    "correct_answer": "B",
    "explanation": "When presenting findings or product functionality, a demonstration allows for finished, if not final, artifacts to be shared with interested stakeholders.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      118,
      233,
      234,
      255
    ],
    "source": "9781119892502"
  },
  {
    "id": 740,
    "question": "The project team needs to gather the opinions of the product users from finance on requirements for the new ERP system. What is the appropriate type of meeting?",
    "choice_a": "Stand-up",
    "choice_b": "Focus groups",
    "choice_c": "Presentation",
    "choice_d": "Workshop",
    "correct_answer": "B",
    "explanation": "Focus groups involve interviewing a small number of people with common traits, experiences, or demographic similarities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      261,
      54,
      97,
      118,
      168
    ],
    "source": "9781119892502"
  },
  {
    "id": 741,
    "question": "Progressively elaborating deliverables into differing levels of a WBS is known as:",
    "choice_a": "Producing a backlog",
    "choice_b": "Progressive iteration",
    "choice_c": "Rolling wave planning",
    "choice_d": "Prioritizing tasks",
    "correct_answer": "C",
    "explanation": "This helps create the differing levels of decomposition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      129,
      127,
      136,
      86,
      131
    ],
    "source": "9781119892502"
  },
  {
    "id": 742,
    "question": "While sequencing activities, a project manager notices an activity that cannot begin until a different task is completed. Which of the logical relationships is the project manager most likely to use?",
    "choice_a": "Start-to-start",
    "choice_b": "Finish-to-start",
    "choice_c": "Start-to-finish",
    "choice_d": "Finish-to-finish",
    "correct_answer": "B",
    "explanation": "Finish-to-start is the type of logical relationship most frequently used within precedence diagramming methods.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      137,
      144,
      136,
      6,
      127
    ],
    "source": "9781119892502"
  },
  {
    "id": 743,
    "question": "In what stage of team development do team members begin to confront each other and vie for position and control?",
    "choice_a": "Forming",
    "choice_b": "Storming",
    "choice_c": "Norming",
    "choice_d": "Performing",
    "correct_answer": "B",
    "explanation": "This stage is a process of establishing who is the most influential, and there is jostling for position.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      172,
      173,
      245,
      179,
      175
    ],
    "source": "9781119892502",
    "choice_e": "Adjourning"
  },
  {
    "id": 744,
    "question": "Which of the following is a simple time management technique where a fixed maximum amount of time for an activity is set in advance, and then the activity is completed within that timeframe?",
    "choice_a": "Sprint planning",
    "choice_b": "Parametric estimating",
    "choice_c": "Timeboxing",
    "choice_d": "Scrum",
    "correct_answer": "C",
    "explanation": "Timeboxing can be either hard or soft. Hard timeboxing dictates that the task or activity must stop when your time is up, regardless of the status. Soft timeboxing is more flexible but gives the expected time a task should stop. This can be useful in complex tasks or activities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      254,
      25,
      115,
      90,
      141
    ],
    "source": "9781119892502"
  },
  {
    "id": 745,
    "question": "When a meeting agenda sets a fixed time on a schedule where a task must be completed within that time, what technique is being used?",
    "choice_a": "Soft timeboxing",
    "choice_b": "Action items",
    "choice_c": "Brainstorming",
    "choice_d": "Hard timeboxing",
    "correct_answer": "D",
    "explanation": "Hard timeboxing can be helpful in having a meeting move on against the desire for perfection or creative churning over possibilities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      254,
      253,
      255,
      256,
      25
    ],
    "source": "9781119892502"
  },
  {
    "id": 746,
    "question": "In an Agile approach to project management, what is a backlog?",
    "choice_a": "Delayed work that is caused by bottlenecks",
    "choice_b": "Customer prioritized functionality list that still needs to be added to the product",
    "choice_c": "Inventory not added to the project because of shipping delays",
    "choice_d": "A daily meeting focusing on three questions",
    "correct_answer": "B",
    "explanation": "This can be recorded through the use of user stories or short descriptions of the functionality.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      117,
      153,
      108,
      158,
      157
    ],
    "source": "9781119892502"
  },
  {
    "id": 747,
    "question": "When estimating activity resources, a project manager looks to variations and other options to complete the work. What is this tool or technique called?",
    "choice_a": "Parametric estimating",
    "choice_b": "Bottom-up estimating",
    "choice_c": "Alternative analysis",
    "choice_d": "Fishbone diagraming",
    "correct_answer": "C",
    "explanation": "Alternative analysis gauges the different options that might be considered to accomplish the assignment with the resources that are available.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      26,
      199,
      136,
      90
    ],
    "source": "9781119892502"
  },
  {
    "id": 748,
    "question": "Nestor is a project manager assigned to build a new branch office for a bank. The branch office will be of a similar size and design as another branch office. He has been asked to create cost and schedule estimates and to follow the bank's best practices for projects. Whose responsibility is it to help Nestor with this effort?",
    "choice_a": "Project sponsor",
    "choice_b": "Project management office",
    "choice_c": "Project team",
    "choice_d": "Project scheduler",
    "correct_answer": "B",
    "explanation": "The project management office's responsibilities include setting standards and practices for an organization, providing tools such as previous project documentation, and delivering standardized documentation and templates.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      200,
      201,
      274,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 749,
    "question": "Crashing is a project management technique involving:",
    "choice_a": "Performing two tasks in parallel that were previously scheduled to start sequentially",
    "choice_b": "Looking at cost and schedule trade-offs like adding more resources",
    "choice_c": "Moving later deliverables to earlier phases to appease stakeholders",
    "choice_d": "Removing critical path activities that are unnecessary",
    "correct_answer": "B",
    "explanation": "Crashing involves looking at cost and schedule trade-offs such as adding more resources.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      147,
      198,
      182,
      135,
      151
    ],
    "source": "9781119892502"
  },
  {
    "id": 750,
    "question": "Fast tracking a project is a technique involving:",
    "choice_a": "Performing two tasks in parallel that were previously scheduled to start sequentially",
    "choice_b": "Looking at cost and schedule trade-offs like adding more resources",
    "choice_c": "Moving later deliverables to earlier phases to appease stakeholders",
    "choice_d": "Removing critical path activities that are unnecessary",
    "correct_answer": "A",
    "explanation": "Fast tracking involves performing two tasks in parallel that were previously scheduled to start sequentially.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      144,
      136,
      90,
      25
    ],
    "source": "9781119892502"
  },
  {
    "id": 751,
    "question": "All of the following techniques can be used to estimate the duration of an activity, EXCEPT:",
    "choice_a": "Expert judgment",
    "choice_b": "Three-point estimating",
    "choice_c": "Analogous estimating",
    "choice_d": "Pareto diagramming",
    "correct_answer": "D",
    "explanation": "Pareto diagramming, or producing a Pareto chart or diagram, is a tool used to focus attention on the most critical issues. It is not used to estimate activity duration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      202,
      199,
      147,
      136,
      261
    ],
    "source": "9781119892502"
  },
  {
    "id": 752,
    "question": "When there are scarce resources to perform specific activities on a project, and the activities must be completed at certain times, which tool or technique would you use?",
    "choice_a": "Fast tracking",
    "choice_b": "Reverse resource allocation",
    "choice_c": "Resource smoothing",
    "choice_d": "Resource leveling",
    "correct_answer": "B",
    "explanation": "If you only have a structural engineer or senior programmer's time for a small window, the schedule is engineered to make use of that resource window.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      164,
      141,
      140,
      151,
      147
    ],
    "source": "9781119892502"
  },
  {
    "id": 753,
    "question": "The practice of adding a percentage of time to a work package, or adding a percentage of money to a project as an emergency, is known as:",
    "choice_a": "Risk response plan",
    "choice_b": "Contingency reserves",
    "choice_c": "Allowing risk strategy",
    "choice_d": "Delphi technique",
    "correct_answer": "B",
    "explanation": "Contingency reserves are calculated for known risks and are paired with documented mitigation response plans.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      151,
      205,
      222,
      216,
      219
    ],
    "source": "9781119892502"
  },
  {
    "id": 754,
    "question": "Which of the following are true regarding kickoff meetings?",
    "choice_a": "First time project team members are introduced to one another.",
    "choice_b": "Happens in the Initiation phase.",
    "choice_c": "Occurs when project planning is complete.",
    "choice_d": "All of the above.",
    "correct_answer": "E",
    "explanation": "The kickoff meeting typically occurs when the charter is signed. The CompTIA Project+ objectives identify it as occurring in the Initiation phase but it is common to see it at the beginning of the Execution phase as well.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      181,
      53,
      254,
      247,
      253
    ],
    "source": "9781119892502",
    "choice_e": "A and C."
  },
  {
    "id": 755,
    "question": "Project managers should spend how much of their time communicating?",
    "choice_a": "Up to 40%",
    "choice_b": "Up to 50%",
    "choice_c": "Up to 75%",
    "choice_d": "Up to 90%",
    "correct_answer": "D",
    "explanation": "Project managers can spend up to 90 percent of their time communicating with the stakeholders and the project team.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      232,
      23,
      51,
      272,
      227
    ],
    "source": "9781119892502"
  },
  {
    "id": 756,
    "question": "A project stakeholder has which of the following responsibilities?",
    "choice_a": "Documentation and administrative support, estimation of task duration, soliciting task status from resources, expertise",
    "choice_b": "Vested interest, providing input and requirements, project steering, expertise",
    "choice_c": "Documentation and administrative support, providing input and requirements, project steering, expertise",
    "choice_d": "Vested interest, providing input and requirements, cross-functional coordination, expertise",
    "correct_answer": "B",
    "explanation": "Vested interest, providing input and requirements, project steering, and expertise are examples of stakeholder responsibilities. Stakeholder expectation setting and engagement are key elements to project success.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      61,
      62,
      97,
      60
    ],
    "source": "9781119892502"
  },
  {
    "id": 757,
    "question": "Jenny works for a company undertaking a project. She will ultimately benefit from the service created and would like to share her thoughts and input on how it should be created. She is also a subject matter expert in the product area. Jenny is most likely which of the following?",
    "choice_a": "Project stakeholder",
    "choice_b": "Project champion",
    "choice_c": "Project sponsor",
    "choice_d": "Member of the PMO",
    "correct_answer": "A",
    "explanation": "In this case, Jenny is considered a project stakeholder. Remember that a team member is also a form of a stakeholder.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      55,
      54,
      26,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 758,
    "question": "What are two types of discretionary fund allocations that a project may be granted?",
    "choice_a": "Top-down and bottom-up",
    "choice_b": "Contingency and discretionary",
    "choice_c": "Parametric and analogous",
    "choice_d": "Contingency and management",
    "correct_answer": "D",
    "explanation": "Contingency reserves are set aside to deal with risk consequences, and management reserves cover future situations that can't be predicted.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      205,
      216,
      219,
      90,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 759,
    "question": "DewDrops has wrapped up project work, and they are looking to hand off the project to the customer and revisit how the project went for everyone. What is the appropriate communication method to conduct these activities?",
    "choice_a": "Kickoff meeting",
    "choice_b": "Virtual meeting",
    "choice_c": "Email",
    "choice_d": "Closure meeting",
    "correct_answer": "D",
    "explanation": "Closure meetings are where the final handoff of the project is conducted, including closing out any contracts and sometime conducting lessons learned. Note: Lessons learned meetings can be separate from closure meetings.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      335,
      253,
      255,
      254,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 760,
    "question": "Pete is a human resources manager who needs to communicate a complaint issued against Ashley. How would the content of this message dictate what type of communication is used with Ashley?",
    "choice_a": "It is of a confidential nature so meet with her face-to-face.",
    "choice_b": "Personal preferences suggest using social media.",
    "choice_c": "Voice conferencing avoids personal threat.",
    "choice_d": "Instant messaging allows time to digest information slowly.",
    "correct_answer": "A",
    "explanation": "The confidential nature of HR issues, plus the need to handle a situation delicately, would invite a face-to-face conversation. A good rule is praise publicly and criticize privately.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      227,
      271,
      230,
      22
    ],
    "source": "9781119892502"
  },
  {
    "id": 761,
    "question": "Which project role is responsible for all project artifacts like project plans, meeting minutes, and project delivery?",
    "choice_a": "Project coordinator",
    "choice_b": "Scheduler",
    "choice_c": "Project team",
    "choice_d": "Project manager",
    "correct_answer": "D",
    "explanation": "The project manager is responsible for all project artifacts produced during the course of doing project work.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      6,
      56,
      25,
      274,
      23
    ],
    "source": "9781119892502"
  },
  {
    "id": 762,
    "question": "What are project requirements?",
    "choice_a": "A measure of the distance traveled on a project",
    "choice_b": "Characteristics of deliverables that must be met",
    "choice_c": "Checkpoints on a project to determine Go/No-Go",
    "choice_d": "Major events in a project used to measure progress",
    "correct_answer": "B",
    "explanation": "Characteristics of deliverables that must be met are known as requirements. Distance traveled on a project is good information for expense tracking and reporting. Checkpoints are gate checks on a project. Major events to track progress are milestones.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      127,
      274,
      51,
      62
    ],
    "source": "9781119892502"
  },
  {
    "id": 763,
    "question": "When using a waterfall methodology, what are critical elements that need to be included in the project schedule?",
    "choice_a": "Define activities, sequence activities, estimate resources, estimate duration",
    "choice_b": "Define activities, budget activities, estimate resources, estimate completion",
    "choice_c": "Budget activities, estimate resources, determine milestones, estimate completion",
    "choice_d": "Develop schedule, determine completion date, check stakeholder assumptions, conduct feasibility assessment",
    "correct_answer": "A",
    "explanation": "Define activities, sequence activities, estimate resources, and estimate duration are all key activities that must occur in order to develop the project schedule.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      127,
      144,
      199,
      201,
      147
    ],
    "source": "9781119892502"
  },
  {
    "id": 764,
    "question": "Nora is a project manager implementing an enterprise software package and she has been assigned an onshore and an offshore team. What are factors that will influence communication methods on the project? (Choose three.)",
    "choice_a": "Time zones",
    "choice_b": "Cultural differences",
    "choice_c": "Level of report detail",
    "choice_d": "Criticality factors",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Of the provided list, time zones, cultural differences, and language barriers would be factors that influence the project the most. Level of report detail, criticality factors, and technological factors would not be unique to an international project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      242,
      271,
      246,
      50
    ],
    "source": "9781119892502",
    "choice_e": "Language barriers",
    "choice_f": "Technological factors"
  },
  {
    "id": 765,
    "question": "Murthy is a project manager working on an international software project. What is a factor influencing the communication methods on the project?",
    "choice_a": "Language barriers",
    "choice_b": "Fax",
    "choice_c": "Risk identification",
    "choice_d": "Scope creep",
    "correct_answer": "A",
    "explanation": "Language barriers can present huge obstacles in communication, sometimes even when the same language is being spoken in different dialects.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      242,
      244,
      243,
      271,
      246
    ],
    "source": "9781119892502"
  },
  {
    "id": 766,
    "question": "Which of the following is the sprint planning meeting used to do?",
    "choice_a": "Get a head start on the work needed for the project.",
    "choice_b": "Prepare the project charter and kickoff meeting.",
    "choice_c": "Set a realistic backlog of items completed during this iteration.",
    "choice_d": "Set the communication and quality plans for the project.",
    "correct_answer": "C",
    "explanation": "The sprint planning meeting establishes what can realistically be accomplished during the sprint.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      119,
      120,
      117,
      256
    ],
    "source": "9781119892502"
  },
  {
    "id": 767,
    "question": "Gus is an oil field team member assigned to a project in a remote area. The trailer he works out of has a telephone line, but internet connectivity and cell phone coverage are spotty. What would be the best method to send Gus's instructions for the next day?",
    "choice_a": "Email",
    "choice_b": "Impromptu meeting",
    "choice_c": "Instant messaging",
    "choice_d": "Fax",
    "correct_answer": "D",
    "explanation": "The more involved nature of instructions would allow written, detail communication to reach the trailer. Other electronic forms of communication would not be reliable in this situation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      271,
      269,
      227
    ],
    "source": "9781119892502"
  },
  {
    "id": 768,
    "question": "Phil and Fernando are technicians working on a project out in the field. Power was supposed to be turned off at 5 p.m. so work can begin, but there is going to be a delay. What is the best way to communicate this change?",
    "choice_a": "Email",
    "choice_b": "Phone call",
    "choice_c": "Text message",
    "choice_d": "Scheduled meeting",
    "correct_answer": "B",
    "explanation": "There is a safety aspect to this change where Phil or Fernando could come to bodily harm. Therefore, getting them on the phone and ensuring they know the delay is happening is the superior method of communication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      271,
      232,
      230,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 769,
    "question": "Mandy is a project manager for a team located at three locations around the globe. She just received an update from the customer of an urgent nature. What type of communication method should Mandy use to get this information out to the team?",
    "choice_a": "Email",
    "choice_b": "Impromptu meeting",
    "choice_c": "Virtual meeting",
    "choice_d": "Scheduled meeting",
    "correct_answer": "A",
    "explanation": "Due to the geographic separation of the project team, the most efficient way to get the communication to the entire project team would be email. Attempting to schedule a virtual meeting would be troublesome due to the different time zones of the project team.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      241,
      233,
      234,
      229,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 770,
    "question": "Which of the following factors present challenges for a global project team located on different continents? (Choose three.)",
    "choice_a": "Language barriers",
    "choice_b": "Level of report detail",
    "choice_c": "Technological factors",
    "choice_d": "Time zones",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "When dealing with any team on different continents, or even on opposite sides of the same continent, time zones will impact communication. The project team also needs to account for language barriers and cultural differences when planning communication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      242,
      243,
      233,
      181
    ],
    "source": "9781119892502",
    "choice_e": "Cultural differences",
    "choice_f": "Criticality factors"
  },
  {
    "id": 771,
    "question": "When considering the basic communication model, what are the basic elements that are needed? (Choose three.)",
    "choice_a": "Transmission",
    "choice_b": "Receiver",
    "choice_c": "Inbox",
    "choice_d": "Sender",
    "correct_answer": [
      "B",
      "D",
      "G"
    ],
    "explanation": "The basic communication model is sender-message-receiver.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      227,
      230,
      229,
      234,
      246
    ],
    "source": "9781119892502",
    "choice_e": "Nonverbal communication",
    "choice_f": "Decoder",
    "choice_g": "Message"
  },
  {
    "id": 772,
    "question": "All of the following are common types of project changes EXCEPT:",
    "choice_a": "Scope changes",
    "choice_b": "Requirement changes",
    "choice_c": "Organizational changes",
    "choice_d": "Timeline changes",
    "correct_answer": "C",
    "explanation": "Organizational changes would come from the functional side of the organization, not the project side.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      288,
      285,
      279,
      289,
      315
    ],
    "source": "9781119892502"
  },
  {
    "id": 773,
    "question": "Once a change request is submitted, where should it be recorded and assigned an identification number for tracking purposes?",
    "choice_a": "Change request log",
    "choice_b": "Risk register",
    "choice_c": "Business process repository",
    "choice_d": "Issue log",
    "correct_answer": "A",
    "explanation": "A change request log can be a simple spreadsheet that has the ID number, date, name, and description of the change.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      280,
      86,
      87,
      282,
      256
    ],
    "source": "9781119892502"
  },
  {
    "id": 774,
    "question": "Which document will ensure the capture of all needed change request information so that it can receive proper consideration?",
    "choice_a": "SIPOC-R",
    "choice_b": "Project charter",
    "choice_c": "Template",
    "choice_d": "Meeting minutes",
    "correct_answer": "C",
    "explanation": "A template allows for a standard submittal in the change control process that includes all the information needed on the purpose and impact of the change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      86,
      87,
      279,
      282
    ],
    "source": "9781119892502"
  },
  {
    "id": 775,
    "question": "In what type of organizational structure would resources report solely to the project manager?",
    "choice_a": "Weak-matrix",
    "choice_b": "Projectized",
    "choice_c": "Strong-matrix",
    "choice_d": "Functional",
    "correct_answer": "B",
    "explanation": "In a projectized organizational structure, the project manager has the most authority, and resources report directly to the project manager.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      159,
      163,
      244,
      168
    ],
    "source": "9781119892502"
  },
  {
    "id": 776,
    "question": "Predecessor and successor tasks can have four possible logical relationships. Which of the following is not one of them?",
    "choice_a": "Finish-to-finish",
    "choice_b": "Start-to-deferred",
    "choice_c": "Finish-to-start",
    "choice_d": "Start-to-finish",
    "correct_answer": "B",
    "explanation": "Rather than start-to-deferred, the missing relationship is start-to-start, meaning that one task must wait for a different task to start for work to begin.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      144,
      141,
      140,
      136
    ],
    "source": "9781119892502"
  },
  {
    "id": 777,
    "question": "What aspect of project management is shared with Agile and other approaches?",
    "choice_a": "Sprint planning",
    "choice_b": "Self-organized and self-directed teams",
    "choice_c": "Iterative approach",
    "choice_d": "Adaptive to new/changing requirements",
    "correct_answer": "C",
    "explanation": "A traditional waterfall methodology can be progressively iterative, similar to the iterative approach used with the Agile methodology.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      123,
      107,
      133,
      106,
      113
    ],
    "source": "9781119892502"
  },
  {
    "id": 778,
    "question": "Before a construction company can begin building a road over a mountain pass, they must wait for the spring thaw to occur so they can get heavy machinery into the work location. This is known as what type of dependency?",
    "choice_a": "Internal",
    "choice_b": "Discretionary",
    "choice_c": "External",
    "choice_d": "Mandatory",
    "correct_answer": "C",
    "explanation": "Weather conditions are examples of dependencies that are external to the organization but that need to happen for a project or activity to proceed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      90,
      136,
      275,
      28
    ],
    "source": "9781119892502"
  },
  {
    "id": 779,
    "question": "A software development company is considering using an Agile approach to a new project. They would use all of the following EXCEPT:",
    "choice_a": "Gate checks",
    "choice_b": "Burndown charts",
    "choice_c": "Sprint planning",
    "choice_d": "Continuous requirements gathering",
    "correct_answer": "A",
    "explanation": "Gate checks would be more representative of a waterfall approach to project management whereas Agile uses a more adaptive approach to requirements and execution.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      133,
      107,
      106,
      112,
      113
    ],
    "source": "9781119892502"
  },
  {
    "id": 780,
    "question": "In terms of resource assignments, which best describes how resources are assigned in a projectized environment?",
    "choice_a": "Resources are assigned on an ad hoc basis.",
    "choice_b": "Resources are assigned from a functional area to the project.",
    "choice_c": "Resources must be outsourced.",
    "choice_d": "Resources must not be collocated.",
    "correct_answer": "A",
    "explanation": "Due to the temporary nature of projects, resources are not permanently assigned to any one project or function.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      163,
      3,
      164,
      148
    ],
    "source": "9781119892502"
  },
  {
    "id": 781,
    "question": "Benched resources are:",
    "choice_a": "Great for an organization as there is always staff to work on a project",
    "choice_b": "Bad for an organization as there is always staff to work on a project",
    "choice_c": "Costly because individuals are being paid to sit around",
    "choice_d": "Inexpensive because individuals are not being paid when they sit around",
    "correct_answer": "C",
    "explanation": "They are costly because individuals are being paid to sit around. This often happens in projectized organizations.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      161,
      163,
      164,
      204,
      205
    ],
    "source": "9781119892502"
  },
  {
    "id": 782,
    "question": "When would an adaptive method be preferable to a more rigid project management style?",
    "choice_a": "In a mature organization with defined processes",
    "choice_b": "When the scope can be easily and thoroughly defined",
    "choice_c": "Where small incremental improvements offer no value to stakeholders",
    "choice_d": "When an organization is dealing with a rapidly changing environment",
    "correct_answer": "D",
    "explanation": "The other options would not take advantage of the flexible, easily changing environment of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      133,
      112,
      60,
      51,
      24
    ],
    "source": "9781119892502"
  },
  {
    "id": 783,
    "question": "The Transportation Exchange is a new ride sharing service trying to break into the marketplace. Which of the following benefits would make sense for them to use an adaptative method of project management?",
    "choice_a": "There is no value with small incremental improvements.",
    "choice_b": "Processes are thoroughly defined.",
    "choice_c": "The environment is rapidly changing.",
    "choice_d": "Scope is easily identified and designed.",
    "correct_answer": "C",
    "explanation": "A rapidly changing environment like that found in a start-up would be the ideal candidate to use an adaptive approach.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      133,
      301,
      114,
      51,
      23
    ],
    "source": "9781119892502"
  },
  {
    "id": 784,
    "question": "The Transportation Exchange project team is assembled, and introductions are being performed. What stage of team development is this?",
    "choice_a": "Storming",
    "choice_b": "Norming",
    "choice_c": "Performing",
    "choice_d": "Forming",
    "correct_answer": "D",
    "explanation": "Early in the process is when individuals will be shy, reserved, and treat each other formally.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      245,
      181,
      242,
      296
    ],
    "source": "9781119892502"
  },
  {
    "id": 785,
    "question": "Adric was recently assigned to a project at WigitCom. He received task assignments from both the project manager and his normal supervisor. He is notified that both the project manager and the supervisor will contribute to his performance review. What type of organizational structure is WigitCom using?",
    "choice_a": "Projectized",
    "choice_b": "Strong-matrix",
    "choice_c": "Balanced-matrix",
    "choice_d": "Weak-matrix",
    "correct_answer": "C",
    "explanation": "Authority and power are shared between the functional manager and the project manager.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      160,
      159,
      161,
      163,
      244
    ],
    "source": "9781119892502"
  },
  {
    "id": 786,
    "question": "WigitCom has a mobile geolocation application that was released last year. They are now working on the latest quarterly release of the application, which has minor updates and bug fixes. Which of the following statements is true regarding the geolocation application effort? (Choose all that apply.)",
    "choice_a": "This is a project because there are minor changes to the application.",
    "choice_b": "This is not a project because the regular releases are a continuing effort.",
    "choice_c": "This is a project because this effort is temporary in nature.",
    "choice_d": "This is not a project because the product being produced is not unique.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "This is an example of ongoing operations that are not temporary in nature and that do not have an end date. Additionally, the work effort does not produce a unique product.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      3,
      6,
      13,
      288
    ],
    "source": "9781119892502"
  },
  {
    "id": 787,
    "question": "An iterative, incremental approach to managing the activities on a project in a highly flexible manner is referred to as:",
    "choice_a": "Waterfall methodology",
    "choice_b": "Matrixed management",
    "choice_c": "Projectized",
    "choice_d": "Agile methodology",
    "correct_answer": "D",
    "explanation": "With values born out of Lean principles, this is an iterative, incremental approach to managing the activities on a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      111,
      123,
      133,
      115
    ],
    "source": "9781119892502"
  },
  {
    "id": 788,
    "question": "A project has a team member who is absent from meetings, is not meeting deadlines, and is affecting the morale of other individuals on a team. The appropriate action for the project manager would be which of the following?",
    "choice_a": "Bring the team member in for a counseling session.",
    "choice_b": "Leave the employee alone and distribute work to other team members.",
    "choice_c": "Remove the team member from the project and seek a replacement.",
    "choice_d": "Relocate the team member to a different facility.",
    "correct_answer": "C",
    "explanation": "There are times where the best course of action for the entire project team is to move on without the disgruntled team member.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      179,
      174,
      173,
      168,
      242
    ],
    "source": "9781119892502"
  },
  {
    "id": 789,
    "question": "What are the defining characteristics of a project? (Choose two.)",
    "choice_a": "An organized effort to fulfill a purpose",
    "choice_b": "Blueprints needed to construct a building",
    "choice_c": "Routine activities to an organization",
    "choice_d": "Has a specific end date",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "An organized effort to fulfill a purpose and has a specific end date are the most correct answers.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      3,
      88,
      86,
      51,
      97
    ],
    "source": "9781119892502",
    "choice_e": "Reworking an existing project"
  },
  {
    "id": 790,
    "question": "Ashley is a program manager for the construction of several transit projects. She asks the bridge project manager for updated estimates on the bridge's construction. Who has the responsibility for the estimating task duration and costs?",
    "choice_a": "Project manager",
    "choice_b": "PMO",
    "choice_c": "Stakeholders",
    "choice_d": "Project team",
    "correct_answer": "D",
    "explanation": "The project team contributes their expertise to the project and gives their estimates for task duration, cost estimates, and dependencies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      201,
      140,
      142,
      199
    ],
    "source": "9781119892502"
  },
  {
    "id": 791,
    "question": "Not including time off, holidays, or nonproject work, the total time involved for an individual to complete a task is:",
    "choice_a": "Analogous estimating",
    "choice_b": "SWAG",
    "choice_c": "Work effort estimate",
    "choice_d": "SPI",
    "correct_answer": "C",
    "explanation": "Also known as a person-hour estimate, this is used in the creation of cost estimates.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      201,
      141,
      140,
      136,
      200
    ],
    "source": "9781119892502"
  },
  {
    "id": 792,
    "question": "In a situation where the end product is uncertain and/or the conditions for developing a product or service are in flux, what would be the best project management approach?",
    "choice_a": "Traditional, or waterfall",
    "choice_b": "Projectized environment",
    "choice_c": "Agile approach",
    "choice_d": "Functional environment",
    "correct_answer": "C",
    "explanation": "The iterative nature of an Agile approach, which emphasizes constant feedback and interactions, would be the best approach in this situation.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      107,
      133,
      158,
      118,
      153
    ],
    "source": "9781119892502"
  },
  {
    "id": 793,
    "question": "Tiffany is the only digital marketer assigned to the project, but only 60 percent of her time is available to the project. There is enough work for a person assigned 100 percent of the time to the project, so Tiffany is struggling to meet her deadlines. This is an example of which of the following?",
    "choice_a": "Low-quality resources",
    "choice_b": "Interdependencies",
    "choice_c": "Dedicated resources",
    "choice_d": "Resource overallocation",
    "correct_answer": "D",
    "explanation": "Tiffany is overallocated for the project assignments because there is more work to do than time to work on it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      141,
      199,
      55,
      131,
      90
    ],
    "source": "9781119892502"
  },
  {
    "id": 794,
    "question": "Amy has been assigned to a project and reports to Kim, the project manager. John, Amy's functional manager, also requires Amy to report to him. What type of resource is Amy?",
    "choice_a": "Dedicated",
    "choice_b": "Physical",
    "choice_c": "Digital",
    "choice_d": "Shared",
    "correct_answer": "D",
    "explanation": "Reporting to both the project manager and the functional manager means that Amy is a shared resource.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      160,
      161,
      55,
      53
    ],
    "source": "9781119892502"
  },
  {
    "id": 795,
    "question": "Obtaining a sign-off on the design of a product would be an example of which type of dependency?",
    "choice_a": "Discretionary",
    "choice_b": "Mandatory",
    "choice_c": "External",
    "choice_d": "Financial",
    "correct_answer": "A",
    "explanation": "A discretionary dependency is defined by the project management team, and they are normally process-or procedure-driven.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      86,
      88,
      274,
      315
    ],
    "source": "9781119892502"
  },
  {
    "id": 796,
    "question": "A project manager is looking to boost the morale of the team through a meeting that includes both social and business aspects. The project manager is engaged in what type of activity?",
    "choice_a": "Trust building",
    "choice_b": "Forming",
    "choice_c": "Team building",
    "choice_d": "Management skills",
    "correct_answer": "C",
    "explanation": "Effective team building can help create efficient and effective groups focused on getting the work done, oftentimes enjoying the work immensely.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      245,
      175,
      23,
      335
    ],
    "source": "9781119892502"
  },
  {
    "id": 797,
    "question": "A visual representation of how quickly requirements are being completed with each iteration is called:",
    "choice_a": "Fishbone diagram",
    "choice_b": "Burndown chart",
    "choice_c": "Gantt chart",
    "choice_d": "Pareto diagram",
    "correct_answer": "B",
    "explanation": "Commonly a bar chart, this depicts the burndown chart that maps the progress made with each iteration as the project approaches completion.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      117,
      119,
      123,
      274
    ],
    "source": "9781119892502"
  },
  {
    "id": 798,
    "question": "WigitCom is faced with changes to scope and personnel on a project. What is the appropriate method to share this information with stakeholders?",
    "choice_a": "Social media and text messages.",
    "choice_b": "Memo and email.",
    "choice_c": "Hold a meeting with the project team.",
    "choice_d": "Let the communication plan be the guide.",
    "correct_answer": "D",
    "explanation": "The communication guide sets who needs to be informed of what types of project changes and will direct the method that communication should be delivered.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      271,
      247,
      248,
      272,
      246
    ],
    "source": "9781119892502"
  },
  {
    "id": 799,
    "question": "At the completion of a project sprint, the project team meets to examine what went well, what didn't go well, and what improvements could be made. This is an example of which of the following?",
    "choice_a": "Governance gates",
    "choice_b": "Product backlog",
    "choice_c": "Daily Scrum",
    "choice_d": "Scrum retrospective",
    "correct_answer": "D",
    "explanation": "This is a form of a lessons-learned meeting used in the Agile methodology to help improve future sprints.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      253,
      112,
      153,
      230,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 800,
    "question": "WigitCom has a group of projects all related to security widgets. They are wanting to add a new product for security cameras and sell them to customers. The effort must be completed within the next three months to beat the competition to market. There is a group of resources who work on security efforts. Which of the following are true about this effort? (Choose three.)",
    "choice_a": "This effort is not a project because security is already done.",
    "choice_b": "This effort is a project because the product being developed is unique.",
    "choice_c": "This effort is a project and will be a part of a program.",
    "choice_d": "There is no reason to do this effort because they already do security.",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "This meets the requirements for a project because WigitCom is creating a new product or service, and the effort is temporary in nature. It would also be a part of a program, or related projects, that share resources. In this case, the security team's resources would be shared with this project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      162,
      163,
      161,
      51
    ],
    "source": "9781119892502",
    "choice_e": "This meets the requirements for a project because it creates a unique product and is temporary in nature."
  },
  {
    "id": 801,
    "question": "With an Agile methodology, all of the following are true with an adaptive life cycle, EXCEPT:",
    "choice_a": "Requires a high degree of stakeholder involvement.",
    "choice_b": "All requirements must be gathered up front.",
    "choice_c": "Rapid iterations.",
    "choice_d": "Fixed time and resources.",
    "correct_answer": "B",
    "explanation": "With an Agile approach, the result is that requirements can be adjusted as results are developed during the iterations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      133,
      107,
      300,
      117,
      153
    ],
    "source": "9781119892502"
  },
  {
    "id": 802,
    "question": "The development of architectural design took twice the amount of time as was projected. What type of project change would this represent?",
    "choice_a": "Scoping change",
    "choice_b": "Timeline change",
    "choice_c": "Quality change",
    "choice_d": "Funding change",
    "correct_answer": "B",
    "explanation": "Work slippages can impact the timeline, especially when that work is along the critical path.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      144,
      285,
      288,
      274,
      147
    ],
    "source": "9781119892502"
  },
  {
    "id": 803,
    "question": "After a productive week, a project team in the field has lots of detailed updates to share with the project manager back at headquarters. The work lead spends an hour writing up all the accomplishments, problems, and next steps for the field team. What factors influence this communication?",
    "choice_a": "Tailor method based on content of message",
    "choice_b": "Intraorganizational differences",
    "choice_c": "Personal preferences",
    "choice_d": "Criticality factors",
    "correct_answer": "A",
    "explanation": "Highly detailed information that requires time to digest is best suited in writing. Hence, the work lead tailors the message delivery based on the content of the message itself.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      246,
      229,
      227,
      237,
      272
    ],
    "source": "9781119892502"
  },
  {
    "id": 804,
    "question": "After establishing the product backlog, what tool would be used to determine the project's velocity?",
    "choice_a": "Fishbone diagram",
    "choice_b": "Burndown chart",
    "choice_c": "Gantt chart",
    "choice_d": "Pareto diagram",
    "correct_answer": "B",
    "explanation": "The burndown chart is a visual representation and measurement tool showing the completed work against a time interval to forecast project completion.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      108,
      211,
      209,
      210,
      153
    ],
    "source": "9781119892502"
  },
  {
    "id": 805,
    "question": "After a subject matter expert (SME) evaluates the impacts of a change, they should then analyze the following specific elements of the change EXCEPT:",
    "choice_a": "Additional equipment needs",
    "choice_b": "Costs",
    "choice_c": "Approve or reject the change",
    "choice_d": "Resource hours needed",
    "correct_answer": "C",
    "explanation": "The CCB, not the SME, would be the role whose responsibility is to approve or reject the change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      285,
      53,
      55,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 806,
    "question": "After a change request has been recorded in the change request log, what is the next step that should be performed?",
    "choice_a": "Submit to CCB to be accepted or rejected.",
    "choice_b": "Defer until there is a break in the project schedule.",
    "choice_c": "Implement the change.",
    "choice_d": "Analyze the impact of the change.",
    "correct_answer": "D",
    "explanation": "A subject matter expert, with input from the project manager, should evaluate the impact of the change to determine if the change should be attempted, the impact to the triple constraints, the benefits, and so forth.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      281,
      55,
      279,
      282,
      87
    ],
    "source": "9781119892502"
  },
  {
    "id": 807,
    "question": "In what stage of team development do things begin to calm down because the team members become more comfortable with one another?",
    "choice_a": "Forming",
    "choice_b": "Storming",
    "choice_c": "Norming",
    "choice_d": "Performing",
    "correct_answer": "C",
    "explanation": "After the team has formed and stormed, this is where familiarity with one another helps to settle things down and individuals begin to deal with project problems instead of people problems.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      172,
      173,
      179,
      174,
      296
    ],
    "source": "9781119892502",
    "choice_e": "Adjourning"
  },
  {
    "id": 808,
    "question": "A change control template should include all of the following EXCEPT:",
    "choice_a": "The change that is requested",
    "choice_b": "The reason for the change",
    "choice_c": "The executive sponsor of the change",
    "choice_d": "What will happen if the change is not made",
    "correct_answer": "C",
    "explanation": "Anyone working on or associated with the project can submit a change, which is then reviewed by a change control board or other process. As such, an executive sponsor is not needed for a change request.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      282,
      279,
      281,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 809,
    "question": "What is the appropriate method for submitting a change request?",
    "choice_a": "In writing",
    "choice_b": "Verbally",
    "choice_c": "Via videoconference",
    "choice_d": "Executive session of the change control board",
    "correct_answer": "A",
    "explanation": "Change requests should always be captured in writing to document the request and the response to the change, and to keep a paper trail to show why the project's timeline, budget, or scope might have changed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      86,
      87,
      281,
      279
    ],
    "source": "9781119892502"
  },
  {
    "id": 810,
    "question": "As a project manager, a dedicated resource would be the ideal situation because:",
    "choice_a": "The team member will continue to share time with their functional work.",
    "choice_b": "The project manager has full authority and controls time and tasks.",
    "choice_c": "The dedicated resource won't have to be paid overtime.",
    "choice_d": "Low-quality resources aren't assigned to a project.",
    "correct_answer": "B",
    "explanation": "The project manager has full authority and controls time and tasks. As a project manager, you need to be wary of having low-quality resources assigned to a project, because sometimes functional managers will try to give you their lowest-caliber individuals. Project managers need to be given full authority to ensure the right skill sets are allocated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      163,
      160,
      159,
      26
    ],
    "source": "9781119892502"
  },
  {
    "id": 811,
    "question": "When a dependency is directly related to the type of work on which it is being performed, it is what type of dependency?",
    "choice_a": "Discretionary",
    "choice_b": "Mandatory",
    "choice_c": "External",
    "choice_d": "Financial",
    "correct_answer": "B",
    "explanation": "An example of a mandatory dependency might be pouring the concrete foundation and letting it cure prior to framing a building.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      86,
      136,
      129,
      315
    ],
    "source": "9781119892502"
  },
  {
    "id": 812,
    "question": "Who can submit a change request?",
    "choice_a": "Project manager",
    "choice_b": "Almost anyone working on or associated with the project",
    "choice_c": "Project sponsor",
    "choice_d": "Change control board",
    "correct_answer": "B",
    "explanation": "Key stakeholders, project staff, sponsors, or governance/CCB members could all be the ones who submit a change request for consideration.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      282,
      52,
      272,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 813,
    "question": "After a project change is identified, evaluated, and approved, what is the next step in the change control process?",
    "choice_a": "Update documents.",
    "choice_b": "Validate the change; do a quality check.",
    "choice_c": "Obtain approval.",
    "choice_d": "Implement change.",
    "correct_answer": "D",
    "explanation": "After approval, the next step would be to implement the change. At that point conducting a quality check and updating documentation can occur.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      279,
      282,
      281,
      280,
      306
    ],
    "source": "9781119892502"
  },
  {
    "id": 814,
    "question": "Avinash is a senior database administrator assigned to a project. After two months, he hands off the work to Alyson, who is a journey-level database administrator. This represents what type of common project change?",
    "choice_a": "Timeline change",
    "choice_b": "Requirements change",
    "choice_c": "Quality change",
    "choice_d": "Resource change",
    "correct_answer": "D",
    "explanation": "The personnel on the project have switched so this is a resource change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      315,
      86,
      148,
      199,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 815,
    "question": "During a merger, the new company has decided to expand their headquarters building, which was a project currently in construction. They have allocated an additional $300,000 to the project to make this happen. Which common project changes does this represent? (Choose two.)",
    "choice_a": "Requirements change",
    "choice_b": "Scoping change",
    "choice_c": "Timeline change",
    "choice_d": "Funding change",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The scope and funding were the common elements that were changed in this example.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      248,
      288,
      86,
      90,
      95
    ],
    "source": "9781119892502"
  },
  {
    "id": 816,
    "question": "Wigitcom is faced with changes to scope and personnel on a project. What is the appropriate method to share this information with the stakeholders?",
    "choice_a": "Via social media and text messages",
    "choice_b": "Using memos and email",
    "choice_c": "Holding a meeting with the project team",
    "choice_d": "Following the communication plan",
    "correct_answer": "D",
    "explanation": "The communication plan sets out who needs to be informed of what types of project changes, and it will direct which method of communication should be used.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      271,
      248,
      272,
      246,
      269
    ],
    "source": "9781119892502"
  },
  {
    "id": 817,
    "question": "Marion is a project manager working on implementing a new asset management system for an agency. She has encountered problems when trying to get participation from other departments, and it is creating problems. Whose responsibility would it be to help clear the obstacle?",
    "choice_a": "Project coordinator",
    "choice_b": "PMO",
    "choice_c": "Stakeholders",
    "choice_d": "Project sponsor",
    "correct_answer": "D",
    "explanation": "Project sponsors should use their influence to help remove obstacles like nonparticipation on the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      61,
      23,
      54,
      24
    ],
    "source": "9781119892502"
  },
  {
    "id": 818,
    "question": "Wigit Construction's customer has changed their mind on the color of the exterior and has decided that the bathrooms in a building all need to be accessible to those with disabilities. This is an example of what type of project change?",
    "choice_a": "Resource change",
    "choice_b": "Requirements change",
    "choice_c": "Funding change",
    "choice_d": "Scope change",
    "correct_answer": "B",
    "explanation": "The requirements to be met for the project have changed but have not fundamentally added to the scope of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      97,
      60,
      88,
      90
    ],
    "source": "9781119892502"
  },
  {
    "id": 819,
    "question": "WigitCom's customer has asked for a reporting engine to be added to their software, which was not originally part of the scope. Which common project changes does this represent? (Choose two.)",
    "choice_a": "Scoping change",
    "choice_b": "Funding change",
    "choice_c": "Quality change",
    "choice_d": "Timeline change",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Adding more work to the project that is not part of the baseline is a scoping change. The added time would be a timeline change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      88,
      274,
      315,
      90
    ],
    "source": "9781119892502"
  },
  {
    "id": 820,
    "question": "A project has fallen behind schedule, and the project manager has decided to run the next several activities in parallel instead of sequentially to help make up time. This is an example of:",
    "choice_a": "Crashing",
    "choice_b": "Risk avoidance",
    "choice_c": "Fast tracking",
    "choice_d": "Critical path method",
    "correct_answer": "C",
    "explanation": "Fast tracking is a schedule compression technique where activities or phases decided to be done in sequence are instead done concurrently.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      56,
      151,
      248,
      315
    ],
    "source": "9781119892502"
  },
  {
    "id": 821,
    "question": "Wigit Construction is organized by projects where the project managers have ultimate authority over resources like personnel and equipment. Which type of organization is Wigit Construction?",
    "choice_a": "Projectized",
    "choice_b": "Matrix",
    "choice_c": "Functional",
    "choice_d": "Agile",
    "correct_answer": "A",
    "explanation": "Organizations where the project managers have authority of personnel and other resources is a projectized organizational structure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      159,
      160,
      163,
      162
    ],
    "source": "9781119892502"
  },
  {
    "id": 822,
    "question": "What is rolling wave planning?",
    "choice_a": "Planning for areas of intense activity to allocate team members according to the resource plan",
    "choice_b": "The process of progressively elaborating deliverables or project phases into differing levels of the WBS",
    "choice_c": "A design technique used to ensure the structural integrity for earthquake-proof buildings",
    "choice_d": "A quick-start technique of where to begin a project with little planning or sign-off to generate momentum",
    "correct_answer": "B",
    "explanation": "This helps depict the differing levels of decomposition depending on the expected date of work.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      129,
      127,
      136,
      131,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 823,
    "question": "Judy is a program manager and is monitoring the work done on several projects. On the telecom project, she needs more information on when certain activities and milestones will occur. Who on the telecom project should Judy reach out to for this information?",
    "choice_a": "Project scheduler",
    "choice_b": "Project coordinator",
    "choice_c": "PMO",
    "choice_d": "Project manager",
    "correct_answer": "A",
    "explanation": "The project scheduler is responsible for communicating the timeline and any changes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      244,
      227,
      246,
      232
    ],
    "source": "9781119892502"
  },
  {
    "id": 824,
    "question": "Madeline serves on a project, is a liaison between senior management and the project team, maintains team management and quality control, and has good knowledge of Agile, Scrum and or Kanban. What is Madeline's role on the project?",
    "choice_a": "Business analyst",
    "choice_b": "Program manager",
    "choice_c": "Scrum master",
    "choice_d": "Developers/engineers",
    "correct_answer": "C",
    "explanation": "A Scrum master is responsible for the direction of the work and the team and helps ensure quality and communication throughout a project. This position needs skills in Agile and Scrum and should have good experience in both before becoming a Scrum master.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      119,
      108,
      113,
      230,
      168
    ],
    "source": "9781119892502"
  },
  {
    "id": 825,
    "question": "A project is underway, and the team has missed several deliverable dates. The steering committee would like the project to stay on track, and the project manager indicates that the team will need to work overtime to make the deadline. The increased cost is restricted by which type of constraint?",
    "choice_a": "Environment",
    "choice_b": "Budget",
    "choice_c": "Scope",
    "choice_d": "Scheduling",
    "correct_answer": "B",
    "explanation": "Budget is the cost constraint, and the team will not be able to work unlimited hours on the project without it affecting budget, scope, or quality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      214,
      210,
      56,
      263
    ],
    "source": "9781119892502"
  },
  {
    "id": 826,
    "question": "Which project role supervises projects and teams with a focus on the successful launch of a product?",
    "choice_a": "Product manager",
    "choice_b": "Project manager",
    "choice_c": "Senior management",
    "choice_d": "Product owner",
    "correct_answer": "A",
    "explanation": "Product managers are advocates for customers who ensure products add value to the lives of consumers.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      108,
      117,
      119,
      6,
      57
    ],
    "source": "9781119892502"
  },
  {
    "id": 827,
    "question": "The scope baseline allows project managers to perform all of the following activities, EXCEPT:",
    "choice_a": "Set the approach to conflict resolution.",
    "choice_b": "Document schedules.",
    "choice_c": "Assign resources.",
    "choice_d": "Monitor and control project work.",
    "correct_answer": "A",
    "explanation": "This is not an element of the scope baseline but a management skill used to help get teams unstuck.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      274,
      87,
      56,
      131
    ],
    "source": "9781119892502"
  },
  {
    "id": 828,
    "question": "All of the following are characteristics of an Agile project management approach, EXCEPT:",
    "choice_a": "Strict adherence to a change control process.",
    "choice_b": "Uses a flexible approach to requirements.",
    "choice_c": "Team members work in short bursts, or sprints.",
    "choice_d": "Each release is tested against the customers' needs.",
    "correct_answer": "A",
    "explanation": "This is indicative of a more traditional waterfall approach where the scope is controlled with a more rigid change process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      106,
      133,
      87,
      112
    ],
    "source": "9781119892502"
  },
  {
    "id": 829,
    "question": "Which of the following is not a principle of extreme programming?",
    "choice_a": "Rapid feedback",
    "choice_b": "Embracing change",
    "choice_c": "Project phases do not overlap",
    "choice_d": "Assume simplicity",
    "correct_answer": "C",
    "explanation": "The waterfall model of project management moves downward through each phase and the phases of development do not overlap. Rapid feedback, embracing change, and assuming simplicity are all principles of extreme programming, which is intended to improve software quality and responsiveness to changing customer wants and needs.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      110,
      107,
      106,
      111,
      114
    ],
    "source": "9781119892502"
  },
  {
    "id": 830,
    "question": "The sprint planning meeting is used to achieve which of the following?",
    "choice_a": "Getting a head start on the work needed for the project",
    "choice_b": "Preparing the project charter and kickoff meeting",
    "choice_c": "Setting a realistic backlog of items completed during this iteration",
    "choice_d": "Establishing the communication and quality plans for the project",
    "correct_answer": "C",
    "explanation": "The sprint planning meeting sets what can realistically be accomplished during the sprint.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      157,
      119,
      120,
      117,
      135
    ],
    "source": "9781119892502"
  },
  {
    "id": 831,
    "question": "Which of the following are characteristics of an Agile project management approach? (Choose three.)",
    "choice_a": "Self-organized teams",
    "choice_b": "Sprint planning",
    "choice_c": "Upfront, comprehensive requirements gathering",
    "choice_d": "Formally organized teams",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Agile is characterized by self-organized and self-directed teams, sprint planning, and continuous requirements gathering. Projects using a waterfall technique would have characteristics of formally organized teams and saving feedback for lessons learned meetings at the end of the project.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      107,
      120,
      133,
      157,
      117
    ],
    "source": "9781119892502",
    "choice_e": "Continuous requirements gathering",
    "choice_f": "Feedback based primarily in lessons learned meetings"
  },
  {
    "id": 832,
    "question": "Which methodology or framework is the union of people, process, and technology to continually provide value to customers?",
    "choice_a": "Scaled Agile Framework (SAFe)",
    "choice_b": "Waterfall",
    "choice_c": "DevOps",
    "choice_d": "Scrum",
    "correct_answer": "C",
    "explanation": "DevOps is used to allow formerly siloed roles, including development and IT operations to coordinate and collaborate to produce better and more reliable products.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      108,
      111,
      172,
      51
    ],
    "source": "9781119892502"
  },
  {
    "id": 833,
    "question": "What are four of the responsibilities of a project sponsor? (Choose four.)",
    "choice_a": "Develops the business case and justification",
    "choice_b": "Functions as the approval authority for funding",
    "choice_c": "Sets the standards and practices a project",
    "choice_d": "Provides input and requirements",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "Option C is not correct because that is the responsibility of the project management office, and option F is the function of the project manager.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      57,
      56,
      6,
      88
    ],
    "source": "9781119892502",
    "choice_e": "Helps to control the project's direction",
    "choice_f": "Manages the risks of the project"
  },
  {
    "id": 834,
    "question": "What are the five main components of the Scaled Agile Framework (SAFe)?",
    "choice_a": "Requirements, Design, Implementation, Verification/Testing, Deployment/Maintenance",
    "choice_b": "Requirements, Sprint Planning Meeting, Discovery, Testing, Closing",
    "choice_c": "Architecture, Integration, Governance, Funding, Roles",
    "choice_d": "Discovery, Sprint Planning Meeting, Testing, Funding, Closing",
    "correct_answer": "C",
    "explanation": "The five main components are Architecture, Integration, Governance, Funding, and Roles. These components help provide a structured and methodical approach to project alignment and completion. Each of these components can be considered on three different levels: team, program, and portfolio.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      301,
      119,
      300,
      5,
      153
    ],
    "source": "9781119892502"
  },
  {
    "id": 835,
    "question": "Which type of project management certification provides a methodology to perform and complete the project?",
    "choice_a": "Project Management Professional (PMP)",
    "choice_b": "Software Development Life Cycle (SDLC)",
    "choice_c": "Extreme Programming (XP)",
    "choice_d": "PRojects IN Controlled Environments (PRINCE2)",
    "correct_answer": "D",
    "explanation": "PRojects IN Controlled Environments (PRINCE2) provides a methodology to perform and complete the project. The Project Management Professional (PMP) provides techniques, tools, and frameworks to perform and complete the project. The Software Development Life Cycle can utilize several methodologies, including Agile and Waterfall to lay out a plan for getting a software development project correct the first time. Extreme programming is also a software development methodology focusing on producing high-quality software in an environment of evolving and changing requirements. Since B and C are software development methodologies, D is the correct answer for project methodologies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      302,
      106,
      107,
      133
    ],
    "source": "9781119892502"
  },
  {
    "id": 836,
    "question": "Which methodology focuses on just-in-time delivery of functionality and managing the amount of work in progress (WIP)?",
    "choice_a": "Waterfall",
    "choice_b": "Kanban",
    "choice_c": "DevOps",
    "choice_d": "SDLC",
    "correct_answer": "B",
    "explanation": "Kanban is a lean software development methodology and organizes work using a Kanban board. A Kanban board organizes work in columns, which identify the states every work item passes through from left to right. Kanban manages the work in progress (WIP) and optimizes the flow of work items through the project.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      109,
      108,
      113,
      107,
      111
    ],
    "source": "9781119892502"
  },
  {
    "id": 837,
    "question": "Which methodology would be used to build an online load application for a finance start-up?",
    "choice_a": "Kanban",
    "choice_b": "Agile",
    "choice_c": "DevOps",
    "choice_d": "DevSecOps",
    "correct_answer": "D",
    "explanation": "DevSecOps stands for development, security, and operations. DevSecOps commits to application and infrastructure security consideration from the beginning of a product's creation. Kanban, Agile, and DevOps are good answers, but the financial nature of the start-up implies that extra security protocols are needed, making DevSecOps the best answer.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      104,
      197,
      113,
      123,
      301
    ],
    "source": "9781119892502"
  },
  {
    "id": 838,
    "question": "Which project management methodology follows a chronological process and works based on fixed dates, requirements, and outcomes?",
    "choice_a": "DevOps",
    "choice_b": "Waterfall",
    "choice_c": "Scrum",
    "choice_d": "Scaled Agile Framework",
    "correct_answer": "B",
    "explanation": "Projects utilizing the Waterfall methodology have self-contained stages like requirements, design, and implementation and generally one stage doesn't begin until the previous stage is completed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      133,
      123,
      107,
      112
    ],
    "source": "9781119892502"
  },
  {
    "id": 839,
    "question": "A project team is assigned two individuals directly out of college with no experience working in advanced electronics. The two team members cannot be assigned work without a more senior team member working alongside them. This is an example of which one of the following?",
    "choice_a": "Shared resources",
    "choice_b": "Resource shortage",
    "choice_c": "Low-quality resources",
    "choice_d": "Benched resources",
    "correct_answer": "C",
    "explanation": "Low-quality resources do not have the required experience, are not accomplished with the skill set, have poor passion for the project, or carry a bad attitude to work. Low-quality resources can sometimes be replaced, but they will always need to be managed in some form.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      169,
      174,
      162,
      140,
      55
    ],
    "source": "9781119892502"
  },
  {
    "id": 840,
    "question": "What are the five common stages in a Waterfall process?",
    "choice_a": "Requirements, Design, Implementation, Verification/Testing, Deployment/Maintenance",
    "choice_b": "Requirements, Sprint Planning Meeting, Discovery, Testing, Closing",
    "choice_c": "Architecture, Integration, Governance, Funding, Roles",
    "choice_d": "Discovery, Sprint Planning Meeting, Testing, Funding, Closing",
    "correct_answer": "A",
    "explanation": "Requirements, Design, Implementation, Verification/Testing, Deployment/Maintenance are the common stages in a Waterfall process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      133,
      107,
      123,
      112
    ],
    "source": "9781119892502"
  },
  {
    "id": 841,
    "question": "What elements are explained in a business case?",
    "choice_a": "Justification by identifying the organizational benefits",
    "choice_b": "Alternative solutions",
    "choice_c": "Alignment to the strategic plan",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "The business case can include justification, alternative solutions, and alignment to the strategic plan.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      14,
      102,
      68,
      67,
      99
    ],
    "source": "9781119892502",
    "choice_e": "A, C"
  },
  {
    "id": 842,
    "question": "What plan determines the information needs of the stakeholders, the format of information delivery, delivery frequency, and the preparer?",
    "choice_a": "Stakeholder analysis plan",
    "choice_b": "Project charter",
    "choice_c": "Human resources plan",
    "choice_d": "Communication plan",
    "correct_answer": "D",
    "explanation": "The communication plan is where all elements of the who, what, when, where, and why of communication needs are documented.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      236,
      231,
      208,
      259,
      132
    ],
    "source": "9781119892502"
  },
  {
    "id": 843,
    "question": "The high-level scope definition describes which of the following?",
    "choice_a": "High-level deliverables of the project",
    "choice_b": "Objectives of the project",
    "choice_c": "Reason for the project",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "The high-level scope definition sets the boundaries of what is included and what is specifically excluded. This includes the deliverables, objects, and purpose of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      82,
      92,
      67,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 844,
    "question": "In what project life cycle phase are the majority of the processes and project documents created?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "C",
    "explanation": "The Planning life cycle phase sets the details for how the project will be carried out and creates the majority of the project plan artifacts, including the project schedule, risk plan, communications plan, and other pertinent documents.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      9,
      12,
      84,
      85,
      132
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 845,
    "question": "Which component of the project charter describes the characteristics of the product created by the project?",
    "choice_a": "Project description",
    "choice_b": "Business case",
    "choice_c": "Deliverables",
    "choice_d": "Quality plan",
    "correct_answer": "A",
    "explanation": "The project description explains the attributes of the product, service, or result of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      70,
      69,
      64,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 846,
    "question": "In what project life cycle phase is the influence of stakeholders the least effective?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "While stakeholders start out with a lot of influence, it decreases as the project advances.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      16,
      59,
      7,
      19,
      10
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 847,
    "question": "Which conflict resolution technique produces a win-lose result for the parties?",
    "choice_a": "Forcing",
    "choice_b": "Confronting",
    "choice_c": "Avoiding",
    "choice_d": "Attacking",
    "correct_answer": "A",
    "explanation": "Forcing is where one party gets their way, and the other party's interest is not represented.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      294,
      236,
      321,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 848,
    "question": "What are the three common constraints found in projects? (Choose three.)",
    "choice_a": "Time",
    "choice_b": "Personnel",
    "choice_c": "Working space",
    "choice_d": "Budget",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "Commonly referred to as the \u201ctriple constraints,\u201d almost all projects are constrained by time, budget, and scope as they impact quality.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      70,
      126,
      203,
      82
    ],
    "source": "9781119892502",
    "choice_e": "Inventory",
    "choice_f": "Scope"
  },
  {
    "id": 849,
    "question": "A road construction project is going to require the company's road paver, a piece of equipment that lays asphalt on roadways, in the next two weeks. The road paver is in use until this Friday in a different city and will require five days to be relocated. This is an example of which type of constraint?",
    "choice_a": "Environment",
    "choice_b": "Scheduling",
    "choice_c": "Scope",
    "choice_d": "Quality",
    "correct_answer": "B",
    "explanation": "Similar to the availability of people with certain skills, equipment availability and <i>scheduling</i> can also lead to a constraint on a project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      134,
      126,
      295,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 850,
    "question": "In the determination of the project scope, which of the following constraints need to be factored into the discussion? (Choose two.)",
    "choice_a": "Project manager",
    "choice_b": "Predefined budget",
    "choice_c": "Mandated finish date",
    "choice_d": "Competitive advantage",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Two of the triple constraints are represented in the options: a predefined budget and a fixed, or mandated, finish date. These constraints will impact the options available in terms of scope, and they should be considered in terms of creating the scope statement.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      68,
      66,
      64,
      126,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 851,
    "question": "Chase is a project manager and has released all of the team members from the project, closed vendor contracts, and archived project documents. In what life cycle phase is the project?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "E",
    "explanation": "Other closing activities would include getting project sign-off, validating all deliverables, closing the contract, removing project team access. and conducting training as a part of the transition/integration plan.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      7,
      325,
      10,
      12
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 852,
    "question": "The project charter is prepared and agreed to in which project life cycle phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "B",
    "explanation": "The project charter is prepared and agreed to in the Initiation phase of a project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      66,
      67,
      7,
      81
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 853,
    "question": "After the project charter is signed, what meeting is held to introduce the project team and stakeholders as well as outline the goals for the project?",
    "choice_a": "Lessons learned meeting",
    "choice_b": "Project introductory meeting",
    "choice_c": "Kickoff meeting",
    "choice_d": "Team building lunch",
    "correct_answer": "C",
    "explanation": "The kickoff meeting is where the project team members and stakeholders are introduced.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      76,
      77,
      81,
      66,
      78
    ],
    "source": "9781119892502"
  },
  {
    "id": 854,
    "question": "Work produced in the high-level risk assessment should be documented in which of the following?",
    "choice_a": "Work breakdown structure",
    "choice_b": "Project charter",
    "choice_c": "Risk register",
    "choice_d": "Quality control plan",
    "correct_answer": "B",
    "explanation": "The high-level risk assessment is an input to the project charter. The risk management process helps determine the approach to addressing risks, and the initial assessment included in the charter gives a broad overview of the risk landscape for the project.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      68,
      66,
      64,
      67,
      9
    ],
    "source": "9781119892502"
  },
  {
    "id": 855,
    "question": "The steering committee originally mandated that cost was the most important factor to the project, keeping the project team size lean. As the project drags on, the steering committee shifts and tells the project manager that schedule is the most important factor to the project. This is an example of which type of influence on a project?",
    "choice_a": "Change request",
    "choice_b": "Constraint reprioritization",
    "choice_c": "Scope creep",
    "choice_d": "Interactions between constraints",
    "correct_answer": "B",
    "explanation": "Constraint reprioritization is a shifting of which constraint is unmovable, thereby setting how the other constraints are manipulated. The old adage \u201cYou can have it cheap, right, or fast; you get to pick two of three,\u201d illuminates the interplay between the triple constraints.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      70,
      14,
      84,
      149
    ],
    "source": "9781119892502"
  },
  {
    "id": 856,
    "question": "Resource allocation, including assigned equipment, team members, and money to support a project, occurs in which project phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "C",
    "explanation": "Planning includes identifying both what resources are needed and when they will be needed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      7,
      81,
      128,
      94,
      18
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 857,
    "question": "A project manager is having problems with one team member who is being insubordinate. The project manager approaches the team member to find out what is going on and determines that a change can be made now that the facts are known. This is an example of which of the following?",
    "choice_a": "Forcing",
    "choice_b": "Avoiding",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "C",
    "explanation": "The confronting technique may also be called problem solving and is a superior way to resolve conflict. The correct solution to a problem can reveal itself, and the facts contribute to discovering the solution.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      236,
      78,
      83,
      260,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 858,
    "question": "Developing the project team involves all the following EXCEPT:",
    "choice_a": "Developing a team that lasts longer than the project",
    "choice_b": "Creating a positive environment for team members",
    "choice_c": "Creating an effective, functioning, and coordinated group",
    "choice_d": "Increasing the team's competency levels",
    "correct_answer": "A",
    "explanation": "Developing a team that lasts longer than the project would be a nice outcome, but it is not the purpose of developing a project team.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      78,
      176,
      76,
      77
    ],
    "source": "9781119892502"
  },
  {
    "id": 859,
    "question": "The characteristics of the lower-level WBS include all of the following EXCEPT:",
    "choice_a": "WBS components are a further decomposition of project deliverables.",
    "choice_b": "WBS components should always happen concurrently with determining major deliverables.",
    "choice_c": "WBS components should be tangible and verifiable.",
    "choice_d": "WBS components should be organized in terms of project organization.",
    "correct_answer": "B",
    "explanation": "WBS components should always happen concurrently with determining major deliverables. Identification of lower-level WBS components occurs after the major deliverables have been identified.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      128,
      69,
      8,
      76,
      134
    ],
    "source": "9781119892502"
  },
  {
    "id": 860,
    "question": "A project manager meets with upset team members to listen to their concerns. After hearing their concerns, the project manager makes some of the team members' recommendations in exchange for the team members accepting other rules. This is an example of which of the following?",
    "choice_a": "Forcing",
    "choice_b": "Compromising",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "B",
    "explanation": "Compromising is when each party in a conflict gives up something to reach a solution.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      236,
      321,
      287,
      79,
      83
    ],
    "source": "9781119892502"
  },
  {
    "id": 861,
    "question": "Which of the following is the best definition of a capital expense, or CapEx?",
    "choice_a": "Money spent on running the business operations of a company",
    "choice_b": "Debt accrued on travel expenses needed to run a business",
    "choice_c": "Money spent on long-term physical or fixed assets used in a business's operations",
    "choice_d": "Debt accrued through the issuing of long-term bonds",
    "correct_answer": "C",
    "explanation": "CapEx is important to help companies grow and maintain their business by investing in new property, equipment, products, or technology.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      14,
      8,
      67,
      68,
      96
    ],
    "source": "9781119892502"
  },
  {
    "id": 862,
    "question": "Expenditures not expensed directly on a company's income statement and considered an investment are known as which of the following?",
    "choice_a": "CapEx",
    "choice_b": "OpEx",
    "choice_c": "TOR",
    "choice_d": "SOW",
    "correct_answer": "A",
    "explanation": "Capital expenses are used on spending for a benefit that will last longer than a year, and some companies might have a dollar amount that a single item might cost that would also lead to the purchase being qualified as a capital expense. As an example, a company might have a $5,000 limit on the individual cost of an item, meaning the purchase of a $6,000 server would qualify as a CapEx but a $2,000 desktop computer would not.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      203,
      70,
      206,
      14,
      99
    ],
    "source": "9781119892502"
  },
  {
    "id": 863,
    "question": "Which of the following is the best definition of an operational expense, or OpEx?",
    "choice_a": "Money spent on running the business operations of a company",
    "choice_b": "Debt accrued on travel expenses needed to run a business",
    "choice_c": "Money spent on long-term physical or fixed assets used in a business's operations",
    "choice_d": "Debt accrued through the issuing of long-term bonds",
    "correct_answer": "A",
    "explanation": "Examples of OpEx would include rent, office equipment, supplies, legal fees, travel expenses, and utilities, to name a few.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      206,
      188,
      96,
      65,
      102
    ],
    "source": "9781119892502"
  },
  {
    "id": 864,
    "question": "DewDrops has received an invoice from their business partner that asks for the monthly payment for staff time plus travel expenses. Which of the following is the best choice on how to categorize this purchase?",
    "choice_a": "CapEx",
    "choice_b": "OpEx",
    "choice_c": "TOR",
    "choice_d": "SOW",
    "correct_answer": "B",
    "explanation": "Expenses with a business partner for the time and travel expenses would likely be categorized as operational expenses. For the test, it is unlikely there will be complicated scenarios, but know that in the real world there are situations where this example could be categorized as a capital expense if the work being performed is part of the implementation of a long-term asset, like a datacenter build, enterprise resource planning implementation, or other large-scale purchase.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      188,
      203,
      10,
      14,
      8
    ],
    "source": "9781119892502"
  },
  {
    "id": 865,
    "question": "Wigit Construction is wanting to expand their headquarters campus by building a new state-of-the-art facility for its design crew. Which of the following would be the best categorization of this spending?",
    "choice_a": "TOR",
    "choice_b": "OpEx",
    "choice_c": "ROI",
    "choice_d": "CapEx",
    "correct_answer": "D",
    "explanation": "This is a capital expense for both the length of time the new building will be used and the dollar amount of the new investment. Note: A business will establish rules where a certain dollar amount threshold (as low as $100) makes a purchase a capital expense.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      102,
      206,
      96,
      19
    ],
    "source": "9781119892502"
  },
  {
    "id": 866,
    "question": "What does TOR stand for?",
    "choice_a": "Time of reflection",
    "choice_b": "Terms of reconciliation",
    "choice_c": "Terms of reference",
    "choice_d": "Time of reference",
    "correct_answer": "C",
    "explanation": "Terms of reference in a contract explain the objectives, scope of work, activities, tasks to be performed, and other information such as the structure of a project.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      66,
      64,
      67,
      68,
      122
    ],
    "source": "9781119892502"
  },
  {
    "id": 867,
    "question": "Derived from the project scope and charter, what would be included in the terms of reference? (Choose three).",
    "choice_a": "General information",
    "choice_b": "Lessons learned",
    "choice_c": "Objectives/deliverables",
    "choice_d": "Project sign-off",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Terms of reference help provide context and information need for bidders to provide comprehensive proposals when answering an RFP or other solicitation. It should contain information about your company, the goals of the project, budget (if known), timeframe, and standards to name a few areas that should be included.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      184,
      14,
      70,
      99,
      65
    ],
    "source": "9781119892502",
    "choice_e": "Standards",
    "choice_f": "Ishikawa diagrams"
  },
  {
    "id": 868,
    "question": "What is a governance gate?",
    "choice_a": "A checkpoint between project phases where approval is obtained to move forward",
    "choice_b": "A checkpoint where quality is checked against a previously established criterion",
    "choice_c": "Checkpoints at the beginning and end of the project only",
    "choice_d": "After a project governor is appointed, unplanned interruptions from this project sponsor",
    "correct_answer": "A",
    "explanation": "A governance gate is a checkpoint between project phases where approval is obtained to move forward. Usually the project reports to a steering committee to help ensure accountability on the project for time, money, and scope.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      150,
      250,
      303,
      81,
      76
    ],
    "source": "9781119892502"
  },
  {
    "id": 869,
    "question": "A seller that has passed through a first phase of onboarding through evaluation using a standard criterion to determine a seller's ability to supply a good or service is known as what?",
    "choice_a": "Bidder's conference",
    "choice_b": "Prequalified vendor",
    "choice_c": "Terms of reference",
    "choice_d": "Statement of work",
    "correct_answer": "B",
    "explanation": "The prequalified vendor list helps buyers prescreen interested parties that sell products and services. This can help create a pool of prospective sellers, which can speed up future procurement processes, establish relationships, and increase the chances a seller will be noticed and selected for future business.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      18,
      188,
      184,
      189,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 870,
    "question": "Jazzmyn just created a business to provide service desk support augmentation services. She is interested in her company having greater visibility with larger businesses and government agencies. The goal is to position her company so that they have a better chance of earning work. In her research, she should inquire to see if these companies have which of the following offerings?",
    "choice_a": "Prequalified vendor lists",
    "choice_b": "Terms of reference",
    "choice_c": "Conflict resolution parameters",
    "choice_d": "Scrum retrospective",
    "correct_answer": "A",
    "explanation": "Becoming a prequalified vendor would allow Jazzmyn's company to pass a first phase of vetting, narrowing the seller pool and thereby increasing the chances her company is selected to perform work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      18,
      184,
      189,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 871,
    "question": "The calculation of the rate of return for a given investment for a given time period is known as which of the following?",
    "choice_a": "Payback period",
    "choice_b": "Return on investment",
    "choice_c": "Time value of money",
    "choice_d": "Earned value",
    "correct_answer": "B",
    "explanation": "A return on investment (ROI) analysis can be used to determine if there will be a positive return on a project's investment.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      14,
      19,
      102,
      203,
      67
    ],
    "source": "9781119892502"
  },
  {
    "id": 872,
    "question": "WigitCom is deliberating whether to go forward with a project to build a new mobile gaming line connected to a popular science fiction franchise. The executive team is concerned about the high cost of this project. What is the best tool the executive team can use to inform the team about the viability of this project?",
    "choice_a": "Earned value",
    "choice_b": "Cost performance index",
    "choice_c": "Present value",
    "choice_d": "Return on investment",
    "correct_answer": "D",
    "explanation": "ROI can help compare a project investment to other well-understood risks available in financial terms to help determine the profitability of the proposed solution.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      102,
      70,
      203,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 873,
    "question": "What is the formula used to compute a return on investment (ROI) for a project?",
    "choice_a": "Earned value \u2013 planned value",
    "choice_b": "[(Financial value \u2013 project cost) / project cost] \u00d7 100",
    "choice_c": "Earned value / actual cost",
    "choice_d": "Earned value \u2013 project cost * 100",
    "correct_answer": "B",
    "explanation": "For the exam, you may need to know how to calculate ROI. If the value generated from this equation is less than 1, there is no profit or financial gain from the project. If the value is 0, there is no loss or gain. A value greater than 1 indicates there is a profit or gain from the project.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      14,
      203,
      65,
      8,
      102
    ],
    "source": "9781119892502"
  },
  {
    "id": 874,
    "question": "An IT company is looking to build a new campus to house development staff as the company continues to grow. The results of the ROI analysis were 35%; should the project proceed?",
    "choice_a": "No, the project will yield a negative return on investment.",
    "choice_b": "Yes, the project will yield a positive return on investment.",
    "choice_c": "No, the project will yield a positive return on investment.",
    "choice_d": "Yes, the project will yield a negative return on investment.",
    "correct_answer": "B",
    "explanation": "A positive number will indicate the project will be profitable. Remember, a number can still be positive and too low to still be considered a \u201cgo\u201d project by the organization. The goals and risk threshold of the company will help guide the interpretation of these results. A number greater than 1 in an ROI analysis will indicate the project is profitable.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      14,
      102,
      67,
      19,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 875,
    "question": "An IT company is looking to build a new campus to house development staff as the company continues to grow. The results of the ROI analysis were \u20136%; should the project proceed?",
    "choice_a": "No, the project will yield a negative return on investment.",
    "choice_b": "Yes, the project will yield a positive return on investment.",
    "choice_c": "No, the project will yield a positive return on investment.",
    "choice_d": "Yes, the project will yield a negative return on investment.",
    "correct_answer": "A",
    "explanation": "A number less than 1, in this case a negative number, will indicate the project will not be profitable. Just because a project will not be profitable does not necessarily mean it should not happen, just as a profitable project is not always assured of being done. ROI analysis is just one of many tools to help determine the viability of a project.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      14,
      102,
      19,
      67,
      8
    ],
    "source": "9781119892502"
  },
  {
    "id": 876,
    "question": "As a project manager, which plan would you establish to guide the creation of project files, how project documents are filed, where to archive project records, and when to destroy these documents?",
    "choice_a": "Project plan",
    "choice_b": "Records management plan",
    "choice_c": "Project charter",
    "choice_d": "Data capacity plan",
    "correct_answer": "B",
    "explanation": "Managing project records is an important responsibility of a project manager, who must make sure every document or file has the proper design, format, communication, and security and is archived and stored correctly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      284,
      12,
      236,
      325,
      328
    ],
    "source": "9781119892502"
  },
  {
    "id": 877,
    "question": "Which of the following are the reasons proper management of records is important? (Choose three).",
    "choice_a": "Story estimation",
    "choice_b": "Saving time and effort",
    "choice_c": "Ease of finding information",
    "choice_d": "Protect data from unauthorized access",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "A records management plan ultimately supports the efficiencies in all other project activities by making sure data is secure, easy to find, and up-to-date and versioned.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      284,
      12,
      84,
      132,
      11
    ],
    "source": "9781119892502",
    "choice_e": "Branding",
    "choice_f": "Budget reconciliation"
  },
  {
    "id": 878,
    "question": "An animation studio has decided to use the principle of least privilege with regard to letting people see artifacts on the project. The principle of least privilege only allows access to information or computer systems to those individuals who need that access to complete a task or deliverable. This is an example of which of the following?",
    "choice_a": "Access requirements",
    "choice_b": "Assess stakeholders",
    "choice_c": "Records management",
    "choice_d": "Quality assurance plan",
    "correct_answer": "A",
    "explanation": "Defining access requirements early in a project can help protect the confidentiality of documents and data as well as protect intellectual property.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      59,
      93,
      12,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 879,
    "question": "WigitCom is building a revolutionary new gaming platform. A functional manager from the administrative division assigned one of his team members to the project and is curious about the project. They ask this team member about details of the project. To conform to the project's access requirements, what should the project team member say to the manager?",
    "choice_a": "Share all the project details with the functional manager.",
    "choice_b": "Let the manager review all existing project artifacts.",
    "choice_c": "Inform the manager they are unable to share details about the project.",
    "choice_d": "Invite the manager into the secure project space and let them look around.",
    "correct_answer": "C",
    "explanation": "The access requirements for the project are a guiding reference to what information can be shared and to whom. The complexity in this scenario is that the manager is the functional boss for the team member, and the familiarity may make it tempting to share details about the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      236,
      59,
      78,
      82,
      66
    ],
    "source": "9781119892502"
  },
  {
    "id": 880,
    "question": "A team has set guidance that project communication can only take place through the company-issued collaboration platform or through company-issued devices. This is an example of which of the following?",
    "choice_a": "Identify and assess stakeholders",
    "choice_b": "A responsibility assignment matrix",
    "choice_c": "Establish accepted communication channels",
    "choice_d": "Establish communication cadence",
    "correct_answer": "C",
    "explanation": "Communication channels are likely to be established to ensure information governance, confidentiality, and information retrieval.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      236,
      231,
      259,
      287,
      324
    ],
    "source": "9781119892502"
  },
  {
    "id": 881,
    "question": "The team is now storing all the completed project documentation in a repository to be available for audits and to serve as a guide for similar future projects. Which project life cycle phase is the project in?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "E",
    "explanation": "Archiving documentation is an activity of the Closing phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      7,
      330,
      325,
      12
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 882,
    "question": "Which of the following activities are not part of the Closing phase of a project? (Choose two).",
    "choice_a": "Develop a transition/release plan",
    "choice_b": "Close contracts",
    "choice_c": "Validate deliverables",
    "choice_d": "Implement organizational change management",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Developing a transition plan occurs in the Planning phase for when the project completes and is handed over to operations. Implementing organizational change management is an activity that would occur in the Execution phase of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      9,
      10,
      294,
      7
    ],
    "source": "9781119892502",
    "choice_e": "Release resources"
  },
  {
    "id": 883,
    "question": "What does the acronym RACI stand for?",
    "choice_a": "Responsible, accountable, consulted, and informed",
    "choice_b": "Responsibility, authority, consult, and inform",
    "choice_c": "Responsible, authority, consulted, and inform",
    "choice_d": "Responsibility, accountable, consult, and informed",
    "correct_answer": "A",
    "explanation": "RACI stands for responsible, accountable, consulted, and informed, and it is a tool to help designate roles and responsibilities on a project.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      8,
      12,
      78,
      16,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 884,
    "question": "All of the following are examples of project resources EXCEPT:",
    "choice_a": "Team members",
    "choice_b": "Equipment",
    "choice_c": "WBS",
    "choice_d": "Materials",
    "correct_answer": "C",
    "explanation": "The WBS is a project artifact, not a resource in the resource management context.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      12,
      10,
      84,
      11
    ],
    "source": "9781119892502"
  },
  {
    "id": 885,
    "question": "The launch of a new flagship hotel is coming down to the wire. The customer wants to add an additional welcome area to the hotel prior to the grand opening. Which of the following impacts would be true?",
    "choice_a": "The scope of the project has changed but not the schedule, so costs will increase.",
    "choice_b": "The schedule of the project has changed but not the costs, so the scope will change.",
    "choice_c": "The costs of the project have changed but not the scope, so the schedule will change.",
    "choice_d": "This change will not have a project impact due to contingencies.",
    "correct_answer": "A",
    "explanation": "The scope of the project has changed but not the schedule, so costs will increase. This is an example of the triple constraints driving what is important in a project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      67,
      203,
      84,
      82
    ],
    "source": "9781119892502"
  },
  {
    "id": 886,
    "question": "Where would the following information be found: types of contracts the project will use, authority of the project team, and information on how multiple vendors will be managed?",
    "choice_a": "Budget",
    "choice_b": "Procurement plan",
    "choice_c": "WBS",
    "choice_d": "Detailed risks",
    "correct_answer": "B",
    "explanation": "The procurement plan document details how the procurement process will be managed.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      188,
      132,
      84,
      66,
      273
    ],
    "source": "9781119892502"
  },
  {
    "id": 887,
    "question": "Deliverables are an output of which phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "Deliverables for the project are produced in the Execution phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      10,
      7,
      12,
      69
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 888,
    "question": "When breaking down project deliverables, what is the lowest level that is recorded in a WBS?",
    "choice_a": "Daily work schedules",
    "choice_b": "High-level requirements",
    "choice_c": "Work package",
    "choice_d": "Major milestones",
    "correct_answer": "C",
    "explanation": "The lowest level recorded in the WBS is the work package.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      122,
      84,
      94,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 889,
    "question": "Which of the following are conflict resolution techniques? (Choose two.)",
    "choice_a": "Threatening",
    "choice_b": "Smoothing",
    "choice_c": "Storming",
    "choice_d": "Norming",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Smoothing and negotiating are conflict resolution techniques.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      10,
      259,
      321,
      295
    ],
    "source": "9781119892502",
    "choice_e": "Negotiating"
  },
  {
    "id": 890,
    "question": "Where would an organization document the results of their buy versus build analysis?",
    "choice_a": "WBS",
    "choice_b": "Budget",
    "choice_c": "Change management plan",
    "choice_d": "Procurement plan",
    "correct_answer": "D",
    "explanation": "The procurement plan document includes the approach to obtaining outside products and services, and the rationale for choosing to in-source or outsource the effort.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      14,
      84,
      12,
      132
    ],
    "source": "9781119892502"
  },
  {
    "id": 891,
    "question": "The following deliverables/activities all occur in the Initiation phase EXCEPT:",
    "choice_a": "Project sign-off",
    "choice_b": "Project charter",
    "choice_c": "Business case",
    "choice_d": "Records management plan",
    "correct_answer": "A",
    "explanation": "Project sign-off occurs in the Closing phase, not the Initiation phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      66,
      7,
      81,
      9
    ],
    "source": "9781119892502"
  },
  {
    "id": 892,
    "question": "Which of the following project documents are created during the Planning phase of a project? (Choose three.)",
    "choice_a": "Status reports",
    "choice_b": "Communication plan",
    "choice_c": "Transition/release plan",
    "choice_d": "Lessons learned",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The communication plan, transition/release plan, and project schedule are all created in the Planning phase.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      9,
      84,
      236,
      134,
      12
    ],
    "source": "9781119892502",
    "choice_e": "Project schedule",
    "choice_f": "Action items"
  },
  {
    "id": 893,
    "question": "What are critical elements that need to be included in the project schedule?",
    "choice_a": "Define activities, sequence activities, estimate resources, estimate duration",
    "choice_b": "Define activities, budget activities, estimate resources, estimate completion",
    "choice_c": "Budget activities, estimate resources, determine milestones, estimate completion",
    "choice_d": "Develop schedule, determine completion date, check stakeholder assumptions, conduct feasibility assessment",
    "correct_answer": "A",
    "explanation": "According to the <i>Project Management Body of Knowledge</i>, the steps taken to create the project schedule are: define activities, sequence activities, estimate resources, and estimate duration.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      143,
      149,
      84,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 894,
    "question": "The preliminary scope statement should be included in which project document?",
    "choice_a": "Communication plan",
    "choice_b": "Project schedule",
    "choice_c": "Project charter",
    "choice_d": "Lessons learned",
    "correct_answer": "C",
    "explanation": "The scope statement in the project charter sets the boundaries for the project.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      64,
      66,
      84,
      12,
      81
    ],
    "source": "9781119892502"
  },
  {
    "id": 895,
    "question": "Which of the following is the main activity of the Execution life cycle phase?",
    "choice_a": "Performance measuring and reporting",
    "choice_b": "Creating and verifying deliverables",
    "choice_c": "Key stakeholder identification",
    "choice_d": "Determining needed project resources",
    "correct_answer": "B",
    "explanation": "The bulk of the work on a project is carried out during the Execution life cycle phase, including the creation and verification of deliverables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      273,
      324,
      327,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 896,
    "question": "What does the acronym RASI stand for?",
    "choice_a": "Responsible, authority, superior, and inform",
    "choice_b": "Responsibility, accountable, support, and informed",
    "choice_c": "Responsible, accountable, superior, and inform",
    "choice_d": "Responsibility, authority, support, and inform",
    "correct_answer": "B",
    "explanation": "It stands for responsibility, accountable, support, and inform. This is an alternative form of a RACI chart, with \u201cconsulted\u201d replaced by identifying who serves in a supporting role.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      8,
      12,
      59,
      236,
      231
    ],
    "source": "9781119892502"
  },
  {
    "id": 897,
    "question": "You would expect the WBS dictionary to contain all of the following information EXCEPT:",
    "choice_a": "Explanations of team members' roles and responsibilities",
    "choice_b": "Description of the work of the component",
    "choice_c": "Quality requirements",
    "choice_d": "Required resources",
    "correct_answer": "A",
    "explanation": "The explanations of team members' roles and responsibilities would generally be found in a responsibility assignment matrix instead of the WBS dictionary.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      12,
      8,
      78,
      98
    ],
    "source": "9781119892502"
  },
  {
    "id": 898,
    "question": "Even though the project scope statement has been approved, the customer has routinely asked for more features to be added to the product, causing the due date and resources to be adjusted consistently. This is an example of which type of influence?",
    "choice_a": "Change request",
    "choice_b": "Constraint reprioritization",
    "choice_c": "Schedule constraint",
    "choice_d": "Scope creep",
    "correct_answer": "D",
    "explanation": "Scope creep is when the project definition is constantly expanding and control over being able to finish the project lessens.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      82,
      92,
      93,
      84,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 899,
    "question": "A scope management plan contains which of the following elements? (Choose three.)",
    "choice_a": "Process for creating the schedule",
    "choice_b": "Process for creating the scope statement",
    "choice_c": "Definition of how the deliverables will be validated",
    "choice_d": "Process for creating, maintaining, and approving the WBS",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The scope management plan includes the process for creating the scope statement, the definitions of how the deliverables will be verified, and the process for creating, maintaining, and approving the WBS. It also will define the process for controlling scope change requests, including the procedure for requesting changes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      128,
      93,
      85,
      94
    ],
    "source": "9781119892502",
    "choice_e": "Process for creating the budget"
  },
  {
    "id": 900,
    "question": "When evaluating the project life cycle phases, in which phase will project costs be the highest?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "Execution phase is when most of the expenditures on materials, people, and time will occur.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      7,
      273,
      9,
      85
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 901,
    "question": "What part of a project request defines the reason for the project, the deliverables at a high level, and the project objectives?",
    "choice_a": "Work breakdown structure",
    "choice_b": "High-level risks",
    "choice_c": "Business case",
    "choice_d": "Preliminary scope statement",
    "correct_answer": "D",
    "explanation": "The preliminary scope statement includes, among other things, the project objectives, criteria for project acceptance, requirements and deliverables, and milestones.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      64,
      65,
      66,
      67,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 902,
    "question": "A high-level or preliminary risk assessment includes all the following EXCEPT:",
    "choice_a": "Risk identification and rolled-up (or categorized) work-task groups",
    "choice_b": "Cost\u2013benefit analysis weighing relative risks to potential gains",
    "choice_c": "High-level responses to mitigate impact",
    "choice_d": "Risk identification of all potential project alternatives",
    "correct_answer": "D",
    "explanation": "Risk identification of all potential project alternatives would take place later in the project when analyzing and creating a risk management plan. The preliminary risk assessment is a high-level overview and an input to the project charter.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      68,
      8,
      64,
      81
    ],
    "source": "9781119892502"
  },
  {
    "id": 903,
    "question": "The project team has completed all the deliverables for the project. They have meetings scheduled to begin the handoff from the project team to the ongoing operations team. In what project life cycle phase is the project at this point?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "E",
    "explanation": "This is the Closing phase. During the transition from the project to normal operations, training of the new specifications will occur.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      7,
      325,
      10,
      8
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 904,
    "question": "Asking questions such as \u201cDoes a task have multiple dependencies?\u201d or \u201cDoes the task utilize new or unfamiliar technology?\u201d is a step in which process?",
    "choice_a": "Quality assurance",
    "choice_b": "Risk identification",
    "choice_c": "Building the project charter",
    "choice_d": "Building the project schedule",
    "correct_answer": "B",
    "explanation": "A good practice when identifying project risks is to have a set of questions to ask during the brainstorming step.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      68,
      225,
      85,
      18,
      99
    ],
    "source": "9781119892502"
  },
  {
    "id": 905,
    "question": "Which of the following are ways to organize the WBS? (Choose three.)",
    "choice_a": "Critical path",
    "choice_b": "Subprojects",
    "choice_c": "Project phases",
    "choice_d": "Prioritized by risk",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The ways to organize the WBS are by subprojects (where the project managers of the subprojects each create a WBS), by project phases, or by major deliverables.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      128,
      85,
      7,
      12,
      69
    ],
    "source": "9781119892502",
    "choice_e": "Major deliverables"
  },
  {
    "id": 906,
    "question": "A project assumption can best be described as which of the following?",
    "choice_a": "Internal or external factors affecting the project team",
    "choice_b": "Factors that restrict the project",
    "choice_c": "Factors considered to be true for planning purposes",
    "choice_d": "Factors considered to be true for control purposes",
    "correct_answer": "C",
    "explanation": "A project assumption can best be described as factors considered to be true for planning purposes. Assumptions are events, actions, or conditions that are believed to be true.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      92,
      66,
      12,
      99
    ],
    "source": "9781119892502"
  },
  {
    "id": 907,
    "question": "How does a high-level scope definition help the planning of a project?",
    "choice_a": "It creates a shared understanding of what is included and excluded from the project.",
    "choice_b": "It sets exactly what a product or service will do.",
    "choice_c": "It is so high level that it ensures that multiple changes can be accommodated by the project.",
    "choice_d": "It helps to shift the blame to the project sponsor if the project is unsuccessful.",
    "correct_answer": "A",
    "explanation": "It creates a shared understanding of what is included and excluded from the project. On the test, high-level scope definition might also be referred to as a preliminary scope statement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      64,
      92,
      82,
      93,
      69
    ],
    "source": "9781119892502"
  },
  {
    "id": 908,
    "question": "A project manager meets with team members who are upset. They discuss areas where there is agreement with each other and the situation. Work then resumes on the project. This is an example of which of the following?",
    "choice_a": "Forcing",
    "choice_b": "Avoiding",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "D",
    "explanation": "During smoothing, no real or permanent solution is achieved. This can be an example of a lose-lose result as neither side gets resolution to their issues.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      273,
      10,
      83,
      78,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 909,
    "question": "All of the following are created during the Planning phase of a project EXCEPT:",
    "choice_a": "Project schedule",
    "choice_b": "Communication plan",
    "choice_c": "Lessons learned",
    "choice_d": "Change management plan",
    "correct_answer": "C",
    "explanation": "The lessons learned session can occur during any phase depending on the project size but is typically included in the Closing phase of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      330,
      11,
      9,
      7,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 910,
    "question": "Mitch is a project manager working in the Planning phase of the project. After completing a skills matrix to understand what kind of talent the project will need, he is screening the r\u00e9sum\u00e9s of talent already employed by the company. What activity is Mitch performing at this stage of the project?",
    "choice_a": "Team building",
    "choice_b": "Team selection",
    "choice_c": "Conflict resolution",
    "choice_d": "Trust building",
    "correct_answer": "B",
    "explanation": "A project is represented by the individuals on the team, and ensuring the correct skills, level of experience, availability, and interest are all part of the team selection process.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      84,
      9,
      188,
      12,
      80
    ],
    "source": "9781119892502"
  },
  {
    "id": 911,
    "question": "Wigit Construction has been using a steamroller to repave a road. A different project finishes early with its paving machine and sends it to the first project to complete the work faster. What type of project change does this represent?",
    "choice_a": "Resource change",
    "choice_b": "Timeline change",
    "choice_c": "Requirements change",
    "choice_d": "Quality change",
    "correct_answer": "A",
    "explanation": "Remember that resources can be people, materials, or equipment.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      10,
      143,
      188,
      84,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 912,
    "question": "What is the project artifact that breaks down resources by category and type?",
    "choice_a": "Resource breakdown structure",
    "choice_b": "Organizational breakdown structure",
    "choice_c": "Equipment breakdown structure",
    "choice_d": "Work breakdown structure",
    "correct_answer": "A",
    "explanation": "Much like the organizational breakdown structure, the RBS lists the different resources by categories like labor, heavy equipment, materials, and supplies.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      12,
      132,
      84,
      70
    ],
    "source": "9781119892502"
  },
  {
    "id": 913,
    "question": "When the schedule slips on a project because the work is taking longer than planned, what type of common project change does this represent?",
    "choice_a": "Risk event",
    "choice_b": "Requirements change",
    "choice_c": "Funding change",
    "choice_d": "Timeline change",
    "correct_answer": "D",
    "explanation": "This is especially true when tasks are along the critical path, or when there is no float for that activity.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      134,
      149,
      143,
      10,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 914,
    "question": "What are major accomplishments of the project or key events known as?",
    "choice_a": "Milestones",
    "choice_b": "Deliverables",
    "choice_c": "Requirements",
    "choice_d": "Risks",
    "correct_answer": "A",
    "explanation": "Milestones can also represent the completion of major deliverables on a project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      150,
      12,
      84,
      67
    ],
    "source": "9781119892502"
  },
  {
    "id": 915,
    "question": "WigitCom has a key programmer who must leave the project due to a family emergency. The project manager has been able to find another individual who has the experience and skills to take over, and that person is added to the project. This type of communication trigger is known as which one of the following?",
    "choice_a": "Project planning",
    "choice_b": "Resource changes",
    "choice_c": "Incident response",
    "choice_d": "Stakeholder changes",
    "correct_answer": "B",
    "explanation": "One of the most common risks to any project can be staff turnover, and when this happens it needs to be communicated to the project team and the project manager.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      236,
      321,
      225,
      59,
      78
    ],
    "source": "9781119892502"
  },
  {
    "id": 916,
    "question": "Among the following, who would be the target audience that should be notified that a milestone has been completed? (Choose three.)",
    "choice_a": "Project sponsor",
    "choice_b": "Auditors",
    "choice_c": "Project team",
    "choice_d": "Product end users",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Auditors are a project independent group that wouldn't need to be communicated with during the project. Product end users would only be communicated with when the product was ready. Shareholders are not normally involved in a project when minute details like milestones would be communicated.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      236,
      59,
      150,
      250,
      77
    ],
    "source": "9781119892502",
    "choice_e": "Steering committee",
    "choice_f": "Shareholders"
  },
  {
    "id": 917,
    "question": "In the creation of a work breakdown structure, the project managers ask to see the OBS as an input to creating the document. What is an OBS?",
    "choice_a": "Office of business structure",
    "choice_b": "Operational business support",
    "choice_c": "Organizational breakdown structure",
    "choice_d": "Office breakdown structure",
    "correct_answer": "C",
    "explanation": "An organizational breakdown structure (OBS) is a hierarchical model setting or it describes the established organizational framework for project planning and resource management.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      128,
      85,
      84,
      9,
      59
    ],
    "source": "9781119892502"
  },
  {
    "id": 918,
    "question": "In which project life cycle phase would you develop a transition or release plan?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "C",
    "explanation": "The transition or release plan should be created in the Planning phase. Starting this work early allows for the end state of the project to be imagined for the transition to operations.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      9,
      85,
      329,
      7,
      84
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 919,
    "question": "WigitCom has a project underway to modernize its network infrastructure. There are new equipment and standards the network team will need to follow once the cutover is complete. The project team is working to design the knowledge transfer and skills development for the network team once the project is complete. Which activity of the transition/release plan is being developed?",
    "choice_a": "Operations training",
    "choice_b": "Operations handoff",
    "choice_c": "Operations readiness",
    "choice_d": "Skills matrix",
    "correct_answer": "A",
    "explanation": "Ensuring the operations team has the knowledge and skills to perform the work after a project is completed is a key activity of any project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      294,
      176,
      325,
      10,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 920,
    "question": "The team is working on the checklist and activities needed to take a project from development into production. This can include communication, cutover of equipment, promoting code to production, and shutting down the replaced equipment. What part of the transition/release plan is being developed?",
    "choice_a": "Operational training",
    "choice_b": "Go live",
    "choice_c": "Operations handoff",
    "choice_d": "Scrum retrospective",
    "correct_answer": "B",
    "explanation": "Understanding the steps to actually be performed when a new product or service is launched is critical to confidence in the project deliverables as well as key to organizational change management since people will believe in a well-run rollout more than one that has lots of errors and misses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      294,
      273,
      10,
      236,
      325
    ],
    "source": "9781119892502"
  },
  {
    "id": 921,
    "question": "DewDrops has been asked to augment a project to develop a new mobile app with outside resources. Once they have selected and onboarded the additional team members, there is a series of training on expectations of the resource management plan, expense, and time reporting, as well as coding standards that will be followed. This is an example of which of the following?",
    "choice_a": "Operational training",
    "choice_b": "Operational handoff",
    "choice_c": "Define access requirements",
    "choice_d": "Train project team members",
    "correct_answer": "D",
    "explanation": "Whenever new resources are brought on a project, it is important to train them on the performance expectations, standards they must follow, and reporting requirements so that the project can run quickly and effectively.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      78,
      76,
      83,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 922,
    "question": "When assessing the resource pool of available talent for a project, what is the purpose of conducting a preliminary procurement needs assessment?",
    "choice_a": "Determine which staff resources can be fired.",
    "choice_b": "Determine options available to augment project staff with needed skills.",
    "choice_c": "Determine the work backlog for the project.",
    "choice_d": "Determine the solution design by selecting a vendor.",
    "correct_answer": "B",
    "explanation": "When beginning a project, assessing what skills and staff are available helps determine gaps that need to be filled for the project to finish on time. Evaluating the vendor pool for cost and availability of staff and services to fill the gap is done in a preliminary procurement needs assessment.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      188,
      184,
      85,
      176,
      14
    ],
    "source": "9781119892502"
  },
  {
    "id": 923,
    "question": "The Wigit Construction project manager is meeting with new owners of a residential home being constructed. The new owners identify the house must be east facing, have four bedrooms, three bathrooms, a two-car garage, and a fenced-in backyard for the family's dog. What element of the project charter is being developed here?",
    "choice_a": "Establish the ROI of building a house",
    "choice_b": "Project objectives",
    "choice_c": "Success criteria",
    "choice_d": "Preliminary scope statement",
    "correct_answer": "C",
    "explanation": "The requirements for the house outline the success criteria for the project. Other requirements might include when the construction must be completed by, the total cost/budget, passing inspections, and no permit violations. Success criteria will vary from project to project.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      67,
      69,
      66,
      68,
      76
    ],
    "source": "9781119892502"
  },
  {
    "id": 924,
    "question": "A project is going to develop new intellectual property for a company that will give it a competitive advantage in the market. The team in considering moving the project work to a secure location that will only allow entry to those with an authorized entry badge. This is an example of which of the following?",
    "choice_a": "Responsibility assignment matrix",
    "choice_b": "Baselines and milestones",
    "choice_c": "Solution design",
    "choice_d": "Access requirements",
    "correct_answer": "D",
    "explanation": "Access requirements will pertain to both physical and electronic access to project materials and work locations. In matters of intellectual property, protecting information from unwanted eyes may be critical to a company's success.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      68,
      59,
      69,
      16,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 925,
    "question": "As a new project is being stood up, the stakeholders and project manager review a feasibility assessment that was conducted on the project idea, review the project management library for similar projects the company has attempted, and review the company's budget and staffing plan for the year. Which activity of the Initiation phase is occurring in this scenario?",
    "choice_a": "Identify stakeholders",
    "choice_b": "Review existing artifacts",
    "choice_c": "Perform an initial risk assessment",
    "choice_d": "Determine solution design",
    "correct_answer": "B",
    "explanation": "As the project is developing from an idea to an organized work effort, reviewing existing artifacts such as previous project documentation, feasibility studies, and company documents can help inform the parameters and activities needed for the new project.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      19,
      18,
      14,
      64,
      66
    ],
    "source": "9781119892502"
  },
  {
    "id": 926,
    "question": "WigitCom is developing a complex new enterprise software platform that will need to be able to be installed on multiple different operating systems and use different browsers. They outline the steps needed for testing in each of the unique environments, which staff will perform the testing, what steps the developers will need to take to meet standards, and how they will keep track of software versions. Which Planning life cycle phase activity are these tasks supporting?",
    "choice_a": "Review existing artifacts",
    "choice_b": "Identify stakeholders",
    "choice_c": "Develop a quality assurance plan",
    "choice_d": "Determine solution design",
    "correct_answer": "C",
    "explanation": "A quality assurance plan helps develop the processes, standards, and validation needed for the creation of a product that meets or exceeds the quality target of a company, project, or product.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      85,
      103,
      99,
      84,
      327
    ],
    "source": "9781119892502"
  },
  {
    "id": 927,
    "question": "When developing a transition plan/release plan, which of the following are the appropriate target audiences for the plan(s)?",
    "choice_a": "Project team only",
    "choice_b": "Internal audience",
    "choice_c": "External audience",
    "choice_d": "Both B and C",
    "correct_answer": "D",
    "explanation": "The target audience of a transition plan/release place oftentimes will need to include both internal and external stakeholders, depending on the nature of the project. It is important to assess early who will need to be consulted or informed of changes to the status quo.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      329,
      59,
      236,
      287,
      76
    ],
    "source": "9781119892502",
    "choice_e": "Both A and B"
  },
  {
    "id": 928,
    "question": "A company is implementing a new enterprise resource planning tool that will allow great visibility of financial data as long as the workforce moves away from existing work processes and tools. The project team is working on a plan that will introduce training to the appropriate stakeholders, follow up at intervals after the product cutover, communicate issues and lessons learned, and develop knowledge bases for self-service. These are all elements of which part of the Execution phase?",
    "choice_a": "Organizational change management",
    "choice_b": "Project change management",
    "choice_c": "Organizational standards",
    "choice_d": "Gate reviews",
    "correct_answer": "A",
    "explanation": "Organizational change management is a critical part of the adoption of a new product, service, or business process. A project needs to account for the concerns, fears, needs, and expectations of stakeholders to counter potential resistance and ensure project adoption. It does not matter that a solution is excellent if the adoption of that solution or change is not also excellent.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      294,
      176,
      236,
      10,
      59
    ],
    "source": "9781119892502"
  },
  {
    "id": 929,
    "question": "DewDrops has contracted with I'm Here for You consulting to provide programming services in the development of a new product. Code turned over to the DewDrops team does not follow the programming standards need for product. The project manager rejects the submission and directs the consultants to correct their defects. This is an example of which of the following?",
    "choice_a": "Obtain project sign-off",
    "choice_b": "Conduct gate reviews",
    "choice_c": "Organizational adoption",
    "choice_d": "Enforce vendor rules of engagement",
    "correct_answer": "D",
    "explanation": "A key part of the Execution phase is the management of vendors supporting the project. The project manager must ensure the expectations spelled out in procurement or project documents are followed and enforced.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      273,
      188,
      10,
      84,
      69
    ],
    "source": "9781119892502"
  },
  {
    "id": 930,
    "question": "Ron in purchasing needs you to create an SOW prior to releasing an RFP. What does SOW stand for?",
    "choice_a": "Service of workforce",
    "choice_b": "Statement of work",
    "choice_c": "Statement of workforce",
    "choice_d": "Support of work",
    "correct_answer": "B",
    "explanation": "A statement of work formally captures and defines work activities, timeframes, milestones, and deliverables that a vendor must meet in the performance of work for a customer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      69,
      70,
      66,
      132
    ],
    "source": "9781119892502"
  },
  {
    "id": 931,
    "question": "Beth has been charged with gathering information from suppliers to have them bid on specific products or services. What is the appropriate procurement vehicle for this activity?",
    "choice_a": "RFI",
    "choice_b": "Sole source",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "D",
    "explanation": "A request for quotation is generally more involved than just a price per item response. It can also be called an invitation for bid.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      184,
      188,
      99,
      69,
      126
    ],
    "source": "9781119892502"
  },
  {
    "id": 932,
    "question": "What are the three types of estimates used in three-point estimates?",
    "choice_a": "Fastest-Schedule, Least Resources, Most Desirable",
    "choice_b": "Fastest-Schedule, Optimistic, Most Desirable",
    "choice_c": "Most Likely, Least Resources, Fastest Schedule",
    "choice_d": "Most Likely, Optimistic, and Pessimistic",
    "correct_answer": "D",
    "explanation": "The formula used is (Most Likely + Optimistic + Pessimistic) / 3.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      143,
      85,
      128,
      122
    ],
    "source": "9781119892502"
  },
  {
    "id": 933,
    "question": "A key stakeholder, Don, is very detail-oriented and likes to do deep dives on the status of projects. He has asked for a highly detailed status report to be emailed to him weekly so that he can stay informed about the project. Which of the following specific stakeholder communication requirements is he asking for? (Choose two.)",
    "choice_a": "Frequency",
    "choice_b": "Level of report detail",
    "choice_c": "Confidentially constraints",
    "choice_d": "Criticality factors",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "To ensure maximum participation by Don on the project, aligning the communication approach to his preferences will help with his engagement.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      236,
      208,
      259,
      59,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 934,
    "question": "WigitCom is going to experience a delay in a project because a key programmer is going to be out on emergency leave. What type of communication trigger does this represent?",
    "choice_a": "Incident response",
    "choice_b": "Business continuity response",
    "choice_c": "Schedule change",
    "choice_d": "Gate review",
    "correct_answer": "C",
    "explanation": "The project will no longer be able to keep to the current schedule due to the emergency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      321,
      236,
      324,
      208,
      79
    ],
    "source": "9781119892502"
  },
  {
    "id": 935,
    "question": "Joyce is an executive who is not a big user of technology, and she has asked to receive all updates verbally rather than through email. This stakeholder's communication requirement is which one of the following?",
    "choice_a": "Frequency",
    "choice_b": "Level of report detail",
    "choice_c": "Confidentiality constraints",
    "choice_d": "Types of communication",
    "correct_answer": "D",
    "explanation": "It is important to attempt to meet stakeholder preferences in terms of communication so that you get an active response and high levels of participation from that stakeholder.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      236,
      231,
      208,
      79,
      125
    ],
    "source": "9781119892502"
  },
  {
    "id": 936,
    "question": "Chuck is the project manager for a project, and he needs a specialized piece of heavy equipment so that he can get work scheduled. Which project artifact should Chuck look to when checking availability?",
    "choice_a": "Project charter",
    "choice_b": "Resource calendar",
    "choice_c": "Project schedule",
    "choice_d": "Project calendar",
    "correct_answer": "B",
    "explanation": "A resource calendar describes the timeframes in which resources (equipment and team members) are available for project work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      10,
      188,
      231,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 937,
    "question": "The situation where the project team is stuck on the last piece of work, which prevents the project from completing, is known as which one of the following?",
    "choice_a": "Pareto diagram",
    "choice_b": "The 95 percent phenomenon",
    "choice_c": "IRR",
    "choice_d": "The 80/20 rule",
    "correct_answer": "B",
    "explanation": "The 95 percent phenomenon is where the project seems to stagnate or be unable to complete the last step or steps so that the project can be completed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      11,
      325,
      84,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 938,
    "question": "The practice of documenting who updated a document when and with what information is known as which one of the following?",
    "choice_a": "Progressive elaboration",
    "choice_b": "Validation",
    "choice_c": "Documentation",
    "choice_d": "Version control",
    "correct_answer": "D",
    "explanation": "Version control helps create the audit trail of changes to documentation, when decisions change, and when the last update to certain documents took place.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      284,
      12,
      84,
      149,
      225
    ],
    "source": "9781119892502"
  },
  {
    "id": 939,
    "question": "What is the entity that reviews change requests, evaluates impacts, and ultimately approves, denies, or defers the request?",
    "choice_a": "CAB",
    "choice_b": "CCB",
    "choice_c": "NDA",
    "choice_d": "MOU",
    "correct_answer": "B",
    "explanation": "A change control board (CCB) is the body that evaluates and approves changes.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      82,
      10,
      284,
      287,
      250
    ],
    "source": "9781119892502"
  },
  {
    "id": 940,
    "question": "A contractor needs to ensure that the subcontractor on the project fulfills the expectations of the customer and wants to create SLAs with the subcontractor. What is an SLA?",
    "choice_a": "Service-level agreement",
    "choice_b": "Statement logistical alignment",
    "choice_c": "Support-level agreement",
    "choice_d": "Service-level assignment",
    "correct_answer": "A",
    "explanation": "Service-level agreements spell out the thresholds that must be maintained in providing services, such as response times, defect rates, and other qualities.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      66,
      67,
      70,
      236,
      188
    ],
    "source": "9781119892502"
  },
  {
    "id": 941,
    "question": "Who is the target audience and what is the rationale behind conducting a gate review?",
    "choice_a": "Project manager, to ensure resource availability",
    "choice_b": "Project sponsor, to see if they picked a good project",
    "choice_c": "Project team, to find out what they are doing wrong",
    "choice_d": "Project governance, to ensure accountability and objective alignment",
    "correct_answer": "D",
    "explanation": "Gate reviews are presented to a governance board or steering committee to validate cost models, schedule, risks, and objective obtainment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      250,
      236,
      16,
      59
    ],
    "source": "9781119892502"
  },
  {
    "id": 942,
    "question": "DewDrops's project manager has assembled the project team together to review the proposed project schedule and receive feedback on the feasibility of the schedule. What was the trigger for this communication?",
    "choice_a": "Risk register updates",
    "choice_b": "Project change",
    "choice_c": "Project planning",
    "choice_d": "Schedule changes",
    "correct_answer": "C",
    "explanation": "Since the project team is working on the proposed project schedule, the trigger is project planning. If the situation was adjusting the schedule after the project is already underway, then the answer would be schedule changes.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      85,
      134,
      9,
      81,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 943,
    "question": "During a project to replace a telephone switch, the project team discovers that one piece of equipment is faulty and a new router will need to be configured. The project manager prepares an email to the organization saying the outage will be extended by an hour to deal with the faulty equipment. What was the trigger for this communication?",
    "choice_a": "Task initiation",
    "choice_b": "Task completion",
    "choice_c": "Project change",
    "choice_d": "Schedule change",
    "correct_answer": "D",
    "explanation": "During the execution of the activity, the expectations that were set have been changed. This should invite the project manager to reset communications with all stakeholders so they will know when the service will be restored.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      324,
      236,
      321,
      10,
      273
    ],
    "source": "9781119892502"
  },
  {
    "id": 944,
    "question": "A key stakeholder has considered a project and discovered a new risk that was not previously identified. The project manager shares this information with the appropriate stakeholders, including the project team. What was the trigger for this communication?",
    "choice_a": "Project change",
    "choice_b": "Risk register update",
    "choice_c": "Milestone",
    "choice_d": "Task completion",
    "correct_answer": "B",
    "explanation": "With the identification of new risks, the information should be captured in the risk register and stakeholders need to be informed so that mitigation plans can be developed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      225,
      231,
      236,
      16,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 945,
    "question": "When a project manager is working on the creation of artifacts like the scope, budget, and schedule of a project, what type of communication trigger does this represent?",
    "choice_a": "Audit",
    "choice_b": "Project planning",
    "choice_c": "Project change",
    "choice_d": "Milestones",
    "correct_answer": "B",
    "explanation": "Communication occurs throughout the project planning process in the creation of plans for risk, quality, communication, schedule, budget, and scope, to name a few.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      9,
      236,
      231,
      85,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 946,
    "question": "A project has fallen behind schedule, and the project manager has decided to have team members work 10 hours of overtime each week instead of bringing in new team members. This is an example of which one of the following?",
    "choice_a": "Crashing",
    "choice_b": "Risk avoidance",
    "choice_c": "Fast tracking",
    "choice_d": "Critical path method",
    "correct_answer": "A",
    "explanation": "Crashing is a technique where resources are added to the project at the lowest possible cost, reflected in the decision to use overtime instead of adding team members.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      134,
      10,
      85,
      188,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 947,
    "question": "Molly is a key stakeholder on a project. She wants a weekly summary every Friday on the project's progress. An urgent issue comes up on Tuesday that could significantly delay the entire project unless a decision is made quickly. What two factors conflict with each other in this scenario?",
    "choice_a": "Intraorganizational differences",
    "choice_b": "Criticality factors",
    "choice_c": "Tailor the method based on the content of the message",
    "choice_d": "Personal preferences",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Sometimes, the urgency or importance of certain communication can overrule a stakeholder's personal preferences because the project team can be at a standstill unless a decision is made.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      236,
      321,
      59,
      79,
      240
    ],
    "source": "9781119892502"
  },
  {
    "id": 948,
    "question": "Devdan received a file from the project manager to review. When he is finished, he saves the document with his initials at the end of the filename and emails it back to the project manager. Adding his initials at the end is a form of which one of the following?",
    "choice_a": "Change requests",
    "choice_b": "Risk response plan",
    "choice_c": "Progressive elaboration",
    "choice_d": "Version control",
    "correct_answer": "D",
    "explanation": "The practice of adding initials at the end allows readers to see who has added comments or changes to a document. Modern productivity and collaboration tools can be utilized to help keep track of version control automatically.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      284,
      82,
      93,
      71,
      69
    ],
    "source": "9781119892502"
  },
  {
    "id": 949,
    "question": "The original project plan for the construction of a building called the facility to be 95 percent defect free by the end of the project. The customer wants few hassles after taking ownership of the building, and this changes to 98 percent defect free. What type of project change does this represent?",
    "choice_a": "Scope",
    "choice_b": "Risk",
    "choice_c": "Timeline",
    "choice_d": "Quality",
    "correct_answer": "D",
    "explanation": "Defects, rework, and their related costs are all related to the quality plan, or a quality change.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      67,
      69,
      313,
      84,
      327
    ],
    "source": "9781119892502"
  },
  {
    "id": 950,
    "question": "The project manager just completed a meeting with the steering committee and announces to the team that the project can move forward. Which of the following initiated the communication?",
    "choice_a": "Gate reviews",
    "choice_b": "Resource changes",
    "choice_c": "Business continuity response",
    "choice_d": "Milestones",
    "correct_answer": "A",
    "explanation": "The key to this answer is the approval to move forward. Gate reviews are check-in points where authorization to proceed must be given.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      150,
      66,
      67,
      8,
      79
    ],
    "source": "9781119892502"
  },
  {
    "id": 951,
    "question": "Ralph is the project manager for the opening of a new ice cream parlor. The owner is always asking for status updates from Ralph and pushes Ralph to finish with a quality store that is on time and on budget. Which role in a RACI matrix would Ralph hold for the entire project?",
    "choice_a": "Responsible",
    "choice_b": "Accountable",
    "choice_c": "Consulted",
    "choice_d": "Informed",
    "correct_answer": "B",
    "explanation": "Ralph's role on the project is that he is accountable for all actions on the project and those of the project team. He has the authority to task, delegate, and ensure the quality from the deliverables.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      8,
      12,
      71,
      76,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 952,
    "question": "Mark submits a purchase requisition to his company's procurement section. He must wait for a PO to be cut in order for the vendor to begin work. What is a PO?",
    "choice_a": "Planned objective",
    "choice_b": "Purchase office",
    "choice_c": "Purchase order",
    "choice_d": "Planned order",
    "correct_answer": "C",
    "explanation": "A purchase order is an official offer issued to a seller indicating types, quantities, and agreed-upon prices for products and services.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      184,
      189,
      10,
      331
    ],
    "source": "9781119892502"
  },
  {
    "id": 953,
    "question": "During a weekly project meeting, there is a list kept of any assignments that are handed out during the meeting. What type of project document is this?",
    "choice_a": "Issue log",
    "choice_b": "Action items",
    "choice_c": "Meeting minutes",
    "choice_d": "Communication plan",
    "correct_answer": "B",
    "explanation": "It is critical to capture any assignments that have been handed out, who owns the assignment, and when the task is due. This helps make sure there is no lapse of completion due to unclear assignments and lack of clarity on what needs to be complete by when.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      78,
      236,
      324,
      76,
      77
    ],
    "source": "9781119892502"
  },
  {
    "id": 954,
    "question": "The project's sponsor is reviewing a communication for the project manager. In the document, she reads that the project is on budget, but there was a delay in getting materials from a supplier since the last communication. <p>Which project document is she reading?</p>",
    "choice_a": "Status report",
    "choice_b": "Scope statement",
    "choice_c": "Risk register",
    "choice_d": "Scrum retrospective",
    "correct_answer": "A",
    "explanation": "A status report is a written document that captures the progress being made on a project, what challenges have materialized, and data on tracking to completing on time and on budget.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      324,
      321,
      259,
      236,
      70
    ],
    "source": "9781119892502"
  },
  {
    "id": 955,
    "question": "The project schedule contains all the following elements EXCEPT:",
    "choice_a": "Activity start and finish dates",
    "choice_b": "Activity duration",
    "choice_c": "Activity assignments to resources",
    "choice_d": "Authorization for the project to begin",
    "correct_answer": "D",
    "explanation": "The project charter is the document that authorizes the project to commence.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      12,
      134,
      84,
      149,
      9
    ],
    "source": "9781119892502"
  },
  {
    "id": 956,
    "question": "Which of the following are a means of communicating the current conditions of a project? (Choose three.)",
    "choice_a": "Dashboard information",
    "choice_b": "Status report",
    "choice_c": "Meeting minutes",
    "choice_d": "Meeting agenda",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Meeting agendas, communication plans, and project charters would all fall into the category of planning documents at various levels. Project condition information, or status, can all be gleaned in different forms from dashboard information, status reports, and meeting minutes.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      259,
      236,
      324,
      321,
      77
    ],
    "source": "9781119892502",
    "choice_e": "Communication plan",
    "choice_f": "Project charter"
  },
  {
    "id": 957,
    "question": "When a company is interested in procuring a commodity or service, they conduct a bidding process where suppliers submit business proposals. What is this process known as?",
    "choice_a": "RFI",
    "choice_b": "Sole source",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "C",
    "explanation": "A request for proposal is a formal document that an organization posts to solicit bids from potential suppliers and vendors.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      189,
      8,
      65,
      99
    ],
    "source": "9781119892502"
  },
  {
    "id": 958,
    "question": "Susan is working on a project, and she is the lone specialist assigned to complete a deliverable on a task. She will do the work to complete the assignment, and she is the person who must answer for the correct and thorough completion of the deliverable. Which two participation types of a RACI matrix has she been assigned? (Choose two.)",
    "choice_a": "Responsible",
    "choice_b": "Accountable",
    "choice_c": "Consulted",
    "choice_d": "Informed",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "It is possible for someone to be both responsible and accountable. Remember that there can be only one person who is accountable, but multiple people can be responsible. Where an individual gets assigned to multiple participation types will be dependent on the number and quality of staff assigned to the project.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      8,
      12,
      59,
      10,
      11
    ],
    "source": "9781119892502"
  },
  {
    "id": 959,
    "question": "At the product launch of a new service, the project team gathers at a local restaurant to celebrate and honor the work they have done. The project sponsor surprises the team members by giving each one a $200 gift card and thanks them for a job well done. The activity of rewarding and celebration typically occurs in which project life cycle phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "E",
    "explanation": "For the exam, know this activity is identified in the Closing phase. Depending on the size of the project and the culture of the company, it is possible that big milestones or other events might be causes for rewards and celebrations. As former Walt Disney World Vice President of Operations Lee Cockerell says, if you burn the \u201cfree fuel\u201d and appreciate, recognize, and encourage everyone, you will have higher morale, productivity, and loyalty.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      11,
      7,
      325,
      10,
      83
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 960,
    "question": "As a project comes to an end, what are two important activities to conduct with project team members?",
    "choice_a": "Monitor performance.",
    "choice_b": "Give performance feedback.",
    "choice_c": "Release team members to their function.",
    "choice_d": "Ensure project adoption.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "To help the project team members grow, it is important to give honest feedback in their performance: things they did well and things they could do to make them even better. Additionally, they should be released from their project responsibilities so they can return to their functional jobs. If they are contract resources, they should be freed up to return to their company, which can assign them to future work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      331,
      330,
      328,
      10,
      176
    ],
    "source": "9781119892502"
  },
  {
    "id": 961,
    "question": "As work activities conclude, what important step should be performed as team members are released from the project?",
    "choice_a": "Remove physical and digital access.",
    "choice_b": "Sell equipment bought for the project.",
    "choice_c": "Invoice customers for the project team's time.",
    "choice_d": "Train project team members.",
    "correct_answer": "A",
    "explanation": "Following the principle of least privilege, make sure that physical and digital access is reviewed and revoked for any project personnel who no longer require this access. This is vital to help ensure the security of the product or service once in production.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      327,
      325,
      326,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 962,
    "question": "Why is it important to collect feedback from stakeholders at the conclusion of project activities? (Choose two).",
    "choice_a": "It is a formality of the project closeout.",
    "choice_b": "To tell the stakeholders what a great job was done.",
    "choice_c": "To see if the stakeholders' needs were meet by the project.",
    "choice_d": "To find opportunities for improvement for future projects.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Ensuring the stakeholders have a voice in the project will help to capture lessons learned that can be utilized on future projects. Additionally, checking in with the stakeholders allows for validation and discussion on how successful the project was in satisfying the objectives.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      11,
      330,
      67,
      328,
      16
    ],
    "source": "9781119892502"
  },
  {
    "id": 963,
    "question": "Why is it important to validate deliverables when a project starts to conclude?",
    "choice_a": "To confirm the project has satisfied the objectives",
    "choice_b": "To ensure the quality of the deliverables is acceptable",
    "choice_c": "To verify timeliness and completeness to pay a vendor",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "It is vital to verify deliverables to ensure they meet specifications and satisfy project objectives. Additionally, vendor payments are often tied to deliverables, so before the vendor is paid and let off the hook for performance, make sure the deliverable is what the project expected it to be.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      327,
      98,
      122,
      331,
      69
    ],
    "source": "9781119892502",
    "choice_e": "A and C only"
  },
  {
    "id": 964,
    "question": "As a project concludes, the project manager meets with the project team to review expenditures for the project and signs off on the project budget. This is known as which of the following?",
    "choice_a": "Return on investment analysis",
    "choice_b": "Updating the project budget",
    "choice_c": "Current state analysis",
    "choice_d": "Budget reconciliation",
    "correct_answer": "D",
    "explanation": "An activity of the Closing phase, the project manager validates all project expenditures, closes purchase orders and contracts, and finalizes the total spend for the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      84,
      203,
      10,
      325
    ],
    "source": "9781119892502"
  },
  {
    "id": 965,
    "question": "All of the following are information-gathering techniques used in project management EXCEPT:",
    "choice_a": "Brainstorming",
    "choice_b": "Delphi technique",
    "choice_c": "Gantt chart",
    "choice_d": "Root cause analysis",
    "correct_answer": "C",
    "explanation": "A Gantt chart is a tool that displays activities and represents visual task duration along with activity precedence.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      134,
      128,
      150,
      59
    ],
    "source": "9781119892502"
  },
  {
    "id": 966,
    "question": "The project manager writes a report, one of the final artifacts created, detailing the status of turnover to production, status of all contracts/purchase orders, total spend on the project, and the release of the resources back to their functional jobs. What is this report called?",
    "choice_a": "Budget reconciliation report",
    "choice_b": "Final project charter",
    "choice_c": "Project closeout report",
    "choice_d": "Update scope statement",
    "correct_answer": "C",
    "explanation": "To close out the project, it is a good idea to describe the status of the project at completion. This can include known additional risks that might need to be monitored on the new product or service. It might also include future scope that could be taken up in a future project that wasn't completed or developed as an opportunity to pursue.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      325,
      12,
      321,
      324,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 967,
    "question": "The project sponsor has been away on a business trip overseas. Her first day back, she finds the project manager to learn the status of the project since she has been away. The project manager develops a quick report and stops by to fill her in. What type of reporting is this known as?",
    "choice_a": "Team touchpoints",
    "choice_b": "Ad hoc reporting",
    "choice_c": "Overall progress reporting",
    "choice_d": "External status reporting",
    "correct_answer": "B",
    "explanation": "A project manager can spend up to 90 percent of their time communicating, and the ability to provide ad hoc status updates can provide timely information to help manage anxieties and expectations.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      236,
      324,
      259,
      321,
      208
    ],
    "source": "9781119892502"
  },
  {
    "id": 968,
    "question": "Robert is a project manager working on an ERP implementation for a local municipality. He sets a weekly team meeting to review progress on assigned deliverables. What type of tracking tool is this known as?",
    "choice_a": "Team touchpoints",
    "choice_b": "Risk reporting",
    "choice_c": "Gap analysis",
    "choice_d": "Ad hoc reporting",
    "correct_answer": "A",
    "explanation": "Team touchpoints are an effective mechanism to determine the obstacles and momentum of a project. A team touchpoint doesn't have to be a meeting since collaboration tools can allow for asynchronous status updates to be shared with the project manager and the rest of the project team.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      259,
      236,
      76,
      78,
      287
    ],
    "source": "9781119892502"
  },
  {
    "id": 969,
    "question": "The project steering committee wants a monthly report that identifies milestones, schedule and budget updates, risks and issues affecting the project, and any personnel issues. What type of report is the steering committee asking for?",
    "choice_a": "Team touchpoints",
    "choice_b": "Overall progress reporting",
    "choice_c": "External status reporting",
    "choice_d": "Gap analysis",
    "correct_answer": "B",
    "explanation": "Overall progress reporting helps to keep key stakeholders informed on the project's momentum, spend, and challenges as it works through the work activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      324,
      321,
      259,
      225,
      150
    ],
    "source": "9781119892502"
  },
  {
    "id": 970,
    "question": "The DewDrops board of directors asks for quarterly reports from all their projects over a specific dollar amount. The project manager is asked to attend the meeting and give an update on a new datacenter being constructed. What type of reporting does this represent?",
    "choice_a": "External status reporting",
    "choice_b": "Overall progress reporting",
    "choice_c": "Ad hoc reporting",
    "choice_d": "Risk reporting",
    "correct_answer": "A",
    "explanation": "External status reporting is targeting stakeholders outside of the project organization such as the organization's board of directors. Other forms of external status reporting could be to a government agency that awarded a grant to an organization to complete certain work.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      208,
      236,
      287,
      259,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 971,
    "question": "A contract employee has been brought on to help document the network architecture for DewDrops. Bruce notices this employee has missed several key meetings and he is still waiting for a weekly status update on the work he has performed. He reaches out to the company to inform them of these challenges. What is this an example of?",
    "choice_a": "External status reporting",
    "choice_b": "Validation of deliverables",
    "choice_c": "Monitoring performance",
    "choice_d": "Collecting feedback from stakeholders",
    "correct_answer": "C",
    "explanation": "Monitoring performance is an activity of managing vendors. Making sure vendor resources are on track for their assignments is as important as it is for internal project resources.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      10,
      259,
      324,
      321,
      59
    ],
    "source": "9781119892502"
  },
  {
    "id": 972,
    "question": "In which project life cycle phase would the brainstorming, evaluation, and impact of risk be assessed?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "C",
    "explanation": "Risk identification, probability and impact analysis, and risk response would all take place during the Planning phase of the project.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      9,
      85,
      68,
      7,
      12
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 973,
    "question": "Nathan is working on a project status report. He is currently tracking where the project is from a schedule and budget perspective and then making a comparison against the original baselines. What type of tracking is Nathan performing?",
    "choice_a": "Team touchpoints",
    "choice_b": "Risk reporting",
    "choice_c": "Overall progress reporting",
    "choice_d": "Gap analysis",
    "correct_answer": "D",
    "explanation": "A gap analysis compares the progress to date versus the expected progress to see if the project is on schedule and on budget.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      324,
      203,
      149,
      84,
      132
    ],
    "source": "9781119892502"
  },
  {
    "id": 974,
    "question": "Gabriel is compiling the impact and probability of known project threats, including identification of active and new threats and opportunities. What type of reporting is he creating?",
    "choice_a": "Risk reporting",
    "choice_b": "Risk planning",
    "choice_c": "Threat identification",
    "choice_d": "Issues reporting",
    "correct_answer": "A",
    "explanation": "A risk can be either positive or negative, which can guide the project's response to dealing with a risk should it occur. Gabriel should be using both the risk plan and the risk register as inputs in the creation of his report.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      225,
      223,
      9,
      260,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 975,
    "question": "The project team believes they have completed all of the activities and deliverables in the Execution phase. They meet with the project steering committee to review progress, deliverables, and the scope of the project. What type of review is taking place?",
    "choice_a": "Overall progress reporting",
    "choice_b": "Risk reporting",
    "choice_c": "Phase gate review",
    "choice_d": "Gap analysis",
    "correct_answer": "C",
    "explanation": "A gate review is a formal governance step designed to ensure required processes and tasks have been completed and that the project is worth continuing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      10,
      273,
      7,
      11,
      324
    ],
    "source": "9781119892502"
  },
  {
    "id": 976,
    "question": "A sprint backlog is composed of which of the following? (Choose three.)",
    "choice_a": "Sprint goal",
    "choice_b": "Gate review",
    "choice_c": "Run charts",
    "choice_d": "Product backlog items",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "The sprint goal sets the single objective and commitment of the developers. The backlog brings transparency to all work that is needed to be performed. The action plan for the sprint is dynamic and changes as the sprint progresses.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      156,
      262,
      238,
      84,
      85
    ],
    "source": "9781119892502",
    "choice_e": "Milestone chart",
    "choice_f": "Action plan"
  },
  {
    "id": 977,
    "question": "All of the following are examples of categories that might be included in a resource breakdown structure EXCEPT:",
    "choice_a": "External",
    "choice_b": "Project management",
    "choice_c": "Organizational",
    "choice_d": "Probability and impact",
    "correct_answer": "D",
    "explanation": "Probability and impact is a prioritization tool and not a category that might be included in a resource breakdown structure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      165,
      294,
      10,
      325
    ],
    "source": "9781119892502"
  },
  {
    "id": 978,
    "question": "What is a RACI matrix used for?",
    "choice_a": "Determining key performance indicators",
    "choice_b": "Identifying roles and responsibilities",
    "choice_c": "Analyzing risk at a moment in time",
    "choice_d": "Presenting status via a dashboard",
    "correct_answer": "B",
    "explanation": "RACI stands for Responsible, Accountable, Consulted, and Informed. At a task or activity level, it identifies who needs to do what action based on the individual's role.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      59,
      63,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 979,
    "question": "A subject matter expert who is not directly working on a project receives a phone call to get her opinion on two options facing the team. Which role in a RACI matrix has this stakeholder been assigned?",
    "choice_a": "Responsible",
    "choice_b": "Accountable",
    "choice_c": "Consulted",
    "choice_d": "Informed",
    "correct_answer": "C",
    "explanation": "Being consulted means there is a two-way communication that will take place prior to a decision or action being taken for a particular task or decision. This will often vary in a RACI matrix from activity to activity.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      8,
      12,
      236,
      59,
      77
    ],
    "source": "9781119892502"
  },
  {
    "id": 980,
    "question": "A government agency has hired a firm to perform work on its sewer system. As a part of the RFP, the agency requires the successful vendor to carry insurance for errors and omissions. What type of risk strategy is this?",
    "choice_a": "Accept, negative risk strategy",
    "choice_b": "Exploit, positive risk strategy",
    "choice_c": "Share, positive risk strategy",
    "choice_d": "Transfer, negative risk strategy",
    "correct_answer": "D",
    "explanation": "By requiring the successful vendor to carry the insurance, it allows the consequences of negative risk to be transferred to the third party.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      225,
      68,
      184,
      188,
      223
    ],
    "source": "9781119892502"
  },
  {
    "id": 981,
    "question": "Meghan is a project manager. A team member reported to her an inappropriate and unprofessional interaction with a project team member on a different team. Meghan is unsure to whom this person reports. Which project document would help her find the correct person to whom to escalate this issue?",
    "choice_a": "RACI matrix",
    "choice_b": "Request for proposal",
    "choice_c": "Organizational chart",
    "choice_d": "Issue log",
    "correct_answer": "C",
    "explanation": "The organizational chart is a graphic representation of how the project is structured and contains the reporting relationships for the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      78,
      59,
      236,
      66,
      76
    ],
    "source": "9781119892502"
  },
  {
    "id": 982,
    "question": "The communication plan contains all of the following components EXCEPT:",
    "choice_a": "Stakeholder information needs",
    "choice_b": "When information should be distributed",
    "choice_c": "Report on status of deliverables and schedule",
    "choice_d": "How information will be delivered",
    "correct_answer": "C",
    "explanation": "This defines a status report. While this is a specific type of communication, the need for the report and who it will be sent to would be included in the communication plan. The actual report itself is a different project artifact.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      236,
      259,
      324,
      208,
      132
    ],
    "source": "9781119892502"
  },
  {
    "id": 983,
    "question": "When creating a RACI matrix, how many different positions can/must have the role of accountable?",
    "choice_a": "Zero",
    "choice_b": "One",
    "choice_c": "Two",
    "choice_d": "Three",
    "correct_answer": "B",
    "explanation": "For any given task, there must be one, and only one, position responsible to be accountable. Being accountable in a RACI context means the one person ultimately answerable for the correct and thorough completion of a deliverable or task.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      59,
      236,
      9
    ],
    "source": "9781119892502"
  },
  {
    "id": 984,
    "question": "Which project plan sets how information will be shared on the project, what the frequency level is with which it will be shared, and with whom it will be shared?",
    "choice_a": "Meeting agenda",
    "choice_b": "Action items",
    "choice_c": "Project charter",
    "choice_d": "Communication plan",
    "correct_answer": "D",
    "explanation": "This plan sets the written communication, meeting schedule, and escalations that should occur to keep the identified stakeholders up-to-date on project events.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      236,
      259,
      132,
      84,
      9
    ],
    "source": "9781119892502"
  },
  {
    "id": 985,
    "question": "Scott is a board director for a nonprofit, and he is looking for an update on the financial aspects of a new project that the organization is attempting. Which document would help bring Scott up to speed on current conditions of the project?",
    "choice_a": "Issue log",
    "choice_b": "Project management plan",
    "choice_c": "SWOT analysis",
    "choice_d": "Status report",
    "correct_answer": "D",
    "explanation": "A status report or dashboard would allow the stakeholder to get the information on the current conditions of the project. Other performance measurement tools like a balanced scorecard could help give a glimpse into the project.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      324,
      259,
      236,
      321,
      208
    ],
    "source": "9781119892502"
  },
  {
    "id": 986,
    "question": "WigitCom has just completed the prototype for a new application and has received user acceptance of the design. This is an example of which one of the following?",
    "choice_a": "Gate check",
    "choice_b": "Milestone",
    "choice_c": "Deliverable",
    "choice_d": "Lessons learned",
    "correct_answer": "B",
    "explanation": "Milestones are major events that are used to measure progress on a project.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      70,
      67,
      103,
      11,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 987,
    "question": "When creating a RACI matrix, what does it mean to be assigned an \u201cR\u201d for Responsible?",
    "choice_a": "The one who is ultimately answerable for the correct and thorough completion of the assignment",
    "choice_b": "Those whose opinions are needed before work or a decision is undertaken",
    "choice_c": "Those who do the work needed to complete the task or deliverable",
    "choice_d": "Those who are kept up-to-date when work or a decision is completed",
    "correct_answer": "C",
    "explanation": "With a RACI matrix, it is easy to get accountable and responsible mixed up and when working through the creation of the matrix. Accountable means they are the ones who must see the task completed, whereas responsible means the people who will do the work. Keep a sharp eye out to make sure you don't get confused.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      8,
      12,
      59,
      236,
      98
    ],
    "source": "9781119892502"
  },
  {
    "id": 988,
    "question": "In which project phase would an issue log generally be developed?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "The issue log contains a list of issues with IDs, descriptions, and owners of the issue, and it starts to develop as the execution of the project gets underway.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      324,
      10,
      7,
      84
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 989,
    "question": "Gerry is a new project manager in a company, and he has been told that this project must go through checkpoints between phases of the project with a steering committee. What is the name for these checkpoints?",
    "choice_a": "Lessons learned",
    "choice_b": "Scrum introspective",
    "choice_c": "Governance gates",
    "choice_d": "Kickoff meetings",
    "correct_answer": "C",
    "explanation": "Governance gate meetings help to ensure accountability and that the project is proceeding according to plan.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      250,
      303,
      70,
      7
    ],
    "source": "9781119892502"
  },
  {
    "id": 990,
    "question": "At the conclusion of a defined work period, Yolanda got the project team together to figure out what went well, what didn't go well, and what improvements could be made. What type of meeting was this?",
    "choice_a": "Scrum introspective",
    "choice_b": "Product backlog",
    "choice_c": "Daily Scrum",
    "choice_d": "Kickoff meeting",
    "correct_answer": "A",
    "explanation": "A Scrum introspective is a form of lessons learned done with the Agile methodology at the end of each sprint.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      238,
      330,
      11,
      325,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 991,
    "question": "There is a question about a project decision that was made at a gathering earlier in a project. Where should the project manager look to help recall the decision and the circumstances that were discussed?",
    "choice_a": "Meeting agenda",
    "choice_b": "Project charter",
    "choice_c": "Action items list",
    "choice_d": "Meeting minutes",
    "correct_answer": "D",
    "explanation": "Meeting minutes are intended to keep track of details of conversations and decisions that were made in the moment. Often during a project, as time passes and with so many other decisions made since a particular decision, it can be difficult to recall what was done and why. Meeting minutes are a tool to help address those challenges.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      260,
      76,
      77,
      78,
      81
    ],
    "source": "9781119892502"
  },
  {
    "id": 992,
    "question": "A project stakeholder receives a regular status update for various activities and milestones after they are completed. What role in a RACI matrix has this stakeholder been assigned?",
    "choice_a": "Responsible",
    "choice_b": "Accountable",
    "choice_c": "Consulted",
    "choice_d": "Informed",
    "correct_answer": "D",
    "explanation": "This stakeholder is designated to be informed, which is a one-way communication that takes place after an action or decision has already been completed.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      8,
      231,
      259,
      236,
      16
    ],
    "source": "9781119892502"
  },
  {
    "id": 993,
    "question": "A meeting has just been conducted on a project where the expectations, goals, and objectives of the project have been explained, including the milestones and timelines of the project. Project sign-off is also likely to occur during this meeting. What type of meeting was this?",
    "choice_a": "Lessons learned",
    "choice_b": "Gate check",
    "choice_c": "Status meeting",
    "choice_d": "Kickoff meeting",
    "correct_answer": "D",
    "explanation": "During the kickoff meeting, formal approval for the project might occur in the form of project sign-off.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      76,
      77,
      79,
      81,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 994,
    "question": "Gayle, the project sponsor, has said that the transit project needs to have four working bus lines operating 18 hours a day when the project is complete. Gayle has given which one of the following?",
    "choice_a": "Criteria for approval",
    "choice_b": "Gate check",
    "choice_c": "Deliverable",
    "choice_d": "Lessons learned",
    "correct_answer": "A",
    "explanation": "The criteria for approval are those conditions that must be in play for the customer to accept the end results of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      69,
      66,
      70,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 995,
    "question": "Wigit Construction has been asked to erect a building that has two bathrooms, a conference room, and an open space for cubicles. Which of the following do the bathrooms, conference room, and open space all represent?",
    "choice_a": "Deliverables",
    "choice_b": "Constraints",
    "choice_c": "Assumptions",
    "choice_d": "Requirements",
    "correct_answer": "A",
    "explanation": "Deliverables are specific items that must be produced in order for the project to be complete, and they are usually tangible in nature.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      66,
      128,
      70,
      122
    ],
    "source": "9781119892502"
  },
  {
    "id": 996,
    "question": "Lisa is a contract project manager assisting a government agency that is implementing companywide software. Lisa is operating the project with the belief that executive sponsorship will be strong on the project and that all project team members will be free of other responsibilities. This is an example of which one of the following?",
    "choice_a": "Deliverables",
    "choice_b": "Constraints",
    "choice_c": "Assumptions",
    "choice_d": "Requirements",
    "correct_answer": "C",
    "explanation": "Assumptions are those things believed to be true for planning purposes. It is important to communicate assumptions with key stakeholders so there are no missed expectations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      92,
      236,
      79,
      66
    ],
    "source": "9781119892502"
  },
  {
    "id": 997,
    "question": "A government agency has invited bids on a project that must be completed by the end of year, have a mobile application to interface the information, and be credit card compliant. These are all examples of which one of the following?",
    "choice_a": "Deliverables",
    "choice_b": "Constraints",
    "choice_c": "Assumptions",
    "choice_d": "Requirements",
    "correct_answer": "D",
    "explanation": "The timeframe, need for a mobile app, and security are all examples of a project's requirements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      64,
      66,
      93,
      94
    ],
    "source": "9781119892502"
  },
  {
    "id": 998,
    "question": "In which project phase would an action items list generally be developed?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "An action items list depicts all the project actions that should be resolved in order to fulfill deliverables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      85,
      81,
      77,
      9,
      69
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 999,
    "question": "The project sponsor has asked that the stakeholders be brought up to speed on project deliverables, schedule, risks, and issues. What is the project sponsor asking for?",
    "choice_a": "Meeting agenda",
    "choice_b": "Status report",
    "choice_c": "Action items",
    "choice_d": "Meeting minutes",
    "correct_answer": "B",
    "explanation": "For longer and more complex projects, status reports become key to make sure stakeholders are current on the progress, risks, and issues facing the project.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      324,
      259,
      321,
      287,
      208
    ],
    "source": "9781119892502"
  },
  {
    "id": 1000,
    "question": "Only two senior engineers are available to work on a project, and one of them is already committed to work on another project until the middle of the next quarter. This is an example of which one of the following?",
    "choice_a": "Deliverables",
    "choice_b": "Constraints",
    "choice_c": "Assumptions",
    "choice_d": "Requirements",
    "correct_answer": "B",
    "explanation": "Constraints are those conditions that restrict or dictate the actions of the project team.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      10,
      85,
      14,
      102
    ],
    "source": "9781119892502"
  },
  {
    "id": 1001,
    "question": "Assessing the status of the budget, reviewing risks/issues logs, and measuring performance occurs in what project phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "Activities that monitor the progress of the project and that require corrective actions occur in the Execution phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      324,
      273,
      259,
      225,
      132
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1002,
    "question": "The project sponsor receives a phone call letting her know that a major task has been completed successfully and that there were no safety issues to report. Which role has the project sponsor been assigned on this task?",
    "choice_a": "Responsible",
    "choice_b": "Accountable",
    "choice_c": "Consulted",
    "choice_d": "Informed",
    "correct_answer": "D",
    "explanation": "When someone has a role of informed, it means they are informed after a decision has been made or a result has been achieved.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      59,
      16,
      236,
      79,
      328
    ],
    "source": "9781119892502"
  },
  {
    "id": 1003,
    "question": "Stephanie is a project manager and has worked with the key stakeholders to get agreement on the project charter. At the kickoff meeting, she makes sure that all key stakeholders and sponsors sign the project charter. This is an example of which one of the following?",
    "choice_a": "Formal approval",
    "choice_b": "CYA",
    "choice_c": "Gate check",
    "choice_d": "Lessons learned",
    "correct_answer": "A",
    "explanation": "Formal approval is normally a requirement for purchase orders to be created, for team members to be assigned to the project, and for work to begin.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      71,
      76,
      79,
      81
    ],
    "source": "9781119892502"
  },
  {
    "id": 1004,
    "question": "What is a work breakdown structure?",
    "choice_a": "A task-oriented decomposition of a project",
    "choice_b": "A deliverable-oriented decomposition of a project",
    "choice_c": "A graphic representation of tasks and their sequence",
    "choice_d": "A high-level outline of milestones on a project",
    "correct_answer": "B",
    "explanation": "The work breakdown structure is a deliverable-oriented decomposition of a project.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      128,
      85,
      69,
      94,
      134
    ],
    "source": "9781119892502"
  },
  {
    "id": 1005,
    "question": "During the Closing phase of the project, what two activities are conducted?",
    "choice_a": "Accept project deliverables and perform quality assurance.",
    "choice_b": "Finalize project work and close all vendor contracts.",
    "choice_c": "Manage stakeholder expectations and close all vendor contracts.",
    "choice_d": "Finalize project work and perform quality assurance.",
    "correct_answer": "B",
    "explanation": "Finalizing project work and closing all vendor contracts take place during the Closing phase. Performing quality assurance would take place during monitor and control, and managing stakeholder expectations should occur throughout the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      11,
      327,
      325,
      12,
      334
    ],
    "source": "9781119892502"
  },
  {
    "id": 1006,
    "question": "All the following are ways to determine whether a project is completed EXCEPT:",
    "choice_a": "When the project manager declares the project is complete",
    "choice_b": "When the project is canceled",
    "choice_c": "When it has been determined that the goals and objectives of the project cannot be accomplished",
    "choice_d": "When the objectives are accomplished and stakeholders are satisfied",
    "correct_answer": "A",
    "explanation": "The project sponsor declares the project is complete. The project manager is not the critical role in this answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      325,
      67,
      69,
      10,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 1007,
    "question": "The Closing processes include all the following EXCEPT:",
    "choice_a": "Archiving of project documents",
    "choice_b": "Release of project members",
    "choice_c": "Review of lessons learned",
    "choice_d": "Monitoring of the risks and issues log",
    "correct_answer": "D",
    "explanation": "Monitoring the risks and issue log is an activity of the Execution life cycle phase since the majority of the work, and therefore the issue and risk probability, occur during this phase.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      11,
      10,
      7,
      225,
      273
    ],
    "source": "9781119892502"
  },
  {
    "id": 1008,
    "question": "A government agency has certain bureaucratic steps it must meet before it can move forward with payment to a vendor. What kind of dependency does this represent?",
    "choice_a": "Discretionary",
    "choice_b": "External",
    "choice_c": "Internal",
    "choice_d": "Optional",
    "correct_answer": "A",
    "explanation": "Best practices and internal processes are known as preferred or soft logic from a dependency standpoint. The three types of dependencies are mandatory, discretionary, and external. Therefore, internal would not be the correct answer, as tempting as it might seem.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      188,
      206,
      150,
      294,
      69
    ],
    "source": "9781119892502"
  },
  {
    "id": 1009,
    "question": "Which of the following project documents are created during the Execution phase? (Choose two.)",
    "choice_a": "Project charter",
    "choice_b": "Communication plan",
    "choice_c": "Issue log",
    "choice_d": "Lessons learned",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The issue log and action items are created during the Execution phase.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      10,
      324,
      273,
      12,
      11
    ],
    "source": "9781119892502",
    "choice_e": "Action items"
  },
  {
    "id": 1010,
    "question": "The communication plan calls for weekly status email updates, monthly status meetings, and semiannual printed newsletters. This plan is laying out which one of the following?",
    "choice_a": "Criticality factors",
    "choice_b": "Types of communication",
    "choice_c": "Level of report detail",
    "choice_d": "Tailor communication style",
    "correct_answer": "B",
    "explanation": "The plan lays out the communication methods as well as the frequency.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      236,
      231,
      259,
      324,
      287
    ],
    "source": "9781119892502"
  },
  {
    "id": 1011,
    "question": "The steering committee sent an announcement to the project team letting them know that only changes to time, money, and scope will require executive review from now on. All other approvals can now be granted by the project manager. What type of organizational change was made?",
    "choice_a": "Project plan",
    "choice_b": "Business process",
    "choice_c": "Risk register",
    "choice_d": "CCB",
    "correct_answer": "B",
    "explanation": "Projects can have business processes just like functional units. This was a change to how a project's business process works.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      294,
      132,
      10,
      125,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 1012,
    "question": "The project sponsor has decided to make a project manager change. Which project-centric document should the incumbent project manager use to get the new project manager up to speed on the project?",
    "choice_a": "Project charter",
    "choice_b": "Action items",
    "choice_c": "Project schedule",
    "choice_d": "Project management plan",
    "correct_answer": "D",
    "explanation": "The project management plan consists of all project planning documents, including the charter, scope statement, schedule, communication plan, and more.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      132,
      12,
      9,
      76
    ],
    "source": "9781119892502"
  },
  {
    "id": 1013,
    "question": "Monty cannot remember what the key performance indicators are to help measure success on the product the project team is creating. Where can Monty find this information?",
    "choice_a": "Issue log",
    "choice_b": "Scope statement",
    "choice_c": "Communication plan",
    "choice_d": "Action items",
    "correct_answer": "B",
    "explanation": "The scope statement is a reference for what the product needs to do, what assumptions and constraints have been identified, and what key performance indicators will be used to track and measure the project's success.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      64,
      67,
      12,
      93,
      9
    ],
    "source": "9781119892502"
  },
  {
    "id": 1014,
    "question": "A project manager meets with an upset team member to listen to their concerns. After hearing their concerns, the project manager maintains business as usual and instructs the team member that they must comply with the rules. The team member agrees to start behaving accordingly. This is an example of which of the following?",
    "choice_a": "Forcing",
    "choice_b": "Compromising",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "A",
    "explanation": "The project manager is forcing the actions of the team member to get compliance. This is not the best technique for team building but may be necessary in temporary situations.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      79,
      77,
      78,
      236,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 1015,
    "question": "The list of items that need to be monitored and/or escalated to minimize the impact on the project team is called what?",
    "choice_a": "Issue log",
    "choice_b": "Action items",
    "choice_c": "Risk register",
    "choice_d": "Budget report",
    "correct_answer": "A",
    "explanation": "Make sure each issue has an identifier, an owner, and a due date to resolve to help keep the project on track.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      78,
      236,
      324,
      82,
      68
    ],
    "source": "9781119892502"
  },
  {
    "id": 1016,
    "question": "The Closing phase of a project serves what critical purpose?",
    "choice_a": "Formal acceptance and turnover to ongoing maintenance and support",
    "choice_b": "Performing governance activities and turnover to ongoing maintenance and support",
    "choice_c": "Formal acceptance and producing deliverables",
    "choice_d": "Performing governance activities and producing deliverables",
    "correct_answer": "A",
    "explanation": "The Closing phase shuts down the project by gaining formal acceptance of project deliverables and then turning over needed activities and service support to ongoing maintenance and support teams.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      11,
      328,
      327,
      334,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 1017,
    "question": "What is the mechanism used to communicate on the status of the project budget?",
    "choice_a": "Expenditure tracking",
    "choice_b": "Expenditure reporting",
    "choice_c": "Budget baseline",
    "choice_d": "Work breakdown structure",
    "correct_answer": "B",
    "explanation": "Expenditure reporting gives feedback in terms of where and how money is being spent on the project. The project manager can then track this feedback against planned spending and against the rate of spending.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      324,
      208,
      321,
      259,
      10
    ],
    "source": "9781119892502"
  },
  {
    "id": 1018,
    "question": "A project manager is having problems with one team member who is being insubordinate. The project manager does not approach the team member and just tries to carry on as business as usual. This is an example of which of the following?",
    "choice_a": "Forcing",
    "choice_b": "Avoiding",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "B",
    "explanation": "Avoiding never results in a resolution and is potentially the least effective technique as nothing gets resolved.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      78,
      83,
      236,
      260,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 1019,
    "question": "In a briefing to the CEO, the project team explains that there is a risk that the company's two biggest competitors might merge. The CEO asks about the likelihood that this will happen. What exactly is she asking for?",
    "choice_a": "A probability and impact matrix",
    "choice_b": "The risk impact",
    "choice_c": "The risk probability",
    "choice_d": "The risk register",
    "correct_answer": "C",
    "explanation": "Although the two companies could merge, the probability that they will do so would yield a score between 0.0 and 1.0 in assessing its likelihood.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      68,
      225,
      102,
      14,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 1020,
    "question": "A project manager listens to the concerns of two team members who are upset with each other. After asking questions, listening, and getting them to talk with each other, the project manager gains agreement on a vested interest for all parties and work resumes. The team members agree to start behaving accordingly. This is an example of which of the following?",
    "choice_a": "Negotiating",
    "choice_b": "Compromising",
    "choice_c": "Confronting",
    "choice_d": "Avoiding",
    "correct_answer": "A",
    "explanation": "This is an example of negotiating. The use of a third party, like the project manager in the question, can help in producing an outcome, and their neutrality can assist in reaching agreement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      83,
      236,
      78,
      76,
      79
    ],
    "source": "9781119892502"
  },
  {
    "id": 1021,
    "question": "When does an item move from the risk register to the issue log?",
    "choice_a": "As soon as the risk as identified",
    "choice_b": "When the risk is triggered",
    "choice_c": "Never",
    "choice_d": "In the creation of the project plan",
    "correct_answer": "B",
    "explanation": "An item moves from the risk register to the issue log when the risk is triggered. A risk becomes an active issue when it is triggered. For instance, if the cost of material starts to rise, it might trigger a budget risk that gets moved to the issue log to be actively managed.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      223,
      225,
      260,
      284,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 1022,
    "question": "Level 1 of the WBS always represents which of the following?",
    "choice_a": "Critical path",
    "choice_b": "Prioritized tasks",
    "choice_c": "Project",
    "choice_d": "Sponsor",
    "correct_answer": "C",
    "explanation": "Level 1 of the WBS is the project level. The first level of decomposition can commonly be the second level of the WBS (deliverables, phases, projects).",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      128,
      84,
      12,
      85,
      76
    ],
    "source": "9781119892502"
  },
  {
    "id": 1023,
    "question": "Acceptance criteria reviews that are used across the project are known as which of the following?",
    "choice_a": "Critical to quality",
    "choice_b": "Quality gates",
    "choice_c": "Kanban boards",
    "choice_d": "Deliverables",
    "correct_answer": "B",
    "explanation": "They are known as quality gates. Predefined acceptance criteria help ensure quality and minimize work. Quality gates can be used in both the Agile and waterfall methods.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      313,
      250,
      69,
      122
    ],
    "source": "9781119892502"
  },
  {
    "id": 1024,
    "question": "Which role of the project is responsible for working to create the deliverables according to the project schedule?",
    "choice_a": "Project stakeholders",
    "choice_b": "Project team members",
    "choice_c": "Project scheduler",
    "choice_d": "Project coordinator",
    "correct_answer": "B",
    "explanation": "Project team members are responsible for producing the deliverables spelled out in the project charter and scope statement.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      10,
      69,
      66,
      84,
      78
    ],
    "source": "9781119892502"
  },
  {
    "id": 1025,
    "question": "Which of the following is defined as anything that restricts or forces the actions of the project team?",
    "choice_a": "A requirement",
    "choice_b": "An assumption",
    "choice_c": "A constraint",
    "choice_d": "An influence",
    "correct_answer": "C",
    "explanation": "A constraint is anything that limits the options of the project team or dictates a specific course of action.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      64,
      66,
      70,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 1026,
    "question": "A project manager is going to conduct a brainstorming exercise to get a list of potential risks on a project. She invites sponsors, core team members, stakeholders, and SMEs. What is a SME?",
    "choice_a": "Service material extract",
    "choice_b": "Service matter expert",
    "choice_c": "Service material expert",
    "choice_d": "Subject matter expert",
    "correct_answer": "D",
    "explanation": "Subject matter experts have expert judgment and experience in the topic or project area that should be consulted.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      18,
      77,
      79,
      78
    ],
    "source": "9781119892502"
  },
  {
    "id": 1027,
    "question": "The architectural design team has completed the blueprints for a new building and communicates this to the project manager. What type of communication trigger is this?",
    "choice_a": "Task completion",
    "choice_b": "Task initiation",
    "choice_c": "Incident response",
    "choice_d": "Resource changes",
    "correct_answer": "A",
    "explanation": "Task completion is communicated to the project manager and/or coordinator so they can signal the next activities to begin.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      236,
      273,
      324,
      287,
      78
    ],
    "source": "9781119892502"
  },
  {
    "id": 1028,
    "question": "When regular project status meetings begin, what elements of the change process should be regularly reviewed? (Choose two.)",
    "choice_a": "Change request log",
    "choice_b": "Risk register",
    "choice_c": "Issue log",
    "choice_d": "Social media",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Communicating changes is a key function of status meetings so that expectations are communicated, input can be gathered, and updated assignments can be given. Issues are discussed so those decisions can be made and actions discussed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      259,
      287,
      294,
      236,
      324
    ],
    "source": "9781119892502"
  },
  {
    "id": 1029,
    "question": "Beau is a project manager who schedules a meeting with subject matter experts to work on activity identification and duration estimation. What triggered this communication?",
    "choice_a": "Milestones",
    "choice_b": "Audit",
    "choice_c": "Scrum retrospective",
    "choice_d": "Project planning",
    "correct_answer": "D",
    "explanation": "A project manager spends up to 90 percent of their time communicating, and coordination during the planning of a project is reliant on high communication.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      81,
      76,
      77,
      236,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 1030,
    "question": "In the development of a project idea, a stakeholder writes down the purpose of the project, what it might cost, and what business value or benefits will be achieved. What is the document being created?",
    "choice_a": "Project description",
    "choice_b": "Business case",
    "choice_c": "Deliverables",
    "choice_d": "Project charter",
    "correct_answer": "B",
    "explanation": "The business case helps to provide justification as to why resources should be assigned to a project and what the return could be on the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      8,
      19,
      65,
      102
    ],
    "source": "9781119892502"
  },
  {
    "id": 1031,
    "question": "DewDrops presents their plan to the CEO where they can decrease defects by 25 percent. The CEO wants to see if they can decrease defects by 75 percent and asks the project team to reanalyze the project. What project variable is the CEO asking them to change?",
    "choice_a": "Quality",
    "choice_b": "Funding",
    "choice_c": "Scope",
    "choice_d": "Risk",
    "correct_answer": "A",
    "explanation": "To achieve drastic a so change in quality might require the project team to look at all aspects of the business: hiring, training, processes, and materials to achieve the CEO's goal.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      66,
      65,
      69,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 1032,
    "question": "What is a set of quantifiable measures that an organization uses to gauge progress toward project goals?",
    "choice_a": "RACI",
    "choice_b": "SWOT",
    "choice_c": "KPI",
    "choice_d": "NDA",
    "correct_answer": "C",
    "explanation": "Key performance indicators are the critical and quantifiable measures needed to track success factors for a project, product, or organization. There should be a limited number of \u201ckey\u201d indicators that need to be tracked.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      67,
      70,
      324,
      203,
      99
    ],
    "source": "9781119892502"
  },
  {
    "id": 1033,
    "question": "At the completion of a meeting, the person who was designated as a scribe will type up their notes along with any decisions that were made and any assignments that were handed out. What type of project-centric document is this?",
    "choice_a": "Action items",
    "choice_b": "Meeting agenda",
    "choice_c": "Status report",
    "choice_d": "Meeting minutes",
    "correct_answer": "D",
    "explanation": "It is critical to create a record of meetings, especially action items and decisions that were made so there is a record for lessons learned and audit purposes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      333,
      12,
      236,
      330,
      11
    ],
    "source": "9781119892502"
  },
  {
    "id": 1034,
    "question": "In which of the following documents would you find information regarding the high-level budget and milestones for the project?",
    "choice_a": "Request for information",
    "choice_b": "Scope statement",
    "choice_c": "Project charter",
    "choice_d": "Action items",
    "correct_answer": "C",
    "explanation": "The project charter will also contain high-level information about assumptions, constraints, and risks. Remember, it also the formal authorization to begin project work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      70,
      66,
      68,
      12,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 1035,
    "question": "A project manager is having problems with one team member who is being insubordinate. The project manager approaches the team member and spells out how the behavior is inappropriate and how the team member will behave from now on. This is an example of which one of the following?",
    "choice_a": "Forcing",
    "choice_b": "Avoiding",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "A",
    "explanation": "The team member is not given a chance to tell their side of the story, and the project manager does not inquire as to why the behavior is happening. These solutions can be short-lived.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      78,
      83,
      236,
      176,
      79
    ],
    "source": "9781119892502"
  },
  {
    "id": 1036,
    "question": "Which tool would you use to create a visual representation of timelines, start dates, durations, and activity sequence?",
    "choice_a": "Process diagram",
    "choice_b": "Pareto chart",
    "choice_c": "Gantt chart",
    "choice_d": "Histogram",
    "correct_answer": "C",
    "explanation": "Named after the American engineer and management consultant, a Gantt chart allows the users to see at a glance information about various activities, activity start and end dates, duration, activity overlaps, and when the project will start and end.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      146,
      145,
      152,
      139,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1037,
    "question": "Which knowledge management tool would be used for a team to communicate instantly, share information on task ownership and status, and see events for an entire work group?",
    "choice_a": "Wiki pages",
    "choice_b": "Intranet sites",
    "choice_c": "Vendor knowledge bases",
    "choice_d": "Collaboration tools",
    "correct_answer": "D",
    "explanation": "Collaboration tools allow for instant messaging, sharing work screens with each other over the network, and other areas, including videoconferencing. A wiki page might be used as a collaboration tool, but the collaboration toolset is much broader than just wiki pages.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      258,
      257,
      235,
      171,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1038,
    "question": "When dealing with a RACI chart, which of the following are true? (Choose three.)",
    "choice_a": "RACI is an acronym for responsible, accountable, consulted, and informed.",
    "choice_b": "RACI is a hierarchical and seniority-based matrix.",
    "choice_c": "RACI is an acronym for reasonable, accountable, conflicted, and informed.",
    "choice_d": "A RACI is matrix-based chart.",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "A RACI chart is a matrix-based chart used to identify roles and responsibilities on a project. It stands for responsible, accountable, consulted, and informed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      171,
      170,
      146,
      154,
      267
    ],
    "source": "9781119892502",
    "choice_e": "A RACI is a form of a SWOT analysis for risk identification.",
    "choice_f": "A RACI is used to identify roles and responsibilities on a project."
  },
  {
    "id": 1039,
    "question": "Once a change request is submitted, where should it be recorded and assigned an identification number for tracking purposes?",
    "choice_a": "Risk register",
    "choice_b": "Issue log",
    "choice_c": "Business process repository",
    "choice_d": "Change request log",
    "correct_answer": "D",
    "explanation": "A change request log can be a simple spreadsheet that has the ID number, date, description, and so forth of the change.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      283,
      316,
      319,
      268,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1040,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf001.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Gantt chart",
    "correct_answer": "A",
    "explanation": "A process diagram is a visual representation of the steps in a process. Other names for process diagrams are process maps and workflow diagrams.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      314,
      138,
      146,
      311,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1041,
    "question": "What is the comprehensive collection of documents that spells out communication, risk management, project schedule, and scope management?",
    "choice_a": "Scope statement",
    "choice_b": "Request for proposal",
    "choice_c": "Project management plan",
    "choice_d": "Dashboard information",
    "correct_answer": "C",
    "explanation": "The project management plan is the collection of plans created to address budget, time, scope, quality, communication, risk, and other project elements.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      130,
      252,
      207,
      283,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1042,
    "question": "Amelia is struggling to get a meeting with a key subject matter expert to gather project requirements within the planned timeframe. Where should this information be recorded?",
    "choice_a": "Communication plan",
    "choice_b": "Issue log",
    "choice_c": "Project schedule",
    "choice_d": "Action items",
    "correct_answer": "B",
    "explanation": "The issue log helps to manage items that need to be monitored and/or escalated to minimize the impact on the project team.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      283,
      252,
      170
    ],
    "source": "9781119892502"
  },
  {
    "id": 1043,
    "question": "Shane is the project manager assigned to a project, and he is creating a graphic that shows the project leads for each subject area along with the resources assigned to them. What type of document is Shane creating?",
    "choice_a": "Communication plan",
    "choice_b": "Pareto diagram",
    "choice_c": "Fishbone diagram",
    "choice_d": "Organizational chart",
    "correct_answer": "D",
    "explanation": "The project organizational chart helps to clarify involvement on the project and can be used to help create a decision-making matrix indicating who has authority to make certain decisions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      171,
      146,
      266,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1044,
    "question": "Which of the following tools is used for entering data to generate a Gantt chart, WBS, or activity sequence automatically?",
    "choice_a": "Process diagram",
    "choice_b": "Scrum retrospective",
    "choice_c": "Collaboration tools",
    "choice_d": "Project scheduling software",
    "correct_answer": "D",
    "explanation": "Standard tools like Microsoft Project or Primavera, plus an exploding market of cloud-based tools, help to automate the creation and updating of the project schedule. More simplistic projects can use Microsoft Excel or a comparable tool.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      146,
      130,
      138,
      139
    ],
    "source": "9781119892502"
  },
  {
    "id": 1045,
    "question": "Which tool provides a visual representation of all of the steps required in a process?",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Project scheduling software",
    "correct_answer": "A",
    "explanation": "Process diagrams are often called workflow diagrams, which show all the steps from start to end in a process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      314,
      138,
      146,
      154,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1046,
    "question": "Which tool would be used to display observed data in a time sequence?",
    "choice_a": "Run chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Scatter diagram",
    "correct_answer": "A",
    "explanation": "Especially valuable at the beginning of a project, a run chart helps identify information about a process before there is enough information to set dependable control limits.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      154,
      212,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1047,
    "question": "During a regular check-in meeting with stakeholders, the project manager presents information on all task areas. Each task area has a column for time, cost, resources, risks, issues, and changes, and each item shows a red, yellow, or green indication representing the condition of each task in each area. What project-centric document is being presented?",
    "choice_a": "Process diagram",
    "choice_b": "Gantt chart",
    "choice_c": "Project dashboard",
    "choice_d": "Run chart",
    "correct_answer": "C",
    "explanation": "A project dashboard is a form of a status report that displays summary information from lots of different areas of the project to present a snapshot of key information for analysis and discussion.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      266,
      252,
      316,
      283,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1048,
    "question": "Earl is a load master for an international shipping company. They have been hired to move construction equipment to a different continent by the end of the month. He is aware that the planes required to carry the largest equipment are currently booked until the end of the month on another assignment. Where should Earl record this information?",
    "choice_a": "Risk register",
    "choice_b": "Action items list",
    "choice_c": "Issue log",
    "choice_d": "Status report",
    "correct_answer": "C",
    "explanation": "The resource conflict with the needed aircraft is an issue that needs to be actively managed, so this would get added to the issue log.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      139,
      283,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1049,
    "question": "A new theater production for Halloween is underway. Josh is the director, Vanessa oversees costuming, Ren is in charge of set construction, and Seth is in charge of marketing and business operations. Where would this information be captured?",
    "choice_a": "Project charter",
    "choice_b": "Communication plan",
    "choice_c": "Project organizational chart",
    "choice_d": "Balanced score card",
    "correct_answer": "C",
    "explanation": "The organizational chart would have a breakdown of the hierarchy for the project and show where the assignments are for each project function and resource.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      170,
      130,
      152,
      146,
      139
    ],
    "source": "9781119892502"
  },
  {
    "id": 1050,
    "question": "Vanina has taken over as the project manager for a large complex project. She has worked with the project team to get updated status and start dates on tasks. What tool would she use to turn this information into updated reports?",
    "choice_a": "Kanban board",
    "choice_b": "Project scheduling software",
    "choice_c": "Intranet sites",
    "choice_d": "Vendor knowledge bases",
    "correct_answer": "B",
    "explanation": "Some projects become impossible to manage without the aid of software to help keep track of information and automate the various reports the stakeholders require.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      266,
      257,
      212,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1051,
    "question": "A team that is geographically dispersed has the need to work on documents together and to have more tools than phone calls by which they can communicate. What is a good option for them to consider using?",
    "choice_a": "Wiki pages",
    "choice_b": "Intranet sites",
    "choice_c": "Vendor knowledge bases",
    "choice_d": "Collaboration tools",
    "correct_answer": "D",
    "explanation": "Collaboration tools would allow screen sharing, joint document editing, video calls, and joint document sharing, task lists, and calendars.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      258,
      235,
      252,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1052,
    "question": "A long meeting is taking place to document all of the steps that have been taken to build a house in order to try to find improvement opportunities. What type of deliverable will be created?",
    "choice_a": "Gantt chart",
    "choice_b": "Histogram",
    "choice_c": "Process diagram",
    "choice_d": "Pareto chart",
    "correct_answer": "C",
    "explanation": "A process diagram can be used in two forms: mapping the processes as they are, and then reworking them to how they should be.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      314,
      311,
      146,
      138,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1053,
    "question": "At a gate check meeting, the committee is presented with a report that shows health in different areas of a project: Schedule = Green, Budget = Yellow, Scope = Green, Risk =Yellow, and Publicity = Red. What type of tool is the committee looking at?",
    "choice_a": "Collaboration tool",
    "choice_b": "Scatter chart",
    "choice_c": "Pareto chart",
    "choice_d": "Balanced scorecard",
    "correct_answer": "D",
    "explanation": "This document is showing values from a variety of different areas on the project to show a balanced view of the project.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      322,
      213,
      212,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1054,
    "question": "During a project meeting, a key stakeholder looks at a report and sees that the schedule now has a yellow setting when last week it was set at green. What kind of data is the stakeholder viewing?",
    "choice_a": "Dashboard information",
    "choice_b": "Fishbone diagram",
    "choice_c": "Project management plan",
    "choice_d": "Risk register",
    "correct_answer": "A",
    "explanation": "A project dashboard is a form of a status report that will display conditions of different data elements and key performance indicators to communicate the progress and challenges of the project.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      266,
      322,
      212,
      152,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1055,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf002.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Gantt chart",
    "correct_answer": "B",
    "explanation": "<!--?sup Start?-->According to <i>A Guide to the Project Management Body of Knowledge</i> (<i>PMBOK</i><sup>\u00ae</sup> <i>Guide</i>), Sixth Edition, a histogram is a special form of a bar chart used to describe central tendency, dispersion, and shape of a statistical distribution.<!--?sup End?-->",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      314,
      146,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1056,
    "question": "Which tool would we use to create a regression line to forecast how the change in an independent variable will change a dependent variable?",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Scatter chart",
    "correct_answer": "D",
    "explanation": "A scatter chart can also be called a scatter diagram and is used to help identify a correlation between the dependent and independent variables.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      311,
      310,
      145,
      322,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1057,
    "question": "What kind of tool would automate the creation of critical path, float, WBS, and activity sequence?",
    "choice_a": "Project scheduling software",
    "choice_b": "SIPOC-R",
    "choice_c": "PERT",
    "choice_d": "Run chart",
    "correct_answer": "A",
    "explanation": "Use of software can increase the amount of time during setup but can save lots of time in managing the project in later phases.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      152,
      146,
      138,
      130,
      145
    ],
    "source": "9781119892502"
  },
  {
    "id": 1058,
    "question": "Roy is struggling with several issues on a project that are overwhelming productivity. He wants to see which issues are causing the biggest disruption to the project. Which tool should he use?",
    "choice_a": "Histogram",
    "choice_b": "Pareto chart",
    "choice_c": "Run chart",
    "choice_d": "Scatter chart",
    "correct_answer": "B",
    "explanation": "A Pareto chart shows the values in a bar chart in descending order from left to right, and then adds a line chart to show the cumulative score. This will allow the analyst to see which issues are causing 80 percent of the disruption and focus on them first.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      310,
      311,
      316,
      266,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1059,
    "question": "A subject matter expert on a project has been monitoring the distribution of support calls received each hour during the day to determine staffing needs for a project. Which tool is this person most likely using?",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Run chart",
    "choice_d": "Gantt chart",
    "correct_answer": "B",
    "explanation": "Most likely, this analyst is using a histogram, which would be used to show the frequencies of problem causes to help understand what is needed for preventive or corrective action.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      310,
      311,
      266,
      212,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1060,
    "question": "Which type of tool would auto-calculate task duration and planned effort by task, and allow for assignment and reassignment of resources?",
    "choice_a": "PERT",
    "choice_b": "SIPOC-R",
    "choice_c": "Project scheduling software",
    "choice_d": "Histograms",
    "correct_answer": "C",
    "explanation": "Project scheduling software, especially for complex projects, can aid in the ease of tracking data and producing reports. Remember, there is a learning curve for all users whenever a new software tool is introduced on a project.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      152,
      146,
      139,
      207,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1061,
    "question": "A large, global project to create a new movie has over a thousand individuals assigned to the project. The project manager needs to find out which individuals are working with the second production unit. Which project-centric document would help give her this information?",
    "choice_a": "Organizational chart",
    "choice_b": "RACI matrix",
    "choice_c": "Fishbone diagram",
    "choice_d": "Project charter",
    "correct_answer": "A",
    "explanation": "The organizational chart describes the project team member organization and identifies reporting structures.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      170,
      171,
      146,
      130,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1062,
    "question": "The field team sends an update to the project manager letting him know that there were 12 employees at the project site, there were no accidents this week and no issues to report, and that the team is tracking toward on-time completion of their work. The project manager adds this information in a box on a report. What would you call this data provided to the project manager's report?",
    "choice_a": "Action items",
    "choice_b": "Dashboard information",
    "choice_c": "Organization chart",
    "choice_d": "Project management plan",
    "correct_answer": "B",
    "explanation": "A dashboard is either an electronic or paper report that shows lots of information in the format of a dashboard display with different \u201cinstrumentation panels\u201d showing key performance information from different project areas.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      266,
      213,
      322,
      212,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1063,
    "question": "JoAnn has been tasked with tracking the production data for a prototype product for the first three months in order to ensure that it meets the forecast for quality. Which tool should she use for this analysis?",
    "choice_a": "Pareto chart",
    "choice_b": "Run chart",
    "choice_c": "Fishbone",
    "choice_d": "Wiki pages",
    "correct_answer": "B",
    "explanation": "A run chart, or a run-sequence plot, creates a graph that displays observed data over a period of time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      307,
      154,
      267,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1064,
    "question": "Which knowledge management tools allow users to freely create and edit web page content using a web browser?",
    "choice_a": "Intranet sites",
    "choice_b": "Wiki knowledge base",
    "choice_c": "Collaboration tools",
    "choice_d": "Internet sites",
    "correct_answer": "B",
    "explanation": "Famous sites like Wikipedia are examples of simple web tools that allow users to create content for websites. Often, content can mean the difference between a popular website and one that doesn't get much web traffic.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      258,
      235,
      252,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1065,
    "question": "Sasha is in a project meeting where a major risk was revealed to be impacting the project. Sasha's boss is in another meeting for the rest of the day, but she needs to provide a detailed update to her boss as quickly as possible. What would be the best method to communicate with Sasha's boss?",
    "choice_a": "Email",
    "choice_b": "Distribution of printed media",
    "choice_c": "Instant messaging",
    "choice_d": "Text message",
    "correct_answer": "A",
    "explanation": "When schedules do not align, and there is a need to share a detailed message about what is going on, what is being done to address an issue, and what alternatives are available, an email would be the superior way to share the information. The next day, it would also be okay to follow up with an in-person meeting to make sure the boss received the information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      252,
      283,
      258,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1066,
    "question": "Wigit Construction is about to begin a project phase replacing a bridge over a major highway. The work will require the highway to be closed at night for several weeks. What is the most appropriate communication method to share these outages with the public?",
    "choice_a": "Enterprise social media",
    "choice_b": "Impromptu meeting",
    "choice_c": "Instant messaging",
    "choice_d": "Email",
    "correct_answer": "A",
    "explanation": "Enterprise social media would allow for broad notices to go out to the general public, including traditional forms of media to let everyone know of the work and closed highway. An enterprise social media strategy helps to build a more substantial brand presence for an organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      235,
      258,
      283,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1067,
    "question": "After establishing the product backlog, what tool would you use to determine the project's velocity?",
    "choice_a": "Burndown chart",
    "choice_b": "Fishbone diagram",
    "choice_c": "Kanban board",
    "choice_d": "Sprint speed",
    "correct_answer": "A",
    "explanation": "The burndown chart is a visual representation and measurement tool showing the completed work against a time interval to forecast project completion.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      267,
      154,
      322,
      145,
      146
    ],
    "source": "9781119892502"
  },
  {
    "id": 1068,
    "question": "The cybersecurity team has been reviewing the security logs and has discovered a potential vulnerability in the software that a project team is developing. The team suggests remediation. What type of communication trigger is this?",
    "choice_a": "Audit",
    "choice_b": "Gate review",
    "choice_c": "Schedule change",
    "choice_d": "Business continuity response",
    "correct_answer": "A",
    "explanation": "A review by an internal team, such as security or even an internal audit division, is an audit with a recommendation to fix the finding.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      316,
      283,
      235,
      258
    ],
    "source": "9781119892502"
  },
  {
    "id": 1069,
    "question": "What is a graphical representation that shows how much money is left to be spent on a project?",
    "choice_a": "Program Evaluation Review Technique (PERT) chart",
    "choice_b": "Milestone chart",
    "choice_c": "Budget burndown chart",
    "choice_d": "Project network diagram",
    "correct_answer": "C",
    "explanation": "A budget burndown chart is a tool used to see how much budget is remaining on the project and how much time there is to spend it. Often using graphical representation can help convey the status of a project better than a written report.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      213,
      266,
      322,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1070,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf003.png\"/>",
    "choice_a": "Program Evaluation Review Technique (PERT) chart",
    "choice_b": "Gantt chart",
    "choice_c": "Project dashboard",
    "choice_d": "Budget burndown chart",
    "correct_answer": "A",
    "explanation": "This is an example of a PERT chart. A PERT chart is a graphical depiction of the project's timeline and helps to identify task dependencies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      146,
      138,
      152,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1071,
    "question": "Which tool provides a visual representation of all the steps required in a process?",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Project scheduling software",
    "correct_answer": "A",
    "explanation": "Process diagrams create visualizations of the different steps needed in any process, typically created as a flowchart.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      314,
      138,
      146,
      154,
      311
    ],
    "source": "9781119892502"
  },
  {
    "id": 1072,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf004.png\"/>",
    "choice_a": "PERT chart",
    "choice_b": "Pareto chart",
    "choice_c": "Milestone chart",
    "choice_d": "Velocity chart",
    "correct_answer": "C",
    "explanation": "This is a milestone chart, which marks the most important steps in the project and the dates they are targeted to be completed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      145,
      152,
      212,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1073,
    "question": "What is a collaboration tool allowing online participants to visually create and share ideas?",
    "choice_a": "Enterprise social media",
    "choice_b": "Whiteboard",
    "choice_c": "SMS",
    "choice_d": "Wiki knowledge base",
    "correct_answer": "B",
    "explanation": "Whiteboarding apps try to simulate the power of using dry erase markers on an actual whiteboard helping to brainstorm and communicate ideas.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      235,
      266,
      252,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1074,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf005.png\"/> <p></p>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Fishbone diagram",
    "correct_answer": "D",
    "explanation": "A fishbone diagram, also called an Ishikawa diagram, is a visualization tool for categorizing the potential causes of a problem in order to identify its root causes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      154,
      267,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1075,
    "question": "The issue log would capture all the following data components EXCEPT:",
    "choice_a": "Issue description",
    "choice_b": "Owner",
    "choice_c": "Mitigation",
    "choice_d": "Due date",
    "correct_answer": "C",
    "explanation": "Mitigation is associated with the prediction and response to risk, whereas an issue log tracks active incidents. A correct answer could be tracking what action is to be taken.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      316,
      319,
      310,
      322,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1076,
    "question": "Which is a special form of a bar chart that visually displays the central tendency, dispersion, and distribution for statistical data?",
    "choice_a": "Kanban board",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "SIPOC-R",
    "correct_answer": "B",
    "explanation": "A histogram chart can be used to show the frequencies of problem causes to help understand what is needed for preventive or corrective action.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      310,
      311,
      314,
      146,
      154
    ],
    "source": "9781119892502"
  },
  {
    "id": 1077,
    "question": "Nathan is a software game developer assigned to a project to create a revolutionary new virtual reality game. He receives notice that he is to attend a meeting and give a presentation for 45 minutes on the capabilities of the technology that they will be using. Which document did Nathan receive that communicated this requirement?",
    "choice_a": "Meeting agenda",
    "choice_b": "Meeting minutes",
    "choice_c": "Action items",
    "choice_d": "Wiki pages",
    "correct_answer": "A",
    "explanation": "Publishing a meeting agenda and disseminating it in advance allows for team members to be prepared, allows meetings to be on time and focused, and improves the use of team members' scarce time on a project. Depending on the type of meeting, agendas can be part of a printed packet of materials for the participants.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      239,
      252,
      235,
      258,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1078,
    "question": "Mickey is in a project meeting where a risk trigger was identified that will need resolution. Mickey's boss is in another meeting for the rest of the day, but he wants to give a brief update as quickly as possible. What would be the best method to communicate with Mickey's boss?",
    "choice_a": "Enterprise social media",
    "choice_b": "Impromptu meeting",
    "choice_c": "Text messaging",
    "choice_d": "Distribution of printed media",
    "correct_answer": "C",
    "explanation": "Text messaging allows Mickey's boss to get an update in the middle of another meeting, and if deemed important enough, allows them to step out of the meeting to get more information.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      258,
      235,
      252,
      283,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1079,
    "question": "The DewDrops project team is conducting a remote meeting to brainstorm ideas for a new application. The team is stuck in their discussion and needing to work freeform to diagram the relationship between different functions. Which is the best tool for the team to use?",
    "choice_a": "Fishbone diagrams",
    "choice_b": "Decision tree",
    "choice_c": "Task board",
    "choice_d": "Whiteboard",
    "correct_answer": "D",
    "explanation": "A whiteboarding tool can help in this process through drawing and other tools just like on a real whiteboard. Drawing a chart or a relationship can help stimulate ideas, visually leading to improved creativity sessions.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      258,
      235,
      257,
      311,
      138
    ],
    "source": "9781119892502"
  },
  {
    "id": 1080,
    "question": "Which of the following are communication triggers? (Choose three.)",
    "choice_a": "Milestones",
    "choice_b": "Task initiation or completion",
    "choice_c": "Resource changes",
    "choice_d": "Technological factors",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Technological factors, times zones, and interorganizational differences are examples of communication methods rather than triggers that would initiate communication to occur. Examples of communication triggers include audits, project planning, project change, risk register updates, milestones, schedule changes, task initiation/completion, stakeholder changes, gate reviews, business continuity response, incident response, and resource changes.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      252,
      283,
      316,
      319,
      146
    ],
    "source": "9781119892502",
    "choice_e": "Time zones",
    "choice_f": "Interorganizational differences"
  },
  {
    "id": 1081,
    "question": "A project team tasked with creating a new software application has discovered that the programming needed is twice as complex as they thought it would be, and they have informed the project manager that they will need more resources or will need to push the due date out by two months. Where would this topic get recorded in project documentation?",
    "choice_a": "Project charter",
    "choice_b": "Issue log",
    "choice_c": "Action items",
    "choice_d": "Risk register",
    "correct_answer": "B",
    "explanation": "The issue log will keep a unique identifier for each issue along with a description of the issue, owner, and due date.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      283,
      213,
      170
    ],
    "source": "9781119892502"
  },
  {
    "id": 1082,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf006.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Gantt chart",
    "correct_answer": "C",
    "explanation": "A Pareto chart contains both a line graph and bars where the individual values are represented in descending order by the bars, and the cumulative total is represented by the line.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      212,
      267,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1083,
    "question": "Which of the following is an electronic reporting tool where users can choose elements of the project to monitor project health and status?",
    "choice_a": "Kanban board",
    "choice_b": "Project scheduling software",
    "choice_c": "Vendor knowledge bases",
    "choice_d": "Dashboard information",
    "correct_answer": "D",
    "explanation": "Dashboards allow for the users to select which elements to display and be reported on. Note: For the exam, look for the electronic delivery of information, but remember nondynamic dashboards can be effective in meetings as one-page brief sheets.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      266,
      152,
      322,
      213,
      212
    ],
    "source": "9781119892502"
  },
  {
    "id": 1084,
    "question": "Emily has logged into the project website and is looking at various elements of the project health and status. What kind of project-centric documentation is Emily looking at?",
    "choice_a": "Meeting minutes",
    "choice_b": "Project management plan",
    "choice_c": "Action items",
    "choice_d": "Dashboard information",
    "correct_answer": "D",
    "explanation": "A dashboard gives a snapshot of many different elements of the project in \u201cinstrumentation panels\u201d on a screen. A dashboard does not have to be electronic, and a single-page, printed dashboard can be an effective communication method.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      212,
      322,
      146,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1085,
    "question": "A project has a team member who routinely is not showing up to meetings or completing assignments. The appropriate place to capture this would be where?",
    "choice_a": "Change request log",
    "choice_b": "Issue log",
    "choice_c": "Risk register",
    "choice_d": "WBS",
    "correct_answer": "B",
    "explanation": "This is an example of an issue that should be captured in the issue log, and then the project manager should address the issue with the individual or the functional manager.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      171,
      252,
      170
    ],
    "source": "9781119892502"
  },
  {
    "id": 1086,
    "question": "What is the only role in a RACI matrix that can only be assigned once per task?",
    "choice_a": "Responsible",
    "choice_b": "Accountable",
    "choice_c": "Consulted",
    "choice_d": "Informed",
    "correct_answer": "B",
    "explanation": "There can be one, and only one, person who is accountable per task in a RACI matrix.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      171,
      170,
      130,
      316,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1087,
    "question": "A change control template should include all of the following, EXCEPT:",
    "choice_a": "The change that is requested",
    "choice_b": "The reason for the change",
    "choice_c": "The executive sponsor of the change",
    "choice_d": "What will happen if the change is not made",
    "correct_answer": "C",
    "explanation": "Anyone working on or associated with the project can submit a change that is then reviewed by a change control board or other process. As such, an executive sponsor is not needed for a change request.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      283,
      316,
      319,
      171,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1088,
    "question": "Which type of chart or diagram is used to represent visually the cause and effect of potential problems to help identify their root causes?",
    "choice_a": "Pareto chart",
    "choice_b": "Histogram",
    "choice_c": "Process diagram",
    "choice_d": "Fishbone diagram",
    "correct_answer": "D",
    "explanation": "Also called Ishikawa diagrams based on the causality diagrams created by Kaoru Ishikawa, fishbone diagrams are a tool to show causes of specific events.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      314,
      310,
      307,
      319
    ],
    "source": "9781119892502"
  },
  {
    "id": 1089,
    "question": "DewDrops is wondering about the timeliness of their checkout process. Danielle has been tasked with creating a tool to track and display this observed data. What output should she create?",
    "choice_a": "Pareto chart",
    "choice_b": "Histogram",
    "choice_c": "Run chart",
    "choice_d": "Scatter diagram",
    "correct_answer": "C",
    "explanation": "Especially valuable at the beginning of a project, a run chart helps identify information about a process before there is enough information to set dependable control limits.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      154,
      212,
      267,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1090,
    "question": "Andy is doing a review of a list that contains active problems on the project, their status, owner, and a due date to get resolution. Which project-centric document is Andy looking at?",
    "choice_a": "Issue log",
    "choice_b": "Organizational chart",
    "choice_c": "Action items",
    "choice_d": "Status report",
    "correct_answer": "A",
    "explanation": "The issue log is a list of issues that contains list numbers, descriptions, and the other attributes listed in the question.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      316,
      319,
      283,
      171,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1091,
    "question": "Interpersonal conflicts are starting to develop on a project. What is the best communication method to use when confronting the problem?",
    "choice_a": "Instant messaging",
    "choice_b": "Videoconferencing",
    "choice_c": "Face-to-face meetings",
    "choice_d": "Email",
    "correct_answer": "C",
    "explanation": "Face-to-face meetings, or in-person meetings, are the superior choice for working on conflict resolution, giving performance appraisals, and working on team building.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      252,
      258,
      316,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1092,
    "question": "An airline engineering company is forced to cut the project budget after poor financial results in the previous quarter. How would this most likely impact the project?",
    "choice_a": "The project is postponed due to lack of finincial resources.",
    "choice_b": "The project scope is cut back to operate within the new budget.",
    "choice_c": "The project will take longer because the number of resources is cut.",
    "choice_d": "The project team goes to the steering committee for more funds.",
    "correct_answer": "B",
    "explanation": "The project scope that is cut back to operate within the new budget is the most likely impact to this project. The schedule would not be impacted as there is no call to lengthen or shorten the project time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      130,
      207,
      283,
      322,
      152
    ],
    "source": "9781119892502"
  },
  {
    "id": 1093,
    "question": "When considering a basic communication model, what are the basic elements that are needed? (Choose three.)",
    "choice_a": "Receiver",
    "choice_b": "Transmission",
    "choice_c": "Inbox",
    "choice_d": "Non-verbal communication",
    "correct_answer": [
      "A",
      "E",
      "F"
    ],
    "explanation": "The basic communication model is sender-message-receiver. This model reflects how all communication exchange occurs.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      252,
      235,
      258,
      283,
      257
    ],
    "source": "9781119892502",
    "choice_e": "Sender",
    "choice_f": "Message",
    "choice_g": "Decoder"
  },
  {
    "id": 1094,
    "question": "Which type of cost estimating uses a mathematical model to compute costs?",
    "choice_a": "Top-down estimating",
    "choice_b": "Bottom-up estimating",
    "choice_c": "Parametric estimating",
    "choice_d": "Three-point estimating",
    "correct_answer": "C",
    "explanation": "Parametric estimating often uses a quantity of work multiplied by the rate formula for computing costs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      207,
      322,
      212,
      213,
      186
    ],
    "source": "9781119892502"
  },
  {
    "id": 1095,
    "question": "A team is not going to finish a project by the assigned date, and it has asked that three more members be assigned to the work so that the date can be achieved. This is an example of which one of the following?",
    "choice_a": "Issue",
    "choice_b": "Risk",
    "choice_c": "Change",
    "choice_d": "Milestone",
    "correct_answer": "C",
    "explanation": "The addition of more resources, the modification of scope, or the adjustment of the timeline are examples of some of the changes that might be requested.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      283,
      322,
      146,
      139,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1096,
    "question": "When a change is being considered, the change control board wants to know how the changes can be reversed if needed. What is this called?",
    "choice_a": "Requirements change",
    "choice_b": "Validation",
    "choice_c": "Version control",
    "choice_d": "Regression plan",
    "correct_answer": "D",
    "explanation": "A regression plan, or rollback plan, will identify the steps and level of effort to return to the original state.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      283,
      316,
      268,
      319,
      332
    ],
    "source": "9781119892502"
  },
  {
    "id": 1097,
    "question": "What are the three types of estimates used in three-point estimates?",
    "choice_a": "Fastest Schedule, Least Resources, Most Desirable",
    "choice_b": "Most Likely, Optimistic, and Pessimistic",
    "choice_c": "Most Likely, Least Resources, Fastest Schedule",
    "choice_d": "Fastest Schedule, Optimistic, Most Desirable",
    "correct_answer": "B",
    "explanation": "The three types are Most Likely, Optimistic, and Pessimistic. The formula is (Most Likely + Optimistic + Pessimistic) / 3. This calculation generates an average of these estimates, providing a single expected estimate to use for planning purposes.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      145,
      152,
      146,
      138,
      139
    ],
    "source": "9781119892502"
  },
  {
    "id": 1098,
    "question": "All of the following would be the recipients of the communication in a risk register update EXCEPT:",
    "choice_a": "Project manager",
    "choice_b": "PMO",
    "choice_c": "Project sponsor",
    "choice_d": "Project team",
    "correct_answer": "B",
    "explanation": "The project management office offers standardization for a project but typically does not get involved in the details of individual projects.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      283,
      171,
      170,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1099,
    "question": "Which tool would be used to help find the distribution of issues (or other variable) from highest to lowest as bars on a chart?",
    "choice_a": "Scatter chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Run chart",
    "correct_answer": "C",
    "explanation": "The Pareto Principle implies that 20 percent of problems take up 80 percent of a team's time to deal with them. A Pareto chart is both a bar and a line chart that shows the largest concentration of values from greatest to smallest.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      314,
      154,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1100,
    "question": "Analogous estimating is where the cost-estimate is developed by which of the following?",
    "choice_a": "Using a mathematical model to compute costs for the project",
    "choice_b": "Calculating the cost of each activity in the work breakdown structure",
    "choice_c": "Using a similar, past project to develop a high-level estimate",
    "choice_d": "Averaging three different estimates of the project cost",
    "correct_answer": "C",
    "explanation": "Using a similar, past project to develop a high-level estimate, this type of estimating can also be called an order-of-magnitude estimate.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      207,
      145,
      212,
      322,
      152
    ],
    "source": "9781119892502"
  },
  {
    "id": 1101,
    "question": "Money actually spent for a specific timeframe for complete work is known as which of the following?",
    "choice_a": "Cost variance",
    "choice_b": "Planned value",
    "choice_c": "Actual cost",
    "choice_d": "Earned value",
    "correct_answer": "C",
    "explanation": "It is known as actual cost. This may include both direct and indirect costs but must correspond to the budget for the activity.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      322,
      212,
      207,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1102,
    "question": "Which type of cost estimating is done by assigning a cost estimate to each work package in the project?",
    "choice_a": "Top-down estimating",
    "choice_b": "Bottom-up estimating",
    "choice_c": "Parametric estimating",
    "choice_d": "Three-point estimating",
    "correct_answer": "B",
    "explanation": "The type is bottom-up estimating. By beginning at the work package level of the WBS, cost for each activity is calculated and assigned to that work package.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      130,
      207,
      212,
      145,
      146
    ],
    "source": "9781119892502"
  },
  {
    "id": 1103,
    "question": "Analogous estimating is also referred to as which of the following?",
    "choice_a": "Top-down estimating",
    "choice_b": "Bottom-up estimating",
    "choice_c": "Parametric estimating",
    "choice_d": "Three-point estimating",
    "correct_answer": "A",
    "explanation": "Top-down estimating, or analogous estimating, is where high-level project cost estimates are used by comparing to a comparable project from the past.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      207,
      212,
      213,
      322,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1104,
    "question": "Earned value is an indication of which of the following?",
    "choice_a": "The actual cost of completing work in a specific timeframe",
    "choice_b": "The cost of work that has been authorized and budgeted",
    "choice_c": "The value of the work completed to date compared to the budgeted amount",
    "choice_d": "The total sum of sales earned at project completion",
    "correct_answer": "C",
    "explanation": "The value of the work completed to date compared to the budgeted amount. This number is expressed as a percentage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      213,
      212,
      310,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1105,
    "question": "A construction company is in the middle of a project to build a guest room on a house. The EV value for the project is $7,000, and the actual cost for the project is $9,500. Select the CV for the project and its meaning.",
    "choice_a": "$2,500 and the project is under-budget",
    "choice_b": "$\u20132,500 and the project is under-budget",
    "choice_c": "$2,500 and the project is over-budget",
    "choice_d": "$\u20132,500 and the project is over-budget",
    "correct_answer": "D",
    "explanation": "The formula for calculating CV is: CV = EV \u2013 AC. Accordingly, the correct answer is $\u20132,500 and the project is over-budget. A positive Cost Variance (CV) means the project is under-budget, and a negative CV means the project is over budget. 7,000 \u2013 9,500 = \u20132,500; therefore the project is over-budget.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      322,
      213,
      212,
      310,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1106,
    "question": "Which of the following is the measure of the cost efficiency of budgeted resources, expressed as a ratio?",
    "choice_a": "AC",
    "choice_b": "EV",
    "choice_c": "CPI",
    "choice_d": "SPI",
    "correct_answer": "C",
    "explanation": "CPI (cost performance index) is an important index, since it tells you the cost efficiency for the work completed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      213,
      212,
      266,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1107,
    "question": "What is the indication of how fast a project is spending its budget?",
    "choice_a": "Fast-tracking",
    "choice_b": "Expenditure tracking",
    "choice_c": "Crashing",
    "choice_d": "Burn rate",
    "correct_answer": "D",
    "explanation": "The burn rate is how fast the project is spending its allotted budget, or how fast the rate money is being expended over a period of time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      213,
      322,
      267,
      154
    ],
    "source": "9781119892502"
  },
  {
    "id": 1108,
    "question": "A project manager for a distributed project team has been gathering a batch of routine organizational messages, project updates, and status reports. What would be the best communication method with which to share this information?",
    "choice_a": "Videoconference",
    "choice_b": "Impromptu meeting",
    "choice_c": "Email",
    "choice_d": "Scheduled meeting",
    "correct_answer": "C",
    "explanation": "If the team is not collocated, routine announcements and updates can be distributed via email as a weekly newsletter or something comparable. Some organizations use collaboration software like Microsoft SharePoint where there is a list of all updates posted as they are gathered and the audience is invited back to read the update.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      257,
      252,
      258,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1109,
    "question": "The published schedule for a project has a filename of <code>ProjectSchedule_v1</code>. The project manager makes an update to the file, and it now is called <code>ProjectSchedule_v2</code>. This is an example of which one of the following?",
    "choice_a": "Version control",
    "choice_b": "Communicating changes",
    "choice_c": "Change request logs",
    "choice_d": "Risk register",
    "correct_answer": "A",
    "explanation": "Using an incremental naming convention is a great way to keep track of versions. Also don't forget to make updates within the document itself to capture the version and the changes made in that version.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      268,
      332,
      283,
      152,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1110,
    "question": "Andy is a project manager for a collocated team, and he just received a mandate from Human Resources (HR) about a lack of compliance from the project team. HR informs Andy that the compliance is important to meet federal law. What type of communication method should Andy use to get this information out to the team?",
    "choice_a": "Videoconference",
    "choice_b": "Impromptu meeting",
    "choice_c": "Email",
    "choice_d": "Scheduled meeting",
    "correct_answer": "C",
    "explanation": "Due to the compliance nature of this topic, the need to have formal documentation of this communication is needed. As such, both sending an email explaining the compliance requirement and asking for an email in return acknowledging receipt and understanding will help create an audit trail.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      235,
      252,
      268,
      283,
      332
    ],
    "source": "9781119892502"
  },
  {
    "id": 1111,
    "question": "All of the following are cost-estimating techniques EXCEPT:",
    "choice_a": "Bottom-up estimating",
    "choice_b": "Program Evaluation and Review Technique (PERT)",
    "choice_c": "Parametric estimating",
    "choice_d": "Analogous estimating",
    "correct_answer": "B",
    "explanation": "Program Evaluation and Review Technique (PERT) is a statistical tool used to analyze and represent tasks, not costs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      207,
      213,
      212,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1112,
    "question": "Carl is the president of a binding company that won the job to bind the books for a new young adult novel. The publishing company needs 100,000 books delivered in 12 days. At the end of each day, Carl asks for the completed number of books to make sure that it is at 8,333 or higher. What does this number represent?",
    "choice_a": "MOU",
    "choice_b": "AC",
    "choice_c": "SPI",
    "choice_d": "KPI",
    "correct_answer": "D",
    "explanation": "A key performance indicator to meet the publisher's target is to complete 1/12 of the books each day, which would be 8,333. Meeting this target would let Carl know they are on track to complete on time. Missing this number would mean Carl would have to change the speed of the process or add more personnel to add more shifts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      267,
      212,
      310,
      146
    ],
    "source": "9781119892502"
  },
  {
    "id": 1113,
    "question": "A systematic and independent examination of project procedures, documentation, spending, statutory compliance, and reporting is known as which one of the following?",
    "choice_a": "Project change",
    "choice_b": "Scrum retrospective",
    "choice_c": "Gate review",
    "choice_d": "Audit",
    "correct_answer": "D",
    "explanation": "Audits are reviews to obtain evidence to ensure good practices are followed, that the project team is behaving in an ethical and legal fashion, and to ensure there is no fraud, waste, and abuse occurring.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      332,
      213,
      316,
      283,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1114,
    "question": "A project team has scheduled a meeting to discuss a critical milestone that is in danger of being missed. Not all the meeting participants will be near a computer or good network bandwidth for the call. Which of the following is the best tool to conduct the meeting?",
    "choice_a": "Telephone",
    "choice_b": "Video",
    "choice_c": "Face-to-face",
    "choice_d": "",
    "correct_answer": "A",
    "explanation": "The question implies a synchronous discussion needs to take place and video would not be an option because of the technological challenges lists. Therefore, a voice conference call (telephone) would be the best solution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      235,
      252,
      319,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1115,
    "question": "Which tool should a project team use to identify in what areas people are spending their efforts and how long it is taking to complete tasks?",
    "choice_a": "Kanban board",
    "choice_b": "Time-tracking tools",
    "choice_c": "Version control tools",
    "choice_d": "Requirements traceability matrix",
    "correct_answer": "B",
    "explanation": "Time-tracking tools allow team members to record their time against different work assignments. This allows the project team to compare the actual work effort needed against the planned amount of time they thought the task would take. Time-tracking tools provide visibility to the project manager to ensure the team is working on the right tasks in the right order.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      146,
      267,
      266,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1116,
    "question": "A project team is looking for a tool that allows a visual representation of work and its path toward completion. They want to be able to see upcoming tasks, in-progress tasks, and tasks that are completed. Which tool should they use?",
    "choice_a": "Version control tools",
    "choice_b": "Time-tracking tools",
    "choice_c": "Action items list",
    "choice_d": "Task board",
    "correct_answer": "D",
    "explanation": "A task board will give the team the picture of the work needing to be completed and its status. This can be a physical board if the team is collocated, or an online application.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      267,
      266,
      152,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1117,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf007.png\"/>",
    "choice_a": "Burndown chart",
    "choice_b": "Run chart",
    "choice_c": "Fishbone/Ishikawa diagram",
    "choice_d": "Requirements traceability matrix",
    "correct_answer": "D",
    "explanation": "A requirements traceability matrix maps and traces user requirements with test cases. It consolidates into a single document all requirements proposed by the client and helps validate all requirements are checked via tests cases. This tool helps verify all needed functionality during software testing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      308,
      307,
      310,
      316,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1118,
    "question": "Which project tool allows for automated routing of a document for the collection of approvals and sign-offs?",
    "choice_a": "Requirements traceability matrix",
    "choice_b": "File sharing programs",
    "choice_c": "Workflow and e-signature platforms",
    "choice_d": "Multi-authoring editing software",
    "correct_answer": "C",
    "explanation": "Workflow and e-signature programs are a major innovation to physically routing documents for signature as it allows great speed and visibility to where in the approval process the document is currently in. There may be additional rules in your organization for formal signatures if there is no program to validate the identity of the signatory.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      257,
      235,
      268,
      283,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1119,
    "question": "Dusty is a project manager and has been asked to create a request for proposal (RFP) for the selection of new monitoring software for a solar panel production company. Which of the following is the best tool for the creation of this document?",
    "choice_a": "Word processing",
    "choice_b": "Spreadsheets",
    "choice_c": "Presentations",
    "choice_d": "Charting/diagramming",
    "correct_answer": "A",
    "explanation": "Word processing tools help in the creation and formatting of documents. While it is possible to create additional tables in a spreadsheet or a chart or diagram to be included in the document, the word processing tool is the superior program to bundle all of the information together.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      183,
      187,
      257,
      235,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1120,
    "question": "A project team member needs to record all of their spending so far on the project so they can keep track of where money has been spent and how much budget is remaining. Which office productivity tool is best suited for this function?",
    "choice_a": "Word processing",
    "choice_b": "Spreadsheets",
    "choice_c": "Presentation",
    "choice_d": "Charting/diagramming",
    "correct_answer": "B",
    "explanation": "A spreadsheet is a basic form of a database and allows the use of functions for formatting, counting, and summing for analytical review.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      212,
      207,
      322,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1121,
    "question": "DewDrops has cut over a new software application and they are receiving complaints about functionality not working correctly. What tool should be used to help keep track of these incidents and the needed follow-up?",
    "choice_a": "Kanban board",
    "choice_b": "Calendaring tools",
    "choice_c": "Ticketing/case management systems",
    "choice_d": "Task board",
    "correct_answer": "C",
    "explanation": "A ticketing system helps keep track of users' issues and helps monitor the follow-up and repair of the system as well as communicate status back to the customer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      283,
      235,
      257,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1122,
    "question": "The project team spent a productive meeting working through the process flow for a new module being built for an organization's finance system. They used sticky notes and a whiteboard to map out the process. Which office productivity tool would work best to memorialize the process?",
    "choice_a": "Word processing",
    "choice_b": "Spreadsheets",
    "choice_c": "Presentation",
    "choice_d": "Charting/diagramming",
    "correct_answer": "D",
    "explanation": "A charting or diagramming program like Microsoft Visio helps with stencils and templates for the creation of workflow diagrams, organizational charts, and fishbone diagrams. There are many programs available for such work.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      314,
      311,
      146,
      171,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1123,
    "question": "Which of the following are used to conduct virtual meetings? (Choose two.)",
    "choice_a": "Face-to-face",
    "choice_b": "Impromptu visits",
    "choice_c": "Videoconferencing",
    "choice_d": "Voice conferencing",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "A virtual meeting is where everyone is not in the same location, and the use of technology allows the meeting to occur.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      235,
      252,
      319,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1124,
    "question": "Jane is the CEO of a company, and there is an update of a security breach at a customer site. She needs to be notified immediately. What is the best method to notify her of the problem?",
    "choice_a": "Social media",
    "choice_b": "Face-to-face conversation",
    "choice_c": "Fax",
    "choice_d": "Text message (SMS)",
    "correct_answer": "D",
    "explanation": "The content of the message will often cause you to tailor the method of communication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      235,
      258,
      266,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1125,
    "question": "What factors should be considered when scheduling a video or telephone conference?",
    "choice_a": "Determining whether team members are introverted or extroverted.",
    "choice_b": "Recognition of the different time zones/schedules being used.",
    "choice_c": "Make sure writing materials are available in the room.",
    "choice_d": "Ensuring the meeting room has sufficient seating.",
    "correct_answer": "B",
    "explanation": "Recognize the different time zones/schedules being used. If your project spans multiple time zones and/or there are a variety of schedules being used, take these factors into consideration in scheduling the meeting.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      258,
      139,
      252,
      235,
      146
    ],
    "source": "9781119892502"
  },
  {
    "id": 1126,
    "question": "A project team will have multiple written deliverables requiring review and feedback from subject matter experts, legal, marketing, and enterprise architecture. What tool should be used to help manage all of the feedback?",
    "choice_a": "Issue log",
    "choice_b": "Version control tools",
    "choice_c": "Task board",
    "choice_d": "Time-tracking tools",
    "correct_answer": "B",
    "explanation": "Version control tools help keep track of what state the document is in, who has reviewed it, and what changes were made or recommended, and keeps older revisions for archive purposes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      268,
      257,
      316,
      332,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1127,
    "question": "A project manager has been asked to speak to the board of directors about the progress and status of their project. It is expected there will be visual slides to help tell the story. Which office productivity tool is likely to be used?",
    "choice_a": "Word processing",
    "choice_b": "Spreadsheets",
    "choice_c": "Presentation",
    "choice_d": "Charting/diagramming",
    "correct_answer": "C",
    "explanation": "People retain more information when they both see and hear data points. Presentation software when used properly can amplify the effectiveness of the story and message.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      235,
      266,
      252,
      212,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1128,
    "question": "A project assistant has been asked to get a requirements gathering meeting scheduled with a large group of individuals both internal and external to the company. What type of tools should he use to coordinate everyone's schedule?",
    "choice_a": "Real-time surveys/polling",
    "choice_b": "Calendaring tools",
    "choice_c": "Conferencing platforms",
    "choice_d": "Chat",
    "correct_answer": "B",
    "explanation": "Calendaring tools help everyone to share their availability and sign up for a meeting time that works for them. This can be useful especially if the project requires lots of individual interviews and saves time by giving the open timeslots and letting the receiver choose the best time for them.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      235,
      152,
      257,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1129,
    "question": "A global project team is collaborating on regional requirements related to a new internet product that is being developed. They are in need of a tool that allows them to see each other's work in a central location. Which type of collaboration tool should they use?",
    "choice_a": "Calendaring tools",
    "choice_b": "Real-time, multi-authoring software",
    "choice_c": "Workflow platforms",
    "choice_d": "File sharing platforms",
    "correct_answer": "D",
    "explanation": "File sharing programs like Google Drive, Dropbox, and Microsoft OneDrive can help to store project information in one location and allow multiple members to see the documents. These tools may also have version control built-in to allow multiple authors to check documents out to maintain document integrity.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      257,
      235,
      258,
      268,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1130,
    "question": "In what situations would a project select a local installation of project management scheduling tools? (Choose two).",
    "choice_a": "When working with a geographically centralized project team",
    "choice_b": "When working with a geographically decentralized project team",
    "choice_c": "When there is only a single person or small group of individuals on the project",
    "choice_d": "When there is a large project team with multiple contributors to schedule information",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Licensing costs can also be a contributing factor in determining which approach the team takes to on-premises versus cloud solutions. If there isn't a need to share information across geographic locations and only a small few making edits to the files, a local implementation may make sense. If the project is a part of a larger program or portfolio, then a cloud implementation may make the most sense even if the size of the project is relatively small.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      257,
      258,
      235,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1131,
    "question": "The project adds a consultant to help determine all the steps needed in the invoice payment process for a company. Which tool would the consultant most likely use?",
    "choice_a": "Process diagram",
    "choice_b": "Pareto chart",
    "choice_c": "Project scheduling software",
    "choice_d": "Project charter",
    "correct_answer": "A",
    "explanation": "Process diagrams are often called workflow diagrams, which show all the steps from start to end in a process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      314,
      138,
      146,
      171,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1132,
    "question": "Which of the following tools would you record risks that you identify might impact the project?",
    "choice_a": "RACI chart",
    "choice_b": "Risk register",
    "choice_c": "Risk probability matrix",
    "choice_d": "Issue log",
    "correct_answer": "B",
    "explanation": "The risk register is the tool used to document all potential risk for future analysis and evaluation.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      316,
      283,
      332,
      130,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1133,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf008.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto Chart",
    "choice_d": "Scatter chart",
    "correct_answer": "D",
    "explanation": "A scatter chart pairs numerical data to help the analyst look for a correlation or relationship.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      266,
      267,
      212
    ],
    "source": "9781119892502"
  },
  {
    "id": 1134,
    "question": "What is the list of items that need to be monitored and/or escalated to minimize the impact on the project team?",
    "choice_a": "Scatter chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Run chart",
    "correct_answer": "D",
    "explanation": "Run charts often represent some aspect of the output or performance of a manufacturing or business process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      319,
      252,
      266,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1135,
    "question": "Erik has been doing an analysis to compare any correlation between an independent and dependent variable. He has created a regression line chart to forecast the changes. What has Erik created?",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Scatter chart",
    "correct_answer": "D",
    "explanation": "Plotted points on a scatter chart indicate the type of relationship, or the absence of a relationship, between two variables, one dependent and one independent.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      311,
      310,
      322,
      154,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1136,
    "question": "A software development team is sharing their knowledge and progress by using a web browser to edit a common page. Which knowledge management tool are they using?",
    "choice_a": "Wiki knowledge base",
    "choice_b": "Intranet sites",
    "choice_c": "Internet sites",
    "choice_d": "Collaboration tools",
    "correct_answer": "A",
    "explanation": "Wiki knowledge bases allow users to freely create and edit web page content using a web browser.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      257,
      235,
      268,
      332,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1137,
    "question": "A project team has locations in two different cities, and two team members in the different locations are trying to solve a problem. They use software that allows them to share their screens with each other. What type of knowledge management tool are they using?",
    "choice_a": "Intranet sites",
    "choice_b": "Wiki pages",
    "choice_c": "Collaboration tools",
    "choice_d": "Internet sites",
    "correct_answer": "C",
    "explanation": "Collaboration tools like videoconferencing, screen sharing, and sites that allow for the joint sharing of documents, tasks, and calendars can be invaluable to a project.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      257,
      235,
      252,
      316
    ],
    "source": "9781119892502"
  },
  {
    "id": 1138,
    "question": "WigitCom is starting a marketing company to build interest in a new mobile device. To help promote the product's \u201ccoolness,\u201d they have created a series of funny videos about the product. What would be the best method to communicate these videos?",
    "choice_a": "Enterprise social media",
    "choice_b": "Impromptu meeting",
    "choice_c": "Short message service (SMS)",
    "choice_d": "Email",
    "correct_answer": "A",
    "explanation": "The hope of the marketing campaign is that some of their videos will go viral where it is repeatedly shared and viewed based on virtual \u201cword of mouth.\u201d.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      235,
      258,
      252,
      266,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1139,
    "question": "A road construction company is working on a project to widen 100 miles of road over a six-month period. They are determined to meet the deadline. To do so, they must complete a little over 3.5 miles a week. They start tracking and reporting against this target. What is this an example of?",
    "choice_a": "COQ",
    "choice_b": "KPP",
    "choice_c": "ETC",
    "choice_d": "KPI",
    "correct_answer": "D",
    "explanation": "The 3.5 mile per week target is a key performance indicator to help track the success of a particular project outcome.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      322,
      266,
      154,
      212,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1140,
    "question": "At the completion of a project to implement enterprise software at an organization, the software manufacturer asks the project team to run certain programs that will inspect the number of licenses in use. This is an example of which one of the following?",
    "choice_a": "Project change",
    "choice_b": "Audit",
    "choice_c": "Gate review",
    "choice_d": "Scrum retrospective",
    "correct_answer": "B",
    "explanation": "In the IT world, software audits are routine to see if there is any true up or true down that needs to happen after a large project is complete.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      307,
      187,
      213,
      322,
      332
    ],
    "source": "9781119892502"
  },
  {
    "id": 1141,
    "question": "Rahul has completed his work assignment and is ready to take up a new assignment. He logs on to the team's shared application to update the status of his completed work and to select a new work item. What tool is the team using to help keep track of project work?",
    "choice_a": "Task board",
    "choice_b": "Project scheduling software",
    "choice_c": "Version control tools",
    "choice_d": "Requirements traceability matrix",
    "correct_answer": "A",
    "explanation": "A task board is a visual representation of the status of different tasks that need to be completed during a sprint or project phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      266,
      154,
      319,
      316
    ],
    "source": "9781119892502"
  },
  {
    "id": 1142,
    "question": "Erin is working on a document that includes an item ID, the type and description of the work that is needed, and an ID for the test cases and their status. What type of tool is Erin creating?",
    "choice_a": "Kanban board",
    "choice_b": "Project dashboard",
    "choice_c": "Requirements traceability matrix",
    "choice_d": "Task board",
    "correct_answer": "C",
    "explanation": "A requirements traceability matrix can include additional information such as who designed the test case, whether user acceptance testing has been completed, defects found and their assigned ID, and who has ownership of the test.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      171,
      283,
      310,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1143,
    "question": "Which office productivity tool would you likely use in the creation of a fishbone or Ishikawa figure?",
    "choice_a": "Kanban board software",
    "choice_b": "Charting/diagramming software",
    "choice_c": "Spreadsheet software",
    "choice_d": "Word processing software",
    "correct_answer": "B",
    "explanation": "An application that helps with templates and stencils in the creation or a root cause diagram would be the best choice. Depending on the complexity of the chart you are creating, some presentation software packages will have a simpler diagramming capability.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      314,
      152,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1144,
    "question": "A simple spreadsheet that contains an ID number, risk name, risk description, risk owner, and other elements is known as which one of the following?",
    "choice_a": "Risk response plan",
    "choice_b": "Probability and impact matrix",
    "choice_c": "RACI chart",
    "choice_d": "Risk register",
    "correct_answer": "D",
    "explanation": "The risk register can contain additional elements, including the response plan or where the plan may be located.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      283,
      319,
      171,
      170
    ],
    "source": "9781119892502"
  },
  {
    "id": 1145,
    "question": "Jean is looking at a visual representation of the reporting structures that describe the project team member organization. What project-centric document is she looking at?",
    "choice_a": "Project charter",
    "choice_b": "Project schedule",
    "choice_c": "Organizational chart",
    "choice_d": "Communication plan",
    "correct_answer": "C",
    "explanation": "The organizational chart will spell out who reports to whom and what teams might exist within the project.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      170,
      171,
      146,
      152,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1146,
    "question": "Kim and Bill are co-project managers for a large complex project. They need to calculate and keep track of tasks and due dates, and they must produce reports quickly and accurately. <p>What should they use for this purpose?</p>",
    "choice_a": "Kanban board",
    "choice_b": "Daily Scrum",
    "choice_c": "Project scheduling software",
    "choice_d": "Vendor knowledge bases",
    "correct_answer": "C",
    "explanation": "Project scheduling software can help keep track of start and end dates, keep track of durations, produce Gantt charts, and track progress through the project.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      146,
      145,
      139,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1147,
    "question": "Which type of document would be given to a committee during a gate check?",
    "choice_a": "Status report",
    "choice_b": "Communication plan",
    "choice_c": "Pareto chart",
    "choice_d": "Project scheduling software",
    "correct_answer": "A",
    "explanation": "To help determine whether the project should move forward, a status report would give a snapshot of the work done to date, the status of budget and schedule, and issues facing the project.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      213,
      252,
      322,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1148,
    "question": "Scott and his team of network engineers have been working through of list of risks and developing counter actions should those risks appear during the course of a project. They are working on which one of the following?",
    "choice_a": "Risk register",
    "choice_b": "Risk response plan",
    "choice_c": "Probability and impact matrix",
    "choice_d": "RACI chart",
    "correct_answer": "B",
    "explanation": "Depending on the analysis supporting the risk response plan, sometimes action may not be taken at all. Other times, a deliberate action is called for to deal with the risk.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      316,
      283,
      252,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1149,
    "question": "What is the event that detects that a known risk's variable has changed and that it is time to move the item from the risk register to the issue log?",
    "choice_a": "Risk response plan",
    "choice_b": "Risk identification",
    "choice_c": "Risk trigger",
    "choice_d": "Probability and impact matrix",
    "correct_answer": "C",
    "explanation": "Risk triggers are a sign that a risk event is about to occur or has occurred and that action is needed according to the risk response plan.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      316,
      252,
      283,
      130,
      311
    ],
    "source": "9781119892502"
  },
  {
    "id": 1150,
    "question": "Jack, Jill, and Harry are three shift managers who help a project work around the clock. What kind of tool would help them keep a log to allow for easy shift change?",
    "choice_a": "Enterprise social media",
    "choice_b": "Internet sites",
    "choice_c": "Wiki pages",
    "choice_d": "Vendor knowledge bases",
    "correct_answer": "C",
    "explanation": "Wiki pages can be edited though a web browser and do not require special software. It would allow the three managers to add to a single page to keep a log on events and progress.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      235,
      316,
      319,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1151,
    "question": "A construction project just passed all the electrical inspections for their permits, and the team can now begin to drywall. The project manager shares this information with the work team. What was the trigger for this communication?",
    "choice_a": "Task completion",
    "choice_b": "Milestone",
    "choice_c": "Risk register update",
    "choice_d": "Gate reviews",
    "correct_answer": "B",
    "explanation": "Notification of passing an inspection would be a milestone. Do not confuse it with task completion because the task in this example would have been wiring and terminating the electrical in the building.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      252,
      283,
      235,
      319,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1152,
    "question": "Which tool would you use to keep track of the key deliverables and dates important for project continuity?",
    "choice_a": "Issue log",
    "choice_b": "Risk register",
    "choice_c": "Milestone chart",
    "choice_d": "Project status report",
    "correct_answer": "C",
    "explanation": "A milestone chart helps track the important achievements during the course of a project. The chart helps signify key events or tasks' completion date and status.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      146,
      212,
      154,
      267,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1153,
    "question": "A project is spread across a large city, and a technical problem has developed on the project. There are team members in the field, some located at the headquarters building, and a vendor in a different city. What is the appropriate communication method for this situation?",
    "choice_a": "Kickoff meeting",
    "choice_b": "In-person meeting",
    "choice_c": "Instant messaging",
    "choice_d": "Virtual meeting",
    "correct_answer": "D",
    "explanation": "For an impromptu meeting where the team is dispersed, a virtual meeting like a conference call would be preferable so that the team in the field can remain on-site and get back to work when there is a resolution. Moreover, the problem in the field might need someone on-site for observation to report to the team.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      235,
      252,
      257,
      319
    ],
    "source": "9781119892502"
  },
  {
    "id": 1154,
    "question": "What is a form of mathematical analysis used to shorten the project schedule duration while keeping the project scope the same?",
    "choice_a": "PERT analysis",
    "choice_b": "Schedule compression",
    "choice_c": "Resource smoothing",
    "choice_d": "Resource leveling",
    "correct_answer": "B",
    "explanation": "When there is a preset project end date, like when a law sets when an activity must be completed by, schedule compression can be used to shorten the project schedule.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      152,
      145,
      138,
      146,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1155,
    "question": "Heather is an audience member at a board meeting scheduled to give details on a project. To help answer questions quickly, she has asked several project team members to stand by to provide information that she doesn't know. What form of communication would they use to share information?",
    "choice_a": "Face-to-face meetings",
    "choice_b": "Fax",
    "choice_c": "Email",
    "choice_d": "Instant messaging",
    "correct_answer": "D",
    "explanation": "Instant messaging allows quick back and forth with minimal distraction to others in attendance at the board meeting.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      258,
      252,
      239,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1156,
    "question": "If a project team is located within the same city, but in different parts of the city, what would be the appropriate communication method to conduct an impromptu meeting?",
    "choice_a": "Voice conferencing",
    "choice_b": "Instant messaging",
    "choice_c": "Daily stand-up meetings",
    "choice_d": "Face-to-face meeting",
    "correct_answer": "A",
    "explanation": "To help keep a project on schedule, the key is to minimize disruptions to project work time. As such, a voice conference or other type of virtual meeting will allow the team to participate in the impromptu meeting without stopping work to travel, deal with traffic, and park.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      258,
      252,
      319,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1157,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf009.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Gantt chart",
    "choice_c": "Pareto chart",
    "choice_d": "Scatter chart",
    "correct_answer": "B",
    "explanation": "A Gantt chart is a type of bar chart that illustrates a project schedule.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      146,
      152,
      145,
      154,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1158,
    "question": "The EV for a project is 900 and the AC is 1100. The CPI for the project would be which of the following?",
    "choice_a": ".82",
    "choice_b": "1.22",
    "choice_c": "\u2013200",
    "choice_d": "200",
    "correct_answer": "A",
    "explanation": "The Cost Performance Index is EV / AC. Therefore 900 / 1100 = .82.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      212,
      213,
      310,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1159,
    "question": "MJ has been asked to set up sessions with each of the relevant testing stakeholders so the team can watch the user acceptance testing and gain feedback on areas of improvement. What type of tool should she use to coordinate this event?",
    "choice_a": "Word processing",
    "choice_b": "Print media",
    "choice_c": "Calendaring tools",
    "choice_d": "File sharing platforms",
    "correct_answer": "C",
    "explanation": "Calendaring tools can help improve efficiency in finding availability where individuals can attend a meeting or event.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      258,
      235,
      252,
      139,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1160,
    "question": "What is a list of risks that includes the ID number, name, description, owner, and response plan?",
    "choice_a": "Risk response plan",
    "choice_b": "Issue list",
    "choice_c": "Risk register",
    "choice_d": "Activity log",
    "correct_answer": "C",
    "explanation": "The risk register will become more detailed through progressive elaboration as the project matures.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      316,
      130,
      283,
      332,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1161,
    "question": "With a major storm approaching, a construction project still has work teams out in the field. The weather service has indicated that everyone should take precautions immediately. What is the best communication method to let the teams in the field know? (Choose two.)",
    "choice_a": "Impromptu meeting",
    "choice_b": "Text messaging",
    "choice_c": "Scheduled meeting",
    "choice_d": "Phone call",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The correct answer would be any form of instant communication such as radio communication, calling a mobile phone, or text messaging. The communication plan should direct the method of communication used when corresponding with members in the field.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      252,
      235,
      258,
      239,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1162,
    "question": "A status report would contain all of the following information EXCEPT:",
    "choice_a": "Recap of meeting discussion",
    "choice_b": "Tracking deliverables",
    "choice_c": "Condition of project compared to the schedule",
    "choice_d": "Updates on risks and issues",
    "correct_answer": "A",
    "explanation": "Meeting minutes are used to provide a recap of what was discussed in a meeting.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      252,
      266,
      319,
      316,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1163,
    "question": "What is a document that is distributed prior to a meeting that spells out the topics to be discussed and who will present them at the meeting?",
    "choice_a": "Meeting minutes",
    "choice_b": "Communication plan",
    "choice_c": "Collaboration tools",
    "choice_d": "Meeting agenda",
    "correct_answer": "D",
    "explanation": "Meetings agendas can be valuable if the project team is struggling to stay focused or struggling to get to needed subjects in the limited time available to meet. Agendas can help improve the efficiency of meetings.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      258,
      319,
      252,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1164,
    "question": "What is an inventory of project actions that should be resolved in order to fulfill deliverables?",
    "choice_a": "Histogram",
    "choice_b": "Wiki pages",
    "choice_c": "Action items",
    "choice_d": "Issue log",
    "correct_answer": "C",
    "explanation": "Action items are comparable to a to-do list of activities that need to occur for product completion. Remember this is a dynamic list that can often grow during the project, specifically in meetings.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      316,
      283,
      171,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1165,
    "question": "Tony is a project manager, and he gets the team together for a brainstorming activity. At the end of the meeting, they have a list of all the items that need to be completed during the next work period. What type of meeting just occurred?",
    "choice_a": "Scrum introspective",
    "choice_b": "Daily Scrum",
    "choice_c": "Product backlog",
    "choice_d": "Delphi technique",
    "correct_answer": "C",
    "explanation": "This is a method of the Agile methodology to create a list of all the activities that need to be completed, whether they are included in the next sprint or not.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      267,
      319,
      146,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1166,
    "question": "Which meeting tool would a project team use for a daily stand-up where some team members are working from home and some are in the office?",
    "choice_a": "Conferencing platforms",
    "choice_b": "Email",
    "choice_c": "Enterprise social media",
    "choice_d": "Wiki knowledge base",
    "correct_answer": "A",
    "explanation": "Conferencing platforms like Slack, Microsoft Teams, and Google Meet allow for instant messaging, screen sharing, file sharing, and video and voice calls.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      258,
      235,
      252,
      139,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1167,
    "question": "Debra is having problems getting connected for a conference call through her computer. She calls the Service Desk. They set up an incident to record the break-fix work and to track the remediation of the problem. What productivity tool is the Service Desk using?",
    "choice_a": "Case management system",
    "choice_b": "Conferencing platforms",
    "choice_c": "Real-time surveys",
    "choice_d": "File sharing platform",
    "correct_answer": "A",
    "explanation": "A ticketing system is a form of a case management system that allows the user and the technician to track and report on the progress of the fix of the user's issue.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      316,
      319,
      283,
      235,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1168,
    "question": "The kickoff meeting for a project needs interactive participation in the modern digital age. They want to allow the participants to use their phones to answer questions and offer their opinions on certain topics. What type of tool would help with this meeting?",
    "choice_a": "Conferencing platforms",
    "choice_b": "Project management scheduling tools",
    "choice_c": "Calendaring tools",
    "choice_d": "Real-time surveys/polling",
    "correct_answer": "D",
    "explanation": "Cloud tools like Slido are easy to set up, make a meeting more dynamic, and hold attendees' interest by having a purpose for this phone or computer. These tools allow for real-time polling of the attendees' opinions and can be a great tool to draw out the participation of introverts who feel more comfortable with typing an answer than speaking out loud.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      235,
      257,
      252,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1169,
    "question": "The internal project team, including legal, senior leadership, and finance, are holding a meeting to review their response to a vendor contract. They open the document and are all adding their comments and changes simultaneously. What kind of software platform is assisting this collaborative effort?",
    "choice_a": "Real-time surveys",
    "choice_b": "Whiteboard",
    "choice_c": "Real-time, multi-authoring editing software",
    "choice_d": "Project management scheduling software",
    "correct_answer": "C",
    "explanation": "Real-time, multi-authoring tools like Microsoft Office 365 and Google Apps will not only allow several users to make changes in the same document at the same time, but they will also show the work of the other individuals and keep track of who is making what change for review and discussion later.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      258,
      235,
      268,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1170,
    "question": "Greg is working in an oilfield assigned to a project in a remote area. The trailer he works out of has a telephone line, but internet connectivity is limited, and mobile phone coverage is spotty. What would be the best method for Greg to participate in a status meeting?",
    "choice_a": "Email",
    "choice_b": "Voice conferencing",
    "choice_c": "Videoconferencing",
    "choice_d": "Whiteboard",
    "correct_answer": "B",
    "explanation": "Voice conferencing, or teleconference, would be the ideal choice as it would not require Greg to travel, allows for back-and-forth communication, and wouldn't be interrupted by poor internet quality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      252,
      319,
      239,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1171,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf010.png\"/>",
    "choice_a": "Run chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Fishbone diagram",
    "correct_answer": "A",
    "explanation": "A run chart is a graph that displays observed data in a time sequence.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      154,
      267,
      146
    ],
    "source": "9781119892502"
  },
  {
    "id": 1172,
    "question": "A project has an earned value of $2,500 and an actual cost of $2,275. The cost variance for this project would be which of the following?",
    "choice_a": "$2,275",
    "choice_b": "$225",
    "choice_c": "$2,500",
    "choice_d": "$\u2212225",
    "correct_answer": "B",
    "explanation": "The formula for calculating cost variance is Earned Value \u2013 Actual Cost. Plug in the numbers as follows: $2,500 \u2013 $2,275 = $225, signifying that the project is under budget.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      213,
      212,
      266,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1173,
    "question": "Which knowledge management tool allows contractors or users of a company's products to find information about a particular issue or to find a work instruction on how to use a product?",
    "choice_a": "Collaboration tools",
    "choice_b": "Social media",
    "choice_c": "Vendor knowledge bases",
    "choice_d": "Intranet sites",
    "correct_answer": "C",
    "explanation": "Vendor knowledge bases can come in two forms: those accessible to all web users, and those where only company representatives can access the information. In either case, they help the user to self-serve to try to solve a problem without calling a help center.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      316,
      235,
      187,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1174,
    "question": "The project management plan consists of all of the following components EXCEPT: (Choose two.)",
    "choice_a": "Project schedule",
    "choice_b": "Scope plan",
    "choice_c": "Action items",
    "choice_d": "Communication plan",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Action items are a tactical item used to record a to-do list in the course of meetings, and a request for proposal is a procurement vehicle to help obtain goods and services. The procurement plan might be a part of the project management plan, but the RFP would ultimately be added to archived project documentation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      130,
      319,
      283,
      332,
      187
    ],
    "source": "9781119892502",
    "choice_e": "Request for proposal"
  },
  {
    "id": 1175,
    "question": "Wigit Construction has reviewed an RFP response and has reached an agreement with the seller. How should they communicate the quantity of goods and services they need and the price that will be paid?",
    "choice_a": "Time and materials",
    "choice_b": "Purchase order",
    "choice_c": "Cost-reimbursable contract",
    "choice_d": "Fixed-price contract",
    "correct_answer": "B",
    "explanation": "A purchase order is a legally binding agreement that guarantees the delivery of goods/services along with the agreed upon compensation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      183,
      187,
      213,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1176,
    "question": "Hugh has been asked to investigate a new line of medical equipment for a hospital that an executive saw at a trade show. The hospital has no idea who supplies this equipment or how much it might cost. What is the appropriate procurement method Hugh should pursue?",
    "choice_a": "SOW",
    "choice_b": "RFI",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "B",
    "explanation": "He should use an RFI. When there is inadequate information to decide to pursue a purchase, a request for information (RFI) can help the buyer gather information to make an informed decision. A RFQ is not an appropriate response in this scenario because Hugh's company is not ready to purchase where a time-limited quote would be useful. They are only investigating at this point.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      183,
      187,
      186,
      252,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1177,
    "question": "What is a SOW?",
    "choice_a": "A procurement method intended to obtain more information about goods and services",
    "choice_b": "A procurement method designed to invite bids, review, select, and purchase goods or services",
    "choice_c": "A procurement document that details the goods and services to be procured from outside the organization",
    "choice_d": "A meeting with prospective vendors prior to completing a proposal",
    "correct_answer": "C",
    "explanation": "In order for a vendor proposal to be accurate and meaningful to the organization who publishes an RFP, there must be a complete written explanation of the goods or services that are needed. This is known as a statement of work (SOW).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      187,
      186,
      130,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1178,
    "question": "WigitCom is looking for a new storage solution to handle its increasing data needs. They are unclear exactly what kind of solution they might need, or even what vendors could sell them a solution. What is the best procurement method they should use?",
    "choice_a": "Request for proposal (RFP)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for information (RFI)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "C",
    "explanation": "An RFI will help give information to WigitCom for them to make a determination as to what solutions are available, give data on the vendor who can help, and give an order of magnitude estimate to the costs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      187,
      186,
      207,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1179,
    "question": "DewDrops is looking to solicit bids for the creation of a new manufacturing facility and delivery dock. Which vendor solicitation method should DewDrops use?",
    "choice_a": "Statement of work (SOW)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for proposal (RFP)",
    "choice_d": "Request for information (RFI)",
    "correct_answer": "B",
    "explanation": "A RFQ is a tool used to help determine estimates for time and cost through bids for specific products or services.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      183,
      186,
      187,
      145,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1180,
    "question": "The process of submitting a SOW, receiving bids from vendors and suppliers, evaluating responses, and selecting is known as which one of the following?",
    "choice_a": "C&D",
    "choice_b": "RFP",
    "choice_c": "Scrum introspective",
    "choice_d": "RFQ",
    "correct_answer": "B",
    "explanation": "An organization issues an RFP when they are ready to begin work and are ready to procure goods and services in support of the work.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      187,
      252,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1181,
    "question": "A project team member is spending time typing task information into a computer application that includes tasks, start and end date, and duration. Which project management tool is this team member using?",
    "choice_a": "Collaboration tools",
    "choice_b": "Key performance indicators",
    "choice_c": "Project scheduling software",
    "choice_d": "Project management plan",
    "correct_answer": "C",
    "explanation": "Scheduling software can aid in the tracking and reporting of tasks, schedule, and critical path.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      146,
      139,
      154,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1182,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf011.png\"/>",
    "choice_a": "Pareto chart",
    "choice_b": "Process diagram",
    "choice_c": "Scatter diagram",
    "choice_d": "Decision tree",
    "correct_answer": "D",
    "explanation": "A decision tree is a technique for making decisions when the consequences of a decision are uncertain by helping to deduce the most beneficial option.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      314,
      310,
      146,
      267,
      152
    ],
    "source": "9781119892502"
  },
  {
    "id": 1183,
    "question": "A construction company is working on a new building. The CPI for the project is 1.25, which means:",
    "choice_a": "The project is over budget.",
    "choice_b": "The project is behind schedule.",
    "choice_c": "The project is under budget.",
    "choice_d": "The project is ahead of schedule.",
    "correct_answer": "C",
    "explanation": "The project is under budget. A CPI over 1 means that the project is spending less than was forecasted for the measurement date.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      213,
      310,
      266,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1184,
    "question": "What is the measure of how well a company or project is doing at achieving key business objectives as gauged through a specific value?",
    "choice_a": "COQ",
    "choice_b": "KPP",
    "choice_c": "ETC",
    "choice_d": "KPI",
    "correct_answer": "D",
    "explanation": "Key performance indicators can be used at different levels of a project or organization to help determine the success of reaching particular outcomes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      266,
      212,
      310,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1185,
    "question": "After cost overruns begin to occur on a project to build a new hospital, a firm is brought in to examine the original budget, expenditures, and the contracts on the project. This is known as which one of the following?",
    "choice_a": "An audit",
    "choice_b": "A gate review",
    "choice_c": "A Scrum retrospective",
    "choice_d": "A project change",
    "correct_answer": "A",
    "explanation": "There can be both internal and external audits; either one should be independent in authority and practice.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      322,
      310,
      307,
      186
    ],
    "source": "9781119892502"
  },
  {
    "id": 1186,
    "question": "The project manager is working with the project team on a weekly document explaining to stakeholders what tasks have been completed, how much budget has been spent, what issues exist, and any risks that are affecting the project. What document are they working on?",
    "choice_a": "Issue log",
    "choice_b": "Action items",
    "choice_c": "Status report",
    "choice_d": "Project management plan",
    "correct_answer": "C",
    "explanation": "A status report provides high-level detail on the progress and challenges the project is experiencing. The cadence, or frequency, of the report will be set by the communication plan.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      252,
      316,
      213,
      266,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1187,
    "question": "Selina has completed negotiation of a contract with a vendor to create a new mobile application to provide digital identification services for several state governments. What collaboration tool would she use to obtain final approval to complete the contract?",
    "choice_a": "Whiteboard",
    "choice_b": "e-signature platform",
    "choice_c": "File sharing platform",
    "choice_d": "Conferencing platforms",
    "correct_answer": "B",
    "explanation": "Electronic signatures speed up approval processes and give visibility of who still needs to sign off on the document. Depending on the organization's licensing, this legally binding alternative can be used for both internal and external approvals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      187,
      171,
      283,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1188,
    "question": "Alexander is attending a meeting and the facilitator asks the group to get out their phones and use a QR code to get to a series of questions on their hopes for the meeting. What kind of tool is the facilitator using for this meeting?",
    "choice_a": "Ticketing system",
    "choice_b": "Real-time surveys/polling",
    "choice_c": "Enterprise social media",
    "choice_d": "Real-time, multi-authoring editing software",
    "correct_answer": "B",
    "explanation": "Use of dynamic interactive tools like real-time surveys can amplify the effectiveness of meeting by helping to hold attendees' interest and can be a great way to capture opinions and comments for use later in the project.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      258,
      235,
      266,
      257,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1189,
    "question": "A project team needs to record their user test observations from multiple locations at the same time. They open a spreadsheet application and set up the sheet with the needed rows and columns to capture their results. What kind of platform would allow them all to edit at the same time?",
    "choice_a": "Multi-authoring editing software",
    "choice_b": "Real-time surveys",
    "choice_c": "Conferencing platforms",
    "choice_d": "Ishikawa diagrams",
    "correct_answer": "A",
    "explanation": "Real-time, multi-authoring editing software allows word processing, spreadsheet, and presentations to be made through group participation simultaneously rather than having to pass a file off to a new author to work on by themselves.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      257,
      235,
      152,
      268,
      332
    ],
    "source": "9781119892502"
  },
  {
    "id": 1190,
    "question": "Jeff has completed the creation of a statement of work and submits it to his company's procurement section to solicit bids from vendors. The procurement team lets him know that he will need to evaluate responses from vendors and help make a selection. <p>Which procurement method is described in this scenario?</p>",
    "choice_a": "SOW",
    "choice_b": "RFI",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "C",
    "explanation": "As Jeff has completed the SOW, the organization knows what they need to procure and are ready to move forward. Therefore, this scenario describes a request for proposal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      183,
      187,
      130,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1191,
    "question": "Which vendor solicitation method is best to use when more data is required about the goods and services that need to be procured?",
    "choice_a": "Request for information (RFI)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for proposal (RFP)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "A",
    "explanation": "An RFI will give a sense of the number of providers or contractors who can provide the goods and services in question. An RFI will also help to give a ballpark estimate for the costs.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      183,
      187,
      186,
      213,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1192,
    "question": "Donna is working on procuring services for a project, but she is uncertain about what is available and what the capabilities of various suppliers are to meet this demand. What is the procurement vehicle that she should use?",
    "choice_a": "RFI",
    "choice_b": "Sole source",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "A",
    "explanation": "When an organization needs help in figuring out what is available in the marketplace, they release a request for information (RFI).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      187,
      130,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1193,
    "question": "Which vendor solicitation method would be used to invite suppliers into a bidding process to bid on specific products or services?",
    "choice_a": "Request for information (RFI)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for proposal (RFP)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "B",
    "explanation": "RFQ generally means the same thing as IFB (invitation for bid). An RFI is similar to an RFQ in that they both serve the same purpose, and most organizations use one or the other of these methods to help determine estimates.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      187,
      239,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1194,
    "question": "All of the following are procurement methods EXCEPT:",
    "choice_a": "RFQ",
    "choice_b": "RACI",
    "choice_c": "RFI",
    "choice_d": "RFP",
    "correct_answer": "B",
    "explanation": "RACI stands for responsible, accountable, consulted, and informed, and is used to help clarify roles and responsibilities. This is not a procurement vehicle.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      171,
      183,
      186,
      187,
      170
    ],
    "source": "9781119892502"
  },
  {
    "id": 1195,
    "question": "DewDrops is the parent company for SunRays, Inc. and DaisyChains, Inc. SunRays and DaisyChains are agreeing to provide service to each other and outline specific criteria each must follow. What is the best method to memorialize the arrangement?",
    "choice_a": "SLA",
    "choice_b": "MOU",
    "choice_c": "NDA",
    "choice_d": "RFP",
    "correct_answer": "B",
    "explanation": "A memorandum of understanding is used when a legal agreement can't be created between the two parties.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      187,
      186,
      183,
      268,
      332
    ],
    "source": "9781119892502"
  },
  {
    "id": 1196,
    "question": "What vendor-centric document would be used to ensure that sensitive or trade secret information is not shared outside of the organization?",
    "choice_a": "MOU",
    "choice_b": "SLA",
    "choice_c": "NDA",
    "choice_d": "RFP",
    "correct_answer": "C",
    "explanation": "A nondisclosure agreement ensures that what's discussed, revealed, or created is kept within the organization.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      187,
      268,
      183,
      186,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1197,
    "question": "When an organization is ready to procure products or services so that work can begin, which procurement method should be used?",
    "choice_a": "Request for information (RFI)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for proposal (RFP)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "C",
    "explanation": "This process includes submitting a SOW, receiving bids from vendors and suppliers, evaluating proposals, and making a selection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      187,
      130,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1198,
    "question": "What is a bidder's conference?",
    "choice_a": "A daily meeting to ask three questions on project progress and hurdles",
    "choice_b": "A meeting with all prospective vendors to answer questions and clarify issues with an RFP",
    "choice_c": "An auction to help find the lowest cost bid for a product or service",
    "choice_d": "A document that spells out the good or service an organization is looking to procure from outside of an organization",
    "correct_answer": "B",
    "explanation": "A bidders conference typically occurs right after an RFP is published to help improve the quality of the proposals submitted. Moreover, vendors can get a better sense of whether or not they have the information they need to decide to provide a bid.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      187,
      235,
      252,
      239
    ],
    "source": "9781119892502"
  },
  {
    "id": 1199,
    "question": "DewDrops has issued an RFP, but their statement of work is undeveloped because they are not sure what they want the finished product to do. Which type of contract would make sense in this situation?",
    "choice_a": "Cost-reimbursable contract",
    "choice_b": "Purchase order",
    "choice_c": "Fixed-price contract",
    "choice_d": "Time and materials",
    "correct_answer": "A",
    "explanation": "As outlined in the contract, the seller can recoup costs that are allowable in the contract terms. This also allows flexibility to the buyer when the final outcome is not well-defined.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      186,
      183,
      187,
      207,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1200,
    "question": "Wigit Construction is responding to an RFP where the work needed is well-defined, clear, and concise. What is the best type of contract to use if they win the work?",
    "choice_a": "Fixed-price contract",
    "choice_b": "Service-level agreement",
    "choice_c": "Cost-reimbursable contract",
    "choice_d": "Time and material",
    "correct_answer": "A",
    "explanation": "Fixed-price contracts are good agreements when the statement of work is clear and concise.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      186,
      183,
      187,
      207,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1201,
    "question": "A government agency is looking for a new constituent management system. Though they are unclear about what options are available, they need to be able to make a decision quickly and move forward to procure a solution. What is the best procurement method for them to use?",
    "choice_a": "SOW",
    "choice_b": "RFI",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "D",
    "explanation": "An RFI and an RFQ are both similar in the gathering of data to help an organization make an informed decision. The differentiator is the agency's desire to move forward with a purchase once the information is gathered and analyzed.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      187,
      186,
      183,
      130,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1202,
    "question": "DewDrops has issued an RFP, but their statement of work is undeveloped. They decide to use a cost-reimbursable contract with the seller. What best describes the risk condition to DewDrops in this scenario?",
    "choice_a": "Risk doesn't occur until the project is started and doesn't matter at the contract phase.",
    "choice_b": "Risk is evenly divided between buyer and seller.",
    "choice_c": "Riskiest because the buyer won't know the final cost until the project is completed.",
    "choice_d": "Least risky because the seller assumes the risk of unknown costs.",
    "correct_answer": "C",
    "explanation": "As the seller of the service continues to work on a project, the more chances for certain costs outlined to be reimbursed are increased. This becomes a trade-off between flexibility and uncertainty.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      183,
      213,
      187,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1203,
    "question": "Wigit Construction is responding to an RFP where the customer wants to use a fixed-price contract. Which of the following statements represents the risk to Wigit Construction should they win the work?",
    "choice_a": "Least risky because the buyer assumes the risk of unknown costs.",
    "choice_b": "Riskiest because problems on the project will increase their costs.",
    "choice_c": "Risk is evenly divided between buyer and seller.",
    "choice_d": "Risk doesn't occur until the project is started and doesn't matter at the contract phase.",
    "correct_answer": "B",
    "explanation": "A fixed-price contract is risky to Wigit Construction as the seller because if there are problems on the project and it takes longer to complete, Wigit Construction must still pay for the labor and increased costs of materials to fulfill the contractual obligation.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      186,
      187,
      213,
      322,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1204,
    "question": "The documentation strategy for a project calls for each change to be reflected in a log at the beginning of each document. This is known as which one of the following?",
    "choice_a": "Change request logs",
    "choice_b": "Scrum retrospective",
    "choice_c": "Version control",
    "choice_d": "Risk register",
    "correct_answer": "C",
    "explanation": "Version control allows for a trail of what changes were added by who at which point in the document's history.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      283,
      268,
      257,
      332,
      316
    ],
    "source": "9781119892502"
  },
  {
    "id": 1205,
    "question": "An anticipated event of water damage in a construction project is confirmed. The project manager notifies appropriate stakeholders that they will need to bring in a team to perform mold mitigation. What type of communication trigger initiated this communication?",
    "choice_a": "Risk register updates",
    "choice_b": "Business continuity response",
    "choice_c": "Schedule change",
    "choice_d": "Resource change",
    "correct_answer": "A",
    "explanation": "Early in a project is when risks are most likely to occur and accordingly can have bigger impacts on the project.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      252,
      283,
      235,
      319,
      316
    ],
    "source": "9781119892502"
  },
  {
    "id": 1206,
    "question": "Valentine has been asked to determine the root cause of communication problems on a global project. Which tool should she use to help her with this analysis?",
    "choice_a": "Pareto chart",
    "choice_b": "Run chart",
    "choice_c": "Wiki pages",
    "choice_d": "Fishbone",
    "correct_answer": "D",
    "explanation": "A fishbone chart is used to help determine and define the different factors that could be the cause of a problem and do analysis to determine the root cause.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      311,
      314,
      310,
      252,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1207,
    "question": "Wigit Construction needs to complete the replacement of six bridges as part of a road-widening project. They need to complete one bridge every 10 weeks for the project to be finished on time. What does the completion of a bridge every 10 weeks represent?",
    "choice_a": "COQ",
    "choice_b": "KPI",
    "choice_c": "ETC",
    "choice_d": "KPP",
    "correct_answer": "B",
    "explanation": "Key performances indicators are a performance measurement tool to help track progress toward a goal or objective.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      266,
      212,
      310,
      154
    ],
    "source": "9781119892502"
  },
  {
    "id": 1208,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf012.png\"/>",
    "choice_a": "Task board",
    "choice_b": "Requirements traceability matrix",
    "choice_c": "Decision tree",
    "choice_d": "Scatter diagram",
    "correct_answer": "A",
    "explanation": "A task board is a visual tool used to create a picture of the work to be completed and the state the work is in. A task board can be either physical or virtual.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      267,
      266,
      152,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1209,
    "question": "During a meeting, the team reports that Brad is sorely underperforming. The discussion with Brad reveals he does not have a needed skill set to perform his work. The project manager agrees to pay for an online class so Brad can complete his assignment. Where would this task get captured?",
    "choice_a": "Meeting agenda",
    "choice_b": "Lessons learned",
    "choice_c": "Issue log",
    "choice_d": "Action items",
    "correct_answer": "D",
    "explanation": "Specific actions that need to get completed get added to the action items list. This list is great during meetings to keep an accurate track of the tasks that come up during discussion so they can be successfully undertaken and completed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      319,
      316,
      171,
      283,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1210,
    "question": "Noreen has been working on a document that outlines several pieces of equipment her company needs as well as the professional services required to install the equipment. What document has Noreen created?",
    "choice_a": "Request for information (RFI)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for proposal (RFP)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "D",
    "explanation": "The SOW specifies in detail the goods and services the organization is purchasing from outside the organization. This is a common prerequisite to the issuing of an RFP.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      187,
      186,
      130,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1211,
    "question": "A government agency has issued a request for quotation for a new computer solution to help their constituents. What other procurement method is comparable to an RFQ?",
    "choice_a": "RFQ",
    "choice_b": "NDA",
    "choice_c": "RFP",
    "choice_d": "RFI",
    "correct_answer": "D",
    "explanation": "A request for information can have a similar meaning to a request for quotation in some companies. A RFQ can also have a cost quote that would be valid for a certain period of time.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      183,
      186,
      187,
      213,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1212,
    "question": "Which two procurement methods serve a similar purpose of scanning the vendor landscape for number of vendors and to gain a cost estimate? (Choose two.)",
    "choice_a": "RFQ",
    "choice_b": "NDA",
    "choice_c": "RFP",
    "choice_d": "RFI",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "RFIs and RFQs may be used interchangeably but may also have different meanings in different organizations. Ask questions to learn what these terms mean in your organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      187,
      207,
      213,
      316
    ],
    "source": "9781119892502"
  },
  {
    "id": 1213,
    "question": "What best describes an RFP?",
    "choice_a": "Procurement method to invite bids, review, select, and purchase goods or services",
    "choice_b": "Procurement method to obtain more information about goods and services",
    "choice_c": "A meeting with prospective vendors prior to completing a proposal",
    "choice_d": "Procurement document that details the goods and services to be procured from outside the organization",
    "correct_answer": "A",
    "explanation": "A request for proposal (RFP) is issued when an organization is ready to begin work and needs to procure goods and services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      283,
      332,
      268
    ],
    "source": "9781119892502"
  },
  {
    "id": 1214,
    "question": "What document would be created to define performance expectations among two or more parties?",
    "choice_a": "MOU",
    "choice_b": "NDA",
    "choice_c": "SLA",
    "choice_d": "RFP",
    "correct_answer": "C",
    "explanation": "Service-level agreements spell out the expected performance levels to be followed and adhered to. For instance, an electrical utility may have a requirement with their customers to restore power within a certain period of time in case there is an outage.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      187,
      186,
      183,
      130,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1215,
    "question": "Fernando is a project employee whose employment will terminate at the end of the software development project. What vehicle would the company use to protect their intellectual property?",
    "choice_a": "C&D",
    "choice_b": "RFP",
    "choice_c": "KPI",
    "choice_d": "NDA",
    "correct_answer": "D",
    "explanation": "A nondisclosure agreement will spell out the confidentiality expected on the project, given legal protections to the company.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      187,
      183,
      268,
      171,
      257
    ],
    "source": "9781119892502"
  },
  {
    "id": 1216,
    "question": "<i>We are here for you!</i> is a temporary staffing firm that has sent two administrative assistants to a project to help keep up with demand. What is the best contract vehicle for them to use to deliver this service?",
    "choice_a": "Cost-reimbursable contract",
    "choice_b": "Purchase order",
    "choice_c": "Fixed-price contract",
    "choice_d": "Time and materials",
    "correct_answer": "D",
    "explanation": "Time and materials contracts set an hourly rate for a contract worker. <i>We are here for you!</i> would get compensated only for the hours the two admin assistants work for the project/organization.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      186,
      187,
      183,
      207,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1217,
    "question": "DewDrops has issued a document allowing a seller to begin work on a project. The document spells out what the seller will be paid and the exact deliverables that need to be provided on the project. What document has DewDrops issued to the seller?",
    "choice_a": "Purchase order",
    "choice_b": "Cost-reimbursable contract",
    "choice_c": "Fixed-price contract",
    "choice_d": "Time and materials",
    "correct_answer": "A",
    "explanation": "A purchase order creates the binding arrangement between buyer and seller, guaranteeing service to the buyer and compensation to the seller.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      187,
      130,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1218,
    "question": "Determining the burn rate and measuring costs to the baseline are elements of what activity?",
    "choice_a": "Expenditure tracking",
    "choice_b": "Spending plan",
    "choice_c": "Parametric estimating",
    "choice_d": "Cost accounting",
    "correct_answer": "A",
    "explanation": "These are elements of expenditure tracking. This activity also includes measuring the project spending to date.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      213,
      322,
      212,
      207,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1219,
    "question": "Which type of contract allows the seller to recover all allowable expenses associated with providing the goods or services?",
    "choice_a": "Cost-reimbursable contract",
    "choice_b": "Time and materials",
    "choice_c": "Statement of work",
    "choice_d": "Fixed-price contract",
    "correct_answer": "A",
    "explanation": "As outlined in the contract, the seller can recoup costs that are allowable in the contract terms.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      186,
      187,
      213,
      212,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1220,
    "question": "The implementation of a new timekeeping system will affect every employee in a company, and they will have to log into a computer each pay period to get paid. What kind of organizational change does this represent?",
    "choice_a": "Outsourcing",
    "choice_b": "Risk response",
    "choice_c": "Internal reorganization",
    "choice_d": "Business process change",
    "correct_answer": "D",
    "explanation": "Alterations in the way business is conducted, information is routed, and approvals are given are all business process changes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      283,
      170,
      252,
      171,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1221,
    "question": "WigitCom is developing a new product, and it needs a specific skill set to help accomplish the project. They find a staffing firm that can provide them with a resource, but WigitCom is unsure what the specific deliverables of the engagement will be. Which contract vehicle will provide them with the most flexibility?",
    "choice_a": "Time and materials",
    "choice_b": "Purchase order",
    "choice_c": "Cost-reimbursable contract",
    "choice_d": "Fixed-price contract",
    "correct_answer": "A",
    "explanation": "Because WigitCom is paying for time and expenses and not for a defined deliverable, they will be able to change their mind as often as they are willing to pay for it.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      186,
      187,
      183,
      213,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1222,
    "question": "Which type of contract would work best when the product or service needed is well-defined?",
    "choice_a": "Time and material",
    "choice_b": "Scrum methodology",
    "choice_c": "Cost-reimbursable contract",
    "choice_d": "Fixed-price contract",
    "correct_answer": "D",
    "explanation": "Fixed-price contracts are good agreements when the statement of work is clear and concise.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      186,
      183,
      187,
      207,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1223,
    "question": "Which type of contract would be used in a staff augmentation situation?",
    "choice_a": "Time and materials",
    "choice_b": "Purchase order",
    "choice_c": "Cost-reimbursable contract",
    "choice_d": "Fixed-price contract",
    "correct_answer": "A",
    "explanation": "Time and materials contracts set an hourly rate for a contract worker, such as a painter to finish an interior, instead of a fixed price. The total cost is not known at the outset and will depend on the amount of time spent to produce the product or service.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      187,
      207,
      213,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1224,
    "question": "Which type of contract is riskiest for the seller?",
    "choice_a": "Cost-reimbursable contract",
    "choice_b": "Purchase order",
    "choice_c": "Fixed-price contract",
    "choice_d": "Time and materials",
    "correct_answer": "C",
    "explanation": "A fixed-price contract is risky to the seller because if there are problems on the project and it takes longer to complete, the seller still must pay for the labor and increased costs of materials to fulfill the contractual obligation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      187,
      213,
      322,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1225,
    "question": "Which type of contract offers the greatest flexibility to change scope on a project?",
    "choice_a": "Cost-reimbursable contract",
    "choice_b": "Purchase order",
    "choice_c": "Fixed-price contract",
    "choice_d": "Time and materials",
    "correct_answer": "D",
    "explanation": "Time and materials is tied to a rate and a number of hours. If the buyer is willing to forgo the task the contract worker was meant to do in favor of other work, or if the buyer would like to have additional work done at their cost, this contract vehicle allows that type of flexibility.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      186,
      187,
      183,
      283,
      207
    ],
    "source": "9781119892502"
  },
  {
    "id": 1226,
    "question": "Measuring the spending to date, determining the burn rate, and accounting for purchases is known as which one of the following?",
    "choice_a": "Expenditure reporting",
    "choice_b": "Expenditure tracking",
    "choice_c": "Cost accounting",
    "choice_d": "ETC",
    "correct_answer": "B",
    "explanation": "This is the activity that compares costs and expenses to date against the cost baseline so stakeholders can see the variance between what was planned for and what actually occurred.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      213,
      322,
      212,
      207,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1227,
    "question": "A legal document that describes the goods or services that will be provided, their cost, and any penalties for noncompliance is known as which one of the following?",
    "choice_a": "Request for proposal",
    "choice_b": "Nondisclosure agreement",
    "choice_c": "Contract",
    "choice_d": "Warranty",
    "correct_answer": "C",
    "explanation": "A contract is legally enforceable and typically falls into three categories: fixed-price contracts, cost-reimbursable contracts, and time and material contracts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      183,
      187,
      130,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1228,
    "question": "Walt works for Wigit Construction, and he has been assigned as a project manager to build a new bridge. The team has six months to build the project and a fixed budget, and the bridge must handle four lanes of traffic. This is an example of which one of the following?",
    "choice_a": "Three-point estimating",
    "choice_b": "Cost of quality",
    "choice_c": "Triple constraints",
    "choice_d": "Progressive elaboration",
    "correct_answer": "C",
    "explanation": "The Wigit Construction bridge project is limited by time, budget, and scope, which are the elements of the triple constraints.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      130,
      146,
      207,
      322,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1229,
    "question": "What best describes an RFI?",
    "choice_a": "Procurement method to obtain more information about goods and services",
    "choice_b": "Procurement method to invite bids, and review, select, and purchase goods or services",
    "choice_c": "Procurement document that details the goods and services to be procured from outside the organization",
    "choice_d": "A meeting with prospective vendors prior to completing a proposal",
    "correct_answer": "A",
    "explanation": "A request for information (RFI) is used when there is not enough information or expert judgment to know what a good or service will cost, or to understand how many vendors there are who can meet this demand.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      183,
      187,
      186,
      130,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1230,
    "question": "Wigit Construction has completed a project. They submit an invoice to recover the money spent on special marble that they used in the creation of a dining room floor, which the contract allows them to do. What type of contract is Wigit Construction using?",
    "choice_a": "Time and materials",
    "choice_b": "Statement of work",
    "choice_c": "Cost-reimbursable contract",
    "choice_d": "Fixed-price contract",
    "correct_answer": "C",
    "explanation": "As outlined in the contract, the seller can recoup costs that are allowable in the contract terms.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      186,
      187,
      213,
      207,
      283
    ],
    "source": "9781119892502"
  },
  {
    "id": 1231,
    "question": "The project manager is given a bar chart representing the statistical distribution of traffic on a stretch of road that needs work. What tool has the project manager been handed?",
    "choice_a": "Pareto chart",
    "choice_b": "Histogram",
    "choice_c": "Process diagram",
    "choice_d": "Fishbone diagram",
    "correct_answer": "B",
    "explanation": "A histogram chart can be used to show the frequencies of problem causes to help explain what is needed for preventive or corrective action.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      310,
      311,
      314,
      146,
      212
    ],
    "source": "9781119892502"
  },
  {
    "id": 1232,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c03uf013.png\"/>",
    "choice_a": "Project network diagram",
    "choice_b": "Gantt chart",
    "choice_c": "Project backlog",
    "choice_d": "Project burndown chart",
    "correct_answer": "D",
    "explanation": "This is a project burndown chart.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      154,
      267,
      212,
      146,
      310
    ],
    "source": "9781119892502"
  },
  {
    "id": 1233,
    "question": "A vendor is very strict in applying formal change control on a project for a customer, and few changes are getting approved. Which contract vehicle would cause a vendor to behave this way?",
    "choice_a": "Cost-reimbursable",
    "choice_b": "Fixed-price",
    "choice_c": "Time and materials",
    "choice_d": "Request for proposal",
    "correct_answer": "B",
    "explanation": "With a fixed-price contract, the risk is on the seller. When changes to a project increase their costs but not their revenue, they stand to lose money. Accordingly, they would likely allow very few changes to the scope.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      186,
      187,
      283,
      213,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1234,
    "question": "The project sponsor considers the project to be a failure because the budget continues to climb. What tool can the project manager use to help confirm or deny the project sponsor's suspicion?",
    "choice_a": "Balanced scorecard",
    "choice_b": "RACI matrix",
    "choice_c": "Gantt chart",
    "choice_d": "Project management plan",
    "correct_answer": "A",
    "explanation": "The project sponsor is looking at a single variable on the project, budget. That variable will probably not tell the complete picture on the project, including that the increased cost resulted from increasing the scope and not cost overruns. A balanced scorecard helps give that bigger picture.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      266,
      322,
      212,
      310,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1235,
    "question": "Dean has been working on a project for six months, though he is not a permanent employee of the company\u2014he is a contract employee provided by a vendor. Which contract vehicle makes the most sense to use in this case?",
    "choice_a": "Cost-reimbursable",
    "choice_b": "Fixed-price",
    "choice_c": "Time and materials",
    "choice_d": "Request for proposal",
    "correct_answer": "C",
    "explanation": "Time and materials are great to use for staff augmentation situations. The customer is only on the hook for whatever time they use, so it gives the customer flexibility.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      187,
      183,
      207,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1236,
    "question": "The project team on which Jenny is working has a detailed set of requirements the project must meet, but the company has limited resources to work on the project. What is the likely result of these two constraints?",
    "choice_a": "The scope must be reduced.",
    "choice_b": "The company must find more resources.",
    "choice_c": "The scope and resources must be adjusted.",
    "choice_d": "The time will expand to deal with scope and cost.",
    "correct_answer": "D",
    "explanation": "In terms of the triple constraints, the results would be the project taking longer with the resources that have been assigned to the project.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      145,
      146,
      139,
      322,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1237,
    "question": "Just allowing the consequences of a negative risk to happen is which type of risk response strategy?",
    "choice_a": "Avoid",
    "choice_b": "Transfer",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "D",
    "explanation": "Acceptance is choosing to live with the impact a risk would have on the project. Essentially, this means choosing inaction as the intentional decision on how to address the risk.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      29,
      33,
      36,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1238,
    "question": "What is the process of examining the risk and establishing the appropriate course of action should it occur called?",
    "choice_a": "Risk analysis",
    "choice_b": "Risk probability",
    "choice_c": "Risk response planning",
    "choice_d": "Risk trigger",
    "correct_answer": "C",
    "explanation": "The risk response plan outlines the course of action that will occur should the risk materialize and start impacting the project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1239,
    "question": "Kevin is working on a project and he wants to store information on a portable hard drive as a backup to his work computer. What two security considerations should he take into account while using removal media storage? (Choose two)",
    "choice_a": "Back up the data at a regular interval.",
    "choice_b": "Encrypt the removable hard drive to prevent unauthorized access.",
    "choice_c": "Lock the device in an out-of-view area such as a drawer or cabinet.",
    "choice_d": "Do nothing, hackers do not target small projects or businesses.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Organizations will likely have policies and practices that govern the use of removable media and may outright prevent the use of these devices. In this question, Kevin's duty to protect the removable hard drive should include encrypting the device and making sure to physically lock up the device when not in use.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      192,
      195,
      191,
      190,
      29
    ],
    "source": "9781119892502"
  },
  {
    "id": 1240,
    "question": "A potential future event that can have either a negative or a positive impact on a project is known as which one of the following?",
    "choice_a": "An issue",
    "choice_b": "A risk",
    "choice_c": "A hope",
    "choice_d": "A requirement",
    "correct_answer": "B",
    "explanation": "Remember that a risk can be either positive or negative and represents an opportunity that did not exist earlier in the project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      32,
      33,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1241,
    "question": "As you identify all the potential risks that might impact a project, you should record them in which one of the following?",
    "choice_a": "RACI chart",
    "choice_b": "Risk register",
    "choice_c": "Risk probability matrix",
    "choice_d": "Issue log",
    "correct_answer": "B",
    "explanation": "The risk register is the tool used to document all potential risk for future analysis and evaluation. It includes a list of risks containing the risk number, description, probability, impact, risk score, risk owner, risk response plan location, and more.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1242,
    "question": "The activity of selecting risks that have the greatest chance of occurring and the biggest impact on the project should they occur is called which one of the following?",
    "choice_a": "Three-point estimating",
    "choice_b": "Pareto diagraming",
    "choice_c": "Monitoring and Controlling",
    "choice_d": "Risk analysis",
    "correct_answer": "D",
    "explanation": "Risk analysis is the process of figuring out what risks might happen and what the results would be if that risk did occur.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1243,
    "question": "The consequence or opportunity the risk poses to the project is known as which one of the following?",
    "choice_a": "Risk response plan",
    "choice_b": "Risk impact",
    "choice_c": "Risk register",
    "choice_d": "Risk probability",
    "correct_answer": "B",
    "explanation": "Risk impact details the consequence or result that will occur if the event actually happens. Typically, this is categorized with a rating of High, Medium, and Low.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1244,
    "question": "Which of the following is defined as the likelihood that a risk will occur?",
    "choice_a": "Risk response plan",
    "choice_b": "Probability and impact matrix",
    "choice_c": "Risk register",
    "choice_d": "Risk probability",
    "correct_answer": "D",
    "explanation": "Risk probability is the likelihood that a risk event will occur and is expressed as a number between 0.0 and 1.0.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1245,
    "question": "Which of the following techniques could be used to create an initial list of risks on a project? (Choose three.)",
    "choice_a": "Parametric estimating",
    "choice_b": "Brainstorming",
    "choice_c": "Three-point estimating",
    "choice_d": "Interviews",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "The techniques of brainstorming, interviews, and facilitated workshops can all assist in creating an initial risk list. The estimating techniques are used in activity estimation for a tasks, and a fishbone diagram would help create cause and effect relationships.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Fishbone diagrams",
    "choice_f": "Facilitated workshops"
  },
  {
    "id": 1246,
    "question": "What does it mean to share a positive risk?",
    "choice_a": "Assign the risk to a third party who is best able to bring about opportunity.",
    "choice_b": "Monitor the probability or impact of the risk event to ensure that benefits are realized.",
    "choice_c": "Choose to accept the consequences of the risk.",
    "choice_d": "Look for opportunities to take advantage of positive impacts.",
    "correct_answer": "A",
    "explanation": "To share a positive risk, the project team seeks to assign the risk to a third party who is best able to bring about the opportunity. For instance, a company already has a working factory in a country where the materials are going to be sold, reducing costs on the project.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1247,
    "question": "When determining risk probability and impact, which tool typically offers the best results?",
    "choice_a": "Expert judgment",
    "choice_b": "Parametric estimating",
    "choice_c": "Environmental factors",
    "choice_d": "Project documentation",
    "correct_answer": "A",
    "explanation": "Expert judgment is where the opinions of subject matter experts, stakeholders, and project team members contribute their expertise from similar projects to help make a recommendation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1248,
    "question": "What tool would be used to prioritize and quantify risks, so the information is easy to understand and is visually informative?",
    "choice_a": "Probability and impact matrix",
    "choice_b": "Fishbone diagram",
    "choice_c": "Histogram",
    "choice_d": "Responsibility assignment matrix",
    "correct_answer": "A",
    "explanation": "The probability and impact matrix is a tool used to calculate an overall risk score that can be used to help organize, prioritize, and determine which risks may require a response.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1249,
    "question": "All of these are common potential risks to a project EXCEPT:",
    "choice_a": "Teams not attending status meetings",
    "choice_b": "Insufficient budget assigned to the project",
    "choice_c": "Scope changes after the project execution begins",
    "choice_d": "Legal ramifications resulting from the project",
    "correct_answer": "A",
    "explanation": "Teams not attending status meetings would be an example of an active issue, not a potential future consequence that will impact the project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1250,
    "question": "What does it mean to exploit a positive risk?",
    "choice_a": "Assign the risk to a third party who is best able to bring about opportunity.",
    "choice_b": "Monitor the probability or impact of the risk event to ensure benefits are realized.",
    "choice_c": "Choose to accept the consequences of the risk.",
    "choice_d": "Look for opportunities to take advantage of positive impacts.",
    "correct_answer": "D",
    "explanation": "When dealing with a positive risk, to exploit it is looking for opportunities to take advantage of positive impacts. For instance, the price of oil drops and the project is able to purchase all the required oil at a significantly reduced price than was planned.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1251,
    "question": "At a minimum, which of the following types of information would be recorded on a risk register? (Choose three.)",
    "choice_a": "Risk score",
    "choice_b": "Risk trigger scores",
    "choice_c": "Risk document review",
    "choice_d": "Risk owners",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "Standard information on a risk register might include an identification number, description, probability and impact, score, and owner as they are all related to risk.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Description of risk",
    "choice_f": "Mitigation strategy"
  },
  {
    "id": 1252,
    "question": "Attempting to ensure that a risk doesn't happen at all, or eliminating the cause of a negative risk, is what type of risk response strategy?",
    "choice_a": "Transfer",
    "choice_b": "Mitigate",
    "choice_c": "Accept",
    "choice_d": "Avoid",
    "correct_answer": "D",
    "explanation": "Avoiding the risk attempts to bypass the risk all together including by eliminating the cause for a risk event.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1253,
    "question": "If a project team wanted to enhance a positive risk, what are they trying to accomplish?",
    "choice_a": "Assign the risk to a third party who is best able to bring about opportunity.",
    "choice_b": "Monitor the probability or impact of the risk event to ensure benefits are realized.",
    "choice_c": "Choose to accept the consequences of the risk.",
    "choice_d": "Look for opportunities to take advantage of positive impacts.",
    "correct_answer": "B",
    "explanation": "Enhancing a risk involves monitoring the probability or impact of the risk event to ensure benefits are realized.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1254,
    "question": "What is the activity of determining and documenting any potential risks that might happen on a project?",
    "choice_a": "Risk planning",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk identification",
    "correct_answer": "D",
    "explanation": "Risk identification is brainstorming and recording all potential risks that might occur during a project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1255,
    "question": "What is an individual or organization's comfort level with how likely they are to accept or avoid risk?",
    "choice_a": "Risk register",
    "choice_b": "Risk avoider",
    "choice_c": "Risk taker",
    "choice_d": "Risk tolerance",
    "correct_answer": "D",
    "explanation": "Risk tolerance is the threshold of comfort one has accepting a risk and its consequences.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1256,
    "question": "Joey has been assigned a project where the deadline must be met before the start of the youth activities season, and there is a limited budget for the project. This is an example of what type of influence?",
    "choice_a": "Scope creep",
    "choice_b": "Interaction between constraints",
    "choice_c": "Constraint reprioritization",
    "choice_d": "Stakeholders opinions on the project",
    "correct_answer": "B",
    "explanation": "There is interplay between time and cost on the project, meaning that scope will need to be adjusted accordingly.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      29,
      36,
      49,
      190,
      196
    ],
    "source": "9781119892502"
  },
  {
    "id": 1257,
    "question": "Nermit has been working on a chart that lists all the risks that have been identified on a project, along with a numerical score of the likelihood that the risk has of occurring and the score for how impactful the results of the risk occurring would be. What is Nermit creating?",
    "choice_a": "Risk response plan",
    "choice_b": "Risk register",
    "choice_c": "Probability and impact matrix",
    "choice_d": "RACI chart",
    "correct_answer": "C",
    "explanation": "The probability and impact matrix will also include a calculated final risk score that can be used to prioritize the risk's severity.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1258,
    "question": "A construction company has been monitoring tropical storms because of the impact a hurricane that might make landfall would have on the project. A tropical storm has just formed, and forecasters are calling for it to make landfall in a populated part of the country. The company begins to buy extra inventory in lumber and other materials. This is an example of which one of the following?",
    "choice_a": "Risk register",
    "choice_b": "Risk trigger",
    "choice_c": "Risk taker",
    "choice_d": "Risk tolerance",
    "correct_answer": "B",
    "explanation": "A risk trigger is an event that warns a risk is imminent and a response plan should be implemented. The formation of a hurricane that could make landfall and impact cost of materials is a risk trigger.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1259,
    "question": "In which project phase would a risk response plan be activated?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "As the project progresses through the Execution phase, the project team would be looking for risk triggers and then engaging a risk response plan should the need arise.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1260,
    "question": "Wigit Construction has completed the risk assessment and cost estimating activities. For certain risks, they have set aside money to cover the costs resulting from possible adverse effects on the project. What are these funds referred to as?",
    "choice_a": "Contingency reserve",
    "choice_b": "Ready reserve",
    "choice_c": "Resource reserve",
    "choice_d": "Management reserve",
    "correct_answer": "A",
    "explanation": "Contingency reserves are used to cover unforeseen costs or time that were not identified as part of the planning process. It is important to set expectations that these funds are not for extra functionality or enhancements, but to deal with circumstances like cost overruns, variances in estimates, and specific risk situations.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      29,
      36,
      49,
      190,
      196
    ],
    "source": "9781119892502"
  },
  {
    "id": 1261,
    "question": "What are the two forms of acceptance when considering risk response strategies?",
    "choice_a": "Passive",
    "choice_b": "Deliberate",
    "choice_c": "Unintentional",
    "choice_d": "Active",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Passive acceptance is when the project team is not able to eliminate all the threats to a project and decides not to take any action about the risk. Active acceptance includes developing contingency reserves to deal with risk should they occur.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1262,
    "question": "Management for Wigit Construction is concerned with understanding what the negative or positive impacts potential future events might have on a project. What is the management team asking about?",
    "choice_a": "Contingency planning",
    "choice_b": "MOU",
    "choice_c": "Risk",
    "choice_d": "Issues",
    "correct_answer": "C",
    "explanation": "The management team is looking for both the threats and opportunities the project might experience so that the appropriate risk response can be enacted.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1263,
    "question": "Every project faces the following potential risks EXCEPT:",
    "choice_a": "Quality defects",
    "choice_b": "Not staying on budget",
    "choice_c": "Scope creep",
    "choice_d": "Project not finishing on time",
    "correct_answer": "A",
    "explanation": "Quality defects are issues to be managed through the project rather than risks. The other answers represent the triple constraints of time, budget, and scope as it pertains to quality.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      33,
      32,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1264,
    "question": "Which of the following is a tool or technique used in identifying risks to a project?",
    "choice_a": "RASI",
    "choice_b": "SWOT",
    "choice_c": "RACI",
    "choice_d": "COQ",
    "correct_answer": "B",
    "explanation": "SWOT stands for strengths, weaknesses, opportunities, and threats and is an exercise to do an environmental scan at a moment in time. This environmental scan can reveal risks to a project.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1265,
    "question": "What is the risk response strategy that attempts to minimize the impact or the probability of a negative risk known as?",
    "choice_a": "Avoid",
    "choice_b": "Transfer",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "C",
    "explanation": "Mitigation of a risk is reducing the chance the risk would happen or lessening the impact in the event the risk does get triggered.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      31,
      195,
      192,
      190,
      194
    ],
    "source": "9781119892502"
  },
  {
    "id": 1266,
    "question": "WigitCom and DewDrops have entered into a partnership to complete a project. Wigitcom wants to ensure that their trade secrets are not revealed or used by DewDrops. What type of agreement should the two organizations use?",
    "choice_a": "RFP",
    "choice_b": "NDA",
    "choice_c": "SLA",
    "choice_d": "MOU",
    "correct_answer": "B",
    "explanation": "A nondisclosure agreement assures what's discussed, revealed, or created is kept confidential for WigitCom.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      195,
      190,
      191,
      31
    ],
    "source": "9781119892502"
  },
  {
    "id": 1267,
    "question": "WigitCom is working on a cutover to a new phone system for an agency with a security component. During the planned outage, a problem is discovered that cannot be solved immediately. What should the project team do?",
    "choice_a": "Continue to implement the change.",
    "choice_b": "Implement the regression plan and reverse the changes.",
    "choice_c": "Evaluate the impact and justification of an extended outage.",
    "choice_d": "Identify and document the change.",
    "correct_answer": "B",
    "explanation": "During any change where the team starts with a working product and the change disrupts the availability, it makes sense to reverse the changes. In some Agile practicing software companies, they may only roll forward to the next version of the software rather than reverse any changes. In this example, the availability of phones due to the security component would make it important to roll back.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      36,
      38
    ],
    "source": "9781119892502"
  },
  {
    "id": 1268,
    "question": "At the completion of a government project requiring security clearance, what document would a vendor likely be asked to sign?",
    "choice_a": "Service-level agreement",
    "choice_b": "Warranty",
    "choice_c": "Request for proposal",
    "choice_d": "Nondisclosure agreement",
    "correct_answer": "D",
    "explanation": "NDAs are common contract vehicles for jobs in both the government and private sector that would require a security clearance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      195,
      29,
      31,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1269,
    "question": "Which of the following roles should be included in the identification of risk on a project?",
    "choice_a": "Subject matter experts (SMEs)",
    "choice_b": "Core team members",
    "choice_c": "Stakeholders",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "All three of these roles can contribute to the identification of risk on a project.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      32,
      33,
      297,
      298,
      42
    ],
    "source": "9781119892502",
    "choice_e": "Both B and C"
  },
  {
    "id": 1270,
    "question": "WigitCom is working on a revolutionary new technology that will potentially alter the entire industry. At an industry conference, a project team member is asked what the team is working on. The employee doesn't share any project details. What is most likely the cause of the employee refusing to share information?",
    "choice_a": "Criticality factors",
    "choice_b": "Cultural differences",
    "choice_c": "Confidentiality constraints",
    "choice_d": "Intraorganizational differences",
    "correct_answer": "C",
    "explanation": "When dealing with a cutting-edge technology project, secrecy can play a key role in being the first to market and/or protecting intellectual property. Confidentiality constraints would prevent the team member from sharing with the rest of the industry until the project is complete.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      196,
      191,
      32,
      33
    ],
    "source": "9781119892502"
  },
  {
    "id": 1271,
    "question": "A government agency has two different business units that have a fleet of trash trucks to pick up garbage. To help save money, the agency decides to move the garbage collection function to a single agency and sell the trash trucks of the other agency. What type of business change is this?",
    "choice_a": "Business process change",
    "choice_b": "Outsourcing",
    "choice_c": "Internal reorganization",
    "choice_d": "Staff turnover",
    "correct_answer": "C",
    "explanation": "Internal reorganizations can disrupt a project if resources are no longer available to work on the project.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      42,
      297,
      298,
      299,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1272,
    "question": "Which of the following is not true regarding environmental, social, and governance (ESG) factors?",
    "choice_a": "It is imperative the project manager understands ESG as it relates to the project so that regulations, standards, and guidelines are followed.",
    "choice_b": "Awareness of applicable regulations and standards is an ESG factor.",
    "choice_c": "PII is an ESG factor that relates to the social factor.",
    "choice_d": "Project impact to company brand value is an ESG factor.",
    "correct_answer": "C",
    "explanation": "PII stands for personally identifiable information and is not part of ESG.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      195,
      29,
      30,
      31,
      32
    ],
    "source": "9781119892502"
  },
  {
    "id": 1273,
    "question": "WigitCom is constructing a new mobile ridesharing app. Users of the service will be required to share their location data to sign up for a ride. Which of the following ESG factors would the company need to consider for this project?",
    "choice_a": "National and local privacy laws and regulations",
    "choice_b": "Choosing waterfall versus an Agile approach",
    "choice_c": "Mitigating risk factors",
    "choice_d": "Critical path activities impacting project planning",
    "correct_answer": "A",
    "explanation": "Companies and projects must be aware of applicable regulations and standards impacting products and services. Complying with privacy laws at both a national and a local level will be critical for the success of the project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      32,
      195,
      31,
      33
    ],
    "source": "9781119892502"
  },
  {
    "id": 1274,
    "question": "DewDrops is the parent company for SunRays, Inc. and DaisyChains. SunRays and DaisyChains agree to provide services to each other and outline specific performance expectations acceptable to the parent company. Which ESG factors would impact the SunRays and DaisyChains projects?",
    "choice_a": "Submitting to audits and inspections",
    "choice_b": "DewDrops data security access policy",
    "choice_c": "DewDrops's mission, vision, and values",
    "choice_d": "Risk tolerance for each of the three companies",
    "correct_answer": "C",
    "explanation": "Awareness of company vision, mission statements, and values is key to help influence decision-making and behaviors of the project team.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      42,
      43,
      45,
      48,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1275,
    "question": "What does PII stand for?",
    "choice_a": "Professional infrastructure information",
    "choice_b": "Personally identifiable information",
    "choice_c": "Professional identifiable information",
    "choice_d": "Personal infrastructure information",
    "correct_answer": "B",
    "explanation": "The U.S. Department of Homeland Security (DHS) defines personally identifiable information or PII as \u201cany information that permits the identity of an individual to be directly or indirectly inferred, including any information that is linked or linkable to that individual, regardless of whether the individual is a U.S. citizen, lawful permanent resident, visitor to the U.S., or employee or contractor.\u201d.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      31,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1276,
    "question": "DewDrops has established a project team in another country. Several stakeholders are irritated because of the difficulty in getting approvals to begin work from the provincial government. This is an example of what kind of ESG factor impacting the project?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "B",
    "explanation": "Regulations and approvals can vary between countries and the various economic unions that can govern commerce both local and globally. Being aware of any regulations and standards that must be followed will help with the timely execution of a project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      190,
      195,
      297
    ],
    "source": "9781119892502"
  },
  {
    "id": 1277,
    "question": "What does PHI stand for?",
    "choice_a": "Personal health information",
    "choice_b": "Professional health initiative",
    "choice_c": "Protected health information",
    "choice_d": "Personal health initiative",
    "correct_answer": "C",
    "explanation": "HIPAA protected health information, or PHI, is any personal health information that can potentially identify an individual, that was created, used, or disclosed in the course of providing healthcare services, whether it was a diagnosis or treatment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      30,
      195,
      29,
      31,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1278,
    "question": "A new U.S. state law gives customers the ability to request what data a company is storing about their users and how the company is using this information. A global company is having to adjust their product design to conform with this requirement. Which ESG factor is the cause for the project to change in this manner?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "B",
    "explanation": "As more companies and industries make a shift to IT-driven services, understanding what standards are spelled out anywhere the service is used becomes a key factor of success. Failure to comply can lead to negative consequences anywhere, from large fines to restrictions for offering those services in certain countries or regions.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      32,
      29,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1279,
    "question": "Which of the following data sources are considered SPII? (Choose two.)",
    "choice_a": "City",
    "choice_b": "Driver's license number",
    "choice_c": "First name",
    "choice_d": "Social Security number (SSN)",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Sensitive personally identifiable information (SPII) is stand-alone data that by itself can identify an individual. If options A, C, and E are linked data and if combined with SPII, then they will become SPII.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      29,
      195,
      31,
      44,
      45
    ],
    "source": "9781119892502",
    "choice_e": "Political party"
  },
  {
    "id": 1280,
    "question": "<i>We Are Here for You!</i> has done work for DewDrops in the past, and has begun to advertise and market that DewDrops is a current project client without DewDrops's consent. What ESG factor might cause DewDrops to issue a cease and desist letter to <i>We Are Here for You!</i> to correct this behavior?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "D",
    "explanation": "DewDrops would be working to make sure the impact to the company brand value is in their control and that the project will not negatively impact their image.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      195,
      191,
      32,
      33
    ],
    "source": "9781119892502"
  },
  {
    "id": 1281,
    "question": "A project manager is assembling a team for a medical company that looks for the highest standards in ethical behavior. The manager is excited by a candidate's skills, attitude, and experience, but a background check reveals the candidate misrepresented their education and work experience. Which ESG factor likely influenced the decision to move away from this candidate?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "C",
    "explanation": "When you know what you stand for, decisions become easier. In this example, there is a mismatch between the candidate's values and the values of the company. If the candidate were not trustworthy in representing their skills and experience, they wouldn't be trusted with patients' confidential information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      195,
      30,
      29,
      31
    ],
    "source": "9781119892502"
  },
  {
    "id": 1282,
    "question": "Which of the following is not true regarding ESG?",
    "choice_a": "PII is an ESG factor that relates to the social factor.",
    "choice_b": "It's imperative the project manager understands ESG as it relates to the project so that regulations, standards, and guidelines are followed.",
    "choice_c": "Awareness of applicable regulations and standards is an ESG factor.",
    "choice_d": "S in ESG stands for social.",
    "correct_answer": "A",
    "explanation": "PII stands for personally identifiable information and is not part of ESG.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      29,
      30,
      31,
      32
    ],
    "source": "9781119892502",
    "choice_e": "Project impact to company brand value is an ESG factor."
  },
  {
    "id": 1283,
    "question": "DewDrops is growing rapidly. The company's leadership wants to install a system that will allow customers to interact with the company to learn more about the company's products and to obtain support. What kind of a system are they considering?",
    "choice_a": "JAD",
    "choice_b": "ERP",
    "choice_c": "CRM",
    "choice_d": "SAFe",
    "correct_answer": "C",
    "explanation": "A customer relationship management (CRM) system is one that is used by companies to interact with their customers.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      43,
      42,
      46,
      48,
      40
    ],
    "source": "9781119892502"
  },
  {
    "id": 1284,
    "question": "The risk response strategy that focuses on shifting the liability for a negative risk to a third party is known as which one of the following?",
    "choice_a": "Avoid",
    "choice_b": "Transfer",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "B",
    "explanation": "Transfer is the strategy of moving the liability for the risk to a third party by purchasing insurance, performance bonds, and other tools.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1285,
    "question": "Risk planning includes all the following activities EXCEPT:",
    "choice_a": "Measuring the SPI and CPI",
    "choice_b": "Analyzing the potential impacts of each risk",
    "choice_c": "Identifying all potential risks to the project",
    "choice_d": "Creating a response to each risk",
    "correct_answer": "A",
    "explanation": "Measuring the Schedule Performance Index (SPI) and the Cost Performance Index (CPI) are a part of executing the project and not directly an activity of risk planning.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1286,
    "question": "In which phase of a project would you keep an eye on risks to see if any immediate action should be taken?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "During the Execution phase, the project observes whether a risk is triggered and takes the planned course of action should that occur.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1287,
    "question": "All of the following are response strategies to positive risks EXCEPT:",
    "choice_a": "Mitigate",
    "choice_b": "Exploit",
    "choice_c": "Share",
    "choice_d": "Enhance",
    "correct_answer": "A",
    "explanation": "The strategies used to respond to positive risks include exploit, share, enhance, and accept. Mitigate is a response strategy used for negative risks.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      29
    ],
    "source": "9781119892502"
  },
  {
    "id": 1288,
    "question": "All of the following are strategies to deal with negative risks EXCEPT:",
    "choice_a": "Register",
    "choice_b": "Avoid",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "A",
    "explanation": "The strategies used to deal with negative risks are avoid, transfer, mitigate, and accept.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      31,
      195,
      29,
      30,
      32
    ],
    "source": "9781119892502"
  },
  {
    "id": 1289,
    "question": "With a forecast for a worse than average hurricane season, a construction company is aware that certain material costs could rise if a hurricane makes landfall. They begin daily monitoring of the National Weather Service and start actively tracking any tropical storm as they form so they can quickly act to purchase materials in case a hurricane becomes a legitimate threat. What type of risk response strategy is this?",
    "choice_a": "Mitigate",
    "choice_b": "Transfer",
    "choice_c": "Share",
    "choice_d": "Enhance",
    "correct_answer": "D",
    "explanation": "The company is trying to enhance by monitoring the probability the risk will happen so they can act quickly to achieve positive benefits.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1290,
    "question": "Katie is a project manager whose last performance review just barely met the core standards of the organization. Which of the following choices would most accurately express Katie's risk tolerance?",
    "choice_a": "Risk avoider",
    "choice_b": "Risk decider",
    "choice_c": "Risk taker",
    "choice_d": "Risk observer",
    "correct_answer": "A",
    "explanation": "Since the need for success on her current project is probably needed for job security, Katie would most likely try to avoid risky decisions because the margin of error is so low.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      32,
      33,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1291,
    "question": "Karen is a superstar for a company who has had several stellar performance reviews in a row. Which choice would most accurately express Karen's risk tolerance?",
    "choice_a": "Risk avoider",
    "choice_b": "Risk observer",
    "choice_c": "Risk decider",
    "choice_d": "Risk taker",
    "correct_answer": "D",
    "explanation": "Because of the stability within her job due to great performance, Karen probably has a bigger cushion to gamble and take more risks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40
    ],
    "source": "9781119892502"
  },
  {
    "id": 1292,
    "question": "The project team has done an in-depth root cause analysis as to why certain risks might happen. The impact of these risks would lead to positive outcomes. What type of strategy is this project employing?",
    "choice_a": "Accept, negative risk strategy",
    "choice_b": "Exploit, positive risk strategy",
    "choice_c": "Enhance, positive risk strategy",
    "choice_d": "Transfer, negative risk strategy",
    "correct_answer": "C",
    "explanation": "This strategy watches for and emphasizes risk triggers to help enhance the probability or impact of certain risks.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1293,
    "question": "All of the following would be updates to the risk register following a qualitative risk analysis EXCEPT:",
    "choice_a": "Causes of risks",
    "choice_b": "Watch list of low-priority risks",
    "choice_c": "Risks requiring near-term responses",
    "choice_d": "Numerical evaluation of each risk",
    "correct_answer": "D",
    "explanation": "Quantitative risk analysis would add more concretely measured items like the numerical score for each risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      190,
      191,
      192,
      194
    ],
    "source": "9781119892502"
  },
  {
    "id": 1294,
    "question": "The process of determining what impact identified risks will have on project objectives and the probability that they will occur is called what?",
    "choice_a": "Qualitative risk analysis",
    "choice_b": "Identify risk",
    "choice_c": "Quantitative risk analysis",
    "choice_d": "Risk categorization",
    "correct_answer": "A",
    "explanation": "The probability ranking in this analysis would be high, medium, and low, and getting expert judgment on what the impact would be.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1295,
    "question": "There is a section of the project management plan that contains elements of risk, including the project methodology, roles and responsibilities, stakeholder tolerances, and categories. What is this called?",
    "choice_a": "Risk register",
    "choice_b": "Risk matrix",
    "choice_c": "Risk response plan",
    "choice_d": "Risk management plan",
    "correct_answer": "D",
    "explanation": "The risk management plan outlines how the project will define, monitor, and control risks throughout the project.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1296,
    "question": "Which of the following are risk response strategies? (Choose two.)",
    "choice_a": "Avoidance",
    "choice_b": "Assumptions",
    "choice_c": "Acceptance",
    "choice_d": "Analysis",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Avoidance and acceptance are both risk responses to deal with negative risks.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Actual cost"
  },
  {
    "id": 1297,
    "question": "DewDrops is working on building the project team, and it is attempting to conduct interviews with company employees located in a different city. Their company practice is to interview candidates in person, but they attempted to conduct video interviews instead due to global travel restrictions related to the ongoing pandemic. What ESG factors influenced this change in direction?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "A",
    "explanation": "The COVID-19 pandemic revealed the impacts travel can have in the spread of a highly contagious illness. Understanding how project needs can impact the local and global environment will influence the planning and execution of a project. In this example, you see various ESG factors in conflict with one another as DewDrops values in interviewing in person are in conflict with global safety. It is not uncommon for project managers to have to navigate conflicting constraints.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      32,
      33,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1298,
    "question": "A company has a large datacenter with nearly a thousand servers and a host of enterprise applications. To align with the company's mission statement, there is a project to move away from high datacenter costs while keeping operational consistency. Which cloud environment should be pursued?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "XaaS",
    "choice_d": "SaaS",
    "correct_answer": "B",
    "explanation": "Maintaining datacenters represents the highest levels of cost, making IaaS the correct cost-saving option. Infrastructure as a service allows the cloud consumer to provision servers, storage, networking, operating systems, and other computing resources on demand. With IaaS, companies have the ability to stand up servers, operating systems, networking hardware, databases, and applications that mirror (or even improve on) the current datacenter environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      49,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1299,
    "question": "What is the purpose of a data warehouse?",
    "choice_a": "To bring various data sources together for the purpose of analysis and decision-making",
    "choice_b": "To separate the data's physical location from other applications",
    "choice_c": "To handle extremely large data environments",
    "choice_d": "To bring all the company's unstructured data together in a central location",
    "correct_answer": "A",
    "explanation": "A data warehouse is a collection of data for the purpose of helping stakeholders make sense out of the data for the purpose of analysis and decision-making. Data in a data warehouse may include internal as well as external data resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      42,
      43,
      44,
      47
    ],
    "source": "9781119892502"
  },
  {
    "id": 1300,
    "question": "WigitCom needs a third party to handle hardware and software tools for the application development team to complete a project. Which cloud model should the project team look to use?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "XaaS",
    "choice_d": "PaaS",
    "correct_answer": "D",
    "explanation": "A platform as a service (PaaS) provider hosts the hardware and software on its own infrastructure for users over the internet.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      40,
      49,
      36,
      37,
      38
    ],
    "source": "9781119892502"
  },
  {
    "id": 1301,
    "question": "What are some disadvantages of using a platform as a service (PaaS)? (Choose three.)",
    "choice_a": "Increased pricing at large scales",
    "choice_b": "More effective application development",
    "choice_c": "Lack of operational features",
    "choice_d": "Reduced control",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Using a service will limit the control the customer has over features, updates, and timing of service. It is also possible that the costs will increase as the use of the service grows.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      49,
      41,
      36,
      37
    ],
    "source": "9781119892502",
    "choice_e": "Public, private and hybrid options",
    "choice_f": "Greater product visibility"
  },
  {
    "id": 1302,
    "question": "All of the following are advantages of using a PaaS EXCEPT:",
    "choice_a": "Reduced complexity",
    "choice_b": "Reduced control",
    "choice_c": "Self-ramping up or down of infrastructure",
    "choice_d": "Easier maintenance and enhancement of applications",
    "correct_answer": "B",
    "explanation": "Reduced control can be a disadvantage to the project team and ongoing support when feature changes and timing of upgrades are controlled by the hosting company and not the customer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      49,
      41,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1303,
    "question": "What is a cloud model that offers essential compute, storage, and networking resources on demand using a pay-as-you-go model?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "XaaS",
    "choice_d": "SaaS",
    "correct_answer": "A",
    "explanation": "This is the definition of infrastructure as a service, which provides virtualized computing resources over the internet.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      40,
      49,
      36,
      38,
      39
    ],
    "source": "9781119892502"
  },
  {
    "id": 1304,
    "question": "Which system would be used to help enforce document retention requirements for an IT project's documentation, including project plans and deliverables?",
    "choice_a": "Data warehouse",
    "choice_b": "Enterprise resource planning (ERP)",
    "choice_c": "Customer relationship management (CRM)",
    "choice_d": "Content management system (CMS)",
    "correct_answer": "D",
    "explanation": "Content management systems help with the organization's tagging, retrieval, and deletion of documents when a retention schedule has been applied to the documents.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      45,
      46,
      42,
      195,
      297
    ],
    "source": "9781119892502"
  },
  {
    "id": 1305,
    "question": "All of the following would be considered drivers of adopting a SaaS application EXCEPT:",
    "choice_a": "Decrease the need to update and maintain traditional client-server applications.",
    "choice_b": "Standardization of the HTTPS protocol providing lightweight security.",
    "choice_c": "Reduced costs of developing new software services.",
    "choice_d": "Organization is forced to remain current as the hosting company updates features.",
    "correct_answer": "D",
    "explanation": "Granted, this can be considered a bit of a trick question. Some organizations are poor at keeping current on an application, leading to risks related to doing no upkeep on the software. That said, being forced to update software and test against an organization's business process whenever the hosting company wants and regardless of the customer's timing is a challenge rather than a driver.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      49,
      42,
      43,
      297
    ],
    "source": "9781119892502"
  },
  {
    "id": 1306,
    "question": "What is a software application that manages back-office activities such as accounting, human resources, supply chain, operations, and procurement called?",
    "choice_a": "Enterprise resource planning (ERP)",
    "choice_b": "Customer relationship management (CRM)",
    "choice_c": "Content management system (CMS)",
    "choice_d": "Database management system (DBMS)",
    "correct_answer": "A",
    "explanation": "ERP systems help organizations manage day-to-day business activities and can vary in size and function depending on the organization and industry using the software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      47,
      43,
      48,
      44
    ],
    "source": "9781119892502"
  },
  {
    "id": 1307,
    "question": "Which software platform would a company use to easily track all communications and nurture the experience people have with their products and services?",
    "choice_a": "Enterprise resource planning (ERP)",
    "choice_b": "Customer relationship management (CRM)",
    "choice_c": "Content management system (CMS)",
    "choice_d": "Database management system (DBMS)",
    "correct_answer": "B",
    "explanation": "Customer relationship management is a process organizations use to administer their interactions with customers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      48,
      40,
      46
    ],
    "source": "9781119892502"
  },
  {
    "id": 1308,
    "question": "A transit company is looking to set up an application where riders can get from one location to another using a software application to coordinate all the legs of their journey. Which of the following identifies what type of model this is?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "XaaS",
    "choice_d": "SaaS",
    "correct_answer": "C",
    "explanation": "XaaS is a collective term that refers to the delivery of anything as a service, in this example mobility as a service. XaaS provides a platform where users can access IaaS, PaaS, and SaaS providers as well as their on-premises services.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      40,
      41,
      49,
      36,
      42
    ],
    "source": "9781119892502"
  },
  {
    "id": 1309,
    "question": "In a multitiered architecture, in which tier does the user interact with the system?",
    "choice_a": "Presentation",
    "choice_b": "Processing",
    "choice_c": "Data",
    "choice_d": "Application",
    "correct_answer": "A",
    "explanation": "The Presentation layer ensures that the interactions passing through it are in the appropriate form for the data to be saved and used in other tiers of the architecture.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      37,
      36,
      38,
      39,
      44
    ],
    "source": "9781119892502"
  },
  {
    "id": 1310,
    "question": "What does MFA stand for?",
    "choice_a": "Multifactor architecture",
    "choice_b": "Multifactor authentication",
    "choice_c": "Mid-tier form architecture",
    "choice_d": "Middle factor authentication",
    "correct_answer": "B",
    "explanation": "Multifactor authentication (MFA) is a security technology that requires multiple methods of authentication from independent categories or credentials to gain access to systems and networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      192,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1311,
    "question": "Kaysie is applying for a job working on a passenger space flight project for a government agency. To help confirm her employment, what steps might be required for Kaysie to be hired as the project manager? (Choose two).",
    "choice_a": "Background screening",
    "choice_b": "Branding restrictions",
    "choice_c": "Service-level agreement",
    "choice_d": "Clearance requirements",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Highly sensitive projects across industries may require the candidate to obtain a security clearance to gain employment. While common when working for certain government agencies, this may also be a requirement for companies that support those agencies. A background screening may be required for employment regardless of whether a security clearance is involved.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      193,
      192,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1312,
    "question": "Desiree has pulled into the parking lot at work and is approaching a door where she must scan her badge to gain entrance into the building. Which security concept does this action represent?",
    "choice_a": "Facility access",
    "choice_b": "Background screening",
    "choice_c": "Multifactor authentication",
    "choice_d": "Removable media considerations",
    "correct_answer": "A",
    "explanation": "Organizations may lock down buildings or areas within buildings to make sure that only those individuals granted access may physically be in that location. This practice can protect again loss of trade secrets and unauthorized access by bad actors attempting to harm sensitive parts of a business. In areas of medical research, areas may be locked down to protect against contamination of clean rooms where research is being conducted or patients are being cared for.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      192,
      194,
      190,
      195,
      193
    ],
    "source": "9781119892502"
  },
  {
    "id": 1313,
    "question": "When determining if a project team can view privileged information, which three elements must the team member possess to be allowed to view the information? (Choose three.)",
    "choice_a": "Personally identifiable information (PII)",
    "choice_b": "A need to know the information",
    "choice_c": "Security clearance",
    "choice_d": "Protected health information (PHI)",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The three pillars of access are the individual must have clearance, access, and a need to know the information. If they do not possess all three, the information should not be shared with them. For example, a team member might have clearance and access to information but in their role, they do not possess a need to know the information. Therefore, the information should not be shared with them.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      193,
      194,
      190,
      191
    ],
    "source": "9781119892502",
    "choice_e": "Access to the information",
    "choice_f": "Industry specific compliance"
  },
  {
    "id": 1314,
    "question": "A project is working on a new industry changing technology. To help protect this information, they mark this information as confidential and lock up all key documents and files when there is no one in the room. Why are these documents marked as confidential?",
    "choice_a": "To project national security",
    "choice_b": "To protect trade secrets",
    "choice_c": "To coverup wrongdoing",
    "choice_d": "To identify removable media considerations",
    "correct_answer": "B",
    "explanation": "The project is protecting trade secrets that will help them gain a competitive advantage in the marketplace. They are ensuring that they protect their intellectual property.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      196,
      192,
      191,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1315,
    "question": "DewDrops Medical has made a breakthrough in anxiety treatment with the development of a new medication. What is the best way for the company to protect their intellectual property?",
    "choice_a": "File for a patent.",
    "choice_b": "File for a trademark.",
    "choice_c": "File for a copyright.",
    "choice_d": "File for multifactor authentication.",
    "correct_answer": "A",
    "explanation": "A patent is a limited property right relating to a discovery or invention in exchange for public disclosure of the invention. In this instance, DewDrops Medical needs to release information about their discovery so they can start selling the treatment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      32,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1316,
    "question": "<i>We Are Here for You!</i> temp agency has hired a firm to create a catchy new jingle that will help customers remember the name and purpose of the company when the company advertises. When they complete the song, what is the best way for the company to protect their intellectual property?",
    "choice_a": "File for a patent.",
    "choice_b": "File for a trademark.",
    "choice_c": "File for a copyright.",
    "choice_d": "File for multifactor authentication.",
    "correct_answer": "C",
    "explanation": "A copyright grants the creator of the original work exclusive rights to use and distribute their creation. Copyrights are used in writings, music, and art, to name a few areas.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      196,
      32,
      33,
      190,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1317,
    "question": "A project team has created an awesome logo for the new product they are creating that identifies the unique device customers can buy. What is the best way to protect their intellectual property?",
    "choice_a": "File for a patent.",
    "choice_b": "File for a trademark.",
    "choice_c": "File for a copyright.",
    "choice_d": "File for multifactor authentication.",
    "correct_answer": "B",
    "explanation": "A trademark is used to protect a brand by identifying any word, name, symbol, device, or any combination intended to be used in the identification of goods and services and to distinguish them from other parties' goods and services.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      196,
      195,
      190,
      191,
      192
    ],
    "source": "9781119892502"
  },
  {
    "id": 1318,
    "question": "A project team is working for a national department of defense in the creation of new technology to assist medical teams on the battlefield. What is the best answer on why this information might be classified?",
    "choice_a": "To protect intellectual property",
    "choice_b": "To protect national security information",
    "choice_c": "To protect trade secrets",
    "choice_d": "To establish background screening requirements",
    "correct_answer": "B",
    "explanation": "There are multiple good answers in this question, but the best answer is to protect national security information. The clues in the question to look for are working with a national government, working with a department of defense, and would support operations in a battlefield. This is all information related to national security.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      193,
      192,
      194,
      196
    ],
    "source": "9781119892502"
  },
  {
    "id": 1319,
    "question": "A project team working on an industry changing technology has a computer policy preventing USB drives from being accessed from the project team's computers. What type of physical security does this policy represent?",
    "choice_a": "Data classification",
    "choice_b": "Multifactor authentication",
    "choice_c": "Mobile device considerations",
    "choice_d": "Removable media considerations",
    "correct_answer": "D",
    "explanation": "Removable media such as hard drives, USB drives, and even mobile phones are great for convenience but represent a risk of loss of data to bad actors when removed from a controlled environment. Moreover, it can violate data retention policies and the ability to find information if data is stored on a remote media device that is not plugged into the network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      195,
      191,
      29,
      31
    ],
    "source": "9781119892502"
  },
  {
    "id": 1320,
    "question": "What are all the reasons a company may lock down the use of removable media on the corporate network? (Choose two.)",
    "choice_a": "To prevent malware and virus",
    "choice_b": "To make users work experience harder",
    "choice_c": "To prevent loss of protected data",
    "choice_d": "To comply with the company's mission, vision, and value",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "While convenience and security are constantly in conflict with one another, the key reasons for this type of policy are to control protected data and to limit the risk to harmful software such as virus and malware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      195,
      190,
      191,
      29
    ],
    "source": "9781119892502"
  },
  {
    "id": 1321,
    "question": "Which law established protected health information and the rules governing its release?",
    "choice_a": "OSHA",
    "choice_b": "HIPPA",
    "choice_c": "DoCRA",
    "choice_d": "PgMP",
    "correct_answer": "B",
    "explanation": "HIPPA stands for the Health Insurance Portability and Accountability Act, which was enacted on August 21, 1996, and that governs standards for electronic exchange, privacy, and security of health information. This act defined protected health information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      30,
      195,
      29,
      31,
      32
    ],
    "source": "9781119892502"
  },
  {
    "id": 1322,
    "question": "Which of the following would not be considered personally identifiable information?",
    "choice_a": "Name",
    "choice_b": "Social Security number",
    "choice_c": "Date of birth",
    "choice_d": "Census data",
    "correct_answer": "D",
    "explanation": "The classification of PII and non-PII can be vague. Nonpersonal data such as generalized data, aggregated statistics, or a partially or fully masked IP addresses is data that will not allow you to identify an individual.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      31,
      44,
      48
    ],
    "source": "9781119892502"
  },
  {
    "id": 1323,
    "question": "What is the process used to document, identify, and authorize changes in an IT environment?",
    "choice_a": "Organizational change management",
    "choice_b": "Executive oversight",
    "choice_c": "Change control",
    "choice_d": "Promote to production",
    "correct_answer": "C",
    "explanation": "Change control can vary slightly between software and infrastructure. The key is to know what changes are made to the environment and the routines that would be followed if there is a problem with the change. This minimizes the amount of downtime the service has.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1324,
    "question": "The project team is ready to make a change to a web application already in use by an organization. Which artifact should the project manager refer to in rolling out the changes?",
    "choice_a": "Downtime/maintenance window schedules",
    "choice_b": "Customer notifications",
    "choice_c": "Tiered architecture",
    "choice_d": "Data warehouse",
    "correct_answer": "A",
    "explanation": "Maintenance windows are pre-negotiated time blocks that let the project team know when it is okay to bring down an IT service that is already in production.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      36,
      46,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1325,
    "question": "The project team has been asked to identify what actions will be taken if a given IT change has a problem or causes a nonrepairable outage. What has the project team been asked to create?",
    "choice_a": "Automate tests",
    "choice_b": "Risk assessment",
    "choice_c": "Rollback plan",
    "choice_d": "Validation checks",
    "correct_answer": "C",
    "explanation": "A rollback plan is established ahead of time so that everyone knows what immediate action is needed to restore service within the maintenance window. In the middle of a process and or a crisis, it can be difficult to think on the fly the steps that might be needed to restore functionality.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1326,
    "question": "David is the IT change manager supporting a large energy company. In support of an upcoming project change, he has established emails to be sent two weeks in advance, a week in advance and the day of the changes so users can expect an outage and a new layout when the service comes back online. What is David working on?",
    "choice_a": "Rollback plan",
    "choice_b": "Notifications",
    "choice_c": "Validation checks",
    "choice_d": "Maintenance windows",
    "correct_answer": "B",
    "explanation": "Notifications happen before, during (depending on the length of the outage/change), and after. Always overcommunicate when you have a production change.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1327,
    "question": "Jarred is a virtualization engineer on a project that is rolling out a configuration change to the whole server farm. After the change, he runs a script that checks to make sure all servers are back online and that their applications are running. What part of the change control process did he perform?",
    "choice_a": "Check downtime schedule.",
    "choice_b": "Execute a rollback plan.",
    "choice_c": "Execute validation checks.",
    "choice_d": "Send customer notifications.",
    "correct_answer": "C",
    "explanation": "Validation checks help to ensure that the change was successful and that all services are available to the end user or customer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1328,
    "question": "While on a project, Jen has been asked to make a change to an e-commerce application responsible for 90 percent of the organization's revenue. She starts to analyze how long the change might take, what security vulnerabilities exist, and what downstream processes might be impacted by the change. What part of the change control process is Jen performing?",
    "choice_a": "Risk assessment",
    "choice_b": "Automated testing",
    "choice_c": "Release management",
    "choice_d": "Promote to production",
    "correct_answer": "A",
    "explanation": "A risk assessment happens when a change to software is requested to gain an understanding of all possible problems and opportunities that might exist with the change.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      298,
      297,
      299,
      190,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1329,
    "question": "The project team is setting up an application that will record all the steps in a timekeeping process. They can then run the steps whenever the team updates the software code. What did the project team set up?",
    "choice_a": "Rollback plan",
    "choice_b": "Automated testing",
    "choice_c": "Manual testing",
    "choice_d": "Risk assessment",
    "correct_answer": "B",
    "explanation": "When the end-to-end process enabled by software is large and/or the changes are frequent, automated testing allows for better quality control before the application is released to production.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      298,
      299,
      297,
      37,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1330,
    "question": "The project team is doing all their work in a development environment. They move any changes to a testing environment for validation before they promote the code to production. What operational change control process concept does this represent?",
    "choice_a": "Automate testing",
    "choice_b": "Manual testing",
    "choice_c": "Tiered architecture",
    "choice_d": "Enterprise architecture",
    "correct_answer": "C",
    "explanation": "A tiered architecture allows for development and testing to take place outside of a production environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      298,
      297,
      37,
      36,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1331,
    "question": "Eva has completed the software upgrade related to a project-required change. She calls Wally and asks him to verify the changes by logging in and entering a record to confirm the application is working. What is she asking Wally to do?",
    "choice_a": "Automated testing",
    "choice_b": "Manual testing",
    "choice_c": "Risk assessment",
    "choice_d": "Requirements definition",
    "correct_answer": "B",
    "explanation": "Manual testing is where a person and not a computer script or application performs testing through actions like logging in the system, running a report, or entering a record. This is appropriate if the application is small or the change is minor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      298,
      297,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1332,
    "question": "The project team has been asked to add some additional functionality to an existing application. A business analyst sits down with the stakeholders to be walked through what the application needs to do, how it needs to look, and what other applications or reports the data needs to be shared with. What part of the change control process is the business analyst performing?",
    "choice_a": "Requirements definition",
    "choice_b": "Customer notifications",
    "choice_c": "Release management",
    "choice_d": "Rollback planning",
    "correct_answer": "A",
    "explanation": "Knowing what success looks like can make or break a project and any change begins with a good requirements definition.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      298,
      297,
      299,
      42,
      48
    ],
    "source": "9781119892502"
  },
  {
    "id": 1333,
    "question": "Denise is part of a change control meeting where she presents her proposed change, the timing and communication to stakeholders, and her rollback plan. She gets a green light to proceed. What was Denise seeking during the meeting?",
    "choice_a": "Nothing, this was purely information.",
    "choice_b": "Clarification of the maintenance window.",
    "choice_c": "Approval of the change.",
    "choice_d": "Validation of the change.",
    "correct_answer": "C",
    "explanation": "A change control manager or approval board helps to ensure everything is ready and the change has followed the appropriate process before a go decision is given.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      297,
      298,
      299,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1334,
    "question": "One project team member has been placed on a performance improvement plan while assigned to a project. The rest of the project team is upset because they do not see management correcting any of this team member's behaviors. What is causing this misunderstanding?",
    "choice_a": "Cultural difference",
    "choice_b": "Confidentiality constraints",
    "choice_c": "Rapport building",
    "choice_d": "Criticality factors",
    "correct_answer": "B",
    "explanation": "Along with nondisclosure agreements, personnel actions are confidential and are not shared beyond the employee and management. As such, it can appear to those not in the know that nothing is happening to correct the problem.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      190,
      191,
      193,
      194
    ],
    "source": "9781119892502"
  },
  {
    "id": 1335,
    "question": "Which of the following is an example of linkable data becoming SPII?",
    "choice_a": "When the link connects an individual's name to a corporate website",
    "choice_b": "When an individual is shown to live within a specific zip code",
    "choice_c": "When the computer IP address is shown",
    "choice_d": "When an individual's name is linked to their Social Security number",
    "correct_answer": "D",
    "explanation": "When linkable data elements such as zip code, date of birth, and more are associated with an SPII data element, the linkable data element becomes sensitive personally identifiable information. SPII stands for sensitive personally identifiable information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      31,
      44,
      45
    ],
    "source": "9781119892502"
  },
  {
    "id": 1336,
    "question": "A medical laboratory has a secure door that can only be accessed through a retinal scan and by scanning an authorized badge. What security concept is being enacted in this scenario?",
    "choice_a": "Branding restrictions",
    "choice_b": "Scrum retrospective",
    "choice_c": "Legal and regulatory impacts",
    "choice_d": "Facility access",
    "correct_answer": "D",
    "explanation": "Facility access is a form of physical security used to prevent unauthorized access to a location, building, or part of a building.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      192,
      194,
      190,
      191,
      193
    ],
    "source": "9781119892502"
  },
  {
    "id": 1337,
    "question": "Wigit Construction has focused on implementing sustainable practices into its processes and has been hired to build a new bridge over a rail line and a wildlife open space. The triple constraints would imply that the project manager work with time, budget, and scope as it relates to quality in getting this project done. What two aspects of sustainable practices should also govern the project manager's approach to completing this project? (Choose two.)",
    "choice_a": "Ensure pollution prevention in the construction to preserve the wildlife habitat.",
    "choice_b": "Create a fund to help convince local decision-makers to waive environmental regulations.",
    "choice_c": "Create a task force to ensure property rights for the rail line and the wildlife habitat are maintained.",
    "choice_d": "Maintain speed of completion as the most important factor even if crews must work long hours for weeks on end.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Sustainable practices include many areas such as human rights, labor practices, the environment, fair operating practices, consumer issues, and community involvement. Option A acknowledges the need to preserve the environment and habitat for wildlife. Option C commits Wigit Construction to fair labor practices. Options B and D would violate the company's vision and values to be more sustainable.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      32,
      33,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1338,
    "question": "Time, budget, and scope are considered the triple constraints to tactical project management. What are the three factors that influence sustainable project management from a strategic context?",
    "choice_a": "Environmentally sound, viral social media, economically viable",
    "choice_b": "Economically viable, on time, on budget",
    "choice_c": "Environmentally sound, socially responsible, economically viable",
    "choice_d": "Economically viable, environmentally sound, return on investment",
    "correct_answer": "C",
    "explanation": "Environmentally sound, socially responsible, and economically viable are three factors where trade-offs must be made in a similar way to the tactical triple constraints.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      29,
      36,
      49,
      190,
      196
    ],
    "source": "9781119892502"
  },
  {
    "id": 1339,
    "question": "Which authentication method requires the user to provide two or more pieces of verification evidence to log into your account?",
    "choice_a": "Certificate-based authentication",
    "choice_b": "Token-based authentication",
    "choice_c": "Multifactor authentication",
    "choice_d": "Biometric authentication",
    "correct_answer": "C",
    "explanation": "Multifactor authentication (MFA) helps protect personal information, financial assets, or company systems from access by an unauthorized third party. It is possible that each of the other options in this question could be one factor of authentication used in an MFA login.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      192,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1340,
    "question": "For a sustainable-driven company, which of the following is not an area to be evaluated when planning the procurement activities of a project?",
    "choice_a": "Suppliers' past performance or reputation",
    "choice_b": "Unique local requirements of the supplier or project site",
    "choice_c": "Focus on lowest bidder to control costs",
    "choice_d": "The sustainable goals of the provider",
    "correct_answer": "C",
    "explanation": "While viewed in a silo, a focus on lowest-cost bidder alone could be detrimental to a buyer's vision, mission statement, and values. However, it is important to realize there still may be a business driver to focus on keeping costs low to stay on budget. Low costs are not a unique sustainability factor.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      33,
      32,
      195,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1341,
    "question": "Risk management focuses on identifying all the positive and negative events that might impact the success of a project or activity. Which of the following would be considered a nontechnical risk?",
    "choice_a": "Project budget is lacking to complete the project.",
    "choice_b": "Local regulations require 30 percent of the project team to live within the country.",
    "choice_c": "The speed to market of the product will determine the market winner.",
    "choice_d": "The time to complete the project is insufficient for the requirements requested.",
    "correct_answer": "B",
    "explanation": "Time, budget, and scope are all technical issues related to project management. Awareness of applicable regulations and standards would be an environmental, social, and governance risk factor, or not technical to the core project itself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1342,
    "question": "WigitCom has a project to open a store in a new country in which it has never done business before. This new country has laws called the consumer bill of rights, which outline a company's responsibility to collecting private data as well as a consumer's ability to see and/or restrict the collection of this data. Which ESG factor would influence WigitCom's project activities?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of appliable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "B",
    "explanation": "Organizations and their project teams must be alert to the interests of the broader stakeholder community. In this instance, the regulations and standards of the new country will absolutely inform how the business will conduct business in-country. Moreover, in an era of global technology companies, one country's laws may force the entire company to adhere to their expectations such as in the cases of personally identifiable information collection.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      29,
      195,
      33,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1343,
    "question": "In May 2018, Europe enacted the GDPR with widespread implications to privacy and the treatment of data. What does GDPR stand for?",
    "choice_a": "Greater Data Privacy and Remediation",
    "choice_b": "General Data Protection Regulation",
    "choice_c": "Greater Discovery for Protecting Remote Access",
    "choice_d": "General Data Privacy Regulation",
    "correct_answer": "B",
    "explanation": "While the GDPR acronym may not be on the test, it was one of the first major privacy laws and it informs how data is treated today. Knowing about the GDPR and its components can help you prepare for the exam and prepare you for when you are a project manager in the real world.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      29,
      32,
      195,
      31,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1344,
    "question": "The Payment Card Industry Data Security Standards (PCI DSS) address the handling and management of payment card data. This act covers all aspects of payment card data handling, including acquiring, transmitting, storing, and processing these data. What is the PCI DSS an example of?",
    "choice_a": "Industry-specific compliance",
    "choice_b": "Personally identifiable information",
    "choice_c": "Regulatory impacts",
    "choice_d": "Country-specific privacy stipulation",
    "correct_answer": "A",
    "explanation": "Financial services worldwide need to make sure they are PCI-DSS compliant to protect payment card handling and sort out vulnerabilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1345,
    "question": "The Sarbanes\u2013Oxley Act is a 2002 U.S. law and was enacted to protect against fraudulent financial transactions by corporations. Sarbanes\u2013Oxley would be an example of which compliance consideration?",
    "choice_a": "Industry-specific compliance",
    "choice_b": "Protected health information",
    "choice_c": "Country-specific compliance regulation",
    "choice_d": "National security information",
    "correct_answer": "C",
    "explanation": "This question provides an example of a country-specific compliance situation. Being aware of this and similar laws will help provide context to questions on the exam. Moreover, it will help you prepare for real-world project management situations you might face.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1346,
    "question": "Deploying a new information system into production while failing to safeguard security and privacy would have all of these inherent risks EXCEPT:",
    "choice_a": "Disclosure of information",
    "choice_b": "Unauthorized access to systems and information",
    "choice_c": "Failing a project gate review",
    "choice_d": "Breach of legal requirements",
    "correct_answer": "C",
    "explanation": "Disclosure of information, unauthorized access to systems and information, and legal breaches would all be risks that failing to properly design and deploy information systems would have.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      32,
      195,
      298
    ],
    "source": "9781119892502"
  },
  {
    "id": 1347,
    "question": "All of the following are used in an Agile approach to project management EXCEPT:",
    "choice_a": "Burndown charts",
    "choice_b": "WBS",
    "choice_c": "Continuous requirements gathering",
    "choice_d": "Sprint planning",
    "correct_answer": "B",
    "explanation": "The work breakdown structure is characteristic of a more deliberate, up-front requirements gathering where many of the requirements are identified early in the project.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1348,
    "question": "Which information security concept addresses where and how your data is stored?",
    "choice_a": "Digital security",
    "choice_b": "Physical security",
    "choice_c": "Network and system security",
    "choice_d": "Application security",
    "correct_answer": "B",
    "explanation": "Physical security guides all parameters regarding where and how your data is stored. In addition to organization and project requirements, remember that different states and countries have very specific laws governing data security.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      192,
      195,
      36,
      39,
      41
    ],
    "source": "9781119892502"
  },
  {
    "id": 1349,
    "question": "Sam has been assigned to work remotely in the United States on a project in South America. Why might Sam have to take additional precautions to store data beyond his company's ordinary data practices?",
    "choice_a": "To enhance the brand value to the company brought on by the project",
    "choice_b": "To protect national security information since data is flowing internationally",
    "choice_c": "To align to local security laws governing where and how to store data",
    "choice_d": "To take advantage of a new data warehouse being constructed",
    "correct_answer": "C",
    "explanation": "Operating in a different state or country than the project or product team members are accustomed to can mean your data storage practices do not align with the needs or legal considerations of your customer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      29,
      195,
      41,
      40
    ],
    "source": "9781119892502"
  },
  {
    "id": 1350,
    "question": "Which of the following are examples of physical security considerations? (Choose three.)",
    "choice_a": "Network uptime and availability",
    "choice_b": "Smoke and fire alarms",
    "choice_c": "Access control systems",
    "choice_d": "User authentication",
    "correct_answer": [
      "B",
      "C",
      "F"
    ],
    "explanation": "Smoke/fire alarms, physical access control systems, and data backups are all related to physical security. Network uptime and availability is a component of network security. User authentication would be application-level security, whereas risk management policies are compliance directives.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      192,
      36,
      38,
      39,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Risk management polices",
    "choice_f": "Data backups"
  },
  {
    "id": 1351,
    "question": "Which of the following is not an area of application security?",
    "choice_a": "Data backup and availability",
    "choice_b": "Data sharing and role-based access control",
    "choice_c": "Project management software data encryption",
    "choice_d": "User authentication",
    "correct_answer": "A",
    "explanation": "Data backup and availability is a component of physical security. Monitoring user activities and mobile application security are other areas of application security.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      194,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1352,
    "question": "Which of the following is both a serious risk management issue and a compliance/legal matter?",
    "choice_a": "Branding restrictions",
    "choice_b": "Anything as a service",
    "choice_c": "Data security classification",
    "choice_d": "Data privacy",
    "correct_answer": "D",
    "explanation": "Reputational and brand harm resulting from a privacy breach can be severe and invite litigation, lead to a loss of business, or result in significant financial damages to the project and organization.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      29,
      31,
      195,
      32,
      196
    ],
    "source": "9781119892502"
  },
  {
    "id": 1353,
    "question": "The commitment to keep a person's or organization's information private and protect unauthorized disclosure of information from being disclosed is known as which of the following?",
    "choice_a": "Confidentiality",
    "choice_b": "Security clearance",
    "choice_c": "Privacy",
    "choice_d": "Data sensitivity",
    "correct_answer": "A",
    "explanation": "Confidentiality protects information from disclosure without the consent of the individual or organization the information is about.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      195,
      190,
      192
    ],
    "source": "9781119892502"
  },
  {
    "id": 1354,
    "question": "Which project management tool helps determine whether a system, process, or program involving personal information raises privacy risks?",
    "choice_a": "Multitiered architecture",
    "choice_b": "Privacy impact assessment",
    "choice_c": "Service-level agreement",
    "choice_d": "Backlog prioritization",
    "correct_answer": "B",
    "explanation": "A PIA is a risk management tool and can help evaluate risks and propose solutions to privacy and data confidentiality needs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      31,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1355,
    "question": "Crystal has applied for a job supporting a national space program and has been asked to complete documentation that will allow a thorough review of her trustworthiness to work on the project. Which information security concept is in play for this applicant?",
    "choice_a": "Clearance requirements",
    "choice_b": "Facility access",
    "choice_c": "Background screening",
    "choice_d": "Access on a need-to-know basis",
    "correct_answer": "C",
    "explanation": "A background screen provides a wide variety of facts that can help determine the integrity and trustworthiness of a candidate. Disqualifying aspects for a position or to obtain clearance can include lying on an application, a previous criminal record, or significant credit or financial problems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      195,
      190,
      191,
      192
    ],
    "source": "9781119892502"
  },
  {
    "id": 1356,
    "question": "What is the purpose of establishing security clearances for project team members?",
    "choice_a": "Democratize data to even the playing field for all.",
    "choice_b": "Create needed overhead to keep people employed.",
    "choice_c": "Allow vetted individuals access to restricted information.",
    "choice_d": "Protect the team members' personally identifiable information.",
    "correct_answer": "C",
    "explanation": "A security clearance is one of the three pieces related to data access: clearance, access, and a need-to-know.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      195,
      194,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1357,
    "question": "Project team members are required to get a badge that opens electronic locks for access to where a new product is being created. Which type of security access does this represent?",
    "choice_a": "Physical security",
    "choice_b": "Operational security",
    "choice_c": "Digital security",
    "choice_d": "Application security",
    "correct_answer": "A",
    "explanation": "Physical security requirements may restrict movement in and out of certain rooms, wings, or buildings.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      192,
      190,
      191,
      194,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1358,
    "question": "A project has developed a new political polling application to help in an upcoming election. The application was originally developed for a single state's use, but now there seems to be a market for the application across the country. Which of the following is not one of the actions the project team should take next?",
    "choice_a": "Assess legal and regulatory impacts for a national rollout",
    "choice_b": "Identify country- and state-specific privacy regulations",
    "choice_c": "Enable multifactor authentication for project team members",
    "choice_d": "Conduct a privacy impact assessment",
    "correct_answer": "C",
    "explanation": "Multifactor authentication, specifically for project team members and not users, is an example of information security. The other three options are all related to privacy and compliance identification and remediation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      29,
      31,
      195,
      194
    ],
    "source": "9781119892502"
  },
  {
    "id": 1359,
    "question": "WigitCom's project manager is ready for the team to promote new code to production. In talking with the business, they decide the third Sunday between 8 p.m. and 11 p.m. would be the most ideal as business is the slowest during that time. What did the project manager and business just negotiate?",
    "choice_a": "Promote to production plan",
    "choice_b": "Automated testing",
    "choice_c": "Customer notifications",
    "choice_d": "Maintenance window",
    "correct_answer": "D",
    "explanation": "A maintenance window communicates the time when a change to an IT system would be the least disruptive to the business. Maintenance windows can be set globally via a schedule or determined on an ad hoc basis.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      297,
      298,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1360,
    "question": "Which of the following are reasons to build sustainability into project management practices?",
    "choice_a": "Reduces resource turnover",
    "choice_b": "Reduces project crisis situations",
    "choice_c": "Minimizes project cancellations and interruptions",
    "choice_d": "Creates a competitive advantage",
    "correct_answer": "E",
    "explanation": "Designing your project approach sustainably can have benefits across the board and will create sustainability benefits that survive beyond the end of the project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "All of the above",
    "choice_f": "None of the above"
  },
  {
    "id": 1361,
    "question": "A project is underway to expand service to a new country. This new country has laws called the consumer bill of rights governing the collection of private data as well as a consumer's ability to see and/or restrict the collection of this data. Since the project team is part of a global company, would they have to adhere to these regulations?",
    "choice_a": "No, as a global company they need to manage their service to the global need and not the local company.",
    "choice_b": "No, the company was not doing business when the law was passed.",
    "choice_c": "Yes, to avoid fines or a loss of the ability to do business in country, they must conform to the law.",
    "choice_d": "Yes, as a gesture of goodwill, the company should start out following the law and then use their leverage later to avoid compliance.",
    "correct_answer": "C",
    "explanation": "Earning the right to do business in-country and avoid punishment is the most correct answer of these options. By proactively complying with the law, the company's brand value will not be adversely impacted, affecting its profitability and growth potential. Additionally, while some activities may be legal in certain countries like the minimum age of employment, it may be in the best interests of the company to comply with a higher standard than the law requires. Clearly, following regulations earns points as the right thing to do.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      32,
      29,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1362,
    "question": "A project manager is working on a new ride share system in the United States. The project manager is aware of the GDPR law that was passed in Europe. Although the project is based in the United States, why might the project manager need to adhere to the GDPR?",
    "choice_a": "They would not; the laws of the United States are the only ones that matter.",
    "choice_b": "For ease of scalability, in case the application is ever moved to Europe.",
    "choice_c": "They would not, since the application would never be used in Europe.",
    "choice_d": "When data on European citizens is stored, companies must abide by the GDPR.",
    "correct_answer": "D",
    "explanation": "If you build a product and allow citizens from all countries to use it, then the GDPR will apply to the way European customers' data is processed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      32,
      195,
      31,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1363,
    "question": "Why might a company consider choosing to integrate sustainability concepts into their project management practices?",
    "choice_a": "Organizations want to assume the responsibility for the societal impacts of their products and services.",
    "choice_b": "Organizations want to avoid the risk associated with their products and services.",
    "choice_c": "Organizations want their customers to assume responsibility for the societal impacts of their products and services.",
    "choice_d": "Organizations do not want to integrate sustainability into their projects because it is bad for the bottom line.",
    "correct_answer": "A",
    "explanation": "Sustainability concepts in project management have emerged as one of the most important trends in project management around the world. Projects are the mechanisms that allow organization-wide change.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1364,
    "question": "What is the \u201ctriple bottom line\u201d in creating sustainability in project management?",
    "choice_a": "Balance between time, money, and scope as it pertains to quality",
    "choice_b": "Harmony between time, scope, and economic sustainability",
    "choice_c": "Balance between social sustainability, environmental sustainability, and scope as it pertains to quality",
    "choice_d": "Harmony between economic, social, and environment sustainability",
    "correct_answer": "D",
    "explanation": "The three ESG factors of environmental, social, and governance become the triple bottom-line elements to sustainability relating to people, profit, and the planet.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      49,
      29,
      33,
      36,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1365,
    "question": "Where should the identification of relevant environmental and social risks and impacts be recorded?",
    "choice_a": "They are not recorded as part of a project.",
    "choice_b": "They are recorded in the risk register.",
    "choice_c": "They are recorded in the meeting minutes.",
    "choice_d": "They are recorded in the issue log.",
    "correct_answer": "B",
    "explanation": "The risk register is the correct location for the recording of ESG factors impacting, or potentially impacting, a project. It may be important to add a category field to the risk register to identify the ESG variables.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1366,
    "question": "Which ESG factor shows up as a criterion for deciding whether to take on a project and how to execute that project?",
    "choice_a": "Environmental",
    "choice_b": "Social",
    "choice_c": "Governance",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "Projects must consider their impact on the environment, and identifying this impact is important as early as in the Discovery and Concept Preparation phase.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      29,
      31,
      32,
      33,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1367,
    "question": "Which ESG factor considers the relationships among stakeholders who take part in or are influenced by a project?",
    "choice_a": "Environmental",
    "choice_b": "Social",
    "choice_c": "Governance",
    "choice_d": "None of the above",
    "correct_answer": "B",
    "explanation": "Projects must consider the impact on people whether it impacts their jobs, their way of doing business, or their community.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1368,
    "question": "Which ESG factor directs the way a project will be led as well as the regulations and standards that may dictate how the project will unfold and what processes must be followed?",
    "choice_a": "Environmental",
    "choice_b": "Social",
    "choice_c": "Governance",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "Awareness and adherence of applicable government regulations, industry standards, and organizational policies and procedures are a critical success factor of modern-day projects.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1369,
    "question": "Which of the following are reasons to build sustainability into project management practices?",
    "choice_a": "Increases resource turnover",
    "choice_b": "Maximizes project crisis situations",
    "choice_c": "Ensures project cancellations and interruptions",
    "choice_d": "Creates a competitive advantage",
    "correct_answer": "D",
    "explanation": "Companies who embrace sustainability beginning at the project level will have a competitive advantage over those organizations that do not by reducing future negative liabilities, increasing brand value, and attracting and retaining top talent.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      30,
      29,
      33,
      36,
      49
    ],
    "source": "9781119892502",
    "choice_e": "All of the above",
    "choice_f": "None of the above"
  },
  {
    "id": 1370,
    "question": "Which ESG factor is most likely to get overlooked in project planning and execution?",
    "choice_a": "Environmental",
    "choice_b": "Social",
    "choice_c": "Governance",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "Impacts on employees, clients, and others oftentimes take a backseat to financial, governance, and environmental concerns.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      43,
      45,
      195,
      191
    ],
    "source": "9781119892502",
    "choice_e": "None of the above"
  },
  {
    "id": 1371,
    "question": "Questions such as \u201cWill the customer experience service be disrupted?,\u201d \u201cWill the project team be expected to work extended hours?,\u201d and \u201cHow will a new organizational structure affect diversity?\u201d are related to which ESG factor?",
    "choice_a": "Environmental",
    "choice_b": "Social",
    "choice_c": "Governance",
    "choice_d": "Organizational",
    "correct_answer": "B",
    "explanation": "These are all elements related to social responsibility in project management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1372,
    "question": "WigitCom planned a project to decommission a datacenter but failed to consider how to properly dispose of retired servers, monitors, and network gear. The original plan had an activity to select the lowest bidder for the disposal, but a local regulation requires this type of equipment be disposed of through a certified electronics recycler. Which two ESG factors contributed to this project change? (Choose two.)",
    "choice_a": "Environmental",
    "choice_b": "Social",
    "choice_c": "Governance",
    "choice_d": "Organizational",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Properly recycling electronic equipment helps environmental sustainability while also following local regulations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      191,
      195,
      36,
      33
    ],
    "source": "9781119892502"
  },
  {
    "id": 1373,
    "question": "Which of the following would be potential project impacts regarding governance? (Choose two.)",
    "choice_a": "Pollution of the local environment's water supply and landfills",
    "choice_b": "Project delays due to failing to consider regulatory requirements on the project schedule",
    "choice_c": "Rework due to failing to meet standards related to personal data",
    "choice_d": "Project team members not being appropriately compensated for overtime",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Not accounting for appropriate approval process through government agencies will negatively impact a project schedule. Additionally, if the final product does not comply with pertinent regulations, it will add cost and delay the project in order to align to the standards.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      190,
      297,
      298
    ],
    "source": "9781119892502"
  },
  {
    "id": 1374,
    "question": "For a sustainable-driven company, which of the following is not an area to be evaluated when planning the procurement activities of a project?",
    "choice_a": "Suppliers' past performance or reputation",
    "choice_b": "Unique local requirements of the supplier or project site",
    "choice_c": "Ability to comply with industry standards such as HIPPA or PCI",
    "choice_d": "The ability to adhere to meet time deadlines over all other requirements",
    "correct_answer": "D",
    "explanation": "While time is of the essence in most projects, a sustainable organization would look to balance the timeframe with its ESG goals.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      29,
      29,
      31,
      190,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1375,
    "question": "DewDrops just launched a new vision to be the model for sustainable practices in their industry. A project is nearing completion when this new mission was announced through a press release. What steps, if any, should the project team take to account for this change in vision?",
    "choice_a": "Do nothing; stakeholders will understand the project was almost complete when this was announced.",
    "choice_b": "Put a warning on their product that the product will likely change in the future because of this announcement.",
    "choice_c": "Perform a sustainability impact assessment to see if there are deliverables that need to be changed and update the project plan if so.",
    "choice_d": "Move forward \u201cas is\u201d and incorporate the new philosophy into future projects.",
    "correct_answer": "C",
    "explanation": "It is common for assumptions and constraints to shift during a project, and when there is a major change linked to a brand's value, the correct course is to evaluate the impact of the change and communicate to the project steering committee any impacts to time, budget, and scope.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      297,
      298,
      299
    ],
    "source": "9781119892502"
  },
  {
    "id": 1376,
    "question": "The CEO of a large corporation has asked to be granted access to all digital files for a new project. Why might the CEO be denied this request despite being the highest-ranking individual in the organization?",
    "choice_a": "Does not have clearance.",
    "choice_b": "Does not have access.",
    "choice_c": "Does not have a need to know.",
    "choice_d": "This request should always be granted.",
    "correct_answer": "C",
    "explanation": "The principle of least privilege provides guidance on how to keep a project's or an organization's data safe. In this example, the CEO should be granted access to only the relevant documents they need to perform their job. Blindly granting extensive access to data if the individual does not have a business justification will increase the risk of data loss or cybersecurity risk. Only grant the minimum access needed to be able to perform the job.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      194,
      195,
      190,
      191,
      192
    ],
    "source": "9781119892502"
  },
  {
    "id": 1377,
    "question": "A software development project has changed project managers from Ellen to Michelle. Using the principle of least privilege, which level of access should Michelle be given to look at the project data?",
    "choice_a": "Michelle should be granted the same access as Ellen.",
    "choice_b": "Michelle should only be granted high-level access to data until she has been on the project longer.",
    "choice_c": "Michelle does not need access granted to her to perform her duties on the project.",
    "choice_d": "Michelle should be granted access to all information in the organization.",
    "correct_answer": "A",
    "explanation": "The business justification in this example is clear since there was already a role established giving access to data when Ellen was in the position. The project manager has a business need to see all documents, reports, and deliverables associated with the project or program they are working in.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      195,
      190,
      45,
      42
    ],
    "source": "9781119892502"
  },
  {
    "id": 1378,
    "question": "A project manager has asked for a legal review of a contract before it is awarded. The email the project manager receives from the legal team includes language stating \u201cThis correspondence represents privileged and confidential communication between a client and their attorney.\u201d What type of data security protocol does this warning provide?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Access on a need-to-know basis",
    "choice_c": "Data classification",
    "choice_d": "Background screening",
    "correct_answer": "C",
    "explanation": "Data classification helps to protect intellectual property, trade secrets, national security information, and privileged conversations between a doctor or lawyer and their client.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      195,
      196,
      32,
      191,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1379,
    "question": "Anvay is part of the IT security team and has been asked to grant permissions for a new employee to see the engineering team's file share. What step should Anvay take prior to performing this task?",
    "choice_a": "Grant the access immediately.",
    "choice_b": "Check the business justification and compare to established security protocols.",
    "choice_c": "Do not grant the access.",
    "choice_d": "Grant the access after an established waiting period.",
    "correct_answer": "B",
    "explanation": "If there is a sound business justification and the necessary approvals match the security protocols, there is no problem granting the access. The next step needs to validate the request before permissions are assigned to the engineering data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      194,
      190,
      193,
      45
    ],
    "source": "9781119892502"
  },
  {
    "id": 1380,
    "question": "A project team member is being terminated from a project involved with the development of intellectual property effective immediately. What is the appropriate course of action for the project manager?",
    "choice_a": "Brief the terminated employee on brand restrictions.",
    "choice_b": "Perform a background screening and check clearance requirements.",
    "choice_c": "Immediately revoke the terminated employee's permissions.",
    "choice_d": "Wait for guidance from human resources before doing anything.",
    "correct_answer": "C",
    "explanation": "When an employee suddenly leaves a project, either voluntarily or involuntarily, it is vital that their access to project materials and systems be removed immediately. This protects the organization from data destruction, sabotage, or loss of trade secrets.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      195,
      196,
      194,
      191,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1381,
    "question": "A list of steps undertaken to undo a release and restore a system to its original state is known as what?",
    "choice_a": "Risk assessment",
    "choice_b": "Anything as a service",
    "choice_c": "Continuous integration process",
    "choice_d": "Rollback plan",
    "correct_answer": "D",
    "explanation": "When implementing a change to a production system, it is important to minimize any downtime so the system is available. A rollback plan is a key step to quickly recover to an available status if there is a problem implementing the change.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1382,
    "question": "Which form of quality assurance for a software release would include team members following a checklist and performing actions such as data entry, validating functionality, and viewing reports?",
    "choice_a": "Automated testing",
    "choice_b": "Turing testing",
    "choice_c": "User acceptance testing",
    "choice_d": "Manual testing",
    "correct_answer": "D",
    "explanation": "New software or changes to applications must be tested prior to release. Manual testing is a key step that must be successfully completed before automated tests can be created and deployed.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      298,
      299,
      297,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1383,
    "question": "A system needs to be taken offline for maintenance to be performed. The project manager reviews the RACI chart and finds the dispatch center has to be informed about the outage. What change control step should the project manager take?",
    "choice_a": "Perform a risk assessment.",
    "choice_b": "Send customer notifications.",
    "choice_c": "Perform software validation checks.",
    "choice_d": "Release the software.",
    "correct_answer": "B",
    "explanation": "RACI charts, maintenance plans, and communication plans will inform how and when to give the customer updates on system activity. A good rule is to overcommunicate outages and changes with the appropriate stakeholders.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      191,
      195,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1384,
    "question": "A company has gone through a rapid growth cycle and now has several one-off systems for activities like the company's finances, supply, and human resources. The leaders of the company want to have a system that brings these activities together. What kind of system would meet these needs?",
    "choice_a": "CRM",
    "choice_b": "LAN",
    "choice_c": "ERP",
    "choice_d": "XaaS",
    "correct_answer": "C",
    "explanation": "When architecting a system that brings various corporate functionality together, an enterprise resource planning (ERP) system is often chosen.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      48,
      47,
      43,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1385,
    "question": "WigitCom has incorporated a sustainable focus into their project to build a new videoconferencing platform. Which of the following is not one of the elements the project manager would need to consider when adopting a more sustainable approach?",
    "choice_a": "Work-line balance of the project team to reduce burnout",
    "choice_b": "Limiting unnecessary travel of the project team to reduce emissions",
    "choice_c": "Creating a compensation model to get the most affordable project team",
    "choice_d": "Creating equitable hiring practices to support innovation and social inclusion",
    "correct_answer": "C",
    "explanation": "A sustainable approach would be to ensure a sufficient income for project team members to allow team members to provide support for themselves and their families.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      29,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1386,
    "question": "WigitCom has built a new application to allow customers to share their homes to guests who want to use the home for their vacation. They are excited for the opportunities this new software will provide to the property owners and renters alike. Which laws would make the most sense to design against from the inception of the project?",
    "choice_a": "GDPR",
    "choice_b": "HIPP-A",
    "choice_c": "PMBOK\u00ae",
    "choice_d": "PRINCE2",
    "correct_answer": "A",
    "explanation": "The General Data Protection Regulation would apply if data were being collected and stored on European citizens. While it would technically be possible to set up two different processes for European and non-European citizens, the most efficient software would follow the guidelines holistically, and the obligations are not overwhelming anyway.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      32,
      43,
      195,
      31
    ],
    "source": "9781119892502"
  },
  {
    "id": 1387,
    "question": "Trevor is the project manager over a civil engineering project, and one of the risks of the project has the potential for a sinkhole in the area where a road is supposed to be built. The project team reports that a sinkhole did in fact form in this area. Which two items are true about this event? (Choose two.)",
    "choice_a": "The risk has now become an issue.",
    "choice_b": "The project team accepted this risk.",
    "choice_c": "The risk trigger has happened, calling for a response.",
    "choice_d": "This needs to go through the change control process.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A risk becomes an active issue should it materialize, and the appropriate risk response strategy should be implemented.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1388,
    "question": "The project team is trying to update a software application that exists on a single-server environment. This is complicated testing, development, quality assurance, and training. What type of solution could they recommend to help the development of this application?",
    "choice_a": "Automated testing",
    "choice_b": "Requirements definition",
    "choice_c": "Tiered architecture",
    "choice_d": "Continuous deployment process",
    "correct_answer": "C",
    "explanation": "A tiered architecture would create stand-alone environments for production, testing, development, QA, and training protecting each of these activities from each other and maximizing uptime. A tiered architecture is more expensive and requires more staff to maintain, so there are trade-offs between cost and availability.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      37,
      298,
      36,
      297,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1389,
    "question": "WigitCom has a problem on an e-commerce website that is causing an outage resulting in a million dollars of lost revenue every hour. In which environment should changes be made?",
    "choice_a": "Testing",
    "choice_b": "Production",
    "choice_c": "Quality assurance",
    "choice_d": "Development",
    "correct_answer": "D",
    "explanation": "While it might be tempting to make the fixes directly in the production environment, having established environments for this work to be performed helps control not just this outage but future outages. Making the changes in development and then promoting the code through testing and production is the correct choice.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      298,
      297,
      37,
      36,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1390,
    "question": "In IT service management, what is the standard traditionally used for change control methods guiding the entire IT life cycle?",
    "choice_a": "Information Technology Infrastructure Library (ITIL)",
    "choice_b": "Project Management Body of Knowledge (PMBOK\u00ae)",
    "choice_c": "Business Analysis Body of Knowledge (BABOK)",
    "choice_d": "Awareness Desire Knowledge Ability Reinforcement (ADKAR)",
    "correct_answer": "A",
    "explanation": "The ITIL framework is widely used in the IT industry and sets the model for IT service delivery, including incident, problem, request, and change management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1391,
    "question": "Which type of change management focuses on service transitions such as moving from one vendor to another or getting all your departments on board with a new ERP platform?",
    "choice_a": "Organizational change management",
    "choice_b": "On-premises change control",
    "choice_c": "Cloud change control",
    "choice_d": "Shift change management",
    "correct_answer": "B",
    "explanation": "On-premises change control is based on ITIL, the Information Technology Infrastructure Library, which sets best practices in IT service management.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      297,
      298,
      299,
      42,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1392,
    "question": "Which change control method is divided into areas of focus such as business model, governance, and the use of a platform?",
    "choice_a": "Organizational change management",
    "choice_b": "On-premises change control",
    "choice_c": "Cloud change control",
    "choice_d": "Shift change management",
    "correct_answer": "C",
    "explanation": "Cloud change control is guided by AWS Cloud Adoption Framework (AWS CAF) and others and builds on the foundations created in ITIL change management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      299,
      298,
      297,
      190,
      42
    ],
    "source": "9781119892502"
  },
  {
    "id": 1393,
    "question": "All of the following are challenges with cloud change management EXCEPT:",
    "choice_a": "Siloed communications",
    "choice_b": "Restricted approval process",
    "choice_c": "Rapid approval process",
    "choice_d": "Legacy business processes lacking agility",
    "correct_answer": "C",
    "explanation": "A cloud change control process would benefit greatly from a speedy and agile approval process. However, when an organization transitions from on-premises to a cloud approach, typically legacy practices are cumbersome and slow compared to cloud implementation needs.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      299,
      297,
      298,
      49,
      41
    ],
    "source": "9781119892502"
  },
  {
    "id": 1394,
    "question": "Which change control approach needs to facilitate faster change processes?",
    "choice_a": "Organizational change management",
    "choice_b": "On-premises change control",
    "choice_c": "Cloud change control",
    "choice_d": "Shift change management",
    "correct_answer": "C",
    "explanation": "Cloud environments offer greater agility, which facilitates speed as it pertains to change. Licenses and subscriptions are always available and setting up new environments, and rolling back changes can happen with minimal steps.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      299,
      40,
      49,
      297,
      298
    ],
    "source": "9781119892502"
  },
  {
    "id": 1395,
    "question": "Which change control approach typically needs abundant planning for capacity upgrades and other infrastructure changes?",
    "choice_a": "Organizational change management",
    "choice_b": "On-premises change control",
    "choice_c": "Cloud change control",
    "choice_d": "Shift change management",
    "correct_answer": "B",
    "explanation": "Traditional IT environments must account for the sunk costs (previous investments) in existing infrastructure and handle multiple steps to be able to scale out the environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      36,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1396,
    "question": "Which change management philosophy is focused on the adoption of new business process, tools, and support models?",
    "choice_a": "Organizational change management",
    "choice_b": "On-premises change control",
    "choice_c": "Cloud change control",
    "choice_d": "Shift change management",
    "correct_answer": "A",
    "explanation": "Organizational change management using an approach like Prosci ADKAR focuses on people adjusting to and adopting new ways of doing business. It is important to know that ADKAR is a great method for individual change if one is seeking to adopt new habits.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1397,
    "question": "Which process refers to the planning, design, scheduling, testing, and deploying of new applications or upgrades?",
    "choice_a": "Cloud change control",
    "choice_b": "Incident or problem management",
    "choice_c": "On-premises change control",
    "choice_d": "Software release control",
    "correct_answer": "D",
    "explanation": "Software release management helps to maintain the available and supportability of the existing production environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      298,
      297,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1398,
    "question": "Which type of management is primarily concerned with how changes flow through preproduction environments?",
    "choice_a": "Problem management",
    "choice_b": "Release management",
    "choice_c": "Change management",
    "choice_d": "Project management",
    "correct_answer": "B",
    "explanation": "Release management enables successful releases to a production environment with minimal disruption and ensures future supportability.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      298,
      297,
      299,
      37,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1399,
    "question": "Wigit Construction has been tasked with repaving a bridge that is a major thoroughfare for a large metropolitan community. They are allowed to shut down traffic from midnight until five in the morning for two weeks straight. What would this five-hour block be called in operational change control terms?",
    "choice_a": "Release management",
    "choice_b": "Validation check",
    "choice_c": "Work breakdown structure",
    "choice_d": "Maintenance window",
    "correct_answer": "D",
    "explanation": "The ability to shut down the road so that the paving work can begin is an example of a downtime or maintenance window where the production system, in this case a road, is not available for use.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1400,
    "question": "Kayla has been working during an outage to upgrade a production database to its most current version. The upgrade is behind schedule, and she has three hours of work to complete in the next 45 minutes. What change control process should she execute?",
    "choice_a": "Perform validation checks.",
    "choice_b": "Initiate the rollback plan.",
    "choice_c": "Start automated testing.",
    "choice_d": "Modify the downtime window.",
    "correct_answer": "B",
    "explanation": "The best answer would be to roll back to the last stable production instance of the database. Maintenance windows are typically negotiated in advance and are not at the discretion of the technician to modify them. Note: There are instances where the downtime can be extended with communication and approval.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      44,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1401,
    "question": "The build and unit testing stages of a software release process where every version committed triggers an automated build and test is known as which of the following?",
    "choice_a": "Cloud change control",
    "choice_b": "Anything as a service",
    "choice_c": "Continuous integration/continuous deployment process",
    "choice_d": "Tier architecture/promote to production process",
    "correct_answer": "C",
    "explanation": "Some organizations embracing rolling forward instead of rolling back utilize automation for build and testing for release to production.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      299,
      298,
      297,
      49,
      40
    ],
    "source": "9781119892502"
  },
  {
    "id": 1402,
    "question": "What is a development process where programmers commit code to repositories frequently and ideally several times a day known as?",
    "choice_a": "Continuous integration",
    "choice_b": "Software release management",
    "choice_c": "Software as a service",
    "choice_d": "Enterprise resource planning",
    "correct_answer": "A",
    "explanation": "Continuous integration asks developers to commit their code frequently to bring greater speed and agility to building new features and delivering the right products for their customers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      299,
      298,
      297,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1403,
    "question": "The collection of hardware and software that determines how fast computations can be made, when systems are connected, and what storage is available is known as which of the following?",
    "choice_a": "Infrastructure as a service",
    "choice_b": "Multitiered architecture",
    "choice_c": "Electronic document and record management systems",
    "choice_d": "Computing services",
    "correct_answer": "D",
    "explanation": "End-user or server-level computing refers to the hardware's capability to process programmed functions. There are several elements that go into determining hardware's computing power, including processor, storage, memory, network connectivity, and software version.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      36,
      37,
      39,
      38,
      40
    ],
    "source": "9781119892502"
  },
  {
    "id": 1404,
    "question": "What is the correct definition of storage?",
    "choice_a": "The processing power, memory, networking, and other resources needed for computational success of a program",
    "choice_b": "The process through which digital data is saved and recovered through computer technology",
    "choice_c": "A structured set of data held in a computer with multiple channels for access",
    "choice_d": "A connected set of computers used to exchange data and share resources with each other",
    "correct_answer": "B",
    "explanation": "Storage is an IT term that can refer to both stored data and to the integrated hardware and software systems used to manage and secure data.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      39,
      36,
      49,
      40,
      41
    ],
    "source": "9781119892502"
  },
  {
    "id": 1405,
    "question": "What is the definition of a database?",
    "choice_a": "The processing power, memory, networking, and other resources needed for computational success of a program",
    "choice_b": "The process through which digital data is saved and recovered through computer technology",
    "choice_c": "A structured set of data held in a computer with multiple channels for access",
    "choice_d": "A connected set of computers used to exchange data and share resources with each other",
    "correct_answer": "C",
    "explanation": "Databases are used to organize a collection of structured information and are typically stored in a computer system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      44,
      42,
      48,
      37,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1406,
    "question": "In terms of information technology, what is the best way to describe a network?",
    "choice_a": "The processing power, memory, networking, and other resources needed for computational success of a program",
    "choice_b": "The process through which digital data is saved and recovered through computer technology",
    "choice_c": "A structured set of data held in a computer with multiple channels for access",
    "choice_d": "A connected set of computers used to exchange data and share resources with each other",
    "correct_answer": "D",
    "explanation": "Networking and the connectivity it brings refers to the extensive process of connecting parts of a network to one another using routers, switches, and gateways.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      38,
      36,
      37,
      297,
      49
    ],
    "source": "9781119892502"
  },
  {
    "id": 1407,
    "question": "The facilities department has all the blueprints and support plans for the corporate buildings they manage. Which of the following would be the appropriate location to store this information?",
    "choice_a": "Enterprise resource planning (ERP)",
    "choice_b": "Customer relationship management (CRM)",
    "choice_c": "Electronic document and records management system (EDRMS)",
    "choice_d": "Database management system (DBMS)",
    "correct_answer": "C",
    "explanation": "Electronic document and records management systems allow for organization and storage of large volumes of documents and allow retention schedules to be created determining how long information should be stored and when to remove it from the system.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      45,
      42,
      44,
      48,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1408,
    "question": "May has completed her work for the week. She logs into a system to record her time and billing for the week. When she completes that task, she moves to another part of the system to record her expenses for reimbursement purposes. What kind of system is May logged into?",
    "choice_a": "Data warehouse",
    "choice_b": "Customer relationship management",
    "choice_c": "Enterprise resource planning",
    "choice_d": "Content management systems",
    "correct_answer": "C",
    "explanation": "An ERP system such as Workday, SAP, or Oracle helps large organizations track and manage various day-to-day business functions. Summary data can often be offloaded to a data warehouse, but warehouses are not the primary systems for transactions like recording time and expenses.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      42,
      48,
      40,
      47,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1409,
    "question": "Max has been assigned as the project manager for a new IT project. She has been assigned an account code to track and report on all budget and spending items related to the project. Which software application does the organization assign and use this code?",
    "choice_a": "Financial systems",
    "choice_b": "Software as a service",
    "choice_c": "Data warehouse",
    "choice_d": "Project management information system",
    "correct_answer": "A",
    "explanation": "Financial systems are configured with the organization's chart of accounts, which is a complete list of financial account codes used to help the organization categorize and track expenditures for planning and reporting purposes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      47,
      42,
      48,
      44,
      45
    ],
    "source": "9781119892502"
  },
  {
    "id": 1410,
    "question": "The marketing department of DewDrops has just completed a campaign for a service in a new area. The team wants to share their data and findings with the rest of the company to help other departments and the corporate leadership look for trends and help guide future decision-making. Where should the team upload this information?",
    "choice_a": "Data warehouse",
    "choice_b": "Cloud storage",
    "choice_c": "Print the data and distribute hard copies",
    "choice_d": "To a PaaS provider",
    "correct_answer": "A",
    "explanation": "The key information in the question is storing the data where multiple stakeholders can analyze the data and drive future decision-making. A data warehouse stores cross-functional data for longer-term analytic purposes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      42,
      43,
      44,
      45
    ],
    "source": "9781119892502"
  },
  {
    "id": 1411,
    "question": "Which cloud model is a software licensing and delivery model where software is licensed on a subscription basis and is centrally hosted?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "XaaS",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "Software as a service is a strategy of most enterprise software companies. SaaS applications are typically accessed through a web browser and are typical for office software, messaging software, payroll processing, and more.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      49,
      42,
      43
    ],
    "source": "9781119892502"
  },
  {
    "id": 1412,
    "question": "What would you call detailed explanations of how to execute a process, method, task, or program that also outlines precise steps needed to successfully complete the item?",
    "choice_a": "Anything as a service",
    "choice_b": "Data warehouse",
    "choice_c": "Documentation",
    "choice_d": "Computing services",
    "correct_answer": "C",
    "explanation": "In complex organizations, documentation is key for organizational success, especially those whose primary focus is IT. Documentation helps communicate how something was created and/or configured and how to use the product or service.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      45,
      190,
      298,
      36,
      46
    ],
    "source": "9781119892502"
  },
  {
    "id": 1413,
    "question": "Which system would you use to process expense reports, make entries into the general ledger, or process PCard (purchasing card) or POs (purchasing orders)?",
    "choice_a": "Content management systems",
    "choice_b": "Data warehouse",
    "choice_c": "Electronic document and record management systems",
    "choice_d": "Financial systems",
    "correct_answer": "D",
    "explanation": "Financial systems can be included as a part of an enterprise resource planning platform or exist as stand-alone applications. Financial systems serve as the single source of truth for all financial transactions and reporting.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      47,
      42,
      40,
      41,
      48
    ],
    "source": "9781119892502"
  },
  {
    "id": 1414,
    "question": "Will works taking phone calls from the public dealing with a variety of issues, including billing, adding or ending service, or complaints about service quality. What type of system would Will be using to research the caller's history and find meaningful information related to their account?",
    "choice_a": "Enterprise resource planning (ERP)",
    "choice_b": "Customer relationship management (CRM)",
    "choice_c": "Content management system (CMS)",
    "choice_d": "Database management system (DBMS)",
    "correct_answer": "B",
    "explanation": "CRM systems help support the customer engagement process to improve customer satisfaction by empowering the support staff with data and access to address customer concerns.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      44,
      48,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1415,
    "question": "Nancy has been hired on to a project to help manage the social media presence and develop a website communicating the timing and upcoming products and services the project will deliver. Which software should she use to manage the website?",
    "choice_a": "Electronic document and records management system (EDRMS)",
    "choice_b": "Content management system (CMS)",
    "choice_c": "Customer relationship management (CRM)",
    "choice_d": "Enterprise resource planning (ERP)",
    "correct_answer": "B",
    "explanation": "CMS tools are used to manage the creation and modification of digital content on a website without the need to write code from scratch.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      46,
      40,
      41,
      42,
      43
    ],
    "source": "9781119892502"
  },
  {
    "id": 1416,
    "question": "Software development kits (SDKs), user guides, run books, and product manuals are all examples of which of the following?",
    "choice_a": "Data warehouse",
    "choice_b": "Customer relationship management",
    "choice_c": "Documentation",
    "choice_d": "Content management systems",
    "correct_answer": "C",
    "explanation": "Documentation is critical to understand decisions that were made regarding the creation of an application, how the software was configured, what changes were made over time, and how to use the product. Poor documentation leads to an inferior customer experience and service degradation over time.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      45,
      46,
      42,
      43,
      48
    ],
    "source": "9781119892502"
  },
  {
    "id": 1417,
    "question": "The project team has been asked to turn over all relevant records regarding the project and to assign the documents a category determining how long to keep the documentations after the project is completed. Where should the project manager look to evaluate which categories should be used?",
    "choice_a": "Organizational retention schedule",
    "choice_b": "Project charter",
    "choice_c": "Project management information systems",
    "choice_d": "Data warehouse",
    "correct_answer": "A",
    "explanation": "The exam is looking to test knowledge related to electronic document and record management systems. It is important to understand that an EDRMS uses an organization's retention schedule to prevent premature deletion as well as the appropriate destruction of documentation. A document's retention may be set by law, regulation, industry standard, or organizational policy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      45,
      32,
      33,
      195,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1418,
    "question": "A local government organization has determined the cost of hosting a disaster recovery site is prohibitive and so they are seeking a service provider capable of meeting their recovery time and recovery point objectives. What type of cloud model is this agency looking to use?",
    "choice_a": "Software as a service (SaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Anything as a service (XaaS)",
    "choice_d": "Infrastructure as a service (IaaS)",
    "correct_answer": "C",
    "explanation": "Anything as a service describes a general category of services related to cloud computing and remote access. In this example, it is a bucket for any end-to-end service that can be provided by a third party such as disaster recovery as a service (DRaaS).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      49,
      36,
      38
    ],
    "source": "9781119892502"
  },
  {
    "id": 1419,
    "question": "With the adoption of the European Union's General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA), which organizational business unit becomes a more important stakeholder for projects?",
    "choice_a": "Legal",
    "choice_b": "Public relations",
    "choice_c": "Finance",
    "choice_d": "Information technology",
    "correct_answer": "A",
    "explanation": "Organizations' legal departments are becoming dependent on project management to achieve compliance with laws governing personal and protected information.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      32,
      29,
      195,
      190,
      45
    ],
    "source": "9781119892502"
  },
  {
    "id": 1420,
    "question": "Which privacy consideration law requires integrating specific data protection practices into business offerings as well as adding processes to address data subject requests?",
    "choice_a": "GDPR",
    "choice_b": "CCPS",
    "choice_c": "HIPPA",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "All these laws fundamentally ask businesses to change how they collect, store, and protect data while giving the consumer visibility into that data.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      29,
      32,
      195,
      190,
      191
    ],
    "source": "9781119892502",
    "choice_e": "None of the above"
  },
  {
    "id": 1421,
    "question": "Which discipline helps legal departments stay in compliance with emerging laws on an ongoing basis?",
    "choice_a": "Project management",
    "choice_b": "Asset management",
    "choice_c": "Change management",
    "choice_d": "Internal and external audit",
    "correct_answer": "A",
    "explanation": "Project management serves at the crux of organizational change management initiatives. Accordingly, the project management discipline is core to keeping pace with compliance requirements as laws and regulations evolve over time.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      32,
      33,
      297,
      298,
      299
    ],
    "source": "9781119892502"
  },
  {
    "id": 1422,
    "question": "All of the following are reasons project management needs to be involved to achieve regulatory compliance EXCEPT:",
    "choice_a": "Regulations change over time.",
    "choice_b": "Data is being collected on an exponential pace.",
    "choice_c": "Laws of other countries do not carry regulatory impact.",
    "choice_d": "New regulations are constantly being enacted.",
    "correct_answer": "C",
    "explanation": "As the use of the internet continues to evolve, just because a law is not affected in your country doesn't mean your project does not need to meet the compliance requirements. Moreover, it is common for regulations to get reproduced from country to country.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      29,
      30,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1423,
    "question": "All of the following are risks of noncompliance of country, state, or province-specific privacy regulations in project management EXCEPT:",
    "choice_a": "Increase in security breaches",
    "choice_b": "Increase in consumer privacy considerations",
    "choice_c": "Loss of productivity",
    "choice_d": "Reputational damage",
    "correct_answer": "B",
    "explanation": "Noncompliant projects have major consequences both the consumer and the business. An increase in privacy protections is the key point of complying with laws, regulations, and IT security practices.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      29,
      32,
      31,
      195,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1424,
    "question": "A steering committee is questioning a proposed budget item in a project budget to ensure compliance with privacy laws. The committee debates the need for this activity to be completed as it carries a high cost. What is the best argument the project manager can make for the investment in compliance?",
    "choice_a": "Compliance is the cost of doing business.",
    "choice_b": "Noncompliance saves the company money and can be struck.",
    "choice_c": "No one will find out if the project does not perform that activity.",
    "choice_d": "Noncompliance costs the company more money.",
    "correct_answer": "D",
    "explanation": "It is estimated that the cost of noncompliance is three times higher than the cost of compliance. Complying with the regulatory environment checks the box legally, but the business is also doing the right thing, the best argument to combat the sticker shock of complying is that the cost of noncompliance is higher.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      32,
      31,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1425,
    "question": "Which of the following are not risks of failing to comply to regulatory requirements? (Choose two.)",
    "choice_a": "Penalties and fines",
    "choice_b": "Gain a competitive advantage",
    "choice_c": "Compliance litigation",
    "choice_d": "Reputational damage",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Companies and projects that comply hold a competitive advantage over those that do not. Moreover, the number of lawsuits brought against companies for noncompliance is increasing liability and costs, and even risk a company's survival.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      29,
      30,
      31
    ],
    "source": "9781119892502",
    "choice_e": "Restricted access to markets and product delays",
    "choice_f": "Regulated out of business"
  },
  {
    "id": 1426,
    "question": "What is a project manager's responsibility to behave ethically?",
    "choice_a": "Project managers abide by a code of ethics.",
    "choice_b": "It depends on the organization.",
    "choice_c": "Project managers must focus on schedule, budget, and scope above all things.",
    "choice_d": "Ethical behavior does not apply to project management.",
    "correct_answer": "A",
    "explanation": "Many associations, such as the Project Management Institute, asks their membership to agree to follow a Code of Ethics and Professional Conduct. This helps instill confidence in the project management profession as a whole. More importantly, it helps aspiring project management individuals become better overall practitioners.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      190,
      191,
      195,
      196,
      193
    ],
    "source": "9781119892502"
  },
  {
    "id": 1427,
    "question": "Professionals who act in an honest, responsible, and respectful way are exhibiting which type of behavior?",
    "choice_a": "Unethical",
    "choice_b": "Criminal",
    "choice_c": "Ethical",
    "choice_d": "Regulatory",
    "correct_answer": "C",
    "explanation": "Ethical professionals make the best leaders, lead by example, and create an environment where project team members want to do the right thing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      190,
      191,
      194,
      195,
      193
    ],
    "source": "9781119892502"
  },
  {
    "id": 1428,
    "question": "In which project life cycle phase should the regulatory impact assessment process begin?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "B",
    "explanation": "The best practice is to include regulatory impact assessment at project initiation as it will set the mindset of compliance for the entire project. It can be difficult to make a significant mindset change when a project is in flight.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      190,
      195,
      297
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1429,
    "question": "All of the following would be considered basics for compliance in project management EXCEPT:",
    "choice_a": "Add compliance activities to the project schedule.",
    "choice_b": "Ensure regulatory management responsibility is assigned.",
    "choice_c": "Monitor changes in regulation.",
    "choice_d": "Manage compliance risk and activities as its own project.",
    "correct_answer": "D",
    "explanation": "Compliance requirements and risks need to be ingrained in all projects and not bundled in a stand-alone and often symbolic project.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      32,
      33,
      190,
      195,
      297
    ],
    "source": "9781119892502"
  },
  {
    "id": 1430,
    "question": "Wigit Construction has been hired to create a new highway road signage system for a large state. They have undertaken this project in other states as well, so they have a solid boilerplate for their project activities. Does a regulatory scan still make sense for this project due to repeatability of successful projects delivered in other states?",
    "choice_a": "No, highway and constructions projects are beholden to national laws and regulations, so compliance is assured.",
    "choice_b": "Yes, state-level regulations may differ, and a regulatory scan will help to illuminate the requirements.",
    "choice_c": "No, highway projects are not concerned with privacy implications as it serves a public good.",
    "choice_d": "Yes, even as a non-value-added activity, the documentation of performing the step will reduce future liability.",
    "correct_answer": "B",
    "explanation": "Regulatory impact assessments are a best practice and should be performed in good faith regardless of the repeatability of the project and whether it pertains to privacy. Some governments have regulations governing how tax dollars can be spent and event guidance on how projects must be completed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1431,
    "question": "In 2015, the U.S. federal government enacted the Program Management Improvement and Accountability Act. What area of compliance is this area focused on?",
    "choice_a": "Privacy",
    "choice_b": "Project management",
    "choice_c": "Financial management",
    "choice_d": "Healthcare",
    "correct_answer": "B",
    "explanation": "This legislation enhances accountability and best practices in project and program management at the federal level. While a question on the PMIAA is unlikely on the exam, the question is a reminder that beyond open data and privacy, it is important to be aware of other industry compliance regulations that need to be followed during a career in project management. Performing an individual regulatory impact assessment could be a differentiator when applying for project management jobs and give you a competitive advantage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      190,
      195,
      297
    ],
    "source": "9781119892502"
  },
  {
    "id": 1432,
    "question": "A company utilizing its offshore team has just won a contract to work on replacing a government agency's financial system. The contract stipulates there is personally identifiable information stored in the system and has a service-level agreement enforcing this clause. What steps if any should the project manager take as the project team is built?",
    "choice_a": "Educate the team on the importance of cybersecurity.",
    "choice_b": "Educate the team on the contract clause and their responsibilities.",
    "choice_c": "Educate the team on personally identifiable data and how to handle it.",
    "choice_d": "All of the above.",
    "correct_answer": "D",
    "explanation": "Education is the first step in handling projects, creating systems, and securing data to make sure stakeholder information is correctly protected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      195,
      193,
      190,
      31
    ],
    "source": "9781119892502",
    "choice_e": "Only A and C."
  },
  {
    "id": 1433,
    "question": "Benched resources are when the project has which of the following issues?",
    "choice_a": "Individuals who are finished with the project but have not yet started a new assignment",
    "choice_b": "Individuals who have too much work for them to be able to complete the project",
    "choice_c": "A lack of talent in the industry, which leads to a shortage of qualified personnel on the project",
    "choice_d": "Individuals ordered to the sidelines because of their performance",
    "correct_answer": "A",
    "explanation": "Individuals who are finished with the project but have not started a new assignment are benched resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1434,
    "question": "In which of the following situations would team-building efforts provide the most impact on a project? (Choose three.)",
    "choice_a": "Team discord",
    "choice_b": "Schedule changes",
    "choice_c": "Missed deliverables",
    "choice_d": "Project phase completion",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "When there is no harmony with the team, team-building exercises can assist in restoring morale. When a phase is completed, it can be beneficial to celebrate the progress on the project and recognize the contributions of the team. Any kind of change in the team dynamic can impact the project, especially when the leadership is new.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      29,
      36,
      49,
      190,
      196
    ],
    "source": "9781119892502",
    "choice_e": "Lessons learned meeting",
    "choice_f": "Change in project manager"
  },
  {
    "id": 1435,
    "question": "Which of the following statements is true regarding a SWOT analysis?",
    "choice_a": "Strengths/weaknesses are external to the organization; opportunities/threats are internal to the organization.",
    "choice_b": "Strengths/weaknesses/opportunities/threats are all external to the organization.",
    "choice_c": "Strengths/weaknesses are internal to the organization; opportunities/threats are external to the organization.",
    "choice_d": "Strengths/weaknesses/opportunities/threats are all internal to the organization.",
    "correct_answer": "C",
    "explanation": "SWOT involves analyzing the project from strengths/weaknesses that are internal to the organization, as well as opportunities/threats that are external to the organization.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      29,
      36,
      49,
      190,
      196
    ],
    "source": "9781119892502"
  },
  {
    "id": 1436,
    "question": "In the project management context, what does COQ stand for?",
    "choice_a": "Cost of quality",
    "choice_b": "Critical to quality",
    "choice_c": "Cost of quantities",
    "choice_d": "Critical of quantities",
    "correct_answer": "A",
    "explanation": "Cost of quality, or COQ, represents the costs needed to bring a substandard product or service produced by the project within the standard described by the Quality Plan or other criteria.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      49,
      29,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1437,
    "question": "Which of the following would you need in the calculation of the risk score? (Choose two.)",
    "choice_a": "SPI",
    "choice_b": "Risk impact",
    "choice_c": "CPI",
    "choice_d": "Risk probability",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The risk score is the risk probability, typically expressed as a number between 0.0 and 1.0, multiplied by the risk impact. Projects may choose different quantifiable measures for probability and impact, and that would be spelled out in the risk plan.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502",
    "choice_e": "Risk trigger scores",
    "choice_f": "EAC"
  },
  {
    "id": 1438,
    "question": "What is the critical chain method?",
    "choice_a": "Schedule network analysis technique",
    "choice_b": "Dependency model",
    "choice_c": "Signature path for project charter approval",
    "choice_d": "Earned value method",
    "correct_answer": "A",
    "explanation": "This technique modifies the project schedule when accounting for unforeseen issues or resource availability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1439,
    "question": "Harry works for a research and development firm trying to create a revolutionary new product. The likely risk tolerance for the company is which one of the following?",
    "choice_a": "Very high",
    "choice_b": "High",
    "choice_c": "Low",
    "choice_d": "Very low",
    "correct_answer": "A",
    "explanation": "The entire R&amp;D industry would likely have a very high risk tolerance because they need to constantly challenge the status quo to become relevant.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      33,
      42,
      48,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1440,
    "question": "What are two defining characteristics of a project? (Choose two.)",
    "choice_a": "Reworking an existing project",
    "choice_b": "An organized effort to fulfill a purpose",
    "choice_c": "Has a specific end date",
    "choice_d": "Routine activities to an organization",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A project is an organized effort to fulfill a purpose and has a specific end date. Additional project characteristics are that it is temporary in nature, has a specific start and end date, and exists to provide a unique product or service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      95,
      88,
      51
    ],
    "source": "9781119892502",
    "choice_e": "Blueprints needed to construct a building"
  },
  {
    "id": 1441,
    "question": "Why would a buyer issue a purchase order?",
    "choice_a": "To describe the quantity of goods and services needed and what price will be paid.",
    "choice_b": "To outline the intent or actions of both parties before entering a contract.",
    "choice_c": "To stop another company from using their intellectual property and to inform them not to do it again.",
    "choice_d": "The situation requires more flexibility and simplicity than a contract.",
    "correct_answer": "A",
    "explanation": "Once accepted by the seller, this becomes a legally binding document for goods/services to be provided, and for compensation to be given at the listed price.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      86,
      281,
      51,
      229
    ],
    "source": "9781119892502"
  },
  {
    "id": 1442,
    "question": "To which project-centric document would you refer to get a description of the project, find out the key deliverables, and gain an understanding of the success and acceptance criteria for the project?",
    "choice_a": "Project charter",
    "choice_b": "Project schedule",
    "choice_c": "Scope statement",
    "choice_d": "Meeting minutes",
    "correct_answer": "C",
    "explanation": "A scope statement documents the project's objectives, deliverables, and requirements, which are used as a basis for future project decisions. This is a more detailed explanation of what the project aims to achieve when compared to the project charter, which contains a high-level scope definition.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      122,
      93,
      99,
      69,
      67
    ],
    "source": "9781119892502"
  },
  {
    "id": 1443,
    "question": "At the completion of a government project requiring security clearance, what document would a vendor likely be asked to sign?",
    "choice_a": "Nondisclosure agreement",
    "choice_b": "Service-level agreement",
    "choice_c": "Warranty",
    "choice_d": "Request for proposal",
    "correct_answer": "A",
    "explanation": "NDAs are common contract vehicles for jobs in both the government and private sector that would require a security clearance. They are used to ensure that sensitive or trade secret information is not shared outside the organization.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      197,
      72,
      277,
      276,
      185
    ],
    "source": "9781119892502"
  },
  {
    "id": 1444,
    "question": "Which of the following data sources are considered SPII? (Choose two.)",
    "choice_a": "Social Security number (SSN)",
    "choice_b": "Political party",
    "choice_c": "First name",
    "choice_d": "City",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Sensitive personally identifiable information (SPII) is stand-alone data that by itself can identify an individual. If options B, C, and D are linked data and if combined with SPII, then they will become SPII.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      29,
      195,
      31,
      44,
      45
    ],
    "source": "9781119892502",
    "choice_e": "Driver\u2019s license number"
  },
  {
    "id": 1445,
    "question": "When the schedule slips on a project because the work is taking longer than planned, what type of common project change does this represent?",
    "choice_a": "Funding change",
    "choice_b": "Timeline change",
    "choice_c": "Risk event",
    "choice_d": "Requirements change",
    "correct_answer": "B",
    "explanation": "This is especially true when tasks are along the critical path, or when there is no float for that activity. Float is the amount of additional time a task has to complete before it begins to disrupt the critical path of a project.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      144,
      210,
      288,
      147,
      315
    ],
    "source": "9781119892502"
  },
  {
    "id": 1446,
    "question": "The process of assigning numerical probabilities to each risk and the impacts on project objectives is known as which one of the following?",
    "choice_a": "Identify risk",
    "choice_b": "Quantitative risk analysis",
    "choice_c": "Qualitative risk analysis",
    "choice_d": "Risk categorization",
    "correct_answer": "B",
    "explanation": "This process takes the more subjective results from the qualitative risk analysis and ties them to more numerical measures for evaluation and prioritization purposes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      219,
      221,
      220,
      216,
      217
    ],
    "source": "9781119892502"
  },
  {
    "id": 1447,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c05uf001.png\"/>",
    "choice_a": "Fishbone diagram",
    "choice_b": "Gantt chart",
    "choice_c": "Collaboration tools",
    "choice_d": "Process diagram",
    "correct_answer": "B",
    "explanation": "A Gantt chart is a type of bar chart that illustrates a project schedule.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      152,
      145,
      154,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1448,
    "question": "Which project role promotes the need and urgency of a project, as well as advertising the project\u2019s success?",
    "choice_a": "Project scheduler",
    "choice_b": "Project manager",
    "choice_c": "Project sponsor or champion",
    "choice_d": "Project coordinator",
    "correct_answer": "C",
    "explanation": "The \u201cchampion\u201d role of the sponsor is very important both initially and as the project commences to keep the energy and focus of the whole organization committed to the project's success.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      57,
      263,
      13,
      232
    ],
    "source": "9781119892502"
  },
  {
    "id": 1449,
    "question": "The EV for a project is 800, and the AC is 1200. The CPI for the project would be which one of the following?",
    "choice_a": "1.5",
    "choice_b": "400",
    "choice_c": "2000",
    "choice_d": ".667",
    "correct_answer": "D",
    "explanation": "The Cost Performance Index is Earned Value / Actual Cost. Therefore 800 / 1200 = .667. The project is over budget. A CPI under 1 means that the project is spending less than was forecasted for the measurement date.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      209,
      210,
      320,
      89
    ],
    "source": "9781119892502"
  },
  {
    "id": 1450,
    "question": "As a part of a daily Scrum meeting, the team seeks to share information in three areas. Which set of questions represents the topics of this knowledge sharing?",
    "choice_a": "What did I accomplish today? Who will you be working with today? What obstacles are preventing progress?",
    "choice_b": "What did I accomplish yesterday? What will I do today? What are the necessary next steps?",
    "choice_c": "What did I accomplish yesterday? What will I do today? What obstacles are preventing progress?",
    "choice_d": "What did I accomplish yesterday? Who will you be working with today? What obstacles are preventing progress?",
    "correct_answer": "C",
    "explanation": "A Scrum meeting is typically held in the morning at the same time, in the same place, and it sets the context for the team's work.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      108,
      119,
      253,
      254,
      229
    ],
    "source": "9781119892502"
  },
  {
    "id": 1451,
    "question": "Which document describes the goods or services an organization is interested in procuring from outside the organization?",
    "choice_a": "SOW",
    "choice_b": "RFI",
    "choice_c": "RFP",
    "choice_d": "RFQ",
    "correct_answer": "A",
    "explanation": "The statement of work (SOW) specifies in detail the goods or services that you are purchasing from outside the organization.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      182,
      86,
      88,
      280,
      95
    ],
    "source": "9781119892502"
  },
  {
    "id": 1452,
    "question": "What is a software application that manages back-office activities such as accounting, human resources, supply chain, operations, and procurement called?",
    "choice_a": "Database management system (DBMS)",
    "choice_b": "Enterprise resource planning (ERP)",
    "choice_c": "Content management system (CMS)",
    "choice_d": "Customer relationship management (CRM)",
    "correct_answer": "B",
    "explanation": "ERP systems help organizations manage day-to-day business activities and can vary in size and function depending on the organization and industry using the software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      47,
      43,
      48,
      44
    ],
    "source": "9781119892502"
  },
  {
    "id": 1453,
    "question": "What does SWOT stand for?",
    "choice_a": "Situation, work, open source, traceability",
    "choice_b": "Strengths, work, opportunities, traceability",
    "choice_c": "Situation, weaknesses, open source, threats",
    "choice_d": "Strengths, weaknesses, opportunities, threats",
    "correct_answer": "D",
    "explanation": "This is a tool used to perform a moment-in-time environmental scan, looking both within and external to the organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      218,
      217,
      292,
      215,
      226
    ],
    "source": "9781119892502"
  },
  {
    "id": 1454,
    "question": "Cheryl is a technical lead on a project that is wrapping up remote work at a customer site. What is the best method to communicate the work efforts and next steps with the customer?",
    "choice_a": "Closure meeting",
    "choice_b": "Virtual meeting",
    "choice_c": "Kickoff meeting",
    "choice_d": "In-person meeting",
    "correct_answer": "A",
    "explanation": "The Closure meeting will allow for the status of all activities, for the project team to return any property like ID badges/key cards and bring that phase of the work effort to an end.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      253,
      271,
      256,
      335,
      265
    ],
    "source": "9781119892502"
  },
  {
    "id": 1455,
    "question": "Which cloud model is a software licensing and delivery model where software is licensed on a subscription basis and is centrally hosted?",
    "choice_a": "XaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "IaaS",
    "correct_answer": "C",
    "explanation": "Software as a service is a strategy of most enterprise software companies. SaaS applications are usually accessed through a web browser and are typical for office software, messaging software, payroll processing, and more.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      40,
      41,
      49,
      42,
      43
    ],
    "source": "9781119892502"
  },
  {
    "id": 1456,
    "question": "The approved budget for given work to be completed within a specific timeframe is called which one of the following?",
    "choice_a": "Cost variance",
    "choice_b": "Planned value",
    "choice_c": "Earned value",
    "choice_d": "Actual costs",
    "correct_answer": "B",
    "explanation": "Planned value is the total cost of work planned as of the reporting date, and it is calculated by multiplying the hourly rate by the total planned or scheduled hours.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      209,
      210,
      211,
      199,
      274
    ],
    "source": "9781119892502"
  },
  {
    "id": 1457,
    "question": "A change manager supports a large transportation agency. In support of an upcoming project change, she has established emails to be sent two weeks in advance, a week in advance, and the day of the changes so that users can expect an outage and a new layout when the service comes back online. What is she working on?",
    "choice_a": "Maintenance windows",
    "choice_b": "Rollback plan",
    "choice_c": "Validation checks",
    "choice_d": "Notifications",
    "correct_answer": "D",
    "explanation": "Notifications happen before, during (depending on the length of the outage/change), and after. Always overcommunicate when you have a production change.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      298,
      299,
      191,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1458,
    "question": "Which law established protected health information and the rules governing its release?",
    "choice_a": "HIPPA",
    "choice_b": "OSHA",
    "choice_c": "DoCRA",
    "choice_d": "PgMP",
    "correct_answer": "A",
    "explanation": "HIPPA stands for Health Insurance Portability and Accountability Act, which was enacted on August 21, 1996 and governs standards for electronic exchange, privacy, and security of health information. This act defined protected health information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      30,
      195,
      29,
      31,
      32
    ],
    "source": "9781119892502"
  },
  {
    "id": 1459,
    "question": "A company is considering opening a store in a new country in which it has never done business before. This new country has laws called the consumer bill of rights that outline a company\u2019s responsibility to collect private data as well as a consumer\u2019s ability to see and/or restrict the collection of this data. Which ESG factor would influence this project\u2019s activities?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of company vision, mission statements, and values",
    "choice_c": "Awareness of appliable regulations and standards",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "C",
    "explanation": "Organizations and their project teams must be alert to the interests of the broader stakeholder community. In this instance, the regulations and standards of the new country will absolutely inform how the business will conduct business in-country. Moreover, in an era of global technology companies, one country's laws may force the entire company to adhere to their expectations such as in personally identifiable information collection.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      32,
      29,
      195,
      33,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1460,
    "question": "Developing contingency reserves to deal with risks, should they occur, is known as which one of the following?",
    "choice_a": "Active acceptance",
    "choice_b": "Passive acceptance",
    "choice_c": "Exploit",
    "choice_d": "Transfer",
    "correct_answer": "A",
    "explanation": "The key is actually setting money aside to deal with the risk should it occur during the course of the project. Failing to plan in this way can lead to project disruption or cancellation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      205,
      151,
      219,
      275,
      281
    ],
    "source": "9781119892502"
  },
  {
    "id": 1461,
    "question": "The project team has been asked to include a data validation module with the software they are developing, and this will add an additional three weeks to the project. This is an example of which one of the following?",
    "choice_a": "Issue",
    "choice_b": "Risk",
    "choice_c": "Change",
    "choice_d": "Milestone",
    "correct_answer": "C",
    "explanation": "The addition of more resources, the modification of scope, or the adjustment of the timeline are examples of some of the changes that might be requested.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      86,
      288,
      56,
      53
    ],
    "source": "9781119892502"
  },
  {
    "id": 1462,
    "question": "What are milestones?",
    "choice_a": "Checkpoints on a project to determine Go/No-Go decisions",
    "choice_b": "A measure of the distance traveled on a project",
    "choice_c": "Characteristics of deliverables that must be met",
    "choice_d": "Major events in a project used to measure progress",
    "correct_answer": "D",
    "explanation": "Milestones are used in project manager to mark a specific point along a project timeline, such as the project start and end date, completion of a phase, or gate checks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      70,
      250,
      134,
      143
    ],
    "source": "9781119892502"
  },
  {
    "id": 1463,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c05uf002.png\"/> <p></p>",
    "choice_a": "Pareto chart",
    "choice_b": "Project schedule",
    "choice_c": "Histogram",
    "choice_d": "Gantt chart",
    "correct_answer": "A",
    "explanation": "A Pareto chart contains both a line graph and bars where the individual values are represented in descending order by the bars, and the cumulative total is represented by the line.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      310,
      311,
      212,
      267,
      154
    ],
    "source": "9781119892502"
  },
  {
    "id": 1464,
    "question": "At the beginning of a work period, or sprint, there is a sprint planning meeting. What does this meeting accomplish?",
    "choice_a": "Sets a realistic backlog of items to be completed during this iteration",
    "choice_b": "Sets the communication and quality plans for the project",
    "choice_c": "Prepares the project charter and kickoff meeting",
    "choice_d": "Gets a head start on the work needed on the project",
    "correct_answer": "A",
    "explanation": "A Scrum master typically coordinates this meeting, which is a collaborative effort to detail all the work that needs to be completed during a work period (such as a sprint) and each item's respective acceptance criteria.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      119,
      108,
      253,
      255
    ],
    "source": "9781119892502"
  },
  {
    "id": 1465,
    "question": "Which vendor solicitation method is best to use when more data is needed about the goods and services that need to be procured?",
    "choice_a": "Request for proposal (RFP)",
    "choice_b": "Request for quotation (RFQ)",
    "choice_c": "Request for information (RFI)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "C",
    "explanation": "An RFI will give a sense of the number of providers or contractors who can provide the goods and services in question. An RFI will also help provide a ballpark estimate for the costs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      200,
      201,
      276,
      185,
      182
    ],
    "source": "9781119892502"
  },
  {
    "id": 1466,
    "question": "The Payment Card Industry Data Security Standards (PCI DSS) address the handling and management of payment card data. It covers all aspects of payment card data handling, including acquiring, transmitting, storing, and processing the data. What is the PCI DSS an example of?",
    "choice_a": "Personally identifiable information",
    "choice_b": "Industry-specific compliance",
    "choice_c": "Regulatory impacts",
    "choice_d": "Country-specific privacy stipulation",
    "correct_answer": "B",
    "explanation": "Financial services worldwide need to make sure they are PCI-DSS compliant to protect payment card handling and sort out vulnerabilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      33,
      32,
      195,
      47,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1467,
    "question": "A systematic and independent examination of project procedures, documentation, spending, statutory compliance, and reporting is known as which one of the following?",
    "choice_a": "Audit",
    "choice_b": "Gate review",
    "choice_c": "Scrum retrospective",
    "choice_d": "Project change",
    "correct_answer": "A",
    "explanation": "Audits are reviews to obtain evidence to ensure that good practices are followed, that the project team is behaving in an ethical and legal fashion, and that there is no fraud, waste, and abuse occurring.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      276,
      309,
      265,
      271,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 1468,
    "question": "A team is being assembled for a financial company that looks for the highest standards in ethical behavior. The project manager is excited by a candidate\u2019s skills, attitude, and experience, but a background check reveals the candidate misrepresented their education and work experience. Which ESG factor likely influenced the decision to move away from this candidate?",
    "choice_a": "Project impact to the local and global environment",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to company brand value",
    "correct_answer": "C",
    "explanation": "When you know what you stand for, decisions become easier. In this example, there is a mismatch between the candidate's values and the values of the company. If the candidate wasn't trustworthy in representing their skills and experience, they shouldn't be trusted with patients' confidential information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      193,
      195,
      191,
      190,
      194
    ],
    "source": "9781119892502"
  },
  {
    "id": 1469,
    "question": "All of the following are examples of deliverables EXCEPT:",
    "choice_a": "Blueprints",
    "choice_b": "User documentation",
    "choice_c": "The finished product",
    "choice_d": "Sign-off on the project charter",
    "correct_answer": "D",
    "explanation": "Sign-off on the project charter would be a milestone, not a deliverable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      327,
      11,
      66,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 1470,
    "question": "What is a special form of a bar chart that visually displays the central tendency, dispersion, and distribution for statistical data?",
    "choice_a": "Kanban board",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "SIPOC-R",
    "correct_answer": "B",
    "explanation": "A histogram chart can be used to show the frequencies of problem causes to help understand what is needed for preventive or corrective action.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      310,
      311,
      314,
      307,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1471,
    "question": "In which project life cycle phase would the issues log generally be developed?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "The issue log constraints list numbers, descriptions, and owners of the issue, and starts to develop as the execution of the project gets underway.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      274,
      317,
      320,
      256
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1472,
    "question": "A meeting has just been conducted on a project where the expectations, goals, and objectives of the project have been explained, including the milestones and timelines of the project. Project sign-off is also likely to occur during this meeting. What type of meeting was this?",
    "choice_a": "Lessons learned",
    "choice_b": "Kickoff meeting",
    "choice_c": "Status meeting",
    "choice_d": "Gate check",
    "correct_answer": "B",
    "explanation": "During the kickoff meeting, formal approval for the project might occur in the form of project sign-off.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      76,
      77,
      79,
      81,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 1473,
    "question": "Liberty in purchasing needs you to create an SOW prior to the releasing an RFP. What does SOW stand for?",
    "choice_a": "Service of workforce",
    "choice_b": "Statement of work",
    "choice_c": "Statement of workforce",
    "choice_d": "Support of work",
    "correct_answer": "B",
    "explanation": "A statement of work formally captures and defines work activities, timeframes, milestones, and deliverables a vendor must meet in the performance of work for a customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      86,
      185,
      276,
      278
    ],
    "source": "9781119892502"
  },
  {
    "id": 1474,
    "question": "Your friend has hinted that she would like a special gift for her birthday. The following steps are needed for the gift exchange: <p>Enjoyment of her gift.</p> <p>Put card on the gift.</p> <p>Wrap present.</p> <p>Choose gift.</p> <p>Give her the present.</p> <p>Make purchase.</p> <p>Fill out the card.</p> <p>What is the correct sequence for project Happy Birthday?</p>",
    "choice_a": "Choose gift; make purchase; put card on gift; wrap present; fill out card; enjoyment of her gift; give her the present.",
    "choice_b": "Give her the present; put card on gift; wrap present; make purchase; fill out card; enjoyment of her gift; choose gift.",
    "choice_c": "Put card on gift; give her the present; fill out card; make purchase; enjoyment of her gift; choose gift; wrap present.",
    "choice_d": "Choose gift; make purchase; wrap present; fill out card; put card on gift; give her the present; enjoyment of her gift.",
    "correct_answer": "D",
    "explanation": "On the exam, it is likely that there will be a scenario-based question that will test your critical thinking skills to reason through the correct activity sequencing of a project. This question should help give you a taste of what you might encounter.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      136,
      144,
      86,
      6
    ],
    "source": "9781119892502"
  },
  {
    "id": 1475,
    "question": "A vendor is very strict on insisting on formal change control on a project for a customer and few changes are actually getting approved. Which contract vehicle would cause a vendor to behave in this way?",
    "choice_a": "Fixed-price",
    "choice_b": "Request for proposal",
    "choice_c": "Time and materials",
    "choice_d": "Cost-reimbursable",
    "correct_answer": "A",
    "explanation": "With a fixed-price contract, the risk is on the seller. When changes to a project increase their costs but not their revenue, they stand to lose money. Accordingly, they would likely allow very few changes to the scope.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      279,
      277,
      281,
      214,
      86
    ],
    "source": "9781119892502"
  },
  {
    "id": 1476,
    "question": "The project team is required to attend a daily stand-up meeting to discuss the project activities and roadblocks. Which document lets the project team know that they need to attend this meeting?",
    "choice_a": "Project schedule",
    "choice_b": "Scope statement",
    "choice_c": "Communication plan",
    "choice_d": "Project charter",
    "correct_answer": "C",
    "explanation": "The communication plan documents the types of information needed by the stakeholders, when the information should be shared, and the method of delivery.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      271,
      269,
      253,
      254,
      255
    ],
    "source": "9781119892502"
  },
  {
    "id": 1477,
    "question": "The joining of two businesses to come together and operate as one, single entity is known as which one of the following?",
    "choice_a": "Business acquisition",
    "choice_b": "Business merger",
    "choice_c": "Business process change",
    "choice_d": "Business split",
    "correct_answer": "B",
    "explanation": "Know the difference between a merger and an acquisition. The latter is where one organization takes over the other one.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      289,
      6,
      274,
      271,
      263
    ],
    "source": "9781119892502"
  },
  {
    "id": 1478,
    "question": "What are the three common constraints found in projects? (Choose three.)",
    "choice_a": "Inventory",
    "choice_b": "Personnel",
    "choice_c": "Environment",
    "choice_d": "Time",
    "correct_answer": [
      "D",
      "E",
      "F"
    ],
    "explanation": "Time, budget, and scope are constraints in terms of how they affect quality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      248,
      56,
      87,
      279
    ],
    "source": "9781119892502",
    "choice_e": "Budget",
    "choice_f": "Scope"
  },
  {
    "id": 1479,
    "question": "A government agency has hired a firm to perform work on its sewer system. As a part of the RFP, the agency requires the successful vendor to carry insurance for errors and omissions. What type of risk strategy is this?",
    "choice_a": "Transfer, negative risk strategy",
    "choice_b": "Exploit, positive risk strategy",
    "choice_c": "Accept, negative risk strategy",
    "choice_d": "Share, positive risk strategy",
    "correct_answer": "A",
    "explanation": "By requiring the successful vendor to carry the insurance, it allows the consequences of negative risk to be transferred to the third party.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      185,
      276,
      277
    ],
    "source": "9781119892502"
  },
  {
    "id": 1480,
    "question": "In what stage of team development do team members begin to confront each other and vie for position and control?",
    "choice_a": "Adjourning",
    "choice_b": "Norming",
    "choice_c": "Forming",
    "choice_d": "Storming",
    "correct_answer": "D",
    "explanation": "In the storming stage, the process of establishing who is the most influential occurs, and there is jostling for position.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      173,
      245,
      179,
      175
    ],
    "source": "9781119892502",
    "choice_e": "Performing"
  },
  {
    "id": 1481,
    "question": "What elements are explained in a business case?",
    "choice_a": "Justification by identifying the organizational benefits",
    "choice_b": "Alternative solutions",
    "choice_c": "Alignment to the strategic plan",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "The business case can include justification, alternative solutions, and alignment to the strategic plan.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      14,
      102,
      68,
      67,
      99
    ],
    "source": "9781119892502",
    "choice_e": "A and C"
  },
  {
    "id": 1482,
    "question": "Which tool would you use to create a visual representation of timelines, start dates, durations, and activity sequence?",
    "choice_a": "Histogram",
    "choice_b": "Gantt chart",
    "choice_c": "Process diagram",
    "choice_d": "Pareto chart",
    "correct_answer": "B",
    "explanation": "A Gantt chart allows the users to see at a glance information about various activities, activity start and end dates, duration, activity overlaps, and when the project will start and end.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      146,
      145,
      154,
      267,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1483,
    "question": "What is the comprehensive collection of documents that spells out communication, risk management, project schedule, and scope management?",
    "choice_a": "Request for proposal",
    "choice_b": "Project management plan",
    "choice_c": "Dashboard information",
    "choice_d": "Scope statement",
    "correct_answer": "B",
    "explanation": "The project management plan is the collection of plans created to address budget, time, scope, quality, communication, risk, and other project elements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      84,
      132,
      9,
      236,
      12
    ],
    "source": "9781119892502"
  },
  {
    "id": 1484,
    "question": "What type of agreement should organizations use to ensure their trade secrets are not revealed or used by other companies?",
    "choice_a": "NDA",
    "choice_b": "MOU",
    "choice_c": "RFP",
    "choice_d": "SLA",
    "correct_answer": "A",
    "explanation": "A nondisclosure agreement ensures that what's discussed, revealed, or created is kept confidential by the various parties working with intellectual property, trade secrets, or classified information.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      72,
      271,
      23,
      51,
      281
    ],
    "source": "9781119892502"
  },
  {
    "id": 1485,
    "question": "What is the purpose of a data warehouse?",
    "choice_a": "To handle extremely large data environments",
    "choice_b": "To separate the data\u2019s physical location from other applications",
    "choice_c": "To bring various data sources together for the purpose of analysis and decision-making",
    "choice_d": "To bring all the company\u2019s unstructured data together in a central location",
    "correct_answer": "C",
    "explanation": "A data warehouse is a collection of data for the purpose of helping stakeholders make sense out of the data for the purpose of analysis and decision-making. Data in a data warehouse may include internal as well as external data resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      48,
      42,
      43,
      44,
      47
    ],
    "source": "9781119892502"
  },
  {
    "id": 1486,
    "question": "A project is seeking a third party to handle hardware and software tools for the application development team to complete a project. Which cloud model should the project team look to use?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "XaaS",
    "choice_d": "PaaS",
    "correct_answer": "D",
    "explanation": "A PaaS provider hosts the hardware and software on its own infrastructure for users over the internet.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      40,
      41,
      49,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1487,
    "question": "In a multitiered architecture, which tier is where information is stored, sorted, and indexed?",
    "choice_a": "Data",
    "choice_b": "Processing",
    "choice_c": "Application",
    "choice_d": "Presentation",
    "correct_answer": "A",
    "explanation": "In the data tier, information is stored and retrieved, and then passed back to the logic tier for processing. Eventually, the data is returned to the user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      37,
      36,
      44,
      39,
      48
    ],
    "source": "9781119892502"
  },
  {
    "id": 1488,
    "question": "A new U.S. state law gives customers the ability to request what data a company is storing about their users and how the company is using this information. A global company is having to adjust their product design to conform with this requirement. Which ESG factor can cause the project to change in this manner?",
    "choice_a": "Awareness of applicable regulations and standards",
    "choice_b": "Awareness of company vision, mission statements, and values",
    "choice_c": "Project impact to company brand value",
    "choice_d": "Project impact to the local and global environment",
    "correct_answer": "A",
    "explanation": "As more companies and industries make a shift to IT-driven services, understanding what standards are spelled out anywhere the service is used becomes a key factor of success. Failure to comply can lead to negative consequences, such as large fines or restrictions for offering those services in certain countries or regions.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      32,
      29,
      195,
      190,
      191
    ],
    "source": "9781119892502"
  },
  {
    "id": 1489,
    "question": "What is a licensed professional who oversees the design of a project known as?",
    "choice_a": "Subject matter expert",
    "choice_b": "Scrum master",
    "choice_c": "Architect",
    "choice_d": "Project manager",
    "correct_answer": "C",
    "explanation": "Project architects design plans and specifications for a project, such as in construction. Architects meet with clients and work closely to ensure understanding of requirements such as deadlines, budget, and structural needs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      58,
      121,
      6,
      51,
      26
    ],
    "source": "9781119892502"
  },
  {
    "id": 1490,
    "question": "During a regular check-in meeting with stakeholders, the project manager presents information on all task areas. Each task area has a column for time, cost, resources, risks, issues, and changes, and each item shows a red, yellow, or green indication representing the condition of each task in each area. What project-centric document is being presented?",
    "choice_a": "Project dashboard",
    "choice_b": "Gantt chart",
    "choice_c": "Process diagram",
    "choice_d": "Run chart",
    "correct_answer": "A",
    "explanation": "A project dashboard is a form of a status report that displays summary information from lots of different areas of the project to present a snapshot of key information for analysis and discussion.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      252,
      316,
      283,
      213
    ],
    "source": "9781119892502"
  },
  {
    "id": 1491,
    "question": "What kind of tool would automate the creation of critical path, float, WBS, and activity sequence?",
    "choice_a": "Project management plan",
    "choice_b": "Project scheduling software",
    "choice_c": "PERT",
    "choice_d": "Run chart",
    "correct_answer": "B",
    "explanation": "Using software can increase the amount of time during setup but can save lots of time in managing the project in later phases.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      6,
      136,
      144,
      137,
      50
    ],
    "source": "9781119892502"
  },
  {
    "id": 1492,
    "question": "Which tool would be used to display observed data in a time sequence?",
    "choice_a": "Pareto chart",
    "choice_b": "Histogram",
    "choice_c": "Run chart",
    "choice_d": "Scatter diagram",
    "correct_answer": "C",
    "explanation": "Especially valuable at the beginning of a project, a run chart helps identify information about a process before there is enough information to set dependable control limits.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      154,
      212,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1493,
    "question": "A subject matter expert on a project has been monitoring the distribution of support calls received each hour during the day to determine staffing needs for a project. Which tool is this person most likely using?",
    "choice_a": "Gantt chart",
    "choice_b": "Histogram",
    "choice_c": "Run chart",
    "choice_d": "Process diagram",
    "correct_answer": "B",
    "explanation": "Most likely, this analyst is using a histogram, which would be used to show the frequencies of problem causes to help understand what is needed for preventive or corrective action.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      266,
      212,
      322
    ],
    "source": "9781119892502"
  },
  {
    "id": 1494,
    "question": "After establishing the product backlog, what tool would you use to determine the project\u2019s velocity?",
    "choice_a": "Burndown chart",
    "choice_b": "Kanban board",
    "choice_c": "Fishbone diagram",
    "choice_d": "Sprint speed",
    "correct_answer": "A",
    "explanation": "The burndown chart is a visual representation and measurement tool showing the completed work against a time interval to forecast project completion.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      153,
      211,
      210,
      209
    ],
    "source": "9781119892502"
  },
  {
    "id": 1495,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c05uf003.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Gantt chart",
    "correct_answer": "B",
    "explanation": "According to the <i>Project Management Body of Knowledge (Sixth Edition)</i>, a histogram is a special form of a bar chart used to describe central tendency, dispersion, and shape of a statistical distribution.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      310,
      311,
      314,
      146,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1496,
    "question": "Which office productivity tool would be best to record spending so far on a project so that the project team can keep track of where money has been spent and how much budget is remaining?",
    "choice_a": "Word processing",
    "choice_b": "Spreadsheets",
    "choice_c": "Presentation",
    "choice_d": "Charting/diagramming",
    "correct_answer": "B",
    "explanation": "A spreadsheet is a basic form of a database and allows the use of functions for formatting, counting, and summing for analytical review.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      213,
      212,
      207,
      322,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1497,
    "question": "What are the two forms of acceptance when considering risk response strategies?",
    "choice_a": "Unintentional",
    "choice_b": "Active",
    "choice_c": "Deliberate",
    "choice_d": "Passive",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Active acceptance includes developing contingency reserves to deal with risk should they occur. Passive acceptance is when the project team is not able to eliminate all the threats to a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      205,
      151,
      219
    ],
    "source": "9781119892502"
  },
  {
    "id": 1498,
    "question": "The Closing phase includes all of the following EXCEPT:",
    "choice_a": "Review of lessons learned",
    "choice_b": "Release of project members",
    "choice_c": "Archiving of project documents",
    "choice_d": "Monitoring the risks and issues log",
    "correct_answer": "D",
    "explanation": "Monitoring the risks and issue log occurs during the Execution phase and are not an activity of the Closing phase.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      11,
      10,
      273,
      324,
      225
    ],
    "source": "9781119892502"
  },
  {
    "id": 1499,
    "question": "What is the process used to document, identify, and authorize changes in an IT environment?",
    "choice_a": "Change control",
    "choice_b": "Executive oversight",
    "choice_c": "Organizational change management",
    "choice_d": "Promote to production",
    "correct_answer": "A",
    "explanation": "Change control can vary slightly between software and infrastructure. The key is to know what changes are made to the environment and the routines that would be followed if there is a problem with the change. This minimizes the amount of downtime the service has.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      279,
      280,
      282,
      281,
      288
    ],
    "source": "9781119892502"
  },
  {
    "id": 1500,
    "question": "The project team has been asked to add some additional functionality to an existing application. A business analyst sits down with the stakeholders to be walked through what the application needs to do, how it needs to look, and what other applications or reports the data needs to be shared with. What part of the change control process is the business analyst performing?",
    "choice_a": "Customer notifications",
    "choice_b": "Requirements definition",
    "choice_c": "Release management",
    "choice_d": "Rollback planning",
    "correct_answer": "B",
    "explanation": "Knowing what success looks like can make or break a project, and any change begins with good requirements definition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      57,
      26,
      86,
      100
    ],
    "source": "9781119892502"
  },
  {
    "id": 1501,
    "question": "At a gate check meeting, the committee is presented with a report that shows health in different areas of a project: Schedule = Green, Budget = Yellow, Scope = Green, Risk = Yellow, and Publicity = Red. What type of tool is the committee looking at?",
    "choice_a": "Pareto chart",
    "choice_b": "Scatter chart",
    "choice_c": "Collaboration tool",
    "choice_d": "Balanced scorecard",
    "correct_answer": "D",
    "explanation": "This document is showing values from a variety of areas on the project to show a balanced view of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      263,
      247,
      56,
      210,
      220
    ],
    "source": "9781119892502"
  },
  {
    "id": 1502,
    "question": "An animated movie project requires the following ordered steps: story idea, script, storyboard, voice talent, models, and sets construction, to name just a few. Storyboard has what relationship to script?",
    "choice_a": "It is a predecessor task.",
    "choice_b": "It is a discretionary task.",
    "choice_c": "It is a successor task.",
    "choice_d": "It is a mandatory task.",
    "correct_answer": "C",
    "explanation": "It is a successor task because storyboarding would come after the development of the script. In the creation of an animated movie, many more steps than these are required to create the final product.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      137,
      136,
      127,
      86,
      275
    ],
    "source": "9781119892502"
  },
  {
    "id": 1503,
    "question": "All of the following are cost-estimating techniques EXCEPT:",
    "choice_a": "SIPOC-R",
    "choice_b": "Bottom-up estimating",
    "choice_c": "Parametric estimating",
    "choice_d": "Analogous estimating",
    "correct_answer": "A",
    "explanation": "SIPOC-R is a process improvement method, and the acronym stands for Suppliers, Inputs, Process, Outputs, Customers, and Requirements. It is not used for cost estimating.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      198,
      200,
      111,
      17,
      292
    ],
    "source": "9781119892502"
  },
  {
    "id": 1504,
    "question": "The work breakdown structure is created during which project life cycle phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "C",
    "explanation": "Creation of the work breakdown structure involves organizing the team's work by breaking it down into manageable chunks, or sections. This effort needs to happen before work begins and therefore occurs in the Planning phase.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      128,
      9,
      85,
      7,
      81
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1505,
    "question": "What is the indication of how fast a project is spending through its budgeted money?",
    "choice_a": "Planned value",
    "choice_b": "Burn rate",
    "choice_c": "Cost variance",
    "choice_d": "Expenditure tracking",
    "correct_answer": "B",
    "explanation": "The burn rate is how fast the project is spending through its allotted budget or the rate money is being expended over a period of time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      205,
      214,
      204
    ],
    "source": "9781119892502"
  },
  {
    "id": 1506,
    "question": "Which of the following is the best definition of a capital expense, or CapEx?",
    "choice_a": "Money spent on running the business operations of a company",
    "choice_b": "Money spent on long-term physical or fixed assess used in a business\u2019s operations",
    "choice_c": "Debt accrued on travel expenses needed to run a business",
    "choice_d": "Debt accrued through the issuing of long-term bonds",
    "correct_answer": "B",
    "explanation": "CapEx is important to help companies grow and maintain their business by investing in new property, equipment, products, or technology.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      8,
      67,
      68,
      102
    ],
    "source": "9781119892502"
  },
  {
    "id": 1507,
    "question": "Which of the following is the best definition of an operational expense, or OpEx?",
    "choice_a": "Money spent on long-term physical or fixed assess used in a business\u2019s operations",
    "choice_b": "Debt accrued through the issuing of long-term bonds",
    "choice_c": "Money spent on running the business operations of a company",
    "choice_d": "Debt accrued on travel expenses needed to run a business",
    "correct_answer": "C",
    "explanation": "Examples of OpEx would include rent, office equipment, supplies, legal fees, travel expenses, and utilities, to name a few.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      206,
      188,
      96,
      65,
      102
    ],
    "source": "9781119892502"
  },
  {
    "id": 1508,
    "question": "A seller that has passed through a first phase of onboarding through evaluation using a standard criterion to determine a seller\u2019s ability to supply a good or service is known as what?",
    "choice_a": "Bidder\u2019s conference",
    "choice_b": "Prequalified vendor",
    "choice_c": "Terms of reference",
    "choice_d": "Statement of work",
    "correct_answer": "B",
    "explanation": "The prequalified vendor list helps buyers prescreen interested parties that wish to sell products and services. This can help create a pool of prospective sellers, which can speed up future procurement processes, establish relationships, and increase the chances a seller will be noticed and selected for future business.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      185,
      182,
      276,
      278,
      62
    ],
    "source": "9781119892502"
  },
  {
    "id": 1509,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c05uf004.png\"/>",
    "choice_a": "Program Evaluation Review Technique (PERT) chart",
    "choice_b": "Gantt chart",
    "choice_c": "Project dashboard",
    "choice_d": "Budget burndown chart",
    "correct_answer": "A",
    "explanation": "This is an example of a PERT chart. A PERT chart is a graphical depiction of the project's timeline and helps to identify task dependencies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      146,
      138,
      152,
      266
    ],
    "source": "9781119892502"
  },
  {
    "id": 1510,
    "question": "A Sprint backlog is composed of which of the following? (Choose three.)",
    "choice_a": "Action plan",
    "choice_b": "Gate review",
    "choice_c": "Run charts",
    "choice_d": "Product backlog items",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The Sprint goal sets the single objective and commitment of the developers. The backlog brings transparency to all work that is needed to be performed. The action plan for the sprint is dynamic and changes as the Sprint progresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      117,
      157,
      153,
      256
    ],
    "source": "9781119892502",
    "choice_e": "Milestone chart",
    "choice_f": "Sprint goal"
  },
  {
    "id": 1511,
    "question": "Why is it important to validate deliverables when a project starts to conclude?",
    "choice_a": "To confirm the project has satisfied the objectives",
    "choice_b": "To accept deliverables to the scope",
    "choice_c": "To verify timeliness and completeness to pay a vendor",
    "choice_d": "All of the above",
    "correct_answer": "E",
    "explanation": "It is vital to verify deliverables to ensure they meet specifications and satisfy project objectives. Additionally, vendor payments are often tied to deliverables, so before the vendor is paid and let off the hook for performance, make sure the deliverable is what the project expected it to be. Option B is scope creep that would prevent the closure of the project.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      327,
      69,
      98,
      331,
      10
    ],
    "source": "9781119892502",
    "choice_e": "A and C"
  },
  {
    "id": 1512,
    "question": "As a project concludes, the project manager meets with the project team to review expenditures for the project and signs off on the project budget. This is known as which of the following?",
    "choice_a": "Return on investment analysis",
    "choice_b": "Budget reconciliation",
    "choice_c": "Current state analysis",
    "choice_d": "Updating the project budget",
    "correct_answer": "B",
    "explanation": "An activity of the Closing phase, the project manager validates all project expenditures, closes purchase orders and contracts, and finalizes the total spend for the project.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      11,
      84,
      203,
      12,
      7
    ],
    "source": "9781119892502"
  },
  {
    "id": 1513,
    "question": "A team has set guidance that project communication can only take place through the company-issued collaboration platform or through company-issued devices. This is an example of which of the following?",
    "choice_a": "Identify and assess stakeholders.",
    "choice_b": "A responsibility assignment matrix.",
    "choice_c": "Establish accepted communication channels.",
    "choice_d": "Establish communication cadence.",
    "correct_answer": "C",
    "explanation": "Established communication channels are likely to be created to ensure information governance, confidentiality, and information retrieval.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      236,
      231,
      259,
      287,
      324
    ],
    "source": "9781119892502"
  },
  {
    "id": 1514,
    "question": "What type of communication method would make sense for routine status meetings on a project where the team is spread out to different cities on the same continent?",
    "choice_a": "In-person meetings",
    "choice_b": "Virtual meetings",
    "choice_c": "Closure meetings",
    "choice_d": "Kickoff meetings",
    "correct_answer": "B",
    "explanation": "To help control costs and to minimize disruption to project work, a virtual meeting would be the ideal choice to handle routine meetings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      233,
      246,
      269,
      254,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 1515,
    "question": "A construction company is in the middle of a project to build a bridge. The earned value for the project is $9,500, and the actual cost for the project is $7,000. Select the correct cost variance for the project and its meaning:",
    "choice_a": "$2,500 and the project is under budget",
    "choice_b": "$\u20132,500 and the project is under budget",
    "choice_c": "$2,500 and the project is over budget",
    "choice_d": "$\u20132,500 and the project is over budget",
    "correct_answer": "A",
    "explanation": "The formula for cost variance (CV) is CV = EV \u2013 AC. The calculations would produce a value of 2,500, indicating the project is under budget. A positive Cost Variance (CV) means the project is under budget, and a negative CV means the project is over budget. 9,500 \u2013 7,000 = 2,500; therefore, the project is under budget.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      210,
      209,
      211,
      214,
      274
    ],
    "source": "9781119892502"
  },
  {
    "id": 1516,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c05uf005.png\"/>",
    "choice_a": "Fishbone/Ishikawa diagram",
    "choice_b": "Burndown chart",
    "choice_c": "Requirements traceability matrix",
    "choice_d": "Run chart",
    "correct_answer": "C",
    "explanation": "A requirements traceability matrix maps and traces user requirements with test cases. It consolidates into a single document all requirements proposed by the client and helps validate all requirements are checked via tests cases. This tool helps verify all needed functionality during software testing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      308,
      307,
      310,
      316,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1517,
    "question": "In the development of a project schedule, setting governance gates are important. All of the following are examples of governance gates EXCEPT:",
    "choice_a": "Daily stand-up meetings",
    "choice_b": "Client sign-off",
    "choice_c": "Management approval",
    "choice_d": "Legislative approval",
    "correct_answer": "A",
    "explanation": "Daily stand-up meetings are typically used with an Agile methodology. As such, a daily stand-up meeting would not have a governance body in attendance and would normally be attended by project team members.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      238,
      262,
      259,
      303
    ],
    "source": "9781119892502"
  },
  {
    "id": 1518,
    "question": "When a meeting agenda sets a fixed time on a schedule where a task must be completed within that time, what technique is being used?",
    "choice_a": "Soft timeboxing",
    "choice_b": "Hard timeboxing",
    "choice_c": "Brainstorming",
    "choice_d": "Action items",
    "correct_answer": "B",
    "explanation": "Hard timeboxing can be helpful in having a meeting move on against the desire for perfection or creative churning over possibilities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      254,
      253,
      255,
      25,
      256
    ],
    "source": "9781119892502"
  },
  {
    "id": 1519,
    "question": "Total expenditures for completed project work within a specific timeframe is known as which one of the following?",
    "choice_a": "Earned Value",
    "choice_b": "Planned Value",
    "choice_c": "Cost Variance",
    "choice_d": "Actual Cost",
    "correct_answer": "D",
    "explanation": "Actual Cost may include both direct and indirect costs but must correspond to the budget for the activity. This can include labor costs, cost of materials, and use of equipment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      209,
      210,
      199,
      201,
      198
    ],
    "source": "9781119892502"
  },
  {
    "id": 1520,
    "question": "Which project management role is responsible for product integrity and ensures conformance to standards and specifications?",
    "choice_a": "Developer/engineers",
    "choice_b": "Business analyst",
    "choice_c": "Testers/quality assurance specialists",
    "choice_d": "Architect",
    "correct_answer": "C",
    "explanation": "Testers and quality assurance specialists inspect and monitor project activities and test products to ensure they are meeting quality thresholds and standards. These positions oversee the inspection and testing of products.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      306,
      309,
      55,
      304
    ],
    "source": "9781119892502"
  },
  {
    "id": 1521,
    "question": "Which of the following is <i>not</i> a communication trigger?",
    "choice_a": "Project planning",
    "choice_b": "Kickoff meeting",
    "choice_c": "Milestones",
    "choice_d": "Schedule changes",
    "correct_answer": "B",
    "explanation": "A kickoff meeting is a form of communication rather than a trigger of communication.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      251,
      248,
      249,
      271,
      254
    ],
    "source": "9781119892502"
  },
  {
    "id": 1522,
    "question": "A potential future event that can have either a negative or positive impact on a project is known as which one of the following?",
    "choice_a": "A risk",
    "choice_b": "A deliverable",
    "choice_c": "A requirement",
    "choice_d": "An issue",
    "correct_answer": "A",
    "explanation": "A risk can be either positive or negative and represents an opportunity that did not exist earlier in the project.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      215,
      219,
      220,
      315,
      222
    ],
    "source": "9781119892502"
  },
  {
    "id": 1523,
    "question": "What risk tolerance would a start-up in the technology industry likely have?",
    "choice_a": "Risk taker",
    "choice_b": "Risk avoider",
    "choice_c": "Gambler",
    "choice_d": "Moderate risk tolerance",
    "correct_answer": "C",
    "explanation": "The industry plus the fact that the company is relatively new would suggest a more aggressive, gambling type of risk tolerance for the company to grow and succeed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      112,
      215,
      216,
      226
    ],
    "source": "9781119892502"
  },
  {
    "id": 1524,
    "question": "As part of the preparation to begin work on a project, the project manager makes a list: (1) There can be no work on weekends and holidays, (2) overtime is not approved without steering committee consent, and (3) seventy-five percent of the project team must be union staff. This list represents which of the following?",
    "choice_a": "Objectives",
    "choice_b": "Requirements",
    "choice_c": "Constraints",
    "choice_d": "Assumptions",
    "correct_answer": "C",
    "explanation": "Constraints are those conditions that restrict the project in certain ways, like resources, timeframes, schedules, or budget.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      66,
      9,
      122,
      85
    ],
    "source": "9781119892502"
  },
  {
    "id": 1525,
    "question": "A start-up company is constructing a new mobile home sharing app. Users of the service will be required to share their location data to be able to sign up for a trip using someone else's mobile home. Which of the following ESG factors would the company need to consider for this project?",
    "choice_a": "Mitigating risk factors",
    "choice_b": "National and local privacy laws and regulations",
    "choice_c": "Critical path activities impacting project planning",
    "choice_d": "Choosing waterfall versus an Agile approach",
    "correct_answer": "B",
    "explanation": "Companies and projects must be aware of applicable regulations and standards impacting products and services. Complying with privacy laws at both a national and a local level will be critical for the success of the project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      32,
      195,
      31,
      33
    ],
    "source": "9781119892502"
  },
  {
    "id": 1526,
    "question": "Which authentication method requires the user to provide two or more pieces of verification evidence to log into their account?",
    "choice_a": "Certificate-based authentication",
    "choice_b": "Biometric authentication",
    "choice_c": "Multifactor authentication",
    "choice_d": "Token-based authentication",
    "correct_answer": "C",
    "explanation": "Multifactor authentication (MFA) helps protect personal information, financial assets, or company systems from access by an unauthorized third party. It is possible that each of the other options in this question could be one factor of authentication used in an MFA login.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      194,
      192,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1527,
    "question": "DewDrops has gone through a rapid growth cycle and now has several one-off systems for activities like the company's finances, supply, and human resources. The leaders of the company want to have a system that brings these activities together. What kind of system would meet these needs?",
    "choice_a": "ERP",
    "choice_b": "XaaS",
    "choice_c": "LAN",
    "choice_d": "CRM",
    "correct_answer": "A",
    "explanation": "When architecting a system that brings various corporate functionality together, an enterprise resource planning (ERP) system is often chosen.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      42,
      48,
      47,
      43,
      36
    ],
    "source": "9781119892502"
  },
  {
    "id": 1528,
    "question": "What is a user story in the Agile methodology?",
    "choice_a": "Customer survey results after product release",
    "choice_b": "Key information about stakeholders and their jobs",
    "choice_c": "A high-level definition of someone using the product or service",
    "choice_d": "A visual representation of product burndown",
    "correct_answer": "C",
    "explanation": "Short stories help focus on how the product is going to be used, which helps shape how the final product is designed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      153,
      158,
      54,
      157
    ],
    "source": "9781119892502"
  },
  {
    "id": 1529,
    "question": "What is the single role in a RACI matrix that can only be assigned once per task?",
    "choice_a": "Consulted",
    "choice_b": "Responsible",
    "choice_c": "Informed",
    "choice_d": "Accountable",
    "correct_answer": "D",
    "explanation": "There can be one, and only one, person who is accountable per task in a RACI matrix.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      8,
      12,
      59,
      128,
      84
    ],
    "source": "9781119892502"
  },
  {
    "id": 1530,
    "question": "Which of the following would not receive communication if there was an update to the risk register?",
    "choice_a": "Project sponsor",
    "choice_b": "Project team",
    "choice_c": "PMO",
    "choice_d": "Project manager",
    "correct_answer": "C",
    "explanation": "The project management office offers standardization for a project but does not get involved in the details of individual projects.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      251,
      57,
      271,
      247,
      216
    ],
    "source": "9781119892502"
  },
  {
    "id": 1531,
    "question": "Dyan is applying for a job working on a defense project for a government agency. To help confirm her employment, what steps might be required for Dyan to be hired as the project manager? (Choose two.)",
    "choice_a": "Service-level agreement",
    "choice_b": "Background screening",
    "choice_c": "Clearance requirements",
    "choice_d": "Branding restrictions",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Highly sensitive projects across industries may require the candidate to obtain a security clearance to gain employment. While common when working for certain government agencies, this may also be a requirement for companies that support those agencies. A background screening may be required for employment regardless of whether a security clearance is involved.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      193,
      192,
      190,
      191,
      195
    ],
    "source": "9781119892502"
  },
  {
    "id": 1532,
    "question": "A movie production facility has a secure door that can only be accessed through a retinal scan and an authorized badge being scanned. What security concept is being enacted in this scenario?",
    "choice_a": "Branding restrictions",
    "choice_b": "Scrum retrospective",
    "choice_c": "Legal and regulatory impacts",
    "choice_d": "Facility access",
    "correct_answer": "D",
    "explanation": "Facility access is a form of physical security used to prevent unauthorized access to a location, building, or part of a building.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      192,
      194,
      190,
      191,
      193
    ],
    "source": "9781119892502"
  },
  {
    "id": 1533,
    "question": "Once a change request is submitted, where should it be recorded and assigned an identification number for tracking purposes?",
    "choice_a": "Risk register",
    "choice_b": "Business process repository",
    "choice_c": "Issue log",
    "choice_d": "Change request log",
    "correct_answer": "D",
    "explanation": "A change request log can be a simple spreadsheet that has the ID number, date, description, and so forth of the change.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      280,
      86,
      87,
      282,
      256
    ],
    "source": "9781119892502"
  },
  {
    "id": 1534,
    "question": "The project charter has a filename of <code>Projectcharter1</code>. The project manager makes an update to the file, and it now is called <code>Projectcharter2</code>. This is an example of which one of the following?",
    "choice_a": "Communicating changes",
    "choice_b": "Version control",
    "choice_c": "Change request logs",
    "choice_d": "Risk register",
    "correct_answer": "B",
    "explanation": "Using an incremental naming convention is a great way to keep track of versions. Do not forget to also make updates within the document itself to capture the version and the changes made in that version.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      268,
      332,
      283,
      239,
      130
    ],
    "source": "9781119892502"
  },
  {
    "id": 1535,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c06uf001.png\"/>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Fishbone diagram",
    "correct_answer": "D",
    "explanation": "A fishbone diagram, also called an Ishikawa diagram, is a visualization tool for categorizing the potential causes of a problem in order to identify its root causes.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      311,
      310,
      154,
      266,
      171
    ],
    "source": "9781119892502"
  },
  {
    "id": 1536,
    "question": "An airline engineering company is forced to cut the project budget after poor financial results in the previous quarter. How would this most likely impact the project?",
    "choice_a": "The project will take longer because the number of resources is cut.",
    "choice_b": "The project team goes to the steering committee for more funds.",
    "choice_c": "The project scope is cut back to operate within the new budget.",
    "choice_d": "The project is postponed due to lack of financial resources.",
    "correct_answer": "C",
    "explanation": "The project scope being cut back to operate within the new budget is the most likely impact on this project. The schedule would not be affected, because there is no reason to lengthen or shorten the project time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      248,
      214,
      88,
      56
    ],
    "source": "9781119892502"
  },
  {
    "id": 1537,
    "question": "A resource shortage means which one of the following?",
    "choice_a": "There are too many resources, leading to underallocation.",
    "choice_b": "There is a shortage of things for team members to work on.",
    "choice_c": "There are not enough resources for the task, leading to overallocation.",
    "choice_d": "There is an abundance of things for team members to work on.",
    "correct_answer": "C",
    "explanation": "There are not enough resources for the tasks assigned, which leads to overallocation of the staff working on the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      148,
      164,
      163,
      26,
      140
    ],
    "source": "9781119892502"
  },
  {
    "id": 1538,
    "question": "Which of the following are ways to organize the WBS? (Choose three.)",
    "choice_a": "Backlog and sprints",
    "choice_b": "Project phases",
    "choice_c": "Subprojects",
    "choice_d": "Major deliverables",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The ways to organize the WBS are by subprojects (where the project managers of the subprojects each create a WBS), by project phases, or by major deliverables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      85,
      7,
      12,
      69
    ],
    "source": "9781119892502",
    "choice_e": "Prioritized by risk"
  },
  {
    "id": 1539,
    "question": "A project sponsor or champion serves what role on a project?",
    "choice_a": "Develops and maintains the schedule",
    "choice_b": "Is the approval authority and removes roadblocks",
    "choice_c": "Sets the standards and practices for projects in the organization",
    "choice_d": "Performs cross-functional coordination",
    "correct_answer": "B",
    "explanation": "Two of the roles of the project sponsor illustrated are the approval authority for the project and to help remove roadblocks in the project team's way.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      57,
      263,
      51,
      214
    ],
    "source": "9781119892502"
  },
  {
    "id": 1540,
    "question": "Which type of contract allows the seller to recover all allowable expenses associated with providing the goods or services?",
    "choice_a": "Time and materials",
    "choice_b": "Fixed-price contract",
    "choice_c": "Statements of work",
    "choice_d": "Cost-reimbursable contract",
    "correct_answer": "D",
    "explanation": "As outlined in the contract, the seller can recoup costs that are allowable in the contract terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      200,
      199,
      278,
      205
    ],
    "source": "9781119892502"
  },
  {
    "id": 1541,
    "question": "The comprehensive collection of documents that spells out communication, risk management, project schedule, and scope management is known as which one of the following?",
    "choice_a": "Request for proposal",
    "choice_b": "Dashboard information",
    "choice_c": "Project management plan",
    "choice_d": "Scope statement",
    "correct_answer": "C",
    "explanation": "The project management plan is the collection of plans created to address budget, time, scope, quality, communication, risk, and other project elements.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      84,
      132,
      9,
      12,
      236
    ],
    "source": "9781119892502"
  },
  {
    "id": 1542,
    "question": "Project team members are required to report to both the project manager and their functional manager, who share authority for the resources. What type of organization is this?",
    "choice_a": "Weak matrix",
    "choice_b": "Balanced matrix",
    "choice_c": "Projectized",
    "choice_d": "Strong matrix",
    "correct_answer": "B",
    "explanation": "In a balanced matrix organization, the project manager and the functional manager both control the budget and share power and authority.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      160,
      159,
      161,
      244,
      168
    ],
    "source": "9781119892502"
  },
  {
    "id": 1543,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c06uf002.png\"/>",
    "choice_a": "Run chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Fishbone diagram",
    "correct_answer": "A",
    "explanation": "A run chart is graph that displays observed data in a time sequence.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      154,
      267,
      146
    ],
    "source": "9781119892502"
  },
  {
    "id": 1544,
    "question": "What are major accomplishments of the project or key events known as?",
    "choice_a": "Requirements",
    "choice_b": "Deliverables",
    "choice_c": "Milestones",
    "choice_d": "Risks",
    "correct_answer": "C",
    "explanation": "Milestones can also represent the completion of major deliverables on a project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      127,
      89,
      335,
      263
    ],
    "source": "9781119892502"
  },
  {
    "id": 1545,
    "question": "Assessing the status of the budget, reviewing risks/issues logs, and measuring performance occurs in what project life cycle phase?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "D",
    "explanation": "Activities that monitor the progress of the project and require corrective actions occurs in the Execution phase.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      273,
      324,
      225,
      7,
      84
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1546,
    "question": "A project manager is having problems with one team member who is being insubordinate. The project manager approaches the team member and communicates how the behavior is inappropriate and how the team member will behave from now on. This is an example of which one of the following?",
    "choice_a": "Forcing",
    "choice_b": "Avoiding",
    "choice_c": "Confronting",
    "choice_d": "Smoothing",
    "correct_answer": "A",
    "explanation": "The team member is not given a chance to tell their side of the story, and the project manager does not inquire to why the behavior is happening. These solutions can be short-lived.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      236,
      78,
      83,
      176,
      321
    ],
    "source": "9781119892502"
  },
  {
    "id": 1547,
    "question": "What are governance gates?",
    "choice_a": "A checkpoint between project phases where approval is obtained to move forward",
    "choice_b": "A checkpoint where quality is checked against a previously established criterion",
    "choice_c": "Checkpoints at the beginning and end of the project only",
    "choice_d": "After a project governor is appointed, unplanned interruptions from this project sponsor",
    "correct_answer": "A",
    "explanation": "A checkpoint between project phases where approval is obtained to move forward. Usually the project reports to a steering committee to help ensure accountability on the project for time, money, and scope.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      303,
      149,
      70,
      93
    ],
    "source": "9781119892502"
  },
  {
    "id": 1548,
    "question": "After establishing the product backlog, what tool would you use to determine the project's velocity?",
    "choice_a": "Fishbone diagram",
    "choice_b": "Burndown chart",
    "choice_c": "Kanban board",
    "choice_d": "Sprint speed",
    "correct_answer": "B",
    "explanation": "The burndown chart is a visual representation and measurement tool showing the completed work against a time interval to forecast project completion.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      153,
      211,
      210,
      209
    ],
    "source": "9781119892502"
  },
  {
    "id": 1549,
    "question": "How should a project team record what was said and agreed to during project gatherings?",
    "choice_a": "Create a scope statement.",
    "choice_b": "Create a business case.",
    "choice_c": "Create meeting minutes.",
    "choice_d": "Create a project management plan.",
    "correct_answer": "C",
    "explanation": "Meeting minutes capture the details for why decisions were made, what was discussed, and any assignments/due dates that materialized out of the meeting.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      255,
      256,
      254,
      232,
      227
    ],
    "source": "9781119892502"
  },
  {
    "id": 1550,
    "question": "Which risk response strategy attempts to minimize the impact or the probability of a negative risk?",
    "choice_a": "Mitigate",
    "choice_b": "Accept",
    "choice_c": "Transfer",
    "choice_d": "Avoid",
    "correct_answer": "A",
    "explanation": "Mitigation of a risk is reducing the chance the risk would happen or lessening the impact in the event the risk does get triggered.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      222,
      216,
      219,
      220,
      221
    ],
    "source": "9781119892502"
  },
  {
    "id": 1551,
    "question": "At the conclusion of a defined work period, Belle got the project team together to figure out what went well, what did not go well, and what improvements could be made. <p>What type of meeting was this?</p>",
    "choice_a": "Scrum retrospective",
    "choice_b": "Product backlog",
    "choice_c": "Daily Scrum",
    "choice_d": "Kickoff meeting",
    "correct_answer": "A",
    "explanation": "A Scrum retrospective is a form of lessons learned done with the Agile methodology at the end of each sprint.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      119,
      253,
      300,
      120
    ],
    "source": "9781119892502"
  },
  {
    "id": 1552,
    "question": "Chase is a project manager, and they have released all of the team members from the project, closed vendor contracts, and archived project documents. In what life cycle phase is the project?",
    "choice_a": "Discovery/concept preparation",
    "choice_b": "Initiation",
    "choice_c": "Planning",
    "choice_d": "Execution",
    "correct_answer": "E",
    "explanation": "Other closing activities would include getting project sign-off, validating all deliverables, close contract, remove project team access, and conducting training as a part of the transition/integration plan.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      11,
      7,
      325,
      10,
      12
    ],
    "source": "9781119892502",
    "choice_e": "Closing"
  },
  {
    "id": 1553,
    "question": "Teams normally go through a similar development cycle. Which is the correct order of those stages?",
    "choice_a": "Forming, norming, performing, storming, and adjourning",
    "choice_b": "Norming, storming, forming, adjourning, and performing",
    "choice_c": "Norming, forming, storming, adjourning, and performing",
    "choice_d": "Forming, storming, norming, performing, and adjourning",
    "correct_answer": "D",
    "explanation": "Forming, storming, norming, performing, and adjourning is the mode of group development that was developed by Dr. Bruce Tuckman.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      120,
      168,
      177,
      261
    ],
    "source": "9781119892502"
  },
  {
    "id": 1554,
    "question": "The project team is ready to make a change to a web application already in use by an organization. Which artifact should the project manager refer to in rolling out the changes?",
    "choice_a": "Tiered architecture",
    "choice_b": "Downtime/maintenance window schedules",
    "choice_c": "Data warehouse",
    "choice_d": "Customer notifications",
    "correct_answer": "B",
    "explanation": "Maintenance windows are pre-negotiated time blocks that let the project team know when it is okay to bring down an IT service that is already in production.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      297,
      298,
      36,
      46,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1555,
    "question": "What are the three common constraints found in projects? (Choose three.)",
    "choice_a": "Scope",
    "choice_b": "Personnel",
    "choice_c": "Working space",
    "choice_d": "Quality",
    "correct_answer": [
      "A",
      "E",
      "F"
    ],
    "explanation": "Commonly referred to as the triple constraints, almost all projects are constrained by time, budget, and scope as they impact quality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      248,
      90,
      91,
      279,
      115
    ],
    "source": "9781119892502",
    "choice_e": "Budget",
    "choice_f": "Time"
  },
  {
    "id": 1556,
    "question": "Which information security concept addresses where and how your data is stored?",
    "choice_a": "Application security",
    "choice_b": "Digital security",
    "choice_c": "Network and system security",
    "choice_d": "Physical security",
    "correct_answer": "D",
    "explanation": "Physical security guides all parameters regarding where and how your data is stored. In addition to organization and project requirements, remember different states and countries have very specific laws governing data security.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      192,
      195,
      32,
      36,
      39
    ],
    "source": "9781119892502"
  },
  {
    "id": 1557,
    "question": "The commitment to keep a person's or organization's information private and protect unauthorized disclosure of information from being disclosed is known as which of the following?",
    "choice_a": "Confidentiality",
    "choice_b": "Data sensitivity",
    "choice_c": "Privacy",
    "choice_d": "Security clearance",
    "correct_answer": "A",
    "explanation": "Confidentiality protects information from disclosure without the consent of the individual or organization the information is about.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      29,
      31,
      195,
      190,
      192
    ],
    "source": "9781119892502"
  },
  {
    "id": 1558,
    "question": "What is the definition of a work breakdown structure?",
    "choice_a": "A deliverable-oriented decomposition of a project",
    "choice_b": "A graphic representation of tasks and their sequence",
    "choice_c": "A high-level outline of milestones on a project",
    "choice_d": "A task-oriented decomposition of a project",
    "correct_answer": "A",
    "explanation": "The work breakdown structure breaks the project down into smaller, more manageable chunks of work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      85,
      12,
      64,
      122
    ],
    "source": "9781119892502"
  },
  {
    "id": 1559,
    "question": "What are project requirements?",
    "choice_a": "A measure of the distance traveled on a project",
    "choice_b": "Major events in a project used to measure progress",
    "choice_c": "Checkpoints on a project to determine Go/No-Go",
    "choice_d": "Characteristics of deliverables that must be met",
    "correct_answer": "D",
    "explanation": "Requirements are the characteristics of deliverables often represented in must have, needed, and wanted categories.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      69,
      99,
      122,
      67,
      98
    ],
    "source": "9781119892502"
  },
  {
    "id": 1560,
    "question": "Expenditures not expensed directly on a company's income statement and that are considered an investment are known as which of the following?",
    "choice_a": "SOW",
    "choice_b": "OpEx",
    "choice_c": "TOR",
    "choice_d": "CapEx",
    "correct_answer": "D",
    "explanation": "Capital expenses are used on spending for a benefit that will last longer than a year, and some companies might have a dollar amount that a single item might cost that would also lead to the purchase being qualified as a capital expense. As an example, a company might have a $5,000 limit on the individual cost of an item, meaning the purchase of a $6,000 server would qualify as a CapEx but a $2,000 desktop computer would not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      203,
      70,
      206,
      14,
      96
    ],
    "source": "9781119892502"
  },
  {
    "id": 1561,
    "question": "The calculation of the rate of return for a given investment for a given period of time is known as which of the following?",
    "choice_a": "Payback period",
    "choice_b": "Return on investment",
    "choice_c": "Time value of money",
    "choice_d": "Earned value",
    "correct_answer": "B",
    "explanation": "A return on investment (ROI) analysis can be used to determine if there will be a positive return on a project's investment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      14,
      19,
      102,
      67,
      203
    ],
    "source": "9781119892502"
  },
  {
    "id": 1562,
    "question": "During a project meeting, a key stakeholder looks at a report and sees that the schedule now has a yellow setting when last week it was set at green. What kind of data is the stakeholder viewing?",
    "choice_a": "Dashboard information",
    "choice_b": "Project management plan",
    "choice_c": "Ishikawa diagram",
    "choice_d": "Risk register",
    "correct_answer": "A",
    "explanation": "A dashboard is a form of a status report that will display conditions of different data elements and key performance indicators to communicate the progress and challenges of the project.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      266,
      322,
      212,
      152,
      252
    ],
    "source": "9781119892502"
  },
  {
    "id": 1563,
    "question": "A team that is geographically dispersed has the need to work on documents together and to have more tools than phone calls by which they can communicate. What is a good option for them to consider using?",
    "choice_a": "Wiki pages",
    "choice_b": "Intranet sites",
    "choice_c": "Collaboration tools",
    "choice_d": "Scrum retrospective",
    "correct_answer": "C",
    "explanation": "Collaboration tools would allow screen sharing, joint document editing, video calls, and joint document sharing, task lists, and calendars.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      243,
      271,
      6,
      104
    ],
    "source": "9781119892502"
  },
  {
    "id": 1564,
    "question": "The team is working on a cutover to a new badge access system for an agency with a security component. During the planned outage, a problem is discovered that cannot be solved immediately. What should the project team do?",
    "choice_a": "Continue to implement the change.",
    "choice_b": "Implement the regression plan and reverse the changes.",
    "choice_c": "Evaluate the impact and justification of an extended outage.",
    "choice_d": "Identify and document the change.",
    "correct_answer": "B",
    "explanation": "During any change where the team starts with a working product and the change disrupts the availability, it makes sense to reverse the changes. In some Agile practicing software companies, they may only roll forward to the next version of the software rather than reverse any changes. In this example, the availability of phones due to the security component would make it important to roll back.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      282,
      50,
      86,
      214,
      288
    ],
    "source": "9781119892502"
  },
  {
    "id": 1565,
    "question": "A software development team is sharing their knowledge and progress by using a web browser to edit a common page. Which knowledge management tool are they using?",
    "choice_a": "Intranet sites",
    "choice_b": "Collaboration tools",
    "choice_c": "Internet sites",
    "choice_d": "Wiki knowledge base",
    "correct_answer": "D",
    "explanation": "Wiki knowledge bases allow users to freely create and edit web page content using a web browser.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      257,
      235,
      268,
      332,
      316
    ],
    "source": "9781119892502"
  },
  {
    "id": 1566,
    "question": "A project team is working on building a new office complex in a remote area. The on-site office trailer has a telephone line, but internet connectivity is limited and mobile phone coverage is spotty. What would be the best method for team members at this location to participate in a status meeting?",
    "choice_a": "Email",
    "choice_b": "Video conferencing",
    "choice_c": "Voice conferencing",
    "choice_d": "Whiteboard",
    "correct_answer": "C",
    "explanation": "Voice conferencing, or teleconference, would be the ideal choice because it would not require team members to travel, allows for back-and-forth communication, and would not be interrupted by poor internet quality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      181,
      271,
      245,
      237,
      230
    ],
    "source": "9781119892502"
  },
  {
    "id": 1567,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c06uf003.png\"/> <p></p>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Scatter chart",
    "correct_answer": "D",
    "explanation": "A scatter chart graph pairs numerical data to help the analyst look for a correlation or relationship. A scatter chart can also be called a scatter diagram and is used to help identify a correlation between the dependent and independent variables.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      266,
      146,
      152
    ],
    "source": "9781119892502"
  },
  {
    "id": 1568,
    "question": "WigitCom is about to launch a new software product to the market. They are concerned about a new regulation that is being considered in a large state that may cause modification to the design, specifically around data privacy. It was suggested during a steering committee meeting that this issue get revisited after the final vote on the new law. What is this an example of?",
    "choice_a": "Action item",
    "choice_b": "Follow-up",
    "choice_c": "Task setting",
    "choice_d": "Refinement",
    "correct_answer": "B",
    "explanation": "Follow-ups check on the status of a new developments in the project environment that may have an impact on the scope, cost, or success of the project. These developments can be either internal or external.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      256,
      263,
      315,
      272,
      215
    ],
    "source": "9781119892502"
  },
  {
    "id": 1569,
    "question": "<i>We are here for you!</i> has done work for DewDrops in the past and has begun to advertise and market that DewDrops is a current project client without DewDrops's consent. What ESG factor might cause DewDrops to issue a cease-and-desist letter to <i>We are here for you!</i> to correct this behavior?",
    "choice_a": "Project impact to company brand value",
    "choice_b": "Awareness of applicable regulations and standards",
    "choice_c": "Awareness of company vision, mission statements, and values",
    "choice_d": "Project impact to the local and global environment",
    "correct_answer": "A",
    "explanation": "DewDrops would be working to make sure the impact to the company brand value is in their control and that their project will not negatively impact their image.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      196,
      195,
      191,
      190,
      45
    ],
    "source": "9781119892502"
  },
  {
    "id": 1570,
    "question": "Time, budget, and scope are considered the triple constraints to tactical project management. What are the three factors that influence sustainable project management from a strategic context?",
    "choice_a": "Environmentally sound, viral social media, economically viable",
    "choice_b": "Economically viable, on time, on budget",
    "choice_c": "Environmentally sound, socially responsible, economically viable",
    "choice_d": "Economically viable, environmentally should, return on investment",
    "correct_answer": "C",
    "explanation": "Environmentally sound, socially responsible, and economically viable are three factors where trade-offs must be made in a similar way to the tactical triple constraints.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      29,
      33,
      36,
      49,
      190
    ],
    "source": "9781119892502"
  },
  {
    "id": 1571,
    "question": "Which type of change management focuses on service transitions such as moving from one vendor to another or getting all of your departments on board with a new financial system?",
    "choice_a": "Organizational change management",
    "choice_b": "On-premises change control",
    "choice_c": "Cloud change control",
    "choice_d": "Shift change management",
    "correct_answer": "B",
    "explanation": "On-premises change control is likely based on ITIL, the Information Technology Infrastructure Library, which sets best practices in IT service management.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      294,
      125,
      10,
      287,
      284
    ],
    "source": "9781119892502"
  },
  {
    "id": 1572,
    "question": "A company has a large datacenter with nearly a thousand servers and a host of enterprise applications. To align with the company's mission statement, there is a project to move away high datacenter costs while keeping operational consistency. Which cloud environment should be pursued?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "XaaS",
    "choice_d": "SaaS",
    "correct_answer": "A",
    "explanation": "Datacenters consist of infrastructure, making IaaS the correct option. Infrastructure as a service allows the cloud consumer to provision servers, storage, networking, operating systems, and other computing resources on demand. With IaaS, companies have the ability to stand up servers, operating systems, networking hardware, databases, and applications that mirror (or even improve on) the current datacenter environment.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      40,
      41,
      49,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1573,
    "question": "What best describes a request for information?",
    "choice_a": "A meeting with prospective vendors prior to completing a proposal",
    "choice_b": "Procurement method to obtain more information about goods and services",
    "choice_c": "Procurement document that details the goods and services to be procured from outside the organization",
    "choice_d": "Procurement method to invite bids, review, select, and purchase goods or services",
    "correct_answer": "B",
    "explanation": "A request for information (RFI) is used when there is not enough information or expert judgment to know what a good or service will cost, or to understand how many vendors there are who can meet this demand.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      182,
      185,
      21,
      280,
      271
    ],
    "source": "9781119892502"
  },
  {
    "id": 1574,
    "question": "What is fast tracking a project?",
    "choice_a": "Removing critical path activities that are unnecessary",
    "choice_b": "Moving later deliverables to earlier phases to appease stakeholders",
    "choice_c": "Performing two tasks in parallel that were previously scheduled to start sequentially",
    "choice_d": "Looking at cost and schedule trade-offs, like adding more resources",
    "correct_answer": "C",
    "explanation": "Fast tracking is a schedule acceleration technique where two tasks that are scheduled in parallel are started at the same time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      147,
      144,
      136,
      135,
      151
    ],
    "source": "9781119892502"
  },
  {
    "id": 1575,
    "question": "What indicates an individual's or organization's comfort level with risky situations or decisions?",
    "choice_a": "Risk register",
    "choice_b": "Risk tolerance",
    "choice_c": "Risk avoider",
    "choice_d": "Risk taker",
    "correct_answer": "B",
    "explanation": "Risk tolerance is the threshold of comfort one has accepting a risk and its consequences.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      215,
      112,
      219,
      220,
      222
    ],
    "source": "9781119892502"
  },
  {
    "id": 1576,
    "question": "An adaptive method would be preferable to a more rigid project management style in which situation?",
    "choice_a": "In a mature organization with defined processes",
    "choice_b": "When dealing with a rapidly changing environment",
    "choice_c": "When the scope can be easily and thoroughly defined",
    "choice_d": "Where small incremental improvements offer no value to stakeholders",
    "correct_answer": "B",
    "explanation": "Dealing with a rapidly changing environment requires the ability to react to new information and feedback. The other options would not take advantage of the flexible, easily changing environment of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      133,
      112,
      97,
      153,
      17
    ],
    "source": "9781119892502"
  },
  {
    "id": 1577,
    "question": "What does a CCB do to support the project?",
    "choice_a": "Helps vet and manage changes to the scope",
    "choice_b": "Provides an accounting structure for tasks",
    "choice_c": "Sets the standards and templates for the project",
    "choice_d": "Sets the costs of quality for the project",
    "correct_answer": "A",
    "explanation": "A change control board helps vet and manage changes to the scope. A change control board, in conjunction with the change control process, will approve or reject changes to the scope of the project.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      282,
      279,
      87,
      86,
      281
    ],
    "source": "9781119892502"
  },
  {
    "id": 1578,
    "question": "When does an item move from the risk register to the issue log?",
    "choice_a": "As soon as the risk as identified.",
    "choice_b": "When the risk is triggered.",
    "choice_c": "It never ends up on the issue log.",
    "choice_d": "During the creation of the project plan.",
    "correct_answer": "B",
    "explanation": "A risk becomes an active issue when it is triggered. For instance, if the cost of material starts to rise, it might trigger a budget risk that gets moved to the issue log to be actively managed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      315,
      317,
      222,
      216,
      220
    ],
    "source": "9781119892502"
  },
  {
    "id": 1579,
    "question": "Which component of the project charter describes the characteristics of the product produced by the project?",
    "choice_a": "Project objectives",
    "choice_b": "Business case",
    "choice_c": "Deliverables",
    "choice_d": "Quality plan",
    "correct_answer": "A",
    "explanation": "The project objectives component will explain the attributes of the product, service, or result of the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      66,
      67,
      69,
      64,
      65
    ],
    "source": "9781119892502"
  },
  {
    "id": 1580,
    "question": "The list of items that need to be monitored and/or escalated to minimize the impact on the project team is called which one of the following?",
    "choice_a": "Scatter chart",
    "choice_b": "Histogram",
    "choice_c": "Pareto chart",
    "choice_d": "Run chart",
    "correct_answer": "D",
    "explanation": "Run charts often represent some aspect of the output or performance of a manufacturing or business process.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      256,
      219,
      90,
      86,
      232
    ],
    "source": "9781119892502"
  },
  {
    "id": 1581,
    "question": "All of the following are advantages of using a PaaS EXCEPT:",
    "choice_a": "Reduced complexity",
    "choice_b": "Self-ramping up or down of infrastructure",
    "choice_c": "Reduced control",
    "choice_d": "Easier maintenance and enhancement of applications",
    "correct_answer": "C",
    "explanation": "Reduced control can be a disadvantage to the project team and ongoing support when feature changes and timing of upgrades are controlled by the hosting company and not the customer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      40,
      49,
      41,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1582,
    "question": "Lashika is the project manager assigned to a project, and she is creating a graphic that shows the project leads for each subject area along with the resources assigned to them. What type of document is Lashika creating?",
    "choice_a": "Communication plan",
    "choice_b": "Pareto diagram",
    "choice_c": "Organizational chart",
    "choice_d": "Ishikawa diagram",
    "correct_answer": "C",
    "explanation": "The project organizational chart helps to clarify involvement on the project and can be used to help create a decision-making matrix indicating who has authority to make certain decisions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      160,
      161,
      51,
      55,
      26
    ],
    "source": "9781119892502"
  },
  {
    "id": 1583,
    "question": "Which tool provides a visual representation of all of the steps required in a process?",
    "choice_a": "Process diagram",
    "choice_b": "Business process repository",
    "choice_c": "Gantt chart",
    "choice_d": "Program Evaluation Review Technique (PERT) chart",
    "correct_answer": "A",
    "explanation": "Process diagrams create visualizations of the different steps needed in any process, typically created as a flowchart.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      314,
      138,
      146,
      154,
      311
    ],
    "source": "9781119892502"
  },
  {
    "id": 1584,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c06uf004.png\"/> <p></p>",
    "choice_a": "Process diagram",
    "choice_b": "Histogram",
    "choice_c": "Decision tree",
    "choice_d": "Scatter chart",
    "correct_answer": "C",
    "explanation": "A decision tree is a technique for making decisions when the consequences of a decision are uncertain by helping to deduce the most beneficial option.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      310,
      146,
      212,
      266,
      314
    ],
    "source": "9781119892502"
  },
  {
    "id": 1585,
    "question": "The sprint planning meeting is used to:",
    "choice_a": "Get a head start on the work needed for the project.",
    "choice_b": "Prepare the project charter and kickoff meeting.",
    "choice_c": "Set a realistic backlog of items completed during this iteration.",
    "choice_d": "Set the communication and quality plans for the project.",
    "correct_answer": "C",
    "explanation": "The sprint planning meeting sets what can realistically be accomplished during the sprint.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      119,
      117,
      135,
      25
    ],
    "source": "9781119892502"
  },
  {
    "id": 1586,
    "question": "A building project requires the following steps: construction, purchasing the build site, blueprinting, and inspection. Construction has what relationship to purchasing the build site?",
    "choice_a": "It is a successor task.",
    "choice_b": "It is a mandatory task.",
    "choice_c": "It is a predecessor task.",
    "choice_d": "It is a discretionary task.",
    "correct_answer": "A",
    "explanation": "It is a successor task. The purchasing of the build site must occur before the construction activity begins.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      127,
      136,
      86,
      275,
      105
    ],
    "source": "9781119892502"
  },
  {
    "id": 1587,
    "question": "Danielle has been doing an analysis to compare any correlation between an independent and a dependent variable. She has created a regression line chart to forecast the changes. What has Danielle created?",
    "choice_a": "Process diagram",
    "choice_b": "Scatter chart",
    "choice_c": "Pareto chart",
    "choice_d": "Histogram",
    "correct_answer": "B",
    "explanation": "Plotted points on a scatter chart indicate the type of relationship, or the absence of a relationship, between two variables, one dependent and one independent.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      314,
      154,
      267
    ],
    "source": "9781119892502"
  },
  {
    "id": 1588,
    "question": "DewDrops is building a revolutionary new video streaming platform. A functional manager from the administrative division assigned one of his team members to the project and is curious about the project. They ask this team member about details of the project. To conform to the project's access requirements, what should the project team member say to the manager?",
    "choice_a": "Share all of the project details with the functional manager.",
    "choice_b": "Let the manager review all existing project artifacts.",
    "choice_c": "Inform the manager they are unable to share details about the project.",
    "choice_d": "Invite the manager into the secure project space and let them look around.",
    "correct_answer": "C",
    "explanation": "The access requirements for the project are a guiding reference to what information can be shared and with whom. The complexity in this scenario is that the manager is the functional boss for the team member, and the familiarity may make it tempting to share details about the project.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      236,
      59,
      78,
      82,
      79
    ],
    "source": "9781119892502"
  },
  {
    "id": 1589,
    "question": "Pete has been asked to determine the root cause of communication problems on a global project. Which tool should he use to help him with this analysis?",
    "choice_a": "Pareto chart",
    "choice_b": "Run chart",
    "choice_c": "Wiki pages",
    "choice_d": "Fishbone diagram",
    "correct_answer": "D",
    "explanation": "A fishbone diagram is used to help determine the different factors that could cause a problem and to do analysis to determine the root cause.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      314,
      310,
      252,
      235
    ],
    "source": "9781119892502"
  },
  {
    "id": 1590,
    "question": "All of the following are characteristic of an Agile project management approach EXCEPT:",
    "choice_a": "Each release is tested against the customers' needs.",
    "choice_b": "It uses a flexible approach to requirements.",
    "choice_c": "It follows a strict adherence to a change control process.",
    "choice_d": "Team members work in short bursts, or sprints.",
    "correct_answer": "C",
    "explanation": "Strict adherence to the change control process is indicative of a more traditional waterfall approach where the scope is controlled with a more rigid change process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      133,
      106,
      87,
      112
    ],
    "source": "9781119892502"
  },
  {
    "id": 1591,
    "question": "The project team has been asked to identify what will happen if a given IT change has a problem or causes a non-repairable outage. What has the project team been asked to create?",
    "choice_a": "Rollback plan",
    "choice_b": "Risk assessment",
    "choice_c": "Automate tests",
    "choice_d": "Validation checks",
    "correct_answer": "A",
    "explanation": "A rollback plan is established ahead of time so that everyone knows what immediate action is needed to restore service within the maintenance window. In the middle of a process and or a crisis, it can be difficult to think on the fly the steps that might be needed to restore functionality.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      297,
      298,
      299,
      36,
      37
    ],
    "source": "9781119892502"
  },
  {
    "id": 1592,
    "question": "The customer site for a project is located in a rural part of a country, while the project headquarters is located in a metropolitan hub. What would be the biggest impediment to face-to-face communication?",
    "choice_a": "Times zones",
    "choice_b": "Geographical factors",
    "choice_c": "Intraorganizational differences",
    "choice_d": "Technological factors",
    "correct_answer": "B",
    "explanation": "When project teams are separated by large distances, mountains, canyons, rivers, oceans, or other factors, geographic factors can influence how and when communication will occur.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      241,
      233,
      271,
      228,
      181
    ],
    "source": "9781119892502"
  },
  {
    "id": 1593,
    "question": "About how much time should a project manager spend communicating?",
    "choice_a": "Up to 90%",
    "choice_b": "Up to 75%",
    "choice_c": "Up to 50%",
    "choice_d": "Up to 27%",
    "correct_answer": "A",
    "explanation": "Project managers can spend up to 90 percent of their time communicating with the stakeholders and the project team on status updates, getting information, and giving assignments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      232,
      23,
      265,
      51,
      272
    ],
    "source": "9781119892502"
  },
  {
    "id": 1594,
    "question": "What type of project management tool is depicted here? <img src=\"/question_assets/Project+/c06uf005.png\"/>",
    "choice_a": "Project network diagram",
    "choice_b": "Gantt chart",
    "choice_c": "Project backlog",
    "choice_d": "Project burndown chart",
    "correct_answer": "D",
    "explanation": "This is a project burndown chart.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      267,
      212,
      146,
      322
    ],
    "source": "9781119892502"
  }
];
